
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0e80"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0e80"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i68qq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2736f6eb2198c2e0$export$2e2bcd8739ae039; });

var $jGU4X = parcelRequire("jGU4X");
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");

var $hLDPq = parcelRequire("hLDPq");

var $2SEys = parcelRequire("2SEys");
var $2736f6eb2198c2e0$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({
    components: {
        TopBar: $jGU4X.default
    },
    data () {
        return {
            loading: true,
            isSignedIn: false
        };
    },
    async beforeCreate () {
        console.log("Adding intercom to site");
        const email = await (0, $hLDPq.getCurrentEmail)();
        const accountNumber = await (0, $2SEys.getCurrentAccountNumber)();
        const intercomSettings = document.createElement("script");
        intercomSettings.innerHTML = `window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: "xzh7ogzw",
        clientEmail: "${email}",
        accountNumber: "${accountNumber}",
        clientFrom: "Periodic Reviews"
      };`;
        const intercomFnc = document.createElement("script");
        intercomFnc.innerHTML = `(function () {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
          ic("reattach_activator");
          ic("update", w.intercomSettings);
        } else {
          var d = document;
          var i = function () {
            i.c(arguments);
          };
          i.q = [];
          i.c = function (args) {
            i.q.push(args);
          };
          w.Intercom = i;
          var l = function () {
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/xzh7ogzw";
            var x = d.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
          };
          if (document.readyState === "complete") {
            l();
          } else if (w.attachEvent) {
            w.attachEvent("onload", l);
          } else {
            w.addEventListener("load", l, false);
          }
        }
      })();`;
        const intercomShow = document.createElement("script");
        intercomShow.innerHTML = `window.Intercom('show');`;
        document.body.appendChild(intercomSettings);
        document.body.appendChild(intercomFnc);
        document.body.appendChild(intercomShow);
    }
});

});
parcelRegister("jGU4X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e55d70ad269d504c$export$2e2bcd8739ae039; });
let $e55d70ad269d504c$var$script;




let $e55d70ad269d504c$var$initialize = ()=>{
    $e55d70ad269d504c$var$script = (parcelRequire("k6YIv"));
    if ($e55d70ad269d504c$var$script.__esModule) $e55d70ad269d504c$var$script = $e55d70ad269d504c$var$script.default;
    $e55d70ad269d504c$var$script.render = (parcelRequire("5fZlh")).render;
    $e55d70ad269d504c$var$script.__cssModules = {};
    (parcelRequire("1UspH")).default($e55d70ad269d504c$var$script);
    $e55d70ad269d504c$var$script.__scopeId = "data-v-46fc62";
    $e55d70ad269d504c$var$script.__file = "TopBar.vue";
};
$e55d70ad269d504c$var$initialize();
var $e55d70ad269d504c$export$2e2bcd8739ae039 = $e55d70ad269d504c$var$script;

});
parcelRegister("k6YIv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b81de89c18e8d78d$export$2e2bcd8739ae039; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");

var $8eKAN = parcelRequire("8eKAN");
var $b81de89c18e8d78d$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({
    components: {
        LanguagePicker: $8eKAN.default
    }
});

});
parcelRegister("a38K9", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("8zRru")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("8zRru")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("8zRru")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("8zRru")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("8zRru")).createElementVNode; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("8zRru")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("8zRru")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("8zRru")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("8zRru")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("8zRru")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("8zRru")).getCurrentInstance; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("8zRru")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("8zRru")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("8zRru")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("g90JB")).isRef; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("8zRru")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("6ZvW5")).normalizeClass; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("8zRru")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("8zRru")).onBeforeMount; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("8zRru")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("8zRru")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("8zRru")).onUnmounted; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("8zRru")).openBlock; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("8zRru")).provide; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("g90JB")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("g90JB")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("8zRru")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("8zRru")).resolveComponent; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("g90JB")).shallowReactive; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("g90JB")).shallowRef; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("8zRru")).Text; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("8zRru")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("8zRru")).watchEffect; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("8zRru")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("5lPju")).createApp; });
$parcel$export(module.exports, "vModelDynamic", function () { return (parcelRequire("5lPju")).vModelDynamic; });
$parcel$export(module.exports, "vModelSelect", function () { return (parcelRequire("5lPju")).vModelSelect; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("5lPju")).vModelText; });
$parcel$export(module.exports, "withKeys", function () { return (parcelRequire("5lPju")).withKeys; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("5lPju")).withModifiers; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("g90JB")).effectScope; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("g90JB")).unref; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("6ZvW5")).toDisplayString; });
/**
* vue v3.5.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8zRru = parcelRequire("8zRru");parcelRequire("5lPju");parcelRequire("g90JB");parcelRequire("6ZvW5");
function $7510f76fe2eaff90$var$initDev() {
    (0, $8zRru.initCustomFormatter)();
}
const $7510f76fe2eaff90$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("8zRru", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $63eb0c2225a75fda$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $63eb0c2225a75fda$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return $63eb0c2225a75fda$export$59536a0199721cab; });
$parcel$export(module.exports, "Fragment", function () { return $63eb0c2225a75fda$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $63eb0c2225a75fda$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Static", function () { return $63eb0c2225a75fda$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "withDirectives", function () { return $63eb0c2225a75fda$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "provide", function () { return $63eb0c2225a75fda$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $63eb0c2225a75fda$export$a976684a0efeb93f; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $63eb0c2225a75fda$export$f13e630aa3915748; });
$parcel$export(module.exports, "watchEffect", function () { return $63eb0c2225a75fda$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watch", function () { return $63eb0c2225a75fda$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "useTransitionState", function () { return $63eb0c2225a75fda$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $63eb0c2225a75fda$export$6d1641039221b5cb; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $63eb0c2225a75fda$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $63eb0c2225a75fda$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "createCommentVNode", function () { return $63eb0c2225a75fda$export$49553837c7236d3c; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $63eb0c2225a75fda$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $63eb0c2225a75fda$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $63eb0c2225a75fda$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $63eb0c2225a75fda$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "createVNode", function () { return $63eb0c2225a75fda$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "createTextVNode", function () { return $63eb0c2225a75fda$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "onUnmounted", function () { return $63eb0c2225a75fda$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onUpdated", function () { return $63eb0c2225a75fda$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onActivated", function () { return $63eb0c2225a75fda$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $63eb0c2225a75fda$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onBeforeMount", function () { return $63eb0c2225a75fda$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $63eb0c2225a75fda$export$ab91988a13872e4c; });
$parcel$export(module.exports, "resolveComponent", function () { return $63eb0c2225a75fda$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "renderList", function () { return $63eb0c2225a75fda$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "openBlock", function () { return $63eb0c2225a75fda$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "createBlock", function () { return $63eb0c2225a75fda$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "computed", function () { return $63eb0c2225a75fda$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "createRenderer", function () { return $63eb0c2225a75fda$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $63eb0c2225a75fda$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $63eb0c2225a75fda$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $63eb0c2225a75fda$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "createStaticVNode", function () { return $63eb0c2225a75fda$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $63eb0c2225a75fda$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $63eb0c2225a75fda$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $63eb0c2225a75fda$export$aed4979be6a60047; });
$parcel$export(module.exports, "warn", function () { return $63eb0c2225a75fda$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("g90JB")).isRef; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("g90JB")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("g90JB")).ref; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("g90JB")).shallowReactive; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("g90JB")).shallowRef; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("g90JB")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("6ZvW5")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("6ZvW5")).normalizeClass; });
/**
* @vue/runtime-core v3.5.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $g90JB = parcelRequire("g90JB");

var $6ZvW5 = parcelRequire("6ZvW5");
const $63eb0c2225a75fda$var$stack = [];
function $63eb0c2225a75fda$var$pushWarningContext(vnode) {
    $63eb0c2225a75fda$var$stack.push(vnode);
}
function $63eb0c2225a75fda$var$popWarningContext() {
    $63eb0c2225a75fda$var$stack.pop();
}
let $63eb0c2225a75fda$var$isWarning = false;
function $63eb0c2225a75fda$var$warn$1(msg, ...args) {
    if ($63eb0c2225a75fda$var$isWarning) return;
    $63eb0c2225a75fda$var$isWarning = true;
    (0, $g90JB.pauseTracking)();
    const instance = $63eb0c2225a75fda$var$stack.length ? $63eb0c2225a75fda$var$stack[$63eb0c2225a75fda$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $63eb0c2225a75fda$var$getComponentTrace();
    if (appWarnHandler) $63eb0c2225a75fda$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$63eb0c2225a75fda$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$63eb0c2225a75fda$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $g90JB.resetTracking)();
    $63eb0c2225a75fda$var$isWarning = false;
}
function $63eb0c2225a75fda$var$getComponentTrace() {
    let currentVNode = $63eb0c2225a75fda$var$stack[$63eb0c2225a75fda$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $63eb0c2225a75fda$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$63eb0c2225a75fda$var$formatTraceEntry(entry));
    });
    return logs;
}
function $63eb0c2225a75fda$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$63eb0c2225a75fda$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$63eb0c2225a75fda$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $63eb0c2225a75fda$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$63eb0c2225a75fda$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $63eb0c2225a75fda$var$formatProp(key, value, raw) {
    if ((0, $6ZvW5.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $g90JB.isRef)(value)) {
        value = $63eb0c2225a75fda$var$formatProp(key, (0, $g90JB.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $6ZvW5.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $g90JB.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $63eb0c2225a75fda$export$dfbcecb440255e4a(val, type) {
    return;
}
const $63eb0c2225a75fda$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $63eb0c2225a75fda$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $63eb0c2225a75fda$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $63eb0c2225a75fda$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $63eb0c2225a75fda$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $6ZvW5.isFunction)(fn)) {
        const res = $63eb0c2225a75fda$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $6ZvW5.isPromise)(res)) res.catch((err)=>{
            $63eb0c2225a75fda$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $6ZvW5.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($63eb0c2225a75fda$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $63eb0c2225a75fda$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $6ZvW5.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $g90JB.pauseTracking)();
            $63eb0c2225a75fda$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $g90JB.resetTracking)();
            return;
        }
    }
    $63eb0c2225a75fda$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $63eb0c2225a75fda$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $63eb0c2225a75fda$var$queue = [];
let $63eb0c2225a75fda$var$flushIndex = -1;
const $63eb0c2225a75fda$var$pendingPostFlushCbs = [];
let $63eb0c2225a75fda$var$activePostFlushCbs = null;
let $63eb0c2225a75fda$var$postFlushIndex = 0;
const $63eb0c2225a75fda$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $63eb0c2225a75fda$var$currentFlushPromise = null;
const $63eb0c2225a75fda$var$RECURSION_LIMIT = 100;
function $63eb0c2225a75fda$export$bdd553fddd433dcb(fn) {
    const p = $63eb0c2225a75fda$var$currentFlushPromise || $63eb0c2225a75fda$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $63eb0c2225a75fda$var$findInsertionIndex(id) {
    let start = $63eb0c2225a75fda$var$flushIndex + 1;
    let end = $63eb0c2225a75fda$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $63eb0c2225a75fda$var$queue[middle];
        const middleJobId = $63eb0c2225a75fda$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $63eb0c2225a75fda$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $63eb0c2225a75fda$var$getId(job);
        const lastJob = $63eb0c2225a75fda$var$queue[$63eb0c2225a75fda$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $63eb0c2225a75fda$var$getId(lastJob)) $63eb0c2225a75fda$var$queue.push(job);
        else $63eb0c2225a75fda$var$queue.splice($63eb0c2225a75fda$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $63eb0c2225a75fda$var$queueFlush();
    }
}
function $63eb0c2225a75fda$var$queueFlush() {
    if (!$63eb0c2225a75fda$var$currentFlushPromise) $63eb0c2225a75fda$var$currentFlushPromise = $63eb0c2225a75fda$var$resolvedPromise.then($63eb0c2225a75fda$var$flushJobs);
}
function $63eb0c2225a75fda$export$59536a0199721cab(cb) {
    if (!(0, $6ZvW5.isArray)(cb)) {
        if ($63eb0c2225a75fda$var$activePostFlushCbs && cb.id === -1) $63eb0c2225a75fda$var$activePostFlushCbs.splice($63eb0c2225a75fda$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $63eb0c2225a75fda$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $63eb0c2225a75fda$var$pendingPostFlushCbs.push(...cb);
    $63eb0c2225a75fda$var$queueFlush();
}
function $63eb0c2225a75fda$var$flushPreFlushCbs(instance, seen, i = $63eb0c2225a75fda$var$flushIndex + 1) {
    for(; i < $63eb0c2225a75fda$var$queue.length; i++){
        const cb = $63eb0c2225a75fda$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $63eb0c2225a75fda$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $63eb0c2225a75fda$var$flushPostFlushCbs(seen) {
    if ($63eb0c2225a75fda$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($63eb0c2225a75fda$var$pendingPostFlushCbs)
        ].sort((a, b)=>$63eb0c2225a75fda$var$getId(a) - $63eb0c2225a75fda$var$getId(b));
        $63eb0c2225a75fda$var$pendingPostFlushCbs.length = 0;
        if ($63eb0c2225a75fda$var$activePostFlushCbs) {
            $63eb0c2225a75fda$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $63eb0c2225a75fda$var$activePostFlushCbs = deduped;
        for($63eb0c2225a75fda$var$postFlushIndex = 0; $63eb0c2225a75fda$var$postFlushIndex < $63eb0c2225a75fda$var$activePostFlushCbs.length; $63eb0c2225a75fda$var$postFlushIndex++){
            const cb = $63eb0c2225a75fda$var$activePostFlushCbs[$63eb0c2225a75fda$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $63eb0c2225a75fda$var$activePostFlushCbs = null;
        $63eb0c2225a75fda$var$postFlushIndex = 0;
    }
}
const $63eb0c2225a75fda$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $63eb0c2225a75fda$var$flushJobs(seen) {
    const check = (0, $6ZvW5.NOOP);
    try {
        for($63eb0c2225a75fda$var$flushIndex = 0; $63eb0c2225a75fda$var$flushIndex < $63eb0c2225a75fda$var$queue.length; $63eb0c2225a75fda$var$flushIndex++){
            const job = $63eb0c2225a75fda$var$queue[$63eb0c2225a75fda$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $63eb0c2225a75fda$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $63eb0c2225a75fda$var$flushIndex < $63eb0c2225a75fda$var$queue.length; $63eb0c2225a75fda$var$flushIndex++){
            const job = $63eb0c2225a75fda$var$queue[$63eb0c2225a75fda$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $63eb0c2225a75fda$var$flushIndex = -1;
        $63eb0c2225a75fda$var$queue.length = 0;
        $63eb0c2225a75fda$var$flushPostFlushCbs(seen);
        $63eb0c2225a75fda$var$currentFlushPromise = null;
        if ($63eb0c2225a75fda$var$queue.length || $63eb0c2225a75fda$var$pendingPostFlushCbs.length) $63eb0c2225a75fda$var$flushJobs(seen);
    }
}
function $63eb0c2225a75fda$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $63eb0c2225a75fda$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $63eb0c2225a75fda$var$getComponentName(instance.type);
        $63eb0c2225a75fda$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $63eb0c2225a75fda$var$isHmrUpdating = false;
const $63eb0c2225a75fda$var$setHmrUpdating = (v1)=>{
    try {
        return $63eb0c2225a75fda$var$isHmrUpdating;
    } finally{
        $63eb0c2225a75fda$var$isHmrUpdating = v1;
    }
};
const $63eb0c2225a75fda$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $63eb0c2225a75fda$var$map = /* @__PURE__ */ new Map();
function $63eb0c2225a75fda$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $63eb0c2225a75fda$var$map.get(id);
    if (!record) {
        $63eb0c2225a75fda$var$createRecord(id, instance.type);
        record = $63eb0c2225a75fda$var$map.get(id);
    }
    record.instances.add(instance);
}
function $63eb0c2225a75fda$var$unregisterHMR(instance) {
    $63eb0c2225a75fda$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $63eb0c2225a75fda$var$createRecord(id, initialDef) {
    if ($63eb0c2225a75fda$var$map.has(id)) return false;
    $63eb0c2225a75fda$var$map.set(id, {
        initialDef: $63eb0c2225a75fda$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $63eb0c2225a75fda$var$normalizeClassComponent(component) {
    return $63eb0c2225a75fda$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $63eb0c2225a75fda$var$rerender(id, newRender) {
    const record = $63eb0c2225a75fda$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $63eb0c2225a75fda$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $63eb0c2225a75fda$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $63eb0c2225a75fda$var$isHmrUpdating = false;
    });
}
function $63eb0c2225a75fda$var$reload(id, newComp) {
    const record = $63eb0c2225a75fda$var$map.get(id);
    if (!record) return;
    newComp = $63eb0c2225a75fda$var$normalizeClassComponent(newComp);
    $63eb0c2225a75fda$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $63eb0c2225a75fda$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $63eb0c2225a75fda$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $63eb0c2225a75fda$var$updateComponentDef(oldComp, newComp);
            $63eb0c2225a75fda$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $63eb0c2225a75fda$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $63eb0c2225a75fda$var$isHmrUpdating = true;
                instance.parent.update();
                $63eb0c2225a75fda$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $63eb0c2225a75fda$export$59536a0199721cab(()=>{
        $63eb0c2225a75fda$var$hmrDirtyComponents.clear();
    });
}
function $63eb0c2225a75fda$var$updateComponentDef(oldComp, newComp) {
    (0, $6ZvW5.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $63eb0c2225a75fda$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $63eb0c2225a75fda$var$devtools$1;
let $63eb0c2225a75fda$var$buffer = [];
let $63eb0c2225a75fda$var$devtoolsNotInstalled = false;
function $63eb0c2225a75fda$var$emit$1(event, ...args) {
    if ($63eb0c2225a75fda$var$devtools$1) $63eb0c2225a75fda$var$devtools$1.emit(event, ...args);
    else if (!$63eb0c2225a75fda$var$devtoolsNotInstalled) $63eb0c2225a75fda$var$buffer.push({
        event: event,
        args: args
    });
}
function $63eb0c2225a75fda$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $63eb0c2225a75fda$var$devtools$1 = hook;
    if ($63eb0c2225a75fda$var$devtools$1) {
        $63eb0c2225a75fda$var$devtools$1.enabled = true;
        $63eb0c2225a75fda$var$buffer.forEach(({ event: event, args: args })=>$63eb0c2225a75fda$var$devtools$1.emit(event, ...args));
        $63eb0c2225a75fda$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $63eb0c2225a75fda$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$63eb0c2225a75fda$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $63eb0c2225a75fda$var$devtoolsNotInstalled = true;
                $63eb0c2225a75fda$var$buffer = [];
            }
        }, 3e3);
    } else {
        $63eb0c2225a75fda$var$devtoolsNotInstalled = true;
        $63eb0c2225a75fda$var$buffer = [];
    }
}
function $63eb0c2225a75fda$var$devtoolsInitApp(app, version) {
    $63eb0c2225a75fda$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $63eb0c2225a75fda$export$ffb0004e005737fa,
        Text: $63eb0c2225a75fda$export$5f1af8db9871e1d6,
        Comment: $63eb0c2225a75fda$export$4d299b491347818a,
        Static: $63eb0c2225a75fda$export$c1b9a1d3af45b7b6
    });
}
function $63eb0c2225a75fda$var$devtoolsUnmountApp(app) {
    $63eb0c2225a75fda$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $63eb0c2225a75fda$var$devtoolsComponentAdded = /* @__PURE__ */ $63eb0c2225a75fda$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $63eb0c2225a75fda$var$devtoolsComponentUpdated = /* @__PURE__ */ $63eb0c2225a75fda$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $63eb0c2225a75fda$var$_devtoolsComponentRemoved = /* @__PURE__ */ $63eb0c2225a75fda$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $63eb0c2225a75fda$var$devtoolsComponentRemoved = (component)=>{
    if ($63eb0c2225a75fda$var$devtools$1 && typeof $63eb0c2225a75fda$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$63eb0c2225a75fda$var$devtools$1.cleanupBuffer(component)) $63eb0c2225a75fda$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $63eb0c2225a75fda$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $63eb0c2225a75fda$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $63eb0c2225a75fda$var$devtoolsPerfStart = /* @__PURE__ */ $63eb0c2225a75fda$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $63eb0c2225a75fda$var$devtoolsPerfEnd = /* @__PURE__ */ $63eb0c2225a75fda$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $63eb0c2225a75fda$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $63eb0c2225a75fda$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $63eb0c2225a75fda$var$devtoolsComponentEmit(component, event, params) {
    $63eb0c2225a75fda$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $63eb0c2225a75fda$var$currentRenderingInstance = null;
let $63eb0c2225a75fda$var$currentScopeId = null;
function $63eb0c2225a75fda$var$setCurrentRenderingInstance(instance) {
    const prev = $63eb0c2225a75fda$var$currentRenderingInstance;
    $63eb0c2225a75fda$var$currentRenderingInstance = instance;
    $63eb0c2225a75fda$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $63eb0c2225a75fda$export$ac020265ca2cc4cd(id) {
    $63eb0c2225a75fda$var$currentScopeId = id;
}
function $63eb0c2225a75fda$export$f2dc6805dc11834e() {
    $63eb0c2225a75fda$var$currentScopeId = null;
}
const $63eb0c2225a75fda$export$15ba313e13f3dd04 = (_id)=>$63eb0c2225a75fda$export$694b237e827a3d23;
function $63eb0c2225a75fda$export$694b237e827a3d23(fn, ctx = $63eb0c2225a75fda$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $63eb0c2225a75fda$export$c20bee82f26f1e27(-1);
        const prevInstance = $63eb0c2225a75fda$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $63eb0c2225a75fda$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $63eb0c2225a75fda$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $63eb0c2225a75fda$var$validateDirectiveName(name) {
    if ((0, $6ZvW5.isBuiltInDirective)(name)) $63eb0c2225a75fda$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $63eb0c2225a75fda$export$49729353e7c1e6c5(vnode, directives) {
    if ($63eb0c2225a75fda$var$currentRenderingInstance === null) return vnode;
    const instance = $63eb0c2225a75fda$var$getComponentPublicInstance($63eb0c2225a75fda$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $6ZvW5.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $6ZvW5.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $g90JB.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $g90JB.pauseTracking)();
            $63eb0c2225a75fda$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $g90JB.resetTracking)();
        }
    }
}
function $63eb0c2225a75fda$export$abe1e183e22e10ad(key, value) {
    if ($63eb0c2225a75fda$var$currentInstance) {
        let provides = $63eb0c2225a75fda$var$currentInstance.provides;
        const parentProvides = $63eb0c2225a75fda$var$currentInstance.parent && $63eb0c2225a75fda$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $63eb0c2225a75fda$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $63eb0c2225a75fda$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $63eb0c2225a75fda$export$f13e630aa3915748();
    if (instance || $63eb0c2225a75fda$var$currentApp) {
        let provides = $63eb0c2225a75fda$var$currentApp ? $63eb0c2225a75fda$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $6ZvW5.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $63eb0c2225a75fda$export$caf6761f24fc571a() {
    return !!($63eb0c2225a75fda$export$f13e630aa3915748() || $63eb0c2225a75fda$var$currentApp);
}
const $63eb0c2225a75fda$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $63eb0c2225a75fda$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $63eb0c2225a75fda$export$a976684a0efeb93f($63eb0c2225a75fda$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $63eb0c2225a75fda$export$ede35fc0e5500309(effect, options) {
    return $63eb0c2225a75fda$var$doWatch(effect, null, options);
}
function $63eb0c2225a75fda$export$b7f27ea67102d543(effect, options) {
    return $63eb0c2225a75fda$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $63eb0c2225a75fda$export$2035654f31b0e555(effect, options) {
    return $63eb0c2225a75fda$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $63eb0c2225a75fda$export$3db5d71bdb2d5499(source, cb, options) {
    return $63eb0c2225a75fda$var$doWatch(source, cb, options);
}
function $63eb0c2225a75fda$var$doWatch(source, cb, options = (0, $6ZvW5.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $6ZvW5.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($63eb0c2225a75fda$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $63eb0c2225a75fda$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $6ZvW5.NOOP);
            watchStopHandle.resume = (0, $6ZvW5.NOOP);
            watchStopHandle.pause = (0, $6ZvW5.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $63eb0c2225a75fda$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$63eb0c2225a75fda$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $63eb0c2225a75fda$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $63eb0c2225a75fda$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $g90JB.watch)(source, cb, baseWatchOptions);
    if ($63eb0c2225a75fda$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $63eb0c2225a75fda$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $6ZvW5.isString)(source) ? source.includes(".") ? $63eb0c2225a75fda$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $6ZvW5.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $63eb0c2225a75fda$var$setCurrentInstance(this);
    const res = $63eb0c2225a75fda$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $63eb0c2225a75fda$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $63eb0c2225a75fda$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $63eb0c2225a75fda$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $63eb0c2225a75fda$var$isTeleport = (type)=>type.__isTeleport;
const $63eb0c2225a75fda$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $63eb0c2225a75fda$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $63eb0c2225a75fda$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $63eb0c2225a75fda$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $63eb0c2225a75fda$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $6ZvW5.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $63eb0c2225a75fda$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $63eb0c2225a75fda$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $63eb0c2225a75fda$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $63eb0c2225a75fda$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $63eb0c2225a75fda$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $63eb0c2225a75fda$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $63eb0c2225a75fda$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $63eb0c2225a75fda$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($63eb0c2225a75fda$var$pendingMounts.get(vnode) !== mountJob) return;
                $63eb0c2225a75fda$var$pendingMounts.delete(vnode);
                if ($63eb0c2225a75fda$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $63eb0c2225a75fda$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $63eb0c2225a75fda$var$pendingMounts.set(vnode, mountJob);
            $63eb0c2225a75fda$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($63eb0c2225a75fda$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $63eb0c2225a75fda$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $63eb0c2225a75fda$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $63eb0c2225a75fda$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $63eb0c2225a75fda$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $63eb0c2225a75fda$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $63eb0c2225a75fda$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $63eb0c2225a75fda$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $63eb0c2225a75fda$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $63eb0c2225a75fda$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $63eb0c2225a75fda$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $63eb0c2225a75fda$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $63eb0c2225a75fda$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const shouldRemove = doRemove || !$63eb0c2225a75fda$var$isTeleportDisabled(props);
        const pendingMount = $63eb0c2225a75fda$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $63eb0c2225a75fda$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $63eb0c2225a75fda$var$moveTeleport,
    hydrate: $63eb0c2225a75fda$var$hydrateTeleport
};
function $63eb0c2225a75fda$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$63eb0c2225a75fda$var$pendingMounts.has(vnode) && (!isReorder || $63eb0c2225a75fda$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $63eb0c2225a75fda$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $63eb0c2225a75fda$var$resolveTarget(vnode.props, querySelector);
    const disabled = $63eb0c2225a75fda$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $63eb0c2225a75fda$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $63eb0c2225a75fda$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $63eb0c2225a75fda$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $63eb0c2225a75fda$export$76d55a0304a371f4 = $63eb0c2225a75fda$var$TeleportImpl;
function $63eb0c2225a75fda$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $63eb0c2225a75fda$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$63eb0c2225a75fda$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $63eb0c2225a75fda$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $63eb0c2225a75fda$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $63eb0c2225a75fda$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $63eb0c2225a75fda$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $63eb0c2225a75fda$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $63eb0c2225a75fda$var$TransitionHookValidator = [
    Function,
    Array
];
const $63eb0c2225a75fda$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $63eb0c2225a75fda$var$TransitionHookValidator,
    onEnter: $63eb0c2225a75fda$var$TransitionHookValidator,
    onAfterEnter: $63eb0c2225a75fda$var$TransitionHookValidator,
    onEnterCancelled: $63eb0c2225a75fda$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $63eb0c2225a75fda$var$TransitionHookValidator,
    onLeave: $63eb0c2225a75fda$var$TransitionHookValidator,
    onAfterLeave: $63eb0c2225a75fda$var$TransitionHookValidator,
    onLeaveCancelled: $63eb0c2225a75fda$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $63eb0c2225a75fda$var$TransitionHookValidator,
    onAppear: $63eb0c2225a75fda$var$TransitionHookValidator,
    onAfterAppear: $63eb0c2225a75fda$var$TransitionHookValidator,
    onAppearCancelled: $63eb0c2225a75fda$var$TransitionHookValidator
};
const $63eb0c2225a75fda$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $63eb0c2225a75fda$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $63eb0c2225a75fda$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $63eb0c2225a75fda$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $63eb0c2225a75fda$export$f13e630aa3915748();
        const state = $63eb0c2225a75fda$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $63eb0c2225a75fda$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $63eb0c2225a75fda$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $63eb0c2225a75fda$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $g90JB.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $63eb0c2225a75fda$var$emptyPlaceholder(child);
            const innerChild = $63eb0c2225a75fda$var$getInnerChild$1(child);
            if (!innerChild) return $63eb0c2225a75fda$var$emptyPlaceholder(child);
            let enterHooks = $63eb0c2225a75fda$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $63eb0c2225a75fda$export$4d299b491347818a) $63eb0c2225a75fda$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $63eb0c2225a75fda$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $63eb0c2225a75fda$export$4d299b491347818a && !$63eb0c2225a75fda$var$isSameVNodeType(oldInnerChild, innerChild) && $63eb0c2225a75fda$var$recursiveGetSubtree(instance).type !== $63eb0c2225a75fda$export$4d299b491347818a) {
                let leavingHooks = $63eb0c2225a75fda$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $63eb0c2225a75fda$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $63eb0c2225a75fda$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $63eb0c2225a75fda$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $63eb0c2225a75fda$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $63eb0c2225a75fda$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$63eb0c2225a75fda$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$63eb0c2225a75fda$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $63eb0c2225a75fda$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $63eb0c2225a75fda$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $63eb0c2225a75fda$export$abd95b5f5e8a8837 = $63eb0c2225a75fda$var$BaseTransitionImpl;
function $63eb0c2225a75fda$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $63eb0c2225a75fda$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $63eb0c2225a75fda$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $63eb0c2225a75fda$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $6ZvW5.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$63eb0c2225a75fda$var$leaveCbKey]) el[$63eb0c2225a75fda$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $63eb0c2225a75fda$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$63eb0c2225a75fda$var$leaveCbKey]) leavingVNode.el[$63eb0c2225a75fda$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$63eb0c2225a75fda$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$63eb0c2225a75fda$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$63eb0c2225a75fda$var$enterCbKey] = void 0;
            };
            const done = el[$63eb0c2225a75fda$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$63eb0c2225a75fda$var$enterCbKey]) el[$63eb0c2225a75fda$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$63eb0c2225a75fda$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$63eb0c2225a75fda$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$63eb0c2225a75fda$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $63eb0c2225a75fda$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $63eb0c2225a75fda$var$emptyPlaceholder(vnode) {
    if ($63eb0c2225a75fda$var$isKeepAlive(vnode)) {
        vnode = $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $63eb0c2225a75fda$var$getInnerChild$1(vnode) {
    if (!$63eb0c2225a75fda$var$isKeepAlive(vnode)) {
        if ($63eb0c2225a75fda$var$isTeleport(vnode.type) && vnode.children) return $63eb0c2225a75fda$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $6ZvW5.isFunction)(children.default)) return children.default();
    }
}
function $63eb0c2225a75fda$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $63eb0c2225a75fda$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $63eb0c2225a75fda$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $63eb0c2225a75fda$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($63eb0c2225a75fda$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $63eb0c2225a75fda$export$4d299b491347818a) ret.push(key != null ? $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $63eb0c2225a75fda$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $6ZvW5.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $6ZvW5.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $63eb0c2225a75fda$export$f680877a34711e37() {
    const i = $63eb0c2225a75fda$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $63eb0c2225a75fda$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $63eb0c2225a75fda$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $63eb0c2225a75fda$export$83a5dbc1f35517ca(key) {
    const i = $63eb0c2225a75fda$export$f13e630aa3915748();
    const r = (0, $g90JB.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $6ZvW5.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $63eb0c2225a75fda$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $63eb0c2225a75fda$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $63eb0c2225a75fda$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $6ZvW5.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$63eb0c2225a75fda$var$setRef(r, oldRawRef && ((0, $6ZvW5.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($63eb0c2225a75fda$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $63eb0c2225a75fda$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $63eb0c2225a75fda$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $6ZvW5.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $g90JB.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $6ZvW5.EMPTY_OBJ) ? (0, $6ZvW5.NO) : (key)=>{
        if ($63eb0c2225a75fda$var$isTemplateRefKey(refs, key)) return false;
        return (0, $6ZvW5.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $63eb0c2225a75fda$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $63eb0c2225a75fda$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $6ZvW5.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $g90JB.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $6ZvW5.isFunction)(ref)) $63eb0c2225a75fda$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $6ZvW5.isString)(ref);
        const _isRef = (0, $g90JB.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $6ZvW5.isArray)(existing) && (0, $6ZvW5.remove)(existing, refValue);
                    else {
                        if (!(0, $6ZvW5.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $63eb0c2225a75fda$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $63eb0c2225a75fda$var$pendingSetRefMap.set(rawRef, job);
                $63eb0c2225a75fda$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $63eb0c2225a75fda$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $63eb0c2225a75fda$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $63eb0c2225a75fda$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $63eb0c2225a75fda$var$pendingSetRefMap.delete(rawRef);
    }
}
let $63eb0c2225a75fda$var$hasLoggedMismatchError = false;
const $63eb0c2225a75fda$var$logMismatchError = ()=>{
    if ($63eb0c2225a75fda$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $63eb0c2225a75fda$var$hasLoggedMismatchError = true;
};
const $63eb0c2225a75fda$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $63eb0c2225a75fda$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $63eb0c2225a75fda$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($63eb0c2225a75fda$var$isSVGContainer(container)) return "svg";
    if ($63eb0c2225a75fda$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $63eb0c2225a75fda$var$isComment = (node)=>node.nodeType === 8;
function $63eb0c2225a75fda$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $63eb0c2225a75fda$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $63eb0c2225a75fda$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $63eb0c2225a75fda$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $63eb0c2225a75fda$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $6ZvW5.def)(node, "__vnode", vnode, true);
            (0, $6ZvW5.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $63eb0c2225a75fda$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $63eb0c2225a75fda$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $63eb0c2225a75fda$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $63eb0c2225a75fda$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $63eb0c2225a75fda$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $63eb0c2225a75fda$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($63eb0c2225a75fda$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $63eb0c2225a75fda$var$getContainerType(container), optimized);
                    if ($63eb0c2225a75fda$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $63eb0c2225a75fda$export$22f9b5ffd89dac9("") : $63eb0c2225a75fda$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $63eb0c2225a75fda$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $63eb0c2225a75fda$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $63eb0c2225a75fda$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $63eb0c2225a75fda$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$63eb0c2225a75fda$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $63eb0c2225a75fda$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $63eb0c2225a75fda$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$63eb0c2225a75fda$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $63eb0c2225a75fda$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $63eb0c2225a75fda$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $63eb0c2225a75fda$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $63eb0c2225a75fda$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $6ZvW5.isOn)(key) && !(0, $6ZvW5.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $6ZvW5.isReservedProp)(key)) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $g90JB.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $63eb0c2225a75fda$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $63eb0c2225a75fda$var$normalizeVNode(children[i]);
            const isText = vnode.type === $63eb0c2225a75fda$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $63eb0c2225a75fda$var$normalizeVNode(children[i + 1]).type === $63eb0c2225a75fda$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$63eb0c2225a75fda$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $63eb0c2225a75fda$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $63eb0c2225a75fda$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $63eb0c2225a75fda$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $63eb0c2225a75fda$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $63eb0c2225a75fda$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$63eb0c2225a75fda$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $63eb0c2225a75fda$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $63eb0c2225a75fda$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $63eb0c2225a75fda$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $63eb0c2225a75fda$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $63eb0c2225a75fda$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $63eb0c2225a75fda$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $63eb0c2225a75fda$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $6ZvW5.normalizeClass)(clientValue);
        if (!$63eb0c2225a75fda$var$isSetEqual($63eb0c2225a75fda$var$toClassSet(actual || ""), $63eb0c2225a75fda$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $6ZvW5.isString)(clientValue) ? clientValue : (0, $6ZvW5.stringifyStyle)((0, $6ZvW5.normalizeStyle)(clientValue));
        const actualMap = $63eb0c2225a75fda$var$toStyleMap(actual);
        const expectedMap = $63eb0c2225a75fda$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $63eb0c2225a75fda$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$63eb0c2225a75fda$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $6ZvW5.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $6ZvW5.isBooleanAttr)(key) || (0, $6ZvW5.isKnownHtmlAttr)(key))) {
        if ((0, $6ZvW5.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $6ZvW5.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $6ZvW5.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$63eb0c2225a75fda$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$63eb0c2225a75fda$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $63eb0c2225a75fda$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $63eb0c2225a75fda$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $63eb0c2225a75fda$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $63eb0c2225a75fda$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $63eb0c2225a75fda$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $63eb0c2225a75fda$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $63eb0c2225a75fda$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $6ZvW5.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $6ZvW5.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $63eb0c2225a75fda$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $63eb0c2225a75fda$var$allowMismatchAttr = "data-allow-mismatch";
const $63eb0c2225a75fda$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $63eb0c2225a75fda$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($63eb0c2225a75fda$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($63eb0c2225a75fda$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($63eb0c2225a75fda$var$MismatchTypeString[allowedType]);
    }
}
const $63eb0c2225a75fda$var$requestIdleCallback = (0, $6ZvW5.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $63eb0c2225a75fda$var$cancelIdleCallback = (0, $6ZvW5.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $63eb0c2225a75fda$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $63eb0c2225a75fda$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$63eb0c2225a75fda$var$cancelIdleCallback(id);
    };
function $63eb0c2225a75fda$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $63eb0c2225a75fda$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($63eb0c2225a75fda$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $63eb0c2225a75fda$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $63eb0c2225a75fda$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $6ZvW5.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $63eb0c2225a75fda$var$forEachElement(node, cb) {
    if ($63eb0c2225a75fda$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($63eb0c2225a75fda$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $63eb0c2225a75fda$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $63eb0c2225a75fda$export$d75d499b4c16cf21(source) {
    if ((0, $6ZvW5.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $63eb0c2225a75fda$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$63eb0c2225a75fda$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $63eb0c2225a75fda$var$currentInstance;
            $63eb0c2225a75fda$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$63eb0c2225a75fda$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $63eb0c2225a75fda$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $63eb0c2225a75fda$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$63eb0c2225a75fda$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $63eb0c2225a75fda$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $g90JB.ref)(false);
            const error = (0, $g90JB.ref)();
            const delayed = (0, $g90JB.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $63eb0c2225a75fda$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $63eb0c2225a75fda$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $63eb0c2225a75fda$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $63eb0c2225a75fda$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $63eb0c2225a75fda$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $63eb0c2225a75fda$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $63eb0c2225a75fda$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $63eb0c2225a75fda$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $63eb0c2225a75fda$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $63eb0c2225a75fda$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $63eb0c2225a75fda$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $6ZvW5.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $63eb0c2225a75fda$var$invalidateMount(instance2.m);
            $63eb0c2225a75fda$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $63eb0c2225a75fda$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $6ZvW5.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $63eb0c2225a75fda$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $63eb0c2225a75fda$var$getComponentName($63eb0c2225a75fda$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$63eb0c2225a75fda$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $63eb0c2225a75fda$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $63eb0c2225a75fda$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$63eb0c2225a75fda$var$matches(include, name));
            exclude && pruneCache((name)=>!$63eb0c2225a75fda$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($63eb0c2225a75fda$var$isSuspense(instance.subTree.type)) $63eb0c2225a75fda$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $63eb0c2225a75fda$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $63eb0c2225a75fda$var$getInnerChild(instance.subTree));
            }
        };
        $63eb0c2225a75fda$export$6d1641039221b5cb(cacheSubtree);
        $63eb0c2225a75fda$export$5876c47052fb88b1(cacheSubtree);
        $63eb0c2225a75fda$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $63eb0c2225a75fda$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $63eb0c2225a75fda$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $63eb0c2225a75fda$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$63eb0c2225a75fda$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $63eb0c2225a75fda$var$getInnerChild(rawVNode);
            if (vnode.type === $63eb0c2225a75fda$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $63eb0c2225a75fda$var$getComponentName($63eb0c2225a75fda$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$63eb0c2225a75fda$var$matches(include, name)) || exclude && name && $63eb0c2225a75fda$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $63eb0c2225a75fda$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $63eb0c2225a75fda$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $63eb0c2225a75fda$export$70eb8a58709972df = $63eb0c2225a75fda$var$KeepAliveImpl;
function $63eb0c2225a75fda$var$matches(pattern, name) {
    if ((0, $6ZvW5.isArray)(pattern)) return pattern.some((p)=>$63eb0c2225a75fda$var$matches(p, name));
    else if ((0, $6ZvW5.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $6ZvW5.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $63eb0c2225a75fda$export$ba52d824b95a2154(hook, target) {
    $63eb0c2225a75fda$var$registerKeepAliveHook(hook, "a", target);
}
function $63eb0c2225a75fda$export$bf1440eeaf5fa709(hook, target) {
    $63eb0c2225a75fda$var$registerKeepAliveHook(hook, "da", target);
}
function $63eb0c2225a75fda$var$registerKeepAliveHook(hook, type, target = $63eb0c2225a75fda$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $63eb0c2225a75fda$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($63eb0c2225a75fda$var$isKeepAlive(current.parent.vnode)) $63eb0c2225a75fda$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $63eb0c2225a75fda$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $63eb0c2225a75fda$var$injectHook(type, hook, keepAliveRoot, true);
    $63eb0c2225a75fda$export$13348a43ccacfe58(()=>{
        (0, $6ZvW5.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $63eb0c2225a75fda$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $63eb0c2225a75fda$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $63eb0c2225a75fda$var$injectHook(type, hook, target = $63eb0c2225a75fda$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $g90JB.pauseTracking)();
            const reset = $63eb0c2225a75fda$var$setCurrentInstance(target);
            const res = $63eb0c2225a75fda$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $g90JB.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $63eb0c2225a75fda$var$createHook = (lifecycle)=>(hook, target = $63eb0c2225a75fda$var$currentInstance)=>{
        if (!$63eb0c2225a75fda$var$isInSSRComponentSetup || lifecycle === "sp") $63eb0c2225a75fda$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $63eb0c2225a75fda$export$23b7aeb0d671f804 = $63eb0c2225a75fda$var$createHook("bm");
const $63eb0c2225a75fda$export$6d1641039221b5cb = $63eb0c2225a75fda$var$createHook("m");
const $63eb0c2225a75fda$export$ab91988a13872e4c = $63eb0c2225a75fda$var$createHook("bu");
const $63eb0c2225a75fda$export$5876c47052fb88b1 = $63eb0c2225a75fda$var$createHook("u");
const $63eb0c2225a75fda$export$40c420df62d2614 = $63eb0c2225a75fda$var$createHook("bum");
const $63eb0c2225a75fda$export$13348a43ccacfe58 = $63eb0c2225a75fda$var$createHook("um");
const $63eb0c2225a75fda$export$ebf0c601f267bceb = $63eb0c2225a75fda$var$createHook("sp");
const $63eb0c2225a75fda$export$898295a813d662eb = $63eb0c2225a75fda$var$createHook("rtg");
const $63eb0c2225a75fda$export$2b41f4235363e921 = $63eb0c2225a75fda$var$createHook("rtc");
function $63eb0c2225a75fda$export$6a3a15856e50ad19(hook, target = $63eb0c2225a75fda$var$currentInstance) {
    $63eb0c2225a75fda$var$injectHook("ec", hook, target);
}
const $63eb0c2225a75fda$var$COMPONENTS = "components";
const $63eb0c2225a75fda$var$DIRECTIVES = "directives";
function $63eb0c2225a75fda$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $63eb0c2225a75fda$var$resolveAsset($63eb0c2225a75fda$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $63eb0c2225a75fda$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $63eb0c2225a75fda$export$b44c564a05ca975(component) {
    if ((0, $6ZvW5.isString)(component)) return $63eb0c2225a75fda$var$resolveAsset($63eb0c2225a75fda$var$COMPONENTS, component, false) || component;
    else return component || $63eb0c2225a75fda$var$NULL_DYNAMIC_COMPONENT;
}
function $63eb0c2225a75fda$export$a1989e995cd481be(name) {
    return $63eb0c2225a75fda$var$resolveAsset($63eb0c2225a75fda$var$DIRECTIVES, name);
}
function $63eb0c2225a75fda$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $63eb0c2225a75fda$var$currentRenderingInstance || $63eb0c2225a75fda$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $63eb0c2225a75fda$var$COMPONENTS) {
            const selfName = $63eb0c2225a75fda$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $6ZvW5.camelize)(name) || selfName === (0, $6ZvW5.capitalize)((0, $6ZvW5.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $63eb0c2225a75fda$var$resolve(instance[type] || Component[type], name) || // global registration
        $63eb0c2225a75fda$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $63eb0c2225a75fda$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $6ZvW5.camelize)(name)] || registry[(0, $6ZvW5.capitalize)((0, $6ZvW5.camelize)(name))]);
}
function $63eb0c2225a75fda$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $6ZvW5.isArray)(source);
    if (sourceIsArray || (0, $6ZvW5.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $g90JB.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $g90JB.isShallow)(source);
            isReadonlySource = (0, $g90JB.isReadonly)(source);
            source = (0, $g90JB.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $g90JB.toReadonly)((0, $g90JB.toReactive)(source[i])) : (0, $g90JB.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $6ZvW5.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $63eb0c2225a75fda$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $6ZvW5.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $63eb0c2225a75fda$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($63eb0c2225a75fda$var$currentRenderingInstance.ce || $63eb0c2225a75fda$var$currentRenderingInstance.parent && $63eb0c2225a75fda$var$isAsyncWrapper($63eb0c2225a75fda$var$currentRenderingInstance.parent) && $63eb0c2225a75fda$var$currentRenderingInstance.parent.ce) {
        const hasProps = Object.keys(props).length > 0;
        if (name !== "default") props.name = name;
        return $63eb0c2225a75fda$export$e7eaa45e502fe5cc(), $63eb0c2225a75fda$export$9f2dfe8048dfb22b($63eb0c2225a75fda$export$ffb0004e005737fa, null, [
            $63eb0c2225a75fda$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $63eb0c2225a75fda$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $63eb0c2225a75fda$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $63eb0c2225a75fda$export$9f2dfe8048dfb22b($63eb0c2225a75fda$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $6ZvW5.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $63eb0c2225a75fda$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$63eb0c2225a75fda$export$3868d13f8734ae81(child)) return true;
        if (child.type === $63eb0c2225a75fda$export$4d299b491347818a) return false;
        if (child.type === $63eb0c2225a75fda$export$ffb0004e005737fa && !$63eb0c2225a75fda$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $63eb0c2225a75fda$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $6ZvW5.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $63eb0c2225a75fda$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($63eb0c2225a75fda$var$isStatefulComponent(i)) return $63eb0c2225a75fda$var$getComponentPublicInstance(i);
    return $63eb0c2225a75fda$var$getPublicInstance(i.parent);
};
const $63eb0c2225a75fda$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $6ZvW5.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$63eb0c2225a75fda$var$getPublicInstance(i.parent),
    $root: (i)=>$63eb0c2225a75fda$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $63eb0c2225a75fda$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $63eb0c2225a75fda$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $63eb0c2225a75fda$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $63eb0c2225a75fda$var$instanceWatch.bind(i) : (0, $6ZvW5.NOOP)
});
const $63eb0c2225a75fda$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $63eb0c2225a75fda$var$hasSetupBinding = (state, key)=>state !== (0, $6ZvW5.EMPTY_OBJ) && !state.__isScriptSetup && (0, $6ZvW5.hasOwn)(state, key);
const $63eb0c2225a75fda$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($63eb0c2225a75fda$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $6ZvW5.EMPTY_OBJ) && (0, $6ZvW5.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $6ZvW5.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $6ZvW5.EMPTY_OBJ) && (0, $6ZvW5.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $63eb0c2225a75fda$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $63eb0c2225a75fda$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $g90JB.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $6ZvW5.EMPTY_OBJ) && (0, $6ZvW5.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $6ZvW5.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($63eb0c2225a75fda$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $6ZvW5.EMPTY_OBJ) && (0, $6ZvW5.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $6ZvW5.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $6ZvW5.EMPTY_OBJ) && key[0] !== "$" && (0, $6ZvW5.hasOwn)(data, key) || $63eb0c2225a75fda$var$hasSetupBinding(setupState, key) || (0, $6ZvW5.hasOwn)(props, key) || (0, $6ZvW5.hasOwn)(ctx, key) || (0, $6ZvW5.hasOwn)($63eb0c2225a75fda$var$publicPropertiesMap, key) || (0, $6ZvW5.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $6ZvW5.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $63eb0c2225a75fda$var$target;
const $63eb0c2225a75fda$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $6ZvW5.extend)({}, $63eb0c2225a75fda$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $63eb0c2225a75fda$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $6ZvW5.isGloballyAllowed)(key);
        return has;
    }
});
function $63eb0c2225a75fda$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($63eb0c2225a75fda$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$63eb0c2225a75fda$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $6ZvW5.NOOP)
        });
    });
    return target;
}
function $63eb0c2225a75fda$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $6ZvW5.NOOP)
        });
    });
}
function $63eb0c2225a75fda$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $g90JB.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($63eb0c2225a75fda$var$isReservedPrefix(key[0])) {
                $63eb0c2225a75fda$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $6ZvW5.NOOP)
            });
        }
    });
}
const $63eb0c2225a75fda$var$warnRuntimeUsage = (method)=>$63eb0c2225a75fda$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $63eb0c2225a75fda$export$80b33eababae110e() {
    return null;
}
function $63eb0c2225a75fda$export$51ecece22fc17ddc() {
    return null;
}
function $63eb0c2225a75fda$export$da25b65ca24b518a(exposed) {}
function $63eb0c2225a75fda$export$77e79129327f3d0d(options) {}
function $63eb0c2225a75fda$export$1b3acd4bb805b712() {
    return null;
}
function $63eb0c2225a75fda$export$acd55aa037e791bb() {}
function $63eb0c2225a75fda$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $63eb0c2225a75fda$export$9203a8e84125433c() {
    return $63eb0c2225a75fda$var$getContext("useSlots").slots;
}
function $63eb0c2225a75fda$export$75e29435042cd2ea() {
    return $63eb0c2225a75fda$var$getContext("useAttrs").attrs;
}
function $63eb0c2225a75fda$var$getContext(calledFunctionName) {
    const i = $63eb0c2225a75fda$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $63eb0c2225a75fda$var$createSetupContext(i));
}
function $63eb0c2225a75fda$var$normalizePropsOrEmits(props) {
    return (0, $6ZvW5.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $63eb0c2225a75fda$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $63eb0c2225a75fda$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $6ZvW5.isArray)(opt) || (0, $6ZvW5.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $63eb0c2225a75fda$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $6ZvW5.isArray)(a) && (0, $6ZvW5.isArray)(b)) return a.concat(b);
    return (0, $6ZvW5.extend)({}, $63eb0c2225a75fda$var$normalizePropsOrEmits(a), $63eb0c2225a75fda$var$normalizePropsOrEmits(b));
}
function $63eb0c2225a75fda$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $63eb0c2225a75fda$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $63eb0c2225a75fda$export$f13e630aa3915748();
    const inSSRSetup = $63eb0c2225a75fda$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $63eb0c2225a75fda$var$unsetCurrentInstance();
    if (inSSRSetup) $63eb0c2225a75fda$var$setInSSRSetupState(false);
    const restore = ()=>{
        $63eb0c2225a75fda$var$setCurrentInstance(ctx);
        if (inSSRSetup) $63eb0c2225a75fda$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($63eb0c2225a75fda$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $63eb0c2225a75fda$var$unsetCurrentInstance();
        if (inSSRSetup) $63eb0c2225a75fda$var$setInSSRSetupState(false);
    };
    if ((0, $6ZvW5.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $63eb0c2225a75fda$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $63eb0c2225a75fda$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $63eb0c2225a75fda$var$shouldCacheAccess = true;
function $63eb0c2225a75fda$var$applyOptions(instance) {
    const options = $63eb0c2225a75fda$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $63eb0c2225a75fda$var$shouldCacheAccess = false;
    if (options.beforeCreate) $63eb0c2225a75fda$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $63eb0c2225a75fda$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $6ZvW5.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $6ZvW5.isObject)(data)) ;
        else instance.data = (0, $g90JB.reactive)(data);
    }
    $63eb0c2225a75fda$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $6ZvW5.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $6ZvW5.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $6ZvW5.NOOP);
        const set = !(0, $6ZvW5.isFunction)(opt) && (0, $6ZvW5.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $6ZvW5.NOOP);
        const c = $63eb0c2225a75fda$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$63eb0c2225a75fda$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $6ZvW5.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $63eb0c2225a75fda$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $63eb0c2225a75fda$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $6ZvW5.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($63eb0c2225a75fda$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($63eb0c2225a75fda$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($63eb0c2225a75fda$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($63eb0c2225a75fda$export$5876c47052fb88b1, updated);
    registerLifecycleHook($63eb0c2225a75fda$export$ba52d824b95a2154, activated);
    registerLifecycleHook($63eb0c2225a75fda$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($63eb0c2225a75fda$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($63eb0c2225a75fda$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($63eb0c2225a75fda$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($63eb0c2225a75fda$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($63eb0c2225a75fda$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($63eb0c2225a75fda$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $6ZvW5.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $6ZvW5.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $63eb0c2225a75fda$var$markAsyncBoundary(instance);
}
function $63eb0c2225a75fda$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $6ZvW5.NOOP)) {
    if ((0, $6ZvW5.isArray)(injectOptions)) injectOptions = $63eb0c2225a75fda$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $6ZvW5.isObject)(opt)) {
            if ("default" in opt) injected = $63eb0c2225a75fda$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $63eb0c2225a75fda$export$a976684a0efeb93f(opt.from || key);
        } else injected = $63eb0c2225a75fda$export$a976684a0efeb93f(opt);
        if ((0, $g90JB.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $63eb0c2225a75fda$var$callHook(hook, instance, type) {
    $63eb0c2225a75fda$export$dae85862a8d94378((0, $6ZvW5.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $63eb0c2225a75fda$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $63eb0c2225a75fda$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $6ZvW5.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $6ZvW5.isFunction)(handler)) $63eb0c2225a75fda$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $6ZvW5.isFunction)(raw)) $63eb0c2225a75fda$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $6ZvW5.isObject)(raw)) {
        if ((0, $6ZvW5.isArray)(raw)) raw.forEach((r)=>$63eb0c2225a75fda$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $6ZvW5.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $6ZvW5.isFunction)(handler)) $63eb0c2225a75fda$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $63eb0c2225a75fda$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$63eb0c2225a75fda$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $63eb0c2225a75fda$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $6ZvW5.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $63eb0c2225a75fda$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $63eb0c2225a75fda$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$63eb0c2225a75fda$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $63eb0c2225a75fda$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $63eb0c2225a75fda$var$internalOptionMergeStrats = {
    data: $63eb0c2225a75fda$var$mergeDataFn,
    props: $63eb0c2225a75fda$var$mergeEmitsOrPropsOptions,
    emits: $63eb0c2225a75fda$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $63eb0c2225a75fda$var$mergeObjectOptions,
    computed: $63eb0c2225a75fda$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $63eb0c2225a75fda$var$mergeAsArray,
    created: $63eb0c2225a75fda$var$mergeAsArray,
    beforeMount: $63eb0c2225a75fda$var$mergeAsArray,
    mounted: $63eb0c2225a75fda$var$mergeAsArray,
    beforeUpdate: $63eb0c2225a75fda$var$mergeAsArray,
    updated: $63eb0c2225a75fda$var$mergeAsArray,
    beforeDestroy: $63eb0c2225a75fda$var$mergeAsArray,
    beforeUnmount: $63eb0c2225a75fda$var$mergeAsArray,
    destroyed: $63eb0c2225a75fda$var$mergeAsArray,
    unmounted: $63eb0c2225a75fda$var$mergeAsArray,
    activated: $63eb0c2225a75fda$var$mergeAsArray,
    deactivated: $63eb0c2225a75fda$var$mergeAsArray,
    errorCaptured: $63eb0c2225a75fda$var$mergeAsArray,
    serverPrefetch: $63eb0c2225a75fda$var$mergeAsArray,
    // assets
    components: $63eb0c2225a75fda$var$mergeObjectOptions,
    directives: $63eb0c2225a75fda$var$mergeObjectOptions,
    // watch
    watch: $63eb0c2225a75fda$var$mergeWatchOptions,
    // provide / inject
    provide: $63eb0c2225a75fda$var$mergeDataFn,
    inject: $63eb0c2225a75fda$var$mergeInject
};
function $63eb0c2225a75fda$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $6ZvW5.extend)((0, $6ZvW5.isFunction)(to) ? to.call(this, this) : to, (0, $6ZvW5.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $63eb0c2225a75fda$var$mergeInject(to, from) {
    return $63eb0c2225a75fda$var$mergeObjectOptions($63eb0c2225a75fda$var$normalizeInject(to), $63eb0c2225a75fda$var$normalizeInject(from));
}
function $63eb0c2225a75fda$var$normalizeInject(raw) {
    if ((0, $6ZvW5.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $63eb0c2225a75fda$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $63eb0c2225a75fda$var$mergeObjectOptions(to, from) {
    return to ? (0, $6ZvW5.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $63eb0c2225a75fda$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $6ZvW5.isArray)(to) && (0, $6ZvW5.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $6ZvW5.extend)(/* @__PURE__ */ Object.create(null), $63eb0c2225a75fda$var$normalizePropsOrEmits(to), $63eb0c2225a75fda$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $63eb0c2225a75fda$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $6ZvW5.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $63eb0c2225a75fda$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $63eb0c2225a75fda$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $6ZvW5.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $63eb0c2225a75fda$var$uid$1 = 0;
function $63eb0c2225a75fda$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $6ZvW5.isFunction)(rootComponent)) rootComponent = (0, $6ZvW5.extend)({}, rootComponent);
        if (rootProps != null && !(0, $6ZvW5.isObject)(rootProps)) rootProps = null;
        const context = $63eb0c2225a75fda$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $63eb0c2225a75fda$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $63eb0c2225a75fda$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $6ZvW5.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $6ZvW5.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $63eb0c2225a75fda$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $63eb0c2225a75fda$var$devtoolsInitApp(app, $63eb0c2225a75fda$export$83d89fbfd8236492);
                    }
                    return $63eb0c2225a75fda$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $63eb0c2225a75fda$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $63eb0c2225a75fda$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $63eb0c2225a75fda$var$currentApp;
                $63eb0c2225a75fda$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $63eb0c2225a75fda$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $63eb0c2225a75fda$var$currentApp = null;
function $63eb0c2225a75fda$export$fb78bd113157f1a1(props, name, options = (0, $6ZvW5.EMPTY_OBJ)) {
    const i = $63eb0c2225a75fda$export$f13e630aa3915748();
    const camelizedName = (0, $6ZvW5.camelize)(name);
    const hyphenatedName = (0, $6ZvW5.hyphenate)(name);
    const modifiers = $63eb0c2225a75fda$var$getModelModifiers(props, camelizedName);
    const res = (0, $g90JB.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $6ZvW5.EMPTY_OBJ);
        let prevEmittedValue;
        $63eb0c2225a75fda$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $6ZvW5.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $6ZvW5.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $6ZvW5.EMPTY_OBJ) && (0, $6ZvW5.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $6ZvW5.hasChanged)(value, prevSetValue) && ((0, $6ZvW5.hasChanged)(value, emittedValue) && !(0, $6ZvW5.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $6ZvW5.EMPTY_OBJ) && !(0, $6ZvW5.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $6ZvW5.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $63eb0c2225a75fda$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $6ZvW5.camelize)(modelName)}Modifiers`] || props[`${(0, $6ZvW5.hyphenate)(modelName)}Modifiers`];
};
function $63eb0c2225a75fda$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $6ZvW5.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $63eb0c2225a75fda$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $6ZvW5.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $6ZvW5.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $6ZvW5.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $6ZvW5.toHandlerKey)((0, $6ZvW5.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $6ZvW5.toHandlerKey)((0, $6ZvW5.hyphenate)(event))];
    if (handler) $63eb0c2225a75fda$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $63eb0c2225a75fda$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $63eb0c2225a75fda$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $63eb0c2225a75fda$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $63eb0c2225a75fda$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $6ZvW5.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $63eb0c2225a75fda$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $6ZvW5.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $6ZvW5.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $6ZvW5.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $6ZvW5.extend)(normalized, raw);
    if ((0, $6ZvW5.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $63eb0c2225a75fda$var$isEmitListener(options, key) {
    if (!options || !(0, $6ZvW5.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $6ZvW5.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $6ZvW5.hasOwn)(options, (0, $6ZvW5.hyphenate)(key)) || (0, $6ZvW5.hasOwn)(options, key);
}
let $63eb0c2225a75fda$var$accessedAttrs = false;
function $63eb0c2225a75fda$var$markAttrsAccessed() {
    $63eb0c2225a75fda$var$accessedAttrs = true;
}
function $63eb0c2225a75fda$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $63eb0c2225a75fda$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $63eb0c2225a75fda$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $63eb0c2225a75fda$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $63eb0c2225a75fda$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $63eb0c2225a75fda$var$blockStack.length = 0;
        $63eb0c2225a75fda$export$d3da1ecaf1206c58(err, instance, 1);
        result = $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $6ZvW5.isModelListener))) fallthroughAttrs = $63eb0c2225a75fda$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $63eb0c2225a75fda$export$7770a22486565649(root, vnode.transition);
    result = root;
    $63eb0c2225a75fda$var$setCurrentRenderingInstance(prev);
    return result;
}
const $63eb0c2225a75fda$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $63eb0c2225a75fda$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $63eb0c2225a75fda$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $63eb0c2225a75fda$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($63eb0c2225a75fda$export$3868d13f8734ae81(child)) {
            if (child.type !== $63eb0c2225a75fda$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $63eb0c2225a75fda$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $6ZvW5.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $63eb0c2225a75fda$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $6ZvW5.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $63eb0c2225a75fda$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $63eb0c2225a75fda$export$4d299b491347818a;
};
function $63eb0c2225a75fda$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $63eb0c2225a75fda$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($63eb0c2225a75fda$var$hasPropValueChanged(nextProps, prevProps, key) && !$63eb0c2225a75fda$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $63eb0c2225a75fda$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $63eb0c2225a75fda$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($63eb0c2225a75fda$var$hasPropValueChanged(nextProps, prevProps, key) && !$63eb0c2225a75fda$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $63eb0c2225a75fda$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $6ZvW5.isObject)(nextProp) && (0, $6ZvW5.isObject)(prevProp)) return !(0, $6ZvW5.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $63eb0c2225a75fda$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $63eb0c2225a75fda$var$internalObjectProto = {};
const $63eb0c2225a75fda$var$createInternalObject = ()=>Object.create($63eb0c2225a75fda$var$internalObjectProto);
const $63eb0c2225a75fda$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $63eb0c2225a75fda$var$internalObjectProto;
function $63eb0c2225a75fda$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $63eb0c2225a75fda$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $63eb0c2225a75fda$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $g90JB.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $63eb0c2225a75fda$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $63eb0c2225a75fda$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $g90JB.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($63eb0c2225a75fda$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $6ZvW5.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $6ZvW5.camelize)(key);
                        props[camelizedKey] = $63eb0c2225a75fda$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($63eb0c2225a75fda$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $6ZvW5.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $6ZvW5.hyphenate)(key)) === key || !(0, $6ZvW5.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $63eb0c2225a75fda$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $6ZvW5.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $g90JB.trigger)(instance.attrs, "set", "");
}
function $63eb0c2225a75fda$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $6ZvW5.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $6ZvW5.hasOwn)(options, camelKey = (0, $6ZvW5.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$63eb0c2225a75fda$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $g90JB.toRaw)(props);
        const castValues = rawCastValues || (0, $6ZvW5.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $63eb0c2225a75fda$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $6ZvW5.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $63eb0c2225a75fda$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $6ZvW5.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $6ZvW5.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $63eb0c2225a75fda$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $6ZvW5.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $63eb0c2225a75fda$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $63eb0c2225a75fda$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $63eb0c2225a75fda$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $6ZvW5.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $63eb0c2225a75fda$var$normalizePropsOptions(raw2, appContext, true);
            (0, $6ZvW5.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $6ZvW5.isObject)(comp)) cache.set(comp, (0, $6ZvW5.EMPTY_ARR));
        return 0, $6ZvW5.EMPTY_ARR;
    }
    if ((0, $6ZvW5.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $6ZvW5.camelize)(raw[i]);
        if ($63eb0c2225a75fda$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $6ZvW5.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $6ZvW5.camelize)(key);
        if ($63eb0c2225a75fda$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $6ZvW5.isArray)(opt) || (0, $6ZvW5.isFunction)(opt) ? {
                type: opt
            } : (0, $6ZvW5.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $6ZvW5.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $6ZvW5.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $6ZvW5.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $6ZvW5.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $6ZvW5.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $63eb0c2225a75fda$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $6ZvW5.isReservedProp)(key)) return true;
    return false;
}
function $63eb0c2225a75fda$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $63eb0c2225a75fda$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $g90JB.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $6ZvW5.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $63eb0c2225a75fda$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $63eb0c2225a75fda$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $63eb0c2225a75fda$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $6ZvW5.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $63eb0c2225a75fda$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $63eb0c2225a75fda$var$warn$1($63eb0c2225a75fda$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $63eb0c2225a75fda$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $63eb0c2225a75fda$var$isSimpleType = /* @__PURE__ */ (0, $6ZvW5.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $63eb0c2225a75fda$var$assertType(value, type) {
    let valid;
    const expectedType = $63eb0c2225a75fda$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($63eb0c2225a75fda$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $6ZvW5.isObject)(value);
    else if (expectedType === "Array") valid = (0, $6ZvW5.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $63eb0c2225a75fda$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $6ZvW5.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $6ZvW5.toRawType)(value);
    const expectedValue = $63eb0c2225a75fda$var$styleValue(value, expectedType);
    const receivedValue = $63eb0c2225a75fda$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $63eb0c2225a75fda$var$isExplicable(expectedType) && $63eb0c2225a75fda$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($63eb0c2225a75fda$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $63eb0c2225a75fda$var$styleValue(value, type) {
    if ((0, $6ZvW5.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $63eb0c2225a75fda$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $63eb0c2225a75fda$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $63eb0c2225a75fda$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $63eb0c2225a75fda$var$normalizeSlotValue = (value)=>(0, $6ZvW5.isArray)(value) ? value.map($63eb0c2225a75fda$var$normalizeVNode) : [
        $63eb0c2225a75fda$var$normalizeVNode(value)
    ];
const $63eb0c2225a75fda$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $63eb0c2225a75fda$export$694b237e827a3d23((...args)=>{
        return $63eb0c2225a75fda$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $63eb0c2225a75fda$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($63eb0c2225a75fda$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $6ZvW5.isFunction)(value)) slots[key] = $63eb0c2225a75fda$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $63eb0c2225a75fda$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $63eb0c2225a75fda$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $63eb0c2225a75fda$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $63eb0c2225a75fda$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$63eb0c2225a75fda$var$isInternalKey(key)) slots[key] = children[key];
};
const $63eb0c2225a75fda$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $63eb0c2225a75fda$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $63eb0c2225a75fda$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $6ZvW5.def)(slots, "_", type, true);
        } else $63eb0c2225a75fda$var$normalizeObjectSlots(children, slots);
    } else if (children) $63eb0c2225a75fda$var$normalizeVNodeSlots(instance, children);
};
const $63eb0c2225a75fda$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $6ZvW5.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $63eb0c2225a75fda$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $63eb0c2225a75fda$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $63eb0c2225a75fda$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$63eb0c2225a75fda$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $63eb0c2225a75fda$var$supported;
let $63eb0c2225a75fda$var$perf;
function $63eb0c2225a75fda$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $63eb0c2225a75fda$var$isSupported()) $63eb0c2225a75fda$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsPerfStart(instance, type, $63eb0c2225a75fda$var$isSupported() ? $63eb0c2225a75fda$var$perf.now() : Date.now());
}
function $63eb0c2225a75fda$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $63eb0c2225a75fda$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$63eb0c2225a75fda$var$formatComponentName(instance, instance.type)}> ${type}`;
        $63eb0c2225a75fda$var$perf.mark(endTag);
        $63eb0c2225a75fda$var$perf.measure(measureName, startTag, endTag);
        $63eb0c2225a75fda$var$perf.clearMeasures(measureName);
        $63eb0c2225a75fda$var$perf.clearMarks(startTag);
        $63eb0c2225a75fda$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsPerfEnd(instance, type, $63eb0c2225a75fda$var$isSupported() ? $63eb0c2225a75fda$var$perf.now() : Date.now());
}
function $63eb0c2225a75fda$var$isSupported() {
    if ($63eb0c2225a75fda$var$supported !== void 0) return $63eb0c2225a75fda$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $63eb0c2225a75fda$var$supported = true;
        $63eb0c2225a75fda$var$perf = window.performance;
    } else $63eb0c2225a75fda$var$supported = false;
    return $63eb0c2225a75fda$var$supported;
}
function $63eb0c2225a75fda$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $6ZvW5.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $6ZvW5.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $6ZvW5.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $63eb0c2225a75fda$var$queuePostRenderEffect = $63eb0c2225a75fda$var$queueEffectWithSuspense;
function $63eb0c2225a75fda$export$53ae2f996c64e9a(options) {
    return $63eb0c2225a75fda$var$baseCreateRenderer(options);
}
function $63eb0c2225a75fda$export$200524cf0d997ff0(options) {
    return $63eb0c2225a75fda$var$baseCreateRenderer(options, $63eb0c2225a75fda$var$createHydrationFunctions);
}
function $63eb0c2225a75fda$var$baseCreateRenderer(options, createHydrationFns) {
    $63eb0c2225a75fda$var$initFeatureFlags();
    const target = (0, $6ZvW5.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $6ZvW5.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$63eb0c2225a75fda$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $63eb0c2225a75fda$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $63eb0c2225a75fda$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $63eb0c2225a75fda$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $63eb0c2225a75fda$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $63eb0c2225a75fda$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $63eb0c2225a75fda$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $63eb0c2225a75fda$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $6ZvW5.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $6ZvW5.def)(el, "__vnode", vnode, true);
            (0, $6ZvW5.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $63eb0c2225a75fda$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $63eb0c2225a75fda$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $63eb0c2225a75fda$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $63eb0c2225a75fda$var$cloneIfMounted(children[i]) : $63eb0c2225a75fda$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $6ZvW5.EMPTY_OBJ);
        const newProps = n2.props || (0, $6ZvW5.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $63eb0c2225a75fda$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $63eb0c2225a75fda$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $63eb0c2225a75fda$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $63eb0c2225a75fda$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $63eb0c2225a75fda$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $63eb0c2225a75fda$var$queuePostRenderEffect(()=>{
            vnodeHook && $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $63eb0c2225a75fda$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $63eb0c2225a75fda$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$63eb0c2225a75fda$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $6ZvW5.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $6ZvW5.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $6ZvW5.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $63eb0c2225a75fda$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $63eb0c2225a75fda$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($63eb0c2225a75fda$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $63eb0c2225a75fda$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($63eb0c2225a75fda$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $63eb0c2225a75fda$var$isAsyncWrapper(initialVNode);
                $63eb0c2225a75fda$var$toggleRecurse(instance, false);
                if (bm) (0, $6ZvW5.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $63eb0c2225a75fda$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $63eb0c2225a75fda$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $63eb0c2225a75fda$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $63eb0c2225a75fda$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $63eb0c2225a75fda$var$queuePostRenderEffect(()=>$63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $63eb0c2225a75fda$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $63eb0c2225a75fda$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $63eb0c2225a75fda$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $63eb0c2225a75fda$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $63eb0c2225a75fda$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $6ZvW5.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $63eb0c2225a75fda$var$toggleRecurse(instance, true);
                const nextTree = $63eb0c2225a75fda$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $63eb0c2225a75fda$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $63eb0c2225a75fda$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $63eb0c2225a75fda$var$queuePostRenderEffect(()=>$63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $g90JB.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$63eb0c2225a75fda$var$queueJob(job);
        $63eb0c2225a75fda$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $63eb0c2225a75fda$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $63eb0c2225a75fda$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $g90JB.pauseTracking)();
        $63eb0c2225a75fda$var$flushPreFlushCbs(instance);
        (0, $g90JB.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $6ZvW5.EMPTY_ARR);
        c2 = c2 || (0, $6ZvW5.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $63eb0c2225a75fda$var$cloneIfMounted(c2[i]) : $63eb0c2225a75fda$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $63eb0c2225a75fda$var$cloneIfMounted(c2[i]) : $63eb0c2225a75fda$var$normalizeVNode(c2[i]);
            if ($63eb0c2225a75fda$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $63eb0c2225a75fda$var$cloneIfMounted(c2[e2]) : $63eb0c2225a75fda$var$normalizeVNode(c2[e2]);
            if ($63eb0c2225a75fda$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $63eb0c2225a75fda$var$cloneIfMounted(c2[i]) : $63eb0c2225a75fda$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $63eb0c2225a75fda$var$cloneIfMounted(c2[i]) : $63eb0c2225a75fda$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $63eb0c2225a75fda$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $63eb0c2225a75fda$var$getSequence(newIndexToOldIndexMap) : (0, $6ZvW5.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $63eb0c2225a75fda$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $63eb0c2225a75fda$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $63eb0c2225a75fda$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$63eb0c2225a75fda$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $63eb0c2225a75fda$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$63eb0c2225a75fda$var$leaveCbKey];
                    if (el._isLeaving) el[$63eb0c2225a75fda$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $g90JB.pauseTracking)();
            $63eb0c2225a75fda$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $g90JB.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$63eb0c2225a75fda$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $63eb0c2225a75fda$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $63eb0c2225a75fda$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $63eb0c2225a75fda$var$queuePostRenderEffect(()=>{
            vnodeHook && $63eb0c2225a75fda$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $63eb0c2225a75fda$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $63eb0c2225a75fda$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $63eb0c2225a75fda$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $63eb0c2225a75fda$var$invalidateMount(m);
        $63eb0c2225a75fda$var$invalidateMount(a);
        if (bum) (0, $6ZvW5.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $63eb0c2225a75fda$var$queuePostRenderEffect(um, parentSuspense);
        $63eb0c2225a75fda$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $63eb0c2225a75fda$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$63eb0c2225a75fda$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $63eb0c2225a75fda$var$flushPreFlushCbs(instance);
            $63eb0c2225a75fda$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $63eb0c2225a75fda$var$createAppAPI(render, hydrate)
    };
}
function $63eb0c2225a75fda$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $63eb0c2225a75fda$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $63eb0c2225a75fda$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $63eb0c2225a75fda$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $6ZvW5.isArray)(ch1) && (0, $6ZvW5.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $63eb0c2225a75fda$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $63eb0c2225a75fda$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $63eb0c2225a75fda$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $63eb0c2225a75fda$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $63eb0c2225a75fda$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $63eb0c2225a75fda$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $63eb0c2225a75fda$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $63eb0c2225a75fda$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $63eb0c2225a75fda$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $63eb0c2225a75fda$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $63eb0c2225a75fda$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $63eb0c2225a75fda$var$isSuspense = (type)=>type.__isSuspense;
let $63eb0c2225a75fda$var$suspenseId = 0;
const $63eb0c2225a75fda$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $63eb0c2225a75fda$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $63eb0c2225a75fda$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $63eb0c2225a75fda$var$hydrateSuspense,
    normalize: $63eb0c2225a75fda$var$normalizeSuspenseChildren
};
const $63eb0c2225a75fda$export$74bf444e3cd11ea5 = $63eb0c2225a75fda$var$SuspenseImpl;
function $63eb0c2225a75fda$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $6ZvW5.isFunction)(eventListener)) eventListener();
}
function $63eb0c2225a75fda$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $63eb0c2225a75fda$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $63eb0c2225a75fda$var$triggerEvent(vnode, "onPending");
        $63eb0c2225a75fda$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $63eb0c2225a75fda$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $63eb0c2225a75fda$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($63eb0c2225a75fda$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $63eb0c2225a75fda$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $63eb0c2225a75fda$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $63eb0c2225a75fda$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $63eb0c2225a75fda$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $63eb0c2225a75fda$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $63eb0c2225a75fda$var$setActiveBranch(suspense, newBranch);
    } else {
        $63eb0c2225a75fda$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $63eb0c2225a75fda$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $63eb0c2225a75fda$var$hasWarned = false;
function $63eb0c2225a75fda$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $63eb0c2225a75fda$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $6ZvW5.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $63eb0c2225a75fda$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $63eb0c2225a75fda$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $63eb0c2225a75fda$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $63eb0c2225a75fda$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $63eb0c2225a75fda$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $63eb0c2225a75fda$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $63eb0c2225a75fda$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $63eb0c2225a75fda$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $63eb0c2225a75fda$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $63eb0c2225a75fda$var$unsetCurrentInstance();
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $63eb0c2225a75fda$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $63eb0c2225a75fda$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $63eb0c2225a75fda$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $63eb0c2225a75fda$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $63eb0c2225a75fda$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $63eb0c2225a75fda$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $63eb0c2225a75fda$var$normalizeSuspenseSlot(children.fallback) : $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$4d299b491347818a);
}
function $63eb0c2225a75fda$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $6ZvW5.isFunction)(s)) {
        const trackBlock = $63eb0c2225a75fda$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $63eb0c2225a75fda$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $63eb0c2225a75fda$var$currentBlock;
            $63eb0c2225a75fda$var$closeBlock();
        }
    }
    if ((0, $6ZvW5.isArray)(s)) {
        const singleChild = $63eb0c2225a75fda$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $63eb0c2225a75fda$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $63eb0c2225a75fda$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $6ZvW5.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $63eb0c2225a75fda$export$59536a0199721cab(fn);
}
function $63eb0c2225a75fda$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $63eb0c2225a75fda$var$updateHOCHostEl(parentComponent, el);
    }
}
function $63eb0c2225a75fda$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $63eb0c2225a75fda$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $63eb0c2225a75fda$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $63eb0c2225a75fda$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $63eb0c2225a75fda$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $63eb0c2225a75fda$var$blockStack = [];
let $63eb0c2225a75fda$var$currentBlock = null;
function $63eb0c2225a75fda$export$e7eaa45e502fe5cc(disableTracking = false) {
    $63eb0c2225a75fda$var$blockStack.push($63eb0c2225a75fda$var$currentBlock = disableTracking ? null : []);
}
function $63eb0c2225a75fda$var$closeBlock() {
    $63eb0c2225a75fda$var$blockStack.pop();
    $63eb0c2225a75fda$var$currentBlock = $63eb0c2225a75fda$var$blockStack[$63eb0c2225a75fda$var$blockStack.length - 1] || null;
}
let $63eb0c2225a75fda$var$isBlockTreeEnabled = 1;
function $63eb0c2225a75fda$export$c20bee82f26f1e27(value, inVOnce = false) {
    $63eb0c2225a75fda$var$isBlockTreeEnabled += value;
    if (value < 0 && $63eb0c2225a75fda$var$currentBlock && inVOnce) $63eb0c2225a75fda$var$currentBlock.hasOnce = true;
}
function $63eb0c2225a75fda$var$setupBlock(vnode) {
    vnode.dynamicChildren = $63eb0c2225a75fda$var$isBlockTreeEnabled > 0 ? $63eb0c2225a75fda$var$currentBlock || (0, $6ZvW5.EMPTY_ARR) : null;
    $63eb0c2225a75fda$var$closeBlock();
    if ($63eb0c2225a75fda$var$isBlockTreeEnabled > 0 && $63eb0c2225a75fda$var$currentBlock) $63eb0c2225a75fda$var$currentBlock.push(vnode);
    return vnode;
}
function $63eb0c2225a75fda$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $63eb0c2225a75fda$var$setupBlock($63eb0c2225a75fda$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $63eb0c2225a75fda$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $63eb0c2225a75fda$var$setupBlock($63eb0c2225a75fda$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $63eb0c2225a75fda$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $63eb0c2225a75fda$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $63eb0c2225a75fda$var$vnodeArgsTransformer;
function $63eb0c2225a75fda$export$83beccd3afeeb809(transformer) {
    $63eb0c2225a75fda$var$vnodeArgsTransformer = transformer;
}
const $63eb0c2225a75fda$var$createVNodeWithArgsTransform = (...args)=>{
    return $63eb0c2225a75fda$var$_createVNode(...$63eb0c2225a75fda$var$vnodeArgsTransformer ? $63eb0c2225a75fda$var$vnodeArgsTransformer(args, $63eb0c2225a75fda$var$currentRenderingInstance) : args);
};
const $63eb0c2225a75fda$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $63eb0c2225a75fda$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $6ZvW5.isString)(ref) || (0, $g90JB.isRef)(ref) || (0, $6ZvW5.isFunction)(ref) ? {
        i: $63eb0c2225a75fda$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $63eb0c2225a75fda$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $63eb0c2225a75fda$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $63eb0c2225a75fda$var$normalizeKey(props),
        ref: props && $63eb0c2225a75fda$var$normalizeRef(props),
        scopeId: $63eb0c2225a75fda$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $63eb0c2225a75fda$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $63eb0c2225a75fda$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $6ZvW5.isString)(children) ? 8 : 16;
    if ($63eb0c2225a75fda$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $63eb0c2225a75fda$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $63eb0c2225a75fda$var$currentBlock.push(vnode);
    return vnode;
}
const $63eb0c2225a75fda$export$bf5c4cf060303d58 = $63eb0c2225a75fda$var$_createVNode;
function $63eb0c2225a75fda$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $63eb0c2225a75fda$var$NULL_DYNAMIC_COMPONENT) type = $63eb0c2225a75fda$export$4d299b491347818a;
    if ($63eb0c2225a75fda$export$3868d13f8734ae81(type)) {
        const cloned = $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $63eb0c2225a75fda$var$normalizeChildren(cloned, children);
        if ($63eb0c2225a75fda$var$isBlockTreeEnabled > 0 && !isBlockNode && $63eb0c2225a75fda$var$currentBlock) {
            if (cloned.shapeFlag & 6) $63eb0c2225a75fda$var$currentBlock[$63eb0c2225a75fda$var$currentBlock.indexOf(type)] = cloned;
            else $63eb0c2225a75fda$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($63eb0c2225a75fda$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $63eb0c2225a75fda$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $6ZvW5.isString)(klass)) props.class = (0, $6ZvW5.normalizeClass)(klass);
        if ((0, $6ZvW5.isObject)(style)) {
            if ((0, $g90JB.isProxy)(style) && !(0, $6ZvW5.isArray)(style)) style = (0, $6ZvW5.extend)({}, style);
            props.style = (0, $6ZvW5.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $6ZvW5.isString)(type) ? 1 : $63eb0c2225a75fda$var$isSuspense(type) ? 128 : $63eb0c2225a75fda$var$isTeleport(type) ? 64 : (0, $6ZvW5.isObject)(type) ? 4 : (0, $6ZvW5.isFunction)(type) ? 2 : 0;
    return $63eb0c2225a75fda$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $63eb0c2225a75fda$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $g90JB.isProxy)(props) || $63eb0c2225a75fda$var$isInternalObject(props) ? (0, $6ZvW5.extend)({}, props) : props;
}
function $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $63eb0c2225a75fda$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $63eb0c2225a75fda$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $6ZvW5.isArray)(ref) ? ref.concat($63eb0c2225a75fda$var$normalizeRef(extraProps)) : [
            ref,
            $63eb0c2225a75fda$var$normalizeRef(extraProps)
        ] : $63eb0c2225a75fda$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $63eb0c2225a75fda$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $63eb0c2225a75fda$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $63eb0c2225a75fda$var$deepCloneVNode(vnode) {
    const cloned = $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $6ZvW5.isArray)(vnode.children)) cloned.children = vnode.children.map($63eb0c2225a75fda$var$deepCloneVNode);
    return cloned;
}
function $63eb0c2225a75fda$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$5f1af8db9871e1d6, null, text, flag);
}
function $63eb0c2225a75fda$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $63eb0c2225a75fda$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($63eb0c2225a75fda$export$e7eaa45e502fe5cc(), $63eb0c2225a75fda$export$9f2dfe8048dfb22b($63eb0c2225a75fda$export$4d299b491347818a, null, text)) : $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$4d299b491347818a, null, text);
}
function $63eb0c2225a75fda$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$4d299b491347818a);
    else if ((0, $6ZvW5.isArray)(child)) return $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($63eb0c2225a75fda$export$3868d13f8734ae81(child)) return $63eb0c2225a75fda$var$cloneIfMounted(child);
    else return $63eb0c2225a75fda$export$bf5c4cf060303d58($63eb0c2225a75fda$export$5f1af8db9871e1d6, null, String(child));
}
function $63eb0c2225a75fda$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $63eb0c2225a75fda$export$ee4f9e12c0a92a1a(child);
}
function $63eb0c2225a75fda$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $6ZvW5.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $63eb0c2225a75fda$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$63eb0c2225a75fda$var$isInternalObject(children)) children._ctx = $63eb0c2225a75fda$var$currentRenderingInstance;
            else if (slotFlag === 3 && $63eb0c2225a75fda$var$currentRenderingInstance) {
                if ($63eb0c2225a75fda$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $6ZvW5.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $63eb0c2225a75fda$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $63eb0c2225a75fda$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $63eb0c2225a75fda$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $6ZvW5.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $6ZvW5.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $6ZvW5.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $6ZvW5.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $6ZvW5.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $63eb0c2225a75fda$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $63eb0c2225a75fda$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $63eb0c2225a75fda$var$emptyAppContext = $63eb0c2225a75fda$var$createAppContext();
let $63eb0c2225a75fda$var$uid = 0;
function $63eb0c2225a75fda$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $63eb0c2225a75fda$var$emptyAppContext;
    const instance = {
        uid: $63eb0c2225a75fda$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $g90JB.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $63eb0c2225a75fda$var$normalizePropsOptions(type, appContext),
        emitsOptions: $63eb0c2225a75fda$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $6ZvW5.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $6ZvW5.EMPTY_OBJ),
        data: (0, $6ZvW5.EMPTY_OBJ),
        props: (0, $6ZvW5.EMPTY_OBJ),
        attrs: (0, $6ZvW5.EMPTY_OBJ),
        slots: (0, $6ZvW5.EMPTY_OBJ),
        refs: (0, $6ZvW5.EMPTY_OBJ),
        setupState: (0, $6ZvW5.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $63eb0c2225a75fda$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $63eb0c2225a75fda$var$currentInstance = null;
const $63eb0c2225a75fda$export$f13e630aa3915748 = ()=>$63eb0c2225a75fda$var$currentInstance || $63eb0c2225a75fda$var$currentRenderingInstance;
let $63eb0c2225a75fda$var$internalSetCurrentInstance;
let $63eb0c2225a75fda$var$setInSSRSetupState;
{
    const g = (0, $6ZvW5.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $63eb0c2225a75fda$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$63eb0c2225a75fda$var$currentInstance = v1);
    $63eb0c2225a75fda$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$63eb0c2225a75fda$var$isInSSRComponentSetup = v1);
}const $63eb0c2225a75fda$var$setCurrentInstance = (instance)=>{
    const prev = $63eb0c2225a75fda$var$currentInstance;
    $63eb0c2225a75fda$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $63eb0c2225a75fda$var$internalSetCurrentInstance(prev);
    };
};
const $63eb0c2225a75fda$var$unsetCurrentInstance = ()=>{
    $63eb0c2225a75fda$var$currentInstance && $63eb0c2225a75fda$var$currentInstance.scope.off();
    $63eb0c2225a75fda$var$internalSetCurrentInstance(null);
};
const $63eb0c2225a75fda$var$isBuiltInTag = /* @__PURE__ */ (0, $6ZvW5.makeMap)("slot,component");
function $63eb0c2225a75fda$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($63eb0c2225a75fda$var$isBuiltInTag(name) || isNativeTag(name)) $63eb0c2225a75fda$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $63eb0c2225a75fda$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $63eb0c2225a75fda$var$isInSSRComponentSetup = false;
function $63eb0c2225a75fda$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $63eb0c2225a75fda$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $63eb0c2225a75fda$var$isStatefulComponent(instance);
    $63eb0c2225a75fda$var$initProps(instance, props, isStateful, isSSR);
    $63eb0c2225a75fda$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $63eb0c2225a75fda$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $63eb0c2225a75fda$var$setInSSRSetupState(false);
    return setupResult;
}
function $63eb0c2225a75fda$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $63eb0c2225a75fda$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $g90JB.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $63eb0c2225a75fda$var$createSetupContext(instance) : null;
        const reset = $63eb0c2225a75fda$var$setCurrentInstance(instance);
        const setupResult = $63eb0c2225a75fda$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $6ZvW5.isPromise)(setupResult);
        (0, $g90JB.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$63eb0c2225a75fda$var$isAsyncWrapper(instance)) $63eb0c2225a75fda$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($63eb0c2225a75fda$var$unsetCurrentInstance, $63eb0c2225a75fda$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $63eb0c2225a75fda$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $63eb0c2225a75fda$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $63eb0c2225a75fda$var$handleSetupResult(instance, setupResult, isSSR);
    } else $63eb0c2225a75fda$var$finishComponentSetup(instance, isSSR);
}
function $63eb0c2225a75fda$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $6ZvW5.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $6ZvW5.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $g90JB.proxyRefs)(setupResult);
    }
    $63eb0c2225a75fda$var$finishComponentSetup(instance, isSSR);
}
let $63eb0c2225a75fda$var$compile;
let $63eb0c2225a75fda$var$installWithProxy;
function $63eb0c2225a75fda$export$667bb5a67822b941(_compile) {
    $63eb0c2225a75fda$var$compile = _compile;
    $63eb0c2225a75fda$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $63eb0c2225a75fda$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $63eb0c2225a75fda$export$c93a9c496c5211fa = ()=>!$63eb0c2225a75fda$var$compile;
function $63eb0c2225a75fda$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $63eb0c2225a75fda$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $63eb0c2225a75fda$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $6ZvW5.extend)((0, $6ZvW5.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $63eb0c2225a75fda$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $6ZvW5.NOOP);
        if ($63eb0c2225a75fda$var$installWithProxy) $63eb0c2225a75fda$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $63eb0c2225a75fda$var$setCurrentInstance(instance);
        (0, $g90JB.pauseTracking)();
        try {
            $63eb0c2225a75fda$var$applyOptions(instance);
        } finally{
            (0, $g90JB.resetTracking)();
            reset();
        }
    }
}
const $63eb0c2225a75fda$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $g90JB.track)(target, "get", "");
        return target[key];
    }
};
function $63eb0c2225a75fda$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $g90JB.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $63eb0c2225a75fda$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $63eb0c2225a75fda$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $63eb0c2225a75fda$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $g90JB.proxyRefs)((0, $g90JB.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $63eb0c2225a75fda$var$publicPropertiesMap) return $63eb0c2225a75fda$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $63eb0c2225a75fda$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $63eb0c2225a75fda$var$classifyRE = /(?:^|[-_])\w/g;
const $63eb0c2225a75fda$var$classify = (str)=>str.replace($63eb0c2225a75fda$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $63eb0c2225a75fda$var$getComponentName(Component, includeInferred = true) {
    return (0, $6ZvW5.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $63eb0c2225a75fda$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $63eb0c2225a75fda$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $63eb0c2225a75fda$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $63eb0c2225a75fda$var$isClassComponent(value) {
    return (0, $6ZvW5.isFunction)(value) && "__vccOpts" in value;
}
const $63eb0c2225a75fda$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $g90JB.computed)(getterOrOptions, debugOptions, $63eb0c2225a75fda$var$isInSSRComponentSetup);
    return c;
};
function $63eb0c2225a75fda$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $63eb0c2225a75fda$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $6ZvW5.isObject)(propsOrChildren) && !(0, $6ZvW5.isArray)(propsOrChildren)) {
                if ($63eb0c2225a75fda$export$3868d13f8734ae81(propsOrChildren)) return $63eb0c2225a75fda$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $63eb0c2225a75fda$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $63eb0c2225a75fda$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $63eb0c2225a75fda$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $63eb0c2225a75fda$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $63eb0c2225a75fda$export$c20bee82f26f1e27(1);
    }
}
function $63eb0c2225a75fda$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $g90JB.toRaw)(instance.props)));
        if (instance.setupState !== (0, $6ZvW5.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $6ZvW5.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $g90JB.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $6ZvW5.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $6ZvW5.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $g90JB.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $6ZvW5.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $6ZvW5.isArray)(opts) && opts.includes(key) || (0, $6ZvW5.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $g90JB.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $63eb0c2225a75fda$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $63eb0c2225a75fda$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $63eb0c2225a75fda$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $6ZvW5.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($63eb0c2225a75fda$var$isBlockTreeEnabled > 0 && $63eb0c2225a75fda$var$currentBlock) $63eb0c2225a75fda$var$currentBlock.push(cached);
    return true;
}
const $63eb0c2225a75fda$export$83d89fbfd8236492 = "3.5.38";
const $63eb0c2225a75fda$export$c106dd0671a0fc2d = (0, $6ZvW5.NOOP);
const $63eb0c2225a75fda$export$795e0ad4a0e2ed30 = $63eb0c2225a75fda$var$ErrorTypeStrings$1;
const $63eb0c2225a75fda$export$6922d3b3a607469e = $63eb0c2225a75fda$var$devtools$1;
const $63eb0c2225a75fda$export$b0c258b32c26c785 = $63eb0c2225a75fda$var$setDevtoolsHook$1;
const $63eb0c2225a75fda$var$_ssrUtils = {
    createComponentInstance: $63eb0c2225a75fda$var$createComponentInstance,
    setupComponent: $63eb0c2225a75fda$var$setupComponent,
    renderComponentRoot: $63eb0c2225a75fda$var$renderComponentRoot,
    setCurrentRenderingInstance: $63eb0c2225a75fda$var$setCurrentRenderingInstance,
    isVNode: $63eb0c2225a75fda$export$3868d13f8734ae81,
    normalizeVNode: $63eb0c2225a75fda$var$normalizeVNode,
    getComponentPublicInstance: $63eb0c2225a75fda$var$getComponentPublicInstance,
    ensureValidVNode: $63eb0c2225a75fda$var$ensureValidVNode,
    pushWarningContext: $63eb0c2225a75fda$var$pushWarningContext,
    popWarningContext: $63eb0c2225a75fda$var$popWarningContext
};
const $63eb0c2225a75fda$export$a9679033567b336d = $63eb0c2225a75fda$var$_ssrUtils;
const $63eb0c2225a75fda$export$83cf26e06ea620e1 = null;
const $63eb0c2225a75fda$export$dc678eddf276286e = null;
const $63eb0c2225a75fda$export$22072a82865312f6 = null;

});
parcelRegister("g90JB", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $bc0e0e7b16b7bafe$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $bc0e0e7b16b7bafe$export$7056603ea81600be; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $bc0e0e7b16b7bafe$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $bc0e0e7b16b7bafe$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $bc0e0e7b16b7bafe$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $bc0e0e7b16b7bafe$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $bc0e0e7b16b7bafe$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isShallow", function () { return $bc0e0e7b16b7bafe$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "toReactive", function () { return $bc0e0e7b16b7bafe$export$45c769cf449a508c; });
$parcel$export(module.exports, "shallowReadArray", function () { return $bc0e0e7b16b7bafe$export$5eb48af14254449e; });
$parcel$export(module.exports, "isReadonly", function () { return $bc0e0e7b16b7bafe$export$92d09b48637741e7; });
$parcel$export(module.exports, "isReactive", function () { return $bc0e0e7b16b7bafe$export$352205f445242f02; });
$parcel$export(module.exports, "toReadonly", function () { return $bc0e0e7b16b7bafe$export$4a78e7a2a4fb689f; });
$parcel$export(module.exports, "isProxy", function () { return $bc0e0e7b16b7bafe$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "isRef", function () { return $bc0e0e7b16b7bafe$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $bc0e0e7b16b7bafe$export$90a44edba14e47be; });
$parcel$export(module.exports, "shallowReactive", function () { return $bc0e0e7b16b7bafe$export$8d81cefd22d22260; });
$parcel$export(module.exports, "markRaw", function () { return $bc0e0e7b16b7bafe$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $bc0e0e7b16b7bafe$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $bc0e0e7b16b7bafe$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "unref", function () { return $bc0e0e7b16b7bafe$export$a239a76781616204; });
$parcel$export(module.exports, "proxyRefs", function () { return $bc0e0e7b16b7bafe$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $bc0e0e7b16b7bafe$export$a20c2dd6199824cb; });
$parcel$export(module.exports, "computed", function () { return $bc0e0e7b16b7bafe$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "watch", function () { return $bc0e0e7b16b7bafe$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "traverse", function () { return $bc0e0e7b16b7bafe$export$df3f009e3d155b20; });
/**
* @vue/reactivity v3.5.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $6ZvW5 = parcelRequire("6ZvW5");
function $bc0e0e7b16b7bafe$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $bc0e0e7b16b7bafe$var$activeEffectScope;
class $bc0e0e7b16b7bafe$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $bc0e0e7b16b7bafe$var$activeEffectScope) {
            if ($bc0e0e7b16b7bafe$var$activeEffectScope.active) {
                this.parent = $bc0e0e7b16b7bafe$var$activeEffectScope;
                this.index = ($bc0e0e7b16b7bafe$var$activeEffectScope.scopes || ($bc0e0e7b16b7bafe$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $bc0e0e7b16b7bafe$var$activeEffectScope;
            try {
                $bc0e0e7b16b7bafe$var$activeEffectScope = this;
                return fn();
            } finally{
                $bc0e0e7b16b7bafe$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $bc0e0e7b16b7bafe$var$activeEffectScope;
            $bc0e0e7b16b7bafe$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($bc0e0e7b16b7bafe$var$activeEffectScope === this) $bc0e0e7b16b7bafe$var$activeEffectScope = this.prevScope;
            else {
                let current = $bc0e0e7b16b7bafe$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $bc0e0e7b16b7bafe$export$7056603ea81600be(detached) {
    return new $bc0e0e7b16b7bafe$export$1168ed9dbc71ddbd(detached);
}
function $bc0e0e7b16b7bafe$export$c7be4b0125a10cba() {
    return $bc0e0e7b16b7bafe$var$activeEffectScope;
}
function $bc0e0e7b16b7bafe$export$a780418acd4762da(fn, failSilently = false) {
    if ($bc0e0e7b16b7bafe$var$activeEffectScope) $bc0e0e7b16b7bafe$var$activeEffectScope.cleanups.push(fn);
}
let $bc0e0e7b16b7bafe$var$activeSub;
const $bc0e0e7b16b7bafe$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $bc0e0e7b16b7bafe$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $bc0e0e7b16b7bafe$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($bc0e0e7b16b7bafe$var$activeEffectScope) {
            if ($bc0e0e7b16b7bafe$var$activeEffectScope.active) $bc0e0e7b16b7bafe$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($bc0e0e7b16b7bafe$var$pausedQueueEffects.has(this)) {
                $bc0e0e7b16b7bafe$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $bc0e0e7b16b7bafe$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $bc0e0e7b16b7bafe$var$cleanupEffect(this);
        $bc0e0e7b16b7bafe$var$prepareDeps(this);
        const prevEffect = $bc0e0e7b16b7bafe$var$activeSub;
        const prevShouldTrack = $bc0e0e7b16b7bafe$var$shouldTrack;
        $bc0e0e7b16b7bafe$var$activeSub = this;
        $bc0e0e7b16b7bafe$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $bc0e0e7b16b7bafe$var$cleanupDeps(this);
            $bc0e0e7b16b7bafe$var$activeSub = prevEffect;
            $bc0e0e7b16b7bafe$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$bc0e0e7b16b7bafe$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $bc0e0e7b16b7bafe$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $bc0e0e7b16b7bafe$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($bc0e0e7b16b7bafe$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $bc0e0e7b16b7bafe$var$isDirty(this);
    }
}
let $bc0e0e7b16b7bafe$var$batchDepth = 0;
let $bc0e0e7b16b7bafe$var$batchedSub;
let $bc0e0e7b16b7bafe$var$batchedComputed;
function $bc0e0e7b16b7bafe$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $bc0e0e7b16b7bafe$var$batchedComputed;
        $bc0e0e7b16b7bafe$var$batchedComputed = sub;
        return;
    }
    sub.next = $bc0e0e7b16b7bafe$var$batchedSub;
    $bc0e0e7b16b7bafe$var$batchedSub = sub;
}
function $bc0e0e7b16b7bafe$var$startBatch() {
    $bc0e0e7b16b7bafe$var$batchDepth++;
}
function $bc0e0e7b16b7bafe$var$endBatch() {
    if (--$bc0e0e7b16b7bafe$var$batchDepth > 0) return;
    if ($bc0e0e7b16b7bafe$var$batchedComputed) {
        let e = $bc0e0e7b16b7bafe$var$batchedComputed;
        $bc0e0e7b16b7bafe$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($bc0e0e7b16b7bafe$var$batchedSub){
        let e = $bc0e0e7b16b7bafe$var$batchedSub;
        $bc0e0e7b16b7bafe$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $bc0e0e7b16b7bafe$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $bc0e0e7b16b7bafe$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $bc0e0e7b16b7bafe$var$removeSub(link);
            $bc0e0e7b16b7bafe$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $bc0e0e7b16b7bafe$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($bc0e0e7b16b7bafe$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $bc0e0e7b16b7bafe$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $bc0e0e7b16b7bafe$var$globalVersion) return;
    computed.globalVersion = $bc0e0e7b16b7bafe$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$bc0e0e7b16b7bafe$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $bc0e0e7b16b7bafe$var$activeSub;
    const prevShouldTrack = $bc0e0e7b16b7bafe$var$shouldTrack;
    $bc0e0e7b16b7bafe$var$activeSub = computed;
    $bc0e0e7b16b7bafe$var$shouldTrack = true;
    try {
        $bc0e0e7b16b7bafe$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $6ZvW5.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $bc0e0e7b16b7bafe$var$activeSub = prevSub;
        $bc0e0e7b16b7bafe$var$shouldTrack = prevShouldTrack;
        $bc0e0e7b16b7bafe$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $bc0e0e7b16b7bafe$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$bc0e0e7b16b7bafe$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $bc0e0e7b16b7bafe$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $bc0e0e7b16b7bafe$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $bc0e0e7b16b7bafe$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $bc0e0e7b16b7bafe$export$28352bb4dd362521(fn);
    if (options) (0, $6ZvW5.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $bc0e0e7b16b7bafe$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $bc0e0e7b16b7bafe$var$shouldTrack = true;
const $bc0e0e7b16b7bafe$var$trackStack = [];
function $bc0e0e7b16b7bafe$export$938a971395fef855() {
    $bc0e0e7b16b7bafe$var$trackStack.push($bc0e0e7b16b7bafe$var$shouldTrack);
    $bc0e0e7b16b7bafe$var$shouldTrack = false;
}
function $bc0e0e7b16b7bafe$export$1f8ffc6fd33b1d16() {
    $bc0e0e7b16b7bafe$var$trackStack.push($bc0e0e7b16b7bafe$var$shouldTrack);
    $bc0e0e7b16b7bafe$var$shouldTrack = true;
}
function $bc0e0e7b16b7bafe$export$c39176b1babaa8b8() {
    const last = $bc0e0e7b16b7bafe$var$trackStack.pop();
    $bc0e0e7b16b7bafe$var$shouldTrack = last === void 0 ? true : last;
}
function $bc0e0e7b16b7bafe$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($bc0e0e7b16b7bafe$var$activeSub instanceof $bc0e0e7b16b7bafe$export$28352bb4dd362521) $bc0e0e7b16b7bafe$var$activeSub.cleanup = fn;
}
function $bc0e0e7b16b7bafe$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $bc0e0e7b16b7bafe$var$activeSub;
        $bc0e0e7b16b7bafe$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $bc0e0e7b16b7bafe$var$activeSub = prevSub;
        }
    }
}
let $bc0e0e7b16b7bafe$var$globalVersion = 0;
class $bc0e0e7b16b7bafe$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $bc0e0e7b16b7bafe$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$bc0e0e7b16b7bafe$var$activeSub || !$bc0e0e7b16b7bafe$var$shouldTrack || $bc0e0e7b16b7bafe$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $bc0e0e7b16b7bafe$var$activeSub) {
            link = this.activeLink = new $bc0e0e7b16b7bafe$var$Link($bc0e0e7b16b7bafe$var$activeSub, this);
            if (!$bc0e0e7b16b7bafe$var$activeSub.deps) $bc0e0e7b16b7bafe$var$activeSub.deps = $bc0e0e7b16b7bafe$var$activeSub.depsTail = link;
            else {
                link.prevDep = $bc0e0e7b16b7bafe$var$activeSub.depsTail;
                $bc0e0e7b16b7bafe$var$activeSub.depsTail.nextDep = link;
                $bc0e0e7b16b7bafe$var$activeSub.depsTail = link;
            }
            $bc0e0e7b16b7bafe$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $bc0e0e7b16b7bafe$var$activeSub.depsTail;
                link.nextDep = void 0;
                $bc0e0e7b16b7bafe$var$activeSub.depsTail.nextDep = link;
                $bc0e0e7b16b7bafe$var$activeSub.depsTail = link;
                if ($bc0e0e7b16b7bafe$var$activeSub.deps === link) $bc0e0e7b16b7bafe$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $bc0e0e7b16b7bafe$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $bc0e0e7b16b7bafe$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $bc0e0e7b16b7bafe$var$endBatch();
        }
    }
}
function $bc0e0e7b16b7bafe$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$bc0e0e7b16b7bafe$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $bc0e0e7b16b7bafe$var$targetMap = /* @__PURE__ */ new WeakMap();
const $bc0e0e7b16b7bafe$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $bc0e0e7b16b7bafe$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $bc0e0e7b16b7bafe$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $bc0e0e7b16b7bafe$export$6b2a7d5132615086(target, type, key) {
    if ($bc0e0e7b16b7bafe$var$shouldTrack && $bc0e0e7b16b7bafe$var$activeSub) {
        let depsMap = $bc0e0e7b16b7bafe$var$targetMap.get(target);
        if (!depsMap) $bc0e0e7b16b7bafe$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $bc0e0e7b16b7bafe$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $bc0e0e7b16b7bafe$var$targetMap.get(target);
    if (!depsMap) {
        $bc0e0e7b16b7bafe$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $bc0e0e7b16b7bafe$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $6ZvW5.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $6ZvW5.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $bc0e0e7b16b7bafe$export$4f926f0baab682cd || !(0, $6ZvW5.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($bc0e0e7b16b7bafe$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($bc0e0e7b16b7bafe$export$3c41b1a4e06acc14));
                        if ((0, $6ZvW5.isMap)(target)) run(depsMap.get($bc0e0e7b16b7bafe$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($bc0e0e7b16b7bafe$export$3c41b1a4e06acc14));
                        if ((0, $6ZvW5.isMap)(target)) run(depsMap.get($bc0e0e7b16b7bafe$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $6ZvW5.isMap)(target)) run(depsMap.get($bc0e0e7b16b7bafe$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $bc0e0e7b16b7bafe$var$endBatch();
}
function $bc0e0e7b16b7bafe$var$getDepFromReactive(object, key) {
    const depMap = $bc0e0e7b16b7bafe$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $bc0e0e7b16b7bafe$export$1544eab4943788e4(array) {
    const raw = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $bc0e0e7b16b7bafe$export$6b2a7d5132615086(raw, "iterate", $bc0e0e7b16b7bafe$export$4f926f0baab682cd);
    return $bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(array) ? raw : raw.map($bc0e0e7b16b7bafe$export$45c769cf449a508c);
}
function $bc0e0e7b16b7bafe$export$5eb48af14254449e(arr) {
    $bc0e0e7b16b7bafe$export$6b2a7d5132615086(arr = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(arr), "iterate", $bc0e0e7b16b7bafe$export$4f926f0baab682cd);
    return arr;
}
function $bc0e0e7b16b7bafe$var$toWrapped(target, item) {
    if ($bc0e0e7b16b7bafe$export$92d09b48637741e7(target)) return $bc0e0e7b16b7bafe$export$352205f445242f02(target) ? $bc0e0e7b16b7bafe$export$4a78e7a2a4fb689f($bc0e0e7b16b7bafe$export$45c769cf449a508c(item)) : $bc0e0e7b16b7bafe$export$4a78e7a2a4fb689f(item);
    return $bc0e0e7b16b7bafe$export$45c769cf449a508c(item);
}
const $bc0e0e7b16b7bafe$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $bc0e0e7b16b7bafe$var$iterator(this, Symbol.iterator, (item)=>$bc0e0e7b16b7bafe$var$toWrapped(this, item));
    },
    concat (...args) {
        return $bc0e0e7b16b7bafe$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $6ZvW5.isArray)(x) ? $bc0e0e7b16b7bafe$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $bc0e0e7b16b7bafe$var$iterator(this, "entries", (value)=>{
            value[1] = $bc0e0e7b16b7bafe$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$bc0e0e7b16b7bafe$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "find", fn, thisArg, (item)=>$bc0e0e7b16b7bafe$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "findLast", fn, thisArg, (item)=>$bc0e0e7b16b7bafe$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $bc0e0e7b16b7bafe$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $bc0e0e7b16b7bafe$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $bc0e0e7b16b7bafe$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $bc0e0e7b16b7bafe$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $bc0e0e7b16b7bafe$var$noTracking(this, "pop");
    },
    push (...args) {
        return $bc0e0e7b16b7bafe$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $bc0e0e7b16b7bafe$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $bc0e0e7b16b7bafe$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $bc0e0e7b16b7bafe$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $bc0e0e7b16b7bafe$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $bc0e0e7b16b7bafe$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $bc0e0e7b16b7bafe$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $bc0e0e7b16b7bafe$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $bc0e0e7b16b7bafe$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $bc0e0e7b16b7bafe$var$noTracking(this, "unshift", args);
    },
    values () {
        return $bc0e0e7b16b7bafe$var$iterator(this, "values", (item)=>$bc0e0e7b16b7bafe$var$toWrapped(this, item));
    }
};
function $bc0e0e7b16b7bafe$var$iterator(self, method, wrapValue) {
    const arr = $bc0e0e7b16b7bafe$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $bc0e0e7b16b7bafe$var$arrayProto = Array.prototype;
function $bc0e0e7b16b7bafe$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $bc0e0e7b16b7bafe$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $bc0e0e7b16b7bafe$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $bc0e0e7b16b7bafe$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $bc0e0e7b16b7bafe$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $bc0e0e7b16b7bafe$var$reduce(self, method, fn, args) {
    const arr = $bc0e0e7b16b7bafe$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $bc0e0e7b16b7bafe$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $bc0e0e7b16b7bafe$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $bc0e0e7b16b7bafe$var$toWrapped(self, result) : result;
}
function $bc0e0e7b16b7bafe$var$searchProxy(self, method, args) {
    const arr = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(self);
    $bc0e0e7b16b7bafe$export$6b2a7d5132615086(arr, "iterate", $bc0e0e7b16b7bafe$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $bc0e0e7b16b7bafe$export$5f3ca29d057519b3(args[0])) {
        args[0] = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $bc0e0e7b16b7bafe$var$noTracking(self, method, args = []) {
    $bc0e0e7b16b7bafe$export$938a971395fef855();
    $bc0e0e7b16b7bafe$var$startBatch();
    const res = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $bc0e0e7b16b7bafe$var$endBatch();
    $bc0e0e7b16b7bafe$export$c39176b1babaa8b8();
    return res;
}
const $bc0e0e7b16b7bafe$var$isNonTrackableKeys = /* @__PURE__ */ (0, $6ZvW5.makeMap)(`__proto__,__v_isRef,__isVue`);
const $bc0e0e7b16b7bafe$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $6ZvW5.isSymbol)));
function $bc0e0e7b16b7bafe$var$hasOwnProperty(key) {
    if (!(0, $6ZvW5.isSymbol)(key)) key = String(key);
    const obj = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(this);
    $bc0e0e7b16b7bafe$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $bc0e0e7b16b7bafe$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $bc0e0e7b16b7bafe$var$shallowReadonlyMap : $bc0e0e7b16b7bafe$var$readonlyMap : isShallow2 ? $bc0e0e7b16b7bafe$var$shallowReactiveMap : $bc0e0e7b16b7bafe$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $6ZvW5.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $bc0e0e7b16b7bafe$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $bc0e0e7b16b7bafe$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $6ZvW5.isSymbol)(key) ? $bc0e0e7b16b7bafe$var$builtInSymbols.has(key) : $bc0e0e7b16b7bafe$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $bc0e0e7b16b7bafe$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($bc0e0e7b16b7bafe$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $6ZvW5.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $6ZvW5.isObject)(value) ? $bc0e0e7b16b7bafe$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $6ZvW5.isObject)(res)) return isReadonly2 ? $bc0e0e7b16b7bafe$export$6ec456bd5b7b3c51(res) : $bc0e0e7b16b7bafe$export$90a44edba14e47be(res);
        return res;
    }
}
class $bc0e0e7b16b7bafe$var$MutableReactiveHandler extends $bc0e0e7b16b7bafe$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $6ZvW5.isArray)(target) && (0, $6ZvW5.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $bc0e0e7b16b7bafe$export$92d09b48637741e7(oldValue);
            if (!$bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(value) && !$bc0e0e7b16b7bafe$export$92d09b48637741e7(value)) {
                oldValue = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(oldValue);
                value = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(oldValue) && !$bc0e0e7b16b7bafe$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $6ZvW5.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $6ZvW5.hasChanged)(value, oldValue)) $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $6ZvW5.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $6ZvW5.isSymbol)(key) || !$bc0e0e7b16b7bafe$var$builtInSymbols.has(key)) $bc0e0e7b16b7bafe$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $bc0e0e7b16b7bafe$export$6b2a7d5132615086(target, "iterate", (0, $6ZvW5.isArray)(target) ? "length" : $bc0e0e7b16b7bafe$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $bc0e0e7b16b7bafe$var$ReadonlyReactiveHandler extends $bc0e0e7b16b7bafe$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $bc0e0e7b16b7bafe$var$mutableHandlers = /* @__PURE__ */ new $bc0e0e7b16b7bafe$var$MutableReactiveHandler();
const $bc0e0e7b16b7bafe$var$readonlyHandlers = /* @__PURE__ */ new $bc0e0e7b16b7bafe$var$ReadonlyReactiveHandler();
const $bc0e0e7b16b7bafe$var$shallowReactiveHandlers = /* @__PURE__ */ new $bc0e0e7b16b7bafe$var$MutableReactiveHandler(true);
const $bc0e0e7b16b7bafe$var$shallowReadonlyHandlers = /* @__PURE__ */ new $bc0e0e7b16b7bafe$var$ReadonlyReactiveHandler(true);
const $bc0e0e7b16b7bafe$var$toShallow = (value)=>value;
const $bc0e0e7b16b7bafe$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $bc0e0e7b16b7bafe$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $6ZvW5.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $bc0e0e7b16b7bafe$var$toShallow : isReadonly2 ? $bc0e0e7b16b7bafe$export$4a78e7a2a4fb689f : $bc0e0e7b16b7bafe$export$45c769cf449a508c;
        !isReadonly2 && $bc0e0e7b16b7bafe$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $bc0e0e7b16b7bafe$export$49093fa1cddcb78d : $bc0e0e7b16b7bafe$export$3c41b1a4e06acc14);
        return (0, $6ZvW5.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $bc0e0e7b16b7bafe$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $bc0e0e7b16b7bafe$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(target);
            const rawKey = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $6ZvW5.hasChanged)(key, rawKey)) $bc0e0e7b16b7bafe$export$6b2a7d5132615086(rawTarget, "get", key);
                $bc0e0e7b16b7bafe$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $bc0e0e7b16b7bafe$var$getProto(rawTarget);
            const wrap = shallow ? $bc0e0e7b16b7bafe$var$toShallow : readonly ? $bc0e0e7b16b7bafe$export$4a78e7a2a4fb689f : $bc0e0e7b16b7bafe$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $bc0e0e7b16b7bafe$export$6b2a7d5132615086($bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(target), "iterate", $bc0e0e7b16b7bafe$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(target);
            const rawKey = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $6ZvW5.hasChanged)(key, rawKey)) $bc0e0e7b16b7bafe$export$6b2a7d5132615086(rawTarget, "has", key);
                $bc0e0e7b16b7bafe$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $bc0e0e7b16b7bafe$var$toShallow : readonly ? $bc0e0e7b16b7bafe$export$4a78e7a2a4fb689f : $bc0e0e7b16b7bafe$export$45c769cf449a508c;
            !readonly && $bc0e0e7b16b7bafe$export$6b2a7d5132615086(rawTarget, "iterate", $bc0e0e7b16b7bafe$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $6ZvW5.extend)(instrumentations, readonly ? {
        add: $bc0e0e7b16b7bafe$var$createReadonlyMethod("add"),
        set: $bc0e0e7b16b7bafe$var$createReadonlyMethod("set"),
        delete: $bc0e0e7b16b7bafe$var$createReadonlyMethod("delete"),
        clear: $bc0e0e7b16b7bafe$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(this);
            const proto = $bc0e0e7b16b7bafe$var$getProto(target);
            const rawValue = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(value) && !$bc0e0e7b16b7bafe$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $6ZvW5.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $6ZvW5.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(value) && !$bc0e0e7b16b7bafe$export$92d09b48637741e7(value)) value = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(value);
            const target = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $bc0e0e7b16b7bafe$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $6ZvW5.hasChanged)(value, oldValue)) $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $bc0e0e7b16b7bafe$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $bc0e0e7b16b7bafe$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $bc0e0e7b16b7bafe$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $bc0e0e7b16b7bafe$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $bc0e0e7b16b7bafe$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $6ZvW5.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $bc0e0e7b16b7bafe$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $bc0e0e7b16b7bafe$var$createInstrumentationGetter(false, false)
};
const $bc0e0e7b16b7bafe$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $bc0e0e7b16b7bafe$var$createInstrumentationGetter(false, true)
};
const $bc0e0e7b16b7bafe$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $bc0e0e7b16b7bafe$var$createInstrumentationGetter(true, false)
};
const $bc0e0e7b16b7bafe$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $bc0e0e7b16b7bafe$var$createInstrumentationGetter(true, true)
};
function $bc0e0e7b16b7bafe$var$checkIdentityKeys(target, has, key) {
    const rawKey = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $6ZvW5.toRawType)(target);
        $bc0e0e7b16b7bafe$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $bc0e0e7b16b7bafe$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $bc0e0e7b16b7bafe$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $bc0e0e7b16b7bafe$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $bc0e0e7b16b7bafe$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $bc0e0e7b16b7bafe$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $bc0e0e7b16b7bafe$export$92d09b48637741e7(target)) return target;
    return $bc0e0e7b16b7bafe$var$createReactiveObject(target, false, $bc0e0e7b16b7bafe$var$mutableHandlers, $bc0e0e7b16b7bafe$var$mutableCollectionHandlers, $bc0e0e7b16b7bafe$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$8d81cefd22d22260(target) {
    return $bc0e0e7b16b7bafe$var$createReactiveObject(target, false, $bc0e0e7b16b7bafe$var$shallowReactiveHandlers, $bc0e0e7b16b7bafe$var$shallowCollectionHandlers, $bc0e0e7b16b7bafe$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$6ec456bd5b7b3c51(target) {
    return $bc0e0e7b16b7bafe$var$createReactiveObject(target, true, $bc0e0e7b16b7bafe$var$readonlyHandlers, $bc0e0e7b16b7bafe$var$readonlyCollectionHandlers, $bc0e0e7b16b7bafe$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$7c4b5f2b50f09f6b(target) {
    return $bc0e0e7b16b7bafe$var$createReactiveObject(target, true, $bc0e0e7b16b7bafe$var$shallowReadonlyHandlers, $bc0e0e7b16b7bafe$var$shallowReadonlyCollectionHandlers, $bc0e0e7b16b7bafe$var$shallowReadonlyMap);
}
function $bc0e0e7b16b7bafe$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $6ZvW5.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $bc0e0e7b16b7bafe$var$targetTypeMap((0, $6ZvW5.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $bc0e0e7b16b7bafe$export$92d09b48637741e7(value)) return /* @__PURE__ */ $bc0e0e7b16b7bafe$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(raw) : observed;
}
function $bc0e0e7b16b7bafe$export$995ab8b13ad7a9d0(value) {
    if (!(0, $6ZvW5.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $6ZvW5.def)(value, "__v_skip", true);
    return value;
}
const $bc0e0e7b16b7bafe$export$45c769cf449a508c = (value)=>(0, $6ZvW5.isObject)(value) ? /* @__PURE__ */ $bc0e0e7b16b7bafe$export$90a44edba14e47be(value) : value;
const $bc0e0e7b16b7bafe$export$4a78e7a2a4fb689f = (value)=>(0, $6ZvW5.isObject)(value) ? /* @__PURE__ */ $bc0e0e7b16b7bafe$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$eff4d24c3ff7876e(value) {
    return $bc0e0e7b16b7bafe$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$9b7bc5fe3b17c8b3(value) {
    return $bc0e0e7b16b7bafe$var$createRef(value, true);
}
function $bc0e0e7b16b7bafe$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $bc0e0e7b16b7bafe$var$RefImpl(rawValue, shallow);
}
class $bc0e0e7b16b7bafe$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $bc0e0e7b16b7bafe$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $bc0e0e7b16b7bafe$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(newValue) || $bc0e0e7b16b7bafe$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(newValue);
        if ((0, $6ZvW5.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $bc0e0e7b16b7bafe$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $bc0e0e7b16b7bafe$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $bc0e0e7b16b7bafe$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $bc0e0e7b16b7bafe$export$30bdcc2218aa9458(source) {
    return (0, $6ZvW5.isFunction)(source) ? source() : $bc0e0e7b16b7bafe$export$a239a76781616204(source);
}
const $bc0e0e7b16b7bafe$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $bc0e0e7b16b7bafe$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $bc0e0e7b16b7bafe$export$f353fd1b97db3fa0(objectWithRefs) {
    return $bc0e0e7b16b7bafe$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $bc0e0e7b16b7bafe$var$shallowUnwrapHandlers);
}
class $bc0e0e7b16b7bafe$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $bc0e0e7b16b7bafe$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $bc0e0e7b16b7bafe$export$a20c2dd6199824cb(factory) {
    return new $bc0e0e7b16b7bafe$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$2e9533675e5e70e0(object) {
    const ret = (0, $6ZvW5.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $bc0e0e7b16b7bafe$var$propertyToRef(object, key);
    return ret;
}
class $bc0e0e7b16b7bafe$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $6ZvW5.isSymbol)(key) ? key : String(key);
        this._raw = $bc0e0e7b16b7bafe$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $6ZvW5.isArray)(_object) || (0, $6ZvW5.isSymbol)(this._key) || !(0, $6ZvW5.isIntegerKey)(this._key)) do shallow = !$bc0e0e7b16b7bafe$export$5f3ca29d057519b3(obj) || $bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $bc0e0e7b16b7bafe$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $bc0e0e7b16b7bafe$var$getDepFromReactive(this._raw, this._key);
    }
}
class $bc0e0e7b16b7bafe$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $bc0e0e7b16b7bafe$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $6ZvW5.isFunction)(source)) return new $bc0e0e7b16b7bafe$var$GetterRefImpl(source);
    else if ((0, $6ZvW5.isObject)(source) && arguments.length > 1) return $bc0e0e7b16b7bafe$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $bc0e0e7b16b7bafe$export$eff4d24c3ff7876e(source);
}
function $bc0e0e7b16b7bafe$var$propertyToRef(source, key, defaultValue) {
    return new $bc0e0e7b16b7bafe$var$ObjectRefImpl(source, key, defaultValue);
}
class $bc0e0e7b16b7bafe$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $bc0e0e7b16b7bafe$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $bc0e0e7b16b7bafe$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $bc0e0e7b16b7bafe$var$activeSub !== this) {
            $bc0e0e7b16b7bafe$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $bc0e0e7b16b7bafe$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $bc0e0e7b16b7bafe$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $6ZvW5.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $bc0e0e7b16b7bafe$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $bc0e0e7b16b7bafe$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $bc0e0e7b16b7bafe$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $bc0e0e7b16b7bafe$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $bc0e0e7b16b7bafe$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $bc0e0e7b16b7bafe$var$INITIAL_WATCHER_VALUE = {};
const $bc0e0e7b16b7bafe$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $bc0e0e7b16b7bafe$var$activeWatcher = void 0;
function $bc0e0e7b16b7bafe$export$2532f7acfca7c82d() {
    return $bc0e0e7b16b7bafe$var$activeWatcher;
}
function $bc0e0e7b16b7bafe$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $bc0e0e7b16b7bafe$var$activeWatcher) {
    if (owner) {
        let cleanups = $bc0e0e7b16b7bafe$var$cleanupMap.get(owner);
        if (!cleanups) $bc0e0e7b16b7bafe$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $bc0e0e7b16b7bafe$export$3db5d71bdb2d5499(source, cb, options = (0, $6ZvW5.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $bc0e0e7b16b7bafe$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $bc0e0e7b16b7bafe$export$df3f009e3d155b20(source2, 1);
        return $bc0e0e7b16b7bafe$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($bc0e0e7b16b7bafe$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(source);
    } else if ($bc0e0e7b16b7bafe$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $6ZvW5.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$bc0e0e7b16b7bafe$export$352205f445242f02(s) || $bc0e0e7b16b7bafe$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($bc0e0e7b16b7bafe$export$4f9f5282de18fc69(s)) return s.value;
                else if ($bc0e0e7b16b7bafe$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $6ZvW5.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $6ZvW5.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $bc0e0e7b16b7bafe$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $bc0e0e7b16b7bafe$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $bc0e0e7b16b7bafe$var$activeWatcher;
            $bc0e0e7b16b7bafe$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $bc0e0e7b16b7bafe$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $6ZvW5.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$bc0e0e7b16b7bafe$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $bc0e0e7b16b7bafe$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $6ZvW5.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            const res = _cb(...args);
            watchHandle();
            return res;
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($bc0e0e7b16b7bafe$var$INITIAL_WATCHER_VALUE) : $bc0e0e7b16b7bafe$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $6ZvW5.hasChanged)(v, oldValue[i])) : (0, $6ZvW5.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $bc0e0e7b16b7bafe$var$activeWatcher;
                $bc0e0e7b16b7bafe$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $bc0e0e7b16b7bafe$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $bc0e0e7b16b7bafe$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $bc0e0e7b16b7bafe$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $bc0e0e7b16b7bafe$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$bc0e0e7b16b7bafe$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $bc0e0e7b16b7bafe$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $bc0e0e7b16b7bafe$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $bc0e0e7b16b7bafe$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $6ZvW5.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($bc0e0e7b16b7bafe$export$4f9f5282de18fc69(value)) $bc0e0e7b16b7bafe$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $6ZvW5.isArray)(value)) for(let i = 0; i < value.length; i++)$bc0e0e7b16b7bafe$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $6ZvW5.isSet)(value) || (0, $6ZvW5.isMap)(value)) value.forEach((v)=>{
        $bc0e0e7b16b7bafe$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $6ZvW5.isPlainObject)(value)) {
        for(const key in value)$bc0e0e7b16b7bafe$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $bc0e0e7b16b7bafe$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("6ZvW5", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $5171365d54d1d9eb$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $5171365d54d1d9eb$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $5171365d54d1d9eb$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $5171365d54d1d9eb$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $5171365d54d1d9eb$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $5171365d54d1d9eb$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $5171365d54d1d9eb$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $5171365d54d1d9eb$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $5171365d54d1d9eb$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $5171365d54d1d9eb$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $5171365d54d1d9eb$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $5171365d54d1d9eb$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $5171365d54d1d9eb$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $5171365d54d1d9eb$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $5171365d54d1d9eb$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $5171365d54d1d9eb$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $5171365d54d1d9eb$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $5171365d54d1d9eb$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $5171365d54d1d9eb$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $5171365d54d1d9eb$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $5171365d54d1d9eb$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $5171365d54d1d9eb$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $5171365d54d1d9eb$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $5171365d54d1d9eb$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $5171365d54d1d9eb$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $5171365d54d1d9eb$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $5171365d54d1d9eb$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $5171365d54d1d9eb$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $5171365d54d1d9eb$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $5171365d54d1d9eb$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $5171365d54d1d9eb$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $5171365d54d1d9eb$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $5171365d54d1d9eb$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $5171365d54d1d9eb$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $5171365d54d1d9eb$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $5171365d54d1d9eb$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $5171365d54d1d9eb$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $5171365d54d1d9eb$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $5171365d54d1d9eb$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $5171365d54d1d9eb$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $5171365d54d1d9eb$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $5171365d54d1d9eb$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $5171365d54d1d9eb$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $5171365d54d1d9eb$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $5171365d54d1d9eb$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $5171365d54d1d9eb$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $5171365d54d1d9eb$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "getEscapedCssVarName", function () { return $5171365d54d1d9eb$export$ad9a320bfb7ba440; });
$parcel$export(module.exports, "looseEqual", function () { return $5171365d54d1d9eb$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $5171365d54d1d9eb$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $5171365d54d1d9eb$export$b5b1545233b45293; });
$parcel$export(module.exports, "normalizeCssVarValue", function () { return $5171365d54d1d9eb$export$97fe3d6453ee2f5e; });
/**
* @vue/shared v3.5.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $5171365d54d1d9eb$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $5171365d54d1d9eb$export$cf583d23ab39677c = {};
const $5171365d54d1d9eb$export$6bd8558f433f1cc1 = [];
const $5171365d54d1d9eb$export$5702a91a6f42969f = ()=>{};
const $5171365d54d1d9eb$export$c01351c0af048e39 = ()=>false;
const $5171365d54d1d9eb$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $5171365d54d1d9eb$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $5171365d54d1d9eb$export$8b58be045bf06082 = Object.assign;
const $5171365d54d1d9eb$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $5171365d54d1d9eb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $5171365d54d1d9eb$export$b5a638e9b3fff9f3 = (val, key)=>$5171365d54d1d9eb$var$hasOwnProperty.call(val, key);
const $5171365d54d1d9eb$export$43bee75e5e14138e = Array.isArray;
const $5171365d54d1d9eb$export$5c90113a285f2241 = (val)=>$5171365d54d1d9eb$export$1dccc787cc36538b(val) === "[object Map]";
const $5171365d54d1d9eb$export$6750766a7c7ec627 = (val)=>$5171365d54d1d9eb$export$1dccc787cc36538b(val) === "[object Set]";
const $5171365d54d1d9eb$export$871608497c498473 = (val)=>$5171365d54d1d9eb$export$1dccc787cc36538b(val) === "[object Date]";
const $5171365d54d1d9eb$export$49841c62b9eff15 = (val)=>$5171365d54d1d9eb$export$1dccc787cc36538b(val) === "[object RegExp]";
const $5171365d54d1d9eb$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $5171365d54d1d9eb$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $5171365d54d1d9eb$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $5171365d54d1d9eb$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $5171365d54d1d9eb$export$4369c812aac99591 = (val)=>{
    return ($5171365d54d1d9eb$export$a6cdc56e425d0d0a(val) || $5171365d54d1d9eb$export$f6e2535fb5126e54(val)) && $5171365d54d1d9eb$export$f6e2535fb5126e54(val.then) && $5171365d54d1d9eb$export$f6e2535fb5126e54(val.catch);
};
const $5171365d54d1d9eb$export$830c053460e5ddf6 = Object.prototype.toString;
const $5171365d54d1d9eb$export$1dccc787cc36538b = (value)=>$5171365d54d1d9eb$export$830c053460e5ddf6.call(value);
const $5171365d54d1d9eb$export$5ad0a3c360b8fbb5 = (value)=>{
    return $5171365d54d1d9eb$export$1dccc787cc36538b(value).slice(8, -1);
};
const $5171365d54d1d9eb$export$53b83ca8eaab0383 = (val)=>$5171365d54d1d9eb$export$1dccc787cc36538b(val) === "[object Object]";
const $5171365d54d1d9eb$export$e2a2b93446ec9fe = (key)=>$5171365d54d1d9eb$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $5171365d54d1d9eb$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $5171365d54d1d9eb$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $5171365d54d1d9eb$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $5171365d54d1d9eb$var$camelizeRE = /-\w/g;
const $5171365d54d1d9eb$export$161d051f5dd25de7 = $5171365d54d1d9eb$var$cacheStringFunction((str)=>{
    return str.replace($5171365d54d1d9eb$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $5171365d54d1d9eb$var$hyphenateRE = /\B([A-Z])/g;
const $5171365d54d1d9eb$export$6e6a0a3676c4b8bb = $5171365d54d1d9eb$var$cacheStringFunction((str)=>str.replace($5171365d54d1d9eb$var$hyphenateRE, "-$1").toLowerCase());
const $5171365d54d1d9eb$export$9a00dee1beb8f576 = $5171365d54d1d9eb$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $5171365d54d1d9eb$export$8c022799eeaaefcd = $5171365d54d1d9eb$var$cacheStringFunction((str)=>{
    const s = str ? `on${$5171365d54d1d9eb$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $5171365d54d1d9eb$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $5171365d54d1d9eb$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $5171365d54d1d9eb$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $5171365d54d1d9eb$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $5171365d54d1d9eb$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $5171365d54d1d9eb$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $5171365d54d1d9eb$var$_globalThis;
const $5171365d54d1d9eb$export$ff5f2eeb11fc7e14 = ()=>{
    return $5171365d54d1d9eb$var$_globalThis || ($5171365d54d1d9eb$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $5171365d54d1d9eb$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $5171365d54d1d9eb$export$53d5e12f9a1d3cde(name) {
    return $5171365d54d1d9eb$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $5171365d54d1d9eb$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $5171365d54d1d9eb$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $5171365d54d1d9eb$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $5171365d54d1d9eb$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $5171365d54d1d9eb$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $5171365d54d1d9eb$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $5171365d54d1d9eb$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $5171365d54d1d9eb$export$f73b8c13b7f97ebf = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8($5171365d54d1d9eb$var$GLOBALS_ALLOWED);
const $5171365d54d1d9eb$export$d6571a1911e4f27e = $5171365d54d1d9eb$export$f73b8c13b7f97ebf;
const $5171365d54d1d9eb$var$range = 2;
function $5171365d54d1d9eb$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $5171365d54d1d9eb$var$range; j <= i + $5171365d54d1d9eb$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $5171365d54d1d9eb$export$8756898546458274(value) {
    if ($5171365d54d1d9eb$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $5171365d54d1d9eb$export$844ec244b1367d54(item) ? $5171365d54d1d9eb$export$76a205ce979d066a(item) : $5171365d54d1d9eb$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($5171365d54d1d9eb$export$844ec244b1367d54(value) || $5171365d54d1d9eb$export$a6cdc56e425d0d0a(value)) return value;
}
const $5171365d54d1d9eb$var$listDelimiterRE = /;(?![^(]*\))/g;
const $5171365d54d1d9eb$var$propertyDelimiterRE = /:([^]+)/;
const $5171365d54d1d9eb$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $5171365d54d1d9eb$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($5171365d54d1d9eb$var$styleCommentRE, "").split($5171365d54d1d9eb$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($5171365d54d1d9eb$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $5171365d54d1d9eb$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($5171365d54d1d9eb$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($5171365d54d1d9eb$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $5171365d54d1d9eb$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $5171365d54d1d9eb$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($5171365d54d1d9eb$export$844ec244b1367d54(value)) res = value;
    else if ($5171365d54d1d9eb$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $5171365d54d1d9eb$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($5171365d54d1d9eb$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $5171365d54d1d9eb$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$5171365d54d1d9eb$export$844ec244b1367d54(klass)) props.class = $5171365d54d1d9eb$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $5171365d54d1d9eb$export$8756898546458274(style);
    return props;
}
const $5171365d54d1d9eb$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $5171365d54d1d9eb$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $5171365d54d1d9eb$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $5171365d54d1d9eb$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $5171365d54d1d9eb$export$1ccf854a0984f890 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8($5171365d54d1d9eb$var$HTML_TAGS);
const $5171365d54d1d9eb$export$6328ce7565ea1049 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8($5171365d54d1d9eb$var$SVG_TAGS);
const $5171365d54d1d9eb$export$4a46ca4c5be17b20 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8($5171365d54d1d9eb$var$MATH_TAGS);
const $5171365d54d1d9eb$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8($5171365d54d1d9eb$var$VOID_TAGS);
const $5171365d54d1d9eb$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $5171365d54d1d9eb$export$d186f5eb2e810715 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8($5171365d54d1d9eb$var$specialBooleanAttrs);
const $5171365d54d1d9eb$export$f763ba3b84e9cd8c = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8($5171365d54d1d9eb$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $5171365d54d1d9eb$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $5171365d54d1d9eb$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $5171365d54d1d9eb$var$attrValidationCache = {};
function $5171365d54d1d9eb$export$d55ef77660f30d12(name) {
    if ($5171365d54d1d9eb$var$attrValidationCache.hasOwnProperty(name)) return $5171365d54d1d9eb$var$attrValidationCache[name];
    const isUnsafe = $5171365d54d1d9eb$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $5171365d54d1d9eb$var$attrValidationCache[name] = !isUnsafe;
}
const $5171365d54d1d9eb$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $5171365d54d1d9eb$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $5171365d54d1d9eb$export$80da416f43933831 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $5171365d54d1d9eb$export$fc0748a8e0014066 = /* @__PURE__ */ $5171365d54d1d9eb$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $5171365d54d1d9eb$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $5171365d54d1d9eb$var$escapeRE = /["'&<>]/;
function $5171365d54d1d9eb$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $5171365d54d1d9eb$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $5171365d54d1d9eb$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $5171365d54d1d9eb$export$7b105034a53bde5f(src) {
    return src.replace($5171365d54d1d9eb$var$commentStripRE, "");
}
const $5171365d54d1d9eb$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $5171365d54d1d9eb$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($5171365d54d1d9eb$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $5171365d54d1d9eb$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $5171365d54d1d9eb$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $5171365d54d1d9eb$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $5171365d54d1d9eb$export$871608497c498473(a);
    let bValidType = $5171365d54d1d9eb$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $5171365d54d1d9eb$export$a244864fd9645c7f(a);
    bValidType = $5171365d54d1d9eb$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $5171365d54d1d9eb$export$43bee75e5e14138e(a);
    bValidType = $5171365d54d1d9eb$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $5171365d54d1d9eb$var$looseCompareArrays(a, b) : false;
    aValidType = $5171365d54d1d9eb$export$a6cdc56e425d0d0a(a);
    bValidType = $5171365d54d1d9eb$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$5171365d54d1d9eb$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $5171365d54d1d9eb$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$5171365d54d1d9eb$export$ae8015769846262c(item, val));
}
const $5171365d54d1d9eb$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $5171365d54d1d9eb$export$b5b1545233b45293 = (val)=>{
    return $5171365d54d1d9eb$export$844ec244b1367d54(val) ? val : val == null ? "" : $5171365d54d1d9eb$export$43bee75e5e14138e(val) || $5171365d54d1d9eb$export$a6cdc56e425d0d0a(val) && (val.toString === $5171365d54d1d9eb$export$830c053460e5ddf6 || !$5171365d54d1d9eb$export$f6e2535fb5126e54(val.toString)) ? $5171365d54d1d9eb$var$isRef(val) ? $5171365d54d1d9eb$export$b5b1545233b45293(val.value) : JSON.stringify(val, $5171365d54d1d9eb$var$replacer, 2) : String(val);
};
const $5171365d54d1d9eb$var$replacer = (_key, val)=>{
    if ($5171365d54d1d9eb$var$isRef(val)) return $5171365d54d1d9eb$var$replacer(_key, val.value);
    else if ($5171365d54d1d9eb$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$5171365d54d1d9eb$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($5171365d54d1d9eb$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$5171365d54d1d9eb$var$stringifySymbol(v))
    };
    else if ($5171365d54d1d9eb$export$a244864fd9645c7f(val)) return $5171365d54d1d9eb$var$stringifySymbol(val);
    else if ($5171365d54d1d9eb$export$a6cdc56e425d0d0a(val) && !$5171365d54d1d9eb$export$43bee75e5e14138e(val) && !$5171365d54d1d9eb$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $5171365d54d1d9eb$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $5171365d54d1d9eb$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $5171365d54d1d9eb$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("5lPju", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("8zRru")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("8zRru")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("8zRru")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("6ZvW5")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("8zRru")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("8zRru")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("8zRru")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("8zRru")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("8zRru")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("8zRru")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("8zRru")).createRenderer; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("8zRru")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("8zRru")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("8zRru")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("8zRru")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("8zRru")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("8zRru")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("8zRru")).getTransitionRawChildren; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("8zRru")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("8zRru")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("8zRru")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("g90JB")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("8zRru")).isRuntimeOnly; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("8zRru")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("6ZvW5")).normalizeClass; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("8zRru")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("8zRru")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("8zRru")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("8zRru")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("8zRru")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("8zRru")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("8zRru")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("8zRru")).openBlock; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("8zRru")).provide; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return (parcelRequire("8zRru")).queuePostFlushCb; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("g90JB")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("g90JB")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("8zRru")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("8zRru")).resolveComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("8zRru")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("8zRru")).setTransitionHooks; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("g90JB")).shallowReactive; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("g90JB")).shallowRef; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("8zRru")).Static; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("8zRru")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("g90JB")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("8zRru")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("8zRru")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("8zRru")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("8zRru")).watchEffect; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("8zRru")).withDirectives; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("g90JB")).effectScope; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("g90JB")).unref; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("6ZvW5")).toDisplayString; });

$parcel$export(module.exports, "createApp", function () { return $3e56b7ab38551f44$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "vModelText", function () { return $3e56b7ab38551f44$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelSelect", function () { return $3e56b7ab38551f44$export$87d227567b51ca39; });
$parcel$export(module.exports, "vModelDynamic", function () { return $3e56b7ab38551f44$export$5ad5c0e01ff62c5; });
$parcel$export(module.exports, "withModifiers", function () { return $3e56b7ab38551f44$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $3e56b7ab38551f44$export$f691a8759658f782; });
/**
* @vue/runtime-dom v3.5.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");
var $g90JB = parcelRequire("g90JB");
var $g90JB = parcelRequire("g90JB");parcelRequire("6ZvW5");

var $6ZvW5 = parcelRequire("6ZvW5");
let $3e56b7ab38551f44$var$policy = void 0;
const $3e56b7ab38551f44$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($3e56b7ab38551f44$var$tt) try {
    $3e56b7ab38551f44$var$policy = /* @__PURE__ */ $3e56b7ab38551f44$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $3e56b7ab38551f44$var$unsafeToTrustedHTML = $3e56b7ab38551f44$var$policy ? (val)=>$3e56b7ab38551f44$var$policy.createHTML(val) : (val)=>val;
const $3e56b7ab38551f44$var$svgNS = "http://www.w3.org/2000/svg";
const $3e56b7ab38551f44$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $3e56b7ab38551f44$var$doc = typeof document !== "undefined" ? document : null;
const $3e56b7ab38551f44$var$templateContainer = $3e56b7ab38551f44$var$doc && /* @__PURE__ */ $3e56b7ab38551f44$var$doc.createElement("template");
const $3e56b7ab38551f44$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $3e56b7ab38551f44$var$doc.createElementNS($3e56b7ab38551f44$var$svgNS, tag) : namespace === "mathml" ? $3e56b7ab38551f44$var$doc.createElementNS($3e56b7ab38551f44$var$mathmlNS, tag) : is ? $3e56b7ab38551f44$var$doc.createElement(tag, {
            is: is
        }) : $3e56b7ab38551f44$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$3e56b7ab38551f44$var$doc.createTextNode(text),
    createComment: (text)=>$3e56b7ab38551f44$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$3e56b7ab38551f44$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $3e56b7ab38551f44$var$templateContainer.innerHTML = $3e56b7ab38551f44$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $3e56b7ab38551f44$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $3e56b7ab38551f44$var$TRANSITION = "transition";
const $3e56b7ab38551f44$var$ANIMATION = "animation";
const $3e56b7ab38551f44$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $3e56b7ab38551f44$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $3e56b7ab38551f44$var$TransitionPropsValidators = /* @__PURE__ */ (0, $6ZvW5.extend)({}, (0, $8zRru.BaseTransitionPropsValidators), $3e56b7ab38551f44$var$DOMTransitionPropsValidators);
const $3e56b7ab38551f44$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $3e56b7ab38551f44$var$TransitionPropsValidators;
    return t;
};
const $3e56b7ab38551f44$export$be58926105124dd4 = /* @__PURE__ */ $3e56b7ab38551f44$var$decorate$1((props, { slots: slots })=>(0, $8zRru.h)((0, $8zRru.BaseTransition), $3e56b7ab38551f44$var$resolveTransitionProps(props), slots));
const $3e56b7ab38551f44$var$callHook = (hook, args = [])=>{
    if ((0, $6ZvW5.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $3e56b7ab38551f44$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $6ZvW5.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $3e56b7ab38551f44$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $3e56b7ab38551f44$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $3e56b7ab38551f44$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $3e56b7ab38551f44$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $3e56b7ab38551f44$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $3e56b7ab38551f44$var$removeTransitionClass(el, leaveFromClass);
        $3e56b7ab38551f44$var$removeTransitionClass(el, leaveToClass);
        $3e56b7ab38551f44$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $3e56b7ab38551f44$var$callHook(hook, [
                el,
                resolve
            ]);
            $3e56b7ab38551f44$var$nextFrame(()=>{
                $3e56b7ab38551f44$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $3e56b7ab38551f44$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$3e56b7ab38551f44$var$hasExplicitCallback(hook)) $3e56b7ab38551f44$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $6ZvW5.extend)(baseProps, {
        onBeforeEnter (el) {
            $3e56b7ab38551f44$var$callHook(onBeforeEnter, [
                el
            ]);
            $3e56b7ab38551f44$var$addTransitionClass(el, enterFromClass);
            $3e56b7ab38551f44$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $3e56b7ab38551f44$var$callHook(onBeforeAppear, [
                el
            ]);
            $3e56b7ab38551f44$var$addTransitionClass(el, appearFromClass);
            $3e56b7ab38551f44$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $3e56b7ab38551f44$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $3e56b7ab38551f44$var$forceReflow(el);
                $3e56b7ab38551f44$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $3e56b7ab38551f44$var$addTransitionClass(el, leaveActiveClass);
                $3e56b7ab38551f44$var$forceReflow(el);
            }
            $3e56b7ab38551f44$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $3e56b7ab38551f44$var$removeTransitionClass(el, leaveFromClass);
                $3e56b7ab38551f44$var$addTransitionClass(el, leaveToClass);
                if (!$3e56b7ab38551f44$var$hasExplicitCallback(onLeave)) $3e56b7ab38551f44$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $3e56b7ab38551f44$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $3e56b7ab38551f44$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $3e56b7ab38551f44$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $3e56b7ab38551f44$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $3e56b7ab38551f44$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $6ZvW5.isObject)(duration)) return [
        $3e56b7ab38551f44$var$NumberOf(duration.enter),
        $3e56b7ab38551f44$var$NumberOf(duration.leave)
    ];
    else {
        const n = $3e56b7ab38551f44$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $3e56b7ab38551f44$var$NumberOf(val) {
    const res = (0, $6ZvW5.toNumber)(val);
    return res;
}
function $3e56b7ab38551f44$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$3e56b7ab38551f44$var$vtcKey] || (el[$3e56b7ab38551f44$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $3e56b7ab38551f44$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$3e56b7ab38551f44$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$3e56b7ab38551f44$var$vtcKey] = void 0;
    }
}
function $3e56b7ab38551f44$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $3e56b7ab38551f44$var$endId = 0;
function $3e56b7ab38551f44$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$3e56b7ab38551f44$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $3e56b7ab38551f44$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $3e56b7ab38551f44$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$3e56b7ab38551f44$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$3e56b7ab38551f44$var$TRANSITION}Duration`);
    const transitionTimeout = $3e56b7ab38551f44$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$3e56b7ab38551f44$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$3e56b7ab38551f44$var$ANIMATION}Duration`);
    const animationTimeout = $3e56b7ab38551f44$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $3e56b7ab38551f44$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $3e56b7ab38551f44$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $3e56b7ab38551f44$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $3e56b7ab38551f44$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $3e56b7ab38551f44$var$TRANSITION : $3e56b7ab38551f44$var$ANIMATION : null;
        propCount = type ? type === $3e56b7ab38551f44$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $3e56b7ab38551f44$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$3e56b7ab38551f44$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $3e56b7ab38551f44$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$3e56b7ab38551f44$var$toMs(d) + $3e56b7ab38551f44$var$toMs(delays[i])));
}
function $3e56b7ab38551f44$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $3e56b7ab38551f44$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $3e56b7ab38551f44$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$3e56b7ab38551f44$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $3e56b7ab38551f44$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $3e56b7ab38551f44$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $3e56b7ab38551f44$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$3e56b7ab38551f44$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $3e56b7ab38551f44$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $3e56b7ab38551f44$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $3e56b7ab38551f44$var$setDisplay(el, false);
            });
        } else $3e56b7ab38551f44$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $3e56b7ab38551f44$var$setDisplay(el, value);
    }
};
function $3e56b7ab38551f44$var$setDisplay(el, value) {
    el.style.display = value ? el[$3e56b7ab38551f44$var$vShowOriginalDisplay] : "none";
    el[$3e56b7ab38551f44$var$vShowHidden] = !value;
}
function $3e56b7ab38551f44$var$initVShowForSSR() {
    $3e56b7ab38551f44$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $3e56b7ab38551f44$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $3e56b7ab38551f44$export$ef28b76f07940108(getter) {
    const instance = (0, $8zRru.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$3e56b7ab38551f44$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $3e56b7ab38551f44$var$setVarsOnNode(instance.ce, vars);
        else $3e56b7ab38551f44$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $8zRru.onBeforeUpdate)(()=>{
        (0, $8zRru.queuePostFlushCb)(setVars);
    });
    (0, $8zRru.onMounted)(()=>{
        (0, $8zRru.watch)(setVars, (0, $6ZvW5.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $8zRru.onUnmounted)(()=>ob.disconnect());
    });
}
function $3e56b7ab38551f44$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $3e56b7ab38551f44$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $3e56b7ab38551f44$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $8zRru.Fragment)) vnode.children.forEach((c)=>$3e56b7ab38551f44$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $8zRru.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $3e56b7ab38551f44$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $3e56b7ab38551f44$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $6ZvW5.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$3e56b7ab38551f44$var$CSS_VAR_TEXT] = cssText;
    }
}
const $3e56b7ab38551f44$var$displayRE = /(?:^|;)\s*display\s*:/;
function $3e56b7ab38551f44$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $6ZvW5.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $6ZvW5.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $3e56b7ab38551f44$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $3e56b7ab38551f44$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$3e56b7ab38551f44$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $6ZvW5.isString)(prev) && prev ? prev[key] : void 0, value)) $3e56b7ab38551f44$var$setStyle(style, key, value);
            } else $3e56b7ab38551f44$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$3e56b7ab38551f44$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $3e56b7ab38551f44$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($3e56b7ab38551f44$var$vShowOriginalDisplay in el) {
        el[$3e56b7ab38551f44$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$3e56b7ab38551f44$var$vShowHidden]) style.display = "none";
    }
}
const $3e56b7ab38551f44$var$semicolonRE = /[^\\];\s*$/;
const $3e56b7ab38551f44$var$importantRE = /\s*!important$/;
function $3e56b7ab38551f44$var$setStyle(style, name, val) {
    if ((0, $6ZvW5.isArray)(val)) val.forEach((v)=>$3e56b7ab38551f44$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $3e56b7ab38551f44$var$autoPrefix(style, name);
            if ($3e56b7ab38551f44$var$importantRE.test(val)) style.setProperty((0, $6ZvW5.hyphenate)(prefixed), val.replace($3e56b7ab38551f44$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $3e56b7ab38551f44$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $3e56b7ab38551f44$var$prefixCache = {};
function $3e56b7ab38551f44$var$autoPrefix(style, rawName) {
    const cached = $3e56b7ab38551f44$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $6ZvW5.camelize)(rawName);
    if (name !== "filter" && name in style) return $3e56b7ab38551f44$var$prefixCache[rawName] = name;
    name = (0, $6ZvW5.capitalize)(name);
    for(let i = 0; i < $3e56b7ab38551f44$var$prefixes.length; i++){
        const prefixed = $3e56b7ab38551f44$var$prefixes[i] + name;
        if (prefixed in style) return $3e56b7ab38551f44$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $3e56b7ab38551f44$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $6ZvW5.isString)(next) && prev === next;
}
const $3e56b7ab38551f44$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $3e56b7ab38551f44$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $6ZvW5.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($3e56b7ab38551f44$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($3e56b7ab38551f44$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $6ZvW5.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $6ZvW5.isSymbol)(value) ? String(value) : value);
}
function $3e56b7ab38551f44$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $3e56b7ab38551f44$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $6ZvW5.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $3e56b7ab38551f44$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $3e56b7ab38551f44$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $3e56b7ab38551f44$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $3e56b7ab38551f44$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$3e56b7ab38551f44$var$veiKey] || (el[$3e56b7ab38551f44$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $3e56b7ab38551f44$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $3e56b7ab38551f44$var$createInvoker(nextValue, instance);
            $3e56b7ab38551f44$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $3e56b7ab38551f44$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $3e56b7ab38551f44$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $3e56b7ab38551f44$var$parseName(name) {
    let options;
    if ($3e56b7ab38551f44$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($3e56b7ab38551f44$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $6ZvW5.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $3e56b7ab38551f44$var$cachedNow = 0;
const $3e56b7ab38551f44$var$p = /* @__PURE__ */ Promise.resolve();
const $3e56b7ab38551f44$var$getNow = ()=>$3e56b7ab38551f44$var$cachedNow || ($3e56b7ab38551f44$var$p.then(()=>$3e56b7ab38551f44$var$cachedNow = 0), $3e56b7ab38551f44$var$cachedNow = Date.now());
function $3e56b7ab38551f44$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $6ZvW5.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $8zRru.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $8zRru.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $3e56b7ab38551f44$var$getNow();
    return invoker;
}
function $3e56b7ab38551f44$var$sanitizeEventValue(value, propName) {
    if ((0, $6ZvW5.isFunction)(value) || (0, $6ZvW5.isArray)(value)) return value;
    (0, $8zRru.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $6ZvW5.NOOP;
}
const $3e56b7ab38551f44$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $3e56b7ab38551f44$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $3e56b7ab38551f44$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $3e56b7ab38551f44$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $6ZvW5.isOn)(key)) {
        if (!(0, $6ZvW5.isModelListener)(key)) $3e56b7ab38551f44$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $3e56b7ab38551f44$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $3e56b7ab38551f44$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $3e56b7ab38551f44$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($3e56b7ab38551f44$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $6ZvW5.isString)(nextValue)))) $3e56b7ab38551f44$var$patchDOMProp(el, (0, $6ZvW5.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $3e56b7ab38551f44$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $3e56b7ab38551f44$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $3e56b7ab38551f44$var$isNativeOn(key) && (0, $6ZvW5.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($3e56b7ab38551f44$var$isNativeOn(key) && (0, $6ZvW5.isString)(value)) return false;
    return key in el;
}
function $3e56b7ab38551f44$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $6ZvW5.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $6ZvW5.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $6ZvW5.camelize)(prop) === camelKey);
}
const $3e56b7ab38551f44$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $3e56b7ab38551f44$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $8zRru.defineComponent)(options, extraOptions);
    if ((0, $6ZvW5.isPlainObject)(Comp)) Comp = (0, $6ZvW5.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $3e56b7ab38551f44$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $3e56b7ab38551f44$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $3e56b7ab38551f44$export$a00e2346eabbdbef(options, extraOptions, $3e56b7ab38551f44$export$35800275c0037383);
};
const $3e56b7ab38551f44$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $3e56b7ab38551f44$export$b337c1a55163dbe3 extends $3e56b7ab38551f44$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $3e56b7ab38551f44$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $3e56b7ab38551f44$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $6ZvW5.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $3e56b7ab38551f44$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $8zRru.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $6ZvW5.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $6ZvW5.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $6ZvW5.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>{
            def.configureApp = this._def.configureApp;
            resolve(this._def = def, true);
        });
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $6ZvW5.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $g90JB.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $6ZvW5.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $6ZvW5.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $3e56b7ab38551f44$var$REMOVAL;
        const camelKey = (0, $6ZvW5.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $6ZvW5.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $3e56b7ab38551f44$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $6ZvW5.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $6ZvW5.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $6ZvW5.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $3e56b7ab38551f44$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $8zRru.createVNode)(this._def, (0, $6ZvW5.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $6ZvW5.isPlainObject)(args[0]) ? (0, $6ZvW5.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $6ZvW5.hyphenate)(event) !== event) dispatch((0, $6ZvW5.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $3e56b7ab38551f44$export$da5acfe93a94e37d(caller) {
    const instance = (0, $8zRru.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $8zRru.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $8zRru.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $3e56b7ab38551f44$export$64d45095031fa749() {
    const el = $3e56b7ab38551f44$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $3e56b7ab38551f44$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $8zRru.getCurrentInstance)();
        if (!instance) return 0, $6ZvW5.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $6ZvW5.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $6ZvW5.EMPTY_OBJ;
        return mod;
    }
}
const $3e56b7ab38551f44$var$positionMap = /* @__PURE__ */ new WeakMap();
const $3e56b7ab38551f44$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $3e56b7ab38551f44$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $3e56b7ab38551f44$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $3e56b7ab38551f44$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $3e56b7ab38551f44$var$TransitionGroupImpl = /* @__PURE__ */ $3e56b7ab38551f44$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $6ZvW5.extend)({}, $3e56b7ab38551f44$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $8zRru.getCurrentInstance)();
        const state = (0, $8zRru.useTransitionState)();
        let prevChildren;
        let children;
        (0, $8zRru.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$3e56b7ab38551f44$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($3e56b7ab38551f44$var$callPendingCbs);
            prevChildren.forEach($3e56b7ab38551f44$var$recordPosition);
            const movedChildren = prevChildren.filter($3e56b7ab38551f44$var$applyTranslation);
            $3e56b7ab38551f44$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $3e56b7ab38551f44$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$3e56b7ab38551f44$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$3e56b7ab38551f44$var$moveCbKey] = null;
                        $3e56b7ab38551f44$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $g90JB.toRaw)(props);
            const cssTransitionProps = $3e56b7ab38551f44$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $8zRru.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$3e56b7ab38551f44$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $8zRru.setTransitionHooks)(child, (0, $8zRru.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $3e56b7ab38551f44$var$positionMap.set(child, $3e56b7ab38551f44$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $8zRru.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $8zRru.setTransitionHooks)(child, (0, $8zRru.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $8zRru.createVNode)(tag, null, children);
        };
    }
});
const $3e56b7ab38551f44$export$19ffa8f511f7bc2e = $3e56b7ab38551f44$var$TransitionGroupImpl;
function $3e56b7ab38551f44$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$3e56b7ab38551f44$var$moveCbKey]) el[$3e56b7ab38551f44$var$moveCbKey]();
    if (el[$3e56b7ab38551f44$var$enterCbKey]) el[$3e56b7ab38551f44$var$enterCbKey]();
}
function $3e56b7ab38551f44$var$recordPosition(c) {
    $3e56b7ab38551f44$var$newPositionMap.set(c, $3e56b7ab38551f44$var$getPosition(c.el));
}
function $3e56b7ab38551f44$var$applyTranslation(c) {
    const oldPos = $3e56b7ab38551f44$var$positionMap.get(c);
    const newPos = $3e56b7ab38551f44$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $3e56b7ab38551f44$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $3e56b7ab38551f44$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$3e56b7ab38551f44$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $3e56b7ab38551f44$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $3e56b7ab38551f44$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $6ZvW5.isArray)(fn) ? (value)=>(0, $6ZvW5.invokeArrayFns)(fn, value) : fn;
};
function $3e56b7ab38551f44$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $3e56b7ab38551f44$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $3e56b7ab38551f44$var$assignKey = /* @__PURE__ */ Symbol("_assign");
function $3e56b7ab38551f44$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $6ZvW5.looseToNumber)(value);
    return value;
}
const $3e56b7ab38551f44$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$3e56b7ab38551f44$var$assignKey] = $3e56b7ab38551f44$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $3e56b7ab38551f44$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$3e56b7ab38551f44$var$assignKey]($3e56b7ab38551f44$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $3e56b7ab38551f44$var$addEventListener(el, "change", ()=>{
            el.value = $3e56b7ab38551f44$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $3e56b7ab38551f44$var$addEventListener(el, "compositionstart", $3e56b7ab38551f44$var$onCompositionStart);
            $3e56b7ab38551f44$var$addEventListener(el, "compositionend", $3e56b7ab38551f44$var$onCompositionEnd);
            $3e56b7ab38551f44$var$addEventListener(el, "change", $3e56b7ab38551f44$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$3e56b7ab38551f44$var$assignKey] = $3e56b7ab38551f44$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $6ZvW5.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $3e56b7ab38551f44$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$3e56b7ab38551f44$var$assignKey] = $3e56b7ab38551f44$var$getModelAssigner(vnode);
        $3e56b7ab38551f44$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $3e56b7ab38551f44$var$getValue(el);
            const checked = el.checked;
            const assign = el[$3e56b7ab38551f44$var$assignKey];
            if ((0, $6ZvW5.isArray)(modelValue)) {
                const index = (0, $6ZvW5.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $6ZvW5.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($3e56b7ab38551f44$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $3e56b7ab38551f44$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$3e56b7ab38551f44$var$assignKey] = $3e56b7ab38551f44$var$getModelAssigner(vnode);
        $3e56b7ab38551f44$var$setChecked(el, binding, vnode);
    }
};
function $3e56b7ab38551f44$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $6ZvW5.isArray)(value)) checked = (0, $6ZvW5.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $6ZvW5.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $6ZvW5.looseEqual)(value, $3e56b7ab38551f44$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $3e56b7ab38551f44$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $6ZvW5.looseEqual)(value, vnode.props.value);
        el[$3e56b7ab38551f44$var$assignKey] = $3e56b7ab38551f44$var$getModelAssigner(vnode);
        $3e56b7ab38551f44$var$addEventListener(el, "change", ()=>{
            el[$3e56b7ab38551f44$var$assignKey]($3e56b7ab38551f44$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$3e56b7ab38551f44$var$assignKey] = $3e56b7ab38551f44$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $6ZvW5.looseEqual)(value, vnode.props.value);
    }
};
const $3e56b7ab38551f44$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $6ZvW5.isSet)(value);
        $3e56b7ab38551f44$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $6ZvW5.looseToNumber)($3e56b7ab38551f44$var$getValue(o)) : $3e56b7ab38551f44$var$getValue(o));
            el[$3e56b7ab38551f44$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $8zRru.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$3e56b7ab38551f44$var$assignKey] = $3e56b7ab38551f44$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $3e56b7ab38551f44$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$3e56b7ab38551f44$var$assignKey] = $3e56b7ab38551f44$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $3e56b7ab38551f44$var$setSelected(el, value);
    }
};
function $3e56b7ab38551f44$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $6ZvW5.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $6ZvW5.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $3e56b7ab38551f44$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $6ZvW5.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $6ZvW5.looseEqual)($3e56b7ab38551f44$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $3e56b7ab38551f44$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $3e56b7ab38551f44$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $3e56b7ab38551f44$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $3e56b7ab38551f44$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $3e56b7ab38551f44$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $3e56b7ab38551f44$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $3e56b7ab38551f44$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $3e56b7ab38551f44$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $3e56b7ab38551f44$export$87d227567b51ca39;
        case "TEXTAREA":
            return $3e56b7ab38551f44$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $3e56b7ab38551f44$export$8847c2e532b35714;
                case "radio":
                    return $3e56b7ab38551f44$export$b4356c59b38b7aa9;
                default:
                    return $3e56b7ab38551f44$export$f1f88689f5728478;
            }
    }
}
function $3e56b7ab38551f44$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $3e56b7ab38551f44$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $3e56b7ab38551f44$var$initVModelForSSR() {
    $3e56b7ab38551f44$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $3e56b7ab38551f44$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $6ZvW5.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $3e56b7ab38551f44$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $6ZvW5.isArray)(value)) {
            if (vnode.props && (0, $6ZvW5.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $6ZvW5.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $3e56b7ab38551f44$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $3e56b7ab38551f44$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $3e56b7ab38551f44$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $3e56b7ab38551f44$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$3e56b7ab38551f44$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $3e56b7ab38551f44$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $3e56b7ab38551f44$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $3e56b7ab38551f44$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $3e56b7ab38551f44$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $6ZvW5.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $3e56b7ab38551f44$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $3e56b7ab38551f44$var$rendererOptions = /* @__PURE__ */ (0, $6ZvW5.extend)({
    patchProp: $3e56b7ab38551f44$export$cd4aa0842d13df8b
}, $3e56b7ab38551f44$export$de4fb7f5030605d3);
let $3e56b7ab38551f44$var$renderer;
let $3e56b7ab38551f44$var$enabledHydration = false;
function $3e56b7ab38551f44$var$ensureRenderer() {
    return $3e56b7ab38551f44$var$renderer || ($3e56b7ab38551f44$var$renderer = (0, $8zRru.createRenderer)($3e56b7ab38551f44$var$rendererOptions));
}
function $3e56b7ab38551f44$var$ensureHydrationRenderer() {
    $3e56b7ab38551f44$var$renderer = $3e56b7ab38551f44$var$enabledHydration ? $3e56b7ab38551f44$var$renderer : (0, $8zRru.createHydrationRenderer)($3e56b7ab38551f44$var$rendererOptions);
    $3e56b7ab38551f44$var$enabledHydration = true;
    return $3e56b7ab38551f44$var$renderer;
}
const $3e56b7ab38551f44$export$b3890eb0ae9dca99 = (...args)=>{
    $3e56b7ab38551f44$var$ensureRenderer().render(...args);
};
const $3e56b7ab38551f44$export$fa8d919ba61d84db = (...args)=>{
    $3e56b7ab38551f44$var$ensureHydrationRenderer().hydrate(...args);
};
const $3e56b7ab38551f44$export$4e373c34abfa8c68 = (...args)=>{
    const app = $3e56b7ab38551f44$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $3e56b7ab38551f44$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $6ZvW5.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $3e56b7ab38551f44$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $3e56b7ab38551f44$export$35800275c0037383 = (...args)=>{
    const app = $3e56b7ab38551f44$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $3e56b7ab38551f44$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $3e56b7ab38551f44$var$resolveRootNamespace(container));
    };
    return app;
};
function $3e56b7ab38551f44$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $3e56b7ab38551f44$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $6ZvW5.isHTMLTag)(tag) || (0, $6ZvW5.isSVGTag)(tag) || (0, $6ZvW5.isMathMLTag)(tag),
        writable: false
    });
}
function $3e56b7ab38551f44$var$injectCompilerOptionsCheck(app) {
    if ((0, $8zRru.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $8zRru.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $8zRru.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $8zRru.warn)(msg);
            }
        });
    }
}
function $3e56b7ab38551f44$var$normalizeContainer(container) {
    if ((0, $6ZvW5.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $3e56b7ab38551f44$var$ssrDirectiveInitialized = false;
const $3e56b7ab38551f44$export$800b28255aa678d9 = ()=>{
    if (!$3e56b7ab38551f44$var$ssrDirectiveInitialized) {
        $3e56b7ab38551f44$var$ssrDirectiveInitialized = true;
        $3e56b7ab38551f44$var$initVModelForSSR();
        $3e56b7ab38551f44$var$initVShowForSSR();
    }
};

});


parcelRegister("8eKAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff3c5d500dd74dc$export$2e2bcd8739ae039; });
let $5ff3c5d500dd74dc$var$script;




let $5ff3c5d500dd74dc$var$initialize = ()=>{
    $5ff3c5d500dd74dc$var$script = (parcelRequire("eTaEs"));
    if ($5ff3c5d500dd74dc$var$script.__esModule) $5ff3c5d500dd74dc$var$script = $5ff3c5d500dd74dc$var$script.default;
    $5ff3c5d500dd74dc$var$script.render = (parcelRequire("6fHxW")).render;
    $5ff3c5d500dd74dc$var$script.__cssModules = {};
    (parcelRequire("akcvz")).default($5ff3c5d500dd74dc$var$script);
    $5ff3c5d500dd74dc$var$script.__scopeId = "data-v-f97375";
    $5ff3c5d500dd74dc$var$script.__file = "LanguagePicker.vue";
};
$5ff3c5d500dd74dc$var$initialize();
var $5ff3c5d500dd74dc$export$2e2bcd8739ae039 = $5ff3c5d500dd74dc$var$script;

});
parcelRegister("eTaEs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $668fea84e9be2593$export$2e2bcd8739ae039; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");

var $2Wseo = parcelRequire("2Wseo");

var $kBVDt = parcelRequire("kBVDt");
var $668fea84e9be2593$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({
    data () {
        return {
            lang: this.$i18n.locale
        };
    },
    methods: {
        async handleLangChange () {
            this.$i18n.locale = this.lang;
            await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_LANG_KEY), this.lang);
        }
    },
    watch: {
        "$i18n.locale": function(newLocale) {
            this.lang = newLocale;
        }
    }
});

});
parcelRegister("2Wseo", function(module, exports) {
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode("");
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== "undefined") {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ("document" in global1 && "onreadystatechange" in global1.document.createElement("script")) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement("script");
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    "REJECTED"
                ];
                var FULFILLED = [
                    "FULFILLED"
                ];
                var PENDING = [
                    "PENDING"
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === "function") {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === "function") {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === "error") return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === "error") onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = "success";
                    } catch (e) {
                        out.status = "error";
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    if (typeof global1.Promise !== "function") global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== "undefined") return indexedDB;
                        if (typeof webkitIndexedDB !== "undefined") return webkitIndexedDB;
                        if (typeof mozIndexedDB !== "undefined") return mozIndexedDB;
                        if (typeof OIndexedDB !== "undefined") return OIndexedDB;
                        if (typeof msIndexedDB !== "undefined") return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== "undefined";
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== "TypeError") throw e;
                        var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === "undefined") // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === "function") promise.then(callback);
                    if (typeof errorCallback === "function") promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== "string") {
                        console.warn(key + " used as a key, but it is not a string.");
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === "function") return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = "readonly";
                var READ_WRITE = "readwrite";
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ""
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === "boolean") return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === "ConstraintError") console.warn('The database "' + dbInfo.name + '"' + " has been upgraded from version " + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + " to version " + dbInfo.version + ".");
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || "");
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === "[object Blob]") return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: "asyncStorage",
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === "function";
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                var BLOB_TYPE_PREFIX = "~~local_forage_type~";
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = "__lfsc__:";
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = "arbf";
                var TYPE_BLOB = "blob";
                var TYPE_INT8ARRAY = "si08";
                var TYPE_UINT8ARRAY = "ui08";
                var TYPE_UINT8CLAMPEDARRAY = "uic8";
                var TYPE_INT16ARRAY = "si16";
                var TYPE_INT32ARRAY = "si32";
                var TYPE_UINT16ARRAY = "ur16";
                var TYPE_UINT32ARRAY = "ui32";
                var TYPE_FLOAT32ARRAY = "fl32";
                var TYPE_FLOAT64ARRAY = "fl64";
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === "=") {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === "=") bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = "";
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + "=";
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + "==";
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = "";
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === "[object Int8Array]") marker += TYPE_INT8ARRAY;
                            else if (valueType === "[object Uint8Array]") marker += TYPE_UINT8ARRAY;
                            else if (valueType === "[object Uint8ClampedArray]") marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === "[object Int16Array]") marker += TYPE_INT16ARRAY;
                            else if (valueType === "[object Uint16Array]") marker += TYPE_UINT16ARRAY;
                            else if (valueType === "[object Int32Array]") marker += TYPE_INT32ARRAY;
                            else if (valueType === "[object Uint32Array]") marker += TYPE_UINT32ARRAY;
                            else if (valueType === "[object Float32Array]") marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === "[object Float64Array]") marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error("Failed to get type for BinaryArray"));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === "[object Blob]") {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error("Unkown type: " + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " " + "(id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " " + "(key, value) VALUES (?, ?)", [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, "", "", 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: "webSQLStorage",
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + "/";
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + "/";
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = "_localforage_support_test";
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + "/");
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: "localStorageWrapper",
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === "[object Array]";
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    "dropInstance"
                ];
                var LibraryMethods = [
                    "clear",
                    "getItem",
                    "iterate",
                    "key",
                    "keys",
                    "length",
                    "removeItem",
                    "setItem"
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: "",
                    driver: DefaultDriverOrder.slice(),
                    name: "localforage",
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: "keyvaluepairs",
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === "storeName") options[i] = options[i].replace(/\W/g, "_");
                                if (i === "version" && typeof options[i] !== "number") return new Error("Database version must be a number.");
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ("driver" in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === "string") return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat("_initStorage");
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error("Method " + methodName + " is not implemented by the current driver");
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info("Redefining LocalForage driver: " + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ("_support" in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === "function") driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error("No available storage method found.");
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error("No available storage method found.");
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("kBVDt", function(module, exports) {

$parcel$export(module.exports, "STORED_EMAIL_KEY", function () { return $3c115e96941dc609$export$3e800fb56ac1a266; });
$parcel$export(module.exports, "STORED_LANG_KEY", function () { return $3c115e96941dc609$export$60890076fc7cbf5f; });
$parcel$export(module.exports, "STORED_ACCOUNT_NUMBER_KEY", function () { return $3c115e96941dc609$export$44cf8008500f0056; });
$parcel$export(module.exports, "STORED_IS_HIGH_RISK_KEY", function () { return $3c115e96941dc609$export$59b2eb681c8a7c62; });
$parcel$export(module.exports, "ACCOUNT_NUMBER_PARAMETER_KEY", function () { return $3c115e96941dc609$export$30a62936694bdec0; });
$parcel$export(module.exports, "EMAIL_PARAMETER_KEY", function () { return $3c115e96941dc609$export$bc5cc45986d9d42; });
$parcel$export(module.exports, "STORED_ACCOUNTS_KEY", function () { return $3c115e96941dc609$export$311b60d4be9f6647; });
$parcel$export(module.exports, "STORED_COUNTRY_KEY", function () { return $3c115e96941dc609$export$9d7a87e5b4bf073d; });
$parcel$export(module.exports, "STORED_EBURY_REGULATORY_BRANCH_KEY", function () { return $3c115e96941dc609$export$858e2df16bcbce5d; });
$parcel$export(module.exports, "isProduction", function () { return $3c115e96941dc609$export$f15d00aa73aafac4; });
const $3c115e96941dc609$export$3e800fb56ac1a266 = "pr-email";
const $3c115e96941dc609$export$60890076fc7cbf5f = "pr-lang";
const $3c115e96941dc609$export$44cf8008500f0056 = "pr-account-number";
const $3c115e96941dc609$export$59b2eb681c8a7c62 = "pr-is-hr";
const $3c115e96941dc609$export$30a62936694bdec0 = `accountNumber`;
const $3c115e96941dc609$export$bc5cc45986d9d42 = `email`;
const $3c115e96941dc609$export$311b60d4be9f6647 = "pr-accounts";
const $3c115e96941dc609$export$9d7a87e5b4bf073d = "pr-country";
const $3c115e96941dc609$export$858e2df16bcbce5d = "pr-ebury-regulatory-branch";
const $3c115e96941dc609$var$currentUrl = new URL(window.location.href);
const $3c115e96941dc609$export$f15d00aa73aafac4 = $3c115e96941dc609$var$currentUrl.host === "periodic-reviews.ebury.com";

});


parcelRegister("6fHxW", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $48d5ec394c1b5da0$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $5lPju = parcelRequire("5lPju");
function $48d5ec394c1b5da0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $8zRru.withDirectives)(((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("select", {
        class: "lang-picker",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.lang = $event),
        onChange: _cache[1] || (_cache[1] = (...args)=>_ctx.handleLangChange && _ctx.handleLangChange(...args))
    }, [
        ..._cache[2] || (_cache[2] = [
            (0, $8zRru.createStaticVNode)('<option value="en">English</option><option value="es">Espa\xf1ol</option><option value="nl">Nederlands</option><option value="fr">Fran\xe7ais</option><option value="pt">Portugu\xeas</option><option value="it">Italiano</option><option value="de">Deutsch</option><option value="pl">Polski</option><option value="ro">Rom\xe2n\u0103</option><option value="gr">\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC</option>', 10)
        ])
    ], 544)), [
        [
            (0, $5lPju.vModelSelect),
            _ctx.lang
        ]
    ]);
}

});

parcelRegister("akcvz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78457982445b6158$export$2e2bcd8739ae039; });
let $78457982445b6158$var$NOOP = ()=>{};
var $78457982445b6158$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("5fZlh", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $3d3defc51772c6ba$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");

var $25mvM = parcelRequire("25mvM");
const $3d3defc51772c6ba$var$_hoisted_1 = {
    class: "top-bar"
};
const $3d3defc51772c6ba$var$_hoisted_2 = {
    class: "top-bar-inner"
};
const $3d3defc51772c6ba$var$_hoisted_3 = {
    class: "top-bar-logo"
};
function $3d3defc51772c6ba$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_language_picker = (0, $8zRru.resolveComponent)("language-picker");
    return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $3d3defc51772c6ba$var$_hoisted_1, [
        (0, $8zRru.createElementVNode)("div", $3d3defc51772c6ba$var$_hoisted_2, [
            (0, $8zRru.createElementVNode)("div", $3d3defc51772c6ba$var$_hoisted_3, [
                _cache[0] || (_cache[0] = (0, $8zRru.createElementVNode)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($25mvM))),
                    alt: ""
                }, null, -1)),
                (0, $8zRru.createElementVNode)("h2", null, (0, $6ZvW5.toDisplayString)(_ctx.$t("formPage.title")), 1)
            ]),
            (0, $8zRru.createVNode)(_component_language_picker)
        ])
    ]);
}

});
parcelRegister("25mvM", function(module, exports) {
module.exports = new URL("ebury-logo.b014e20d.svg", import.meta.url).toString();

});


parcelRegister("1UspH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16410fbccc911210$export$2e2bcd8739ae039; });
let $16410fbccc911210$var$NOOP = ()=>{};
var $16410fbccc911210$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("hLDPq", function(module, exports) {

$parcel$export(module.exports, "getCurrentEmail", function () { return $aa6984be8beda35b$export$3a6ef9b47bcc76d1; });

var $2Wseo = parcelRequire("2Wseo");

var $kBVDt = parcelRequire("kBVDt");
const $aa6984be8beda35b$export$3a6ef9b47bcc76d1 = async ()=>{
    let email = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_EMAIL_KEY));
    if (email) return email;
    const currentUrl = new URL(window.location.href);
    email = currentUrl.searchParams.get((0, $kBVDt.EMAIL_PARAMETER_KEY));
    await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_EMAIL_KEY), email);
    return email;
};

});

parcelRegister("2SEys", function(module, exports) {

$parcel$export(module.exports, "getCurrentAccountNumber", function () { return $9216bb817e31522d$export$d61eab7f0a5bc95e; });

var $2Wseo = parcelRequire("2Wseo");

var $kBVDt = parcelRequire("kBVDt");
const $9216bb817e31522d$export$d61eab7f0a5bc95e = async ()=>{
    const currentUrl = new URL(window.location.href);
    const parameters = currentUrl.searchParams;
    const accountNumber = parameters.get((0, $kBVDt.ACCOUNT_NUMBER_PARAMETER_KEY));
    if (accountNumber) {
        await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_ACCOUNT_NUMBER_KEY), accountNumber);
        return accountNumber;
    }
    const lastStoredAccountNumber = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_ACCOUNT_NUMBER_KEY));
    console.log(lastStoredAccountNumber, accountNumber);
    return lastStoredAccountNumber;
};

});


parcelRegister("h69le", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $c72a3e3ec8b57f32$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
const $c72a3e3ec8b57f32$var$_hoisted_1 = {
    class: "content"
};
function $c72a3e3ec8b57f32$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_top_bar = (0, $8zRru.resolveComponent)("top-bar");
    const _component_router_view = (0, $8zRru.resolveComponent)("router-view");
    return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)((0, $8zRru.Fragment), null, [
        (0, $8zRru.createVNode)(_component_top_bar),
        (0, $8zRru.createElementVNode)("div", $c72a3e3ec8b57f32$var$_hoisted_1, [
            ((0, $8zRru.openBlock)(), (0, $8zRru.createBlock)(_component_router_view, {
                key: _ctx.$route.fullPath
            }))
        ])
    ], 64);
}

});

parcelRegister("a7MAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75f03f9de4953b2f$export$2e2bcd8739ae039; });
let $75f03f9de4953b2f$var$NOOP = ()=>{};
var $75f03f9de4953b2f$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gLwTq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0176ae2f496c9160$export$2e2bcd8739ae039; });
parcelRequire("i2PrI");
var $cxzoJ = parcelRequire("cxzoJ");

var $2Wseo = parcelRequire("2Wseo");
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");

var $2aNQ5 = parcelRequire("2aNQ5");

var $bv5EI = parcelRequire("bv5EI");

var $iZ8Do = parcelRequire("iZ8Do");

var $lbeuH = parcelRequire("lbeuH");

var $1ZR76 = parcelRequire("1ZR76");

var $96jlp = parcelRequire("96jlp");

var $cUl0O = parcelRequire("cUl0O");

var $kBVDt = parcelRequire("kBVDt");

var $58E6z = parcelRequire("58E6z");

var $l2h0I = parcelRequire("l2h0I");

var $2EJsO = parcelRequire("2EJsO");

var $av4DF = parcelRequire("av4DF");

var $2SEys = parcelRequire("2SEys");

var $85fCd = parcelRequire("85fCd");

var $7v7ww = parcelRequire("7v7ww");

var $36h9V = parcelRequire("36h9V");

var $lgUhZ = parcelRequire("lgUhZ");

var $ctTWP = parcelRequire("ctTWP");

var $eTlDg = parcelRequire("eTlDg");

var $gF9qy = parcelRequire("gF9qy");

var $8uxR7 = parcelRequire("8uxR7");
var $0176ae2f496c9160$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({
    components: {
        Informational: $lbeuH.default,
        SuccessMessage: $cUl0O.default,
        LoadingSpinner: $1ZR76.default,
        PRSelector: $96jlp.default,
        Button: $iZ8Do.default
    },
    data () {
        return {
            loading: true,
            data: [],
            sections: [],
            currentSectionIndex: 0,
            isLastSection: false,
            accounts: [],
            accountNumber: "",
            country: "",
            eburyRegulatoryBranch: "",
            isHighRisk: false,
            isFirstSection: true,
            lang: this.$i18n.locale,
            datePickerLang: (0, $85fCd.getDatePickerLocale)(this.$i18n.locale),
            submitted: false,
            alreadySubmitted: false
        };
    },
    watch: {
        "$i18n.locale" (newLocale) {
            const localeToUse = (0, $7v7ww.getLocaleToUse)(newLocale);
            this.updateLocale(localeToUse);
            this.$i18n.locale = localeToUse;
        },
        accountNumber: function(newAccountNumber) {
            const correspondingAccount = this.accounts.find((account)=>account.accountNumber === newAccountNumber);
            this.country = correspondingAccount?.country;
        }
    },
    created () {
        const firebaseInstance = (0, $58E6z.firebaseApp).instance;
        const auth = (0, $cxzoJ.o)(firebaseInstance);
        auth.onAuthStateChanged(async (user)=>{
            const lang = await (0, $36h9V.getSavedLang)();
            (0, $8uxR7.consoleLogStaging)({
                user: user
            });
            if (user) {
                const successMessage = (0, $2aNQ5.SUCCESS_MESSAGES).AUTHORIZED_AS[lang];
                (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Notify.success(`${successMessage} ${user.email}`);
                const token = await user.getIdToken(true);
                (0, $eTlDg.setToken)(token);
                return;
            }
            const isLinkValid = (0, $cxzoJ.ad)(auth, window.location.href);
            const email = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_EMAIL_KEY));
            const errorTitle = (0, $2aNQ5.ERROR_MESSAGES).NO_EMAIL[lang];
            const errorMessage = (0, $2aNQ5.ERROR_MESSAGES).USE_EBURY_EMAIL[lang];
            if (!email) {
                (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Report.warning(errorTitle, errorMessage, "OK", ()=>{
                    this.$router.push("/");
                });
                return;
            }
            if (isLinkValid) try {
                const emailLink = window.location.href;
                const result = await (0, $cxzoJ.ae)(auth, email, emailLink);
                const user = result?.user;
                const token = await user.getIdToken(true);
                (0, $eTlDg.setToken)(token);
                return;
            } catch (error) {
                const errorTitle = (0, $2aNQ5.ERROR_MESSAGES).INVALID_LINK[lang];
                (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Report.warning(errorTitle, errorMessage, "OK", ()=>{
                    this.$router.push("/");
                });
            }
        });
    },
    async mounted () {
        const initialValues = {
            file: null,
            text: "",
            textarea: "",
            select: null,
            radio: null
        };
        let dataObj = null;
        let accounts = null;
        const accountNumber = await (0, $2SEys.getCurrentAccountNumber)();
        if (!accountNumber) {
            const lang = await (0, $36h9V.getSavedLang)();
            const errorTitle = (0, $2aNQ5.ERROR_MESSAGES).NO_ACCOUNT_NUMBER[lang];
            const errorMessage = (0, $2aNQ5.ERROR_MESSAGES).USE_EBURY_EMAIL[lang];
            return (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Report.warning(errorTitle, errorMessage, "OK", ()=>{
                this.$router.push("/");
            });
        }
        const locallySavedData = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem(accountNumber);
        if (locallySavedData) {
            const storedIsHighRisk = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_IS_HIGH_RISK_KEY));
            this.isHighRisk = storedIsHighRisk ?? false;
            const storedCountry = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_COUNTRY_KEY));
            this.country = storedCountry ?? "";
            const storedEburyRegulatoryBranch = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_EBURY_REGULATORY_BRANCH_KEY));
            const isStoredEburyRegulatoryBranchMissing = storedEburyRegulatoryBranch === null;
            if (isStoredEburyRegulatoryBranchMissing) {
                const action = "get_form_json";
                const response = await (0, $2EJsO.callApi)({
                    action: action
                });
                const backfilledEburyRegulatoryBranch = response?.data?.metadata?.eburyRegulatoryBranch ?? "";
                this.eburyRegulatoryBranch = backfilledEburyRegulatoryBranch;
                await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_EBURY_REGULATORY_BRANCH_KEY), this.eburyRegulatoryBranch);
            } else this.eburyRegulatoryBranch = storedEburyRegulatoryBranch;
            dataObj = locallySavedData;
            accounts = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_ACCOUNTS_KEY));
            (0, $8uxR7.consoleLogStaging)({
                dataObj: dataObj
            });
        } else {
            const action = "get_form_json";
            const response = await (0, $2EJsO.callApi)({
                action: action
            });
            if (!response) return;
            const responseData = response.data;
            const language = responseData.metadata.language;
            accounts = responseData.metadata.accounts;
            await (0, $lgUhZ.saveLocally)((0, $kBVDt.STORED_ACCOUNTS_KEY), accounts, this.lang);
            const alreadySubmitted = responseData.metadata.alreadySubmitted;
            if (alreadySubmitted) {
                this.alreadySubmitted = true;
                this.loading = false;
                this.accounts = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_ACCOUNTS_KEY));
                await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).clear();
                return;
            }
            const responseWithData = responseData;
            (0, $8uxR7.consoleLogStaging)({
                responseWithData: responseWithData
            });
            const { data: data } = responseWithData;
            this.updateLocale(language);
            for (const [index, field] of data.entries()){
                const value = field?.value ?? initialValues[field.type];
                data[index] = {
                    ...field,
                    value: value
                };
            }
            dataObj = data;
            this.isHighRisk = responseData.metadata.isHighRisk ?? false;
            await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_IS_HIGH_RISK_KEY), this.isHighRisk);
            this.eburyRegulatoryBranch = responseData.metadata.eburyRegulatoryBranch ?? "";
            await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_EBURY_REGULATORY_BRANCH_KEY), this.eburyRegulatoryBranch);
            await (0, $lgUhZ.saveLocally)(accountNumber, dataObj, this.lang);
        }
        const sections = (0, $ctTWP.splitArrayBySeparator)(dataObj);
        this.sections = sections;
        this.accounts = accounts;
        this.accountNumber = accountNumber;
        const correspondingAccount = accounts.find((account)=>account.accountNumber === accountNumber);
        if (correspondingAccount) this.country = correspondingAccount.country;
        await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_COUNTRY_KEY), this.country);
        this.data = dataObj;
        this.loading = false;
    },
    methods: {
        resetFileInput (id) {
            const fileInput = document.getElementById(id);
            fileInput.value = "";
        },
        async handleChange (event, question) {
            const inputElement = event.target;
            let value = question.value;
            const isSelect = question.type === "select";
            const relationTypes = [
                "auth contact",
                "ubo",
                "director",
                "corporate director"
            ];
            const isRelationSelect = relationTypes.includes(inputElement.value);
            const shouldAddRelation = isSelect && isRelationSelect;
            if (shouldAddRelation) this.handleAddRelationFields(question, inputElement.value);
            const isFile = question.type === "file";
            if (isFile) {
                const fileInput = inputElement;
                const file = fileInput.files ? fileInput.files[0] : null;
                let storedFile = null;
                if (!file) {
                    value = "";
                    storedFile = {
                        name: question.id,
                        originalName: "",
                        type: "",
                        content: null
                    };
                } else {
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(file);
                    const promisifiedFileReader = new Promise((resolve, reject)=>{
                        fileReader.onload = (event)=>{
                            value = file.name;
                            const content = event.target?.result;
                            const storedFile = {
                                name: question.id,
                                originalName: file.name,
                                type: file.type,
                                content: content
                            };
                            resolve(storedFile);
                        };
                        fileReader.onerror = ()=>{
                            reject(new Error("Failed to read file."));
                        };
                    });
                    storedFile = await promisifiedFileReader;
                }
                await (0, $lgUhZ.saveLocally)(`${(0, $2aNQ5.FILE_UPLOAD_PREFIX)}${question.id}`, storedFile, this.lang, false);
            }
            const isRadio = question.type === "radio";
            if (isRadio) {
                const isValueTrue = inputElement.value === "true";
                const isValueFalse = inputElement.value === "false";
                value = isValueTrue ? true : isValueFalse ? false : inputElement.value;
            }
            question.value = value;
            await (0, $lgUhZ.saveLocally)(this.accountNumber, this.data, this.lang);
        },
        async handleDeleteRelation (question) {
            const relationNumberToDelete = question.value;
            this.data = this.data.filter((element)=>!element.id.startsWith(`relation_${relationNumberToDelete}`));
            this.sections = (0, $ctTWP.splitArrayBySeparator)(this.data);
            await (0, $lgUhZ.saveLocally)(this.accountNumber, this.data, this.lang);
        },
        async handleAddNewRelation () {
            const onlyRelations = this.data.filter((element)=>element.id.startsWith("relation"));
            const lastRelation = onlyRelations[onlyRelations.length - 1];
            const lastRelationIndex = this.data.findIndex((element)=>element.id === lastRelation.id);
            const lastRelationNumber = (0, $av4DF.extractIndex)(lastRelation.id);
            const newRelationNumber = lastRelationNumber ? (lastRelationNumber + 1).toString() : "1";
            const newRelationElements = (0, $l2h0I.addNewRelation)(newRelationNumber);
            this.data.splice(lastRelationIndex + 1, 0, ...newRelationElements);
            this.sections = (0, $ctTWP.splitArrayBySeparator)(this.data);
            await (0, $lgUhZ.saveLocally)(this.accountNumber, this.data, this.lang);
        },
        async handleAddRelationFields (question, relationType) {
            const relationNumber = (0, $av4DF.extractIndex)(question.id);
            if (!relationNumber) throw new Error("Could not extract relation index");
            const relationArrayIndex = this.data.findIndex((element)=>{
                return element.id === question.id;
            });
            this.data = this.data.filter((element, index)=>{
                return index <= relationArrayIndex || !element.id.includes(`relation_${relationNumber}`);
            });
            const indexToInjectTo = relationArrayIndex + 1;
            const elementsToInject = (0, $bv5EI.addRelationFields)({
                relationNumber: relationNumber.toString(),
                country: this.country,
                relationType: relationType,
                isHighRisk: this.isHighRisk
            });
            this.data.splice(indexToInjectTo, 0, ...elementsToInject);
            this.sections = (0, $ctTWP.splitArrayBySeparator)(this.data);
            await (0, $lgUhZ.saveLocally)(this.accountNumber, this.data, this.lang);
        },
        async updateLocale (newLocale) {
            const allowedLanguages = (0, $2aNQ5.languages);
            const isNewLocaleAllowed = allowedLanguages.includes(newLocale);
            const localeToUse = isNewLocaleAllowed ? newLocale : "en";
            this.lang = localeToUse;
            this.$i18n.locale = localeToUse;
            await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_LANG_KEY), localeToUse);
            this.datePickerLang = (0, $85fCd.getDatePickerLocale)(this.$i18n.locale);
        },
        checkConditions (question) {
            if (!question.renderConditions) return true;
            return Object.entries(question.renderConditions).every(([id, acceptedValues])=>{
                const field = this.extractQuestions.find((q)=>q.id === id);
                return field && acceptedValues.includes(field.value);
            });
        },
        handleNavigation (direction) {
            const currentIndex = this.currentSectionIndex;
            const lastIndex = this.sections.length - 1;
            const firstIndex = 0;
            const isForwardDirection = direction === "forward";
            // move to next section
            if (isForwardDirection) {
                const form = this.$refs.mainForm;
                const areAllFieldsFilled = form.reportValidity();
                if (!areAllFieldsFilled) return;
                const newIndex = currentIndex + 1;
                this.currentSectionIndex = newIndex;
                this.isLastSection = newIndex === lastIndex;
                this.isFirstSection = false;
            } else // move to previous section
            if (currentIndex >= 0) {
                const newIndex = currentIndex - 1;
                this.currentSectionIndex = newIndex;
                this.isFirstSection = newIndex === firstIndex;
                this.isLastSection = false;
            }
            window.scrollTo(0, 0);
        },
        async handleSubmit () {
            const form = this.$refs.mainForm;
            const areAllFieldsFilled = form.reportValidity();
            if (!areAllFieldsFilled) return;
            this.loading = true;
            let areThereStillFilesToUpload = true;
            while(areThereStillFilesToUpload){
                const storedKeys = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).keys();
                const hasUploadFilePrefix = storedKeys.some((key)=>key.startsWith((0, $2aNQ5.FILE_UPLOAD_PREFIX)));
                if (!hasUploadFilePrefix) areThereStillFilesToUpload = false;
                await new Promise((resolve)=>setTimeout(resolve, 500));
            }
            const payload = {};
            this.data.forEach((element)=>{
                payload[element.id] = element.prefilledValue || element.value;
            });
            payload.ebury_regulatory_branch = this.eburyRegulatoryBranch;
            (0, $8uxR7.consoleLogStaging)({
                payload: payload
            });
            const action = "submit_form_response";
            const result = await (0, $2EJsO.callApi)({
                action: action,
                data: payload
            });
            if (!result) return;
            await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).clear();
            this.loading = false;
            this.submitted = true;
        }
    },
    computed: {
        extractQuestions () {
            const questionTypes = [
                "select",
                `radio`,
                "hidden"
            ];
            const questions = [];
            this.sections[this.currentSectionIndex].forEach((element)=>{
                const isQuestion = questionTypes.includes(element.type);
                if (isQuestion) questions.push(element);
            });
            return questions;
        }
    }
});

});
parcelRegister("i2PrI", function(module, exports) {
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("cxzoJ")).o; });
$parcel$export(module.exports, "isSignInWithEmailLink", function () { return (parcelRequire("cxzoJ")).ad; });
$parcel$export(module.exports, "sendSignInLinkToEmail", function () { return (parcelRequire("cxzoJ")).ac; });
$parcel$export(module.exports, "signInWithEmailLink", function () { return (parcelRequire("cxzoJ")).ae; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("cxzoJ")).C; });
parcelRequire("j9Ust");

});
parcelRegister("j9Ust", function(module, exports) {

$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("cxzoJ")).o; });
$parcel$export(module.exports, "isSignInWithEmailLink", function () { return (parcelRequire("cxzoJ")).ad; });
$parcel$export(module.exports, "sendSignInLinkToEmail", function () { return (parcelRequire("cxzoJ")).ac; });
$parcel$export(module.exports, "signInWithEmailLink", function () { return (parcelRequire("cxzoJ")).ae; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("cxzoJ")).C; });

var $cxzoJ = parcelRequire("cxzoJ");
parcelRequire("gc3di");
parcelRequire("i9zJL");
parcelRequire("dQajh");

parcelRequire("6DAV2");

});
parcelRegister("cxzoJ", function(module, exports) {

$parcel$export(module.exports, "ac", function () { return $921406603d6a2f44$export$2219238a014317b0; });
$parcel$export(module.exports, "ad", function () { return $921406603d6a2f44$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "ae", function () { return $921406603d6a2f44$export$f787f51d84a910ad; });
$parcel$export(module.exports, "C", function () { return $921406603d6a2f44$export$e7094788287c5e9b; });
$parcel$export(module.exports, "o", function () { return $921406603d6a2f44$export$ae1af26003f05816; });

var $gc3di = parcelRequire("gc3di");

var $i9zJL = parcelRequire("i9zJL");

var $dQajh = parcelRequire("dQajh");

var $cgTd8 = parcelRequire("cgTd8");

var $6DAV2 = parcelRequire("6DAV2");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $921406603d6a2f44$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $921406603d6a2f44$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $921406603d6a2f44$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $921406603d6a2f44$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $921406603d6a2f44$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registered for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: "The supplied auth credential is incorrect, malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend.",
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "The password does not meet the requirements."
    };
}
function $921406603d6a2f44$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $921406603d6a2f44$export$2329c99376c9d0a4 = $921406603d6a2f44$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $921406603d6a2f44$export$7f8ddf7c7c20b3cd = $921406603d6a2f44$var$_prodErrorMap;
const $921406603d6a2f44$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $i9zJL.ErrorFactory)("auth", "Firebase", $921406603d6a2f44$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $921406603d6a2f44$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_LOGIN_CREDENTIALS: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$logClient = new (0, $dQajh.Logger)("@firebase/auth");
function $921406603d6a2f44$var$_logWarn(msg, ...args) {
    if ($921406603d6a2f44$var$logClient.logLevel <= (0, $dQajh.LogLevel).WARN) $921406603d6a2f44$var$logClient.warn(`Auth (${(0, $gc3di.SDK_VERSION)}): ${msg}`, ...args);
}
function $921406603d6a2f44$var$_logError(msg, ...args) {
    if ($921406603d6a2f44$var$logClient.logLevel <= (0, $dQajh.LogLevel).ERROR) $921406603d6a2f44$var$logClient.error(`Auth (${(0, $gc3di.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $921406603d6a2f44$var$createErrorInternal(authOrCode, ...rest);
}
function $921406603d6a2f44$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $921406603d6a2f44$var$createErrorInternal(authOrCode, ...rest);
}
function $921406603d6a2f44$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $921406603d6a2f44$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $i9zJL.ErrorFactory)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $921406603d6a2f44$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function $921406603d6a2f44$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $921406603d6a2f44$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $921406603d6a2f44$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $921406603d6a2f44$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $921406603d6a2f44$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $921406603d6a2f44$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $921406603d6a2f44$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $921406603d6a2f44$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $921406603d6a2f44$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $921406603d6a2f44$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $921406603d6a2f44$var$_isHttpOrHttps() {
    return $921406603d6a2f44$var$_getCurrentScheme() === "http:" || $921406603d6a2f44$var$_getCurrentScheme() === "https:";
}
function $921406603d6a2f44$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $921406603d6a2f44$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($921406603d6a2f44$var$_isHttpOrHttps() || (0, $i9zJL.isBrowserExtension)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $921406603d6a2f44$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $921406603d6a2f44$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $921406603d6a2f44$export$1fbe638ecf81657e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $i9zJL.isMobileCordova)() || (0, $i9zJL.isReactNative)();
    }
    get() {
        if (!$921406603d6a2f44$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$_emulatorUrl(config, path) {
    $921406603d6a2f44$export$1fbe638ecf81657e(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== "undefined") return fetch;
        $921406603d6a2f44$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== "undefined") return Headers;
        $921406603d6a2f44$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
        if (typeof Response !== "undefined") return Response;
        $921406603d6a2f44$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $921406603d6a2f44$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$DEFAULT_API_TIMEOUT_MS = new $921406603d6a2f44$var$Delay(30000, 60000);
function $921406603d6a2f44$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $921406603d6a2f44$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $921406603d6a2f44$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $i9zJL.querystring)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method: method,
            headers: headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $i9zJL.isCloudflareWorker)()) fetchArgs.referrerPolicy = "no-referrer";
        return $921406603d6a2f44$export$2ed0fc6709e59212.fetch()($921406603d6a2f44$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $921406603d6a2f44$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $921406603d6a2f44$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $921406603d6a2f44$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $921406603d6a2f44$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $921406603d6a2f44$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $921406603d6a2f44$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $921406603d6a2f44$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $921406603d6a2f44$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $i9zJL.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $921406603d6a2f44$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $921406603d6a2f44$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $921406603d6a2f44$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $921406603d6a2f44$var$_emulatorUrl(auth.config, base);
}
function $921406603d6a2f44$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $921406603d6a2f44$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($921406603d6a2f44$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $921406603d6a2f44$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $921406603d6a2f44$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $921406603d6a2f44$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $921406603d6a2f44$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $921406603d6a2f44$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $921406603d6a2f44$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$getRecaptchaParams(auth) {
    return (await $921406603d6a2f44$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $921406603d6a2f44$var$getRecaptchaConfig(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$deleteAccount(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $921406603d6a2f44$var$deleteLinkedAccounts(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $921406603d6a2f44$var$getAccountInfo(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $921406603d6a2f44$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $i9zJL.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $921406603d6a2f44$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $921406603d6a2f44$var$_parseToken(token);
    $921406603d6a2f44$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $921406603d6a2f44$var$utcTimestampToDateString($921406603d6a2f44$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $921406603d6a2f44$var$utcTimestampToDateString($921406603d6a2f44$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $921406603d6a2f44$var$utcTimestampToDateString($921406603d6a2f44$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $921406603d6a2f44$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $921406603d6a2f44$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $921406603d6a2f44$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $i9zJL.base64Decode)(payload);
        if (!decoded) {
            $921406603d6a2f44$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $921406603d6a2f44$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $921406603d6a2f44$var$_tokenExpiresIn(token) {
    const parsedToken = $921406603d6a2f44$var$_parseToken(token);
    $921406603d6a2f44$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $921406603d6a2f44$export$890c4ad488842ce7(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $921406603d6a2f44$export$890c4ad488842ce7(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $i9zJL.FirebaseError) && $921406603d6a2f44$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $921406603d6a2f44$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $921406603d6a2f44$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $921406603d6a2f44$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $921406603d6a2f44$var$_logoutIfInvalidated(user, $921406603d6a2f44$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $921406603d6a2f44$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $921406603d6a2f44$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $921406603d6a2f44$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $921406603d6a2f44$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $921406603d6a2f44$export$d24c54395ce0c509(user) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    await $921406603d6a2f44$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $921406603d6a2f44$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $921406603d6a2f44$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $cgTd8.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$requestStsToken(auth, refreshToken) {
    const response = await $921406603d6a2f44$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $i9zJL.querystring)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $921406603d6a2f44$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $921406603d6a2f44$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $921406603d6a2f44$var$revokeToken(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $921406603d6a2f44$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $921406603d6a2f44$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $921406603d6a2f44$export$890c4ad488842ce7(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $921406603d6a2f44$export$890c4ad488842ce7(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $921406603d6a2f44$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $921406603d6a2f44$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $921406603d6a2f44$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $921406603d6a2f44$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $921406603d6a2f44$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $921406603d6a2f44$var$StsTokenManager();
        if (refreshToken) {
            $921406603d6a2f44$export$890c4ad488842ce7(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $921406603d6a2f44$export$890c4ad488842ce7(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $921406603d6a2f44$export$890c4ad488842ce7(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $921406603d6a2f44$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $921406603d6a2f44$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$assertStringOrUndefined(assertion, appName) {
    $921406603d6a2f44$export$890c4ad488842ce7(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $921406603d6a2f44$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $cgTd8.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $921406603d6a2f44$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $921406603d6a2f44$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $921406603d6a2f44$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $921406603d6a2f44$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $921406603d6a2f44$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $921406603d6a2f44$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $921406603d6a2f44$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $921406603d6a2f44$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $921406603d6a2f44$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $921406603d6a2f44$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $gc3di._isFirebaseServerApp)(this.auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $921406603d6a2f44$var$_logoutIfInvalidated(this, $921406603d6a2f44$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $921406603d6a2f44$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $921406603d6a2f44$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $921406603d6a2f44$export$890c4ad488842ce7(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $921406603d6a2f44$var$assertStringOrUndefined(displayName, auth.name);
        $921406603d6a2f44$var$assertStringOrUndefined(email, auth.name);
        $921406603d6a2f44$export$890c4ad488842ce7(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $921406603d6a2f44$export$890c4ad488842ce7(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $921406603d6a2f44$var$assertStringOrUndefined(phoneNumber, auth.name);
        $921406603d6a2f44$var$assertStringOrUndefined(photoURL, auth.name);
        $921406603d6a2f44$var$assertStringOrUndefined(tenantId, auth.name);
        $921406603d6a2f44$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $921406603d6a2f44$var$assertStringOrUndefined(createdAt, auth.name);
        $921406603d6a2f44$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $921406603d6a2f44$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $921406603d6a2f44$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $921406603d6a2f44$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $921406603d6a2f44$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $921406603d6a2f44$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $921406603d6a2f44$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $921406603d6a2f44$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $921406603d6a2f44$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $921406603d6a2f44$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$instanceCache = new Map();
function $921406603d6a2f44$export$158acd800e1ef08b(cls) {
    $921406603d6a2f44$export$1fbe638ecf81657e(cls instanceof Function, "Expected a class definition");
    let instance = $921406603d6a2f44$var$instanceCache.get(cls);
    if (instance) {
        $921406603d6a2f44$export$1fbe638ecf81657e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $921406603d6a2f44$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$921406603d6a2f44$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $921406603d6a2f44$export$3a6d5c9ae78a2c08 = $921406603d6a2f44$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $921406603d6a2f44$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $921406603d6a2f44$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $921406603d6a2f44$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $921406603d6a2f44$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $921406603d6a2f44$var$PersistenceUserManager($921406603d6a2f44$export$158acd800e1ef08b($921406603d6a2f44$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $921406603d6a2f44$export$158acd800e1ef08b($921406603d6a2f44$export$3a6d5c9ae78a2c08);
        const key = $921406603d6a2f44$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $921406603d6a2f44$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $921406603d6a2f44$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $921406603d6a2f44$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $921406603d6a2f44$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($921406603d6a2f44$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($921406603d6a2f44$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($921406603d6a2f44$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($921406603d6a2f44$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($921406603d6a2f44$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $921406603d6a2f44$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($921406603d6a2f44$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $921406603d6a2f44$var$_isFirefox(ua = (0, $i9zJL.getUA)()) {
    return /firefox\//i.test(ua);
}
function $921406603d6a2f44$var$_isSafari(userAgent = (0, $i9zJL.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $921406603d6a2f44$var$_isChromeIOS(ua = (0, $i9zJL.getUA)()) {
    return /crios\//i.test(ua);
}
function $921406603d6a2f44$var$_isIEMobile(ua = (0, $i9zJL.getUA)()) {
    return /iemobile/i.test(ua);
}
function $921406603d6a2f44$export$92108d983e8ee699(ua = (0, $i9zJL.getUA)()) {
    return /android/i.test(ua);
}
function $921406603d6a2f44$var$_isBlackBerry(ua = (0, $i9zJL.getUA)()) {
    return /blackberry/i.test(ua);
}
function $921406603d6a2f44$var$_isWebOS(ua = (0, $i9zJL.getUA)()) {
    return /webos/i.test(ua);
}
function $921406603d6a2f44$export$d66dc83d8cfc8dd(ua = (0, $i9zJL.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $921406603d6a2f44$export$91c6e00c14e7e6fd(ua = (0, $i9zJL.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $921406603d6a2f44$var$_isIOSStandalone(ua = (0, $i9zJL.getUA)()) {
    var _a;
    return $921406603d6a2f44$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $921406603d6a2f44$var$_isIE10() {
    return (0, $i9zJL.isIE)() && document.documentMode === 10;
}
function $921406603d6a2f44$var$_isMobileBrowser(ua = (0, $i9zJL.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $921406603d6a2f44$export$d66dc83d8cfc8dd(ua) || $921406603d6a2f44$export$92108d983e8ee699(ua) || $921406603d6a2f44$var$_isWebOS(ua) || $921406603d6a2f44$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $921406603d6a2f44$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $921406603d6a2f44$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $921406603d6a2f44$var$_getBrowserName((0, $i9zJL.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$921406603d6a2f44$var$_getBrowserName((0, $i9zJL.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $gc3di.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $921406603d6a2f44$var$_getPasswordPolicy(auth, request = {}) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $921406603d6a2f44$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $921406603d6a2f44$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $921406603d6a2f44$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $921406603d6a2f44$var$Subscription(this);
        this.idTokenSubscription = new $921406603d6a2f44$var$Subscription(this);
        this.beforeStateQueue = new $921406603d6a2f44$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $921406603d6a2f44$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $921406603d6a2f44$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $921406603d6a2f44$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $921406603d6a2f44$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $921406603d6a2f44$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn("FirebaseServerApp could not login user with provided authIdToken: ", err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $gc3di._isFirebaseServerApp)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $921406603d6a2f44$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $921406603d6a2f44$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $921406603d6a2f44$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $gc3di._isFirebaseServerApp)(this.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $i9zJL.getModularInstance)(userExtern) : null;
        if (user) $921406603d6a2f44$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $921406603d6a2f44$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $gc3di._isFirebaseServerApp)(this.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $gc3di._isFirebaseServerApp)(this.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($921406603d6a2f44$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $921406603d6a2f44$var$_getPasswordPolicy(this);
        const passwordPolicy = new $921406603d6a2f44$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $i9zJL.ErrorFactory)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: "apple.com",
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $921406603d6a2f44$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $921406603d6a2f44$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $921406603d6a2f44$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $921406603d6a2f44$var$PersistenceUserManager.create(this, [
                $921406603d6a2f44$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $921406603d6a2f44$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === "function") {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $921406603d6a2f44$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $921406603d6a2f44$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $921406603d6a2f44$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $921406603d6a2f44$export$a05254e7c3aeba6e(auth) {
    return (0, $i9zJL.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class $921406603d6a2f44$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $i9zJL.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        $921406603d6a2f44$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $921406603d6a2f44$var$externalJSProvider = {
    async loadJS () {
        throw new Error("Unable to load external scripts");
    },
    recaptchaV2Script: "",
    recaptchaEnterpriseScript: "",
    gapiScript: ""
};
function $921406603d6a2f44$var$_setExternalJSProvider(p) {
    $921406603d6a2f44$var$externalJSProvider = p;
}
function $921406603d6a2f44$var$_loadJS(url) {
    return $921406603d6a2f44$var$externalJSProvider.loadJS(url);
}
function $921406603d6a2f44$var$_recaptchaV2ScriptUrl() {
    return $921406603d6a2f44$var$externalJSProvider.recaptchaV2Script;
}
function $921406603d6a2f44$var$_recaptchaEnterpriseScriptUrl() {
    return $921406603d6a2f44$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $921406603d6a2f44$var$_gapiScriptUrl() {
    return $921406603d6a2f44$var$externalJSProvider.gapiScript;
}
function $921406603d6a2f44$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $921406603d6a2f44$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $921406603d6a2f44$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $921406603d6a2f44$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $921406603d6a2f44$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $921406603d6a2f44$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $921406603d6a2f44$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $921406603d6a2f44$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($921406603d6a2f44$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($921406603d6a2f44$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $921406603d6a2f44$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    let url = $921406603d6a2f44$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $921406603d6a2f44$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $921406603d6a2f44$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $921406603d6a2f44$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $921406603d6a2f44$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $921406603d6a2f44$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $921406603d6a2f44$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $921406603d6a2f44$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    const response = await $921406603d6a2f44$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $921406603d6a2f44$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $921406603d6a2f44$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $921406603d6a2f44$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $gc3di._getProvider)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $i9zJL.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $921406603d6a2f44$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($921406603d6a2f44$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $921406603d6a2f44$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    $921406603d6a2f44$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $921406603d6a2f44$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $921406603d6a2f44$var$extractProtocol(url);
    const { host: host, port: port } = $921406603d6a2f44$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $921406603d6a2f44$var$emitEmulatorWarning();
}
function $921406603d6a2f44$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $921406603d6a2f44$var$extractHostAndPort(url) {
    const protocol = $921406603d6a2f44$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $921406603d6a2f44$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $921406603d6a2f44$var$parsePort(port)
        };
    }
}
function $921406603d6a2f44$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $921406603d6a2f44$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $921406603d6a2f44$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $921406603d6a2f44$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $921406603d6a2f44$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $921406603d6a2f44$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $921406603d6a2f44$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$resetPassword(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
async function $921406603d6a2f44$var$updateEmailPassword(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $921406603d6a2f44$var$linkEmailPassword(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $921406603d6a2f44$var$applyActionCode$1(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$signInWithPassword(auth, request) {
    return $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
async function $921406603d6a2f44$var$sendOobCode(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
async function $921406603d6a2f44$var$sendEmailVerification$1(auth, request) {
    return $921406603d6a2f44$var$sendOobCode(auth, request);
}
async function $921406603d6a2f44$var$sendPasswordResetEmail$1(auth, request) {
    return $921406603d6a2f44$var$sendOobCode(auth, request);
}
async function $921406603d6a2f44$var$sendSignInLinkToEmail$1(auth, request) {
    return $921406603d6a2f44$var$sendOobCode(auth, request);
}
async function $921406603d6a2f44$var$verifyAndChangeEmail(auth, request) {
    return $921406603d6a2f44$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$signInWithEmailLink$1(auth, request) {
    return $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
async function $921406603d6a2f44$var$signInWithEmailLinkForLinking(auth, request) {
    return $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $921406603d6a2f44$export$3a1a48c8f6ef640e extends $921406603d6a2f44$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $921406603d6a2f44$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $921406603d6a2f44$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $921406603d6a2f44$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $921406603d6a2f44$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $921406603d6a2f44$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $921406603d6a2f44$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $921406603d6a2f44$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $921406603d6a2f44$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$signInWithIdp(auth, request) {
    return $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $921406603d6a2f44$export$a07804094c3ecf2d extends $921406603d6a2f44$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $921406603d6a2f44$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $921406603d6a2f44$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $cgTd8.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $921406603d6a2f44$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $921406603d6a2f44$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $921406603d6a2f44$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $921406603d6a2f44$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $921406603d6a2f44$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $i9zJL.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$sendPhoneVerificationCode(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
async function $921406603d6a2f44$var$signInWithPhoneNumber$1(auth, request) {
    return $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
async function $921406603d6a2f44$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $921406603d6a2f44$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $921406603d6a2f44$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $921406603d6a2f44$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, apiRequest), $921406603d6a2f44$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $921406603d6a2f44$export$3722cfe417b6ed86 extends $921406603d6a2f44$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $921406603d6a2f44$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $921406603d6a2f44$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $921406603d6a2f44$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $921406603d6a2f44$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $921406603d6a2f44$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $921406603d6a2f44$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $921406603d6a2f44$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $921406603d6a2f44$var$parseDeepLink(url) {
    const link = (0, $i9zJL.querystringDecode)((0, $i9zJL.extractQuerystring)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $i9zJL.querystringDecode)((0, $i9zJL.extractQuerystring)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $i9zJL.querystringDecode)((0, $i9zJL.extractQuerystring)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $i9zJL.querystringDecode)((0, $i9zJL.extractQuerystring)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $921406603d6a2f44$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $i9zJL.querystringDecode)((0, $i9zJL.extractQuerystring)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $921406603d6a2f44$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $921406603d6a2f44$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $921406603d6a2f44$var$parseDeepLink(link);
        try {
            return new $921406603d6a2f44$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $921406603d6a2f44$export$3b513254972cfc9c(link) {
    return $921406603d6a2f44$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $921406603d6a2f44$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $921406603d6a2f44$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $921406603d6a2f44$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $921406603d6a2f44$export$f38c853ae54ed474.parseLink(emailLink);
        $921406603d6a2f44$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $921406603d6a2f44$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $921406603d6a2f44$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $921406603d6a2f44$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $921406603d6a2f44$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $921406603d6a2f44$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $921406603d6a2f44$var$BaseOAuthProvider extends $921406603d6a2f44$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $921406603d6a2f44$export$dc98b0b04f4c7758 extends $921406603d6a2f44$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $921406603d6a2f44$export$890c4ad488842ce7("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $921406603d6a2f44$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $921406603d6a2f44$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $921406603d6a2f44$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $921406603d6a2f44$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $921406603d6a2f44$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $921406603d6a2f44$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $921406603d6a2f44$export$71cec2538cb2c617 extends $921406603d6a2f44$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $921406603d6a2f44$export$a07804094c3ecf2d._fromParams({
            providerId: $921406603d6a2f44$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $921406603d6a2f44$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $921406603d6a2f44$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $921406603d6a2f44$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $921406603d6a2f44$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $921406603d6a2f44$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $921406603d6a2f44$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $921406603d6a2f44$export$78acf4525d8a74c4 extends $921406603d6a2f44$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $921406603d6a2f44$export$a07804094c3ecf2d._fromParams({
            providerId: $921406603d6a2f44$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $921406603d6a2f44$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $921406603d6a2f44$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $921406603d6a2f44$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $921406603d6a2f44$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $921406603d6a2f44$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $921406603d6a2f44$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $921406603d6a2f44$export$8743009a87fcb00f extends $921406603d6a2f44$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $921406603d6a2f44$export$a07804094c3ecf2d._fromParams({
            providerId: $921406603d6a2f44$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $921406603d6a2f44$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $921406603d6a2f44$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $921406603d6a2f44$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $921406603d6a2f44$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $921406603d6a2f44$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $921406603d6a2f44$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $921406603d6a2f44$export$f96d196f7728bb5 extends $921406603d6a2f44$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $921406603d6a2f44$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $921406603d6a2f44$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $921406603d6a2f44$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $921406603d6a2f44$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $921406603d6a2f44$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $921406603d6a2f44$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $921406603d6a2f44$export$71511d61b312f219 extends $921406603d6a2f44$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $921406603d6a2f44$export$890c4ad488842ce7(providerId.startsWith($921406603d6a2f44$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $921406603d6a2f44$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $921406603d6a2f44$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $921406603d6a2f44$export$f96d196f7728bb5.fromJSON(json);
        $921406603d6a2f44$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $921406603d6a2f44$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $921406603d6a2f44$export$3d8c2f653ac9d0b9 extends $921406603d6a2f44$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $921406603d6a2f44$export$a07804094c3ecf2d._fromParams({
            providerId: $921406603d6a2f44$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $921406603d6a2f44$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $921406603d6a2f44$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $921406603d6a2f44$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $921406603d6a2f44$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $921406603d6a2f44$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $921406603d6a2f44$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$signUp(auth, request) {
    return $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $921406603d6a2f44$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $921406603d6a2f44$var$providerIdForResponse(idTokenResponse);
        const userCred = new $921406603d6a2f44$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $921406603d6a2f44$var$providerIdForResponse(response);
        return new $921406603d6a2f44$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $921406603d6a2f44$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $921406603d6a2f44$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $921406603d6a2f44$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $921406603d6a2f44$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $921406603d6a2f44$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$MultiFactorError extends (0, $i9zJL.FirebaseError) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $921406603d6a2f44$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $921406603d6a2f44$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $921406603d6a2f44$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $921406603d6a2f44$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $921406603d6a2f44$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $921406603d6a2f44$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    await $921406603d6a2f44$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $921406603d6a2f44$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $921406603d6a2f44$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $921406603d6a2f44$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $921406603d6a2f44$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $921406603d6a2f44$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $921406603d6a2f44$var$_assertLinkedStatus(expected, user, provider) {
    await $921406603d6a2f44$var$_reloadWithoutSaving(user);
    const providerIds = $921406603d6a2f44$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $921406603d6a2f44$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $921406603d6a2f44$var$_logoutIfInvalidated(user, $921406603d6a2f44$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $921406603d6a2f44$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $921406603d6a2f44$var$_parseToken(response.idToken);
        $921406603d6a2f44$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $921406603d6a2f44$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $921406603d6a2f44$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $921406603d6a2f44$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $921406603d6a2f44$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $921406603d6a2f44$export$3c2fa207a37baaea(auth, credential) {
    return $921406603d6a2f44$var$_signInWithCredential($921406603d6a2f44$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $921406603d6a2f44$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    await $921406603d6a2f44$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $921406603d6a2f44$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $921406603d6a2f44$export$6559d589eb85fbb6(user, credential) {
    return $921406603d6a2f44$var$_reauthenticate((0, $i9zJL.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$signInWithCustomToken$1(auth, request) {
    return $921406603d6a2f44$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $921406603d6a2f44$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    const response = await $921406603d6a2f44$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $921406603d6a2f44$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $921406603d6a2f44$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $921406603d6a2f44$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $921406603d6a2f44$var$PhoneMultiFactorInfoImpl extends $921406603d6a2f44$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $921406603d6a2f44$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $921406603d6a2f44$var$TotpMultiFactorInfoImpl extends $921406603d6a2f44$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $921406603d6a2f44$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $921406603d6a2f44$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $921406603d6a2f44$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $921406603d6a2f44$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $921406603d6a2f44$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $921406603d6a2f44$var$recachePasswordPolicy(auth) {
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $921406603d6a2f44$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $921406603d6a2f44$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $921406603d6a2f44$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $921406603d6a2f44$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $921406603d6a2f44$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $921406603d6a2f44$var$resetPassword((0, $i9zJL.getModularInstance)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $921406603d6a2f44$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $921406603d6a2f44$export$a93c5207d687da10(auth, oobCode) {
    await $921406603d6a2f44$var$applyActionCode$1((0, $i9zJL.getModularInstance)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $921406603d6a2f44$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $i9zJL.getModularInstance)(auth);
    const response = await $921406603d6a2f44$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $921406603d6a2f44$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $921406603d6a2f44$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $921406603d6a2f44$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $921406603d6a2f44$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $921406603d6a2f44$var$MultiFactorInfoImpl._fromServerResponse($921406603d6a2f44$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $921406603d6a2f44$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $921406603d6a2f44$export$c3950d9923825c02((0, $i9zJL.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $921406603d6a2f44$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $921406603d6a2f44$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $921406603d6a2f44$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $921406603d6a2f44$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $921406603d6a2f44$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $921406603d6a2f44$export$555508cbc6add439(auth, email, password) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $921406603d6a2f44$export$3c2fa207a37baaea((0, $i9zJL.getModularInstance)(auth), $921406603d6a2f44$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $921406603d6a2f44$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $921406603d6a2f44$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $921406603d6a2f44$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $921406603d6a2f44$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $921406603d6a2f44$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $921406603d6a2f44$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $921406603d6a2f44$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $921406603d6a2f44$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $921406603d6a2f44$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $i9zJL.getModularInstance)(auth);
    const credential = $921406603d6a2f44$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $921406603d6a2f44$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $921406603d6a2f44$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $921406603d6a2f44$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$createAuthUri(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $921406603d6a2f44$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $921406603d6a2f44$var$_isHttpOrHttps() ? $921406603d6a2f44$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $921406603d6a2f44$var$createAuthUri((0, $i9zJL.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $921406603d6a2f44$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $921406603d6a2f44$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $921406603d6a2f44$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $921406603d6a2f44$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $921406603d6a2f44$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $921406603d6a2f44$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$var$updateProfile$1(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $921406603d6a2f44$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $921406603d6a2f44$var$_logoutIfInvalidated(userInternal, $921406603d6a2f44$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $921406603d6a2f44$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    if ((0, $gc3di._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $921406603d6a2f44$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $921406603d6a2f44$export$1a82df3d29112e01(user, newPassword) {
    return $921406603d6a2f44$var$updateEmailOrPassword((0, $i9zJL.getModularInstance)(user), null, newPassword);
}
async function $921406603d6a2f44$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $921406603d6a2f44$var$_logoutIfInvalidated(user, $921406603d6a2f44$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $921406603d6a2f44$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $921406603d6a2f44$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $921406603d6a2f44$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $921406603d6a2f44$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $921406603d6a2f44$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $921406603d6a2f44$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $921406603d6a2f44$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $921406603d6a2f44$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $921406603d6a2f44$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $921406603d6a2f44$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $921406603d6a2f44$var$FederatedAdditionalUserInfoWithUsername extends $921406603d6a2f44$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $921406603d6a2f44$var$FacebookAdditionalUserInfo extends $921406603d6a2f44$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $921406603d6a2f44$var$GithubAdditionalUserInfo extends $921406603d6a2f44$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $921406603d6a2f44$var$GoogleAdditionalUserInfo extends $921406603d6a2f44$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $921406603d6a2f44$var$TwitterAdditionalUserInfo extends $921406603d6a2f44$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $921406603d6a2f44$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $921406603d6a2f44$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $921406603d6a2f44$export$9e5f44173e64f162(auth, persistence) {
    return (0, $i9zJL.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $921406603d6a2f44$export$625550452a3fa3ec(auth) {
    return $921406603d6a2f44$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $921406603d6a2f44$export$90a7f3efeed30595(auth, password) {
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $921406603d6a2f44$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $i9zJL.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $921406603d6a2f44$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $i9zJL.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $921406603d6a2f44$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $i9zJL.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $921406603d6a2f44$export$df995fae86a55f06(auth) {
    (0, $i9zJL.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $921406603d6a2f44$export$ef35774e6d314e91(auth, user) {
    return (0, $i9zJL.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $921406603d6a2f44$export$e7094788287c5e9b(auth) {
    return (0, $i9zJL.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $921406603d6a2f44$export$96f57966bedc81b4(auth, token) {
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $921406603d6a2f44$export$a9c23c6ac3fc3eca(user) {
    return (0, $i9zJL.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $921406603d6a2f44$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $921406603d6a2f44$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $921406603d6a2f44$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $921406603d6a2f44$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $921406603d6a2f44$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$921406603d6a2f44$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $921406603d6a2f44$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $921406603d6a2f44$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $921406603d6a2f44$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $921406603d6a2f44$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $921406603d6a2f44$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $921406603d6a2f44$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $921406603d6a2f44$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $i9zJL.getModularInstance)(auth);
    const errorInternal = error;
    $921406603d6a2f44$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $921406603d6a2f44$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $921406603d6a2f44$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$startEnrollPhoneMfa(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
function $921406603d6a2f44$var$finalizeEnrollPhoneMfa(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
function $921406603d6a2f44$var$startEnrollTotpMfa(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
function $921406603d6a2f44$var$finalizeEnrollTotpMfa(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
function $921406603d6a2f44$var$withdrawMfa(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
class $921406603d6a2f44$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$921406603d6a2f44$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $921406603d6a2f44$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $921406603d6a2f44$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $921406603d6a2f44$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $921406603d6a2f44$var$_logoutIfInvalidated(this.user, $921406603d6a2f44$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $921406603d6a2f44$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $921406603d6a2f44$export$493d36ec626b6698(user) {
    const userModular = (0, $i9zJL.getModularInstance)(user);
    if (!$921406603d6a2f44$var$multiFactorUserCache.has(userModular)) $921406603d6a2f44$var$multiFactorUserCache.set(userModular, $921406603d6a2f44$var$MultiFactorUserImpl._fromUser(userModular));
    return $921406603d6a2f44$var$multiFactorUserCache.get(userModular);
}
const $921406603d6a2f44$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $921406603d6a2f44$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($921406603d6a2f44$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($921406603d6a2f44$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $921406603d6a2f44$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $921406603d6a2f44$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $921406603d6a2f44$var$BrowserLocalPersistence extends $921406603d6a2f44$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $921406603d6a2f44$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($921406603d6a2f44$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $921406603d6a2f44$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $921406603d6a2f44$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$921406603d6a2f44$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $921406603d6a2f44$export$8b22cf2602fb60ce = $921406603d6a2f44$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$BrowserSessionPersistence extends $921406603d6a2f44$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$921406603d6a2f44$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $921406603d6a2f44$export$407448d2b89b1813 = $921406603d6a2f44$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $921406603d6a2f44$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $921406603d6a2f44$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $921406603d6a2f44$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $921406603d6a2f44$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$921406603d6a2f44$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$export$faec65b429be379(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $921406603d6a2f44$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $921406603d6a2f44$export$faec65b429be379("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $921406603d6a2f44$var$_window() {
    return window;
}
function $921406603d6a2f44$var$_setWindowLocation(url) {
    $921406603d6a2f44$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$_isWorker() {
    return typeof $921406603d6a2f44$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $921406603d6a2f44$var$_window()["importScripts"] === "function";
}
async function $921406603d6a2f44$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $921406603d6a2f44$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $921406603d6a2f44$var$_getWorkerGlobalScope() {
    return $921406603d6a2f44$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$DB_NAME = "firebaseLocalStorageDb";
const $921406603d6a2f44$var$DB_VERSION = 1;
const $921406603d6a2f44$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $921406603d6a2f44$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $921406603d6a2f44$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $921406603d6a2f44$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $921406603d6a2f44$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($921406603d6a2f44$var$DB_OBJECTSTORE_NAME);
}
function $921406603d6a2f44$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($921406603d6a2f44$var$DB_NAME);
    return new $921406603d6a2f44$var$DBPromise(request).toPromise();
}
function $921406603d6a2f44$var$_openDatabase() {
    const request = indexedDB.open($921406603d6a2f44$var$DB_NAME, $921406603d6a2f44$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($921406603d6a2f44$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $921406603d6a2f44$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($921406603d6a2f44$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $921406603d6a2f44$var$_deleteDatabase();
                resolve(await $921406603d6a2f44$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $921406603d6a2f44$var$_putObject(db, key, value) {
    const request = $921406603d6a2f44$var$getObjectStore(db, true).put({
        [$921406603d6a2f44$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $921406603d6a2f44$var$DBPromise(request).toPromise();
}
async function $921406603d6a2f44$var$getObject(db, key) {
    const request = $921406603d6a2f44$var$getObjectStore(db, false).get(key);
    const data = await new $921406603d6a2f44$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $921406603d6a2f44$var$_deleteObject(db, key) {
    const request = $921406603d6a2f44$var$getObjectStore(db, true).delete(key);
    return new $921406603d6a2f44$var$DBPromise(request).toPromise();
}
const $921406603d6a2f44$var$_POLLING_INTERVAL_MS = 800;
const $921406603d6a2f44$var$_TRANSACTION_RETRY_COUNT = 3;
class $921406603d6a2f44$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $921406603d6a2f44$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $921406603d6a2f44$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $921406603d6a2f44$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $921406603d6a2f44$var$Receiver._getInstance($921406603d6a2f44$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $921406603d6a2f44$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $921406603d6a2f44$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $921406603d6a2f44$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $921406603d6a2f44$var$_openDatabase();
            await $921406603d6a2f44$var$_putObject(db, $921406603d6a2f44$var$STORAGE_AVAILABLE_KEY, "1");
            await $921406603d6a2f44$var$_deleteObject(db, $921406603d6a2f44$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$921406603d6a2f44$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$921406603d6a2f44$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$921406603d6a2f44$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $921406603d6a2f44$var$getObjectStore(db, false).getAll();
            return new $921406603d6a2f44$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $921406603d6a2f44$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$921406603d6a2f44$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $921406603d6a2f44$export$23f2a1d2818174ef = $921406603d6a2f44$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$startSignInPhoneMfa(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
function $921406603d6a2f44$var$finalizeSignInPhoneMfa(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
function $921406603d6a2f44$var$finalizeSignInTotpMfa(auth, request) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $921406603d6a2f44$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$_SOLVE_TIME_MS = 500;
const $921406603d6a2f44$var$_EXPIRATION_TIME_MS = 60000;
const $921406603d6a2f44$var$_WIDGET_ID_START = 1000000000000;
class $921406603d6a2f44$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $921406603d6a2f44$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $921406603d6a2f44$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $921406603d6a2f44$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $921406603d6a2f44$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $921406603d6a2f44$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $921406603d6a2f44$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $921406603d6a2f44$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $921406603d6a2f44$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $921406603d6a2f44$var$_EXPIRATION_TIME_MS);
        }, $921406603d6a2f44$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $921406603d6a2f44$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $921406603d6a2f44$var$_JSLOAD_CALLBACK = $921406603d6a2f44$var$_generateCallbackName("rcb");
const $921406603d6a2f44$var$NETWORK_TIMEOUT_DELAY = new $921406603d6a2f44$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $921406603d6a2f44$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $921406603d6a2f44$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $921406603d6a2f44$export$890c4ad488842ce7($921406603d6a2f44$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $921406603d6a2f44$var$isV2($921406603d6a2f44$var$_window().grecaptcha)) return Promise.resolve($921406603d6a2f44$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $921406603d6a2f44$var$_window().setTimeout(()=>{
                reject($921406603d6a2f44$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $921406603d6a2f44$var$NETWORK_TIMEOUT_DELAY.get());
            $921406603d6a2f44$var$_window()[$921406603d6a2f44$var$_JSLOAD_CALLBACK] = ()=>{
                $921406603d6a2f44$var$_window().clearTimeout(networkTimeout);
                delete $921406603d6a2f44$var$_window()[$921406603d6a2f44$var$_JSLOAD_CALLBACK];
                const recaptcha = $921406603d6a2f44$var$_window().grecaptcha;
                if (!recaptcha || !$921406603d6a2f44$var$isV2(recaptcha)) {
                    reject($921406603d6a2f44$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$921406603d6a2f44$var$_recaptchaV2ScriptUrl()}?${(0, $i9zJL.querystring)({
                onload: $921406603d6a2f44$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $921406603d6a2f44$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($921406603d6a2f44$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $921406603d6a2f44$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $921406603d6a2f44$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $921406603d6a2f44$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $921406603d6a2f44$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $921406603d6a2f44$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $921406603d6a2f44$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $921406603d6a2f44$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $921406603d6a2f44$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $921406603d6a2f44$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $921406603d6a2f44$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $921406603d6a2f44$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $921406603d6a2f44$var$MockReCaptchaLoaderImpl() : new $921406603d6a2f44$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $921406603d6a2f44$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $921406603d6a2f44$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $921406603d6a2f44$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $921406603d6a2f44$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $921406603d6a2f44$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $921406603d6a2f44$export$890c4ad488842ce7($921406603d6a2f44$var$_isHttpOrHttps() && !$921406603d6a2f44$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $921406603d6a2f44$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $921406603d6a2f44$var$getRecaptchaParams(this.auth);
        $921406603d6a2f44$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $921406603d6a2f44$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $921406603d6a2f44$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $921406603d6a2f44$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $921406603d6a2f44$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    const verificationId = await $921406603d6a2f44$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $i9zJL.getModularInstance)(appVerifier));
    return new $921406603d6a2f44$var$ConfirmationResultImpl(verificationId, (cred)=>$921406603d6a2f44$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $921406603d6a2f44$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    await $921406603d6a2f44$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $921406603d6a2f44$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $i9zJL.getModularInstance)(appVerifier));
    return new $921406603d6a2f44$var$ConfirmationResultImpl(verificationId, (cred)=>$921406603d6a2f44$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $921406603d6a2f44$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    if ((0, $gc3di._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $921406603d6a2f44$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $i9zJL.getModularInstance)(appVerifier));
    return new $921406603d6a2f44$var$ConfirmationResultImpl(verificationId, (cred)=>$921406603d6a2f44$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $921406603d6a2f44$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $921406603d6a2f44$export$890c4ad488842ce7(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $921406603d6a2f44$export$890c4ad488842ce7(verifier.type === $921406603d6a2f44$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $921406603d6a2f44$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $921406603d6a2f44$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $921406603d6a2f44$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $921406603d6a2f44$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $921406603d6a2f44$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $921406603d6a2f44$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $921406603d6a2f44$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    if ((0, $gc3di._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $921406603d6a2f44$var$_link$1(userInternal, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $921406603d6a2f44$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $921406603d6a2f44$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $921406603d6a2f44$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $i9zJL.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $921406603d6a2f44$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $921406603d6a2f44$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $921406603d6a2f44$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $921406603d6a2f44$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $921406603d6a2f44$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $921406603d6a2f44$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $921406603d6a2f44$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $921406603d6a2f44$export$158acd800e1ef08b(resolverOverride);
    $921406603d6a2f44$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$IdpCredential extends $921406603d6a2f44$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $921406603d6a2f44$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $921406603d6a2f44$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $921406603d6a2f44$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $921406603d6a2f44$var$_signIn(params) {
    return $921406603d6a2f44$var$_signInWithCredential(params.auth, new $921406603d6a2f44$var$IdpCredential(params), params.bypassAuthState);
}
function $921406603d6a2f44$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $921406603d6a2f44$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $921406603d6a2f44$var$_reauthenticate(user, new $921406603d6a2f44$var$IdpCredential(params), params.bypassAuthState);
}
async function $921406603d6a2f44$var$_link(params) {
    const { auth: auth, user: user } = params;
    $921406603d6a2f44$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $921406603d6a2f44$var$_link$1(user, new $921406603d6a2f44$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $921406603d6a2f44$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $921406603d6a2f44$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $921406603d6a2f44$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $921406603d6a2f44$var$_reauth;
            default:
                $921406603d6a2f44$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $921406603d6a2f44$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $921406603d6a2f44$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $921406603d6a2f44$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $921406603d6a2f44$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    $921406603d6a2f44$var$_assertInstanceOf(auth, provider, $921406603d6a2f44$var$FederatedAuthProvider);
    const resolverInternal = $921406603d6a2f44$var$_withDefaultResolver(authInternal, resolver);
    const action = new $921406603d6a2f44$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $921406603d6a2f44$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    if ((0, $gc3di._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($921406603d6a2f44$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $921406603d6a2f44$var$_assertInstanceOf(userInternal.auth, provider, $921406603d6a2f44$var$FederatedAuthProvider);
    const resolverInternal = $921406603d6a2f44$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $921406603d6a2f44$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $921406603d6a2f44$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    $921406603d6a2f44$var$_assertInstanceOf(userInternal.auth, provider, $921406603d6a2f44$var$FederatedAuthProvider);
    const resolverInternal = $921406603d6a2f44$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $921406603d6a2f44$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $921406603d6a2f44$var$PopupOperation extends $921406603d6a2f44$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($921406603d6a2f44$var$PopupOperation.currentPopupAction) $921406603d6a2f44$var$PopupOperation.currentPopupAction.cancel();
        $921406603d6a2f44$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $921406603d6a2f44$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $921406603d6a2f44$export$1fbe638ecf81657e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $921406603d6a2f44$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($921406603d6a2f44$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($921406603d6a2f44$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $921406603d6a2f44$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($921406603d6a2f44$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $921406603d6a2f44$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$921406603d6a2f44$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $921406603d6a2f44$var$redirectOutcomeMap = new Map();
class $921406603d6a2f44$var$RedirectAction extends $921406603d6a2f44$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $921406603d6a2f44$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $921406603d6a2f44$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $921406603d6a2f44$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $921406603d6a2f44$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $921406603d6a2f44$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $921406603d6a2f44$var$pendingRedirectKey(auth);
    const persistence = $921406603d6a2f44$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $921406603d6a2f44$var$_setPendingRedirectStatus(resolver, auth) {
    return $921406603d6a2f44$var$resolverPersistence(resolver)._set($921406603d6a2f44$var$pendingRedirectKey(auth), "true");
}
function $921406603d6a2f44$export$b9a6b53f9be3734() {
    $921406603d6a2f44$var$redirectOutcomeMap.clear();
}
function $921406603d6a2f44$export$a33b77bbdbb8366c(auth, result) {
    $921406603d6a2f44$var$redirectOutcomeMap.set(auth._key(), result);
}
function $921406603d6a2f44$var$resolverPersistence(resolver) {
    return $921406603d6a2f44$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $921406603d6a2f44$var$pendingRedirectKey(auth) {
    return $921406603d6a2f44$export$cf2f7c5792f80b46($921406603d6a2f44$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $921406603d6a2f44$export$2d1720544b23b823(auth, provider, resolver) {
    return $921406603d6a2f44$var$_signInWithRedirect(auth, provider, resolver);
}
async function $921406603d6a2f44$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    $921406603d6a2f44$var$_assertInstanceOf(auth, provider, $921406603d6a2f44$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $921406603d6a2f44$var$_withDefaultResolver(authInternal, resolver);
    await $921406603d6a2f44$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $921406603d6a2f44$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $921406603d6a2f44$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $921406603d6a2f44$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    $921406603d6a2f44$var$_assertInstanceOf(userInternal.auth, provider, $921406603d6a2f44$var$FederatedAuthProvider);
    if ((0, $gc3di._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $921406603d6a2f44$var$_withDefaultResolver(userInternal.auth, resolver);
    await $921406603d6a2f44$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $921406603d6a2f44$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $921406603d6a2f44$export$39b482c5e57630a8(user, provider, resolver) {
    return $921406603d6a2f44$var$_linkWithRedirect(user, provider, resolver);
}
async function $921406603d6a2f44$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $i9zJL.getModularInstance)(user);
    $921406603d6a2f44$var$_assertInstanceOf(userInternal.auth, provider, $921406603d6a2f44$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $921406603d6a2f44$var$_withDefaultResolver(userInternal.auth, resolver);
    await $921406603d6a2f44$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $921406603d6a2f44$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $921406603d6a2f44$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $921406603d6a2f44$export$35e795649ee09318(auth, resolver) {
    await $921406603d6a2f44$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $921406603d6a2f44$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $921406603d6a2f44$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $gc3di._isFirebaseServerApp)(auth.app)) return Promise.reject($921406603d6a2f44$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $921406603d6a2f44$export$a05254e7c3aeba6e(auth);
    const resolver = $921406603d6a2f44$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $921406603d6a2f44$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $921406603d6a2f44$var$prepareUserForRedirect(user) {
    const eventId = $921406603d6a2f44$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $921406603d6a2f44$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $921406603d6a2f44$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$921406603d6a2f44$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$921406603d6a2f44$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($921406603d6a2f44$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $921406603d6a2f44$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($921406603d6a2f44$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($921406603d6a2f44$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $921406603d6a2f44$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $921406603d6a2f44$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $921406603d6a2f44$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $921406603d6a2f44$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $921406603d6a2f44$export$3d12bd131bb975d1(auth, request = {}) {
    return $921406603d6a2f44$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $921406603d6a2f44$var$HTTP_REGEX = /^https?/;
async function $921406603d6a2f44$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $921406603d6a2f44$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($921406603d6a2f44$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $921406603d6a2f44$var$matchDomain(expected) {
    const currentUrl = $921406603d6a2f44$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$921406603d6a2f44$var$HTTP_REGEX.test(protocol)) return false;
    if ($921406603d6a2f44$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$NETWORK_TIMEOUT = new $921406603d6a2f44$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $921406603d6a2f44$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $921406603d6a2f44$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $921406603d6a2f44$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $921406603d6a2f44$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $921406603d6a2f44$var$resetUnloadedGapiModules();
                    reject($921406603d6a2f44$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $921406603d6a2f44$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $921406603d6a2f44$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $921406603d6a2f44$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $921406603d6a2f44$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $921406603d6a2f44$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($921406603d6a2f44$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $921406603d6a2f44$var$_loadJS(`${$921406603d6a2f44$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $921406603d6a2f44$var$cachedGApiLoader = null;
        throw error;
    });
}
let $921406603d6a2f44$var$cachedGApiLoader = null;
function $921406603d6a2f44$var$_loadGapi(auth) {
    $921406603d6a2f44$var$cachedGApiLoader = $921406603d6a2f44$var$cachedGApiLoader || $921406603d6a2f44$var$loadGapi(auth);
    return $921406603d6a2f44$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$PING_TIMEOUT = new $921406603d6a2f44$var$Delay(5000, 15000);
const $921406603d6a2f44$var$IFRAME_PATH = "__/auth/iframe";
const $921406603d6a2f44$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $921406603d6a2f44$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $921406603d6a2f44$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $921406603d6a2f44$var$getIframeUrl(auth) {
    const config = auth.config;
    $921406603d6a2f44$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $921406603d6a2f44$var$_emulatorUrl(config, $921406603d6a2f44$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$921406603d6a2f44$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $gc3di.SDK_VERSION)
    };
    const eid = $921406603d6a2f44$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $i9zJL.querystring)(params).slice(1)}`;
}
async function $921406603d6a2f44$var$_openIframe(auth) {
    const context = await $921406603d6a2f44$var$_loadGapi(auth);
    const gapi1 = $921406603d6a2f44$var$_window().gapi;
    $921406603d6a2f44$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $921406603d6a2f44$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $921406603d6a2f44$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $921406603d6a2f44$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $921406603d6a2f44$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $921406603d6a2f44$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $921406603d6a2f44$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $921406603d6a2f44$var$DEFAULT_WIDTH = 500;
const $921406603d6a2f44$var$DEFAULT_HEIGHT = 600;
const $921406603d6a2f44$var$TARGET_BLANK = "_blank";
const $921406603d6a2f44$var$FIREFOX_EMPTY_URL = "http://localhost";
class $921406603d6a2f44$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $921406603d6a2f44$var$_open(auth, url, name, width = $921406603d6a2f44$var$DEFAULT_WIDTH, height = $921406603d6a2f44$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $921406603d6a2f44$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $i9zJL.getUA)().toLowerCase();
    if (name) target = $921406603d6a2f44$var$_isChromeIOS(ua) ? $921406603d6a2f44$var$TARGET_BLANK : name;
    if ($921406603d6a2f44$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $921406603d6a2f44$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($921406603d6a2f44$var$_isIOSStandalone(ua) && target !== "_self") {
        $921406603d6a2f44$var$openAsNewWindowIOS(url || "", target);
        return new $921406603d6a2f44$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $921406603d6a2f44$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $921406603d6a2f44$export$c03999cb2f36933f(newWin);
}
function $921406603d6a2f44$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $921406603d6a2f44$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $921406603d6a2f44$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $921406603d6a2f44$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $921406603d6a2f44$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $921406603d6a2f44$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $921406603d6a2f44$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $gc3di.SDK_VERSION),
        eventId: eventId
    };
    if (provider instanceof $921406603d6a2f44$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $i9zJL.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $921406603d6a2f44$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$921406603d6a2f44$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$921406603d6a2f44$var$getHandlerBase(auth)}?${(0, $i9zJL.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $921406603d6a2f44$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$921406603d6a2f44$var$WIDGET_PATH}`;
    return $921406603d6a2f44$var$_emulatorUrl(config, $921406603d6a2f44$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $921406603d6a2f44$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $921406603d6a2f44$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $921406603d6a2f44$export$407448d2b89b1813;
        this._completeRedirectFn = $921406603d6a2f44$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $921406603d6a2f44$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $921406603d6a2f44$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $921406603d6a2f44$export$28f7fcd39efa255(auth, provider, authType, $921406603d6a2f44$var$_getCurrentUrl(), eventId);
        return $921406603d6a2f44$var$_open(auth, url, $921406603d6a2f44$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $921406603d6a2f44$export$28f7fcd39efa255(auth, provider, authType, $921406603d6a2f44$var$_getCurrentUrl(), eventId);
        $921406603d6a2f44$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $921406603d6a2f44$export$1fbe638ecf81657e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $921406603d6a2f44$var$_openIframe(auth);
        const manager = new $921406603d6a2f44$export$24baa2b76016ce0e(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $921406603d6a2f44$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($921406603d6a2f44$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $921406603d6a2f44$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$921406603d6a2f44$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $921406603d6a2f44$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $921406603d6a2f44$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $921406603d6a2f44$var$_isMobileBrowser() || $921406603d6a2f44$var$_isSafari() || $921406603d6a2f44$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $921406603d6a2f44$export$342063e11d6c3cad = $921406603d6a2f44$var$BrowserPopupRedirectResolver;
class $921406603d6a2f44$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $921406603d6a2f44$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $921406603d6a2f44$var$PhoneMultiFactorAssertionImpl extends $921406603d6a2f44$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $921406603d6a2f44$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $921406603d6a2f44$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $921406603d6a2f44$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $921406603d6a2f44$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $921406603d6a2f44$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $921406603d6a2f44$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $921406603d6a2f44$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $921406603d6a2f44$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $921406603d6a2f44$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $921406603d6a2f44$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $921406603d6a2f44$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $921406603d6a2f44$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $921406603d6a2f44$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $921406603d6a2f44$var$TotpMultiFactorAssertionImpl extends $921406603d6a2f44$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $921406603d6a2f44$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $921406603d6a2f44$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $921406603d6a2f44$export$890c4ad488842ce7(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $921406603d6a2f44$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $921406603d6a2f44$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $921406603d6a2f44$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $921406603d6a2f44$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $921406603d6a2f44$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($921406603d6a2f44$var$_isEmptyString(accountName) || $921406603d6a2f44$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($921406603d6a2f44$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($921406603d6a2f44$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $921406603d6a2f44$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $921406603d6a2f44$var$name = "@firebase/auth";
var $921406603d6a2f44$var$version = "1.7.9";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $921406603d6a2f44$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $921406603d6a2f44$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $921406603d6a2f44$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return "web-extension";
        default:
            return undefined;
    }
}
/** @internal */ function $921406603d6a2f44$var$registerAuth(clientPlatform) {
    (0, $gc3di._registerComponent)(new (0, $6DAV2.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $921406603d6a2f44$export$890c4ad488842ce7(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $921406603d6a2f44$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $921406603d6a2f44$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $921406603d6a2f44$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $gc3di._registerComponent)(new (0, $6DAV2.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $921406603d6a2f44$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $921406603d6a2f44$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $gc3di.registerVersion)($921406603d6a2f44$var$name, $921406603d6a2f44$var$version, $921406603d6a2f44$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $gc3di.registerVersion)($921406603d6a2f44$var$name, $921406603d6a2f44$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $921406603d6a2f44$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $921406603d6a2f44$var$authIdTokenMaxAge = (0, $i9zJL.getExperimentalSetting)("authIdTokenMaxAge") || $921406603d6a2f44$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $921406603d6a2f44$var$lastPostedIdToken = null;
const $921406603d6a2f44$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $921406603d6a2f44$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($921406603d6a2f44$var$lastPostedIdToken === idToken) return;
        $921406603d6a2f44$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $921406603d6a2f44$export$ae1af26003f05816(app = (0, $gc3di.getApp)()) {
    const provider = (0, $gc3di._getProvider)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $921406603d6a2f44$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $921406603d6a2f44$export$342063e11d6c3cad,
        persistence: [
            $921406603d6a2f44$export$23f2a1d2818174ef,
            $921406603d6a2f44$export$8b22cf2602fb60ce,
            $921406603d6a2f44$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $i9zJL.getExperimentalSetting)("authTokenSyncURL");
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === "boolean" && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $921406603d6a2f44$var$mintCookieFactory(authTokenSyncUrl.toString());
            $921406603d6a2f44$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $921406603d6a2f44$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $i9zJL.getDefaultEmulatorHost)("auth");
    if (authEmulatorHost) $921406603d6a2f44$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $921406603d6a2f44$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$921406603d6a2f44$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement("script");
            el.setAttribute("src", url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $921406603d6a2f44$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = "text/javascript";
            el.charset = "UTF-8";
            $921406603d6a2f44$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: "https://apis.google.com/js/api.js",
    recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
    recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
$921406603d6a2f44$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );

});
parcelRegister("gc3di", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $bca04276e8783580$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $bca04276e8783580$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_isFirebaseServerApp", function () { return $bca04276e8783580$export$643c8bc6c389f34e; });
$parcel$export(module.exports, "registerVersion", function () { return $bca04276e8783580$export$d29d5299a7137abc; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $bca04276e8783580$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $bca04276e8783580$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $bca04276e8783580$export$f9962582c9e66d99; });
$parcel$export(module.exports, "getApps", function () { return $bca04276e8783580$export$68ddedf7d44b3bdf; });

var $6DAV2 = parcelRequire("6DAV2");

var $dQajh = parcelRequire("dQajh");

var $i9zJL = parcelRequire("i9zJL");

var $hnGkz = parcelRequire("hnGkz");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $bca04276e8783580$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($bca04276e8783580$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $bca04276e8783580$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $bca04276e8783580$var$name$q = "@firebase/app";
const $bca04276e8783580$var$version$1 = "0.10.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $bca04276e8783580$var$logger = new (0, $dQajh.Logger)("@firebase/app");
const $bca04276e8783580$var$name$p = "@firebase/app-compat";
const $bca04276e8783580$var$name$o = "@firebase/analytics-compat";
const $bca04276e8783580$var$name$n = "@firebase/analytics";
const $bca04276e8783580$var$name$m = "@firebase/app-check-compat";
const $bca04276e8783580$var$name$l = "@firebase/app-check";
const $bca04276e8783580$var$name$k = "@firebase/auth";
const $bca04276e8783580$var$name$j = "@firebase/auth-compat";
const $bca04276e8783580$var$name$i = "@firebase/database";
const $bca04276e8783580$var$name$h = "@firebase/data-connect";
const $bca04276e8783580$var$name$g = "@firebase/database-compat";
const $bca04276e8783580$var$name$f = "@firebase/functions";
const $bca04276e8783580$var$name$e = "@firebase/functions-compat";
const $bca04276e8783580$var$name$d = "@firebase/installations";
const $bca04276e8783580$var$name$c = "@firebase/installations-compat";
const $bca04276e8783580$var$name$b = "@firebase/messaging";
const $bca04276e8783580$var$name$a = "@firebase/messaging-compat";
const $bca04276e8783580$var$name$9 = "@firebase/performance";
const $bca04276e8783580$var$name$8 = "@firebase/performance-compat";
const $bca04276e8783580$var$name$7 = "@firebase/remote-config";
const $bca04276e8783580$var$name$6 = "@firebase/remote-config-compat";
const $bca04276e8783580$var$name$5 = "@firebase/storage";
const $bca04276e8783580$var$name$4 = "@firebase/storage-compat";
const $bca04276e8783580$var$name$3 = "@firebase/firestore";
const $bca04276e8783580$var$name$2 = "@firebase/vertexai-preview";
const $bca04276e8783580$var$name$1 = "@firebase/firestore-compat";
const $bca04276e8783580$var$name = "firebase";
const $bca04276e8783580$var$version = "10.14.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $bca04276e8783580$export$9f30fa0c10967f7f = "[DEFAULT]";
const $bca04276e8783580$var$PLATFORM_LOG_STRING = {
    [$bca04276e8783580$var$name$q]: "fire-core",
    [$bca04276e8783580$var$name$p]: "fire-core-compat",
    [$bca04276e8783580$var$name$n]: "fire-analytics",
    [$bca04276e8783580$var$name$o]: "fire-analytics-compat",
    [$bca04276e8783580$var$name$l]: "fire-app-check",
    [$bca04276e8783580$var$name$m]: "fire-app-check-compat",
    [$bca04276e8783580$var$name$k]: "fire-auth",
    [$bca04276e8783580$var$name$j]: "fire-auth-compat",
    [$bca04276e8783580$var$name$i]: "fire-rtdb",
    [$bca04276e8783580$var$name$h]: "fire-data-connect",
    [$bca04276e8783580$var$name$g]: "fire-rtdb-compat",
    [$bca04276e8783580$var$name$f]: "fire-fn",
    [$bca04276e8783580$var$name$e]: "fire-fn-compat",
    [$bca04276e8783580$var$name$d]: "fire-iid",
    [$bca04276e8783580$var$name$c]: "fire-iid-compat",
    [$bca04276e8783580$var$name$b]: "fire-fcm",
    [$bca04276e8783580$var$name$a]: "fire-fcm-compat",
    [$bca04276e8783580$var$name$9]: "fire-perf",
    [$bca04276e8783580$var$name$8]: "fire-perf-compat",
    [$bca04276e8783580$var$name$7]: "fire-rc",
    [$bca04276e8783580$var$name$6]: "fire-rc-compat",
    [$bca04276e8783580$var$name$5]: "fire-gcs",
    [$bca04276e8783580$var$name$4]: "fire-gcs-compat",
    [$bca04276e8783580$var$name$3]: "fire-fst",
    [$bca04276e8783580$var$name$1]: "fire-fst-compat",
    [$bca04276e8783580$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$bca04276e8783580$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $bca04276e8783580$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $bca04276e8783580$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bca04276e8783580$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $bca04276e8783580$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $bca04276e8783580$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $bca04276e8783580$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $bca04276e8783580$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($bca04276e8783580$export$9566bce3835c0f28.has(componentName)) {
        $bca04276e8783580$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $bca04276e8783580$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $bca04276e8783580$export$b4e3c36c855b14b5.values())$bca04276e8783580$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $bca04276e8783580$export$fb03ad8d3d5c5f76.values())$bca04276e8783580$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $bca04276e8783580$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $bca04276e8783580$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $bca04276e8783580$export$9f30fa0c10967f7f) {
    $bca04276e8783580$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $bca04276e8783580$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $bca04276e8783580$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $bca04276e8783580$export$3685d89b9c3cdfaf() {
    $bca04276e8783580$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $bca04276e8783580$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $bca04276e8783580$var$ERROR_FACTORY = new (0, $i9zJL.ErrorFactory)("app", "Firebase", $bca04276e8783580$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $bca04276e8783580$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $6DAV2.Component)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $bca04276e8783580$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $bca04276e8783580$var$FirebaseServerAppImpl extends $bca04276e8783580$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $bca04276e8783580$export$d29d5299a7137abc($bca04276e8783580$var$name$q, $bca04276e8783580$var$version$1, "serverapp");
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $bca04276e8783580$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $bca04276e8783580$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $bca04276e8783580$export$31499a9cd224b78c = $bca04276e8783580$var$version;
function $bca04276e8783580$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $bca04276e8783580$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $bca04276e8783580$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $i9zJL.getDefaultAppConfig)());
    if (!options) throw $bca04276e8783580$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $bca04276e8783580$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $i9zJL.deepEqual)(options, existingApp.options) && (0, $i9zJL.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $bca04276e8783580$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $6DAV2.ComponentContainer)(name);
    for (const component of $bca04276e8783580$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $bca04276e8783580$var$FirebaseAppImpl(options, config, container);
    $bca04276e8783580$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $bca04276e8783580$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $i9zJL.isBrowser)() && !(0, $i9zJL.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $bca04276e8783580$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($bca04276e8783580$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $bca04276e8783580$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $bca04276e8783580$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $6DAV2.ComponentContainer)(nameString);
    for (const component of $bca04276e8783580$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $bca04276e8783580$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $bca04276e8783580$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $bca04276e8783580$export$f9962582c9e66d99(name = $bca04276e8783580$export$9f30fa0c10967f7f) {
    const app = $bca04276e8783580$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $bca04276e8783580$export$9f30fa0c10967f7f && (0, $i9zJL.getDefaultAppConfig)()) return $bca04276e8783580$export$c55cfd413944906d();
    if (!app) throw $bca04276e8783580$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $bca04276e8783580$export$68ddedf7d44b3bdf() {
    return Array.from($bca04276e8783580$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $bca04276e8783580$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($bca04276e8783580$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $bca04276e8783580$export$b4e3c36c855b14b5.delete(name);
    } else if ($bca04276e8783580$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $bca04276e8783580$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $bca04276e8783580$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $bca04276e8783580$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $bca04276e8783580$var$logger.warn(warning.join(" "));
        return;
    }
    $bca04276e8783580$export$c930050e7bb63965(new (0, $6DAV2.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $bca04276e8783580$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $bca04276e8783580$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $dQajh.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $bca04276e8783580$export$c622e99c0ce7b1c9(logLevel) {
    (0, $dQajh.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $bca04276e8783580$var$DB_NAME = "firebase-heartbeat-database";
const $bca04276e8783580$var$DB_VERSION = 1;
const $bca04276e8783580$var$STORE_NAME = "firebase-heartbeat-store";
let $bca04276e8783580$var$dbPromise = null;
function $bca04276e8783580$var$getDbPromise() {
    if (!$bca04276e8783580$var$dbPromise) $bca04276e8783580$var$dbPromise = (0, $hnGkz.openDB)($bca04276e8783580$var$DB_NAME, $bca04276e8783580$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($bca04276e8783580$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $bca04276e8783580$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $bca04276e8783580$var$dbPromise;
}
async function $bca04276e8783580$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $bca04276e8783580$var$getDbPromise();
        const tx = db.transaction($bca04276e8783580$var$STORE_NAME);
        const result = await tx.objectStore($bca04276e8783580$var$STORE_NAME).get($bca04276e8783580$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $i9zJL.FirebaseError)) $bca04276e8783580$var$logger.warn(e.message);
        else {
            const idbGetError = $bca04276e8783580$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $bca04276e8783580$var$logger.warn(idbGetError.message);
        }
    }
}
async function $bca04276e8783580$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $bca04276e8783580$var$getDbPromise();
        const tx = db.transaction($bca04276e8783580$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($bca04276e8783580$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $bca04276e8783580$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $i9zJL.FirebaseError)) $bca04276e8783580$var$logger.warn(e.message);
        else {
            const idbGetError = $bca04276e8783580$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $bca04276e8783580$var$logger.warn(idbGetError.message);
        }
    }
}
function $bca04276e8783580$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $bca04276e8783580$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $bca04276e8783580$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $bca04276e8783580$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $bca04276e8783580$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider("platform-logger").getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $bca04276e8783580$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $bca04276e8783580$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $bca04276e8783580$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            const date = $bca04276e8783580$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $bca04276e8783580$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $i9zJL.base64urlEncodeWithoutPadding)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $bca04276e8783580$var$logger.warn(e);
            return "";
        }
    }
}
function $bca04276e8783580$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $bca04276e8783580$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $bca04276e8783580$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($bca04276e8783580$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($bca04276e8783580$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $bca04276e8783580$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $i9zJL.isIndexedDBAvailable)()) return false;
        else return (0, $i9zJL.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $bca04276e8783580$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $bca04276e8783580$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $bca04276e8783580$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $bca04276e8783580$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $i9zJL.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $bca04276e8783580$var$registerCoreComponents(variant) {
    $bca04276e8783580$export$c930050e7bb63965(new (0, $6DAV2.Component)("platform-logger", (container)=>new $bca04276e8783580$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $bca04276e8783580$export$c930050e7bb63965(new (0, $6DAV2.Component)("heartbeat", (container)=>new $bca04276e8783580$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $bca04276e8783580$export$d29d5299a7137abc($bca04276e8783580$var$name$q, $bca04276e8783580$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $bca04276e8783580$export$d29d5299a7137abc($bca04276e8783580$var$name$q, $bca04276e8783580$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $bca04276e8783580$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $bca04276e8783580$var$registerCoreComponents("");

});
parcelRegister("6DAV2", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $4d5305e964280f1b$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $4d5305e964280f1b$export$436a80eea5d5c0c5; });

var $i9zJL = parcelRequire("i9zJL");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $4d5305e964280f1b$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4d5305e964280f1b$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $4d5305e964280f1b$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $i9zJL.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($4d5305e964280f1b$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $4d5305e964280f1b$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $4d5305e964280f1b$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $4d5305e964280f1b$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $4d5305e964280f1b$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $4d5305e964280f1b$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $4d5305e964280f1b$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $4d5305e964280f1b$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $4d5305e964280f1b$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $4d5305e964280f1b$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $4d5305e964280f1b$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $4d5305e964280f1b$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $4d5305e964280f1b$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

});
parcelRegister("i9zJL", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $d374c9e4c71a9120$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $d374c9e4c71a9120$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $d374c9e4c71a9120$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $d374c9e4c71a9120$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $d374c9e4c71a9120$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $d374c9e4c71a9120$export$85f6557964517f1a; });
$parcel$export(module.exports, "getUA", function () { return $d374c9e4c71a9120$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $d374c9e4c71a9120$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowser", function () { return $d374c9e4c71a9120$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isWebWorker", function () { return $d374c9e4c71a9120$export$97b87b8868ff7a3c; });
$parcel$export(module.exports, "isCloudflareWorker", function () { return $d374c9e4c71a9120$export$ad9e9b75cb9fb797; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $d374c9e4c71a9120$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $d374c9e4c71a9120$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $d374c9e4c71a9120$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $d374c9e4c71a9120$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $d374c9e4c71a9120$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $d374c9e4c71a9120$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $d374c9e4c71a9120$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $d374c9e4c71a9120$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $d374c9e4c71a9120$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $d374c9e4c71a9120$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $d374c9e4c71a9120$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $d374c9e4c71a9120$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $d374c9e4c71a9120$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $d374c9e4c71a9120$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $kke6R = parcelRequire("kke6R");
const $d374c9e4c71a9120$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $d374c9e4c71a9120$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $d374c9e4c71a9120$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $d374c9e4c71a9120$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $d374c9e4c71a9120$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d374c9e4c71a9120$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $d374c9e4c71a9120$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $d374c9e4c71a9120$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($d374c9e4c71a9120$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $d374c9e4c71a9120$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $d374c9e4c71a9120$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $d374c9e4c71a9120$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $d374c9e4c71a9120$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $d374c9e4c71a9120$var$stringToByteArray$1(str);
    return $d374c9e4c71a9120$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $d374c9e4c71a9120$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $d374c9e4c71a9120$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $d374c9e4c71a9120$export$c62426fdd000a97e = function(str) {
    try {
        return $d374c9e4c71a9120$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $d374c9e4c71a9120$export$6c40052bed430212(value) {
    return $d374c9e4c71a9120$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $d374c9e4c71a9120$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$d374c9e4c71a9120$var$isValidKey(prop)) continue;
        target[prop] = $d374c9e4c71a9120$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $d374c9e4c71a9120$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $d374c9e4c71a9120$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d374c9e4c71a9120$var$getDefaultsFromGlobal = ()=>$d374c9e4c71a9120$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $d374c9e4c71a9120$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $kke6R === "undefined" || typeof $kke6R.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $d374c9e4c71a9120$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $d374c9e4c71a9120$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $d374c9e4c71a9120$export$212bb2fc580a90a8 = ()=>{
    try {
        return $d374c9e4c71a9120$var$getDefaultsFromGlobal() || $d374c9e4c71a9120$var$getDefaultsFromEnvVariable() || $d374c9e4c71a9120$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $d374c9e4c71a9120$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $d374c9e4c71a9120$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $d374c9e4c71a9120$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $d374c9e4c71a9120$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $d374c9e4c71a9120$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $d374c9e4c71a9120$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $d374c9e4c71a9120$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $d374c9e4c71a9120$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d374c9e4c71a9120$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d374c9e4c71a9120$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $d374c9e4c71a9120$export$4b5284a3025a455(JSON.stringify(header)),
        $d374c9e4c71a9120$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $d374c9e4c71a9120$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $d374c9e4c71a9120$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($d374c9e4c71a9120$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $d374c9e4c71a9120$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $d374c9e4c71a9120$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $d374c9e4c71a9120$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $d374c9e4c71a9120$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $d374c9e4c71a9120$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $d374c9e4c71a9120$export$ad9e9b75cb9fb797() {
    return typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers";
}
function $d374c9e4c71a9120$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $d374c9e4c71a9120$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $d374c9e4c71a9120$export$f2f6a8999f8ebd30() {
    return $d374c9e4c71a9120$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $d374c9e4c71a9120$export$7e7b1a9668aaed8() {
    const ua = $d374c9e4c71a9120$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $d374c9e4c71a9120$export$202944b2d2824246() {
    return $d374c9e4c71a9120$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $d374c9e4c71a9120$export$5d1d834fbbf8bab7() {
    return $d374c9e4c71a9120$export$588c7fdda06fbb0a.NODE_CLIENT === true || $d374c9e4c71a9120$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $d374c9e4c71a9120$export$95df08bae54cb4df() {
    return !$d374c9e4c71a9120$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $d374c9e4c71a9120$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $d374c9e4c71a9120$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $d374c9e4c71a9120$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $d374c9e4c71a9120$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $d374c9e4c71a9120$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $d374c9e4c71a9120$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $d374c9e4c71a9120$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d374c9e4c71a9120$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $d374c9e4c71a9120$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $d374c9e4c71a9120$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $d374c9e4c71a9120$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $d374c9e4c71a9120$var$replaceTemplate(template, data) {
    return template.replace($d374c9e4c71a9120$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $d374c9e4c71a9120$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $d374c9e4c71a9120$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $d374c9e4c71a9120$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d374c9e4c71a9120$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $d374c9e4c71a9120$export$c5a53ce6a17cf18d($d374c9e4c71a9120$export$c62426fdd000a97e(parts[0]) || "");
        claims = $d374c9e4c71a9120$export$c5a53ce6a17cf18d($d374c9e4c71a9120$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d374c9e4c71a9120$export$5f870fcca7ae6a88 = function(token) {
    const claims = $d374c9e4c71a9120$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d374c9e4c71a9120$export$701c661ec91095f2 = function(token) {
    const claims = $d374c9e4c71a9120$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d374c9e4c71a9120$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $d374c9e4c71a9120$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $d374c9e4c71a9120$export$fc970ed23da99565 = function(token) {
    const claims = $d374c9e4c71a9120$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d374c9e4c71a9120$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $d374c9e4c71a9120$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $d374c9e4c71a9120$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $d374c9e4c71a9120$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $d374c9e4c71a9120$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($d374c9e4c71a9120$var$isObject(aProp) && $d374c9e4c71a9120$var$isObject(bProp)) {
            if (!$d374c9e4c71a9120$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $d374c9e4c71a9120$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $d374c9e4c71a9120$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $d374c9e4c71a9120$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $d374c9e4c71a9120$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $d374c9e4c71a9120$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $d374c9e4c71a9120$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $d374c9e4c71a9120$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $d374c9e4c71a9120$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $d374c9e4c71a9120$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $d374c9e4c71a9120$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($d374c9e4c71a9120$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $d374c9e4c71a9120$var$noop;
        if (observer.error === undefined) observer.error = $d374c9e4c71a9120$var$noop;
        if (observer.complete === undefined) observer.complete = $d374c9e4c71a9120$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $d374c9e4c71a9120$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $d374c9e4c71a9120$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $d374c9e4c71a9120$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $d374c9e4c71a9120$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $d374c9e4c71a9120$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $d374c9e4c71a9120$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($d374c9e4c71a9120$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $d374c9e4c71a9120$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($d374c9e4c71a9120$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $d374c9e4c71a9120$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($d374c9e4c71a9120$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $d374c9e4c71a9120$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $d374c9e4c71a9120$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $d374c9e4c71a9120$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $d374c9e4c71a9120$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $d374c9e4c71a9120$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $d374c9e4c71a9120$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $d374c9e4c71a9120$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $d374c9e4c71a9120$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $d374c9e4c71a9120$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $d374c9e4c71a9120$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $d374c9e4c71a9120$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $d374c9e4c71a9120$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($d374c9e4c71a9120$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $d374c9e4c71a9120$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $d374c9e4c71a9120$var$indicator(i);
}
function $d374c9e4c71a9120$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d374c9e4c71a9120$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRegister("kke6R", function(module, exports) {
// shim for using process in browser
var $ecc09ec6ba85e059$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ecc09ec6ba85e059$var$cachedSetTimeout;
var $ecc09ec6ba85e059$var$cachedClearTimeout;
function $ecc09ec6ba85e059$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ecc09ec6ba85e059$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ecc09ec6ba85e059$var$cachedSetTimeout = setTimeout;
        else $ecc09ec6ba85e059$var$cachedSetTimeout = $ecc09ec6ba85e059$var$defaultSetTimout;
    } catch (e) {
        $ecc09ec6ba85e059$var$cachedSetTimeout = $ecc09ec6ba85e059$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ecc09ec6ba85e059$var$cachedClearTimeout = clearTimeout;
        else $ecc09ec6ba85e059$var$cachedClearTimeout = $ecc09ec6ba85e059$var$defaultClearTimeout;
    } catch (e) {
        $ecc09ec6ba85e059$var$cachedClearTimeout = $ecc09ec6ba85e059$var$defaultClearTimeout;
    }
})();
function $ecc09ec6ba85e059$var$runTimeout(fun) {
    if ($ecc09ec6ba85e059$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ecc09ec6ba85e059$var$cachedSetTimeout === $ecc09ec6ba85e059$var$defaultSetTimout || !$ecc09ec6ba85e059$var$cachedSetTimeout) && setTimeout) {
        $ecc09ec6ba85e059$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ecc09ec6ba85e059$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ecc09ec6ba85e059$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ecc09ec6ba85e059$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ecc09ec6ba85e059$var$runClearTimeout(marker) {
    if ($ecc09ec6ba85e059$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ecc09ec6ba85e059$var$cachedClearTimeout === $ecc09ec6ba85e059$var$defaultClearTimeout || !$ecc09ec6ba85e059$var$cachedClearTimeout) && clearTimeout) {
        $ecc09ec6ba85e059$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ecc09ec6ba85e059$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ecc09ec6ba85e059$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ecc09ec6ba85e059$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ecc09ec6ba85e059$var$queue = [];
var $ecc09ec6ba85e059$var$draining = false;
var $ecc09ec6ba85e059$var$currentQueue;
var $ecc09ec6ba85e059$var$queueIndex = -1;
function $ecc09ec6ba85e059$var$cleanUpNextTick() {
    if (!$ecc09ec6ba85e059$var$draining || !$ecc09ec6ba85e059$var$currentQueue) return;
    $ecc09ec6ba85e059$var$draining = false;
    if ($ecc09ec6ba85e059$var$currentQueue.length) $ecc09ec6ba85e059$var$queue = $ecc09ec6ba85e059$var$currentQueue.concat($ecc09ec6ba85e059$var$queue);
    else $ecc09ec6ba85e059$var$queueIndex = -1;
    if ($ecc09ec6ba85e059$var$queue.length) $ecc09ec6ba85e059$var$drainQueue();
}
function $ecc09ec6ba85e059$var$drainQueue() {
    if ($ecc09ec6ba85e059$var$draining) return;
    var timeout = $ecc09ec6ba85e059$var$runTimeout($ecc09ec6ba85e059$var$cleanUpNextTick);
    $ecc09ec6ba85e059$var$draining = true;
    var len = $ecc09ec6ba85e059$var$queue.length;
    while(len){
        $ecc09ec6ba85e059$var$currentQueue = $ecc09ec6ba85e059$var$queue;
        $ecc09ec6ba85e059$var$queue = [];
        while(++$ecc09ec6ba85e059$var$queueIndex < len)if ($ecc09ec6ba85e059$var$currentQueue) $ecc09ec6ba85e059$var$currentQueue[$ecc09ec6ba85e059$var$queueIndex].run();
        $ecc09ec6ba85e059$var$queueIndex = -1;
        len = $ecc09ec6ba85e059$var$queue.length;
    }
    $ecc09ec6ba85e059$var$currentQueue = null;
    $ecc09ec6ba85e059$var$draining = false;
    $ecc09ec6ba85e059$var$runClearTimeout(timeout);
}
$ecc09ec6ba85e059$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ecc09ec6ba85e059$var$queue.push(new $ecc09ec6ba85e059$var$Item(fun, args));
    if ($ecc09ec6ba85e059$var$queue.length === 1 && !$ecc09ec6ba85e059$var$draining) $ecc09ec6ba85e059$var$runTimeout($ecc09ec6ba85e059$var$drainQueue);
};
// v8 likes predictible objects
function $ecc09ec6ba85e059$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ecc09ec6ba85e059$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ecc09ec6ba85e059$var$process.title = "browser";
$ecc09ec6ba85e059$var$process.browser = true;
$ecc09ec6ba85e059$var$process.env = {};
$ecc09ec6ba85e059$var$process.argv = [];
$ecc09ec6ba85e059$var$process.version = ""; // empty string to avoid regexp issues
$ecc09ec6ba85e059$var$process.versions = {};
function $ecc09ec6ba85e059$var$noop() {}
$ecc09ec6ba85e059$var$process.on = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.addListener = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.once = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.off = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.removeListener = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.removeAllListeners = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.emit = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.prependListener = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.prependOnceListener = $ecc09ec6ba85e059$var$noop;
$ecc09ec6ba85e059$var$process.listeners = function(name) {
    return [];
};
$ecc09ec6ba85e059$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ecc09ec6ba85e059$var$process.cwd = function() {
    return "/";
};
$ecc09ec6ba85e059$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ecc09ec6ba85e059$var$process.umask = function() {
    return 0;
};

});



parcelRegister("dQajh", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $a138210b56a558e2$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $a138210b56a558e2$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $a138210b56a558e2$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $a138210b56a558e2$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $a138210b56a558e2$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $a138210b56a558e2$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($a138210b56a558e2$export$243e62d78d3b544d || ($a138210b56a558e2$export$243e62d78d3b544d = {}));
const $a138210b56a558e2$var$levelStringToEnum = {
    "debug": $a138210b56a558e2$export$243e62d78d3b544d.DEBUG,
    "verbose": $a138210b56a558e2$export$243e62d78d3b544d.VERBOSE,
    "info": $a138210b56a558e2$export$243e62d78d3b544d.INFO,
    "warn": $a138210b56a558e2$export$243e62d78d3b544d.WARN,
    "error": $a138210b56a558e2$export$243e62d78d3b544d.ERROR,
    "silent": $a138210b56a558e2$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $a138210b56a558e2$var$defaultLogLevel = $a138210b56a558e2$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $a138210b56a558e2$var$ConsoleMethod = {
    [$a138210b56a558e2$export$243e62d78d3b544d.DEBUG]: "log",
    [$a138210b56a558e2$export$243e62d78d3b544d.VERBOSE]: "log",
    [$a138210b56a558e2$export$243e62d78d3b544d.INFO]: "info",
    [$a138210b56a558e2$export$243e62d78d3b544d.WARN]: "warn",
    [$a138210b56a558e2$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $a138210b56a558e2$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $a138210b56a558e2$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $a138210b56a558e2$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $a138210b56a558e2$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $a138210b56a558e2$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $a138210b56a558e2$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $a138210b56a558e2$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $a138210b56a558e2$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $a138210b56a558e2$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $a138210b56a558e2$export$c622e99c0ce7b1c9(level) {
    $a138210b56a558e2$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $a138210b56a558e2$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $a138210b56a558e2$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $a138210b56a558e2$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $a138210b56a558e2$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("hnGkz", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $ca756bab38316645$export$ca0ed41b1a2af7e; });

var $fnDC6 = parcelRequire("fnDC6");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $ca756bab38316645$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $fnDC6.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $fnDC6.w)(request.result), event.oldVersion, event.newVersion, (0, $fnDC6.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $ca756bab38316645$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $fnDC6.w)(request).then(()=>undefined);
}
const $ca756bab38316645$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $ca756bab38316645$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $ca756bab38316645$var$cachedMethods = new Map();
function $ca756bab38316645$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($ca756bab38316645$var$cachedMethods.get(prop)) return $ca756bab38316645$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $ca756bab38316645$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $ca756bab38316645$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $ca756bab38316645$var$cachedMethods.set(prop, method);
    return method;
}
(0, $fnDC6.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$ca756bab38316645$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$ca756bab38316645$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("fnDC6", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $b327bb6d5dcb7303$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $b327bb6d5dcb7303$export$43caf9889c228507; });
const $b327bb6d5dcb7303$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $b327bb6d5dcb7303$var$idbProxyableTypes;
let $b327bb6d5dcb7303$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $b327bb6d5dcb7303$var$getIdbProxyableTypes() {
    return $b327bb6d5dcb7303$var$idbProxyableTypes || ($b327bb6d5dcb7303$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $b327bb6d5dcb7303$var$getCursorAdvanceMethods() {
    return $b327bb6d5dcb7303$var$cursorAdvanceMethods || ($b327bb6d5dcb7303$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $b327bb6d5dcb7303$var$cursorRequestMap = new WeakMap();
const $b327bb6d5dcb7303$var$transactionDoneMap = new WeakMap();
const $b327bb6d5dcb7303$var$transactionStoreNamesMap = new WeakMap();
const $b327bb6d5dcb7303$var$transformCache = new WeakMap();
const $b327bb6d5dcb7303$export$407448d2b89b1813 = new WeakMap();
function $b327bb6d5dcb7303$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($b327bb6d5dcb7303$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $b327bb6d5dcb7303$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $b327bb6d5dcb7303$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $b327bb6d5dcb7303$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($b327bb6d5dcb7303$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $b327bb6d5dcb7303$var$transactionDoneMap.set(tx, done);
}
let $b327bb6d5dcb7303$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $b327bb6d5dcb7303$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $b327bb6d5dcb7303$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $b327bb6d5dcb7303$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $b327bb6d5dcb7303$export$43caf9889c228507(callback) {
    $b327bb6d5dcb7303$var$idbProxyTraps = callback($b327bb6d5dcb7303$var$idbProxyTraps);
}
function $b327bb6d5dcb7303$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($b327bb6d5dcb7303$export$3b14a55fb2447963(this), storeNames, ...args);
        $b327bb6d5dcb7303$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $b327bb6d5dcb7303$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($b327bb6d5dcb7303$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($b327bb6d5dcb7303$export$3b14a55fb2447963(this), args);
        return $b327bb6d5dcb7303$export$efccba1c4a2ef57b($b327bb6d5dcb7303$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $b327bb6d5dcb7303$export$efccba1c4a2ef57b(func.apply($b327bb6d5dcb7303$export$3b14a55fb2447963(this), args));
    };
}
function $b327bb6d5dcb7303$var$transformCachableValue(value) {
    if (typeof value === "function") return $b327bb6d5dcb7303$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $b327bb6d5dcb7303$var$cacheDonePromiseForTransaction(value);
    if ($b327bb6d5dcb7303$export$23f2a1d2818174ef(value, $b327bb6d5dcb7303$var$getIdbProxyableTypes())) return new Proxy(value, $b327bb6d5dcb7303$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $b327bb6d5dcb7303$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $b327bb6d5dcb7303$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($b327bb6d5dcb7303$var$transformCache.has(value)) return $b327bb6d5dcb7303$var$transformCache.get(value);
    const newValue = $b327bb6d5dcb7303$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $b327bb6d5dcb7303$var$transformCache.set(value, newValue);
        $b327bb6d5dcb7303$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $b327bb6d5dcb7303$export$3b14a55fb2447963 = (value)=>$b327bb6d5dcb7303$export$407448d2b89b1813.get(value);

});



parcelRegister("cgTd8", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $8ef1ce660f439744$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8ef1ce660f439744$var$extendStatics = function(d, b) {
    $8ef1ce660f439744$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8ef1ce660f439744$var$extendStatics(d, b);
};
function $8ef1ce660f439744$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8ef1ce660f439744$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8ef1ce660f439744$export$18ce0697a983be9b = function() {
    $8ef1ce660f439744$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ef1ce660f439744$export$18ce0697a983be9b.apply(this, arguments);
};
function $8ef1ce660f439744$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8ef1ce660f439744$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8ef1ce660f439744$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8ef1ce660f439744$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8ef1ce660f439744$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8ef1ce660f439744$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8ef1ce660f439744$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8ef1ce660f439744$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8ef1ce660f439744$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8ef1ce660f439744$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8ef1ce660f439744$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8ef1ce660f439744$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8ef1ce660f439744$export$45d3717a4c69092e(o, m, p);
}
function $8ef1ce660f439744$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8ef1ce660f439744$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8ef1ce660f439744$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8ef1ce660f439744$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8ef1ce660f439744$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8ef1ce660f439744$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8ef1ce660f439744$export$10c90e4f7922046c(v) {
    return this instanceof $8ef1ce660f439744$export$10c90e4f7922046c ? (this.v = v, this) : new $8ef1ce660f439744$export$10c90e4f7922046c(v);
}
function $8ef1ce660f439744$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8ef1ce660f439744$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8ef1ce660f439744$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8ef1ce660f439744$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8ef1ce660f439744$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8ef1ce660f439744$export$19a8beecd37a4c45 === "function" ? $8ef1ce660f439744$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8ef1ce660f439744$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8ef1ce660f439744$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8ef1ce660f439744$var$ownKeys = function(o) {
    $8ef1ce660f439744$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8ef1ce660f439744$var$ownKeys(o);
};
function $8ef1ce660f439744$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8ef1ce660f439744$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8ef1ce660f439744$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8ef1ce660f439744$var$__setModuleDefault(result, mod);
    return result;
}
function $8ef1ce660f439744$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8ef1ce660f439744$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8ef1ce660f439744$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8ef1ce660f439744$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8ef1ce660f439744$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8ef1ce660f439744$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8ef1ce660f439744$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8ef1ce660f439744$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8ef1ce660f439744$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8ef1ce660f439744$export$2e2bcd8739ae039 = {
    __extends: $8ef1ce660f439744$export$a8ba968b8961cb8a,
    __assign: $8ef1ce660f439744$export$18ce0697a983be9b,
    __rest: $8ef1ce660f439744$export$3c9a16f847548506,
    __decorate: $8ef1ce660f439744$export$29e00dfd3077644b,
    __param: $8ef1ce660f439744$export$d5ad3fd78186038f,
    __esDecorate: $8ef1ce660f439744$export$3a84e1ae4e97e9b0,
    __runInitializers: $8ef1ce660f439744$export$d831c04e792af3d,
    __propKey: $8ef1ce660f439744$export$6a2a36740a146cb8,
    __setFunctionName: $8ef1ce660f439744$export$d1a06452d3489bc7,
    __metadata: $8ef1ce660f439744$export$f1db080c865becb9,
    __awaiter: $8ef1ce660f439744$export$1050f835b63b671e,
    __generator: $8ef1ce660f439744$export$67ebef60e6f28a6,
    __createBinding: $8ef1ce660f439744$export$45d3717a4c69092e,
    __exportStar: $8ef1ce660f439744$export$f33643c0debef087,
    __values: $8ef1ce660f439744$export$19a8beecd37a4c45,
    __read: $8ef1ce660f439744$export$8d051b38c9118094,
    __spread: $8ef1ce660f439744$export$afc72e2116322959,
    __spreadArrays: $8ef1ce660f439744$export$6388937ca91ccae8,
    __spreadArray: $8ef1ce660f439744$export$1216008129fb82ed,
    __await: $8ef1ce660f439744$export$10c90e4f7922046c,
    __asyncGenerator: $8ef1ce660f439744$export$e427f37a30a4de9b,
    __asyncDelegator: $8ef1ce660f439744$export$bbd80228419bb833,
    __asyncValues: $8ef1ce660f439744$export$e3b29a3d6162315f,
    __makeTemplateObject: $8ef1ce660f439744$export$4fb47efe1390b86f,
    __importStar: $8ef1ce660f439744$export$c21735bcef00d192,
    __importDefault: $8ef1ce660f439744$export$da59b14a69baef04,
    __classPrivateFieldGet: $8ef1ce660f439744$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8ef1ce660f439744$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8ef1ce660f439744$export$81fdc39f203e4e04,
    __addDisposableResource: $8ef1ce660f439744$export$88ac25d8e944e405,
    __disposeResources: $8ef1ce660f439744$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8ef1ce660f439744$export$889dfb5d17574b0b
};

});




parcelRegister("2aNQ5", function(module, exports) {

$parcel$export(module.exports, "VERSIONS", function () { return $fd326960d2ef7534$export$aa5307f1aca77413; });
$parcel$export(module.exports, "FILE_UPLOAD_PREFIX", function () { return $fd326960d2ef7534$export$b4573bd8acf8e409; });
$parcel$export(module.exports, "languages", function () { return $fd326960d2ef7534$export$d0d68bb9ed2c643d; });
$parcel$export(module.exports, "yesOrNoOptions", function () { return $fd326960d2ef7534$export$74543c06f8d61a49; });
$parcel$export(module.exports, "relationTypeOptions", function () { return $fd326960d2ef7534$export$7dd719789dae94b2; });
$parcel$export(module.exports, "secondaryRelationTypeOptions", function () { return $fd326960d2ef7534$export$a8a2331513137d55; });
$parcel$export(module.exports, "SUCCESS_MESSAGES", function () { return $fd326960d2ef7534$export$f61ac5598f63032a; });
$parcel$export(module.exports, "ERROR_MESSAGES", function () { return $fd326960d2ef7534$export$69d25b90d0002cf3; });
$parcel$export(module.exports, "idDocsDescription", function () { return $fd326960d2ef7534$export$88db146324465721; });
$parcel$export(module.exports, "addressProofDescription", function () { return $fd326960d2ef7534$export$478ad5c19925bc6f; });
$parcel$export(module.exports, "getRelationDivider", function () { return $fd326960d2ef7534$export$1f6c3e3e96f89bd4; });
$parcel$export(module.exports, "nbbCountries", function () { return $fd326960d2ef7534$export$45eb56ae4e0f487f; });
const $fd326960d2ef7534$export$aa5307f1aca77413 = {
    API: 1,
    INTERFACE: 1
};
const $fd326960d2ef7534$export$bb0caef18649c979 = 100;
const $fd326960d2ef7534$export$ba665b6c9de5430c = 1;
const $fd326960d2ef7534$export$b4573bd8acf8e409 = "file-upload:";
const $fd326960d2ef7534$export$d0d68bb9ed2c643d = [
    "en",
    "es",
    "nl",
    "fr",
    "pt",
    "it",
    "de",
    "pl",
    "ro",
    "gr"
];
const $fd326960d2ef7534$export$74d99a0fa9518c78 = {
    en: "English",
    es: "Espa\xf1ol",
    fr: "Fran\xe7ais",
    nl: "Nederlands",
    pt: "Portugu\xeas",
    it: "Italiano",
    de: "Deutsch",
    pl: "Polski",
    ro: "Rom\xe2n\u0103",
    gr: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"
};
const $fd326960d2ef7534$export$74543c06f8d61a49 = [
    {
        label: {
            en: "Yes",
            es: "S\xed",
            fr: "Oui",
            nl: "Ja",
            pt: "Sim",
            it: "Si",
            de: "Ja",
            pl: "Tak",
            ro: "Da",
            gr: "\u039D\u03B1\u03B9"
        },
        value: true
    },
    {
        label: {
            en: "No",
            es: "No",
            fr: "Non",
            nl: "Nee",
            pt: "N\xe3o",
            it: "No",
            de: "Nein",
            pl: "Nie",
            ro: "Nu",
            gr: "\u038C\u03C7\u03B9"
        },
        value: false
    }
];
const $fd326960d2ef7534$export$7dd719789dae94b2 = [
    {
        label: {
            en: "Authorised contact",
            es: "Contacto autorizado",
            fr: "Contacts Autoris\xe9s",
            nl: "Geautoriseerd contact",
            pt: "Contato autorizado",
            it: "Contatto autorizzato",
            de: "Autorisierter Kontakt",
            pl: "Autoryzowany kontakt",
            ro: "Persoan\u0103 de contact autorizat\u0103",
            gr: "\u0395\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03B7\u03BC\u03AD\u03BD\u03B7 \u0395\u03C0\u03B1\u03C6\u03AE"
        },
        value: "auth contact"
    },
    {
        label: {
            en: "Director",
            es: "Director",
            fr: "Directeur",
            nl: "Directeur",
            pt: "Diretor",
            it: "Direttore",
            de: "Gesch\xe4ftsf\xfchrer",
            pl: "Zarz\u0105d",
            ro: "Director",
            gr: "\u0394\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AE\u03C2"
        },
        value: "director"
    },
    {
        label: {
            en: "Ultimate beneficial owner",
            es: "Titular real",
            fr: "B\xe9n\xe9ficiaires Effectives",
            nl: "Uiteindelijke begunstigde eigenaar",
            pt: "Propriet\xe1rio benefici\xe1rio final",
            it: "Titolare Effettivo",
            de: "Wirtschaftlicher Eigent\xfcmer",
            pl: "Beneficjent rzeczywisty",
            ro: "Beneficiar real final",
            gr: "\u0395\u03C0\u03B9\u03BA\u03B1\u03C1\u03C0\u03C9\u03C4\u03AE\u03C2"
        },
        value: "ubo"
    },
    {
        label: {
            en: "Corporate director",
            es: "Director corporativo",
            fr: "Directeur corporatif",
            nl: "Bedrijfsdirecteur",
            pt: "Empresa como Diretora",
            it: "Direttore aziendale",
            de: "Gesch\xe4ftsf\xfchrer",
            pl: "Dyrektor korporacyjny (osoba prawna)",
            ro: "Director corporativ",
            gr: "\u0395\u03C4\u03B1\u03B9\u03C1\u03B9\u03BA\u03CC\u03C2 \u03B4\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AE\u03C2"
        },
        value: "corporate director"
    }
];
const $fd326960d2ef7534$export$a8a2331513137d55 = [
    {
        label: {
            en: "Director",
            es: "Director",
            fr: "Directeur",
            nl: "Directeur",
            pt: "Diretor",
            it: "Direttore",
            de: "Gesch\xe4ftsf\xfchrer",
            pl: "Zarz\u0105d",
            ro: "Director",
            gr: "\u0394\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AE\u03C2"
        },
        value: "director"
    },
    {
        label: {
            en: "Corporate director",
            es: "Director corporativo",
            fr: "Directeur corporatif",
            nl: "Bedrijfsdirecteur",
            pt: "Empresa como Diretora",
            it: "Direttore aziendale",
            de: "Gesch\xe4ftsf\xfchrer",
            pl: "Dyrektor korporacyjny (osoba prawna)",
            ro: "Director corporativ",
            gr: "\u03B5\u03C4\u03B1\u03B9\u03C1\u03B9\u03BA\u03CC\u03C2 \u03B4\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AE\u03C2"
        },
        value: "corporate director"
    }
];
const $fd326960d2ef7534$export$f61ac5598f63032a = {
    AUTHORIZED_AS: {
        en: "Authorized successfully as",
        es: "Autorizado con \xe9xito como",
        nl: "Met succes geautoriseerd als",
        fr: "Autoris\xe9 avec succ\xe8s comme",
        pt: "Autorizado com sucesso como",
        it: "Autorizzato con successo come",
        de: "Erfolgreich autorisiert als",
        pl: "Autoryzowano pomy\u015Blnie dla",
        ro: "Autorizat cu succes ca",
        gr: "\u0395\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03AE\u03B8\u03B7\u03BA\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2"
    }
};
const $fd326960d2ef7534$export$69d25b90d0002cf3 = {
    NO_DATA_FOUND: {
        en: "No data found for the given email and account number. Please use the link provided in the email sent by Ebury",
        es: "No se han encontrado datos para el e-mail y n\xfamero de cuenta indicados. Por favor, utilice el enlace proporcionado en el e-mail enviado por Ebury.",
        nl: "Geen gegevens gevonden voor het opgegeven e-mailadres en rekeningnummer. Gebruik de link in de e-mail die door Ebury is verzonden.",
        fr: "Aucune donn\xe9e trouv\xe9e pour l'e-mail et le num\xe9ro de compte indiqu\xe9s. Veuillez utiliser le lien fourni dans l'e-mail envoy\xe9 par Ebury.",
        pt: "N\xe3o foram encontrados dados para o email e n\xfamero de conta indicados. Por favor, utilize o link facultado no email enviado pela Ebury",
        it: "Nessun dato trovato per l'e-mail e il numero di account specificati. Utilizza il link fornito nell'e-mail inviata da Ebury",
        de: "F\xfcr die angegebene E-Mail-Adresse und Kontonummer wurden keine Daten gefunden. Bitte verwenden Sie den in der von Ebury gesendeten E-Mail bereitgestellten Link.",
        pl: "Nie znaleziono danych dla podanego adresu e-mail i numeru konta. Prosimy o u\u017Cycie linku dostarczonego w wiadomo\u015Bci e-mail wys\u0142anej przez Ebury",
        ro: "Nu s-au g\u0103sit date pentru adresa de e-mail \u0219i num\u0103rul de cont date. V\u0103 rug\u0103m s\u0103 utiliza\u021Bi linkul furnizat \xeen e-mailul trimis de Ebury",
        gr: "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03BF email \u03BA\u03B1\u03B9 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03C0\u03BF\u03C5 \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03BF email \u03C0\u03BF\u03C5 \u03AD\u03C3\u03C4\u03B5\u03B9\u03BB\u03B5 \u03B7 Ebury"
    },
    GENERAL_ERROR: {
        en: "Don't worry, your progress has been saved, and our team has been notified. Sorry for the inconvenience!",
        es: "No se preocupe, su progreso se ha guardado y nuestro equipo ha sido notificado. Sentimos las molestias.",
        nl: "Geen zorgen, de voortgang is opgeslagen en ons team is op de hoogte gesteld. Excuses voor het ongemak!",
        fr: "Ne vous inqui\xe9tez pas, votre progression a \xe9t\xe9 sauvegard\xe9e, et votre \xe9quipe a \xe9t\xe9 inform\xe9e. Desol\xe9e pour les d\xe9sagr\xe9ments",
        pt: "N\xe3o se preocupe, o seu progresso foi guardado e a nossa equipa foi notificada. Pedimos desculpa pela inconveni\xeancia.",
        it: "Non preoccuparti, i tuoi progressi sono stati salvati e il nostro team \xe8 stato avvisato. Ci scusiamo per l'inconveniente!",
        de: "Keine Sorge, Ihr Fortschritt wurde gespeichert und unser Team wurde benachrichtigt. Entschuldigen Sie die Unannehmlichkeiten!",
        pl: "Uprzejmie informujemy, \u017Ce wprowadzone dane zosta\u0142y zapisane, a nasz zesp\xf3\u0142 zosta\u0142 ju\u017C powiadomiony o zaistnia\u0142ej sytuacji. Przepraszamy za wszelkie niedogodno\u015Bci, kt\xf3re mog\u0142y wynikn\u0105\u0107.",
        ro: "Nu v\u0103 face\u021Bi griji, progresul dvs. a fost salvat, iar echipa noastr\u0103 a fost notificat\u0103. Ne cerem scuze pentru nepl\u0103cerile create!",
        gr: "\u039C\u03B7\u03BD \u03B1\u03BD\u03B7\u03C3\u03C5\u03C7\u03B5\u03AF\u03C4\u03B5, \u03B7 \u03C0\u03C1\u03CC\u03BF\u03B4\u03CC\u03C2 \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03C4\u03B5\u03AF \u03BA\u03B1\u03B9 \u03B7 \u03BF\u03BC\u03AC\u03B4\u03B1 \u03BC\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF. \u039B\u03C5\u03C0\u03BF\u03CD\u03BC\u03B1\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C4\u03B1\u03BB\u03B1\u03B9\u03C0\u03C9\u03C1\u03AF\u03B1!"
    },
    ERROR_OCCURRED: {
        en: "An error has occurred",
        es: "Ha ocurrido un error",
        nl: "Er is een fout opgetreden",
        fr: "Une erreur s'est produite",
        pt: "Ocorreu um erro",
        it: "Si \xe8 verificato un errore",
        de: "Ein Fehler ist aufgetreten",
        pl: "Wyst\u0105pi\u0142 b\u0142\u0105d",
        ro: "A ap\u0103rut o eroare",
        gr: "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1"
    },
    NO_ACCOUNT_NUMBER: {
        en: "No account number found. Please use the link provided in the email sent by Ebury",
        es: "No se ha podido encontrar el n\xfamero de cuenta. Utilice el enlace enviado a su correo electr\xf3nico por Ebury.",
        nl: "Geen rekeningnummer gevonden. Gebruik de link in de e-mail die Ebury heeft verzonden",
        fr: "Pas de num\xe9ro de compte trouv\xe9. Veuillez utiliser le lien fourni dans le mail envoy\xe9 par Ebury.",
        pt: "N\xe3o foram encontrados dados para o e-mail e n\xfamero de conta fornecidos. Por favor, utilize o link fornecido no e-mail enviado pela Ebury",
        it: "Nessun numero di conto trovato. Si prega di utilizzare il link fornito nell'email inviata da Ebury.",
        de: "Keine Kontonummer gefunden. Bitte verwenden Sie den per E-Mail bereitgestellten Link.",
        pl: "Nie znaleziono numeru konta. Prosimy o klikni\u0119cie linku, kt\xf3ry znajduje si\u0119 w otrzymanej wiadomo\u015Bci e-mail.",
        ro: "Nu s-a g\u0103sit niciun num\u0103r de cont. V\u0103 rug\u0103m s\u0103 utiliza\u021Bi linkul furnizat prin e-mail.",
        gr: "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03C0\u03BF\u03C5 \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03BC\u03AD\u03C3\u03C9 email."
    },
    NO_EMAIL: {
        en: "No email found",
        es: "No se ha encontrado ning\xfan correo electr\xf3nico",
        nl: "Geen e-mailadres gevonden",
        fr: "Pas d'adresse mail trouv\xe9e",
        pt: "Nenhum e-mail encontrado",
        it: "Nessuna e-mail trovata",
        de: "Keine E-Mail gefunden",
        pl: "Nie znaleziono adresu e-mail",
        ro: "Nu s-a g\u0103sit niciun e-mail",
        gr: "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5 email"
    },
    USE_EBURY_EMAIL: {
        en: "Please use the link provided by email",
        es: "Utilice el enlace proporcionado por correo electr\xf3nico",
        nl: "Gebruik de link die per e-mail is verstrekt",
        fr: "Veuillez utiliser le lien fourni par mail",
        pt: "Por favor utilize o link fornecido por e-mail",
        it: "Utilizza il link fornito tramite e-mail",
        de: "Bitte verwenden Sie den per E-Mail bereitgestellten Link",
        pl: "Prosimy o klikni\u0119cie linku, kt\xf3ry znajduje si\u0119 w otrzymanej wiadomo\u015Bci e-mail.",
        ro: "V\u0103 rug\u0103m s\u0103 utiliza\u021Bi linkul furnizat prin e-mail",
        gr: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03C0\u03BF\u03C5 \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03BC\u03AD\u03C3\u03C9 email"
    },
    INVALID_LINK: {
        en: "Invalid link",
        es: "Enlace no v\xe1lido",
        fr: "Lien invalide",
        nl: "Ongeldige link",
        pt: "Link inv\xe1lido",
        it: "Link non valido",
        de: "Ung\xfcltiger Link",
        pl: "Nieprawid\u0142owy link",
        ro: "Link nevalid",
        gr: "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2"
    },
    SIGN_IN_FAILED: {
        en: "Sign in failed",
        es: "Fallo al iniciar sesi\xf3n",
        nl: "Inloggen mislukt",
        fr: "L\xb4identification a \xe9chou\xe9",
        pt: "Falha ao entrar",
        it: "Accesso non riuscito",
        de: "Anmeldung fehlgeschlagen",
        pl: "Nie uda\u0142o si\u0119 zalogowa\u0107",
        ro: "Conectare nereu\u0219it\u0103",
        gr: "\u0397 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5"
    },
    SIGN_IN_FAILED_REFRESH: {
        en: "Sign in with email failed. Please refresh and try again",
        es: "El inicio de sesi\xf3n con su correo eletr\xf3nico ha fallado. Por favor, actualice y pruebe de nuevo.",
        nl: "Aanmelden met e-mailadres is mislukt. Vernieuw de pagina en probeer het opnieuw",
        fr: "L\xb4identification par mail a \xe9chou\xe9. Veuillez rafra\xeechir la page et essayer de nouveau",
        pt: "Falha ao iniciar sess\xe3o com e-mail. Atualize e tente novamente",
        it: "Accesso con e-mail non riuscito. Aggiorna e riprova",
        de: "Anmeldung mit E-Mail fehlgeschlagen. Bitte aktualisieren und erneut versuchen",
        pl: "Nie uda\u0142o si\u0119 zalogowa\u0107 za pomoc\u0105 adresu e-mail. Od\u015Bwie\u017C i spr\xf3buj ponownie",
        ro: "Conectare cu e-mail nereu\u0219it\u0103. Re\xeemprosp\u0103ta\u021Bi pagina \u0219i \xeencerca\u021Bi din nou",
        gr: "\u0397 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03BC\u03B5 email \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5. \u039A\u03AC\u03BD\u03C4\u03B5 \u03B1\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7 \u03BA\u03B1\u03B9 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC"
    },
    EMAIL_NOT_IN_ACCOUNT: {
        en: "The email you are trying to sign in with is not associated with the account number. Please, click ok and try signing in with a different email",
        es: "El correo electr\xf3nico con el que intenta iniciar sesi\xf3n no est\xe1 asociado con el n\xfamero de cuenta. Por favor, haga clic en ok e intente iniciar sesi\xf3n con un correo electr\xf3nico diferente.",
        nl: "De e-mail waarmee u probeert in te loggen is niet gekoppeld aan het rekeningnummer. Klik op ok en probeer in te loggen met een ander e-mailadres",
        fr: "L\xb4adresse mail avec laquelle vous essayez de vous identifier n\xb4est pas associ\xe9e au num\xe9ro de compte. Veuillez cliquer sur ok et essayer de vous identifier avec une adresse mail diff\xe9rente",
        pt: "O e-mail com o qual voc\xea est\xe1 tentando entrar n\xe3o est\xe1 associado ao n\xfamero da conta. Por favor, clique em ok e tente entrar com um e-mail diferente",
        it: "L'email con cui stai cercando di accedere non \xe8 associato al numero di conto. Clicca su ok e prova ad accedere con un'email diversa",
        de: "Die E-Mail, mit der Sie sich anmelden m\xf6chten, ist nicht mit der Kontonummer verkn\xfcpft. Bitte klicken Sie auf OK und versuchen Sie es mit einer anderen E-Mail-Adresse erneut",
        pl: "E-mail, kt\xf3rego pr\xf3bujesz u\u017Cy\u0107 do logowania, nie jest powi\u0105zany z numerem konta. Kliknij OK i spr\xf3buj zalogowa\u0107 si\u0119 za pomoc\u0105 innego adresu e-mail",
        ro: "E-mailul pe care \xeencerca\u021Bi s\u0103 v\u0103 conecta\u021Bi nu este asociat cu num\u0103rul de cont. V\u0103 rug\u0103m s\u0103 face\u021Bi clic pe ok \u0219i s\u0103 \xeencerca\u021Bi s\u0103 v\u0103 conecta\u021Bi cu un e-mail diferit",
        gr: "\u03A4\u03BF email \u03BC\u03B5 \u03C4\u03BF \u03BF\u03C0\u03BF\u03AF\u03BF \u03C0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF \u03BC\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD. \u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF ok \u03BA\u03B1\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC email"
    }
};
const $fd326960d2ef7534$export$88db146324465721 = {
    en: `Please provide a valid and certified ID document. ID documents should be in date and government issued and contain at least full name, photograph and date of birth. Certifications must be carried out by professionals authorised to do so in your country, be signed and contain the details of the certifier.  If you prefer to use an electronic identity verification method please contact your relationship manager or KYC@ebury.com`,
    es: `Por favor, proporcione una copia certificada del Documento De Identidad. El documento de identidad debe estar en vigor e incluir, por lo menos, nombre completo, fotograf\xeda y fecha de nacimiento. Las certificaciones deben llevarse a cabo por profesionales autorizados para ello siguiendo la normativa de su pa\xeds, y deben estar firmados e incluir los detalles del certificador. Si prefiere usar un m\xe9todo de verificaci\xf3n de identidad electr\xf3nico, por favor contacte a su gestor o a kyc@ebury.com`,
    nl: `Graag ontvangen wij een geldig en gecertificeerd identiteitsbewijs. Identiteitsdocumenten moeten de datum en de door de overheid afgegeven datum hebben en ten minste de volledige naam, foto en geboortedatum bevatten. Certificeringen moeten worden uitgevoerd door professionals die daartoe in uw land geautoriseerd zijn, de documenten moeten ondertekend zijn en de gegevens van de certificeerder bevatten. Als u liever een elektronische identiteitsverificatiemethode gebruikt, neem dan contact op met uw relatiebeheerder of kyc@ebury.com`,
    fr: `Veuillez fournir une pi\xe8ce d'identit\xe9 valide et certifi\xe9e. Les documents d'identit\xe9 doivent \xeatre dat\xe9s et d\xe9livr\xe9s par le Gouvernement et contenir au moins le nom complet, la photographie et la date de naissance. Les certifications doivent \xeatre r\xe9alis\xe9es par des professionnels habilit\xe9s \xe0 le faire dans votre pays, \xeatre sign\xe9es et contenir les coordonn\xe9es du certificateur. Si vous pr\xe9f\xe9rez utiliser une m\xe9thode de v\xe9rification d'identit\xe9 \xe9lectronique, veuillez contacter votre responsable relationnel ou kyc@ebury.com`,
    pt: `Providencie uma c\xf3pia certificada do seu documento de identidade. O documento de identidade deve ser v\xe1lido e incluir, pelo menos, o nome completo, a fotografia e a data de nascimento. As certifica\xe7\xf5es devem ser realizadas por profissionais autorizados a faz\xea-lo em conformidade com a regulamenta\xe7\xe3o do seu pa\xeds e devem ser assinadas e incluir os dados do certificador. Se preferir utilizar um m\xe9todo eletr\xf3nico de verifica\xe7\xe3o de identidade, contacte o seu gestor de conta ou kyc@ebury.com`,
    it: "Si prega di fornire un documento d'identit\xe0 valido e certificato. I documenti d'identit\xe0 devono essere in corso di validit\xe0 e rilasciati dal governo, e devono contenere almeno nome completo, fotografia e data di nascita. Le certificazioni devono essere eseguite da professionisti autorizzati a farlo nel vostro paese, essere firmate e contenere i dettagli del certificatore. Se preferite utilizzare un metodo di verifica dell'identit\xe0 elettronica, si prega di contattare il vostro relationship manager o KYC@ebury.com",
    de: "Bitte legen Sie einen g\xfcltigen und beglaubigten Ausweis vor. Ausweisdokumente sollten aktuell und von einer Regierungsbeh\xf6rde ausgestellt sein und mindestens den vollst\xe4ndigen Namen, ein Foto und das Geburtsdatum enthalten. Beglaubigungen m\xfcssen von in Ihrem Land dazu befugten Fachleuten durchgef\xfchrt werden, unterzeichnet sein und die Angaben des Beglaubigers enthalten. Wenn Sie eine elektronische Methode zur Identit\xe4tspr\xfcfung bevorzugen, wenden Sie sich bitte an Ihren Kundenbetreuer oder an KYC@ebury.com",
    pl: "Prosimy o dostarczenie wa\u017Cnego i po\u015Bwiadczonego dokumentu to\u017Csamo\u015Bci. Dokumenty to\u017Csamo\u015Bci powinny by\u0107 aktualne, wydane przez organ pa\u0144stwowy i zawiera\u0107 co najmniej imi\u0119 i nazwisko, zdj\u0119cie oraz dat\u0119 urodzenia. Po\u015Bwiadczenia musz\u0105 by\u0107 wykonane przez profesjonalist\xf3w upowa\u017Cnionych do tego w Pa\u0144stwa kraju, by\u0107 podpisane i zawiera\u0107 dane osoby po\u015Bwiadczaj\u0105cej. Je\u015Bli wolisz skorzysta\u0107 z elektronicznej metody weryfikacji to\u017Csamo\u015Bci, skontaktuj si\u0119 ze swoim mened\u017Cerem ds. relacji lub pod adresem KYC@ebury.com",
    ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document de identitate valabil \u0219i certificat. Documentele de identitate trebuie s\u0103 fie la zi, emise de o autoritate guvernamental\u0103 \u0219i s\u0103 con\u021Bin\u0103 cel pu\u021Bin numele complet, fotografia \u0219i data na\u0219terii. Certific\u0103rile trebuie efectuate de profesioni\u0219ti autoriza\u021Bi \xeen \u021Bara dumneavoastr\u0103, s\u0103 fie semnate \u0219i s\u0103 con\u021Bin\u0103 detaliile certificatorului. Dac\u0103 prefera\u021Bi s\u0103 utiliza\u021Bi o metod\u0103 electronic\u0103 de verificare a identit\u0103\u021Bii, v\u0103 rug\u0103m s\u0103 contacta\u021Bi managerul de rela\u021Bii sau KYC@ebury.com",
    gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03B5\u03AF\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03BA\u03B1\u03B9 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2. \u03A4\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03BD \u03B9\u03C3\u03C7\u03CD, \u03B5\u03BA\u03B4\u03BF\u03B8\u03AD\u03BD\u03C4\u03B1 \u03B1\u03C0\u03CC \u03BA\u03C1\u03B1\u03C4\u03B9\u03BA\u03AE \u03B1\u03C1\u03C7\u03AE \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03BF\u03C5\u03BD \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03BF\u03BD\u03BF\u03BC\u03B1\u03C4\u03B5\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF, \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2. \u039F\u03B9 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B4\u03B9\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03B7\u03BC\u03AD\u03BD\u03BF\u03C5\u03C2 \u03BD\u03B1 \u03C4\u03BF \u03C0\u03C1\u03AC\u03C4\u03C4\u03BF\u03C5\u03BD \u03C3\u03C4\u03B7 \u03C7\u03CE\u03C1\u03B1 \u03C3\u03B1\u03C2, \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03B3\u03B5\u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03BF\u03C5\u03BD \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BD\u03C4\u03BF\u03C2. \u0395\u03AC\u03BD \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03AC\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2, \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03C5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF \u03C0\u03B5\u03BB\u03B1\u03C4\u03B5\u03B9\u03B1\u03BA\u03CE\u03BD \u03C3\u03C7\u03AD\u03C3\u03B5\u03C9\u03BD \u03AE \u03BC\u03B5 \u03C4\u03BF KYC@ebury.com"
};
const $fd326960d2ef7534$export$478ad5c19925bc6f = {
    en: "Proof of address documents should be dated within the last 3 months and issued by an independent verifiable source.",
    es: "Los justificantes de domicilio deben haber sido emitidos en los \xfaltimos 3 meses y por una fuente independiente y verificable.",
    nl: "Bewijs van adresdocumenten moeten binnen de afgelopen drie maanden zijn gedateerd en zijn afgegeven door een onafhankelijke, verifieerbare bron.",
    fr: "Les justificatifs de domicile doivent \xeatre dat\xe9s de moins de 3 mois et d\xe9livr\xe9s par une source ind\xe9pendante v\xe9rifiable.",
    pt: "Os comprovativos de endere\xe7o devem ter a data dos \xfaltimos 6 meses e emitidos por uma fonte independente e verific\xe1vel.",
    it: "I documenti di prova dell'indirizzo devono essere datati negli ultimi 3 mesi e rilasciati da una fonte indipendente e verificabile.",
    de: "Adressnachweise sollten innerhalb der letzten 3 Monate datiert und von einer unabh\xe4ngigen, \xfcberpr\xfcfbaren Quelle ausgestellt sein.",
    pl: "Dokumenty potwierdzaj\u0105ce adres powinny by\u0107 datowane w ci\u0105gu ostatnich 3 miesi\u0119cy i wydane przez niezale\u017Cne, weryfikowalne \u017Ar\xf3d\u0142o.",
    ro: "Documentele doveditoare ale adresei trebuie s\u0103 fie datate \xeen ultimele 3 luni \u0219i emise de o surs\u0103 independent\u0103 \u0219i verificabil\u0103.",
    gr: "\u03A4\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1 \u03B1\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7\u03C2 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03AD\u03C7\u03BF\u03C5\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B5\u03BD\u03C4\u03CC\u03C2 \u03C4\u03C9\u03BD \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03C9\u03BD 3 \u03BC\u03B7\u03BD\u03CE\u03BD \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03AD\u03C7\u03BF\u03C5\u03BD \u03B5\u03BA\u03B4\u03BF\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03B1\u03BD\u03B5\u03BE\u03AC\u03C1\u03C4\u03B7\u03C4\u03B7, \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03B9\u03BC\u03B7 \u03C0\u03B7\u03B3\u03AE."
};
const $fd326960d2ef7534$export$e8c9778bf415dd08 = {
    id: "divider",
    type: "divider",
    title: {
        en: "divider"
    }
};
const $fd326960d2ef7534$export$1f6c3e3e96f89bd4 = (relationNumber)=>{
    return {
        id: `relation_${relationNumber}_divider`,
        type: "divider",
        title: {
            en: "divider"
        }
    };
};
const $fd326960d2ef7534$export$c49915ba9861042d = [
    "United Kingdom",
    "Switzerland",
    "Australia",
    "Canada",
    "Hong Kong",
    "United Arab Emirates"
];
const $fd326960d2ef7534$export$45eb56ae4e0f487f = [
    "Belgium",
    "Czechia",
    "France",
    "Germany",
    "Greece",
    "Italy",
    "Spain",
    "Poland",
    "Netherlands",
    "Luxembourg",
    "Portugal",
    "Bulgaria",
    "Romania",
    "Ireland",
    "Lithuania"
];
const $fd326960d2ef7534$export$234e4f7526f79ef2 = [
    ...$fd326960d2ef7534$export$c49915ba9861042d,
    ...$fd326960d2ef7534$export$45eb56ae4e0f487f
];

});

parcelRegister("bv5EI", function(module, exports) {

$parcel$export(module.exports, "addRelationFields", function () { return $28925532ba5d204d$export$b0cc30b4d2b68656; });

var $2aNQ5 = parcelRequire("2aNQ5");

var $2tUDf = parcelRequire("2tUDf");
const $28925532ba5d204d$export$b0cc30b4d2b68656 = (options)=>{
    const { relationNumber: relationNumber, country: country, relationType: relationType, didTheRelationChangeId: didTheRelationChangeId, isExistingRelation: isExistingRelation, isHighRisk: isHighRisk = false, relationResidenceCountry: relationResidenceCountry, existingValues: existingValues } = options;
    // We are doing it like this so that we filter out the unnecessary questions.
    // if it is a director and the country is in europe, then
    // only ask the defaults (name, nationality, dob, address)
    const isDirector = relationType === "director";
    const isInEurope = (0, $2aNQ5.nbbCountries).includes(country);
    const askDefaultQuestionsOnly = isDirector && isInEurope;
    const countryToUse = askDefaultQuestionsOnly ? "Not in list" : country;
    const isEpbeDeBranch = country === "Germany";
    const isDeResidentRelation = relationResidenceCountry === "Germany";
    const requireDeTaxNumber = isEpbeDeBranch && isDeResidentRelation;
    const allFields = $28925532ba5d204d$var$getAllFields(relationNumber, isHighRisk);
    if (requireDeTaxNumber) {
        const taxNumberFieldId = `relation_${relationNumber}_relation_type_updated_tax_number`;
        const taxNumberFieldIndex = allFields.findIndex((field)=>field.id === taxNumberFieldId);
        const hasTaxNumberField = taxNumberFieldIndex !== -1;
        if (hasTaxNumberField) allFields[taxNumberFieldIndex] = {
            ...allFields[taxNumberFieldIndex],
            onlyForCountries: [
                ...allFields[taxNumberFieldIndex].onlyForCountries ?? [],
                "Germany"
            ],
            value: "PLEASE COMPLETE, INFORMATION MISSING"
        };
    }
    // EPDU branch (United Arab Emirates) requires Document type, Document number,
    // Date of expiry and Country of issue for Signatory and UBO sections only —
    // auth contacts and directors are excluded per the FCTP country-specific matrix.
    const isEpduBranch = country === "United Arab Emirates";
    if (isEpduBranch) {
        const epduFieldSuffixes = [
            "doc_type",
            "doc_number",
            "expiry_date",
            "issue_country"
        ];
        const epduRelationTypes = [
            "ubo",
            "signatory"
        ];
        epduFieldSuffixes.forEach((suffix)=>{
            const fieldId = `relation_${relationNumber}_relation_type_updated_${suffix}`;
            const fieldIndex = allFields.findIndex((field)=>field.id === fieldId);
            const hasField = fieldIndex !== -1;
            if (hasField) {
                const field = allFields[fieldIndex];
                const relationTypeKey = `relation_${relationNumber}_relation_type_updated`;
                allFields[fieldIndex] = {
                    ...field,
                    onlyForCountries: [
                        ...field.onlyForCountries ?? [],
                        "United Arab Emirates"
                    ],
                    renderConditions: {
                        ...field.renderConditions,
                        [relationTypeKey]: epduRelationTypes
                    }
                };
            }
        });
    }
    const isEpbeClBranch = country === "Chile";
    if (isEpbeClBranch) {
        const isClResidentRelation = relationResidenceCountry === "Chile";
        const docNumberFieldId = `relation_${relationNumber}_relation_type_updated_doc_number`;
        const docNumberFieldIndex = allFields.findIndex((field)=>field.id === docNumberFieldId);
        const hasDocNumberField = docNumberFieldIndex !== -1;
        if (hasDocNumberField) {
            const docNumberAllowedRelationTypes = isClResidentRelation ? [
                "auth contact",
                "ubo",
                "director",
                "signatory"
            ] : [
                "auth contact",
                "ubo",
                "signatory"
            ];
            allFields[docNumberFieldIndex] = {
                ...allFields[docNumberFieldIndex],
                title: {
                    en: "RUT Number",
                    es: "N\xfamero de RUT",
                    nl: "RUT-nummer",
                    fr: "Num\xe9ro RUT",
                    pt: "N\xfamero RUT",
                    it: "Numero RUT",
                    de: "RUT-Nummer",
                    pl: "Numer RUT",
                    ro: "Num\u0103r RUT",
                    gr: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 RUT"
                },
                onlyForCountries: [
                    ...allFields[docNumberFieldIndex].onlyForCountries ?? [],
                    "Chile"
                ],
                renderConditions: {
                    ...allFields[docNumberFieldIndex].renderConditions,
                    [`relation_${relationNumber}_relation_type_updated`]: docNumberAllowedRelationTypes
                }
            };
        }
        const addressNarrowing = [
            {
                suffix: "city",
                allowedTypes: [
                    "signatory",
                    "ubo",
                    "director"
                ]
            },
            {
                suffix: "street_name",
                allowedTypes: [
                    "ubo",
                    "director"
                ]
            },
            {
                suffix: "county_state_province",
                allowedTypes: [
                    "ubo",
                    "director"
                ]
            },
            {
                suffix: "postal_code",
                allowedTypes: [
                    "ubo",
                    "director"
                ]
            }
        ];
        for (const { suffix: suffix, allowedTypes: allowedTypes } of addressNarrowing){
            const fieldId = `relation_${relationNumber}_relation_type_updated_${suffix}`;
            const fieldIndex = allFields.findIndex((field)=>field.id === fieldId);
            const hasField = fieldIndex !== -1;
            if (hasField) allFields[fieldIndex] = {
                ...allFields[fieldIndex],
                renderConditions: {
                    ...allFields[fieldIndex].renderConditions,
                    [`relation_${relationNumber}_relation_type_updated`]: allowedTypes
                }
            };
        }
    }
    let filteredFieldsByCountry = allFields.filter((field)=>!field.onlyForCountries || field.onlyForCountries.includes(countryToUse));
    if (isExistingRelation) filteredFieldsByCountry = filteredFieldsByCountry.filter((field)=>{
        const shouldInclude = !field.id.includes("dob") && !field.id.includes("gender") && !field.id.includes("birth_place") && !field.id.includes("_info");
        return shouldInclude;
    });
    const isEpbePlBranch = country === "Poland";
    const shouldRemovePlExpiredIdHardStop = isEpbePlBranch && isExistingRelation === true && didTheRelationChangeId !== undefined && [
        "auth contact",
        "signatory",
        "ubo"
    ].includes(relationType);
    if (shouldRemovePlExpiredIdHardStop) {
        const plAuthContactHardStopSuffixes = [
            "auth_contact_valid_certified_doc",
            "auth_contact_electronic_verification_method",
            "auth_contact_electronic_verification_method_message",
            "auth_contact_certified_doc"
        ];
        filteredFieldsByCountry = filteredFieldsByCountry.filter((field)=>{
            const isHardStopField = plAuthContactHardStopSuffixes.some((suffix)=>field.id === `relation_${relationNumber}_relation_type_updated_${suffix}`);
            return !isHardStopField;
        });
    }
    if (didTheRelationChangeId) filteredFieldsByCountry = filteredFieldsByCountry.map((field)=>{
        return {
            ...field,
            renderConditions: {
                ...field.renderConditions,
                [`${didTheRelationChangeId}`]: [
                    "changed"
                ]
            }
        };
    });
    const hasExistingValues = existingValues !== undefined && Object.keys(existingValues).length > 0;
    if (hasExistingValues) {
        const fieldIdPrefix = `relation_${relationNumber}_relation_type_updated_`;
        filteredFieldsByCountry = filteredFieldsByCountry.map((field)=>{
            const isPrefilledField = field.id.startsWith(fieldIdPrefix);
            if (!isPrefilledField) return field;
            const suffix = field.id.slice(fieldIdPrefix.length);
            const value = existingValues[suffix];
            const hasValue = value !== undefined && value.length > 0;
            if (!hasValue) return field;
            return {
                ...field,
                value: value
            };
        });
    }
    return filteredFieldsByCountry;
};
const $28925532ba5d204d$var$getAllFields = (relationNumber, isHighRisk)=>{
    const uboPercentage = isHighRisk ? "10" : "25";
    return [
        // Corporate Directors
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_legal_entity_name`,
            title: {
                en: "Legal Entity Name",
                es: "Nombre de entidad legal",
                nl: "Naam rechtspersoon",
                fr: "Nom de l'entit\xe9 juridique",
                pt: "Nome legal da empresa",
                it: "Nome dell'entit\xe0 legale",
                de: "Name der juristischen Person",
                pl: "Nazwa podmiotu prawnego",
                ro: "Persoan\u0103 juridic\u0103",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BD\u03BF\u03BC\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03BF\u03C3\u03CE\u03C0\u03BF\u03C5"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "corporate director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_country_of_incorporation`,
            title: {
                en: "Country of incorporation",
                es: "Pa\xeds de incorporaci\xf3n",
                nl: "land van oprichting",
                fr: "Pays de constitution",
                pt: "Pa\xeds de registro",
                it: "Paese di costituzione",
                de: "Land der Unternehmensgr\xfcndung",
                pl: "Kraj rejestracji",
                ro: "\u021Aara de constituire",
                gr: "\u03A7\u03CE\u03C1\u03B1 \u03C3\u03CD\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "corporate director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`,
            title: {
                en: `Provide the director or corporate director information that manages the corporate director that has just been added`,
                es: `Proporcione informaci\xf3n sobre el director o director corporativo que administre al director corporativo que acaba de agregar`,
                nl: `Geef informatie over de directeur of bedrijfsdirecteur die de zojuist toegevoegde bedrijfsdirecteur beheert`,
                fr: `Fournissez les informations du directeur corporatif g\xe9rant le directeur corporatif qui vient d'\xeatre ajout\xe9`,
                pt: `Providencie informa\xe7\xe3o sobre o representante/ diretor da empresa agora nomeada como diretora`,
                it: "Fornisci le informazioni del direttore o del direttore aziendale che gestisce il direttore aziendale appena aggiunto",
                de: `Geben Sie die Informationen des Gesch\xe4ftsf\xfchrers oder des Unternehmensleiters an, der den gerade hinzugef\xfcgten Unternehmensleiter verwaltet`,
                pl: `Uprzejmie prosimy o podanie informacji o dyrektorze (osoba fizyczna) lub dyrektorze korporacyjnym (osoba prawna), kt\xf3ry zarz\u{105}dza nowo dodanym dyrektorem korporacyjnym`,
                ro: `Furniza\u{21B}i informa\u{21B}ii despre directorul sau directorul corporativ, care se refer\u{103} la directorul corporativ care tocmai a fost ad\u{103}ugat`,
                gr: `\u{394}\u{3CE}\u{3C3}\u{3C4}\u{3B5} \u{3C4}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1} \u{3C4}\u{3BF}\u{3C5} \u{3B4}\u{3B9}\u{3B5}\u{3C5}\u{3B8}\u{3C5}\u{3BD}\u{3C4}\u{3AE} \u{3AE} \u{3C4}\u{3BF}\u{3C5} \u{3B5}\u{3C4}\u{3B1}\u{3B9}\u{3C1}\u{3B9}\u{3BA}\u{3BF}\u{3CD} \u{3C3}\u{3C4}\u{3B5}\u{3BB}\u{3AD}\u{3C7}\u{3BF}\u{3C5}\u{3C2} \u{3C0}\u{3BF}\u{3C5} \u{3B4}\u{3B9}\u{3B5}\u{3C5}\u{3B8}\u{3CD}\u{3BD}\u{3B5}\u{3B9} \u{3C4}\u{3BF} \u{3B4}\u{3B9}\u{3BF}\u{3B9}\u{3BA}\u{3B7}\u{3C4}\u{3B9}\u{3BA}\u{3CC} \u{3C3}\u{3C5}\u{3BC}\u{3B2}\u{3BF}\u{3CD}\u{3BB}\u{3B9}\u{3BF} \u{3C0}\u{3BF}\u{3C5} \u{3BC}\u{3CC}\u{3BB}\u{3B9}\u{3C2} \u{3C0}\u{3C1}\u{3BF}\u{3C3}\u{3C4}\u{3AD}\u{3B8}\u{3B7}\u{3BA}\u{3B5}`
            },
            type: "select",
            options: (0, $2aNQ5.secondaryRelationTypeOptions),
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "corporate director"
                ]
            }
        },
        // relation type info
        {
            id: `relation_${relationNumber}_relation_auth_contact_info`,
            title: {
                en: "Please provide details for the new authorised contact",
                es: "Proporcione detalles para el nuevo contacto autorizado",
                nl: "Gelieve de gegevens van de nieuwe geautoriseerde contactpersoon op te geven",
                fr: "Veuillez fournir les d\xe9tails du nouveau contact autoris\xe9",
                pt: `Providencie informa\xe7\xf5es adicionais dos novos contactos autorizados`,
                it: "Fornisci i dettagli del nuovo contatto autorizzato",
                de: "Bitte geben Sie Details zum neuen autorisierten Kontakt an",
                pl: "Prosimy o podanie danych nowego kontaktu autoryzowanego",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi detalii pentru noul contact autorizat",
                gr: "\u0394\u03CE\u03C3\u03C4\u03B5 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03BD\u03AD\u03B1 \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03B7\u03BC\u03AD\u03BD\u03B7 \u03B5\u03C0\u03B1\u03C6\u03AE"
            },
            type: "paragraph",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_ubo_info_25_percent`,
            title: {
                en: `Please state who the new UBO(s) of the company are and provide their personal details. In case there are intermediary layers in the shareholding structure holding ${uboPercentage}% or more of the shares please also include this information.`,
                es: `Por favor, proporcione qui\xe9nes son los nuevos titulares reales (UBOs) de la empresa y sus datos personales. En caso de que existan capas intermedias en la estructura accionarial que posean el ${uboPercentage}% o m\xe1s de las acciones, incluya tambi\xe9n esta informaci\xf3n.`,
                nl: `Vermeld hierbij wie de nieuwe UBO('s) van de onderneming zijn en geef hun persoonsgegevens door. Indien er tussenliggende lagen in de aandeelhoudersstructuur zijn die ${uboPercentage}% of meer van de aandelen bezitten, gelieve deze informatie ook op te nemen.`,
                fr: `Veuillez indiquer qui sont les nouveaux UBO de l'entreprise et fournir leurs coordonn\xe9es. En cas de couches interm\xe9diaires dans la structure actionnariale d\xe9tenant ${uboPercentage}% ou plus des actions, veuillez \xe9galement inclure cette information.`,
                pt: `Indique quem s\xe3o os novos benefici\xe1rios efectivos (UBO) da empresa e os seus dados pessoais. Caso existam empresas interm\xe9dias na estrutura acionista com ${uboPercentage}% ou mais das a\xe7\xf5es, inclua tamb\xe9m esta informa\xe7\xe3o.`,
                it: `Si prega di indicare chi sono i nuovi Titolari Effettivi (UBO) dell'azienda e di fornire i loro dati personali. Nel caso ci siano livelli intermedi nella struttura azionaria che detengono il ${uboPercentage}% o pi\xf9 delle azioni, si prega di includere anche queste informazioni.`,
                de: `Bitte geben Sie an, wer die neuen wirtschaftlich Berechtigten (UBOs) des Unternehmens sind, und machen Sie deren pers\xf6nliche Angaben. Falls es Zwischenebenen in der Beteiligungsstruktur gibt, die ${uboPercentage}% oder mehr der Anteile halten, f\xfcgen Sie bitte auch diese Informationen hinzu.`,
                pl: `Prosz\u{119} wskaza\u{107}, kto jest nowym beneficjentem rzeczywistym (UBO) firmy i poda\u{107} jego dane osobowe. W przypadku istnienia warstw po\u{15B}rednich w strukturze akcjonariatu posiadaj\u{105}cych ${uboPercentage}% lub wi\u{119}cej akcji, prosz\u{119} r\xf3wnie\u{17C} uwzgl\u{119}dni\u{107} te informacje.`,
                ro: `V\u{103} rug\u{103}m s\u{103} preciza\u{21B}i cine sunt noii beneficiari reali (UBO) ai companiei \u{219}i s\u{103} furniza\u{21B}i datele lor personale. \xcen cazul \xeen care exist\u{103} straturi intermediare \xeen structura ac\u{21B}ionariatului care de\u{21B}in ${uboPercentage}% sau mai mult din ac\u{21B}iuni, v\u{103} rug\u{103}m s\u{103} include\u{21B}i \u{219}i aceste informa\u{21B}ii.`,
                gr: `\u{3A0}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3B1}\u{3BB}\u{3CE} \u{3B4}\u{3B7}\u{3BB}\u{3CE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3BF}\u{3B9}\u{3BF}\u{3C2} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BF} \u{3BD}\u{3AD}\u{3BF}\u{3C2} \u{3C0}\u{3C1}\u{3B1}\u{3B3}\u{3BC}\u{3B1}\u{3C4}\u{3B9}\u{3BA}\u{3CC}\u{3C2} \u{3B4}\u{3B9}\u{3BA}\u{3B1}\u{3B9}\u{3BF}\u{3CD}\u{3C7}\u{3BF}\u{3C2} (UBO) \u{3C4}\u{3B7}\u{3C2} \u{3B5}\u{3C4}\u{3B1}\u{3B9}\u{3C1}\u{3B5}\u{3AF}\u{3B1}\u{3C2} \u{3BA}\u{3B1}\u{3B9} \u{3B4}\u{3CE}\u{3C3}\u{3C4}\u{3B5} \u{3C4}\u{3B1} \u{3C0}\u{3C1}\u{3BF}\u{3C3}\u{3C9}\u{3C0}\u{3B9}\u{3BA}\u{3AC} \u{3C4}\u{3BF}\u{3C5} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}. \u{3A3}\u{3B5} \u{3C0}\u{3B5}\u{3C1}\u{3AF}\u{3C0}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3BF}\u{3C5} \u{3C5}\u{3C0}\u{3AC}\u{3C1}\u{3C7}\u{3BF}\u{3C5}\u{3BD} \u{3B5}\u{3BD}\u{3B4}\u{3B9}\u{3AC}\u{3BC}\u{3B5}\u{3C3}\u{3B1} \u{3B5}\u{3C0}\u{3AF}\u{3C0}\u{3B5}\u{3B4}\u{3B1} \u{3C3}\u{3C4}\u{3B7} \u{3BC}\u{3B5}\u{3C4}\u{3BF}\u{3C7}\u{3B9}\u{3BA}\u{3AE} \u{3B4}\u{3BF}\u{3BC}\u{3AE} \u{3C0}\u{3BF}\u{3C5} \u{3BA}\u{3B1}\u{3C4}\u{3AD}\u{3C7}\u{3BF}\u{3C5}\u{3BD} ${uboPercentage}% \u{3AE} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3BF} \u{3C4}\u{3C9}\u{3BD} \u{3BC}\u{3B5}\u{3C4}\u{3BF}\u{3C7}\u{3CE}\u{3BD}, \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3B1}\u{3BB}\u{3CE} \u{3C3}\u{3C5}\u{3BC}\u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3BB}\u{3AC}\u{3B2}\u{3B5}\u{3C4}\u{3B5} \u{3BA}\u{3B1}\u{3B9} \u{3B1}\u{3C5}\u{3C4}\u{3AD}\u{3C2} \u{3C4}\u{3B9}\u{3C2} \u{3C0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}.`
            },
            type: "paragraph",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ]
            },
            onlyForCountries: [
                "United Kingdom",
                "Australia",
                "Canada",
                "Hong Kong",
                "United Arab Emirates",
                "Romania"
            ]
        },
        {
            id: `relation_${relationNumber}_relation_ubo_info_more_than_25_percent`,
            title: {
                en: `Please state who the new UBO(s) of the company are and provide their personal details. In case there are intermediary layers in the shareholding structure holding more than ${uboPercentage}% of the shares please also include this information.`,
                es: `Por favor, proporcione qui\xe9nes son los nuevos titulares reales (UBOs) de la empresa y sus datos personales. En caso de que existan capas intermedias en la estructura accionarial que posean m\xe1s del ${uboPercentage}% de las acciones, incluya tambi\xe9n esta informaci\xf3n.`,
                nl: `Vermeld hierbij wie de nieuwe UBO('s) van de onderneming zijn en geef hun persoonsgegevens door. Indien er tussenliggende lagen in de aandeelhoudersstructuur zijn die meer dan ${uboPercentage}% van de aandelen bezitten, gelieve deze informatie ook op te nemen.`,
                fr: `Veuillez indiquer qui sont les nouveaux UBO de l'entreprise et fournir leurs coordonn\xe9es. En cas de couches interm\xe9diaires dans la structure actionnariale d\xe9tenant plus de ${uboPercentage}% des actions, veuillez \xe9galement inclure cette information.`,
                pt: `Indique quem s\xe3o os novos benefici\xe1rios efectivos (UBO) da empresa e os seus dados pessoais. Caso existam empresas interm\xe9dias na estrutura acionista com mais de ${uboPercentage}% das a\xe7\xf5es, inclua tamb\xe9m esta informa\xe7\xe3o.`,
                it: `Si prega di indicare chi sono i nuovi Titolari Effettivi (UBO) dell'azienda e di fornire i loro dati personali. Nel caso ci siano livelli intermedi nella struttura azionaria che detengono pi\xf9 del ${uboPercentage}% delle azioni, si prega di includere anche queste informazioni.`,
                de: `Bitte geben Sie an, wer die neuen wirtschaftlich Berechtigten (UBOs) des Unternehmens sind, und machen Sie deren pers\xf6nliche Angaben. Falls es Zwischenebenen in der Beteiligungsstruktur gibt, die mehr als ${uboPercentage}% der Anteile halten, f\xfcgen Sie bitte auch diese Informationen hinzu.`,
                pl: `Prosz\u{119} wskaza\u{107}, kto jest nowym beneficjentem rzeczywistym (UBO) firmy i poda\u{107} jego dane osobowe. W przypadku istnienia warstw po\u{15B}rednich w strukturze akcjonariatu posiadaj\u{105}cych wi\u{119}cej ni\u{17C} ${uboPercentage}% akcji, prosz\u{119} r\xf3wnie\u{17C} uwzgl\u{119}dni\u{107} te informacje.`,
                ro: `V\u{103} rug\u{103}m s\u{103} preciza\u{21B}i cine sunt noii beneficiari reali (UBO) ai companiei \u{219}i s\u{103} furniza\u{21B}i datele lor personale. \xcen cazul \xeen care exist\u{103} straturi intermediare \xeen structura ac\u{21B}ionariatului care de\u{21B}in mai mult de ${uboPercentage}% din ac\u{21B}iuni, v\u{103} rug\u{103}m s\u{103} include\u{21B}i \u{219}i aceste informa\u{21B}ii.`,
                gr: `\u{3A0}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3B1}\u{3BB}\u{3CE} \u{3B4}\u{3B7}\u{3BB}\u{3CE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3BF}\u{3B9}\u{3BF}\u{3C2} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BF} \u{3BD}\u{3AD}\u{3BF}\u{3C2} \u{3C0}\u{3C1}\u{3B1}\u{3B3}\u{3BC}\u{3B1}\u{3C4}\u{3B9}\u{3BA}\u{3CC}\u{3C2} \u{3B4}\u{3B9}\u{3BA}\u{3B1}\u{3B9}\u{3BF}\u{3CD}\u{3C7}\u{3BF}\u{3C2} (UBO) \u{3C4}\u{3B7}\u{3C2} \u{3B5}\u{3C4}\u{3B1}\u{3B9}\u{3C1}\u{3B5}\u{3AF}\u{3B1}\u{3C2} \u{3BA}\u{3B1}\u{3B9} \u{3B4}\u{3CE}\u{3C3}\u{3C4}\u{3B5} \u{3C4}\u{3B1} \u{3C0}\u{3C1}\u{3BF}\u{3C3}\u{3C9}\u{3C0}\u{3B9}\u{3BA}\u{3AC} \u{3C4}\u{3BF}\u{3C5} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}. \u{3A3}\u{3B5} \u{3C0}\u{3B5}\u{3C1}\u{3AF}\u{3C0}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3BF}\u{3C5} \u{3C5}\u{3C0}\u{3AC}\u{3C1}\u{3C7}\u{3BF}\u{3C5}\u{3BD} \u{3B5}\u{3BD}\u{3B4}\u{3B9}\u{3AC}\u{3BC}\u{3B5}\u{3C3}\u{3B1} \u{3B5}\u{3C0}\u{3AF}\u{3C0}\u{3B5}\u{3B4}\u{3B1} \u{3C3}\u{3C4}\u{3B7} \u{3BC}\u{3B5}\u{3C4}\u{3BF}\u{3C7}\u{3B9}\u{3BA}\u{3AE} \u{3B4}\u{3BF}\u{3BC}\u{3AE} \u{3C0}\u{3BF}\u{3C5} \u{3BA}\u{3B1}\u{3C4}\u{3AD}\u{3C7}\u{3BF}\u{3C5}\u{3BD} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3BF} \u{3B1}\u{3C0}\u{3CC} ${uboPercentage}% \u{3C4}\u{3C9}\u{3BD} \u{3BC}\u{3B5}\u{3C4}\u{3BF}\u{3C7}\u{3CE}\u{3BD}, \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3B1}\u{3BB}\u{3CE} \u{3C3}\u{3C5}\u{3BC}\u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3BB}\u{3AC}\u{3B2}\u{3B5}\u{3C4}\u{3B5} \u{3BA}\u{3B1}\u{3B9} \u{3B1}\u{3C5}\u{3C4}\u{3AD}\u{3C2} \u{3C4}\u{3B9}\u{3C2} \u{3C0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}.`
            },
            type: "paragraph",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ]
            },
            onlyForCountries: [
                "Belgium",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Spain",
                "Poland",
                "Netherlands",
                "Luxembourg",
                "Portugal",
                "Bulgaria",
                "Ireland",
                "Lithuania"
            ]
        },
        {
            id: `relation_${relationNumber}_relation_director_info`,
            title: {
                en: "Please state who the current director(s) of the company are.",
                es: "Por favor, confirme qui\xe9nes son los admisnitradores actuales de la empresa.",
                nl: "Gelieve te vermelden wie de huidige directeur(en) van de vennootschap zijn.",
                fr: "Veuillez indiquer qui sont les directeurs actuels de la soci\xe9t\xe9.",
                pt: `Indique quem s\xe3o os atuais diretores da empresa.`,
                it: "Si prega di indicare chi sono gli attuali amministratori dell'azienda.",
                de: "Bitte geben Sie an, wer die aktuellen Gesch\xe4ftsf\xfchrer des Unternehmens sind.",
                pl: "Prosz\u0119 poda\u0107, kto jest obecnym dyrektorem (dyrektorami) firmy.",
                ro: "V\u0103 rug\u0103m s\u0103 preciza\u021Bi cine este (sunt) actualul (actualii) director(i) al (ai) companiei.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03B7\u03BB\u03CE\u03C3\u03C4\u03B5 \u03C0\u03BF\u03B9\u03BF\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF \u03C4\u03C1\u03AD\u03C7\u03C9\u03BD \u03B4\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AE\u03C2 (\u03AE \u03B4\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AD\u03C2) \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2."
            },
            type: "paragraph",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_signatory_info`,
            title: {
                en: "Please provide the updated details for the signatory.",
                es: "Por favor, proporcione los datos personales actualizados del firmante.",
                nl: "Gelieve de bijgewerkte gegevens van de ondertekenaar op te geven.",
                fr: "Veuillez fournir les d\xe9tails mis \xe0 jour pour le signataire.",
                pt: `Providencie os dados atualizados do signat\xe1rio.`,
                it: "Si prega di fornire i dettagli aggiornati per il firmatario.",
                de: "Bitte geben Sie die aktualisierten Daten f\xfcr den Unterzeichner an.",
                pl: "Prosz\u0119 poda\u0107 zaktualizowane dane dla sygnatariusza.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi detaliile actualizate pentru semnatar.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03BC\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03C5\u03C0\u03BF\u03B3\u03C1\u03AC\u03C6\u03BF\u03BD\u03C4\u03BF\u03C2."
            },
            type: "paragraph",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "signatory"
                ]
            }
        },
        //relation data
        {
            id: `relation_${relationNumber}_relation_type_updated_first_name`,
            title: {
                en: `First Name`,
                es: `Nombre`,
                nl: `Naam`,
                fr: `Pr\xe9nom`,
                pt: `Nome`,
                it: `Nome`,
                de: "Vorname",
                pl: "Imi\u0119",
                ro: "Prenume",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_middle_name`,
            title: {
                en: `Middle Name (optional)`,
                es: `Nombre compuesto (opcional)`,
                nl: `Midden-naam (optioneel)`,
                fr: `Deuxi\xe8me pr\xe9nom (optionnel)`,
                pt: `Nome do meio (opcional)`,
                it: `Nome del mezzo (opzionale)`,
                de: "Zweiter Vorname (optional)",
                pl: "Drugie imi\u0119 (opcjonalnie)",
                ro: "Al doilea prenume (op\u021Bional)",
                gr: "\u039C\u03B5\u03C3\u03B1\u03AF\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 (\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)"
            },
            type: "text",
            required: false,
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_surname`,
            title: {
                en: `Surname`,
                es: `Apellido`,
                nl: `Achternaam`,
                fr: `Nom de famille`,
                pt: `Sobrenome`,
                it: `Cognome`,
                de: "Nachname",
                pl: "Nazwisko",
                ro: "Nume de familie",
                gr: "\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_dob`,
            title: {
                en: `Date of Birth`,
                es: `Fecha de nacimiento`,
                nl: `Geboortedatum`,
                fr: `Date de naissance`,
                pt: `Data de nascimento`,
                it: `Data di nascita`,
                de: "Geburtsdatum",
                pl: "Data urodzenia",
                ro: "Data na\u0219terii",
                gr: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2"
            },
            type: "date",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_birth_place`,
            title: {
                en: `Place of Birth`,
                es: `Lugar de nacimiento`,
                nl: `Geboorteplaats`,
                fr: `Lieu de naissance`,
                pt: `Naturalidade`,
                it: `Luogo di nascita`,
                de: "Geburtsort",
                pl: "Miejsce urodzenia",
                ro: "Locul na\u0219terii",
                gr: "\u03A4\u03CC\u03C0\u03BF\u03C2 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2"
            },
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Portugal",
                "Romania",
                "Luxembourg"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_nationality`,
            title: {
                en: `Nationality`,
                es: `Nacionalidad`,
                nl: `Nationaliteit`,
                fr: `Nationalit\xe9`,
                pt: `Nacionalidade`,
                it: `Nazionalit\xe0`,
                de: "Staatsangeh\xf6rigkeit",
                pl: "Narodowo\u015B\u0107",
                ro: "Na\u021Bionalitate",
                gr: "\u0399\u03B8\u03B1\u03B3\u03AD\u03BD\u03B5\u03B9\u03B1"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_gender`,
            title: {
                en: `Gender`,
                es: `G\xe9nero`,
                nl: `Geslacht`,
                fr: `Genre`,
                pt: `G\xe9nero`,
                it: `Sesso`,
                de: "Geschlecht",
                pl: "P\u0142e\u0107",
                ro: "Gen",
                gr: "\u03A6\u03CD\u03BB\u03BF"
            },
            onlyForCountries: [
                "Belgium",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Luxembourg"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_street_name`,
            title: {
                en: `Street name and number`,
                es: `Nombre y n\xfamero de la calle`,
                nl: `Straatnaam en huisnummer`,
                fr: `Nom et num\xe9ro de rue`,
                pt: `Nome e n\xfamero da rua`,
                it: `Nome e numero civico`,
                de: "Stra\xdfe und Hausnummer",
                pl: "Nazwa ulicy i numer",
                ro: "Numele str\u0103zii \u0219i num\u0103rul",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BF\u03B4\u03BF\u03CD \u03BA\u03B1\u03B9 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_city`,
            title: {
                en: `City`,
                es: `Ciudad`,
                nl: `Stad`,
                fr: `Ville`,
                pt: `Cidade`,
                it: `Citt\xe0`,
                de: "Stadt",
                pl: "Miasto",
                ro: "Ora\u0219",
                gr: "\u03A0\u03CC\u03BB\u03B7"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_county_state_province`,
            title: {
                en: `County/State/Province`,
                es: `Condado/estado/provincia`,
                nl: `Provincie`,
                fr: `D\xe9partement/\xc9tat/Province`,
                pt: `Distrito`,
                it: `Contea/Stato/Provincia`,
                de: "Landkreis/Bundesland/Provinz",
                pl: "Hrabstwo/Stan/Prowincja",
                ro: "Jude\u021B/Stat/Provincie",
                gr: "\u039D\u03BF\u03BC\u03CC\u03C2/\u03A0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1/\u0395\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_country`,
            title: {
                en: `Country`,
                es: `Pa\xeds`,
                nl: `Land`,
                fr: `Pays`,
                pt: `Pa\xeds`,
                it: `Paese`,
                de: "Land",
                pl: "Kraj",
                ro: "\u021Aar\u0103",
                gr: "\u03A7\u03CE\u03C1\u03B1"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_postal_code`,
            title: {
                en: `Postal Code`,
                es: `C\xf3digo Postal`,
                nl: `Postcode`,
                fr: `Code postal`,
                pt: `C\xf3digo Postal`,
                it: `Codice Postale`,
                de: "Postleitzahl",
                pl: "Kod pocztowy",
                ro: "Cod po\u0219tal",
                gr: "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_phone_number`,
            title: {
                en: `Phone Number (landline or mobile)`,
                es: `N\xfamero de tel\xe9fono (tel\xe9fono fijo o m\xf3vil)`,
                nl: `Telefoonnummer (vaste of mobiel)`,
                fr: `Num\xe9ro de t\xe9l\xe9phone (ligne fixe ou mobile)`,
                pt: `N\xfamero de telefone`,
                it: `Numero di telefono (fisso o cellulare)`,
                de: "Telefonnummer (Festnetz oder Mobil)",
                pl: "Numer telefonu (stacjonarny lub kom\xf3rkowy)",
                ro: "Num\u0103r de telefon (fix sau mobil)",
                gr: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 (\u03C3\u03C4\u03B1\u03B8\u03B5\u03C1\u03CC \u03AE \u03BA\u03B9\u03BD\u03B7\u03C4\u03CC)"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_email`,
            title: {
                en: "Email",
                es: "Email",
                nl: "Email",
                fr: "Adresse e-mail",
                pt: "Email",
                it: "Email",
                de: "E-Mail",
                pl: "E-mail",
                ro: "Email",
                gr: "Email"
            },
            type: "email",
            required: true,
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_doc_type`,
            title: {
                en: `Document type`,
                es: `Tipo de Documento`,
                nl: `Type document`,
                fr: `Type de document`,
                pt: `Tipo de documento`,
                it: `Tipo di documento`,
                de: "Dokumententyp",
                pl: "Typ dokumentu",
                ro: "Tipul documentului",
                gr: "\u03A4\u03CD\u03C0\u03BF\u03C2 \u03B5\u03B3\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5"
            },
            type: "text",
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Portugal",
                "Romania",
                "Spain",
                "Luxembourg"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_doc_number`,
            title: {
                en: `Document Number`,
                es: `N\xfamero del Documento`,
                nl: `Document Nummer`,
                fr: `num\xe9ro de document`,
                pt: `N\xfamero de documento`,
                it: `Numero di documento`,
                de: "Dokumentennummer",
                pl: "Numer dokumentu",
                ro: "Num\u0103rul documentului",
                gr: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B5\u03B3\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5"
            },
            type: "text",
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Poland",
                "Portugal",
                "Romania",
                "Spain",
                "Luxembourg",
                "Netherlands"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_issue_date`,
            title: {
                en: `Date of Issue`,
                es: `Fecha de emisi\xf3n`,
                nl: `Uitgavedatum`,
                fr: `Date d'\xe9mission`,
                pt: `Data de emiss\xe3o`,
                it: `Data di emissione`,
                de: "Ausstellungsdatum",
                pl: "Data wydania",
                ro: "Data emiterii",
                gr: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7\u03C2"
            },
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Portugal",
                "Luxembourg"
            ],
            type: "date",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_expiry_date`,
            title: {
                en: `Date of Expiry`,
                es: `Fecha de caducidad`,
                nl: `vervaldatum`,
                fr: `Date d'expiration`,
                pt: `Data de validade`,
                it: `Data di scadenza`,
                de: "Ablaufdatum",
                pl: "Data wa\u017Cno\u015Bci",
                ro: "Data expir\u0103rii",
                gr: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2"
            },
            type: "date",
            onlyForCountries: [
                "Netherlands",
                "Romania"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_issue_country`,
            title: {
                en: `Country of Issue`,
                es: `Pa\xeds de Emisi\xf3n`,
                nl: `Land van afgifte`,
                fr: `Pays d'\xe9mission`,
                pt: `Pa\xeds de Emiss\xe3o`,
                it: `Paese di emissione`,
                de: "Ausstellungsland",
                pl: "Kraj wydania",
                ro: "\u021Aara emitent\u0103",
                gr: "\u03A7\u03CE\u03C1\u03B1 \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7\u03C2"
            },
            type: "text",
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Portugal",
                "Romania",
                "Spain",
                "Luxembourg"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_issue_place`,
            title: {
                en: `Place of Issue`,
                es: `Lugar de emisi\xf3n`,
                nl: `Plaats van afgifte`,
                fr: `Lieu d'\xe9mission`,
                pt: `Local de emiss\xe3o`,
                it: `Luogo di emissione`,
                de: "Ausstellungsort",
                pl: "Miejsce wydania",
                ro: "Locul emiterii",
                gr: "\u03A4\u03CC\u03C0\u03BF\u03C2 \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7\u03C2"
            },
            onlyForCountries: [
                "France",
                "Greece",
                "Italy",
                "Netherlands"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_tax_number`,
            title: {
                en: `Tax Identification Number`,
                es: `Numero de identificaci\xf3n fiscal`,
                nl: `BTW-nummer`,
                fr: `Num\xe9ro d'identification fiscale`,
                pt: `N\xfamero de identifica\xe7\xe3o fiscal`,
                it: `Codice Fiscale`,
                de: "Steueridentifikationsnummer",
                pl: "Numer identyfikacji podatkowej",
                ro: "Num\u0103r de identificare fiscal\u0103",
                gr: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03BF\u03CD \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5"
            },
            onlyForCountries: [
                "Belgium",
                "Greece",
                "Italy",
                "Poland",
                "Portugal",
                "Luxembourg"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_occupation`,
            title: {
                en: `Occupation`,
                es: `Ocupaci\xf3n`,
                nl: `Beroep`,
                fr: `Profession`,
                pt: `Ocupa\xe7\xe3o`,
                it: `Occupazione`,
                de: "Beruf",
                pl: "Zaw\xf3d",
                ro: "Ocupa\u021Bie",
                gr: "\u0395\u03C0\u03AC\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_occupation_street_name`,
            title: {
                en: `Street name and number`,
                es: `Nombre y n\xfamero de la calle`,
                nl: `Straatnaam en huisnummer`,
                fr: `Nom et num\xe9ro de rue`,
                pt: `Nome e n\xfamero da rua`,
                it: `Nome e numero civico`,
                de: "Stra\xdfe und Hausnummer",
                pl: "Nazwa ulicy i numer",
                ro: "Numele str\u0103zii \u0219i num\u0103rul",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BF\u03B4\u03BF\u03CD \u03BA\u03B1\u03B9 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_occupation_city`,
            title: {
                en: `City`,
                es: `Ciudad`,
                nl: `Stad`,
                fr: `Ville`,
                pt: `Cidade`,
                it: `Citt\xe0`,
                de: "Stadt",
                pl: "Miasto",
                ro: "Ora\u0219",
                gr: "\u03A0\u03CC\u03BB\u03B7"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_occupation_county_province_state`,
            title: {
                en: `County/State/Province`,
                es: `Condado/estado/provincia`,
                nl: `Provincie`,
                fr: `D\xe9partement/\xc9tat/Province`,
                pt: `Distrito`,
                it: `Contea/Stato/Provincia`,
                de: "Landkreis/Bundesland/Provinz",
                pl: "Hrabstwo/Stan/Prowincja",
                ro: "Jude\u021B/Stat/Provincie",
                gr: "\u039D\u03BF\u03BC\u03CC\u03C2/\u03A0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1/\u0395\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_occupation_country`,
            title: {
                en: `Country`,
                es: `Pa\xeds`,
                nl: `Land`,
                fr: `Pays`,
                pt: `Pa\xeds`,
                it: `Paese`,
                de: "Land",
                pl: "Kraj",
                ro: "\u021Aar\u0103",
                gr: "\u03A7\u03CE\u03C1\u03B1"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_occupation_postal_code`,
            title: {
                en: `Postal Code`,
                es: `C\xf3digo Postal`,
                nl: `Postcode`,
                fr: `Code postal`,
                pt: `C\xf3digo Postal`,
                it: `Codice Postale`,
                de: "Postleitzahl",
                pl: "Kod pocztowy",
                ro: "Cod po\u0219tal",
                gr: "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_fathers_name`,
            title: {
                en: `Father\u{2019}s Name`,
                es: `Nombre del Padre`,
                nl: `Naam van de vader`,
                fr: `Le nom du p\xe8re`,
                pt: `Nome do pai`,
                it: `Nome del padre`,
                de: "Name des Vaters",
                pl: "Imi\u0119 ojca",
                ro: "Numele tat\u0103lui",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B1\u03C4\u03C1\u03CC\u03C2"
            },
            type: "text",
            onlyForCountries: [
                "Greece"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact",
                    "ubo",
                    "director",
                    "signatory"
                ]
            }
        },
        //relation data for corporate director director
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_first_name`,
            title: {
                en: `First Name`,
                es: `Nombre`,
                nl: `Naam`,
                fr: `Pr\xe9nom`,
                pt: `Nome`,
                it: `Nome`,
                de: "Vorname",
                pl: "Imi\u0119",
                ro: "Prenume",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_middle_name`,
            title: {
                en: `Middle Name (optional)`,
                es: `Nombre compuesto (opcional)`,
                nl: `Midden-naam (optioneel)`,
                fr: `Deuxi\xe8me pr\xe9nom (optionnel)`,
                pt: `Nome do meio (opcional)`,
                it: `Secondo nome (facoltativo)`,
                de: "Zweiter Vorname (optional)",
                pl: "Drugie imi\u0119 (opcjonalnie)",
                ro: "Al doilea prenume (op\u021Bional)",
                gr: "\u039C\u03B5\u03C3\u03B1\u03AF\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 (\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)"
            },
            type: "text",
            required: false,
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_surname`,
            title: {
                en: `Surname`,
                es: `Apellido`,
                nl: `Achternaam`,
                fr: `Nom de famille`,
                pt: `Sobrenome`,
                it: `Cognome`,
                de: "Nachname",
                pl: "Nazwisko",
                ro: "Nume de familie",
                gr: "\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_dob`,
            title: {
                en: `Date of Birth`,
                es: `Fecha de nacimiento`,
                nl: `Geboortedatum`,
                fr: `Date de naissance`,
                pt: `Data de nascimento`,
                it: `Data di nascita`,
                de: "Geburtsdatum",
                pl: "Data urodzenia",
                ro: "Data na\u0219terii",
                gr: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2"
            },
            type: "date",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_birth_place`,
            title: {
                en: `Place of Birth`,
                es: `Lugar de nacimiento`,
                nl: `Geboorteplaats`,
                fr: `Lieu de naissance`,
                pt: `Naturalidade`,
                it: `Luogo di nascita`,
                de: "Geburtsort",
                pl: "Miejsce urodzenia",
                ro: "Locul na\u0219terii",
                gr: "\u03A4\u03CC\u03C0\u03BF\u03C2 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2"
            },
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Portugal",
                "Romania"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_nationality`,
            title: {
                en: `Nationality`,
                es: `Nacionalidad`,
                nl: `Nationaliteit`,
                fr: `Nationalit\xe9`,
                pt: `Nacionalidade`,
                it: `Nazionalit\xe0`,
                de: "Staatsangeh\xf6rigkeit",
                pl: "Narodowo\u015B\u0107",
                ro: "Na\u021Bionalitate",
                gr: "\u0399\u03B8\u03B1\u03B3\u03AD\u03BD\u03B5\u03B9\u03B1"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_corporate_director_director_updated_gender`,
            title: {
                en: `Gender`,
                es: `G\xe9nero`,
                nl: `Geslacht`,
                fr: `Genre`,
                pt: `G\xe9nero`,
                it: `Sesso`,
                de: "Geschlecht",
                pl: "P\u0142e\u0107",
                ro: "Gen",
                gr: "\u03A6\u03CD\u03BB\u03BF"
            },
            onlyForCountries: [
                "Belgium",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Luxembourg"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_street_name`,
            title: {
                en: `Street name and number`,
                es: `Nombre y n\xfamero de la calle`,
                nl: `Straatnaam en huisnummer`,
                fr: `Nom et num\xe9ro de rue`,
                pt: `Nome e n\xfamero da rua`,
                it: `Nome e numero civico`,
                de: "Stra\xdfe und Hausnummer",
                pl: "Nazwa ulicy i numer",
                ro: "Numele str\u0103zii \u0219i num\u0103rul",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BF\u03B4\u03BF\u03CD \u03BA\u03B1\u03B9 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_city`,
            title: {
                en: `City`,
                es: `Ciudad`,
                nl: `Stad`,
                fr: `Ville`,
                pt: `Cidade`,
                it: `Citt\xe0`,
                de: "Stadt",
                pl: "Miasto",
                ro: "Ora\u0219",
                gr: "\u03A0\u03CC\u03BB\u03B7"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_county_state_province`,
            title: {
                en: `County/State/Province`,
                es: `Condado/estado/provincia`,
                nl: `Provincie`,
                fr: `D\xe9partement/\xc9tat/Province`,
                pt: `Distrito`,
                it: `Contea/Stato/Provincia`,
                de: "Landkreis/Bundesland/Provinz",
                pl: "Hrabstwo/Stan/Prowincja",
                ro: "Jude\u021B/Stat/Provincie",
                gr: "\u039D\u03BF\u03BC\u03CC\u03C2/\u03A0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1/\u0395\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_country`,
            title: {
                en: `Country`,
                es: `Pa\xeds`,
                nl: `Land`,
                fr: `Pays`,
                pt: `Pa\xeds`,
                it: `Paese`,
                de: "Land",
                pl: "Kraj",
                ro: "\u021Aar\u0103",
                gr: "\u03A7\u03CE\u03C1\u03B1"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_postal_code`,
            title: {
                en: `Postal Code`,
                es: `C\xf3digo Postal`,
                nl: `Postcode`,
                fr: `Code postal`,
                pt: `C\xf3digo Postal`,
                it: `Codice Postale`,
                de: "Postleitzahl",
                pl: "Kod pocztowy",
                ro: "Cod po\u0219tal",
                gr: "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2"
            },
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_phone_number`,
            title: {
                en: `Phone Number (landline or mobile)`,
                es: `N\xfamero de tel\xe9fono (tel\xe9fono fijo o m\xf3vil)`,
                nl: `Telefoonnummer (vaste of mobiel)`,
                fr: `Num\xe9ro de t\xe9l\xe9phone (ligne fixe ou mobile)`,
                pt: `N\xfamero de telefone`,
                it: `Numero di telefono (fisso o cellulare)`,
                de: "Telefonnummer (Festnetz oder Mobil)",
                pl: "Numer telefonu (stacjonarny lub kom\xf3rkowy)",
                ro: "Num\u0103r de telefon (fix sau mobil)",
                gr: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 (\u03C3\u03C4\u03B1\u03B8\u03B5\u03C1\u03CC \u03AE \u03BA\u03B9\u03BD\u03B7\u03C4\u03CC)"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_doc_type`,
            title: {
                en: `Document type`,
                es: `Tipo de Documento`,
                nl: `Type document`,
                fr: `Type de document`,
                pt: `Tipo de documento`,
                it: `Tipo di documento`,
                de: "Dokumententyp",
                pl: "Typ dokumentu",
                ro: "Tipul documentului",
                gr: "\u03A4\u03CD\u03C0\u03BF\u03C2 \u03B5\u03B3\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5"
            },
            type: "text",
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Portugal",
                "Romania",
                "Spain",
                "Luxembourg"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_doc_number`,
            title: {
                en: `Document Number`,
                es: `N\xfamero del Documento`,
                nl: `Document Nummer`,
                fr: `num\xe9ro de document`,
                pt: `N\xfamero de documento`,
                it: `Numero di documento`,
                de: "Dokumentennummer",
                pl: "Numer dokumentu",
                ro: "Num\u0103rul documentului",
                gr: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B5\u03B3\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5"
            },
            type: "text",
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Poland",
                "Portugal",
                "Romania",
                "Spain",
                "Luxembourg"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_issue_date`,
            title: {
                en: `Date of Issue`,
                es: `Fecha de emisi\xf3n`,
                nl: `Uitgavedatum`,
                fr: `Date d'\xe9mission`,
                pt: `Data de emiss\xe3o`,
                it: `Data di emissione`,
                de: "Ausstellungsdatum",
                pl: "Data wydania",
                ro: "Data emiterii",
                gr: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7\u03C2"
            },
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Portugal",
                "Romania",
                "Luxembourg"
            ],
            type: "date",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_expiry_date`,
            title: {
                en: `Date of Expiry`,
                es: `Fecha de caducidad`,
                nl: `vervaldatum`,
                fr: `Date d'expiration`,
                pt: `Data de validade`,
                it: `Data di scadenza`,
                de: "Ablaufdatum",
                pl: "Data wa\u017Cno\u015Bci",
                ro: "Data expir\u0103rii",
                gr: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2"
            },
            type: "date",
            onlyForCountries: [
                "Netherlands",
                "Portugal"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_issue_country`,
            title: {
                en: `Country of Issue`,
                es: `Pa\xeds de Emisi\xf3n`,
                nl: `Land van afgifte`,
                fr: `Pays d'\xe9mission`,
                pt: `Pa\xeds emissor`,
                it: `Paese di emissione`,
                de: "Ausstellungsland",
                pl: "Kraj wydania",
                ro: "\u021Aara emitent\u0103",
                gr: "\u03A7\u03CE\u03C1\u03B1 \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7\u03C2"
            },
            type: "text",
            onlyForCountries: [
                "Belgium",
                "Bulgaria",
                "Czech Republic",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Poland",
                "Portugal",
                "Romania",
                "Spain",
                "Luxembourg"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_issue_place`,
            title: {
                en: `Place of Issue`,
                es: `Lugar de emisi\xf3n`,
                nl: `Plaats van afgifte`,
                fr: `Lieu d'\xe9mission`,
                pt: `Lugar de emiss\xe3o`,
                it: `Luogo di emissione`,
                de: "Ausstellungsort",
                pl: "Miejsce wydania",
                ro: "Locul emiterii",
                gr: "\u03A4\u03CC\u03C0\u03BF\u03C2 \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7\u03C2"
            },
            onlyForCountries: [
                "France",
                "Greece",
                "Italy",
                "Netherlands"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_tax_number`,
            title: {
                en: `Tax Identification Number`,
                es: `Numero de identificaci\xf3n fiscal`,
                nl: `BTW-nummer`,
                fr: `Num\xe9ro d'identification fiscale`,
                pt: `N\xfamero de identifica\xe7\xe3o fiscal`,
                it: `Numero di identificazione fiscale`,
                de: "Steueridentifikationsnummer",
                pl: "Numer identyfikacji podatkowej",
                ro: "Num\u0103r de identificare fiscal\u0103",
                gr: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03BF\u03CD \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5"
            },
            onlyForCountries: [
                "Belgium",
                "Greece",
                "Italy",
                "Poland",
                "Portugal",
                "Luxembourg"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_occupation`,
            title: {
                en: `Occupation`,
                es: `Ocupaci\xf3n`,
                nl: `Beroep`,
                fr: `Profession`,
                pt: `Profiss\xe3o`,
                it: `Occupazione`,
                de: "Beruf",
                pl: "Zaw\xf3d",
                ro: "Ocupa\u021Bie",
                gr: "\u0395\u03C0\u03AC\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_occupation_street_name`,
            title: {
                en: `Street name and number`,
                es: `Nombre y n\xfamero de la calle`,
                nl: `Straatnaam en huisnummer`,
                fr: `Nom et num\xe9ro de rue`,
                pt: `Nome e n\xfamero da rua`,
                it: `Nome e numero civico`,
                de: "Stra\xdfe und Hausnummer",
                pl: "Nazwa ulicy i numer",
                ro: "Numele str\u0103zii \u0219i num\u0103rul",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BF\u03B4\u03BF\u03CD \u03BA\u03B1\u03B9 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text"
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_occupation_city`,
            title: {
                en: `City`,
                es: `Ciudad`,
                nl: `Stad`,
                fr: `Ville`,
                pt: `Cidade`,
                it: `Citt\xe0`,
                de: "Stadt",
                pl: "Miasto",
                ro: "Ora\u0219",
                gr: "\u03A0\u03CC\u03BB\u03B7"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_occupation_county_province_state`,
            title: {
                en: `County/State/Province`,
                es: `Condado/estado/provincia`,
                nl: `Provincie`,
                fr: `D\xe9partement/\xc9tat/Province`,
                pt: `Distrito`,
                it: `Contea/Stato/Provincia`,
                de: "Landkreis/Bundesland/Provinz",
                pl: "Hrabstwo/Stan/Prowincja",
                ro: "Jude\u021B/Stat/Provincie",
                gr: "\u039D\u03BF\u03BC\u03CC\u03C2/\u03A0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1/\u0395\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_occupation_country`,
            title: {
                en: `Country`,
                es: `Pa\xeds`,
                nl: `Land`,
                fr: `Pays`,
                pt: `Pa\xeds`,
                it: `Paese`,
                de: "Land",
                pl: "Kraj",
                ro: "\u021Aar\u0103",
                gr: "\u03A7\u03CE\u03C1\u03B1"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_occupation_postal_code`,
            title: {
                en: `Postal Code`,
                es: `C\xf3digo Postal`,
                nl: `Postcode`,
                fr: `Code postal`,
                pt: `C\xf3digo Postal`,
                it: `Codice Postale`,
                de: "Postleitzahl",
                pl: "Kod pocztowy",
                ro: "Cod po\u0219tal",
                gr: "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2"
            },
            onlyForCountries: [
                "Greece"
            ],
            type: "text",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        ...(0, $2tUDf.getRelationDocRequirements)(relationNumber),
        (0, $2aNQ5.getRelationDivider)(relationNumber)
    ];
};

});
parcelRegister("2tUDf", function(module, exports) {

$parcel$export(module.exports, "getRelationDocRequirements", function () { return $9d28424ad6690571$export$b58da3630a5de9aa; });

var $2aNQ5 = parcelRequire("2aNQ5");
const $9d28424ad6690571$export$b58da3630a5de9aa = (relationNumber)=>{
    return [
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_fathers_name`,
            title: {
                en: `Father\u{2019}s Name`,
                es: `Nombre del Padre`,
                nl: `Naam van de vader`,
                fr: `Le nom du p\xe8re`,
                pt: `Nome do pai`,
                it: `Nome del padre`,
                de: "Name des Vaters",
                pl: "Imi\u0119 ojca",
                ro: "Numele tat\u0103lui",
                gr: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B1\u03C4\u03C1\u03CC\u03C2"
            },
            type: "text",
            onlyForCountries: [
                "Greece"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        //DOC REQUIREMENTS FOR AUTH CONTACT
        {
            id: `relation_${relationNumber}_relation_type_updated_auth_contact_valid_doc`,
            title: {
                en: `Please provide a valid ID document.`,
                es: `Proporcione un documento de identidad en vigor. `,
                nl: `Geef een geldig identiteitsbewijs op`,
                fr: `Veuillez fournir une pi\xe8ce d'identit\xe9 valide`,
                pt: `Providencie um documento de identifica\xe7\xe3o v\xe1lido`,
                it: `Fornisci un documento di identit\xe0 valido`,
                de: "Bitte legen Sie einen g\xfcltigen Ausweis vor.",
                pl: "Prosz\u0119 dostarczy\u0107 wa\u017Cny dokument to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document de identitate valabil.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            type: "file",
            description: (0, $2aNQ5.idDocsDescription),
            onlyForCountries: [
                "Italy",
                "Portugal",
                "Bulgaria",
                "Ireland",
                "Lithuania"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_auth_contact_valid_certified_doc`,
            title: {
                en: `Please provide a valid and certified ID document.`,
                es: `Por favor, proporcione una copia certificada del Documento De Identidad. El documento de identidad debe estar en vigor.`,
                nl: `Graag ontvangen wij een geldig en gecertificeerd identiteitsbewijs.`,
                fr: `Veuillez fournir une pi\xe8ce d'identit\xe9 valide et certifi\xe9e.`,
                pt: `Providencie um documento de identifica\xe7\xe3o v\xe1lido e autenticado`,
                it: "Si prega di fornire un documento d'identit\xe0 valido e certificato",
                de: "Bitte legen Sie einen g\xfcltigen und beglaubigten Ausweis vor.",
                pl: "Prosz\u0119 dostarczy\u0107 wa\u017Cny i po\u015Bwiadczony dokument to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document de identitate valabil \u0219i certificat.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03BA\u03B1\u03B9 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            type: "file",
            description: (0, $2aNQ5.idDocsDescription),
            onlyForCountries: [
                "Czechia",
                "Greece",
                "Poland"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_auth_contact_electronic_verification_method`,
            title: {
                en: `Would you like to complete the identity verification using an electronic verification method?`,
                es: `\xbfPreferir\xeda utilizar un m\xe9todo de verificaci\xf3n de identidad electr\xf3nica?`,
                nl: `Wilt u liever een elektronische identiteitsverificatiemethode gebruiken?`,
                fr: `Pr\xe9f\xe9reriez-vous utiliser une m\xe9thode de v\xe9rification d\u{2019}identit\xe9 \xe9lectronique ?`,
                pt: `Deseja completar a verifica\xe7\xe3o de identidade utilizando um m\xe9todo de verifica\xe7\xe3o eletr\xf3nica?`,
                it: "Vuoi completare la verifica dell'identit\xe0 utilizzando un metodo di verifica elettronica?",
                de: "M\xf6chten Sie die Identit\xe4tspr\xfcfung mit einer elektronischen Verifizierungsmethode durchf\xfchren?",
                pl: "Czy chcesz zako\u0144czy\u0107 weryfikacj\u0119 to\u017Csamo\u015Bci za pomoc\u0105 metody weryfikacji elektronicznej?",
                ro: "Dori\u021Bi s\u0103 finaliza\u021Bi verificarea identit\u0103\u021Bii utiliz\xe2nd o metod\u0103 de verificare electronic\u0103?",
                gr: "\u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03BC\u03B9\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2;"
            },
            type: "select",
            options: (0, $2aNQ5.yesOrNoOptions),
            description: (0, $2aNQ5.idDocsDescription),
            onlyForCountries: [
                "Canada",
                "Belgium",
                "Czechia",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Spain",
                "Poland",
                "Netherlands",
                "Luxembourg",
                "Portugal",
                "Bulgaria",
                "Romania",
                "Ireland",
                "Lithuania"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_auth_contact_electronic_verification_method_message`,
            type: "paragraph",
            title: {
                en: "Please contact your relationship manager or KYC@ebury.com for them to give you a link to complete the electronic identity verification",
                es: "P\xf3ngase en contacto con su gerente de relaciones o kyc@ebury.com para que le den un enlace para completar la verificaci\xf3n de identidad electr\xf3nica",
                nl: "Neem contact op met uw relatiebeheerder of KYC@ebury.com zodat zij u een link kunnen geven waarmee u de elektronische identiteitsverificatie kunt voltooien",
                fr: "Veuillez contacter votre responsable relationnel ou KYC@ebury.com pour qu'il vous fournisse un lien permettant de compl\xe9ter la v\xe9rification \xe9lectronique de l'identit\xe9.",
                pt: "Contacte o seu gestor de conta ou KYC@ebury.com para que lhe proporcione um link para a verifica\xe7\xe3o de identifdade eletr\xf3nica",
                it: "Contatta il tuo relationship manager o KYC@ebury.com affinch\xe9 ti forniscano un collegamento per completare la verifica dell'identit\xe0 elettronica",
                de: "Bitte kontaktieren Sie Ihren Kundenbetreuer oder KYC@ebury.com, damit dieser Ihnen einen Link zur Durchf\xfchrung der elektronischen Identit\xe4tspr\xfcfung zukommen l\xe4sst.",
                pl: "Skontaktuj si\u0119 ze swoim mened\u017Cerem ds. relacji lub KYC@ebury.com, aby otrzyma\u0107 link do uko\u0144czenia elektronicznej weryfikacji to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 contacta\u021Bi managerul de rela\u021Bii sau KYC@ebury.com pentru a v\u0103 oferi un link pentru a finaliza verificarea electronic\u0103 a identit\u0103\u021Bii.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03C5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF \u03C0\u03B5\u03BB\u03B1\u03C4\u03B5\u03B9\u03B1\u03BA\u03CE\u03BD \u03C3\u03C7\u03AD\u03C3\u03B5\u03C9\u03BD \u03AE \u03C4\u03BF KYC@ebury.com \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03B4\u03CE\u03C3\u03BF\u03C5\u03BD \u03AD\u03BD\u03B1\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact"
                ],
                [`relation_${relationNumber}_relation_type_updated_auth_contact_electronic_verification_method`]: [
                    true
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_auth_contact_certified_doc`,
            title: {
                en: `Please upload a certified ID document for each new authorised contact.`,
                es: `Sube un documento de identificaci\xf3n certificado para cada nuevo contacto autorizado.`,
                nl: `Upload voor elk nieuw geautoriseerd contact een gecertificeerd identiteitsbewijs.`,
                fr: `Veuillez t\xe9l\xe9charger une pi\xe8ce d'identit\xe9 certifi\xe9e pour chaque nouveau contact autoris\xe9.`,
                pt: `Anexe um documento de identifica\xe7\xe3o certificado para cada novo contacto autorizado.`,
                it: "Carica un documento di identit\xe0 certificato per ogni nuovo contatto autorizzato.",
                de: "Bitte laden Sie f\xfcr jeden neuen autorisierten Kontakt ein beglaubigtes Ausweisdokument hoch.",
                pl: "Prosz\u0119 przes\u0142a\u0107 po\u015Bwiadczony dokument to\u017Csamo\u015Bci dla ka\u017Cdego nowego autoryzowanego kontaktu.",
                ro: "V\u0103 rug\u0103m s\u0103 \xeenc\u0103rca\u021Bi un document de identitate certificat pentru fiecare nou contact autorizat.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03BD\u03AD\u03B1 \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03B7\u03BC\u03AD\u03BD\u03B7 \u03B5\u03C0\u03B1\u03C6\u03AE."
            },
            type: "file",
            description: (0, $2aNQ5.idDocsDescription),
            onlyForCountries: [
                "Czechia",
                "France",
                "Germany",
                "Italy",
                "Spain",
                "Poland",
                "Netherlands",
                "Luxembourg",
                "Bulgaria",
                "Romania"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact"
                ],
                [`relation_${relationNumber}_relation_type_updated_auth_contact_electronic_verification_method`]: [
                    false
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_auth_contact_address_doc`,
            title: {
                en: `Please provide a proof of address document dated within the last 3 months.`,
                es: `Proporcione un documento de prueba de direcci\xf3n emitido en los \xfaltimos 3 meses.`,
                nl: `Gelieve een bewijs van adres op te geven dat gedateerd is binnen de afgelopen 3 maanden.`,
                fr: `Veuillez fournir un justificatif de domicile dat\xe9 de moins de 3 mois.`,
                pt: `Providencie um comprovativo de endere\xe7o com data dos \xfaltimos 3 meses.`,
                it: "Fornisci un documento di prova dell'indirizzo datato negli ultimi 3 mesi.",
                de: "Bitte legen Sie einen Adressnachweis vor, der innerhalb der letzten 3 Monate datiert ist.",
                pl: "Prosz\u0119 dostarczy\u0107 dokument potwierdzaj\u0105cy adres, datowany w ci\u0105gu ostatnich 3 miesi\u0119cy.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document doveditor al adresei, datat \xeen ultimele 3 luni.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03B1\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7\u03C2 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 \u03BC\u03B5 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B5\u03BD\u03C4\u03CC\u03C2 \u03C4\u03C9\u03BD \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03C9\u03BD 3 \u03BC\u03B7\u03BD\u03CE\u03BD."
            },
            type: "file",
            onlyForCountries: [
                "Canada",
                "Germany",
                "Greece",
                "Italy",
                "Netherlands",
                "Luxembourg",
                "Portugal",
                "Bulgaria",
                "Romania"
            ],
            description: (0, $2aNQ5.addressProofDescription),
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "auth contact"
                ]
            }
        },
        // DOC REQUIREMENTS FOR UBO
        {
            id: `relation_${relationNumber}_relation_type_updated_ubo_sharehold_structure_doc_signed`,
            title: {
                en: `Please provide a document showing the shareholder structure, this must include all intermediary layers in the shareholding structure until reaching the UBO(s) and signed by the legal representative of the company`,
                es: `Por favor, proporcione un documento que refleje la estructura accionarial incluyendo todas las capas intermedias hasta llegar al titular real (UBO) y firmado por el representante legal de la empresa.`,
                nl: `Gelieve een document aan te leveren waaruit de aandeelhoudersstructuur blijkt, dit moet alle tussenliggende lagen in de aandeelhoudersstructuur omvatten tot aan de UBO('s) en ondertekend zijn door de wettelijke vertegenwoordiger van de onderneming.`,
                fr: `Veuillez fournir un document montrant la structure actionnariale, celui-ci doit inclure toutes les couches interm\xe9diaires de la structure actionnariale jusqu'\xe0 atteindre le(s) UBO et \xeatre sign\xe9 par le repr\xe9sentant l\xe9gal de l'entreprise.`,
                pt: `Providencie um documento da estrutura acionista, incluindo todas as empresas interm\xe9dias at\xe9 ao benefici\xe1rio efetivo (UBO) e assinado pelo representante legal da empresa.`,
                it: "Si prega di fornire un documento che mostri la struttura azionaria; questo deve includere tutti gli strati intermedi nella struttura della partecipazione azionaria fino al/ai Titolare/i Effettivo/i e firmato dal rappresentante legale dell'azienda.",
                de: "Bitte legen Sie ein Dokument vor, das die Aktion\xe4rsstruktur zeigt. Dieses muss alle Zwischenebenen in der Beteiligungsstruktur bis zum Erreichen des/der wirtschaftlich Berechtigten (UBOs) enthalten und vom gesetzlichen Vertreter des Unternehmens unterzeichnet sein.",
                pl: "Prosz\u0119 dostarczy\u0107 dokument przedstawiaj\u0105cy struktur\u0119 akcjonariatu, kt\xf3ry musi zawiera\u0107 wszystkie warstwy po\u015Brednie w strukturze udzia\u0142\xf3w a\u017C do osi\u0105gni\u0119cia beneficjenta(-\xf3w) rzeczywistego(-ych) (UBO) i podpisany przez prawnego przedstawiciela firmy.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document care s\u0103 arate structura ac\u021Bionariatului, acesta trebuie s\u0103 includ\u0103 toate straturile intermediare din structura ac\u021Bionariatului p\xe2n\u0103 la atingerea beneficiarului (beneficiarilor) reali (UBO) \u0219i semnat de reprezentantul legal al companiei.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C0\u03BF\u03C5 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C7\u03BD\u03B5\u03B9 \u03C4\u03B7 \u03BC\u03B5\u03C4\u03BF\u03C7\u03B9\u03BA\u03AE \u03B4\u03BF\u03BC\u03AE, \u03C4\u03BF \u03BF\u03C0\u03BF\u03AF\u03BF \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03B9 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03B5\u03BD\u03B4\u03B9\u03AC\u03BC\u03B5\u03C3\u03B1 \u03B5\u03C0\u03AF\u03C0\u03B5\u03B4\u03B1 \u03C3\u03C4\u03B7 \u03BC\u03B5\u03C4\u03BF\u03C7\u03B9\u03BA\u03AE \u03B4\u03BF\u03BC\u03AE \u03BC\u03AD\u03C7\u03C1\u03B9 \u03BD\u03B1 \u03C6\u03C4\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD/\u03C3\u03C4\u03BF\u03C5\u03C2 \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03B9\u03BA\u03CC(-\u03BF\u03CD\u03C2) \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF(-\u03BF\u03C5\u03C2) (UBO) \u03BA\u03B1\u03B9 \u03C5\u03C0\u03BF\u03B3\u03B5\u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03BD\u03BF \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BD\u03CC\u03BC\u03B9\u03BC\u03BF \u03B5\u03BA\u03C0\u03C1\u03CC\u03C3\u03C9\u03C0\u03BF \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2."
            },
            type: "file",
            onlyForCountries: [
                "United Arab Emirates",
                "Belgium",
                "Czechia",
                "France",
                "Germany",
                "Greece",
                "Italy",
                "Spain",
                "Poland",
                "Netherlands",
                "Luxembourg",
                "Portugal",
                "Bulgaria",
                "Romania",
                "Ireland",
                "Lithuania",
                "Chile"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_ubo_sharehold_structure_doc_certified`,
            title: {
                en: `Please provide a document showing the shareholder structure, this must include all intermediary layers in the shareholding structure until reaching the UBO(s) and certified by a verifiable third party`,
                es: `Por favor, proporcione un documento que refleje la estructura accionarial incluyendo todas las capas intermedias hasta llegar al titular real (UBO) y certificado por un tercero verificable.`,
                nl: `Gelieve een document aan te leveren waaruit de aandeelhoudersstructuur blijkt, dit moet alle tussenliggende lagen in de aandeelhoudersstructuur omvatten tot aan de UBO('s) en gecertificeerd zijn door een verifieerbare derde partij.`,
                fr: `Veuillez fournir un document montrant la structure actionnariale, celui-ci doit inclure toutes les couches interm\xe9diaires de la structure actionnariale jusqu'\xe0 atteindre le(s) UBO et \xeatre certifi\xe9 par un tiers v\xe9rifiable.`,
                pt: `Providencie um documento da estrutura acionista, incluindo todas as empresas interm\xe9dias at\xe9 ao benefici\xe1rio efetivo (UBO) e certificado por terceiros verific\xe1veis.`,
                it: "Si prega di fornire un documento che mostri la struttura azionaria; questo deve includere tutti gli strati intermedi nella struttura della partecipazione azionaria fino al/ai Titolare/i Effettivo/i e certificato da una terza parte verificabile.",
                de: "Bitte legen Sie ein Dokument vor, das die Aktion\xe4rsstruktur zeigt. Dieses muss alle Zwischenebenen in der Beteiligungsstruktur bis zum Erreichen des/der wirtschaftlich Berechtigten (UBOs) enthalten und von einer nachpr\xfcfbaren dritten Partei beglaubigt sein.",
                pl: "Prosz\u0119 dostarczy\u0107 dokument przedstawiaj\u0105cy struktur\u0119 akcjonariatu, kt\xf3ry musi zawiera\u0107 wszystkie warstwy po\u015Brednie w strukturze udzia\u0142\xf3w a\u017C do osi\u0105gni\u0119cia beneficjenta(-\xf3w) rzeczywistego(-ych) (UBO) i po\u015Bwiadczony przez weryfikowaln\u0105 stron\u0119 trzeci\u0105.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document care s\u0103 arate structura ac\u021Bionariatului, acesta trebuie s\u0103 includ\u0103 toate straturile intermediare din structura ac\u021Bionariatului p\xe2n\u0103 la atingerea beneficiarului (beneficiarilor) reali (UBO) \u0219i certificat de o ter\u021B\u0103 parte verificabil\u0103.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C0\u03BF\u03C5 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C7\u03BD\u03B5\u03B9 \u03C4\u03B7 \u03BC\u03B5\u03C4\u03BF\u03C7\u03B9\u03BA\u03AE \u03B4\u03BF\u03BC\u03AE, \u03C4\u03BF \u03BF\u03C0\u03BF\u03AF\u03BF \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03B9 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03B5\u03BD\u03B4\u03B9\u03AC\u03BC\u03B5\u03C3\u03B1 \u03B5\u03C0\u03AF\u03C0\u03B5\u03B4\u03B1 \u03C3\u03C4\u03B7 \u03BC\u03B5\u03C4\u03BF\u03C7\u03B9\u03BA\u03AE \u03B4\u03BF\u03BC\u03AE \u03BC\u03AD\u03C7\u03C1\u03B9 \u03BD\u03B1 \u03C6\u03C4\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD/\u03C3\u03C4\u03BF\u03C5\u03C2 \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03B9\u03BA\u03CC(-\u03BF\u03CD\u03C2) \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF(-\u03BF\u03C5\u03C2) (UBO) \u03BA\u03B1\u03B9 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03B1\u03C0\u03CC \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03B9\u03BC\u03BF \u03C4\u03C1\u03AF\u03C4\u03BF \u03BC\u03AD\u03C1\u03BF\u03C2."
            },
            type: "file",
            onlyForCountries: [
                "United Kingdom",
                "Australia",
                "Canada",
                "Hong Kong"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_ubo_valid_doc`,
            title: {
                en: `Please provide a valid ID document for all new UBOs.`,
                es: `Por favor, proporcione una copia del Documento De Identidad de todos los nuevos titulares reales.`,
                nl: `Gelieve voor alle nieuwe UBO\u{2019}s een geldig identiteitsbewijs op te geven.`,
                fr: `Veuillez fournir une pi\xe8ce d\u{2019}identit\xe9 valide pour tous les nouveaux UBO.`,
                pt: `Proporcione um documento de identifica\xe7\xe3o v\xe1lido para todos os novos UBOs.`,
                it: "Si prega di fornire un documento d'identit\xe0 valido per tutti i nuovi Titolari Effettivi.",
                de: "Bitte legen Sie f\xfcr alle neuen wirtschaftlich Berechtigten (UBOs) ein g\xfcltiges Ausweisdokument vor.",
                pl: "Prosz\u0119 dostarczy\u0107 wa\u017Cny dokument to\u017Csamo\u015Bci dla wszystkich nowych beneficjent\xf3w rzeczywistych (UBO).",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document de identitate valabil pentru to\u021Bi noii beneficiari reali (UBO).",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BD\u03AD\u03BF\u03C5\u03C2 \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C5\u03C2 (UBO)."
            },
            type: "file",
            description: (0, $2aNQ5.idDocsDescription),
            onlyForCountries: [
                "Belgium",
                "France",
                "Italy",
                "Spain",
                "Portugal",
                "Romania"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_ubo_valid_certified_doc`,
            title: {
                en: `Please provide a valid and certified ID document for all new UBOs.`,
                es: `Por favor, proporcione una copia certificada del Documento De Identidad de todos los nuevos titulares reales.`,
                nl: `Voor alle nieuwe UBO\u{2019}s dient u een geldig en gewaarmerkt identiteitsbewijs te verstrekken`,
                fr: `Veuillez fournir une pi\xe8ce d\u{2019}identit\xe9 valide et certifi\xe9e pour tous les nouveaux UBO.`,
                pt: `Providencie um documento de identifica\xe7\xe3o v\xe1lido e certificado para todos os novos UBOs.`,
                it: "Si prega di fornire un documento d'identit\xe0 valido e certificato per tutti i nuovi Titolari Effettivi.",
                de: "Bitte legen Sie f\xfcr alle neuen wirtschaftlich Berechtigten (UBOs) ein g\xfcltiges und beglaubigtes Ausweisdokument vor.",
                pl: "Prosz\u0119 dostarczy\u0107 wa\u017Cny i po\u015Bwiadczony dokument to\u017Csamo\u015Bci dla wszystkich nowych beneficjent\xf3w rzeczywistych (UBO).",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document de identitate valabil \u0219i certificat pentru to\u021Bi noii beneficiari reali (UBO).",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03BA\u03B1\u03B9 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BD\u03AD\u03BF\u03C5\u03C2 \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C5\u03C2 (UBO)."
            },
            type: "file",
            description: {
                en: "Please provide a valid and certified ID document. ID documents should be in date and government issued and contain at least full name, photograph and date of birth. Certifications must be carried out by professionals authorised to do so in your country, be signed and contain the details of the certifier.",
                es: "Por favor, proporcione una copia certificada del Documento De Identidad. El documento de identidad debe estar en vigor e incluir, por lo menos, nombre completo, fotograf\xeda y fecha de nacimiento.  Las certificaciones deben llevarse a cabo por profesionales autorizados para ello siguiendo la normativa de su pa\xeds, y deben estar firmados e incluir los detalles del certificador.",
                nl: "Graag ontvangen wij een geldig en gecertificeerd identiteitsbewijs. Identiteitsdocumenten moeten de datum en de door de overheid afgegeven datum hebben en ten minste de volledige naam, foto en geboortedatum bevatten. Certificeringen moeten worden uitgevoerd door professionals die daartoe in uw land geautoriseerd zijn, de documenten moeten ondertekend zijn en de gegevens van de certificeerder bevatten.",
                fr: "Veuillez fournir une pi\xe8ce d'identit\xe9 valide et certifi\xe9e. Les documents d'identit\xe9 doivent \xeatre dat\xe9s et d\xe9livr\xe9s par le Gouvernement et contenir au moins le nom complet, la photographie et la date de naissance. Les certifications doivent \xeatre r\xe9alis\xe9es par des professionnels habilit\xe9s \xe0 le faire dans votre pays, \xeatre sign\xe9es et contenir les coordonn\xe9es du certificateur.",
                pt: "Providencie um documento de identifica\xe7\xe3o v\xe1lido e certificado. Os documentos de identifica\xe7\xe3o devem estar dentro do prazo de validade, ser emitidos pelo governo e conter pelo menos o nome completo, fotografia e data de nascimento. As certifica\xe7\xf5es devem ser realizadas por profissionais autorizados no seu pa\xeds, ser assinadas e conter os dados do certificador.",
                it: "Si prega di fornire un documento d'identit\xe0 valido e certificato. I documenti d'identit\xe0 devono essere in corso di validit\xe0 e rilasciati dal governo, e devono contenere almeno nome completo, fotografia e data di nascita. Le certificazioni devono essere eseguite da professionisti autorizzati a farlo nel vostro paese, essere firmate e contenere i dettagli del certificatore.",
                de: "Bitte legen Sie ein g\xfcltiges und beglaubigtes Ausweisdokument vor. Ausweisdokumente sollten aktuell und von einer Regierungsbeh\xf6rde ausgestellt sein und mindestens den vollst\xe4ndigen Namen, ein Foto und das Geburtsdatum enthalten. Beglaubigungen m\xfcssen von in Ihrem Land dazu befugten Fachleuten durchgef\xfchrt werden, unterzeichnet sein und die Angaben des Beglaubigers enthalten.",
                pl: "Prosz\u0119 dostarczy\u0107 wa\u017Cny i po\u015Bwiadczony dokument to\u017Csamo\u015Bci. Dokumenty to\u017Csamo\u015Bci powinny by\u0107 aktualne, wydane przez organ pa\u0144stwowy i zawiera\u0107 co najmniej imi\u0119 i nazwisko, zdj\u0119cie oraz dat\u0119 urodzenia. Po\u015Bwiadczenia musz\u0105 by\u0107 wykonane przez profesjonalist\xf3w upowa\u017Cnionych do tego w Pa\u0144stwa kraju, by\u0107 podpisane i zawiera\u0107 dane osoby po\u015Bwiadczaj\u0105cej.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document de identitate valabil \u0219i certificat. Documentele de identitate trebuie s\u0103 fie la zi, emise de o autoritate guvernamental\u0103 \u0219i s\u0103 con\u021Bin\u0103 cel pu\u021Bin numele complet, fotografia \u0219i data na\u0219terii. Certific\u0103rile trebuie efectuate de profesioni\u0219ti autoriza\u021Bi \xeen \u021Bara dumneavoastr\u0103, s\u0103 fie semnate \u0219i s\u0103 con\u021Bin\u0103 detaliile certificatorului.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03B5\u03AF\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03BA\u03B1\u03B9 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2. \u03A4\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03BD \u03B9\u03C3\u03C7\u03CD, \u03B5\u03BA\u03B4\u03BF\u03B8\u03AD\u03BD\u03C4\u03B1 \u03B1\u03C0\u03CC \u03BA\u03C1\u03B1\u03C4\u03B9\u03BA\u03AE \u03B1\u03C1\u03C7\u03AE \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03BF\u03C5\u03BD \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03BF\u03BD\u03BF\u03BC\u03B1\u03C4\u03B5\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF, \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2. \u039F\u03B9 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B4\u03B9\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03B7\u03BC\u03AD\u03BD\u03BF\u03C5\u03C2 \u03BD\u03B1 \u03C4\u03BF \u03C0\u03C1\u03AC\u03C4\u03C4\u03BF\u03C5\u03BD \u03C3\u03C4\u03B7 \u03C7\u03CE\u03C1\u03B1 \u03C3\u03B1\u03C2, \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03B3\u03B5\u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03BF\u03C5\u03BD \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BD\u03C4\u03BF\u03C2."
            },
            onlyForCountries: [
                "Luxembourg",
                "Portugal"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_ubo_electronic_verification_method`,
            title: {
                en: `Would you like to complete the identity verification using an electronic verification method?`,
                es: `\xbfLe gustar\xeda completar la verificaci\xf3n de identidad utilizando un m\xe9todo de verificaci\xf3n electr\xf3nica?`,
                nl: `Wilt u de identiteitsverificatie via een elektronische verificatiemethode voltooien?`,
                fr: `Souhaitez-vous effectuer la v\xe9rification d\u{2019}identit\xe9 \xe0 l\u{2019}aide d\u{2019}une m\xe9thode de v\xe9rification \xe9lectronique?`,
                pt: `Deseja completar a verifica\xe7\xe3o de identidade utilizando um m\xe9todo de verifica\xe7\xe3o eletr\xf3nica?`,
                it: "Vuoi completare la verifica dell'identit\xe0 utilizzando un metodo di verifica elettronica?",
                de: "M\xf6chten Sie die Identit\xe4tspr\xfcfung mit einer elektronischen Verifizierungsmethode durchf\xfchren?",
                pl: "Czy chcesz zako\u0144czy\u0107 weryfikacj\u0119 to\u017Csamo\u015Bci za pomoc\u0105 metody weryfikacji elektronicznej?",
                ro: "Dori\u021Bi s\u0103 finaliza\u021Bi verificarea identit\u0103\u021Bii utiliz\xe2nd o metod\u0103 de verificare electronic\u0103?",
                gr: "\u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03BC\u03B9\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2;"
            },
            type: "select",
            options: (0, $2aNQ5.yesOrNoOptions),
            onlyForCountries: [
                "Switzerland",
                "Australia",
                "Hong Kong",
                "United Arab Emirates",
                "Bulgaria",
                "Greece",
                "Netherlands",
                "Romania",
                "Ireland"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_ubo_electronic_verification_method_message`,
            type: "paragraph",
            title: {
                en: "Please contact your relationship manager or KYC@ebury.com for them to give you a link to complete the electronic identity verification",
                es: "P\xf3ngase en contacto con su gerente de relaciones o kyc@ebury.com para que le den un enlace para completar la verificaci\xf3n de identidad electr\xf3nica",
                nl: "Neem contact op met uw relatiebeheerder of KYC@ebury.com zodat zij u een link kunnen geven waarmee u de elektronische identiteitsverificatie kunt voltooien",
                fr: "Veuillez contacter votre responsable relationnel ou KYC@ebury.com pour qu'il vous fournisse un lien permettant de compl\xe9ter la v\xe9rification \xe9lectronique de l'identit\xe9.",
                pt: "Contacte o seu gestor de conta ou KYC@ebury.com para que lhe proporcione um link para a verifica\xe7\xe3o de identifdade eletr\xf3nica",
                it: "Contatta il tuo relationship manager o KYC@ebury.com affinch\xe9 ti forniscano un collegamento per completare la verifica dell'identit\xe0 elettronica",
                de: "Bitte kontaktieren Sie Ihren Kundenbetreuer oder KYC@ebury.com, damit dieser Ihnen einen Link zur Durchf\xfchrung der elektronischen Identit\xe4tspr\xfcfung zukommen l\xe4sst.",
                pl: "Skontaktuj si\u0119 ze swoim mened\u017Cerem ds. relacji lub KYC@ebury.com, aby otrzyma\u0107 link do uko\u0144czenia elektronicznej weryfikacji to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 contacta\u021Bi managerul de rela\u021Bii sau KYC@ebury.com pentru a v\u0103 oferi un link pentru a finaliza verificarea electronic\u0103 a identit\u0103\u021Bii.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03C5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF \u03C0\u03B5\u03BB\u03B1\u03C4\u03B5\u03B9\u03B1\u03BA\u03CE\u03BD \u03C3\u03C7\u03AD\u03C3\u03B5\u03C9\u03BD \u03AE \u03C4\u03BF KYC@ebury.com \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03B4\u03CE\u03C3\u03BF\u03C5\u03BD \u03AD\u03BD\u03B1\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            onlyForCountries: [
                "Switzerland",
                "Australia",
                "Canada",
                "Hong Kong",
                "United Arab Emirates",
                "Germany",
                "Bulgaria"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ],
                [`relation_${relationNumber}_relation_type_updated_ubo_electronic_verification_method`]: [
                    true
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_ubo_certified_doc`,
            title: {
                en: `Please upload a certified ID document.`,
                es: `Por favor, proporcione suba una copia certificada del Documento de Identidad.`,
                nl: `Upload een gecertificeerd identiteitsbewijs.`,
                fr: `Veuillez t\xe9l\xe9charger une pi\xe8ce d'identit\xe9 certifi\xe9e.`,
                pt: `Anexe um documento de identifica\xe7\xe3o certificado.`,
                it: "Si prega di caricare un documento d'identit\xe0 certificato.",
                de: "Bitte laden Sie ein beglaubigtes Ausweisdokument hoch.",
                pl: "Prosz\u0119 przes\u0142a\u0107 po\u015Bwiadczony dokument to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 \xeenc\u0103rca\u021Bi un document de identitate certificat.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            type: "file",
            onlyForCountries: [
                "Switzerland",
                "Australia",
                "Hong Kong",
                "United Arab Emirates",
                "Bulgaria",
                "Greece",
                "Netherlands",
                "Romania",
                "Ireland"
            ],
            description: (0, $2aNQ5.idDocsDescription),
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ],
                [`relation_${relationNumber}_relation_type_updated_ubo_electronic_verification_method`]: [
                    false
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_ubo_address_doc`,
            title: {
                en: `Please provide a proof of address document dated within the last 3 month for all new UBOs.`,
                es: `Por favor, proporcione un justificante de domicilio emitido en los \xfaltimos 3 meses para todos los nuevos titulares reales (UBOs).`,
                nl: `UVoor alle nieuwe UBO's verzoeken wij u een adresbewijs mee te sturen dat gedateerd is binnen de afgelopen 3 maanden.`,
                fr: `Veuillez fournir un justificatif de domicile dat\xe9 de moins de 3 mois pour tous les nouveaux UBO.`,
                pt: `Providencie um comprovativo de endere\xe7o com data dos \xfaltimos 3 meses para todos os novos UBOs`,
                it: "Si prega di fornire un documento di prova dell'indirizzo datato negli ultimi 3 mesi per tutti i nuovi Titolari Effettivi.",
                de: "Bitte legen Sie f\xfcr alle neuen wirtschaftlich Berechtigten (UBOs) einen Adressnachweis vor, der innerhalb der letzten 3 Monate datiert ist.",
                pl: "Prosz\u0119 dostarczy\u0107 dokument potwierdzaj\u0105cy adres, datowany w ci\u0105gu ostatnich 3 miesi\u0119cy, dla wszystkich nowych beneficjent\xf3w rzeczywistych (UBO).",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document doveditor al adresei, datat \xeen ultimele 3 luni, pentru to\u021Bi noii beneficiari reali (UBO).",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03B1\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7\u03C2 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 \u03BC\u03B5 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B5\u03BD\u03C4\u03CC\u03C2 \u03C4\u03C9\u03BD \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03C9\u03BD 3 \u03BC\u03B7\u03BD\u03CE\u03BD \u03B3\u03B9\u03B1 \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BD\u03AD\u03BF\u03C5\u03C2 \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03B9\u03BA\u03BF\u03CD\u03BF\u03C5\u03C2 \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C5\u03C2 (UBO)."
            },
            type: "file",
            onlyForCountries: [
                "Australia",
                "Greece"
            ],
            description: (0, $2aNQ5.addressProofDescription),
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "ubo"
                ]
            }
        },
        //DOC REQUIREMENTS FOR DIRECTORS
        {
            id: `relation_${relationNumber}_relation_type_updated_directors_doc`,
            title: {
                en: `Please provide an official/third party document showing the current directors of the company`,
                es: `Por favor, proporcione un documento oficial o de terceros que muestre los directores actuales de la empresa.`,
                nl: `Gelieve een officieel document/document van derden te verstrekken waaruit de huidige bestuurders van de vennootschap blijken.`,
                fr: `Veuillez fournir un document officiel/de tiers indiquant les administrateurs actuels de la soci\xe9t\xe9.`,
                pt: `Providencie um documento oficial que indique os atuais diretores da empresa.`,
                it: "Si prega di fornire un documento ufficiale/di terze parti che mostri gli attuali amministratori dell'azienda.",
                de: "Bitte legen Sie ein offizielles/Drittanbieter-Dokument vor, das die aktuellen Gesch\xe4ftsf\xfchrer des Unternehmens zeigt.",
                pl: "Prosz\u0119 dostarczy\u0107 oficjalny dokument/dokument od strony trzeciej, przedstawiaj\u0105cy obecnych dyrektor\xf3w firmy.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document oficial/de la ter\u021Bi care s\u0103 arate directorii actuali ai companiei.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03B5\u03C0\u03AF\u03C3\u03B7\u03BC\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF/\u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03C1\u03AF\u03C4\u03BF\u03C5 \u03BC\u03AD\u03C1\u03BF\u03C5\u03C2 \u03C0\u03BF\u03C5 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C7\u03BD\u03B5\u03B9 \u03C4\u03BF\u03C5\u03C2 \u03C4\u03C1\u03AD\u03C7\u03BF\u03BD\u03C4\u03B5\u03C2 \u03B4\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AD\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2."
            },
            type: "file",
            onlyForCountries: [
                "United Arab Emirates"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_director_electronic_verification_method`,
            title: {
                en: `Would you like to complete the identity verification using an electronic verification method?`,
                es: `\xbfLe gustar\xeda completar la verificaci\xf3n de identidad utilizando un m\xe9todo de verificaci\xf3n electr\xf3nica?`,
                nl: `Wilt u de identiteitsverificatie via een elektronische verificatiemethode voltooien?`,
                fr: `Souhaitez-vous effectuer la v\xe9rification d\u{2019}identit\xe9 \xe0 l\u{2019}aide d\u{2019}une m\xe9thode de v\xe9rification \xe9lectronique?`,
                pt: `Deseja completar a verifica\xe7\xe3o de identidade utilizando um m\xe9todo de verifica\xe7\xe3o eletr\xf3nica?`,
                it: "Vuoi completare la verifica dell'identit\xe0 utilizzando un metodo di verifica elettronica?",
                de: "M\xf6chten Sie die Identit\xe4tspr\xfcfung mit einer elektronischen Verifizierungsmethode durchf\xfchren?",
                pl: "Czy chcesz zako\u0144czy\u0107 weryfikacj\u0119 to\u017Csamo\u015Bci za pomoc\u0105 metody weryfikacji elektronicznej?",
                ro: "Dori\u021Bi s\u0103 finaliza\u021Bi verificarea identit\u0103\u021Bii utiliz\xe2nd o metod\u0103 de verificare electronic\u0103?",
                gr: "\u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03BC\u03B9\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2;"
            },
            type: "select",
            options: (0, $2aNQ5.yesOrNoOptions),
            onlyForCountries: [
                "United Kingdom",
                "Hong Kong"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_director_electronic_verification_method_message`,
            type: "paragraph",
            title: {
                en: "Please contact your relationship manager or KYC@ebury.com for them to give you a link to complete the electronic identity verification",
                es: "P\xf3ngase en contacto con su gerente de relaciones o kyc@ebury.com para que le den un enlace para completar la verificaci\xf3n de identidad electr\xf3nica",
                nl: "Neem contact op met uw relatiebeheerder of KYC@ebury.com zodat zij u een link kunnen geven waarmee u de elektronische identiteitsverificatie kunt voltooien",
                fr: "Veuillez contacter votre responsable relationnel ou KYC@ebury.com pour qu'il vous fournisse un lien permettant de compl\xe9ter la v\xe9rification \xe9lectronique de l'identit\xe9.",
                pt: "Contacte o seu gestor de conta ou KYC@ebury.com para que lhe proporcione um link para a verifica\xe7\xe3o de identifdade eletr\xf3nica",
                it: "Contatta il tuo relationship manager o KYC@ebury.com affinch\xe9 ti forniscano un collegamento per completare la verifica dell'identit\xe0 elettronica",
                de: "Bitte kontaktieren Sie Ihren Kundenbetreuer oder KYC@ebury.com, damit dieser Ihnen einen Link zur Durchf\xfchrung der elektronischen Identit\xe4tspr\xfcfung zukommen l\xe4sst.",
                pl: "Skontaktuj si\u0119 ze swoim mened\u017Cerem ds. relacji lub KYC@ebury.com, aby otrzyma\u0107 link do uko\u0144czenia elektronicznej weryfikacji to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 contacta\u021Bi managerul de rela\u021Bii sau KYC@ebury.com pentru a v\u0103 oferi un link pentru a finaliza verificarea electronic\u0103 a identit\u0103\u021Bii.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03C5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF \u03C0\u03B5\u03BB\u03B1\u03C4\u03B5\u03B9\u03B1\u03BA\u03CE\u03BD \u03C3\u03C7\u03AD\u03C3\u03B5\u03C9\u03BD \u03AE \u03C4\u03BF KYC@ebury.com \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03B4\u03CE\u03C3\u03BF\u03C5\u03BD \u03AD\u03BD\u03B1\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            onlyForCountries: [
                "Hong Kong"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "director"
                ],
                [`relation_${relationNumber}_relation_type_updated_director_electronic_verification_method`]: [
                    true
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_director_certified_doc`,
            title: {
                en: `Please upload a certified ID document.`,
                es: `Por favor, proporcione suba una copia certificada del Documento de Identidad.`,
                nl: `Upload een gecertificeerd identiteitsbewijs.`,
                fr: `Veuillez t\xe9l\xe9charger une pi\xe8ce d'identit\xe9 certifi\xe9e.`,
                pt: `Anexe um documento de identifica\xe7\xe3o certificado.`,
                it: "Carica un documento di identit\xe0 certificato per ogni nuovo contatto autorizzato.",
                de: "Bitte laden Sie ein beglaubigtes Ausweisdokument hoch.",
                pl: "Prosz\u0119 przes\u0142a\u0107 po\u015Bwiadczony dokument to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 \xeenc\u0103rca\u021Bi un document de identitate certificat.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            type: "file",
            description: (0, $2aNQ5.idDocsDescription),
            onlyForCountries: [
                "Hong Kong"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "director"
                ],
                [`relation_${relationNumber}_relation_type_updated_director_electronic_verification_method`]: [
                    false
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_director_address_doc`,
            title: {
                en: `Please provide a proof of address document.`,
                es: `Proporcione un documento de prueba de direcci\xf3n.`,
                nl: `Gelieve een bewijs van adres op te geven.`,
                fr: `Veuillez fournir un justificatif de domicile.`,
                pt: `Providencie um comprovativo de endere\xe7o.`,
                it: "Fornisci un documento di prova dell'indirizzo.",
                de: "Bitte legen Sie einen Adressnachweis vor.",
                pl: "Prosz\u0119 dostarczy\u0107 dokument potwierdzaj\u0105cy adres.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document doveditor al adresei.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03B1\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7\u03C2 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2."
            },
            type: "file",
            description: (0, $2aNQ5.addressProofDescription),
            onlyForCountries: [
                "United Kingdom",
                "United Arab Emirates"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "director"
                ]
            }
        },
        //DOC REQUIREMENTS FOR CORPORATE DIRECTOR DIRECTORS
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_directors_doc`,
            title: {
                en: `Please provide a proof of address document dated within the last 3 month for all new UBOs.`,
                es: `Por favor, proporcione un justificante de domicilio emitido en los \xfaltimos 3 meses para todos los nuevos titulares reales (UBOs).`,
                nl: `Voor alle nieuwe UBO's verzoeken wij u een adresbewijs mee te sturen dat gedateerd is binnen de afgelopen 3 maanden.`,
                fr: `Veuillez fournir un justificatif de domicile dat\xe9 de moins de 3 mois pour tous les nouveaux UBO.`,
                pt: `Providencie um comprovativo de endere\xe7o com data dos \xfaltimos 3 meses para todos os novos UBOs.`,
                it: "Si prega di fornire un documento di prova dell'indirizzo datato negli ultimi 3 mesi per tutti i nuovi Titolari Effettivi.",
                de: "Bitte reichen Sie f\xfcr alle neuen wirtschaftlich Berechtigten (UBOs) einen Adressnachweis ein, der innerhalb der letzten 3 Monate ausgestellt wurde.",
                pl: "Prosimy o dostarczenie dokumentu potwierdzaj\u0105cego adres zamieszkania wystawionego w ci\u0105gu ostatnich 3 miesi\u0119cy dla wszystkich nowych UBO.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document de dovad\u0103 a adresei emis \xeen ultimele 3 luni pentru to\u021Bi noii UBO.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03BD\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B5\u03BA\u03B4\u03BF\u03B8\u03B5\u03AF \u03C4\u03BF\u03C5\u03C2 \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03BF\u03C5\u03C2 3 \u03BC\u03AE\u03BD\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BD\u03AD\u03BF\u03C5\u03C2 UBO."
            },
            type: "file",
            onlyForCountries: [
                "United Arab Emirates"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_electronic_verification_method`,
            title: {
                en: `Would you like to complete the identity verification using an electronic verification method?`,
                es: `\xbfPreferir\xeda utilizar un m\xe9todo de verificaci\xf3n de identidad electr\xf3nica?`,
                nl: `Wilt u liever een elektronische identiteitsverificatiemethode gebruiken?`,
                fr: `Pr\xe9f\xe9reriez-vous utiliser une m\xe9thode de v\xe9rification d\u{2019}identit\xe9 \xe9lectronique ?`,
                pt: `Deseja completar a verifica\xe7\xe3o de identidade utilizando um m\xe9todo de verifica\xe7\xe3o eletr\xf3nica?`,
                it: "Vuoi completare la verifica dell'identit\xe0 utilizzando un metodo di verifica elettronica?",
                de: "M\xf6chten Sie die Identit\xe4tspr\xfcfung mit einer elektronischen Verifizierungsmethode durchf\xfchren?",
                pl: "Czy chcesz zako\u0144czy\u0107 weryfikacj\u0119 to\u017Csamo\u015Bci za pomoc\u0105 metody weryfikacji elektronicznej?",
                ro: "Dori\u021Bi s\u0103 finaliza\u021Bi verificarea identit\u0103\u021Bii utiliz\xe2nd o metod\u0103 de verificare electronic\u0103?",
                gr: "\u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03BC\u03B9\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2;"
            },
            type: "select",
            options: (0, $2aNQ5.yesOrNoOptions),
            onlyForCountries: [
                "Hong Kong"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_electronic_verification_method_message`,
            type: "paragraph",
            title: {
                en: "Please contact your relationship manager or KYC@ebury.com for them to give you a link to complete the electronic identity verification",
                es: "P\xf3ngase en contacto con su gerente de relaciones o kyc@ebury.com para que le den un enlace para completar la verificaci\xf3n de identidad electr\xf3nica",
                nl: "Neem contact op met uw relatiebeheerder of KYC@ebury.com zodat zij u een link kunnen geven waarmee u de elektronische identiteitsverificatie kunt voltooien",
                fr: "Veuillez contacter votre responsable relationnel ou KYC@ebury.com pour qu'il vous fournisse un lien permettant de compl\xe9ter la v\xe9rification \xe9lectronique de l'identit\xe9.",
                pt: "Contacte o seu gestor de conta ou KYC@ebury.com para que lhe proporcione um link para a verifica\xe7\xe3o de identifdade eletr\xf3nica",
                it: "Contatta il tuo relationship manager o KYC@ebury.com affinch\xe9 ti forniscano un collegamento per completare la verifica dell'identit\xe0 elettronica",
                de: "Bitte kontaktieren Sie Ihren Kundenbetreuer oder KYC@ebury.com, damit dieser Ihnen einen Link zur Durchf\xfchrung der elektronischen Identit\xe4tspr\xfcfung zukommen l\xe4sst.",
                pl: "Skontaktuj si\u0119 ze swoim mened\u017Cerem ds. relacji lub KYC@ebury.com, aby otrzyma\u0107 link do uko\u0144czenia elektronicznej weryfikacji to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 contacta\u021Bi managerul de rela\u021Bii sau KYC@ebury.com pentru a v\u0103 oferi un link pentru a finaliza verificarea electronic\u0103 a identit\u0103\u021Bii.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03C5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF \u03C0\u03B5\u03BB\u03B1\u03C4\u03B5\u03B9\u03B1\u03BA\u03CE\u03BD \u03C3\u03C7\u03AD\u03C3\u03B5\u03C9\u03BD \u03AE \u03C4\u03BF KYC@ebury.com \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03B4\u03CE\u03C3\u03BF\u03C5\u03BD \u03AD\u03BD\u03B1\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            onlyForCountries: [
                "Hong Kong"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated`]: [
                    "director"
                ],
                [`relation_${relationNumber}_relation_type_updated_corporate_director_director_electronic_verification_method`]: [
                    true
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_certified_doc`,
            title: {
                en: `Please upload a certified ID document.`,
                es: `Por favor, proporcione suba una copia certificada del Documento de Identidad.`,
                nl: `Upload een gecertificeerd identiteitsbewijs.`,
                fr: `Veuillez t\xe9l\xe9charger une pi\xe8ce d'identit\xe9 certifi\xe9e.`,
                pt: `Anexe um documento de identifica\xe7\xe3o certificado.`,
                it: "Si prega di caricare un documento d'identit\xe0 certificato.",
                de: "Bitte laden Sie ein beglaubigtes Ausweisdokument hoch.",
                pl: "Prosz\u0119 przes\u0142a\u0107 po\u015Bwiadczony dokument to\u017Csamo\u015Bci.",
                ro: "V\u0103 rug\u0103m s\u0103 \xeenc\u0103rca\u021Bi un document de identitate certificat.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2."
            },
            type: "file",
            description: (0, $2aNQ5.idDocsDescription),
            onlyForCountries: [
                "Hong Kong"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ],
                [`relation_${relationNumber}_relation_type_updated_corporate_director_director_electronic_verification_method`]: [
                    false
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_address_doc`,
            title: {
                en: `Please provide a proof of address document.`,
                es: `Proporcione un documento de prueba de direcci\xf3n.`,
                nl: `Gelieve een bewijs van adres op te geven.`,
                fr: `Veuillez fournir un justificatif de domicile.`,
                pt: `Providencie um comprovativo de endere\xe7o.`,
                it: "Fornisci un documento di prova dell'indirizzo.",
                de: "Bitte legen Sie einen Adressnachweis vor.",
                pl: "Prosz\u0119 dostarczy\u0107 dokument potwierdzaj\u0105cy adres.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document doveditor al adresei.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03B1\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7\u03C2 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2."
            },
            type: "file",
            description: (0, $2aNQ5.addressProofDescription),
            onlyForCountries: [
                "United Kingdom",
                "United Arab Emirates"
            ],
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "director"
                ]
            }
        },
        {
            id: `relation_${relationNumber}_relation_type_updated_corporate_director_director_doc`,
            title: {
                en: `Please provide a document showing the full corporate director structure.`,
                es: `Proporcione un documento que muestre la estructura completa del director corporativo.`,
                nl: `Geef een document met de volledige bestuursstructuur.`,
                fr: `Veuillez fournir un document montrant la structure compl\xe8te du directeur corporatif.`,
                pt: `Providencie um documento que mostre a estrutura completa dos directores da empresa.`,
                it: "Fornisci un documento che mostri la struttura completa del direttore aziendale.",
                de: "Bitte legen Sie ein Dokument vor, das die vollst\xe4ndige Struktur des Unternehmensleiters zeigt.",
                pl: "Prosz\u0119 dostarczy\u0107 dokument przedstawiaj\u0105cy pe\u0142n\u0105 struktur\u0119 dyrektora korporacyjnego.",
                ro: "V\u0103 rug\u0103m s\u0103 furniza\u021Bi un document care s\u0103 arate structura complet\u0103 a directorului corporativ.",
                gr: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03BA\u03BF\u03BC\u03AF\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03BF \u03C0\u03BF\u03C5 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C7\u03BD\u03B5\u03B9 \u03C4\u03B7\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03B4\u03BF\u03BC\u03AE \u03C4\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B9\u03BA\u03BF\u03CD \u03B4\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AE."
            },
            type: "file",
            renderConditions: {
                [`relation_${relationNumber}_relation_type_updated_corporate_director_secondary_type_update`]: [
                    "corporate director"
                ]
            }
        }
    ];
};

});


parcelRegister("iZ8Do", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd249f1a4a538342$export$2e2bcd8739ae039; });
let $dd249f1a4a538342$var$script;




let $dd249f1a4a538342$var$initialize = ()=>{
    $dd249f1a4a538342$var$script = (parcelRequire("lDPTq"));
    if ($dd249f1a4a538342$var$script.__esModule) $dd249f1a4a538342$var$script = $dd249f1a4a538342$var$script.default;
    $dd249f1a4a538342$var$script.render = (parcelRequire("1Jb5t")).render;
    $dd249f1a4a538342$var$script.__cssModules = {};
    (parcelRequire("io4aA")).default($dd249f1a4a538342$var$script);
    $dd249f1a4a538342$var$script.__scopeId = "data-v-b8a5c0";
    $dd249f1a4a538342$var$script.__file = "Button.vue";
};
$dd249f1a4a538342$var$initialize();
var $dd249f1a4a538342$export$2e2bcd8739ae039 = $dd249f1a4a538342$var$script;

});
parcelRegister("lDPTq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c6e010ae97a9ac49$export$2e2bcd8739ae039; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $c6e010ae97a9ac49$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({
    props: {
        isPrimary: {
            type: Boolean,
            default: true
        },
        showIcon: {
            type: Boolean,
            default: false
        },
        buttonText: {
            type: String,
            required: true
        }
    },
    methods: {
        handleClick () {
            this.$emit("buttonClick");
        }
    }
});

});

parcelRegister("1Jb5t", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $1422981ba6e68aa8$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");

var $1Frv0 = parcelRequire("1Frv0");
const $1422981ba6e68aa8$var$_hoisted_1 = {
    key: 0
};
function $1422981ba6e68aa8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("button", {
        class: (0, $6ZvW5.normalizeClass)([
            "button",
            {
                "primary-button": _ctx.isPrimary,
                "secondary-button": !_ctx.isPrimary
            }
        ]),
        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.handleClick && _ctx.handleClick(...args))
    }, [
        _ctx.showIcon ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("span", $1422981ba6e68aa8$var$_hoisted_1, [
            ..._cache[1] || (_cache[1] = [
                (0, $8zRru.createElementVNode)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1Frv0))),
                    alt: "add icon"
                }, null, -1)
            ])
        ])) : (0, $8zRru.createCommentVNode)("", true),
        (0, $8zRru.createTextVNode)(" " + (0, $6ZvW5.toDisplayString)(_ctx.buttonText), 1)
    ], 2);
}

});
parcelRegister("1Frv0", function(module, exports) {
module.exports = new URL("plus-icon.fd89b9a0.svg", import.meta.url).toString();

});


parcelRegister("io4aA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d62db3e9e1af1117$export$2e2bcd8739ae039; });
let $d62db3e9e1af1117$var$NOOP = ()=>{};
var $d62db3e9e1af1117$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lbeuH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6b5de4c03c08057$export$2e2bcd8739ae039; });
let $f6b5de4c03c08057$var$script;



let $f6b5de4c03c08057$var$initialize = ()=>{
    $f6b5de4c03c08057$var$script = {};
    $f6b5de4c03c08057$var$script.render = (parcelRequire("aeohC")).render;
    $f6b5de4c03c08057$var$script.__cssModules = {};
    (parcelRequire("odTvK")).default($f6b5de4c03c08057$var$script);
    $f6b5de4c03c08057$var$script.__scopeId = "data-v-cc734e";
    $f6b5de4c03c08057$var$script.__file = "Informational.vue";
};
$f6b5de4c03c08057$var$initialize();
var $f6b5de4c03c08057$export$2e2bcd8739ae039 = $f6b5de4c03c08057$var$script;

});
parcelRegister("aeohC", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $01ec18f92aac5b8b$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");

var $lbR1H = parcelRequire("lbR1H");
const $01ec18f92aac5b8b$var$_hoisted_1 = {
    class: "informational"
};
const $01ec18f92aac5b8b$var$_hoisted_2 = {
    class: "bold"
};
function $01ec18f92aac5b8b$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $01ec18f92aac5b8b$var$_hoisted_1, [
        _cache[0] || (_cache[0] = (0, $8zRru.createElementVNode)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lbR1H))),
            alt: "information icon",
            class: "information-icon"
        }, null, -1)),
        (0, $8zRru.createElementVNode)("div", null, [
            (0, $8zRru.createElementVNode)("p", $01ec18f92aac5b8b$var$_hoisted_2, (0, $6ZvW5.toDisplayString)(_ctx.$t("formPage.savedLocallyMessage")), 1),
            (0, $8zRru.createElementVNode)("p", null, (0, $6ZvW5.toDisplayString)(_ctx.$t("formPage.accessFormAgain")), 1)
        ])
    ]);
}

});
parcelRegister("lbR1H", function(module, exports) {
module.exports = new URL("information-icon.1bcf3da1.svg", import.meta.url).toString();

});


parcelRegister("odTvK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $048d0521cc81c1fe$export$2e2bcd8739ae039; });
let $048d0521cc81c1fe$var$NOOP = ()=>{};
var $048d0521cc81c1fe$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1ZR76", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1744b036aa5bf98c$export$2e2bcd8739ae039; });
let $1744b036aa5bf98c$var$script;




let $1744b036aa5bf98c$var$initialize = ()=>{
    $1744b036aa5bf98c$var$script = (parcelRequire("7g3eu"));
    if ($1744b036aa5bf98c$var$script.__esModule) $1744b036aa5bf98c$var$script = $1744b036aa5bf98c$var$script.default;
    $1744b036aa5bf98c$var$script.render = (parcelRequire("4rKLJ")).render;
    $1744b036aa5bf98c$var$script.__cssModules = {};
    (parcelRequire("gWHyF")).default($1744b036aa5bf98c$var$script);
    $1744b036aa5bf98c$var$script.__scopeId = "data-v-a92420";
    $1744b036aa5bf98c$var$script.__file = "LoadingSpinner.vue";
};
$1744b036aa5bf98c$var$initialize();
var $1744b036aa5bf98c$export$2e2bcd8739ae039 = $1744b036aa5bf98c$var$script;

});
parcelRegister("7g3eu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $50c4aac310f4bd68$export$2e2bcd8739ae039; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $50c4aac310f4bd68$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({});

});

parcelRegister("4rKLJ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $33cdf657b152ea25$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");

var $lE5TP = parcelRequire("lE5TP");
const $33cdf657b152ea25$var$_hoisted_1 = {
    class: "loading-spinner"
};
function $33cdf657b152ea25$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $33cdf657b152ea25$var$_hoisted_1, [
        _cache[0] || (_cache[0] = (0, $8zRru.createElementVNode)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lE5TP))),
            alt: "loading spinner"
        }, null, -1)),
        (0, $8zRru.createElementVNode)("p", null, (0, $6ZvW5.toDisplayString)(_ctx.$t("formPage.waitMessage")), 1)
    ]);
}

});
parcelRegister("lE5TP", function(module, exports) {
module.exports = new URL("loading-spinner.22cc1742.svg", import.meta.url).toString();

});


parcelRegister("gWHyF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c563d9e2abb860ee$export$2e2bcd8739ae039; });
let $c563d9e2abb860ee$var$NOOP = ()=>{};
var $c563d9e2abb860ee$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("96jlp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a03adf52b617110$export$2e2bcd8739ae039; });
let $6a03adf52b617110$var$script;




let $6a03adf52b617110$var$initialize = ()=>{
    $6a03adf52b617110$var$script = (parcelRequire("7DNvE"));
    if ($6a03adf52b617110$var$script.__esModule) $6a03adf52b617110$var$script = $6a03adf52b617110$var$script.default;
    $6a03adf52b617110$var$script.render = (parcelRequire("gLOZv")).render;
    $6a03adf52b617110$var$script.__cssModules = {};
    (parcelRequire("8bVZx")).default($6a03adf52b617110$var$script);
    $6a03adf52b617110$var$script.__scopeId = "data-v-ea9f8a";
    $6a03adf52b617110$var$script.__file = "PRSelector.vue";
};
$6a03adf52b617110$var$initialize();
var $6a03adf52b617110$export$2e2bcd8739ae039 = $6a03adf52b617110$var$script;

});
parcelRegister("7DNvE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3fdf3a20c5deb830$export$2e2bcd8739ae039; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");

var $2Wseo = parcelRequire("2Wseo");

var $kBVDt = parcelRequire("kBVDt");
var $3fdf3a20c5deb830$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({
    props: {
        accounts: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            currentSelection: ""
        };
    },
    async mounted () {
        const storedAccountNumber = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_ACCOUNT_NUMBER_KEY));
        if (storedAccountNumber) this.currentSelection = storedAccountNumber;
    },
    methods: {
        async handleChange (event) {
            const inputElement = event.target;
            const newAccountNumber = inputElement.value;
            this.currentSelection = newAccountNumber;
            await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_ACCOUNT_NUMBER_KEY), newAccountNumber);
            const queryParams = {
                ...this.$route.query
            };
            queryParams.accountNumber = newAccountNumber;
            this.$router.replace({
                ...this.$router.currentRoute,
                query: queryParams
            });
        }
    }
});

});

parcelRegister("gLOZv", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $c35896e2a145d460$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");
var $5lPju = parcelRequire("5lPju");
const $c35896e2a145d460$var$_hoisted_1 = {
    class: "pr-selector"
};
const $c35896e2a145d460$var$_hoisted_2 = [
    "value"
];
function $c35896e2a145d460$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $c35896e2a145d460$var$_hoisted_1, [
        (0, $8zRru.createElementVNode)("label", null, (0, $6ZvW5.toDisplayString)(_ctx.$t("formPage.openPRs")) + ":", 1),
        (0, $8zRru.withDirectives)((0, $8zRru.createElementVNode)("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.currentSelection = $event),
            onChange: _cache[1] || (_cache[1] = (...args)=>_ctx.handleChange && _ctx.handleChange(...args)),
            class: "select"
        }, [
            ((0, $8zRru.openBlock)(true), (0, $8zRru.createElementBlock)((0, $8zRru.Fragment), null, (0, $8zRru.renderList)(_ctx.accounts, (account)=>{
                return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("option", {
                    key: account.accountNumber,
                    value: account.accountNumber
                }, (0, $6ZvW5.toDisplayString)(account.companyName), 9, $c35896e2a145d460$var$_hoisted_2);
            }), 128))
        ], 544), [
            [
                (0, $5lPju.vModelSelect),
                _ctx.currentSelection
            ]
        ])
    ]);
}

});

parcelRegister("8bVZx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f6c55bfd314f908$export$2e2bcd8739ae039; });
let $5f6c55bfd314f908$var$NOOP = ()=>{};
var $5f6c55bfd314f908$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cUl0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $965b03950d52347b$export$2e2bcd8739ae039; });
let $965b03950d52347b$var$script;




let $965b03950d52347b$var$initialize = ()=>{
    $965b03950d52347b$var$script = (parcelRequire("3zbjS"));
    if ($965b03950d52347b$var$script.__esModule) $965b03950d52347b$var$script = $965b03950d52347b$var$script.default;
    $965b03950d52347b$var$script.render = (parcelRequire("6T4rM")).render;
    $965b03950d52347b$var$script.__cssModules = {};
    (parcelRequire("6ydS5")).default($965b03950d52347b$var$script);
    $965b03950d52347b$var$script.__scopeId = "data-v-b4a022";
    $965b03950d52347b$var$script.__file = "SuccessMessage.vue";
};
$965b03950d52347b$var$initialize();
var $965b03950d52347b$export$2e2bcd8739ae039 = $965b03950d52347b$var$script;

});
parcelRegister("3zbjS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $298d6bd7afb38741$export$2e2bcd8739ae039; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $298d6bd7afb38741$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({
    props: {
        message: {
            type: String,
            required: true
        }
    }
});

});

parcelRegister("6T4rM", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $503b543baff56fa9$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");

var $2X1Mg = parcelRequire("2X1Mg");
const $503b543baff56fa9$var$_hoisted_1 = {
    class: "success-message"
};
function $503b543baff56fa9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $503b543baff56fa9$var$_hoisted_1, [
        _cache[0] || (_cache[0] = (0, $8zRru.createElementVNode)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2X1Mg))),
            alt: "check mark"
        }, null, -1)),
        (0, $8zRru.createElementVNode)("p", null, (0, $6ZvW5.toDisplayString)(_ctx.message), 1)
    ]);
}

});
parcelRegister("2X1Mg", function(module, exports) {
module.exports = new URL("tick.8d2efeb9.svg", import.meta.url).toString();

});


parcelRegister("6ydS5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c50ada109b1c946$export$2e2bcd8739ae039; });
let $4c50ada109b1c946$var$NOOP = ()=>{};
var $4c50ada109b1c946$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("58E6z", function(module, exports) {

$parcel$export(module.exports, "firebaseApp", function () { return $cd9074ec8c87218d$export$a4e2c8f07e884e; });
parcelRequire("6f4QY");
var $gc3di = parcelRequire("gc3di");
const $cd9074ec8c87218d$var$firebaseConfig = {
    staging: {
        apiKey: "AIzaSyDr4_dyU0gvfgLVh-fk9QDAVmtKd6BL0OQ",
        authDomain: "appscript-296515.firebaseapp.com",
        projectId: "appscript-296515",
        storageBucket: "appscript-296515.appspot.com",
        messagingSenderId: "1060281356034",
        appId: "1:1060281356034:web:ec2fb857a9e3020bdfbc1b",
        measurementId: "G-C8BG5ECPDK"
    },
    production: {
        apiKey: "AIzaSyCe1Do7FlQ0JYX69rrYZ7MJbUNKCNpeN-E",
        authDomain: "ebury-bpa-326309.firebaseapp.com",
        projectId: "ebury-bpa-326309",
        storageBucket: "ebury-bpa-326309.appspot.com",
        messagingSenderId: "784561049560",
        appId: "1:784561049560:web:02fadc49579cc23a216cad"
    }
};
const $cd9074ec8c87218d$export$a4e2c8f07e884e = {
    get instance () {
        const areThereApps = (0, $gc3di.getApps)().length > 0;
        if (areThereApps) {
            const app = (0, $gc3di.getApp)();
            return app;
        }
        const currentUrl = new URL(window.location.href);
        const isProduction = currentUrl.host === "periodic-reviews.ebury.com";
        const config = isProduction ? $cd9074ec8c87218d$var$firebaseConfig.production : $cd9074ec8c87218d$var$firebaseConfig.staging;
        const initializedApp = (0, $gc3di.initializeApp)(config);
        return initializedApp;
    }
};

});
parcelRegister("6f4QY", function(module, exports) {
$parcel$export(module.exports, "getApp", function () { return (parcelRequire("gc3di")).getApp; });
$parcel$export(module.exports, "getApps", function () { return (parcelRequire("gc3di")).getApps; });
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("gc3di")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("gc3di")).registerVersion; });

var $gc3di = parcelRequire("gc3di");
var $48b7e89a7152456e$var$name = "firebase";
var $48b7e89a7152456e$var$version = "10.14.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $gc3di.registerVersion)($48b7e89a7152456e$var$name, $48b7e89a7152456e$var$version, "app");

});


parcelRegister("l2h0I", function(module, exports) {

$parcel$export(module.exports, "addNewRelation", function () { return $113ce9fc939fc945$export$456b0416b362c6c; });

var $2aNQ5 = parcelRequire("2aNQ5");
const $113ce9fc939fc945$export$456b0416b362c6c = (relationNumber)=>{
    return [
        {
            id: `relation_${relationNumber}_header`,
            title: {
                en: `Relation ${relationNumber}`,
                es: `Relaci\xf3n ${relationNumber}`,
                nl: `Relatie ${relationNumber}`,
                fr: `Relation ${relationNumber}`,
                pt: `Rela\xe7\xe3o ${relationNumber}`,
                it: `Relazione ${relationNumber}`,
                de: `Beziehung ${relationNumber}`,
                pl: `Relacja ${relationNumber}`,
                ro: `Rela\u{21B}ia ${relationNumber}`,
                gr: `\u{3A3}\u{3C7}\u{3AD}\u{3C3}\u{3B7} ${relationNumber}`
            },
            type: "subheader"
        },
        {
            id: `relation_${relationNumber}_delete`,
            title: {
                en: `Relation delete`
            },
            value: relationNumber,
            type: "relationDelete"
        },
        {
            id: `relation_${relationNumber}_relation_type_updated`,
            title: {
                en: `Relation type`,
                es: `Tipo de relaci\xf3n`,
                nl: `Relatietype`,
                fr: `Type de relation`,
                pt: `Tipo de rela\xe7\xe3o`,
                it: `Tipo di relazione`,
                de: `Beziehungstyp`,
                pl: `Typ relacji`,
                ro: `Tipul rela\u{21B}iei`,
                gr: `\u{3A4}\u{3CD}\u{3C0}\u{3BF}\u{3C2} \u{3C3}\u{3C7}\u{3AD}\u{3C3}\u{3B7}\u{3C2}`
            },
            type: "select",
            options: (0, $2aNQ5.relationTypeOptions)
        }
    ];
};

});

parcelRegister("2EJsO", function(module, exports) {

$parcel$export(module.exports, "callApi", function () { return $26ac628f9d1ef7d3$export$16b551886ad4ac7f; });

var $gF9qy = parcelRequire("gF9qy");

var $kBVDt = parcelRequire("kBVDt");

var $eJ9Nc = parcelRequire("eJ9Nc");

var $2SEys = parcelRequire("2SEys");

var $eTlDg = parcelRequire("eTlDg");

var $2aNQ5 = parcelRequire("2aNQ5");

var $36h9V = parcelRequire("36h9V");

var $8uxR7 = parcelRequire("8uxR7");

var $jOIeS = parcelRequire("jOIeS");

var $2Wseo = parcelRequire("2Wseo");
parcelRequire("i2PrI");
var $cxzoJ = parcelRequire("cxzoJ");

var $58E6z = parcelRequire("58E6z");
const $26ac628f9d1ef7d3$export$16b551886ad4ac7f = async (options)=>{
    const baseUrl = (0, $eJ9Nc.getBackendUrl)();
    const currentUrl = new URL(window.location.href);
    const lang = await (0, $36h9V.getSavedLang)();
    let testingEmail = currentUrl.searchParams.get("testingEmail");
    let testData = currentUrl.searchParams.get("testData");
    const continueUrlParam = currentUrl.searchParams.get("continueUrl");
    let accountNumber = await (0, $2SEys.getCurrentAccountNumber)();
    if (continueUrlParam) {
        const continueUrl = new URL(continueUrlParam);
        testingEmail = continueUrl.searchParams.get("testingEmail");
        testData = continueUrl.searchParams.get("testData");
        if (!accountNumber) accountNumber = continueUrl.searchParams.get("accountNumber");
    }
    (0, $8uxR7.consoleLogStaging)({
        testingEmail: testingEmail
    });
    const isNotification = options.action === "notify_error";
    const isAccountNumberMissingAndIsNotNotification = !isNotification && !accountNumber;
    if (isAccountNumberMissingAndIsNotNotification) {
        const errorMessage = (0, $2aNQ5.ERROR_MESSAGES).NO_ACCOUNT_NUMBER[lang];
        (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Notify.failure(errorMessage);
        throw new Error("No account number found");
    }
    let url = `${baseUrl}?action=${options.action}&${(0, $kBVDt.ACCOUNT_NUMBER_PARAMETER_KEY)}=${accountNumber}&lang=${lang}`;
    const isTesting = !(0, $kBVDt.isProduction) && !!testingEmail;
    if (isTesting) url += `&testingEmail=${testingEmail}&testData=${testData}`;
    const token = await (0, $eTlDg.getToken)();
    if (!token) return null;
    const { data: data } = options;
    const request = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    };
    request.body = JSON.stringify(data);
    try {
        const response = await fetch(url, request);
        const result = await response.json();
        const responseAsError = result;
        if (responseAsError.error) throw new Error(responseAsError.error);
        return result;
    } catch (error) {
        /**
     * If the error is related to firebase id token expiring, no call is being made to avoid an infinite loop.
     */ const isMessageFirebaseTokenIdExpired = error.message.includes("Firebase ID token has expired");
        console.log({
            isMessageFirebaseTokenIdExpired: isMessageFirebaseTokenIdExpired
        });
        if (isMessageFirebaseTokenIdExpired) return null;
        const isNoDataFound = error.message === (0, $2aNQ5.ERROR_MESSAGES).NO_DATA_FOUND["en"];
        if (isNoDataFound) {
            const errorTitle = (0, $2aNQ5.ERROR_MESSAGES).ERROR_OCCURRED[lang];
            const errorMessage = (0, $2aNQ5.ERROR_MESSAGES).NO_DATA_FOUND[lang];
            (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Report.warning(errorTitle, errorMessage, "OK", ()=>null, {
                plainText: true
            });
            return null;
        }
        const isEmailNotFound = error.message === (0, $2aNQ5.ERROR_MESSAGES).EMAIL_NOT_IN_ACCOUNT["en"];
        if (isEmailNotFound) {
            const errorTitle = (0, $2aNQ5.ERROR_MESSAGES).ERROR_OCCURRED[lang];
            const errorMessage = (0, $2aNQ5.ERROR_MESSAGES).EMAIL_NOT_IN_ACCOUNT[lang];
            (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Report.warning(errorTitle, errorMessage, "OK", async ()=>{
                const auth = (0, $cxzoJ.o)((0, $58E6z.firebaseApp).instance);
                (0, $8uxR7.consoleLogStaging)("Signing out user");
                (0, $8uxR7.consoleLogStaging)(auth);
                await (0, $jOIeS.clearIndexedDBs)();
                await (0, $cxzoJ.C)(auth);
                await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).clear();
                window.location.href = "/";
            }, {
                plainText: true
            });
            return null;
        }
        const errorTitle = (0, $2aNQ5.ERROR_MESSAGES).ERROR_OCCURRED[lang];
        const errorMessage = (0, $2aNQ5.ERROR_MESSAGES).GENERAL_ERROR[lang];
        (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Report.warning(errorTitle, errorMessage, "OK", ()=>{}, {
            plainText: false
        });
        throw error;
    }
};

});
parcelRegister("gF9qy", function(module, exports) {
/* Notiflix AIO (https://notiflix.github.io) - Version: 3.2.8 - Author: Furkan (https://github.com/furcan) - Copyright 2019 - 2025 Notiflix, MIT License (https://opensource.org/licenses/MIT) */ (function(t, e) {
    "function" == typeof define && define.amd ? define([], function() {
        return e(t);
    }) : "object" == typeof module.exports ? module.exports = e(t) : t.Notiflix = e(t);
})("undefined" == typeof $parcel$global ? "undefined" == typeof window ? module.exports : window : $parcel$global, function(t) {
    "use strict";
    if ("undefined" == typeof t && "undefined" == typeof t.document) return !1;
    var e, i, a, n, o, r = "\n\nVisit documentation page to learn more: https://notiflix.github.io/documentation", s = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif', l = {
        Success: "Success",
        Failure: "Failure",
        Warning: "Warning",
        Info: "Info"
    }, m = {
        wrapID: "NotiflixNotifyWrap",
        overlayID: "NotiflixNotifyOverlay",
        width: "280px",
        position: "right-top",
        distance: "10px",
        opacity: 1,
        borderRadius: "5px",
        rtl: !1,
        timeout: 3e3,
        messageMaxLength: 110,
        backOverlay: !1,
        backOverlayColor: "rgba(0,0,0,0.5)",
        plainText: !0,
        showOnlyTheLastOne: !1,
        clickToClose: !1,
        pauseOnHover: !0,
        ID: "NotiflixNotify",
        className: "notiflix-notify",
        zindex: 4001,
        fontFamily: "Quicksand",
        fontSize: "13px",
        cssAnimation: !0,
        cssAnimationDuration: 400,
        cssAnimationStyle: "fade",
        closeButton: !1,
        useIcon: !0,
        useFontAwesome: !1,
        fontAwesomeIconStyle: "basic",
        fontAwesomeIconSize: "34px",
        success: {
            background: "#32c682",
            textColor: "#fff",
            childClassName: "notiflix-notify-success",
            notiflixIconColor: "rgba(0,0,0,0.2)",
            fontAwesomeClassName: "fas fa-check-circle",
            fontAwesomeIconColor: "rgba(0,0,0,0.2)",
            backOverlayColor: "rgba(50,198,130,0.2)"
        },
        failure: {
            background: "#ff5549",
            textColor: "#fff",
            childClassName: "notiflix-notify-failure",
            notiflixIconColor: "rgba(0,0,0,0.2)",
            fontAwesomeClassName: "fas fa-times-circle",
            fontAwesomeIconColor: "rgba(0,0,0,0.2)",
            backOverlayColor: "rgba(255,85,73,0.2)"
        },
        warning: {
            background: "#eebf31",
            textColor: "#fff",
            childClassName: "notiflix-notify-warning",
            notiflixIconColor: "rgba(0,0,0,0.2)",
            fontAwesomeClassName: "fas fa-exclamation-circle",
            fontAwesomeIconColor: "rgba(0,0,0,0.2)",
            backOverlayColor: "rgba(238,191,49,0.2)"
        },
        info: {
            background: "#26c0d3",
            textColor: "#fff",
            childClassName: "notiflix-notify-info",
            notiflixIconColor: "rgba(0,0,0,0.2)",
            fontAwesomeClassName: "fas fa-info-circle",
            fontAwesomeIconColor: "rgba(0,0,0,0.2)",
            backOverlayColor: "rgba(38,192,211,0.2)"
        }
    }, c = {
        Success: "Success",
        Failure: "Failure",
        Warning: "Warning",
        Info: "Info"
    }, p = {
        ID: "NotiflixReportWrap",
        className: "notiflix-report",
        width: "320px",
        backgroundColor: "#f8f8f8",
        borderRadius: "25px",
        rtl: !1,
        zindex: 4002,
        backOverlay: !0,
        backOverlayColor: "rgba(0,0,0,0.5)",
        backOverlayClickToClose: !1,
        fontFamily: "Quicksand",
        svgSize: "110px",
        plainText: !0,
        titleFontSize: "16px",
        titleMaxLength: 34,
        messageFontSize: "13px",
        messageMaxLength: 400,
        buttonFontSize: "14px",
        buttonMaxLength: 34,
        cssAnimation: !0,
        cssAnimationDuration: 360,
        cssAnimationStyle: "fade",
        success: {
            svgColor: "#32c682",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#32c682",
            buttonColor: "#fff",
            backOverlayColor: "rgba(50,198,130,0.2)"
        },
        failure: {
            svgColor: "#ff5549",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#ff5549",
            buttonColor: "#fff",
            backOverlayColor: "rgba(255,85,73,0.2)"
        },
        warning: {
            svgColor: "#eebf31",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#eebf31",
            buttonColor: "#fff",
            backOverlayColor: "rgba(238,191,49,0.2)"
        },
        info: {
            svgColor: "#26c0d3",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#26c0d3",
            buttonColor: "#fff",
            backOverlayColor: "rgba(38,192,211,0.2)"
        }
    }, f = {
        Show: "Show",
        Ask: "Ask",
        Prompt: "Prompt"
    }, d = {
        ID: "NotiflixConfirmWrap",
        className: "notiflix-confirm",
        width: "300px",
        zindex: 4003,
        position: "center",
        distance: "10px",
        backgroundColor: "#f8f8f8",
        borderRadius: "25px",
        backOverlay: !0,
        backOverlayColor: "rgba(0,0,0,0.5)",
        rtl: !1,
        fontFamily: "Quicksand",
        cssAnimation: !0,
        cssAnimationDuration: 300,
        cssAnimationStyle: "fade",
        plainText: !0,
        titleColor: "#32c682",
        titleFontSize: "16px",
        titleMaxLength: 34,
        messageColor: "#1e1e1e",
        messageFontSize: "14px",
        messageMaxLength: 110,
        buttonsFontSize: "15px",
        buttonsMaxLength: 34,
        okButtonColor: "#f8f8f8",
        okButtonBackground: "#32c682",
        cancelButtonColor: "#f8f8f8",
        cancelButtonBackground: "#a9a9a9"
    }, x = {
        Standard: "Standard",
        Hourglass: "Hourglass",
        Circle: "Circle",
        Arrows: "Arrows",
        Dots: "Dots",
        Pulse: "Pulse",
        Custom: "Custom",
        Notiflix: "Notiflix"
    }, g = {
        ID: "NotiflixLoadingWrap",
        className: "notiflix-loading",
        zindex: 4e3,
        backgroundColor: "rgba(0,0,0,0.8)",
        rtl: !1,
        fontFamily: "Quicksand",
        cssAnimation: !0,
        cssAnimationDuration: 400,
        clickToClose: !1,
        customSvgUrl: null,
        customSvgCode: null,
        svgSize: "80px",
        svgColor: "#32c682",
        messageID: "NotiflixLoadingMessage",
        messageFontSize: "15px",
        messageMaxLength: 34,
        messageColor: "#dcdcdc"
    }, b = {
        Standard: "Standard",
        Hourglass: "Hourglass",
        Circle: "Circle",
        Arrows: "Arrows",
        Dots: "Dots",
        Pulse: "Pulse"
    }, u = {
        ID: "NotiflixBlockWrap",
        querySelectorLimit: 200,
        className: "notiflix-block",
        position: "absolute",
        zindex: 1e3,
        backgroundColor: "rgba(255,255,255,0.9)",
        rtl: !1,
        fontFamily: "Quicksand",
        cssAnimation: !0,
        cssAnimationDuration: 300,
        svgSize: "45px",
        svgColor: "#383838",
        messageFontSize: "14px",
        messageMaxLength: 34,
        messageColor: "#383838"
    }, y = function(t) {
        return console.error("%c Notiflix Error ", "padding:2px;border-radius:20px;color:#fff;background:#ff5549", "\n" + t + r);
    }, k = function(t) {
        return console.log("%c Notiflix Info ", "padding:2px;border-radius:20px;color:#fff;background:#26c0d3", "\n" + t + r);
    }, w = function(e) {
        return e || (e = "head"), void 0 !== t.document[e] || (y('\nNotiflix needs to be appended to the "<' + e + '>" element, but you called it before the "<' + e + '>" element has been created.'), !1);
    }, h = function(e, i) {
        if (!w("head")) return !1;
        if (null !== e() && !t.document.getElementById(i)) {
            var a = t.document.createElement("style");
            a.id = i, a.innerHTML = e(), t.document.head.appendChild(a);
        }
    }, v = function() {
        var t = {}, e = !1, a = 0;
        "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (e = arguments[0], a++);
        for(var n = function(i) {
            for(var a in i)Object.prototype.hasOwnProperty.call(i, a) && (t[a] = e && "[object Object]" === Object.prototype.toString.call(i[a]) ? v(t[a], i[a]) : i[a]);
        }; a < arguments.length; a++)n(arguments[a]);
        return t;
    }, N = function(e) {
        var i = t.document.createElement("div");
        return i.innerHTML = e, i.textContent || i.innerText || "";
    }, C = function(t, e) {
        t || (t = "110px"), e || (e = "#32c682");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" id="NXReportSuccess" width="' + t + '" height="' + t + '" fill="' + e + '" viewBox="0 0 120 120"><style>@-webkit-keyframes NXReportSuccess1-animation{0%{-webkit-transform:translate(60px,57.7px) scale(.5,.5) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(.5,.5) translate(-60px,-57.7px)}50%,to{-webkit-transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px)}60%{-webkit-transform:translate(60px,57.7px) scale(.95,.95) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(.95,.95) translate(-60px,-57.7px)}}@keyframes NXReportSuccess1-animation{0%{-webkit-transform:translate(60px,57.7px) scale(.5,.5) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(.5,.5) translate(-60px,-57.7px)}50%,to{-webkit-transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px)}60%{-webkit-transform:translate(60px,57.7px) scale(.95,.95) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(.95,.95) translate(-60px,-57.7px)}}@-webkit-keyframes NXReportSuccess4-animation{0%{opacity:0}50%,to{opacity:1}}@keyframes NXReportSuccess4-animation{0%{opacity:0}50%,to{opacity:1}}@-webkit-keyframes NXReportSuccess3-animation{0%{opacity:0}40%,to{opacity:1}}@keyframes NXReportSuccess3-animation{0%{opacity:0}40%,to{opacity:1}}@-webkit-keyframes NXReportSuccess2-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportSuccess2-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}#NXReportSuccess *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g style="-webkit-animation-name:NXReportSuccess2-animation;animation-name:NXReportSuccess2-animation;-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)"><path d="M60 115.38C29.46 115.38 4.62 90.54 4.62 60 4.62 29.46 29.46 4.62 60 4.62c30.54 0 55.38 24.84 55.38 55.38 0 30.54-24.84 55.38-55.38 55.38zM60 0C26.92 0 0 26.92 0 60s26.92 60 60 60 60-26.92 60-60S93.08 0 60 0z" style="-webkit-animation-name:NXReportSuccess3-animation;animation-name:NXReportSuccess3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g><g style="-webkit-animation-name:NXReportSuccess1-animation;animation-name:NXReportSuccess1-animation;-webkit-transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px);-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)"><path d="M88.27 35.39L52.8 75.29 31.43 58.2c-.98-.81-2.44-.63-3.24.36-.79.99-.63 2.44.36 3.24l23.08 18.46c.43.34.93.51 1.44.51.64 0 1.27-.26 1.74-.78l36.91-41.53a2.3 2.3 0 0 0-.19-3.26c-.95-.86-2.41-.77-3.26.19z" style="-webkit-animation-name:NXReportSuccess4-animation;animation-name:NXReportSuccess4-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g></svg>';
        return i;
    }, z = function(t, e) {
        t || (t = "110px"), e || (e = "#ff5549");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" id="NXReportFailure" width="' + t + '" height="' + t + '" fill="' + e + '" viewBox="0 0 120 120"><style>@-webkit-keyframes NXReportFailure2-animation{0%{opacity:0}40%,to{opacity:1}}@keyframes NXReportFailure2-animation{0%{opacity:0}40%,to{opacity:1}}@-webkit-keyframes NXReportFailure1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportFailure1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@-webkit-keyframes NXReportFailure3-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}50%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportFailure3-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}50%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@-webkit-keyframes NXReportFailure4-animation{0%{opacity:0}50%,to{opacity:1}}@keyframes NXReportFailure4-animation{0%{opacity:0}50%,to{opacity:1}}#NXReportFailure *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g style="-webkit-animation-name:NXReportFailure1-animation;animation-name:NXReportFailure1-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M4.35 34.95c0-16.82 13.78-30.6 30.6-30.6h50.1c16.82 0 30.6 13.78 30.6 30.6v50.1c0 16.82-13.78 30.6-30.6 30.6h-50.1c-16.82 0-30.6-13.78-30.6-30.6v-50.1zM34.95 120h50.1c19.22 0 34.95-15.73 34.95-34.95v-50.1C120 15.73 104.27 0 85.05 0h-50.1C15.73 0 0 15.73 0 34.95v50.1C0 104.27 15.73 120 34.95 120z" style="-webkit-animation-name:NXReportFailure2-animation;animation-name:NXReportFailure2-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g><g style="-webkit-animation-name:NXReportFailure3-animation;animation-name:NXReportFailure3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M82.4 37.6c-.9-.9-2.37-.9-3.27 0L60 56.73 40.86 37.6a2.306 2.306 0 0 0-3.26 3.26L56.73 60 37.6 79.13c-.9.9-.9 2.37 0 3.27.45.45 1.04.68 1.63.68.59 0 1.18-.23 1.63-.68L60 63.26 79.13 82.4c.45.45 1.05.68 1.64.68.58 0 1.18-.23 1.63-.68.9-.9.9-2.37 0-3.27L63.26 60 82.4 40.86c.9-.91.9-2.36 0-3.26z" style="-webkit-animation-name:NXReportFailure4-animation;animation-name:NXReportFailure4-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g></svg>';
        return i;
    }, S = function(t, e) {
        t || (t = "110px"), e || (e = "#eebf31");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" id="NXReportWarning" width="' + t + '" height="' + t + '" fill="' + e + '" viewBox="0 0 120 120"><style>@-webkit-keyframes NXReportWarning2-animation{0%{opacity:0}40%,to{opacity:1}}@keyframes NXReportWarning2-animation{0%{opacity:0}40%,to{opacity:1}}@-webkit-keyframes NXReportWarning1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportWarning1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@-webkit-keyframes NXReportWarning3-animation{0%{-webkit-transform:translate(60px,66.6px) scale(.5,.5) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(.5,.5) translate(-60px,-66.6px)}50%,to{-webkit-transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px)}60%{-webkit-transform:translate(60px,66.6px) scale(.95,.95) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(.95,.95) translate(-60px,-66.6px)}}@keyframes NXReportWarning3-animation{0%{-webkit-transform:translate(60px,66.6px) scale(.5,.5) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(.5,.5) translate(-60px,-66.6px)}50%,to{-webkit-transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px)}60%{-webkit-transform:translate(60px,66.6px) scale(.95,.95) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(.95,.95) translate(-60px,-66.6px)}}@-webkit-keyframes NXReportWarning4-animation{0%{opacity:0}50%,to{opacity:1}}@keyframes NXReportWarning4-animation{0%{opacity:0}50%,to{opacity:1}}#NXReportWarning *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g style="-webkit-animation-name:NXReportWarning1-animation;animation-name:NXReportWarning1-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M115.46 106.15l-54.04-93.8c-.61-1.06-2.23-1.06-2.84 0l-54.04 93.8c-.62 1.07.21 2.29 1.42 2.29h108.08c1.21 0 2.04-1.22 1.42-2.29zM65.17 10.2l54.04 93.8c2.28 3.96-.65 8.78-5.17 8.78H5.96c-4.52 0-7.45-4.82-5.17-8.78l54.04-93.8c2.28-3.95 8.03-4 10.34 0z" style="-webkit-animation-name:NXReportWarning2-animation;animation-name:NXReportWarning2-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g><g style="-webkit-animation-name:NXReportWarning3-animation;animation-name:NXReportWarning3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px)"><path d="M57.83 94.01c0 1.2.97 2.17 2.17 2.17s2.17-.97 2.17-2.17v-3.2c0-1.2-.97-2.17-2.17-2.17s-2.17.97-2.17 2.17v3.2zm0-14.15c0 1.2.97 2.17 2.17 2.17s2.17-.97 2.17-2.17V39.21c0-1.2-.97-2.17-2.17-2.17s-2.17.97-2.17 2.17v40.65z" style="-webkit-animation-name:NXReportWarning4-animation;animation-name:NXReportWarning4-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g></svg>';
        return i;
    }, L = function(t, e) {
        t || (t = "110px"), e || (e = "#26c0d3");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" id="NXReportInfo" width="' + t + '" height="' + t + '" fill="' + e + '" viewBox="0 0 120 120"><style>@-webkit-keyframes NXReportInfo4-animation{0%{opacity:0}50%,to{opacity:1}}@keyframes NXReportInfo4-animation{0%{opacity:0}50%,to{opacity:1}}@-webkit-keyframes NXReportInfo3-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}50%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportInfo3-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}50%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@-webkit-keyframes NXReportInfo2-animation{0%{opacity:0}40%,to{opacity:1}}@keyframes NXReportInfo2-animation{0%{opacity:0}40%,to{opacity:1}}@-webkit-keyframes NXReportInfo1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportInfo1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}#NXReportInfo *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g style="-webkit-animation-name:NXReportInfo1-animation;animation-name:NXReportInfo1-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M60 115.38C29.46 115.38 4.62 90.54 4.62 60 4.62 29.46 29.46 4.62 60 4.62c30.54 0 55.38 24.84 55.38 55.38 0 30.54-24.84 55.38-55.38 55.38zM60 0C26.92 0 0 26.92 0 60s26.92 60 60 60 60-26.92 60-60S93.08 0 60 0z" style="-webkit-animation-name:NXReportInfo2-animation;animation-name:NXReportInfo2-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g><g style="-webkit-animation-name:NXReportInfo3-animation;animation-name:NXReportInfo3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M57.75 43.85c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v48.18c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25V43.85zm0-15.88c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v3.32c0 1.25-1.01 2.25-2.25 2.25s-2.25-1-2.25-2.25v-3.32z" style="-webkit-animation-name:NXReportInfo4-animation;animation-name:NXReportInfo4-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g></svg>';
        return i;
    }, W = function(t, e) {
        t || (t = "60px"), e || (e = "#32c682");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" stroke="' + e + '" width="' + t + '" height="' + t + '" transform="scale(.8)" viewBox="0 0 38 38"><g fill="none" fill-rule="evenodd" stroke-width="2" transform="translate(1 1)"><circle cx="18" cy="18" r="18" stroke-opacity=".25"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" dur="1s" from="0 18 18" repeatCount="indefinite" to="360 18 18" type="rotate"/></path></g></svg>';
        return i;
    }, I = function(t, e) {
        t || (t = "60px"), e || (e = "#32c682");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" id="NXLoadingHourglass" fill="' + e + '" width="' + t + '" height="' + t + '" viewBox="0 0 200 200"><style>@-webkit-keyframes NXhourglass5-animation{0%{-webkit-transform:scale(1,1);transform:scale(1,1)}16.67%{-webkit-transform:scale(1,.8);transform:scale(1,.8)}33.33%{-webkit-transform:scale(.88,.6);transform:scale(.88,.6)}37.5%{-webkit-transform:scale(.85,.55);transform:scale(.85,.55)}41.67%{-webkit-transform:scale(.8,.5);transform:scale(.8,.5)}45.83%{-webkit-transform:scale(.75,.45);transform:scale(.75,.45)}50%{-webkit-transform:scale(.7,.4);transform:scale(.7,.4)}54.17%{-webkit-transform:scale(.6,.35);transform:scale(.6,.35)}58.33%{-webkit-transform:scale(.5,.3);transform:scale(.5,.3)}83.33%,to{-webkit-transform:scale(.2,0);transform:scale(.2,0)}}@keyframes NXhourglass5-animation{0%{-webkit-transform:scale(1,1);transform:scale(1,1)}16.67%{-webkit-transform:scale(1,.8);transform:scale(1,.8)}33.33%{-webkit-transform:scale(.88,.6);transform:scale(.88,.6)}37.5%{-webkit-transform:scale(.85,.55);transform:scale(.85,.55)}41.67%{-webkit-transform:scale(.8,.5);transform:scale(.8,.5)}45.83%{-webkit-transform:scale(.75,.45);transform:scale(.75,.45)}50%{-webkit-transform:scale(.7,.4);transform:scale(.7,.4)}54.17%{-webkit-transform:scale(.6,.35);transform:scale(.6,.35)}58.33%{-webkit-transform:scale(.5,.3);transform:scale(.5,.3)}83.33%,to{-webkit-transform:scale(.2,0);transform:scale(.2,0)}}@-webkit-keyframes NXhourglass3-animation{0%{-webkit-transform:scale(1,.02);transform:scale(1,.02)}79.17%,to{-webkit-transform:scale(1,1);transform:scale(1,1)}}@keyframes NXhourglass3-animation{0%{-webkit-transform:scale(1,.02);transform:scale(1,.02)}79.17%,to{-webkit-transform:scale(1,1);transform:scale(1,1)}}@-webkit-keyframes NXhourglass1-animation{0%,83.33%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(180deg);transform:rotate(180deg)}}@keyframes NXhourglass1-animation{0%,83.33%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(180deg);transform:rotate(180deg)}}#NXLoadingHourglass *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g data-animator-group="true" data-animator-type="1" style="-webkit-animation-name:NXhourglass1-animation;animation-name:NXhourglass1-animation;-webkit-transform-origin:50% 50%;transform-origin:50% 50%;transform-box:fill-box"><g id="NXhourglass2" fill="inherit"><g data-animator-group="true" data-animator-type="2" style="-webkit-animation-name:NXhourglass3-animation;animation-name:NXhourglass3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform-origin:50% 100%;transform-origin:50% 100%;transform-box:fill-box" opacity=".4"><path id="NXhourglass4" d="M100 100l-34.38 32.08v31.14h68.76v-31.14z"/></g><g data-animator-group="true" data-animator-type="2" style="-webkit-animation-name:NXhourglass5-animation;animation-name:NXhourglass5-animation;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;transform-box:fill-box" opacity=".4"><path id="NXhourglass6" d="M100 100L65.62 67.92V36.78h68.76v31.14z"/></g><path d="M51.14 38.89h8.33v14.93c0 15.1 8.29 28.99 23.34 39.1 1.88 1.25 3.04 3.97 3.04 7.08s-1.16 5.83-3.04 7.09c-15.05 10.1-23.34 23.99-23.34 39.09v14.93h-8.33a4.859 4.859 0 1 0 0 9.72h97.72a4.859 4.859 0 1 0 0-9.72h-8.33v-14.93c0-15.1-8.29-28.99-23.34-39.09-1.88-1.26-3.04-3.98-3.04-7.09s1.16-5.83 3.04-7.08c15.05-10.11 23.34-24 23.34-39.1V38.89h8.33a4.859 4.859 0 1 0 0-9.72H51.14a4.859 4.859 0 1 0 0 9.72zm79.67 14.93c0 15.87-11.93 26.25-19.04 31.03-4.6 3.08-7.34 8.75-7.34 15.15 0 6.41 2.74 12.07 7.34 15.15 7.11 4.78 19.04 15.16 19.04 31.03v14.93H69.19v-14.93c0-15.87 11.93-26.25 19.04-31.02 4.6-3.09 7.34-8.75 7.34-15.16 0-6.4-2.74-12.07-7.34-15.15-7.11-4.78-19.04-15.16-19.04-31.03V38.89h61.62v14.93z"/></g></g></svg>';
        return i;
    }, R = function(t, e) {
        t || (t = "60px"), e || (e = "#32c682");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" width="' + t + '" height="' + t + '" viewBox="25 25 50 50" style="-webkit-animation:rotate 2s linear infinite;animation:rotate 2s linear infinite;height:' + t + ";-webkit-transform-origin:center center;-ms-transform-origin:center center;transform-origin:center center;width:" + t + ';position:absolute;top:0;left:0;margin:auto"><style>@-webkit-keyframes rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35}to{stroke-dasharray:89,200;stroke-dashoffset:-124}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35}to{stroke-dasharray:89,200;stroke-dashoffset:-124}}</style><circle cx="50" cy="50" r="20" fill="none" stroke="' + e + '" stroke-width="2" style="-webkit-animation:dash 1.5s ease-in-out infinite,color 1.5s ease-in-out infinite;animation:dash 1.5s ease-in-out infinite,color 1.5s ease-in-out infinite" stroke-dasharray="150 200" stroke-dashoffset="-10" stroke-linecap="round"/></svg>';
        return i;
    }, A = function(t, e) {
        t || (t = "60px"), e || (e = "#32c682");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" fill="' + e + '" width="' + t + '" height="' + t + '" viewBox="0 0 128 128"><g><path fill="inherit" d="M109.25 55.5h-36l12-12a29.54 29.54 0 0 0-49.53 12H18.75A46.04 46.04 0 0 1 96.9 31.84l12.35-12.34v36zm-90.5 17h36l-12 12a29.54 29.54 0 0 0 49.53-12h16.97A46.04 46.04 0 0 1 31.1 96.16L18.74 108.5v-36z"/><animateTransform attributeName="transform" dur="1.5s" from="0 64 64" repeatCount="indefinite" to="360 64 64" type="rotate"/></g></svg>';
        return i;
    }, M = function(t, e) {
        t || (t = "60px"), e || (e = "#32c682");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" fill="' + e + '" width="' + t + '" height="' + t + '" viewBox="0 0 100 100"><g transform="translate(25 50)"><circle r="9" fill="inherit" transform="scale(.239)"><animateTransform attributeName="transform" begin="-0.266s" calcMode="spline" dur="0.8s" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" keyTimes="0;0.5;1" repeatCount="indefinite" type="scale" values="0;1;0"/></circle></g><g transform="translate(50 50)"><circle r="9" fill="inherit" transform="scale(.00152)"><animateTransform attributeName="transform" begin="-0.133s" calcMode="spline" dur="0.8s" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" keyTimes="0;0.5;1" repeatCount="indefinite" type="scale" values="0;1;0"/></circle></g><g transform="translate(75 50)"><circle r="9" fill="inherit" transform="scale(.299)"><animateTransform attributeName="transform" begin="0s" calcMode="spline" dur="0.8s" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" keyTimes="0;0.5;1" repeatCount="indefinite" type="scale" values="0;1;0"/></circle></g></svg>';
        return i;
    }, B = function(t, e) {
        t || (t = "60px"), e || (e = "#32c682");
        var i = '<svg xmlns="http://www.w3.org/2000/svg" stroke="' + e + '" width="' + t + '" height="' + t + '" viewBox="0 0 44 44"><g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" calcMode="spline" dur="1.8s" keySplines="0.165, 0.84, 0.44, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 20"/><animate attributeName="stroke-opacity" begin="0s" calcMode="spline" dur="1.8s" keySplines="0.3, 0.61, 0.355, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 0"/></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" calcMode="spline" dur="1.8s" keySplines="0.165, 0.84, 0.44, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 20"/><animate attributeName="stroke-opacity" begin="-0.9s" calcMode="spline" dur="1.8s" keySplines="0.3, 0.61, 0.355, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 0"/></circle></g></svg>';
        return i;
    }, X = function(t, e, i) {
        t || (t = "60px"), e || (e = "#f8f8f8"), i || (i = "#32c682");
        var a = '<svg xmlns="http://www.w3.org/2000/svg" id="NXLoadingNotiflixLib" width="' + t + '" height="' + t + '" viewBox="0 0 200 200"><defs><style>@keyframes notiflix-n{0%{stroke-dashoffset:1000}to{stroke-dashoffset:0}}@keyframes notiflix-x{0%{stroke-dashoffset:1000}to{stroke-dashoffset:0}}@keyframes notiflix-dot{0%,to{stroke-width:0}50%{stroke-width:12}}.nx-icon-line{stroke:' + e + ';stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22;fill:none}</style></defs><path d="M47.97 135.05a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13z" style="animation-name:notiflix-dot;animation-timing-function:ease-in-out;animation-duration:1.25s;animation-iteration-count:infinite;animation-direction:normal" fill="' + i + '" stroke="' + i + '" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="22" stroke-width="12"/><path class="nx-icon-line" d="M10.14 144.76V87.55c0-5.68-4.54-41.36 37.83-41.36 42.36 0 37.82 35.68 37.82 41.36v57.21" style="animation-name:notiflix-n;animation-timing-function:linear;animation-duration:2.5s;animation-delay:0s;animation-iteration-count:infinite;animation-direction:normal" stroke-dasharray="500"/><path class="nx-icon-line" d="M115.06 144.49c24.98-32.68 49.96-65.35 74.94-98.03M114.89 46.6c25.09 32.58 50.19 65.17 75.29 97.75" style="animation-name:notiflix-x;animation-timing-function:linear;animation-duration:2.5s;animation-delay:.2s;animation-iteration-count:infinite;animation-direction:normal" stroke-dasharray="500"/></svg>';
        return a;
    }, D = function() {
        return '[id^=NotiflixNotifyWrap]{pointer-events:none;position:fixed;z-index:4001;opacity:1;right:10px;top:10px;width:280px;max-width:96%;-webkit-box-sizing:border-box;box-sizing:border-box;background:transparent}[id^=NotiflixNotifyWrap].nx-flex-center-center{max-height:calc(100vh - 20px);overflow-x:hidden;overflow-y:auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;margin:auto}[id^=NotiflixNotifyWrap]::-webkit-scrollbar{width:0;height:0}[id^=NotiflixNotifyWrap]::-webkit-scrollbar-thumb{background:transparent}[id^=NotiflixNotifyWrap]::-webkit-scrollbar-track{background:transparent}[id^=NotiflixNotifyWrap] *{-webkit-box-sizing:border-box;box-sizing:border-box}[id^=NotiflixNotifyOverlay]{-webkit-transition:background .3s ease-in-out;-o-transition:background .3s ease-in-out;transition:background .3s ease-in-out}[id^=NotiflixNotifyWrap]>div{pointer-events:all;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:"Quicksand",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;width:100%;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;position:relative;margin:0 0 10px;border-radius:5px;background:#1e1e1e;color:#fff;padding:10px 12px;font-size:14px;line-height:1.4}[id^=NotiflixNotifyWrap]>div:last-child{margin:0}[id^=NotiflixNotifyWrap]>div.nx-with-callback{cursor:pointer}[id^=NotiflixNotifyWrap]>div.nx-with-icon{padding:8px;min-height:56px}[id^=NotiflixNotifyWrap]>div.nx-paused{cursor:auto}[id^=NotiflixNotifyWrap]>div.nx-notify-click-to-close{cursor:pointer}[id^=NotiflixNotifyWrap]>div.nx-with-close-button{padding:10px 36px 10px 12px}[id^=NotiflixNotifyWrap]>div.nx-with-icon.nx-with-close-button{padding:6px 36px 6px 6px}[id^=NotiflixNotifyWrap]>div>span.nx-message{cursor:inherit;font-weight:normal;font-family:inherit!important;word-break:break-all;word-break:break-word}[id^=NotiflixNotifyWrap]>div>span.nx-close-button{cursor:pointer;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;position:absolute;right:8px;top:0;bottom:0;margin:auto;color:inherit;width:20px;height:20px}[id^=NotiflixNotifyWrap]>div>span.nx-close-button:hover{-webkit-transform:rotate(90deg);transform:rotate(90deg)}[id^=NotiflixNotifyWrap]>div>span.nx-close-button>svg{position:absolute;width:16px;height:16px;right:2px;top:2px}[id^=NotiflixNotifyWrap]>div>.nx-message-icon{position:absolute;width:40px;height:40px;font-size:30px;line-height:40px;text-align:center;left:8px;top:0;bottom:0;margin:auto;border-radius:inherit}[id^=NotiflixNotifyWrap]>div>.nx-message-icon-fa.nx-message-icon-fa-shadow{color:inherit;background:rgba(0,0,0,.15);-webkit-box-shadow:inset 0 0 34px rgba(0,0,0,.2);box-shadow:inset 0 0 34px rgba(0,0,0,.2);text-shadow:0 0 10px rgba(0,0,0,.3)}[id^=NotiflixNotifyWrap]>div>span.nx-with-icon{position:relative;float:left;width:calc(100% - 40px);margin:0 0 0 40px;padding:0 0 0 10px;-webkit-box-sizing:border-box;box-sizing:border-box}[id^=NotiflixNotifyWrap]>div.nx-rtl-on>.nx-message-icon{left:auto;right:8px}[id^=NotiflixNotifyWrap]>div.nx-rtl-on>span.nx-with-icon{padding:0 10px 0 0;margin:0 40px 0 0}[id^=NotiflixNotifyWrap]>div.nx-rtl-on>span.nx-close-button{right:auto;left:8px}[id^=NotiflixNotifyWrap]>div.nx-with-icon.nx-with-close-button.nx-rtl-on{padding:6px 6px 6px 36px}[id^=NotiflixNotifyWrap]>div.nx-with-close-button.nx-rtl-on{padding:10px 12px 10px 36px}[id^=NotiflixNotifyOverlay].nx-with-animation,[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-fade{-webkit-animation:notify-animation-fade .3s ease-in-out 0s normal;animation:notify-animation-fade .3s ease-in-out 0s normal}@-webkit-keyframes notify-animation-fade{0%{opacity:0}100%{opacity:1}}@keyframes notify-animation-fade{0%{opacity:0}100%{opacity:1}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-zoom{-webkit-animation:notify-animation-zoom .3s ease-in-out 0s normal;animation:notify-animation-zoom .3s ease-in-out 0s normal}@-webkit-keyframes notify-animation-zoom{0%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1.05);transform:scale(1.05)}100%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes notify-animation-zoom{0%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1.05);transform:scale(1.05)}100%{-webkit-transform:scale(1);transform:scale(1)}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-from-right{-webkit-animation:notify-animation-from-right .3s ease-in-out 0s normal;animation:notify-animation-from-right .3s ease-in-out 0s normal}@-webkit-keyframes notify-animation-from-right{0%{right:-300px;opacity:0}50%{right:8px;opacity:1}100%{right:0;opacity:1}}@keyframes notify-animation-from-right{0%{right:-300px;opacity:0}50%{right:8px;opacity:1}100%{right:0;opacity:1}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-from-left{-webkit-animation:notify-animation-from-left .3s ease-in-out 0s normal;animation:notify-animation-from-left .3s ease-in-out 0s normal}@-webkit-keyframes notify-animation-from-left{0%{left:-300px;opacity:0}50%{left:8px;opacity:1}100%{left:0;opacity:1}}@keyframes notify-animation-from-left{0%{left:-300px;opacity:0}50%{left:8px;opacity:1}100%{left:0;opacity:1}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-from-top{-webkit-animation:notify-animation-from-top .3s ease-in-out 0s normal;animation:notify-animation-from-top .3s ease-in-out 0s normal}@-webkit-keyframes notify-animation-from-top{0%{top:-50px;opacity:0}50%{top:8px;opacity:1}100%{top:0;opacity:1}}@keyframes notify-animation-from-top{0%{top:-50px;opacity:0}50%{top:8px;opacity:1}100%{top:0;opacity:1}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-from-bottom{-webkit-animation:notify-animation-from-bottom .3s ease-in-out 0s normal;animation:notify-animation-from-bottom .3s ease-in-out 0s normal}@-webkit-keyframes notify-animation-from-bottom{0%{bottom:-50px;opacity:0}50%{bottom:8px;opacity:1}100%{bottom:0;opacity:1}}@keyframes notify-animation-from-bottom{0%{bottom:-50px;opacity:0}50%{bottom:8px;opacity:1}100%{bottom:0;opacity:1}}[id^=NotiflixNotifyOverlay].nx-with-animation.nx-remove,[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-fade.nx-remove{opacity:0;-webkit-animation:notify-remove-fade .3s ease-in-out 0s normal;animation:notify-remove-fade .3s ease-in-out 0s normal}@-webkit-keyframes notify-remove-fade{0%{opacity:1}100%{opacity:0}}@keyframes notify-remove-fade{0%{opacity:1}100%{opacity:0}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-zoom.nx-remove{-webkit-transform:scale(0);transform:scale(0);-webkit-animation:notify-remove-zoom .3s ease-in-out 0s normal;animation:notify-remove-zoom .3s ease-in-out 0s normal}@-webkit-keyframes notify-remove-zoom{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(1.05);transform:scale(1.05)}100%{-webkit-transform:scale(0);transform:scale(0)}}@keyframes notify-remove-zoom{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(1.05);transform:scale(1.05)}100%{-webkit-transform:scale(0);transform:scale(0)}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-from-top.nx-remove{opacity:0;-webkit-animation:notify-remove-to-top .3s ease-in-out 0s normal;animation:notify-remove-to-top .3s ease-in-out 0s normal}@-webkit-keyframes notify-remove-to-top{0%{top:0;opacity:1}50%{top:8px;opacity:1}100%{top:-50px;opacity:0}}@keyframes notify-remove-to-top{0%{top:0;opacity:1}50%{top:8px;opacity:1}100%{top:-50px;opacity:0}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-from-right.nx-remove{opacity:0;-webkit-animation:notify-remove-to-right .3s ease-in-out 0s normal;animation:notify-remove-to-right .3s ease-in-out 0s normal}@-webkit-keyframes notify-remove-to-right{0%{right:0;opacity:1}50%{right:8px;opacity:1}100%{right:-300px;opacity:0}}@keyframes notify-remove-to-right{0%{right:0;opacity:1}50%{right:8px;opacity:1}100%{right:-300px;opacity:0}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-from-bottom.nx-remove{opacity:0;-webkit-animation:notify-remove-to-bottom .3s ease-in-out 0s normal;animation:notify-remove-to-bottom .3s ease-in-out 0s normal}@-webkit-keyframes notify-remove-to-bottom{0%{bottom:0;opacity:1}50%{bottom:8px;opacity:1}100%{bottom:-50px;opacity:0}}@keyframes notify-remove-to-bottom{0%{bottom:0;opacity:1}50%{bottom:8px;opacity:1}100%{bottom:-50px;opacity:0}}[id^=NotiflixNotifyWrap]>div.nx-with-animation.nx-from-left.nx-remove{opacity:0;-webkit-animation:notify-remove-to-left .3s ease-in-out 0s normal;animation:notify-remove-to-left .3s ease-in-out 0s normal}@-webkit-keyframes notify-remove-to-left{0%{left:0;opacity:1}50%{left:8px;opacity:1}100%{left:-300px;opacity:0}}@keyframes notify-remove-to-left{0%{left:0;opacity:1}50%{left:8px;opacity:1}100%{left:-300px;opacity:0}}';
    }, T = 0, F = function(a, n, o, r) {
        if (!w("body")) return !1;
        e || G.Notify.init({});
        var c = v(!0, e, {});
        if ("object" == typeof o && !Array.isArray(o) || "object" == typeof r && !Array.isArray(r)) {
            var p = {};
            "object" == typeof o ? p = o : "object" == typeof r && (p = r), e = v(!0, e, p);
        }
        var f = e[a.toLocaleLowerCase("en")];
        T++, "string" != typeof n && (n = "Notiflix " + a), e.plainText && (n = N(n)), !e.plainText && n.length > e.messageMaxLength && (e = v(!0, e, {
            closeButton: !0,
            messageMaxLength: 150
        }), n = 'Possible HTML Tags Error: The "plainText" option is "false" and the notification content length is more than the "messageMaxLength" option.'), n.length > e.messageMaxLength && (n = n.substring(0, e.messageMaxLength) + "..."), "shadow" === e.fontAwesomeIconStyle && (f.fontAwesomeIconColor = f.background), e.cssAnimation || (e.cssAnimationDuration = 0);
        var d = t.document.getElementById(m.wrapID) || t.document.createElement("div");
        if (d.id = m.wrapID, d.style.width = e.width, d.style.zIndex = e.zindex, d.style.opacity = e.opacity, "center-center" === e.position ? (d.style.left = e.distance, d.style.top = e.distance, d.style.right = e.distance, d.style.bottom = e.distance, d.style.margin = "auto", d.classList.add("nx-flex-center-center"), d.style.maxHeight = "calc((100vh - " + e.distance + ") - " + e.distance + ")", d.style.display = "flex", d.style.flexWrap = "wrap", d.style.flexDirection = "column", d.style.justifyContent = "center", d.style.alignItems = "center", d.style.pointerEvents = "none") : "center-top" === e.position ? (d.style.left = e.distance, d.style.right = e.distance, d.style.top = e.distance, d.style.bottom = "auto", d.style.margin = "auto") : "center-bottom" === e.position ? (d.style.left = e.distance, d.style.right = e.distance, d.style.bottom = e.distance, d.style.top = "auto", d.style.margin = "auto") : "right-bottom" === e.position ? (d.style.right = e.distance, d.style.bottom = e.distance, d.style.top = "auto", d.style.left = "auto") : "left-top" === e.position ? (d.style.left = e.distance, d.style.top = e.distance, d.style.right = "auto", d.style.bottom = "auto") : "left-bottom" === e.position ? (d.style.left = e.distance, d.style.bottom = e.distance, d.style.top = "auto", d.style.right = "auto") : (d.style.right = e.distance, d.style.top = e.distance, d.style.left = "auto", d.style.bottom = "auto"), e.backOverlay) {
            var x = t.document.getElementById(m.overlayID) || t.document.createElement("div");
            x.id = m.overlayID, x.style.width = "100%", x.style.height = "100%", x.style.position = "fixed", x.style.zIndex = e.zindex - 1, x.style.left = 0, x.style.top = 0, x.style.right = 0, x.style.bottom = 0, x.style.background = f.backOverlayColor || e.backOverlayColor, x.className = e.cssAnimation ? "nx-with-animation" : "", x.style.animationDuration = e.cssAnimation ? e.cssAnimationDuration + "ms" : "", t.document.getElementById(m.overlayID) || t.document.body.appendChild(x);
        }
        t.document.getElementById(m.wrapID) || t.document.body.appendChild(d);
        var g = t.document.createElement("div");
        g.id = e.ID + "-" + T, g.className = e.className + " " + f.childClassName + " " + (e.cssAnimation ? "nx-with-animation" : "") + " " + (e.useIcon ? "nx-with-icon" : "") + " nx-" + e.cssAnimationStyle + " " + (e.closeButton && "function" != typeof o ? "nx-with-close-button" : "") + " " + ("function" == typeof o ? "nx-with-callback" : "") + " " + (e.clickToClose ? "nx-notify-click-to-close" : ""), g.style.fontSize = e.fontSize, g.style.color = f.textColor, g.style.background = f.background, g.style.borderRadius = e.borderRadius, g.style.pointerEvents = "all", e.rtl && (g.setAttribute("dir", "rtl"), g.classList.add("nx-rtl-on")), g.style.fontFamily = '"' + e.fontFamily + '", ' + s, e.cssAnimation && (g.style.animationDuration = e.cssAnimationDuration + "ms");
        var b = "";
        if (e.closeButton && "function" != typeof o && (b = '<span class="nx-close-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g><path fill="' + f.notiflixIconColor + '" d="M0.38 2.19l7.8 7.81 -7.8 7.81c-0.51,0.5 -0.51,1.31 -0.01,1.81 0.25,0.25 0.57,0.38 0.91,0.38 0.34,0 0.67,-0.14 0.91,-0.38l7.81 -7.81 7.81 7.81c0.24,0.24 0.57,0.38 0.91,0.38 0.34,0 0.66,-0.14 0.9,-0.38 0.51,-0.5 0.51,-1.31 0,-1.81l-7.81 -7.81 7.81 -7.81c0.51,-0.5 0.51,-1.31 0,-1.82 -0.5,-0.5 -1.31,-0.5 -1.81,0l-7.81 7.81 -7.81 -7.81c-0.5,-0.5 -1.31,-0.5 -1.81,0 -0.51,0.51 -0.51,1.32 0,1.82z"/></g></svg></span>'), !e.useIcon) g.innerHTML = '<span class="nx-message">' + n + "</span>" + (e.closeButton ? b : "");
        else if (e.useFontAwesome) g.innerHTML = '<i style="color:' + f.fontAwesomeIconColor + "; font-size:" + e.fontAwesomeIconSize + ';" class="nx-message-icon nx-message-icon-fa ' + f.fontAwesomeClassName + " " + ("shadow" === e.fontAwesomeIconStyle ? "nx-message-icon-fa-shadow" : "nx-message-icon-fa-basic") + '"></i><span class="nx-message nx-with-icon">' + n + "</span>" + (e.closeButton ? b : "");
        else {
            var u = "";
            a === l.Success ? u = '<svg class="nx-message-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g><path fill="' + f.notiflixIconColor + '" d="M20 0c11.03,0 20,8.97 20,20 0,11.03 -8.97,20 -20,20 -11.03,0 -20,-8.97 -20,-20 0,-11.03 8.97,-20 20,-20zm0 37.98c9.92,0 17.98,-8.06 17.98,-17.98 0,-9.92 -8.06,-17.98 -17.98,-17.98 -9.92,0 -17.98,8.06 -17.98,17.98 0,9.92 8.06,17.98 17.98,17.98zm-2.4 -13.29l11.52 -12.96c0.37,-0.41 1.01,-0.45 1.42,-0.08 0.42,0.37 0.46,1 0.09,1.42l-12.16 13.67c-0.19,0.22 -0.46,0.34 -0.75,0.34 -0.23,0 -0.45,-0.07 -0.63,-0.22l-7.6 -6.07c-0.43,-0.35 -0.5,-0.99 -0.16,-1.42 0.35,-0.43 0.99,-0.5 1.42,-0.16l6.85 5.48z"/></g></svg>' : a === l.Failure ? u = '<svg class="nx-message-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g><path fill="' + f.notiflixIconColor + '" d="M20 0c11.03,0 20,8.97 20,20 0,11.03 -8.97,20 -20,20 -11.03,0 -20,-8.97 -20,-20 0,-11.03 8.97,-20 20,-20zm0 37.98c9.92,0 17.98,-8.06 17.98,-17.98 0,-9.92 -8.06,-17.98 -17.98,-17.98 -9.92,0 -17.98,8.06 -17.98,17.98 0,9.92 8.06,17.98 17.98,17.98zm1.42 -17.98l6.13 6.12c0.39,0.4 0.39,1.04 0,1.43 -0.19,0.19 -0.45,0.29 -0.71,0.29 -0.27,0 -0.53,-0.1 -0.72,-0.29l-6.12 -6.13 -6.13 6.13c-0.19,0.19 -0.44,0.29 -0.71,0.29 -0.27,0 -0.52,-0.1 -0.71,-0.29 -0.39,-0.39 -0.39,-1.03 0,-1.43l6.13 -6.12 -6.13 -6.13c-0.39,-0.39 -0.39,-1.03 0,-1.42 0.39,-0.39 1.03,-0.39 1.42,0l6.13 6.12 6.12 -6.12c0.4,-0.39 1.04,-0.39 1.43,0 0.39,0.39 0.39,1.03 0,1.42l-6.13 6.13z"/></g></svg>' : a === l.Warning ? u = '<svg class="nx-message-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g><path fill="' + f.notiflixIconColor + '" d="M21.91 3.48l17.8 30.89c0.84,1.46 -0.23,3.25 -1.91,3.25l-35.6 0c-1.68,0 -2.75,-1.79 -1.91,-3.25l17.8 -30.89c0.85,-1.47 2.97,-1.47 3.82,0zm16.15 31.84l-17.8 -30.89c-0.11,-0.2 -0.41,-0.2 -0.52,0l-17.8 30.89c-0.12,0.2 0.05,0.4 0.26,0.4l35.6 0c0.21,0 0.38,-0.2 0.26,-0.4zm-19.01 -4.12l0 -1.05c0,-0.53 0.42,-0.95 0.95,-0.95 0.53,0 0.95,0.42 0.95,0.95l0 1.05c0,0.53 -0.42,0.95 -0.95,0.95 -0.53,0 -0.95,-0.42 -0.95,-0.95zm0 -4.66l0 -13.39c0,-0.52 0.42,-0.95 0.95,-0.95 0.53,0 0.95,0.43 0.95,0.95l0 13.39c0,0.53 -0.42,0.96 -0.95,0.96 -0.53,0 -0.95,-0.43 -0.95,-0.96z"/></g></svg>' : a === l.Info && (u = '<svg class="nx-message-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g><path fill="' + f.notiflixIconColor + '" d="M20 0c11.03,0 20,8.97 20,20 0,11.03 -8.97,20 -20,20 -11.03,0 -20,-8.97 -20,-20 0,-11.03 8.97,-20 20,-20zm0 37.98c9.92,0 17.98,-8.06 17.98,-17.98 0,-9.92 -8.06,-17.98 -17.98,-17.98 -9.92,0 -17.98,8.06 -17.98,17.98 0,9.92 8.06,17.98 17.98,17.98zm-0.99 -23.3c0,-0.54 0.44,-0.98 0.99,-0.98 0.55,0 0.99,0.44 0.99,0.98l0 15.86c0,0.55 -0.44,0.99 -0.99,0.99 -0.55,0 -0.99,-0.44 -0.99,-0.99l0 -15.86zm0 -5.22c0,-0.55 0.44,-0.99 0.99,-0.99 0.55,0 0.99,0.44 0.99,0.99l0 1.09c0,0.54 -0.44,0.99 -0.99,0.99 -0.55,0 -0.99,-0.45 -0.99,-0.99l0 -1.09z"/></g></svg>'), g.innerHTML = u + '<span class="nx-message nx-with-icon">' + n + "</span>" + (e.closeButton ? b : "");
        }
        if ("left-bottom" === e.position || "right-bottom" === e.position) {
            var y = t.document.getElementById(m.wrapID);
            y.insertBefore(g, y.firstChild);
        } else t.document.getElementById(m.wrapID).appendChild(g);
        var k = t.document.getElementById(g.id);
        if (k) {
            var h, C, z = function() {
                k.classList.add("nx-remove");
                var e = t.document.getElementById(m.overlayID);
                e && 0 >= d.childElementCount && e.classList.add("nx-remove"), clearTimeout(h);
            }, S = function() {
                if (k && null !== k.parentNode && k.parentNode.removeChild(k), 0 >= d.childElementCount && null !== d.parentNode) {
                    d.parentNode.removeChild(d);
                    var e = t.document.getElementById(m.overlayID);
                    e && null !== e.parentNode && e.parentNode.removeChild(e);
                }
                clearTimeout(C);
            };
            if (e.closeButton && "function" != typeof o) {
                var L = t.document.getElementById(g.id).querySelector("span.nx-close-button");
                L.addEventListener("click", function() {
                    z();
                    var t = setTimeout(function() {
                        S(), clearTimeout(t);
                    }, e.cssAnimationDuration);
                });
            }
            if (("function" == typeof o || e.clickToClose) && k.addEventListener("click", function() {
                "function" == typeof o && o(), z();
                var t = setTimeout(function() {
                    S(), clearTimeout(t);
                }, e.cssAnimationDuration);
            }), !e.closeButton && "function" != typeof o) {
                var W = function() {
                    h = setTimeout(function() {
                        z();
                    }, e.timeout), C = setTimeout(function() {
                        S();
                    }, e.timeout + e.cssAnimationDuration);
                };
                W(), e.pauseOnHover && (k.addEventListener("mouseenter", function() {
                    k.classList.add("nx-paused"), clearTimeout(h), clearTimeout(C);
                }), k.addEventListener("mouseleave", function() {
                    k.classList.remove("nx-paused"), W();
                }));
            }
        }
        if (e.showOnlyTheLastOne && 0 < T) for(var I, R = t.document.querySelectorAll("[id^=" + e.ID + "-]:not([id=" + e.ID + "-" + T + "])"), A = 0; A < R.length; A++)I = R[A], null !== I.parentNode && I.parentNode.removeChild(I);
        e = v(!0, e, c);
    }, E = function() {
        return '[id^=NotiflixReportWrap]{position:fixed;z-index:4002;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:"Quicksand",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;left:0;top:0;padding:10px;color:#1e1e1e;border-radius:25px;background:transparent;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}[id^=NotiflixReportWrap] *{-webkit-box-sizing:border-box;box-sizing:border-box}[id^=NotiflixReportWrap]>div[class*="-overlay"]{width:100%;height:100%;left:0;top:0;background:rgba(255,255,255,.5);position:fixed;z-index:0}[id^=NotiflixReportWrap]>div.nx-report-click-to-close{cursor:pointer}[id^=NotiflixReportWrap]>div[class*="-content"]{width:320px;max-width:100%;max-height:96vh;overflow-x:hidden;overflow-y:auto;border-radius:inherit;padding:10px;-webkit-filter:drop-shadow(0 0 5px rgba(0,0,0,0.05));filter:drop-shadow(0 0 5px rgba(0, 0, 0, .05));border:1px solid rgba(0,0,0,.03);background:#f8f8f8;position:relative;z-index:1}[id^=NotiflixReportWrap]>div[class*="-content"]::-webkit-scrollbar{width:0;height:0}[id^=NotiflixReportWrap]>div[class*="-content"]::-webkit-scrollbar-thumb{background:transparent}[id^=NotiflixReportWrap]>div[class*="-content"]::-webkit-scrollbar-track{background:transparent}[id^=NotiflixReportWrap]>div[class*="-content"]>div[class$="-icon"]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:110px;height:110px;display:block;margin:6px auto 12px}[id^=NotiflixReportWrap]>div[class*="-content"]>div[class$="-icon"] svg{min-width:100%;max-width:100%;height:auto}[id^=NotiflixReportWrap]>*>h5{word-break:break-all;word-break:break-word;font-family:inherit!important;font-size:16px;font-weight:500;line-height:1.4;margin:0 0 10px;padding:0 0 10px;border-bottom:1px solid rgba(0,0,0,.1);float:left;width:100%;text-align:center}[id^=NotiflixReportWrap]>*>p{word-break:break-all;word-break:break-word;font-family:inherit!important;font-size:13px;line-height:1.4;font-weight:normal;float:left;width:100%;padding:0 10px;margin:0 0 10px}[id^=NotiflixReportWrap] a#NXReportButton{word-break:break-all;word-break:break-word;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:inherit!important;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;transition:all .25s ease-in-out;cursor:pointer;float:right;padding:7px 17px;background:#32c682;font-size:14px;line-height:1.4;font-weight:500;border-radius:inherit!important;color:#fff}[id^=NotiflixReportWrap] a#NXReportButton:hover{-webkit-box-shadow:inset 0 -60px 5px -5px rgba(0,0,0,.25);box-shadow:inset 0 -60px 5px -5px rgba(0,0,0,.25)}[id^=NotiflixReportWrap].nx-rtl-on a#NXReportButton{float:left}[id^=NotiflixReportWrap]>div[class*="-overlay"].nx-with-animation{-webkit-animation:report-overlay-animation .3s ease-in-out 0s normal;animation:report-overlay-animation .3s ease-in-out 0s normal}@-webkit-keyframes report-overlay-animation{0%{opacity:0}100%{opacity:1}}@keyframes report-overlay-animation{0%{opacity:0}100%{opacity:1}}[id^=NotiflixReportWrap]>div[class*="-content"].nx-with-animation.nx-fade{-webkit-animation:report-animation-fade .3s ease-in-out 0s normal;animation:report-animation-fade .3s ease-in-out 0s normal}@-webkit-keyframes report-animation-fade{0%{opacity:0}100%{opacity:1}}@keyframes report-animation-fade{0%{opacity:0}100%{opacity:1}}[id^=NotiflixReportWrap]>div[class*="-content"].nx-with-animation.nx-zoom{-webkit-animation:report-animation-zoom .3s ease-in-out 0s normal;animation:report-animation-zoom .3s ease-in-out 0s normal}@-webkit-keyframes report-animation-zoom{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}50%{opacity:1;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes report-animation-zoom{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}50%{opacity:1;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}[id^=NotiflixReportWrap].nx-remove>div[class*="-overlay"].nx-with-animation{opacity:0;-webkit-animation:report-overlay-animation-remove .3s ease-in-out 0s normal;animation:report-overlay-animation-remove .3s ease-in-out 0s normal}@-webkit-keyframes report-overlay-animation-remove{0%{opacity:1}100%{opacity:0}}@keyframes report-overlay-animation-remove{0%{opacity:1}100%{opacity:0}}[id^=NotiflixReportWrap].nx-remove>div[class*="-content"].nx-with-animation.nx-fade{opacity:0;-webkit-animation:report-animation-fade-remove .3s ease-in-out 0s normal;animation:report-animation-fade-remove .3s ease-in-out 0s normal}@-webkit-keyframes report-animation-fade-remove{0%{opacity:1}100%{opacity:0}}@keyframes report-animation-fade-remove{0%{opacity:1}100%{opacity:0}}[id^=NotiflixReportWrap].nx-remove>div[class*="-content"].nx-with-animation.nx-zoom{opacity:0;-webkit-animation:report-animation-zoom-remove .3s ease-in-out 0s normal;animation:report-animation-zoom-remove .3s ease-in-out 0s normal}@-webkit-keyframes report-animation-zoom-remove{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.5;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}}@keyframes report-animation-zoom-remove{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.5;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}}';
    }, j = function(e, a, n, o, r, l) {
        if (!w("body")) return !1;
        i || G.Report.init({});
        var m = {};
        if ("object" == typeof r && !Array.isArray(r) || "object" == typeof l && !Array.isArray(l)) {
            var f = {};
            "object" == typeof r ? f = r : "object" == typeof l && (f = l), m = v(!0, i, {}), i = v(!0, i, f);
        }
        var d = i[e.toLocaleLowerCase("en")];
        "string" != typeof a && (a = "Notiflix " + e), "string" != typeof n && (e === c.Success ? n = '"Do not try to become a person of success but try to become a person of value." <br><br>- Albert Einstein' : e === c.Failure ? n = '"Failure is simply the opportunity to begin again, this time more intelligently." <br><br>- Henry Ford' : e === c.Warning ? n = '"The peoples who want to live comfortably without producing and fatigue; they are doomed to lose their dignity, then liberty, and then independence and destiny." <br><br>- Mustafa Kemal Ataturk' : e === c.Info && (n = '"Knowledge rests not upon truth alone, but upon error also." <br><br>- Carl Gustav Jung')), "string" != typeof o && (o = "Okay"), i.plainText && (a = N(a), n = N(n), o = N(o)), i.plainText || (a.length > i.titleMaxLength && (a = "Possible HTML Tags Error", n = 'The "plainText" option is "false" and the title content length is more than the "titleMaxLength" option.', o = "Okay"), n.length > i.messageMaxLength && (a = "Possible HTML Tags Error", n = 'The "plainText" option is "false" and the message content length is more than the "messageMaxLength" option.', o = "Okay"), o.length > i.buttonMaxLength && (a = "Possible HTML Tags Error", n = 'The "plainText" option is "false" and the button content length is more than the "buttonMaxLength" option.', o = "Okay")), a.length > i.titleMaxLength && (a = a.substring(0, i.titleMaxLength) + "..."), n.length > i.messageMaxLength && (n = n.substring(0, i.messageMaxLength) + "..."), o.length > i.buttonMaxLength && (o = o.substring(0, i.buttonMaxLength) + "..."), i.cssAnimation || (i.cssAnimationDuration = 0);
        var x = t.document.createElement("div");
        x.id = p.ID, x.className = i.className, x.style.zIndex = i.zindex, x.style.borderRadius = i.borderRadius, x.style.fontFamily = '"' + i.fontFamily + '", ' + s, i.rtl && (x.setAttribute("dir", "rtl"), x.classList.add("nx-rtl-on")), x.style.display = "flex", x.style.flexWrap = "wrap", x.style.flexDirection = "column", x.style.alignItems = "center", x.style.justifyContent = "center";
        var g = "", b = !0 === i.backOverlayClickToClose;
        i.backOverlay && (g = '<div class="' + i.className + "-overlay" + (i.cssAnimation ? " nx-with-animation" : "") + (b ? " nx-report-click-to-close" : "") + '" style="background:' + (d.backOverlayColor || i.backOverlayColor) + ";animation-duration:" + i.cssAnimationDuration + 'ms;"></div>');
        var u = "";
        if (e === c.Success ? u = C(i.svgSize, d.svgColor) : e === c.Failure ? u = z(i.svgSize, d.svgColor) : e === c.Warning ? u = S(i.svgSize, d.svgColor) : e === c.Info && (u = L(i.svgSize, d.svgColor)), x.innerHTML = g + '<div class="' + i.className + "-content" + (i.cssAnimation ? " nx-with-animation " : "") + " nx-" + i.cssAnimationStyle + '" style="width:' + i.width + "; background:" + i.backgroundColor + "; animation-duration:" + i.cssAnimationDuration + 'ms;"><div style="width:' + i.svgSize + "; height:" + i.svgSize + ';" class="' + i.className + '-icon">' + u + '</div><h5 class="' + i.className + '-title" style="font-weight:500; font-size:' + i.titleFontSize + "; color:" + d.titleColor + ';">' + a + '</h5><p class="' + i.className + '-message" style="font-size:' + i.messageFontSize + "; color:" + d.messageColor + ';">' + n + '</p><a id="NXReportButton" class="' + i.className + '-button" style="font-weight:500; font-size:' + i.buttonFontSize + "; background:" + d.buttonBackground + "; color:" + d.buttonColor + ';">' + o + "</a></div>", !t.document.getElementById(x.id)) {
            t.document.body.appendChild(x);
            var y = function() {
                var e = t.document.getElementById(x.id);
                e.classList.add("nx-remove");
                var a = setTimeout(function() {
                    null !== e.parentNode && e.parentNode.removeChild(e), clearTimeout(a);
                }, i.cssAnimationDuration);
            }, k = t.document.getElementById("NXReportButton");
            if (k.addEventListener("click", function() {
                "function" == typeof r && r(), y();
            }), g && b) {
                var h = t.document.querySelector(".nx-report-click-to-close");
                h.addEventListener("click", function() {
                    y();
                });
            }
        }
        i = v(!0, i, m);
    }, O = function() {
        return '[id^=NotiflixConfirmWrap]{position:fixed;z-index:4003;width:100%;height:100%;left:0;top:0;padding:10px;-webkit-box-sizing:border-box;box-sizing:border-box;background:transparent;font-family:"Quicksand",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}[id^=NotiflixConfirmWrap].nx-position-center-top{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}[id^=NotiflixConfirmWrap].nx-position-center-bottom{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}[id^=NotiflixConfirmWrap].nx-position-left-top{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}[id^=NotiflixConfirmWrap].nx-position-left-center{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start}[id^=NotiflixConfirmWrap].nx-position-left-bottom{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}[id^=NotiflixConfirmWrap].nx-position-right-top{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}[id^=NotiflixConfirmWrap].nx-position-right-center{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end}[id^=NotiflixConfirmWrap].nx-position-right-bottom{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}[id^=NotiflixConfirmWrap] *{-webkit-box-sizing:border-box;box-sizing:border-box}[id^=NotiflixConfirmWrap]>div[class*="-overlay"]{width:100%;height:100%;left:0;top:0;background:rgba(255,255,255,.5);position:fixed;z-index:0}[id^=NotiflixConfirmWrap]>div[class*="-overlay"].nx-with-animation{-webkit-animation:confirm-overlay-animation .3s ease-in-out 0s normal;animation:confirm-overlay-animation .3s ease-in-out 0s normal}@-webkit-keyframes confirm-overlay-animation{0%{opacity:0}100%{opacity:1}}@keyframes confirm-overlay-animation{0%{opacity:0}100%{opacity:1}}[id^=NotiflixConfirmWrap].nx-remove>div[class*="-overlay"].nx-with-animation{opacity:0;-webkit-animation:confirm-overlay-animation-remove .3s ease-in-out 0s normal;animation:confirm-overlay-animation-remove .3s ease-in-out 0s normal}@-webkit-keyframes confirm-overlay-animation-remove{0%{opacity:1}100%{opacity:0}}@keyframes confirm-overlay-animation-remove{0%{opacity:1}100%{opacity:0}}[id^=NotiflixConfirmWrap]>div[class*="-content"]{width:300px;max-width:100%;max-height:96vh;overflow-x:hidden;overflow-y:auto;border-radius:25px;padding:10px;margin:0;-webkit-filter:drop-shadow(0 0 5px rgba(0,0,0,0.05));filter:drop-shadow(0 0 5px rgba(0, 0, 0, .05));background:#f8f8f8;color:#1e1e1e;position:relative;z-index:1;text-align:center}[id^=NotiflixConfirmWrap]>div[class*="-content"]::-webkit-scrollbar{width:0;height:0}[id^=NotiflixConfirmWrap]>div[class*="-content"]::-webkit-scrollbar-thumb{background:transparent}[id^=NotiflixConfirmWrap]>div[class*="-content"]::-webkit-scrollbar-track{background:transparent}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]{float:left;width:100%;text-align:inherit}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]>h5{float:left;width:100%;margin:0;padding:0 0 10px;border-bottom:1px solid rgba(0,0,0,.1);color:#32c682;font-family:inherit!important;font-size:16px;line-height:1.4;font-weight:500;text-align:inherit}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]>div{font-family:inherit!important;margin:15px 0 20px;padding:0 10px;float:left;width:100%;font-size:14px;line-height:1.4;font-weight:normal;color:inherit;text-align:inherit}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]>div>div{font-family:inherit!important;float:left;width:100%;margin:15px 0 0;padding:0}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]>div>div>input{font-family:inherit!important;float:left;width:100%;height:40px;margin:0;padding:0 15px;border:1px solid rgba(0,0,0,.1);border-radius:25px;font-size:14px;font-weight:normal;line-height:1;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;transition:all .25s ease-in-out;text-align:left}[id^=NotiflixConfirmWrap].nx-rtl-on>div[class*="-content"]>div[class*="-head"]>div>div>input{text-align:right}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]>div>div>input:hover{border-color:rgba(0,0,0,.1)}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]>div>div>input:focus{border-color:rgba(0,0,0,.3)}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]>div>div>input.nx-validation-failure{border-color:#ff5549}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-head"]>div>div>input.nx-validation-success{border-color:#32c682}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-buttons"]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:inherit;float:left;width:100%;text-align:inherit}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-buttons"]>a{cursor:pointer;font-family:inherit!important;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;transition:all .25s ease-in-out;float:left;width:48%;padding:9px 5px;border-radius:inherit!important;font-weight:500;font-size:15px;line-height:1.4;color:#f8f8f8;text-align:inherit}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-buttons"]>a.nx-confirm-button-ok{margin:0 2% 0 0;background:#32c682}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-buttons"]>a.nx-confirm-button-cancel{margin:0 0 0 2%;background:#a9a9a9}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-buttons"]>a.nx-full{margin:0;width:100%}[id^=NotiflixConfirmWrap]>div[class*="-content"]>div[class*="-buttons"]>a:hover{-webkit-box-shadow:inset 0 -60px 5px -5px rgba(0,0,0,.25);box-shadow:inset 0 -60px 5px -5px rgba(0,0,0,.25)}[id^=NotiflixConfirmWrap].nx-rtl-on>div[class*="-content"]>div[class*="-buttons"],[id^=NotiflixConfirmWrap].nx-rtl-on>div[class*="-content"]>div[class*="-buttons"]>a{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}[id^=NotiflixConfirmWrap].nx-with-animation.nx-fade>div[class*="-content"]{-webkit-animation:confirm-animation-fade .3s ease-in-out 0s normal;animation:confirm-animation-fade .3s ease-in-out 0s normal}@-webkit-keyframes confirm-animation-fade{0%{opacity:0}100%{opacity:1}}@keyframes confirm-animation-fade{0%{opacity:0}100%{opacity:1}}[id^=NotiflixConfirmWrap].nx-with-animation.nx-zoom>div[class*="-content"]{-webkit-animation:confirm-animation-zoom .3s ease-in-out 0s normal;animation:confirm-animation-zoom .3s ease-in-out 0s normal}@-webkit-keyframes confirm-animation-zoom{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}50%{opacity:1;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes confirm-animation-zoom{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}50%{opacity:1;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}[id^=NotiflixConfirmWrap].nx-with-animation.nx-fade.nx-remove>div[class*="-content"]{opacity:0;-webkit-animation:confirm-animation-fade-remove .3s ease-in-out 0s normal;animation:confirm-animation-fade-remove .3s ease-in-out 0s normal}@-webkit-keyframes confirm-animation-fade-remove{0%{opacity:1}100%{opacity:0}}@keyframes confirm-animation-fade-remove{0%{opacity:1}100%{opacity:0}}[id^=NotiflixConfirmWrap].nx-with-animation.nx-zoom.nx-remove>div[class*="-content"]{opacity:0;-webkit-animation:confirm-animation-zoom-remove .3s ease-in-out 0s normal;animation:confirm-animation-zoom-remove .3s ease-in-out 0s normal}@-webkit-keyframes confirm-animation-zoom-remove{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.5;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}}@keyframes confirm-animation-zoom-remove{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.5;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}}';
    }, H = function(e, i, n, o, r, l, m, c, p) {
        if (!w("body")) return !1;
        a || G.Confirm.init({});
        var x = v(!0, a, {});
        "object" != typeof p || Array.isArray(p) || (a = v(!0, a, p)), "string" != typeof i && (i = "Notiflix Confirm"), "string" != typeof n && (n = "Do you agree with me?"), "string" != typeof r && (r = "Yes"), "string" != typeof l && (l = "No"), "function" != typeof m && (m = void 0), "function" != typeof c && (c = void 0), a.plainText && (i = N(i), n = N(n), r = N(r), l = N(l)), a.plainText || (i.length > a.titleMaxLength && (i = "Possible HTML Tags Error", n = 'The "plainText" option is "false" and the title content length is more than "titleMaxLength" option.', r = "Okay", l = "..."), n.length > a.messageMaxLength && (i = "Possible HTML Tags Error", n = 'The "plainText" option is "false" and the message content length is more than "messageMaxLength" option.', r = "Okay", l = "..."), (r.length || l.length) > a.buttonsMaxLength && (i = "Possible HTML Tags Error", n = 'The "plainText" option is "false" and the buttons content length is more than "buttonsMaxLength" option.', r = "Okay", l = "...")), i.length > a.titleMaxLength && (i = i.substring(0, a.titleMaxLength) + "..."), n.length > a.messageMaxLength && (n = n.substring(0, a.messageMaxLength) + "..."), r.length > a.buttonsMaxLength && (r = r.substring(0, a.buttonsMaxLength) + "..."), l.length > a.buttonsMaxLength && (l = l.substring(0, a.buttonsMaxLength) + "..."), a.cssAnimation || (a.cssAnimationDuration = 0);
        var g = t.document.createElement("div");
        g.id = d.ID, g.className = a.className + (a.cssAnimation ? " nx-with-animation nx-" + a.cssAnimationStyle : ""), g.style.zIndex = a.zindex, g.style.padding = a.distance, a.rtl && (g.setAttribute("dir", "rtl"), g.classList.add("nx-rtl-on"));
        var b = "string" == typeof a.position ? a.position.trim() : "center";
        g.classList.add("nx-position-" + b), g.style.fontFamily = '"' + a.fontFamily + '", ' + s;
        var u = "";
        a.backOverlay && (u = '<div class="' + a.className + "-overlay" + (a.cssAnimation ? " nx-with-animation" : "") + '" style="background:' + a.backOverlayColor + ";animation-duration:" + a.cssAnimationDuration + 'ms;"></div>');
        var y = "";
        "function" == typeof m && (y = '<a id="NXConfirmButtonCancel" class="nx-confirm-button-cancel" style="color:' + a.cancelButtonColor + ";background:" + a.cancelButtonBackground + ";font-size:" + a.buttonsFontSize + ';">' + l + "</a>");
        var k = "", h = null, C = void 0;
        if (e === f.Ask || e === f.Prompt) {
            h = o || "";
            var z = e === f.Ask ? Math.ceil(1.5 * h.length) : 200 < h.length ? Math.ceil(1.5 * h.length) : 250, S = e === f.Prompt ? 'value="' + h + '"' : "";
            k = '<div><input id="NXConfirmValidationInput" type="text" ' + S + ' maxlength="' + z + '" style="font-size:' + a.messageFontSize + ";border-radius: " + a.borderRadius + ';" autocomplete="off" spellcheck="false" autocapitalize="none" /></div>';
        }
        if (g.innerHTML = u + '<div class="' + a.className + '-content" style="width:' + a.width + "; background:" + a.backgroundColor + "; animation-duration:" + a.cssAnimationDuration + "ms; border-radius: " + a.borderRadius + ';"><div class="' + a.className + '-head"><h5 style="color:' + a.titleColor + ";font-size:" + a.titleFontSize + ';">' + i + '</h5><div style="color:' + a.messageColor + ";font-size:" + a.messageFontSize + ';">' + n + k + '</div></div><div class="' + a.className + '-buttons"><a id="NXConfirmButtonOk" class="nx-confirm-button-ok' + ("function" == typeof m ? "" : " nx-full") + '" style="color:' + a.okButtonColor + ";background:" + a.okButtonBackground + ";font-size:" + a.buttonsFontSize + ';">' + r + "</a>" + y + "</div></div>", !t.document.getElementById(g.id)) {
            t.document.body.appendChild(g);
            var L = t.document.getElementById(g.id), W = t.document.getElementById("NXConfirmButtonOk"), I = t.document.getElementById("NXConfirmValidationInput");
            if (I && (I.focus(), I.setSelectionRange(0, (I.value || "").length), I.addEventListener("keyup", function(t) {
                var i = t.target.value;
                if (e === f.Ask && i !== h) t.preventDefault(), I.classList.add("nx-validation-failure"), I.classList.remove("nx-validation-success");
                else {
                    e === f.Ask && (I.classList.remove("nx-validation-failure"), I.classList.add("nx-validation-success"));
                    var a = "enter" === (t.key || "").toLocaleLowerCase("en") || 13 === t.keyCode;
                    a && W.dispatchEvent(new Event("click"));
                }
            })), W.addEventListener("click", function(t) {
                if (e === f.Ask && h && I) {
                    var i = (I.value || "").toString();
                    if (i !== h) return I.focus(), I.classList.add("nx-validation-failure"), t.stopPropagation(), t.preventDefault(), t.returnValue = !1, t.cancelBubble = !0, !1;
                    I.classList.remove("nx-validation-failure");
                }
                "function" == typeof m && (e === f.Prompt && I && (C = I.value || ""), m(C)), L.classList.add("nx-remove");
                var n = setTimeout(function() {
                    null !== L.parentNode && (L.parentNode.removeChild(L), clearTimeout(n));
                }, a.cssAnimationDuration);
            }), "function" == typeof m) {
                var R = t.document.getElementById("NXConfirmButtonCancel");
                R.addEventListener("click", function() {
                    "function" == typeof c && (e === f.Prompt && I && (C = I.value || ""), c(C)), L.classList.add("nx-remove");
                    var t = setTimeout(function() {
                        null !== L.parentNode && (L.parentNode.removeChild(L), clearTimeout(t));
                    }, a.cssAnimationDuration);
                });
            }
        }
        a = v(!0, a, x);
    }, P = function() {
        return '[id^=NotiflixLoadingWrap]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:fixed;z-index:4000;width:100%;height:100%;left:0;top:0;right:0;bottom:0;margin:auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center;-webkit-box-sizing:border-box;box-sizing:border-box;background:rgba(0,0,0,.8);font-family:"Quicksand",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif}[id^=NotiflixLoadingWrap] *{-webkit-box-sizing:border-box;box-sizing:border-box}[id^=NotiflixLoadingWrap].nx-loading-click-to-close{cursor:pointer}[id^=NotiflixLoadingWrap]>div[class*="-icon"]{width:60px;height:60px;position:relative;-webkit-transition:top .2s ease-in-out;-o-transition:top .2s ease-in-out;transition:top .2s ease-in-out;margin:0 auto}[id^=NotiflixLoadingWrap]>div[class*="-icon"] img,[id^=NotiflixLoadingWrap]>div[class*="-icon"] svg{max-width:unset;max-height:unset;width:100%;height:auto;position:absolute;left:0;top:0}[id^=NotiflixLoadingWrap]>p{position:relative;margin:10px auto 0;font-family:inherit!important;font-weight:normal;font-size:15px;line-height:1.4;padding:0 10px;width:100%;text-align:center}[id^=NotiflixLoadingWrap].nx-with-animation{-webkit-animation:loading-animation-fade .3s ease-in-out 0s normal;animation:loading-animation-fade .3s ease-in-out 0s normal}@-webkit-keyframes loading-animation-fade{0%{opacity:0}100%{opacity:1}}@keyframes loading-animation-fade{0%{opacity:0}100%{opacity:1}}[id^=NotiflixLoadingWrap].nx-with-animation.nx-remove{opacity:0;-webkit-animation:loading-animation-fade-remove .3s ease-in-out 0s normal;animation:loading-animation-fade-remove .3s ease-in-out 0s normal}@-webkit-keyframes loading-animation-fade-remove{0%{opacity:1}100%{opacity:0}}@keyframes loading-animation-fade-remove{0%{opacity:1}100%{opacity:0}}[id^=NotiflixLoadingWrap]>p.nx-loading-message-new{-webkit-animation:loading-new-message-fade .3s ease-in-out 0s normal;animation:loading-new-message-fade .3s ease-in-out 0s normal}@-webkit-keyframes loading-new-message-fade{0%{opacity:0}100%{opacity:1}}@keyframes loading-new-message-fade{0%{opacity:0}100%{opacity:1}}';
    }, U = function(e, i, a, o, r) {
        if (!w("body")) return !1;
        n || G.Loading.init({});
        var l = v(!0, n, {});
        if ("object" == typeof i && !Array.isArray(i) || "object" == typeof a && !Array.isArray(a)) {
            var m = {};
            "object" == typeof i ? m = i : "object" == typeof a && (m = a), n = v(!0, n, m);
        }
        var c = "";
        if ("string" == typeof i && 0 < i.length && (c = i), o) {
            c = c.length > n.messageMaxLength ? N(c).toString().substring(0, n.messageMaxLength) + "..." : N(c).toString();
            var p = "";
            0 < c.length && (p = '<p id="' + n.messageID + '" class="nx-loading-message" style="color:' + n.messageColor + ";font-size:" + n.messageFontSize + ';">' + c + "</p>"), n.cssAnimation || (n.cssAnimationDuration = 0);
            var f = "";
            if (e === x.Standard) f = W(n.svgSize, n.svgColor);
            else if (e === x.Hourglass) f = I(n.svgSize, n.svgColor);
            else if (e === x.Circle) f = R(n.svgSize, n.svgColor);
            else if (e === x.Arrows) f = A(n.svgSize, n.svgColor);
            else if (e === x.Dots) f = M(n.svgSize, n.svgColor);
            else if (e === x.Pulse) f = B(n.svgSize, n.svgColor);
            else if (e === x.Custom && null !== n.customSvgCode && null === n.customSvgUrl) f = n.customSvgCode || "";
            else if (e === x.Custom && null !== n.customSvgUrl && null === n.customSvgCode) f = '<img class="nx-custom-loading-icon" width="' + n.svgSize + '" height="' + n.svgSize + '" src="' + n.customSvgUrl + '" alt="Notiflix">';
            else {
                if (e === x.Custom && (null === n.customSvgUrl || null === n.customSvgCode)) return y('You have to set a static SVG url to "customSvgUrl" option to use Loading Custom.'), !1;
                f = X(n.svgSize, "#f8f8f8", "#32c682");
            }
            var d = parseInt((n.svgSize || "").replace(/[^0-9]/g, "")), b = t.innerWidth, u = d >= b ? b - 40 + "px" : d + "px", k = '<div style="width:' + u + "; height:" + u + ';" class="' + n.className + "-icon" + (0 < c.length ? " nx-with-message" : "") + '">' + f + "</div>", h = t.document.createElement("div");
            if (h.id = g.ID, h.className = n.className + (n.cssAnimation ? " nx-with-animation" : "") + (n.clickToClose ? " nx-loading-click-to-close" : ""), h.style.zIndex = n.zindex, h.style.background = n.backgroundColor, h.style.animationDuration = n.cssAnimationDuration + "ms", h.style.fontFamily = '"' + n.fontFamily + '", ' + s, h.style.display = "flex", h.style.flexWrap = "wrap", h.style.flexDirection = "column", h.style.alignItems = "center", h.style.justifyContent = "center", n.rtl && (h.setAttribute("dir", "rtl"), h.classList.add("nx-rtl-on")), h.innerHTML = k + p, !t.document.getElementById(h.id) && (t.document.body.appendChild(h), n.clickToClose)) {
                var C = t.document.getElementById(h.id);
                C.addEventListener("click", function() {
                    h.classList.add("nx-remove");
                    var t = setTimeout(function() {
                        null !== h.parentNode && (h.parentNode.removeChild(h), clearTimeout(t));
                    }, n.cssAnimationDuration);
                });
            }
        } else if (t.document.getElementById(g.ID)) var z = t.document.getElementById(g.ID), S = setTimeout(function() {
            z.classList.add("nx-remove");
            var t = setTimeout(function() {
                null !== z.parentNode && (z.parentNode.removeChild(z), clearTimeout(t));
            }, n.cssAnimationDuration);
            clearTimeout(S);
        }, r);
        n = v(!0, n, l);
    }, V = function(e) {
        "string" != typeof e && (e = "");
        var i = t.document.getElementById(g.ID);
        if (i) {
            if (0 < e.length) {
                e = e.length > n.messageMaxLength ? N(e).substring(0, n.messageMaxLength) + "..." : N(e);
                var a = i.getElementsByTagName("p")[0];
                if (a) a.innerHTML = e;
                else {
                    var o = t.document.createElement("p");
                    o.id = n.messageID, o.className = "nx-loading-message nx-loading-message-new", o.style.color = n.messageColor, o.style.fontSize = n.messageFontSize, o.innerHTML = e, i.appendChild(o);
                }
            } else y("Where is the new message?");
        }
    }, q = function() {
        return '[id^=NotiflixBlockWrap]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;z-index:1000;font-family:"Quicksand",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;background:rgba(255,255,255,.9);text-align:center;animation-duration:.4s;width:100%;height:100%;left:0;top:0;border-radius:inherit;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}[id^=NotiflixBlockWrap] *{-webkit-box-sizing:border-box;box-sizing:border-box}[id^=NotiflixBlockWrap]>span[class*="-icon"]{display:block;width:45px;height:45px;position:relative;margin:0 auto}[id^=NotiflixBlockWrap]>span[class*="-icon"] svg{width:inherit;height:inherit}[id^=NotiflixBlockWrap]>span[class*="-message"]{position:relative;display:block;width:100%;margin:10px auto 0;padding:0 10px;font-family:inherit!important;font-weight:normal;font-size:14px;line-height:1.4}[id^=NotiflixBlockWrap].nx-with-animation{-webkit-animation:block-animation-fade .3s ease-in-out 0s normal;animation:block-animation-fade .3s ease-in-out 0s normal}@-webkit-keyframes block-animation-fade{0%{opacity:0}100%{opacity:1}}@keyframes block-animation-fade{0%{opacity:0}100%{opacity:1}}[id^=NotiflixBlockWrap].nx-with-animation.nx-remove{opacity:0;-webkit-animation:block-animation-fade-remove .3s ease-in-out 0s normal;animation:block-animation-fade-remove .3s ease-in-out 0s normal}@-webkit-keyframes block-animation-fade-remove{0%{opacity:1}100%{opacity:0}}@keyframes block-animation-fade-remove{0%{opacity:1}100%{opacity:0}}';
    }, Q = 0, Y = function(e, i, a, n, r, l) {
        var m;
        if (Array.isArray(a)) {
            if (1 > a.length) return y("Array of HTMLElements should contains at least one HTMLElement."), !1;
            m = a;
        } else if (Object.prototype.isPrototypeOf.call(NodeList.prototype, a)) {
            if (1 > a.length) return y("NodeListOf<HTMLElement> should contains at least one HTMLElement."), !1;
            m = Array.prototype.slice.call(a);
        } else {
            var c = "string" != typeof a || 1 > (a || "").length || 1 === (a || "").length && ("#" === (a || "")[0] || "." === (a || "")[0]);
            if (c) return y("The selector parameter must be a string and matches a specified CSS selector(s)."), !1;
            var p = t.document.querySelectorAll(a);
            if (1 > p.length) return y('You called the "Notiflix.Block..." function with "' + a + '" selector, but there is no such element(s) in the document.'), !1;
            m = p;
        }
        o || G.Block.init({});
        var f = v(!0, o, {});
        if ("object" == typeof n && !Array.isArray(n) || "object" == typeof r && !Array.isArray(r)) {
            var d = {};
            "object" == typeof n ? d = n : "object" == typeof r && (d = r), o = v(!0, o, d);
        }
        var x = "";
        "string" == typeof n && 0 < n.length && (x = n), o.cssAnimation || (o.cssAnimationDuration = 0);
        var g = u.className;
        "string" == typeof o.className && (g = o.className.trim());
        var h = "number" == typeof o.querySelectorLimit ? o.querySelectorLimit : 200, C = (m || []).length >= h ? h : m.length, z = "nx-block-temporary-position";
        if (e) {
            for(var S, L = [
                "area",
                "base",
                "br",
                "col",
                "command",
                "embed",
                "hr",
                "img",
                "input",
                "keygen",
                "link",
                "meta",
                "param",
                "source",
                "track",
                "wbr",
                "html",
                "head",
                "title",
                "script",
                "style",
                "iframe"
            ], X = 0; X < C; X++)if (S = m[X], S) {
                if (-1 < L.indexOf(S.tagName.toLocaleLowerCase("en"))) break;
                var D = S.querySelectorAll("[id^=" + u.ID + "]");
                if (1 > D.length) {
                    var T = "";
                    i && (i === b.Hourglass ? T = I(o.svgSize, o.svgColor) : i === b.Circle ? T = R(o.svgSize, o.svgColor) : i === b.Arrows ? T = A(o.svgSize, o.svgColor) : i === b.Dots ? T = M(o.svgSize, o.svgColor) : i === b.Pulse ? T = B(o.svgSize, o.svgColor) : T = W(o.svgSize, o.svgColor));
                    var F = '<span class="' + g + '-icon" style="width:' + o.svgSize + ";height:" + o.svgSize + ';">' + T + "</span>", E = "";
                    0 < x.length && (x = x.length > o.messageMaxLength ? N(x).substring(0, o.messageMaxLength) + "..." : N(x), E = '<span style="font-size:' + o.messageFontSize + ";color:" + o.messageColor + ';" class="' + g + '-message">' + x + "</span>"), Q++;
                    var j = t.document.createElement("div");
                    j.id = u.ID + "-" + Q, j.className = g + (o.cssAnimation ? " nx-with-animation" : ""), j.style.position = o.position, j.style.zIndex = o.zindex, j.style.background = o.backgroundColor, j.style.animationDuration = o.cssAnimationDuration + "ms", j.style.fontFamily = '"' + o.fontFamily + '", ' + s, j.style.display = "flex", j.style.flexWrap = "wrap", j.style.flexDirection = "column", j.style.alignItems = "center", j.style.justifyContent = "center", o.rtl && (j.setAttribute("dir", "rtl"), j.classList.add("nx-rtl-on")), j.innerHTML = F + E;
                    var O = t.getComputedStyle(S).getPropertyValue("position"), H = "string" == typeof O ? O.toLocaleLowerCase("en") : "relative", P = Math.round(1.25 * parseInt(o.svgSize)) + 40, U = S.offsetHeight || 0, V = "";
                    P > U && (V = "min-height:" + P + "px;");
                    var q = "";
                    q = S.getAttribute("id") ? "#" + S.getAttribute("id") : S.classList[0] ? "." + S.classList[0] : (S.tagName || "").toLocaleLowerCase("en");
                    var Y = "", K = -1 >= [
                        "absolute",
                        "relative",
                        "fixed",
                        "sticky"
                    ].indexOf(H);
                    if (K || 0 < V.length) {
                        if (!w("head")) return !1;
                        K && (Y = "position:relative!important;");
                        var $ = '<style id="Style-' + u.ID + "-" + Q + '">' + q + "." + z + "{" + Y + V + "}</style>", J = t.document.createRange();
                        J.selectNode(t.document.head);
                        var Z = J.createContextualFragment($);
                        t.document.head.appendChild(Z), S.classList.add(z);
                    }
                    S.appendChild(j);
                }
            }
        } else var _ = function(e) {
            var i = setTimeout(function() {
                null !== e.parentNode && e.parentNode.removeChild(e);
                var a = e.getAttribute("id"), n = t.document.getElementById("Style-" + a);
                n && null !== n.parentNode && n.parentNode.removeChild(n), clearTimeout(i);
            }, o.cssAnimationDuration);
        }, tt = function(t) {
            if (t && 0 < t.length) for(var e, n = 0; n < t.length; n++)e = t[n], e && (e.classList.add("nx-remove"), _(e));
            else "string" == typeof a ? k('"Notiflix.Block.remove();" function called with "' + a + '" selector, but this selector does not have a "Block" element to remove.') : k('"Notiflix.Block.remove();" function called with "' + a + '", but this "Array<HTMLElement>" or "NodeListOf<HTMLElement>" does not have a "Block" element to remove.');
        }, et = function(t) {
            var e = setTimeout(function() {
                t.classList.remove(z), clearTimeout(e);
            }, o.cssAnimationDuration + 300);
        }, it = setTimeout(function() {
            for(var t, e = 0; e < C; e++)t = m[e], t && (et(t), D = t.querySelectorAll("[id^=" + u.ID + "]"), tt(D));
            clearTimeout(it);
        }, l);
        o = v(!0, o, f);
    }, G = {
        Notify: {
            init: function(t) {
                e = v(!0, m, t), h(D, "NotiflixNotifyInternalCSS");
            },
            merge: function(t) {
                return e ? void (e = v(!0, e, t)) : (y("You have to initialize the Notify module before call Merge function."), !1);
            },
            success: function(t, e, i) {
                F(l.Success, t, e, i);
            },
            failure: function(t, e, i) {
                F(l.Failure, t, e, i);
            },
            warning: function(t, e, i) {
                F(l.Warning, t, e, i);
            },
            info: function(t, e, i) {
                F(l.Info, t, e, i);
            }
        },
        Report: {
            init: function(t) {
                i = v(!0, p, t), h(E, "NotiflixReportInternalCSS");
            },
            merge: function(t) {
                return i ? void (i = v(!0, i, t)) : (y("You have to initialize the Report module before call Merge function."), !1);
            },
            success: function(t, e, i, a, n) {
                j(c.Success, t, e, i, a, n);
            },
            failure: function(t, e, i, a, n) {
                j(c.Failure, t, e, i, a, n);
            },
            warning: function(t, e, i, a, n) {
                j(c.Warning, t, e, i, a, n);
            },
            info: function(t, e, i, a, n) {
                j(c.Info, t, e, i, a, n);
            }
        },
        Confirm: {
            init: function(t) {
                a = v(!0, d, t), h(O, "NotiflixConfirmInternalCSS");
            },
            merge: function(t) {
                return a ? void (a = v(!0, a, t)) : (y("You have to initialize the Confirm module before call Merge function."), !1);
            },
            show: function(t, e, i, a, n, o, r) {
                H(f.Show, t, e, null, i, a, n, o, r);
            },
            ask: function(t, e, i, a, n, o, r, s) {
                H(f.Ask, t, e, i, a, n, o, r, s);
            },
            prompt: function(t, e, i, a, n, o, r, s) {
                H(f.Prompt, t, e, i, a, n, o, r, s);
            }
        },
        Loading: {
            init: function(t) {
                n = v(!0, g, t), h(P, "NotiflixLoadingInternalCSS");
            },
            merge: function(t) {
                return n ? void (n = v(!0, n, t)) : (y("You have to initialize the Loading module before call Merge function."), !1);
            },
            standard: function(t, e) {
                U(x.Standard, t, e, !0, 0);
            },
            hourglass: function(t, e) {
                U(x.Hourglass, t, e, !0, 0);
            },
            circle: function(t, e) {
                U(x.Circle, t, e, !0, 0);
            },
            arrows: function(t, e) {
                U(x.Arrows, t, e, !0, 0);
            },
            dots: function(t, e) {
                U(x.Dots, t, e, !0, 0);
            },
            pulse: function(t, e) {
                U(x.Pulse, t, e, !0, 0);
            },
            custom: function(t, e) {
                U(x.Custom, t, e, !0, 0);
            },
            notiflix: function(t, e) {
                U(x.Notiflix, t, e, !0, 0);
            },
            remove: function(t) {
                "number" != typeof t && (t = 0), U(null, null, null, !1, t);
            },
            change: function(t) {
                V(t);
            }
        },
        Block: {
            init: function(t) {
                o = v(!0, u, t), h(q, "NotiflixBlockInternalCSS");
            },
            merge: function(t) {
                return o ? void (o = v(!0, o, t)) : (y('You have to initialize the "Notiflix.Block" module before call Merge function.'), !1);
            },
            standard: function(t, e, i) {
                Y(!0, b.Standard, t, e, i);
            },
            hourglass: function(t, e, i) {
                Y(!0, b.Hourglass, t, e, i);
            },
            circle: function(t, e, i) {
                Y(!0, b.Circle, t, e, i);
            },
            arrows: function(t, e, i) {
                Y(!0, b.Arrows, t, e, i);
            },
            dots: function(t, e, i) {
                Y(!0, b.Dots, t, e, i);
            },
            pulse: function(t, e, i) {
                Y(!0, b.Pulse, t, e, i);
            },
            remove: function(t, e) {
                "number" != typeof e && (e = 0), Y(!1, null, t, null, null, e);
            }
        }
    };
    return "object" == typeof t.Notiflix ? v(!0, t.Notiflix, {
        Notify: G.Notify,
        Report: G.Report,
        Confirm: G.Confirm,
        Loading: G.Loading,
        Block: G.Block
    }) : {
        Notify: G.Notify,
        Report: G.Report,
        Confirm: G.Confirm,
        Loading: G.Loading,
        Block: G.Block
    };
});

});

parcelRegister("eJ9Nc", function(module, exports) {

$parcel$export(module.exports, "getBackendUrl", function () { return $d5f9605b526afad8$export$580109732c057b1e; });
const $d5f9605b526afad8$export$580109732c057b1e = ()=>{
    const currentUrl = new URL(window.location.href);
    const isLocal = currentUrl.host.startsWith("localhost");
    if (isLocal) return "http://localhost:8081";
    const isStaging = currentUrl.host.startsWith("periodic-reviews-staging");
    if (isStaging) return "https://periodic-reviews-api-staging-854436407780.europe-west1.run.app";
    return "https://periodic-reviews-api-production-1060281356034.europe-west1.run.app";
};

});

parcelRegister("eTlDg", function(module, exports) {

$parcel$export(module.exports, "setToken", function () { return $8d3d3208af4027bd$export$57e714f81a2c3d86; });
$parcel$export(module.exports, "getToken", function () { return $8d3d3208af4027bd$export$257b2d10b709d8ef; });
let $8d3d3208af4027bd$var$token;
const $8d3d3208af4027bd$export$57e714f81a2c3d86 = (newToken)=>{
    $8d3d3208af4027bd$var$token = newToken;
};
const $8d3d3208af4027bd$export$257b2d10b709d8ef = ()=>{
    return new Promise((resolve)=>{
        const intervalId = setInterval(()=>{
            if ($8d3d3208af4027bd$var$token) {
                clearInterval(intervalId);
                resolve($8d3d3208af4027bd$var$token);
            }
        }, 1000);
    });
};

});

parcelRegister("36h9V", function(module, exports) {

$parcel$export(module.exports, "getSavedLang", function () { return $77532e72cadca7e1$export$12fc82ef37db4783; });

var $2Wseo = parcelRequire("2Wseo");

var $kBVDt = parcelRequire("kBVDt");
const $77532e72cadca7e1$export$12fc82ef37db4783 = async ()=>{
    const savedLang = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_LANG_KEY));
    if (!savedLang) return "en";
    return savedLang;
};

});

parcelRegister("8uxR7", function(module, exports) {

$parcel$export(module.exports, "consoleLogStaging", function () { return $a17d016fc9fef2c0$export$5335aff909a19e85; });

var $kBVDt = parcelRequire("kBVDt");
const $a17d016fc9fef2c0$export$5335aff909a19e85 = (msg)=>{
    if (0, $kBVDt.isProduction) return;
    console.log(msg);
};

});

parcelRegister("jOIeS", function(module, exports) {

$parcel$export(module.exports, "clearIndexedDBs", function () { return $f75f18a6869bf32c$export$afae05de7e144f21; });
const $f75f18a6869bf32c$export$afae05de7e144f21 = async ()=>{
    const hasIndexedDb = "indexedDB" in window;
    if (!hasIndexedDb) return;
    const hasDatabasesMethod = typeof window.indexedDB.databases === "function";
    if (!hasDatabasesMethod) return;
    const dbs = await window.indexedDB.databases();
    const deletePromises = dbs.map((db)=>{
        if (!db.name) return Promise.resolve();
        return new Promise((resolve)=>{
            const request = window.indexedDB.deleteDatabase(db.name);
            request.onsuccess = ()=>{
                resolve();
            };
            request.onerror = ()=>{
                resolve();
            };
            request.onblocked = ()=>{
                resolve();
            };
        });
    });
    await Promise.all(deletePromises);
};

});


parcelRegister("av4DF", function(module, exports) {

$parcel$export(module.exports, "extractIndex", function () { return $d37ff88da1728c52$export$6f8597ed1a9f6cc5; });
const $d37ff88da1728c52$export$6f8597ed1a9f6cc5 = (stringId)=>{
    const match = stringId.match(/\d+/);
    console.log({
        match: match
    });
    return match ? parseInt(match[0]) : null;
};

});

parcelRegister("85fCd", function(module, exports) {

$parcel$export(module.exports, "getDatePickerLocale", function () { return $72978b9b818f796e$export$461339b450ea2f45; });

var $dGPIc = parcelRequire("dGPIc");
var $9urF2 = parcelRequire("9urF2");
var $4Fhyy = parcelRequire("4Fhyy");
var $bs9HA = parcelRequire("bs9HA");
var $5Ij1B = parcelRequire("5Ij1B");
var $4dmbt = parcelRequire("4dmbt");
var $kxQo4 = parcelRequire("kxQo4");
var $l1Do6 = parcelRequire("l1Do6");
var $unZAh = parcelRequire("unZAh");
var $24OGi = parcelRequire("24OGi");
const $72978b9b818f796e$export$461339b450ea2f45 = (lang)=>{
    // defaults
    const locale = {
        en: (0, $4Fhyy.enGB),
        es: $bs9HA.es,
        fr: $5Ij1B.fr,
        nl: $kxQo4.nl,
        pt: $unZAh.pt,
        it: $4dmbt.it,
        de: $dGPIc.de,
        pl: $l1Do6.pl,
        ro: $24OGi.ro,
        gr: (0, $9urF2.el)
    };
    //TODO: add new language here
    return locale[lang] || "";
};

});
parcelRegister("dGPIc", function(module, exports) {

$parcel$export(module.exports, "de", function () { return $f65d1b9542d2dfd2$export$2fa162a495d26869; });

var $47Gas = parcelRequire("47Gas");

var $8H6fE = parcelRequire("8H6fE");

var $4mg5w = parcelRequire("4mg5w");

var $hOOvV = parcelRequire("hOOvV");

var $24o9l = parcelRequire("24o9l");
const $f65d1b9542d2dfd2$export$2fa162a495d26869 = {
    code: "de",
    formatDistance: (0, $47Gas.formatDistance),
    formatLong: (0, $8H6fE.formatLong),
    formatRelative: (0, $4mg5w.formatRelative),
    localize: (0, $hOOvV.localize),
    match: (0, $24o9l.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$f65d1b9542d2dfd2$export$2e2bcd8739ae039 = $f65d1b9542d2dfd2$export$2fa162a495d26869;

});
parcelRegister("47Gas", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $13aa553e4a0fefce$export$2c14ff85d6318973; });
const $13aa553e4a0fefce$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        }
    },
    xSeconds: {
        standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        },
        withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        }
    },
    halfAMinute: {
        standalone: "eine halbe Minute",
        withPreposition: "einer halben Minute"
    },
    lessThanXMinutes: {
        standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        }
    },
    xMinutes: {
        standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        },
        withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        },
        withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        }
    },
    xHours: {
        standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        },
        withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        }
    },
    xDays: {
        standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
        },
        withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        },
        withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
        },
        withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
        }
    },
    xMonths: {
        standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
        },
        withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
        }
    },
    aboutXYears: {
        standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
        },
        withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
        }
    },
    xYears: {
        standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
        },
        withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
        }
    },
    overXYears: {
        standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
        }
    },
    almostXYears: {
        standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
        },
        withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
        }
    }
};
const $13aa553e4a0fefce$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = options?.addSuffix ? $13aa553e4a0fefce$var$formatDistanceLocale[token].withPreposition : $13aa553e4a0fefce$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return "vor " + result;
    }
    return result;
};

});

parcelRegister("8H6fE", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $283ce3ce18924acb$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const $283ce3ce18924acb$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $283ce3ce18924acb$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $283ce3ce18924acb$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $283ce3ce18924acb$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $283ce3ce18924acb$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $283ce3ce18924acb$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $283ce3ce18924acb$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("qt1Oy", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $9281d187849befc8$export$38e44e97ce4dbb7d; });
function $9281d187849befc8$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("4mg5w", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $f4717dbf81db8d27$export$8fbbfd65594f46a0; });
const $f4717dbf81db8d27$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
const $f4717dbf81db8d27$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$f4717dbf81db8d27$var$formatRelativeLocale[token];

});

parcelRegister("hOOvV", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $f59710e600dda854$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $f59710e600dda854$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
const $f59710e600dda854$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $f59710e600dda854$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const $f59710e600dda854$var$formattingMonthValues = {
    narrow: $f59710e600dda854$var$monthValues.narrow,
    abbreviated: [
        "Jan.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $f59710e600dda854$var$monthValues.wide
};
const $f59710e600dda854$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const $f59710e600dda854$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
const $f59710e600dda854$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
const $f59710e600dda854$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $f59710e600dda854$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f59710e600dda854$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $f59710e600dda854$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $f59710e600dda854$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $f59710e600dda854$var$monthValues,
        formattingValues: $f59710e600dda854$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $f59710e600dda854$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $f59710e600dda854$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f59710e600dda854$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("s97TY", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $0a09605a21c0a885$export$63596d6ee8878b25; });
/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $0a09605a21c0a885$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("24o9l", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $ed1764e750ba4cac$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $ed1764e750ba4cac$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $ed1764e750ba4cac$var$parseOrdinalNumberPattern = /\d+/i;
const $ed1764e750ba4cac$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
const $ed1764e750ba4cac$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
const $ed1764e750ba4cac$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
const $ed1764e750ba4cac$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ed1764e750ba4cac$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
const $ed1764e750ba4cac$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $ed1764e750ba4cac$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
const $ed1764e750ba4cac$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
const $ed1764e750ba4cac$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
const $ed1764e750ba4cac$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        evening: /abends/i,
        night: /nachts/i
    }
};
const $ed1764e750ba4cac$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $ed1764e750ba4cac$var$matchOrdinalNumberPattern,
        parsePattern: $ed1764e750ba4cac$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ed1764e750ba4cac$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1764e750ba4cac$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ed1764e750ba4cac$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1764e750ba4cac$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ed1764e750ba4cac$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1764e750ba4cac$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ed1764e750ba4cac$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1764e750ba4cac$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ed1764e750ba4cac$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1764e750ba4cac$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("e6NRw", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $2c785bdfdb5731cb$export$1430a0f35710914d; });
function $2c785bdfdb5731cb$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $2c785bdfdb5731cb$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $2c785bdfdb5731cb$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $2c785bdfdb5731cb$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $2c785bdfdb5731cb$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("KSzlc", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $96b52d54b07830b0$export$fdaf2fd6d7edde95; });
function $96b52d54b07830b0$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("9urF2", function(module, exports) {

$parcel$export(module.exports, "el", function () { return $790049daa7ed1df4$export$c3da0dad1b44eea9; });

var $jd5N2 = parcelRequire("jd5N2");

var $gwaml = parcelRequire("gwaml");

var $iQ6jp = parcelRequire("iQ6jp");

var $3Wp6U = parcelRequire("3Wp6U");

var $Ilnmu = parcelRequire("Ilnmu");
const $790049daa7ed1df4$export$c3da0dad1b44eea9 = {
    code: "el",
    formatDistance: (0, $jd5N2.formatDistance),
    formatLong: (0, $gwaml.formatLong),
    formatRelative: (0, $iQ6jp.formatRelative),
    localize: (0, $3Wp6U.localize),
    match: (0, $Ilnmu.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$790049daa7ed1df4$export$2e2bcd8739ae039 = $790049daa7ed1df4$export$c3da0dad1b44eea9;

});
parcelRegister("jd5N2", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $7a7c0965ca66e8cd$export$2c14ff85d6318973; });
const $7a7c0965ca66e8cd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
const $7a7c0965ca66e8cd$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $7a7c0965ca66e8cd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};

});

parcelRegister("gwaml", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $27e562fde5495400$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $27e562fde5495400$var$dateFormats = {
    full: "EEEE, d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "d/M/yy"
};
const $27e562fde5495400$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $27e562fde5495400$var$dateTimeFormats = {
    full: "{{date}} - {{time}}",
    long: "{{date}} - {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $27e562fde5495400$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $27e562fde5495400$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $27e562fde5495400$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $27e562fde5495400$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("iQ6jp", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $1914b931a6d200df$export$8fbbfd65594f46a0; });
const $1914b931a6d200df$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 6:
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: "P"
};
const $1914b931a6d200df$export$8fbbfd65594f46a0 = (token, date)=>{
    const format = $1914b931a6d200df$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};

});

parcelRegister("3Wp6U", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $0dadbf0a5500d425$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $0dadbf0a5500d425$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
const $0dadbf0a5500d425$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
const $0dadbf0a5500d425$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
const $0dadbf0a5500d425$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
const $0dadbf0a5500d425$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        "T",
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
const $0dadbf0a5500d425$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
const $0dadbf0a5500d425$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let suffix;
    if (unit === "year" || unit === "month") suffix = "\u03BF\u03C2";
    else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
const $0dadbf0a5500d425$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0dadbf0a5500d425$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $0dadbf0a5500d425$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $0dadbf0a5500d425$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $0dadbf0a5500d425$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $0dadbf0a5500d425$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $0dadbf0a5500d425$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $0dadbf0a5500d425$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("Ilnmu", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $d65e1ecd24c4313d$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $d65e1ecd24c4313d$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
const $d65e1ecd24c4313d$var$parseOrdinalNumberPattern = /\d+/i;
const $d65e1ecd24c4313d$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
const $d65e1ecd24c4313d$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
const $d65e1ecd24c4313d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
const $d65e1ecd24c4313d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d65e1ecd24c4313d$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
const $d65e1ecd24c4313d$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
const $d65e1ecd24c4313d$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
const $d65e1ecd24c4313d$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
const $d65e1ecd24c4313d$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
const $d65e1ecd24c4313d$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
const $d65e1ecd24c4313d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $d65e1ecd24c4313d$var$matchOrdinalNumberPattern,
        parsePattern: $d65e1ecd24c4313d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $d65e1ecd24c4313d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d65e1ecd24c4313d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $d65e1ecd24c4313d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d65e1ecd24c4313d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $d65e1ecd24c4313d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d65e1ecd24c4313d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $d65e1ecd24c4313d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d65e1ecd24c4313d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $d65e1ecd24c4313d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d65e1ecd24c4313d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("4Fhyy", function(module, exports) {

$parcel$export(module.exports, "enGB", function () { return $6b0e5258c700826b$export$1d08ac19b34481d5; });

var $77Xqn = parcelRequire("77Xqn");

var $5pSiC = parcelRequire("5pSiC");

var $p60Yw = parcelRequire("p60Yw");

var $1fgXo = parcelRequire("1fgXo");

var $jQbnq = parcelRequire("jQbnq");
const $6b0e5258c700826b$export$1d08ac19b34481d5 = {
    code: "en-GB",
    formatDistance: (0, $77Xqn.formatDistance),
    formatLong: (0, $jQbnq.formatLong),
    formatRelative: (0, $5pSiC.formatRelative),
    localize: (0, $p60Yw.localize),
    match: (0, $1fgXo.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$6b0e5258c700826b$export$2e2bcd8739ae039 = $6b0e5258c700826b$export$1d08ac19b34481d5;

});
parcelRegister("77Xqn", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $3581786bb0ba7eef$export$2c14ff85d6318973; });
const $3581786bb0ba7eef$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $3581786bb0ba7eef$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $3581786bb0ba7eef$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("5pSiC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $7a14daf2b3e03890$export$8fbbfd65594f46a0; });
const $7a14daf2b3e03890$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $7a14daf2b3e03890$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$7a14daf2b3e03890$var$formatRelativeLocale[token];

});

parcelRegister("p60Yw", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $b089ef8bc55f0e87$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $b089ef8bc55f0e87$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $b089ef8bc55f0e87$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $b089ef8bc55f0e87$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $b089ef8bc55f0e87$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $b089ef8bc55f0e87$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $b089ef8bc55f0e87$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $b089ef8bc55f0e87$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $b089ef8bc55f0e87$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b089ef8bc55f0e87$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $b089ef8bc55f0e87$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $b089ef8bc55f0e87$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $b089ef8bc55f0e87$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $b089ef8bc55f0e87$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $b089ef8bc55f0e87$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b089ef8bc55f0e87$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("1fgXo", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $098a85b9cc8a3df8$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $098a85b9cc8a3df8$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $098a85b9cc8a3df8$var$parseOrdinalNumberPattern = /\d+/i;
const $098a85b9cc8a3df8$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $098a85b9cc8a3df8$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $098a85b9cc8a3df8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $098a85b9cc8a3df8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $098a85b9cc8a3df8$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $098a85b9cc8a3df8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $098a85b9cc8a3df8$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $098a85b9cc8a3df8$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $098a85b9cc8a3df8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $098a85b9cc8a3df8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $098a85b9cc8a3df8$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $098a85b9cc8a3df8$var$matchOrdinalNumberPattern,
        parsePattern: $098a85b9cc8a3df8$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $098a85b9cc8a3df8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $098a85b9cc8a3df8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $098a85b9cc8a3df8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $098a85b9cc8a3df8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $098a85b9cc8a3df8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $098a85b9cc8a3df8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $098a85b9cc8a3df8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $098a85b9cc8a3df8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $098a85b9cc8a3df8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $098a85b9cc8a3df8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});

parcelRegister("jQbnq", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $fc927595125f87ca$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $fc927595125f87ca$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $fc927595125f87ca$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $fc927595125f87ca$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $fc927595125f87ca$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $fc927595125f87ca$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $fc927595125f87ca$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $fc927595125f87ca$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});


parcelRegister("bs9HA", function(module, exports) {

$parcel$export(module.exports, "es", function () { return $2504a6da4af322f4$export$ca5e4045a55e76d2; });

var $4ixl0 = parcelRequire("4ixl0");

var $5ZlHM = parcelRequire("5ZlHM");

var $4RXeg = parcelRequire("4RXeg");

var $6PnK8 = parcelRequire("6PnK8");

var $9Pz7p = parcelRequire("9Pz7p");
const $2504a6da4af322f4$export$ca5e4045a55e76d2 = {
    code: "es",
    formatDistance: (0, $4ixl0.formatDistance),
    formatLong: (0, $5ZlHM.formatLong),
    formatRelative: (0, $4RXeg.formatRelative),
    localize: (0, $6PnK8.localize),
    match: (0, $9Pz7p.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$2504a6da4af322f4$export$2e2bcd8739ae039 = $2504a6da4af322f4$export$ca5e4045a55e76d2;

});
parcelRegister("4ixl0", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $fd118cc3db378047$export$2c14ff85d6318973; });
const $fd118cc3db378047$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
const $fd118cc3db378047$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $fd118cc3db378047$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};

});

parcelRegister("5ZlHM", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $738fc223ec201718$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $738fc223ec201718$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $738fc223ec201718$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $738fc223ec201718$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $738fc223ec201718$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $738fc223ec201718$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $738fc223ec201718$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $738fc223ec201718$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("4RXeg", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $0c7b90194397dc80$export$8fbbfd65594f46a0; });
const $0c7b90194397dc80$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
const $0c7b90194397dc80$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
const $0c7b90194397dc80$export$8fbbfd65594f46a0 = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $0c7b90194397dc80$var$formatRelativeLocalePlural[token];
    else return $0c7b90194397dc80$var$formatRelativeLocale[token];
};

});

parcelRegister("6PnK8", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $f0dcb73297b9d8ff$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $f0dcb73297b9d8ff$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
const $f0dcb73297b9d8ff$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $f0dcb73297b9d8ff$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
const $f0dcb73297b9d8ff$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
const $f0dcb73297b9d8ff$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
const $f0dcb73297b9d8ff$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
const $f0dcb73297b9d8ff$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $f0dcb73297b9d8ff$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f0dcb73297b9d8ff$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $f0dcb73297b9d8ff$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $f0dcb73297b9d8ff$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $f0dcb73297b9d8ff$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $f0dcb73297b9d8ff$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $f0dcb73297b9d8ff$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f0dcb73297b9d8ff$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("9Pz7p", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $74ea5bfca59ead61$export$4659b591c19bdf3d; });

var $KSzlc = parcelRequire("KSzlc");

var $e6NRw = parcelRequire("e6NRw");
const $74ea5bfca59ead61$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $74ea5bfca59ead61$var$parseOrdinalNumberPattern = /\d+/i;
const $74ea5bfca59ead61$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
const $74ea5bfca59ead61$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
const $74ea5bfca59ead61$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $74ea5bfca59ead61$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $74ea5bfca59ead61$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
const $74ea5bfca59ead61$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
const $74ea5bfca59ead61$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
const $74ea5bfca59ead61$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
const $74ea5bfca59ead61$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
const $74ea5bfca59ead61$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
const $74ea5bfca59ead61$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $74ea5bfca59ead61$var$matchOrdinalNumberPattern,
        parsePattern: $74ea5bfca59ead61$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $74ea5bfca59ead61$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74ea5bfca59ead61$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $74ea5bfca59ead61$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74ea5bfca59ead61$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $74ea5bfca59ead61$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74ea5bfca59ead61$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $74ea5bfca59ead61$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74ea5bfca59ead61$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $74ea5bfca59ead61$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $74ea5bfca59ead61$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("5Ij1B", function(module, exports) {

$parcel$export(module.exports, "fr", function () { return $7b2e2451aa53bee2$export$acb2a88f7d552ebf; });

var $49HtY = parcelRequire("49HtY");

var $4Iazq = parcelRequire("4Iazq");

var $4qgh8 = parcelRequire("4qgh8");

var $5r0pz = parcelRequire("5r0pz");

var $4rRlh = parcelRequire("4rRlh");
const $7b2e2451aa53bee2$export$acb2a88f7d552ebf = {
    code: "fr",
    formatDistance: (0, $49HtY.formatDistance),
    formatLong: (0, $4Iazq.formatLong),
    formatRelative: (0, $4qgh8.formatRelative),
    localize: (0, $5r0pz.localize),
    match: (0, $4rRlh.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$7b2e2451aa53bee2$export$2e2bcd8739ae039 = $7b2e2451aa53bee2$export$acb2a88f7d552ebf;

});
parcelRegister("49HtY", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $ac55d4de5de1284a$export$2c14ff85d6318973; });
const $ac55d4de5de1284a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
const $ac55d4de5de1284a$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const form = $ac55d4de5de1284a$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};

});

parcelRegister("4Iazq", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a2855be9ef82c7fd$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $a2855be9ef82c7fd$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $a2855be9ef82c7fd$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a2855be9ef82c7fd$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a2855be9ef82c7fd$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $a2855be9ef82c7fd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $a2855be9ef82c7fd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $a2855be9ef82c7fd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("4qgh8", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $bd76a94db4b7c618$export$8fbbfd65594f46a0; });
const $bd76a94db4b7c618$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
const $bd76a94db4b7c618$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$bd76a94db4b7c618$var$formatRelativeLocale[token];

});

parcelRegister("5r0pz", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $4bab8465d439947e$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $4bab8465d439947e$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
const $4bab8465d439947e$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
const $4bab8465d439947e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
const $4bab8465d439947e$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
const $4bab8465d439947e$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
const $4bab8465d439947e$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return "0";
    const feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    let suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
const $4bab8465d439947e$var$LONG_MONTHS_TOKENS = [
    "MMM",
    "MMMM"
];
const $4bab8465d439947e$export$b3bd0bc58e36cd63 = {
    preprocessor: (date, parts)=>{
        // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
        // Use case "do MMMM" => 1er août, 29 août
        // see https://github.com/date-fns/date-fns/issues/1391
        if (date.getDate() === 1) return parts;
        const hasLongMonthToken = parts.some((part)=>part.isToken && $4bab8465d439947e$var$LONG_MONTHS_TOKENS.includes(part.value));
        if (!hasLongMonthToken) return parts;
        return parts.map((part)=>part.isToken && part.value === "do" ? {
                isToken: true,
                value: "d"
            } : part);
    },
    ordinalNumber: $4bab8465d439947e$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $4bab8465d439947e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $4bab8465d439947e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $4bab8465d439947e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $4bab8465d439947e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $4bab8465d439947e$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("4rRlh", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $17d8cc0d9315a5f0$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $17d8cc0d9315a5f0$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const $17d8cc0d9315a5f0$var$parseOrdinalNumberPattern = /\d+/i;
const $17d8cc0d9315a5f0$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
const $17d8cc0d9315a5f0$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $17d8cc0d9315a5f0$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
const $17d8cc0d9315a5f0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $17d8cc0d9315a5f0$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
const $17d8cc0d9315a5f0$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $17d8cc0d9315a5f0$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
const $17d8cc0d9315a5f0$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
const $17d8cc0d9315a5f0$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
const $17d8cc0d9315a5f0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
const $17d8cc0d9315a5f0$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $17d8cc0d9315a5f0$var$matchOrdinalNumberPattern,
        parsePattern: $17d8cc0d9315a5f0$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $17d8cc0d9315a5f0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $17d8cc0d9315a5f0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $17d8cc0d9315a5f0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $17d8cc0d9315a5f0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $17d8cc0d9315a5f0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $17d8cc0d9315a5f0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $17d8cc0d9315a5f0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $17d8cc0d9315a5f0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $17d8cc0d9315a5f0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $17d8cc0d9315a5f0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("4dmbt", function(module, exports) {

$parcel$export(module.exports, "it", function () { return $1744b8259f19a87b$export$3486a10f30cf1ee4; });

var $ydN1v = parcelRequire("ydN1v");

var $32ZvX = parcelRequire("32ZvX");

var $cygHJ = parcelRequire("cygHJ");

var $ggklE = parcelRequire("ggklE");

var $fsDya = parcelRequire("fsDya");
const $1744b8259f19a87b$export$3486a10f30cf1ee4 = {
    code: "it",
    formatDistance: (0, $ydN1v.formatDistance),
    formatLong: (0, $32ZvX.formatLong),
    formatRelative: (0, $cygHJ.formatRelative),
    localize: (0, $ggklE.localize),
    match: (0, $fsDya.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$1744b8259f19a87b$export$2e2bcd8739ae039 = $1744b8259f19a87b$export$3486a10f30cf1ee4;

});
parcelRegister("ydN1v", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $d601dc283a47d3f0$export$2c14ff85d6318973; });
const $d601dc283a47d3f0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
    },
    xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
    },
    xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "un'ora",
        other: "{{count}} ore"
    },
    xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
    },
    aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
    },
    xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
    },
    aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
    },
    xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
    },
    aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
    },
    xYears: {
        one: "un anno",
        other: "{{count}} anni"
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
    }
};
const $d601dc283a47d3f0$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $d601dc283a47d3f0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "tra " + result;
        else return result + " fa";
    }
    return result;
};

});

parcelRegister("32ZvX", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $c75f4e4c212d5ae7$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $c75f4e4c212d5ae7$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $c75f4e4c212d5ae7$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $c75f4e4c212d5ae7$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $c75f4e4c212d5ae7$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $c75f4e4c212d5ae7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $c75f4e4c212d5ae7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $c75f4e4c212d5ae7$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("cygHJ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $c52f4050808e36fa$export$8fbbfd65594f46a0; });

var $1qhAB = parcelRequire("1qhAB");
const $c52f4050808e36fa$var$weekdays = [
    "domenica",
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    "sabato"
];
function $c52f4050808e36fa$var$lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $c52f4050808e36fa$var$weekdays[day] + " scorso alle' p";
    }
}
function $c52f4050808e36fa$var$thisWeek(day) {
    return "'" + $c52f4050808e36fa$var$weekdays[day] + " alle' p";
}
function $c52f4050808e36fa$var$nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $c52f4050808e36fa$var$weekdays[day] + " prossimo alle' p";
    }
}
const $c52f4050808e36fa$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $1qhAB.isSameWeek)(date, baseDate, options)) return $c52f4050808e36fa$var$thisWeek(day);
        else return $c52f4050808e36fa$var$lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $1qhAB.isSameWeek)(date, baseDate, options)) return $c52f4050808e36fa$var$thisWeek(day);
        else return $c52f4050808e36fa$var$nextWeek(day);
    },
    other: "P"
};
const $c52f4050808e36fa$export$8fbbfd65594f46a0 = (token, date, baseDate, options)=>{
    const format = $c52f4050808e36fa$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};

});
parcelRegister("1qhAB", function(module, exports) {

$parcel$export(module.exports, "isSameWeek", function () { return $a52ffdaa2b7313d0$export$6ea683876c36b8d2; });

var $jv0RF = parcelRequire("jv0RF");
function $a52ffdaa2b7313d0$export$6ea683876c36b8d2(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $jv0RF.startOfWeek)(dateLeft, options);
    const dateRightStartOfWeek = (0, $jv0RF.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}
var // Fallback for modularized imports:
$a52ffdaa2b7313d0$export$2e2bcd8739ae039 = $a52ffdaa2b7313d0$export$6ea683876c36b8d2;

});
parcelRegister("jv0RF", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $ba5c7e2110307656$export$42c81a444fbfb5d4; });

var $ulRSg = parcelRequire("ulRSg");

var $hNzio = parcelRequire("hNzio");
function $ba5c7e2110307656$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $hNzio.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $ulRSg.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$ba5c7e2110307656$export$2e2bcd8739ae039 = $ba5c7e2110307656$export$42c81a444fbfb5d4;

});
parcelRegister("ulRSg", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $2014e8cb04986786$export$e67a095c620b86fe; });
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $2014e8cb04986786$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$2014e8cb04986786$export$2e2bcd8739ae039 = $2014e8cb04986786$export$e67a095c620b86fe;

});

parcelRegister("hNzio", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $3dcc67520d787197$export$430a3269e24b912e; });
let $3dcc67520d787197$var$defaultOptions = {};
function $3dcc67520d787197$export$430a3269e24b912e() {
    return $3dcc67520d787197$var$defaultOptions;
}
function $3dcc67520d787197$export$95365be1b0704abc(newOptions) {
    $3dcc67520d787197$var$defaultOptions = newOptions;
}

});




parcelRegister("ggklE", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $ffedc189eccfe75e$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $ffedc189eccfe75e$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "avanti Cristo",
        "dopo Cristo"
    ]
};
const $ffedc189eccfe75e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $ffedc189eccfe75e$var$monthValues = {
    narrow: [
        "G",
        "F",
        "M",
        "A",
        "M",
        "G",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
    ],
    wide: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
    ]
};
const $ffedc189eccfe75e$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "G",
        "V",
        "S"
    ],
    short: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    wide: [
        "domenica",
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        "sabato"
    ]
};
const $ffedc189eccfe75e$var$dayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    }
};
const $ffedc189eccfe75e$var$formattingDayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    }
};
const $ffedc189eccfe75e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return String(number);
};
const $ffedc189eccfe75e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ffedc189eccfe75e$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $ffedc189eccfe75e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $ffedc189eccfe75e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $ffedc189eccfe75e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $ffedc189eccfe75e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $ffedc189eccfe75e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ffedc189eccfe75e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("fsDya", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $e9176ff1f6b85df5$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $e9176ff1f6b85df5$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $e9176ff1f6b85df5$var$parseOrdinalNumberPattern = /\d+/i;
const $e9176ff1f6b85df5$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
const $e9176ff1f6b85df5$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
const $e9176ff1f6b85df5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $e9176ff1f6b85df5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e9176ff1f6b85df5$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
const $e9176ff1f6b85df5$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $e9176ff1f6b85df5$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
const $e9176ff1f6b85df5$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
const $e9176ff1f6b85df5$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
const $e9176ff1f6b85df5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
const $e9176ff1f6b85df5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $e9176ff1f6b85df5$var$matchOrdinalNumberPattern,
        parsePattern: $e9176ff1f6b85df5$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $e9176ff1f6b85df5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9176ff1f6b85df5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $e9176ff1f6b85df5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9176ff1f6b85df5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $e9176ff1f6b85df5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9176ff1f6b85df5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $e9176ff1f6b85df5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9176ff1f6b85df5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $e9176ff1f6b85df5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e9176ff1f6b85df5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("kxQo4", function(module, exports) {

$parcel$export(module.exports, "nl", function () { return $9507270ca4f38136$export$9c64ee4d84d79ce1; });

var $kJ9cu = parcelRequire("kJ9cu");

var $2YoFr = parcelRequire("2YoFr");

var $9fZxR = parcelRequire("9fZxR");

var $83QhK = parcelRequire("83QhK");

var $uBolx = parcelRequire("uBolx");
const $9507270ca4f38136$export$9c64ee4d84d79ce1 = {
    code: "nl",
    formatDistance: (0, $kJ9cu.formatDistance),
    formatLong: (0, $2YoFr.formatLong),
    formatRelative: (0, $9fZxR.formatRelative),
    localize: (0, $83QhK.localize),
    match: (0, $uBolx.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$9507270ca4f38136$export$2e2bcd8739ae039 = $9507270ca4f38136$export$9c64ee4d84d79ce1;

});
parcelRegister("kJ9cu", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4e9215d163d38345$export$2c14ff85d6318973; });
const $4e9215d163d38345$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
const $4e9215d163d38345$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $4e9215d163d38345$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};

});

parcelRegister("2YoFr", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $427566c1af513992$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $427566c1af513992$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
const $427566c1af513992$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $427566c1af513992$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $427566c1af513992$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $427566c1af513992$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $427566c1af513992$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $427566c1af513992$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9fZxR", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $64731c478b9c14a7$export$8fbbfd65594f46a0; });
const $64731c478b9c14a7$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $64731c478b9c14a7$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$64731c478b9c14a7$var$formatRelativeLocale[token];

});

parcelRegister("83QhK", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $4fb9384dee1546d9$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $4fb9384dee1546d9$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $4fb9384dee1546d9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
const $4fb9384dee1546d9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $4fb9384dee1546d9$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
const $4fb9384dee1546d9$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
const $4fb9384dee1546d9$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $4fb9384dee1546d9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $4fb9384dee1546d9$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $4fb9384dee1546d9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $4fb9384dee1546d9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $4fb9384dee1546d9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $4fb9384dee1546d9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $4fb9384dee1546d9$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("uBolx", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $448ed688049f0376$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $448ed688049f0376$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $448ed688049f0376$var$parseOrdinalNumberPattern = /\d+/i;
const $448ed688049f0376$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
const $448ed688049f0376$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $448ed688049f0376$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
const $448ed688049f0376$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $448ed688049f0376$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
const $448ed688049f0376$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
const $448ed688049f0376$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
const $448ed688049f0376$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
const $448ed688049f0376$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
const $448ed688049f0376$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
const $448ed688049f0376$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $448ed688049f0376$var$matchOrdinalNumberPattern,
        parsePattern: $448ed688049f0376$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $448ed688049f0376$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $448ed688049f0376$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $448ed688049f0376$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $448ed688049f0376$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $448ed688049f0376$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $448ed688049f0376$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $448ed688049f0376$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $448ed688049f0376$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $448ed688049f0376$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $448ed688049f0376$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("l1Do6", function(module, exports) {

$parcel$export(module.exports, "pl", function () { return $d1e500f7966ca51d$export$6ea5311eda92944f; });

var $2xhbA = parcelRequire("2xhbA");

var $2MXH0 = parcelRequire("2MXH0");

var $9p62V = parcelRequire("9p62V");

var $4PfxX = parcelRequire("4PfxX");

var $lnRMy = parcelRequire("lnRMy");
const $d1e500f7966ca51d$export$6ea5311eda92944f = {
    code: "pl",
    formatDistance: (0, $2xhbA.formatDistance),
    formatLong: (0, $2MXH0.formatLong),
    formatRelative: (0, $9p62V.formatRelative),
    localize: (0, $4PfxX.localize),
    match: (0, $lnRMy.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$d1e500f7966ca51d$export$2e2bcd8739ae039 = $d1e500f7966ca51d$export$6ea5311eda92944f;

});
parcelRegister("2xhbA", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $4a36f966076f9a1b$export$2c14ff85d6318973; });
const $4a36f966076f9a1b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: "{{count}} sekundy",
        other: "{{count}} sekund"
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: "{{count}} minuty",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: "godzina",
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: "{{count}} godziny",
        other: "{{count}} godzin"
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: "{{count}} dni",
        other: "{{count}} dni"
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: "{{count}} tygodnie",
        other: "{{count}} tygodni"
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: "rok",
        twoFour: "{{count}} lata",
        other: "{{count}} lat"
    },
    overXYears: {
        one: "ponad rok",
        twoFour: "ponad {{count}} lata",
        other: "ponad {{count}} lat"
    },
    almostXYears: {
        one: "prawie rok",
        twoFour: "prawie {{count}} lata",
        other: "prawie {{count}} lat"
    }
};
function $4a36f966076f9a1b$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    const rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    const rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $4a36f966076f9a1b$var$declension(scheme, count, time) {
    const group = $4a36f966076f9a1b$var$declensionGroup(scheme, count);
    const finalText = typeof group === "string" ? group : group[time];
    return finalText.replace("{{count}}", String(count));
}
const $4a36f966076f9a1b$export$2c14ff85d6318973 = (token, count, options)=>{
    const scheme = $4a36f966076f9a1b$var$formatDistanceLocale[token];
    if (!options?.addSuffix) return $4a36f966076f9a1b$var$declension(scheme, count, "regular");
    if (options.comparison && options.comparison > 0) return "za " + $4a36f966076f9a1b$var$declension(scheme, count, "future");
    else return $4a36f966076f9a1b$var$declension(scheme, count, "past") + " temu";
};

});

parcelRegister("2MXH0", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $a838cc11ffbdbb8b$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $a838cc11ffbdbb8b$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $a838cc11ffbdbb8b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a838cc11ffbdbb8b$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a838cc11ffbdbb8b$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $a838cc11ffbdbb8b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $a838cc11ffbdbb8b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $a838cc11ffbdbb8b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("9p62V", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $9bad35f4c7e0c111$export$8fbbfd65594f46a0; });

var $1qhAB = parcelRequire("1qhAB");
const $9bad35f4c7e0c111$var$adjectivesLastWeek = {
    masculine: "ostatni",
    feminine: "ostatnia"
};
const $9bad35f4c7e0c111$var$adjectivesThisWeek = {
    masculine: "ten",
    feminine: "ta"
};
const $9bad35f4c7e0c111$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
const $9bad35f4c7e0c111$var$dayGrammaticalGender = {
    0: "feminine",
    1: "masculine",
    2: "masculine",
    3: "feminine",
    4: "masculine",
    5: "masculine",
    6: "feminine"
};
function $9bad35f4c7e0c111$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    let adjectives;
    if ((0, $1qhAB.isSameWeek)(date, baseDate, options)) adjectives = $9bad35f4c7e0c111$var$adjectivesThisWeek;
    else if (token === "lastWeek") adjectives = $9bad35f4c7e0c111$var$adjectivesLastWeek;
    else if (token === "nextWeek") adjectives = $9bad35f4c7e0c111$var$adjectivesNextWeek;
    else throw new Error(`Cannot determine adjectives for token ${token}`);
    const day = date.getDay();
    const grammaticalGender = $9bad35f4c7e0c111$var$dayGrammaticalGender[day];
    const adjective = adjectives[grammaticalGender];
    return `'${adjective}' eeee 'o' p`;
}
const $9bad35f4c7e0c111$var$formatRelativeLocale = {
    lastWeek: $9bad35f4c7e0c111$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $9bad35f4c7e0c111$var$dayAndTimeWithAdjective,
    other: "P"
};
const $9bad35f4c7e0c111$export$8fbbfd65594f46a0 = (token, date, baseDate, options)=>{
    const format = $9bad35f4c7e0c111$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(token, date, baseDate, options);
    return format;
};

});

parcelRegister("4PfxX", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $a36d9660032ad0e0$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $a36d9660032ad0e0$var$eraValues = {
    narrow: [
        "p.n.e.",
        "n.e."
    ],
    abbreviated: [
        "p.n.e.",
        "n.e."
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        "naszej ery"
    ]
};
const $a36d9660032ad0e0$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I kw.",
        "II kw.",
        "III kw.",
        "IV kw."
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
const $a36d9660032ad0e0$var$monthValues = {
    narrow: [
        "S",
        "L",
        "M",
        "K",
        "M",
        "C",
        "L",
        "S",
        "W",
        "P",
        "L",
        "G"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycze\u0144",
        "luty",
        "marzec",
        "kwiecie\u0144",
        "maj",
        "czerwiec",
        "lipiec",
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        "listopad",
        "grudzie\u0144"
    ]
};
const $a36d9660032ad0e0$var$monthFormattingValues = {
    narrow: [
        "s",
        "l",
        "m",
        "k",
        "m",
        "c",
        "l",
        "s",
        "w",
        "p",
        "l",
        "g"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        "listopada",
        "grudnia"
    ]
};
const $a36d9660032ad0e0$var$dayValues = {
    narrow: [
        "N",
        "P",
        "W",
        "\u015A",
        "C",
        "P",
        "S"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $a36d9660032ad0e0$var$dayFormattingValues = {
    narrow: [
        "n",
        "p",
        "w",
        "\u015B",
        "c",
        "p",
        "s"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $a36d9660032ad0e0$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: "rano",
        afternoon: "popo\u0142.",
        evening: "wiecz.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    }
};
const $a36d9660032ad0e0$var$dayPeriodFormattingValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: "rano",
        afternoon: "po po\u0142.",
        evening: "wiecz.",
        night: "w nocy"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    }
};
const $a36d9660032ad0e0$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $a36d9660032ad0e0$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a36d9660032ad0e0$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $a36d9660032ad0e0$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $a36d9660032ad0e0$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $a36d9660032ad0e0$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $a36d9660032ad0e0$var$monthFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $a36d9660032ad0e0$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $a36d9660032ad0e0$var$dayFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $a36d9660032ad0e0$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a36d9660032ad0e0$var$dayPeriodFormattingValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("lnRMy", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $733a75fd1fb79f88$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $733a75fd1fb79f88$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $733a75fd1fb79f88$var$parseOrdinalNumberPattern = /\d+/i;
const $733a75fd1fb79f88$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
const $733a75fd1fb79f88$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
const $733a75fd1fb79f88$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
const $733a75fd1fb79f88$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
const $733a75fd1fb79f88$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
const $733a75fd1fb79f88$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
const $733a75fd1fb79f88$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
const $733a75fd1fb79f88$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
const $733a75fd1fb79f88$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
const $733a75fd1fb79f88$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
const $733a75fd1fb79f88$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $733a75fd1fb79f88$var$matchOrdinalNumberPattern,
        parsePattern: $733a75fd1fb79f88$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $733a75fd1fb79f88$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $733a75fd1fb79f88$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $733a75fd1fb79f88$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $733a75fd1fb79f88$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $733a75fd1fb79f88$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $733a75fd1fb79f88$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $733a75fd1fb79f88$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $733a75fd1fb79f88$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $733a75fd1fb79f88$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $733a75fd1fb79f88$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("unZAh", function(module, exports) {

$parcel$export(module.exports, "pt", function () { return $5334d12cdaa3ffc2$export$84175d5f1cb4e39d; });

var $ancsn = parcelRequire("ancsn");

var $cId7d = parcelRequire("cId7d");

var $ibpU2 = parcelRequire("ibpU2");

var $gJy4t = parcelRequire("gJy4t");

var $9zztL = parcelRequire("9zztL");
const $5334d12cdaa3ffc2$export$84175d5f1cb4e39d = {
    code: "pt",
    formatDistance: (0, $ancsn.formatDistance),
    formatLong: (0, $cId7d.formatLong),
    formatRelative: (0, $ibpU2.formatRelative),
    localize: (0, $gJy4t.localize),
    match: (0, $9zztL.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$5334d12cdaa3ffc2$export$2e2bcd8739ae039 = $5334d12cdaa3ffc2$export$84175d5f1cb4e39d;

});
parcelRegister("ancsn", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $1007eabe07973369$export$2c14ff85d6318973; });
const $1007eabe07973369$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: "aproximadamente {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $1007eabe07973369$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $1007eabe07973369$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "daqui a " + result;
        else return "h\xe1 " + result;
    }
    return result;
};

});

parcelRegister("cId7d", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $d1f2de7ef3e19396$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $d1f2de7ef3e19396$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
};
const $d1f2de7ef3e19396$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $d1f2de7ef3e19396$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $d1f2de7ef3e19396$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $d1f2de7ef3e19396$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $d1f2de7ef3e19396$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $d1f2de7ef3e19396$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("ibpU2", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $de2a3ed004327218$export$8fbbfd65594f46a0; });
const $de2a3ed004327218$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $de2a3ed004327218$export$8fbbfd65594f46a0 = (token, date, _baseDate, _options)=>{
    const format = $de2a3ed004327218$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};

});

parcelRegister("gJy4t", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $589ee4f5d9cd8ce7$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $589ee4f5d9cd8ce7$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "antes de Cristo",
        "depois de Cristo"
    ]
};
const $589ee4f5d9cd8ce7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $589ee4f5d9cd8ce7$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $589ee4f5d9cd8ce7$var$dayValues = {
    narrow: [
        "d",
        "s",
        "t",
        "q",
        "q",
        "s",
        "s"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    abbreviated: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $589ee4f5d9cd8ce7$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    }
};
const $589ee4f5d9cd8ce7$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    }
};
const $589ee4f5d9cd8ce7$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $589ee4f5d9cd8ce7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $589ee4f5d9cd8ce7$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $589ee4f5d9cd8ce7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $589ee4f5d9cd8ce7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $589ee4f5d9cd8ce7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $589ee4f5d9cd8ce7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $589ee4f5d9cd8ce7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $589ee4f5d9cd8ce7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("9zztL", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $ce97303a44114d86$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $ce97303a44114d86$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
const $ce97303a44114d86$var$parseOrdinalNumberPattern = /\d+/i;
const $ce97303a44114d86$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
const $ce97303a44114d86$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
const $ce97303a44114d86$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
const $ce97303a44114d86$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ce97303a44114d86$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $ce97303a44114d86$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $ce97303a44114d86$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
const $ce97303a44114d86$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
const $ce97303a44114d86$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
const $ce97303a44114d86$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
const $ce97303a44114d86$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $ce97303a44114d86$var$matchOrdinalNumberPattern,
        parsePattern: $ce97303a44114d86$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ce97303a44114d86$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ce97303a44114d86$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ce97303a44114d86$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ce97303a44114d86$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ce97303a44114d86$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ce97303a44114d86$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ce97303a44114d86$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ce97303a44114d86$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $ce97303a44114d86$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ce97303a44114d86$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});


parcelRegister("24OGi", function(module, exports) {

$parcel$export(module.exports, "ro", function () { return $6629781eb8d30d9b$export$ea30ec7f37fb148d; });

var $9SuVr = parcelRequire("9SuVr");

var $MnoLb = parcelRequire("MnoLb");

var $3WiXC = parcelRequire("3WiXC");

var $5heAD = parcelRequire("5heAD");

var $ep5hs = parcelRequire("ep5hs");
const $6629781eb8d30d9b$export$ea30ec7f37fb148d = {
    code: "ro",
    formatDistance: (0, $9SuVr.formatDistance),
    formatLong: (0, $MnoLb.formatLong),
    formatRelative: (0, $3WiXC.formatRelative),
    localize: (0, $5heAD.localize),
    match: (0, $ep5hs.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$6629781eb8d30d9b$export$2e2bcd8739ae039 = $6629781eb8d30d9b$export$ea30ec7f37fb148d;

});
parcelRegister("9SuVr", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $0d27044437ed95f3$export$2c14ff85d6318973; });
const $0d27044437ed95f3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: "{{count}} secunde"
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "1 or\u0103",
        other: "{{count}} ore"
    },
    xDays: {
        one: "1 zi",
        other: "{{count}} zile"
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: "circa {{count}} luni"
    },
    xMonths: {
        one: "1 lun\u0103",
        other: "{{count}} luni"
    },
    aboutXYears: {
        one: "circa 1 an",
        other: "circa {{count}} ani"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ani"
    },
    overXYears: {
        one: "peste 1 an",
        other: "peste {{count}} ani"
    },
    almostXYears: {
        one: "aproape 1 an",
        other: "aproape {{count}} ani"
    }
};
const $0d27044437ed95f3$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $0d27044437ed95f3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};

});

parcelRegister("MnoLb", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $6c9f60075a42d81c$export$cbf60ecb96cbb82f; });

var $qt1Oy = parcelRequire("qt1Oy");
const $6c9f60075a42d81c$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd.MM.yyyy"
};
const $6c9f60075a42d81c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6c9f60075a42d81c$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6c9f60075a42d81c$export$cbf60ecb96cbb82f = {
    date: (0, $qt1Oy.buildFormatLongFn)({
        formats: $6c9f60075a42d81c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $qt1Oy.buildFormatLongFn)({
        formats: $6c9f60075a42d81c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $qt1Oy.buildFormatLongFn)({
        formats: $6c9f60075a42d81c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("3WiXC", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $a6ad9749e2967b70$export$8fbbfd65594f46a0; });
const $a6ad9749e2967b70$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: "P"
};
const $a6ad9749e2967b70$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$a6ad9749e2967b70$var$formatRelativeLocale[token];

});

parcelRegister("5heAD", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $717e3cbebeedc226$export$b3bd0bc58e36cd63; });

var $s97TY = parcelRequire("s97TY");
const $717e3cbebeedc226$var$eraValues = {
    narrow: [
        "\xce",
        "D"
    ],
    abbreviated: [
        "\xce.d.C.",
        "D.C."
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
const $717e3cbebeedc226$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "primul trimestru",
        "al doilea trimestru",
        "al treilea trimestru",
        "al patrulea trimestru"
    ]
};
const $717e3cbebeedc226$var$monthValues = {
    narrow: [
        "I",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "noi",
        "dec"
    ],
    wide: [
        "ianuarie",
        "februarie",
        "martie",
        "aprilie",
        "mai",
        "iunie",
        "iulie",
        "august",
        "septembrie",
        "octombrie",
        "noiembrie",
        "decembrie"
    ]
};
const $717e3cbebeedc226$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "du",
        "lu",
        "ma",
        "mi",
        "jo",
        "vi",
        "s\xe2"
    ],
    abbreviated: [
        "dum",
        "lun",
        "mar",
        "mie",
        "joi",
        "vin",
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        "luni",
        "mar\u021Bi",
        "miercuri",
        "joi",
        "vineri",
        "s\xe2mb\u0103t\u0103"
    ]
};
const $717e3cbebeedc226$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "ami",
        morning: "dim",
        afternoon: "da",
        evening: "s",
        night: "n"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
const $717e3cbebeedc226$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
const $717e3cbebeedc226$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $717e3cbebeedc226$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $717e3cbebeedc226$var$ordinalNumber,
    era: (0, $s97TY.buildLocalizeFn)({
        values: $717e3cbebeedc226$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $s97TY.buildLocalizeFn)({
        values: $717e3cbebeedc226$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $s97TY.buildLocalizeFn)({
        values: $717e3cbebeedc226$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $s97TY.buildLocalizeFn)({
        values: $717e3cbebeedc226$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $s97TY.buildLocalizeFn)({
        values: $717e3cbebeedc226$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $717e3cbebeedc226$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});

parcelRegister("ep5hs", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $cdb632687b15398c$export$4659b591c19bdf3d; });

var $e6NRw = parcelRequire("e6NRw");

var $KSzlc = parcelRequire("KSzlc");
const $cdb632687b15398c$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $cdb632687b15398c$var$parseOrdinalNumberPattern = /\d+/i;
const $cdb632687b15398c$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
const $cdb632687b15398c$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
const $cdb632687b15398c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
const $cdb632687b15398c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $cdb632687b15398c$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
const $cdb632687b15398c$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $cdb632687b15398c$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
const $cdb632687b15398c$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
const $cdb632687b15398c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
const $cdb632687b15398c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
const $cdb632687b15398c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $KSzlc.buildMatchPatternFn)({
        matchPattern: $cdb632687b15398c$var$matchOrdinalNumberPattern,
        parsePattern: $cdb632687b15398c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $cdb632687b15398c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cdb632687b15398c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $cdb632687b15398c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cdb632687b15398c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $cdb632687b15398c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cdb632687b15398c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $cdb632687b15398c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cdb632687b15398c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e6NRw.buildMatchFn)({
        matchPatterns: $cdb632687b15398c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cdb632687b15398c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});



parcelRegister("7v7ww", function(module, exports) {

$parcel$export(module.exports, "getLocaleToUse", function () { return $f54042aa4ff52865$export$2b5e882832367014; });

var $2aNQ5 = parcelRequire("2aNQ5");
const $f54042aa4ff52865$export$2b5e882832367014 = (newLocale)=>{
    const allowedLanguages = (0, $2aNQ5.languages);
    const isNewLocaleAllowed = allowedLanguages.includes(newLocale);
    if (isNewLocaleAllowed) return newLocale;
    return "en";
};

});

parcelRegister("lgUhZ", function(module, exports) {

$parcel$export(module.exports, "saveLocally", function () { return $e6a71746cdf07352$export$5158381d8f4c267b; });

var $2Wseo = parcelRequire("2Wseo");

var $gF9qy = parcelRequire("gF9qy");
const $e6a71746cdf07352$var$translations = {
    en: "Changes saved locally",
    es: "Cambios guardados localmente",
    fr: "Modifications enregistr\xe9es localement",
    nl: "Wijzigingen lokaal opgeslagen",
    pt: "Altera\xe7\xf5es guardadas localmente",
    it: "Modifiche salvate localmente",
    de: "\xc4nderungen lokal gespeichert",
    pl: "Zmiany zapisane lokalnie",
    ro: "Modific\u0103rile au fost salvate local",
    gr: "\u039F\u03B9 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C4\u03B7\u03BA\u03B1\u03BD \u03C4\u03BF\u03C0\u03B9\u03BA\u03AC"
};
const $e6a71746cdf07352$export$5158381d8f4c267b = async (key, value, lang, notify = false)=>{
    const stringifiedData = JSON.stringify(value);
    const parsedData = JSON.parse(stringifiedData);
    await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem(key, parsedData);
    const message = $e6a71746cdf07352$var$translations[lang];
    if (!message) throw new Error("No translation");
    if (notify) (0, $gF9qy.Notify).success(message, {
        showOnlyTheLastOne: true
    });
};

});

parcelRegister("ctTWP", function(module, exports) {

$parcel$export(module.exports, "splitArrayBySeparator", function () { return $6f2290ecd89412ea$export$faa55ef14038984; });
const $6f2290ecd89412ea$export$faa55ef14038984 = (dataArray)=>{
    const resultArray = [];
    dataArray.forEach((element)=>{
        const isSeparator = element.type === "separator";
        if (isSeparator) resultArray.push([]);
        else resultArray[resultArray.length - 1].push(element);
    });
    return resultArray;
};

});


parcelRegister("2PoEo", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $20f3774800fa1c01$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");
var $5lPju = parcelRequire("5lPju");

var $bA7RK = parcelRequire("bA7RK");

var $4SNgb = parcelRequire("4SNgb");

var $1Frv0 = parcelRequire("1Frv0");
const $20f3774800fa1c01$var$_hoisted_1 = {
    key: 1
};
const $20f3774800fa1c01$var$_hoisted_2 = {
    key: 2
};
const $20f3774800fa1c01$var$_hoisted_3 = {
    key: 3
};
const $20f3774800fa1c01$var$_hoisted_4 = {
    key: 0,
    class: "hidden"
};
const $20f3774800fa1c01$var$_hoisted_5 = {
    key: 1
};
const $20f3774800fa1c01$var$_hoisted_6 = {
    key: 2,
    class: "header"
};
const $20f3774800fa1c01$var$_hoisted_7 = {
    key: 3
};
const $20f3774800fa1c01$var$_hoisted_8 = [
    "onClick"
];
const $20f3774800fa1c01$var$_hoisted_9 = {
    key: 5
};
const $20f3774800fa1c01$var$_hoisted_10 = [
    "value",
    "id"
];
const $20f3774800fa1c01$var$_hoisted_11 = [
    "onUpdate:modelValue",
    "required",
    "id",
    "onChange"
];
const $20f3774800fa1c01$var$_hoisted_12 = [
    "value"
];
const $20f3774800fa1c01$var$_hoisted_13 = {
    key: 3,
    class: "radio-btns"
};
const $20f3774800fa1c01$var$_hoisted_14 = [
    "value",
    "name",
    "onChange",
    "checked",
    "required"
];
const $20f3774800fa1c01$var$_hoisted_15 = [
    "onUpdate:modelValue",
    "onChange",
    "required",
    "id"
];
const $20f3774800fa1c01$var$_hoisted_16 = [
    "onUpdate:modelValue",
    "onChange",
    "required",
    "id"
];
const $20f3774800fa1c01$var$_hoisted_17 = {
    key: 6
};
const $20f3774800fa1c01$var$_hoisted_18 = {
    key: 7
};
const $20f3774800fa1c01$var$_hoisted_19 = {
    key: 0,
    style: {
        "font-style": "italic"
    }
};
const $20f3774800fa1c01$var$_hoisted_20 = [
    "id",
    "onChange",
    "required"
];
const $20f3774800fa1c01$var$_hoisted_21 = {
    key: 1,
    class: "file-input"
};
const $20f3774800fa1c01$var$_hoisted_22 = {
    style: {
        "margin": "0"
    },
    class: "file-name"
};
const $20f3774800fa1c01$var$_hoisted_23 = [
    "onClick"
];
const $20f3774800fa1c01$var$_hoisted_24 = [
    "for"
];
const $20f3774800fa1c01$var$_hoisted_25 = [
    "type",
    "onUpdate:modelValue",
    "required",
    "id",
    "onChange",
    "value"
];
function $20f3774800fa1c01$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_loading_spinner = (0, $8zRru.resolveComponent)("loading-spinner");
    const _component_PRSelector = (0, $8zRru.resolveComponent)("PRSelector");
    const _component_success_message = (0, $8zRru.resolveComponent)("success-message");
    const _component_Informational = (0, $8zRru.resolveComponent)("Informational");
    const _component_Button = (0, $8zRru.resolveComponent)("Button");
    return _ctx.loading ? ((0, $8zRru.openBlock)(), (0, $8zRru.createBlock)(_component_loading_spinner, {
        key: 0
    })) : _ctx.submitted ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $20f3774800fa1c01$var$_hoisted_1, [
        _ctx.accounts.length > 1 ? ((0, $8zRru.openBlock)(), (0, $8zRru.createBlock)(_component_PRSelector, {
            key: 0,
            accounts: _ctx.accounts
        }, null, 8, [
            "accounts"
        ])) : (0, $8zRru.createCommentVNode)("", true),
        (0, $8zRru.createVNode)(_component_success_message, {
            message: _ctx.$t("formPage.submittedMessage")
        }, null, 8, [
            "message"
        ])
    ])) : _ctx.alreadySubmitted ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $20f3774800fa1c01$var$_hoisted_2, [
        _ctx.accounts.length > 1 ? ((0, $8zRru.openBlock)(), (0, $8zRru.createBlock)(_component_PRSelector, {
            key: 0,
            accounts: _ctx.accounts
        }, null, 8, [
            "accounts"
        ])) : (0, $8zRru.createCommentVNode)("", true),
        (0, $8zRru.createVNode)(_component_success_message, {
            message: _ctx.$t("formPage.alreadySubmittedMessage")
        }, null, 8, [
            "message"
        ])
    ])) : ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $20f3774800fa1c01$var$_hoisted_3, [
        (0, $8zRru.createVNode)(_component_Informational),
        (0, $8zRru.createElementVNode)("form", {
            onSubmit: _cache[1] || (_cache[1] = (0, $5lPju.withModifiers)((...args)=>_ctx.handleSubmit && _ctx.handleSubmit(...args), [
                "prevent"
            ])),
            onKeydown: _cache[2] || (_cache[2] = (0, $5lPju.withKeys)(($event)=>$event.preventDefault(), [
                "enter"
            ])),
            ref: "mainForm"
        }, [
            _ctx.accounts.length > 1 ? ((0, $8zRru.openBlock)(), (0, $8zRru.createBlock)(_component_PRSelector, {
                key: 0,
                accounts: _ctx.accounts
            }, null, 8, [
                "accounts"
            ])) : (0, $8zRru.createCommentVNode)("", true),
            !_ctx.isFirstSection ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("img", {
                key: 1,
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.handleNavigation("back")),
                class: "back-button",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($bA7RK))),
                alt: "back button"
            })) : (0, $8zRru.createCommentVNode)("", true),
            ((0, $8zRru.openBlock)(true), (0, $8zRru.createElementBlock)((0, $8zRru.Fragment), null, (0, $8zRru.renderList)(_ctx.sections[_ctx.currentSectionIndex], (question)=>{
                return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", {
                    key: question.id
                }, [
                    question.type == "hidden" ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $20f3774800fa1c01$var$_hoisted_4)) : question.type === "divider" && _ctx.checkConditions(question) ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("hr", $20f3774800fa1c01$var$_hoisted_5)) : question.type === "header" && _ctx.checkConditions(question) ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("h1", $20f3774800fa1c01$var$_hoisted_6, (0, $6ZvW5.toDisplayString)(_ctx.currentSectionIndex + 1) + ". " + (0, $6ZvW5.toDisplayString)(question.title[_ctx.lang]), 1)) : question.type === "subheader" && _ctx.checkConditions(question) ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("h3", $20f3774800fa1c01$var$_hoisted_7, (0, $6ZvW5.toDisplayString)(question.title[_ctx.lang]), 1)) : question.type === "relationDelete" ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("img", {
                        key: 4,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4SNgb))),
                        onClick: ($event)=>_ctx.handleDeleteRelation(question),
                        class: "relation-delete-icon"
                    }, null, 8, $20f3774800fa1c01$var$_hoisted_8)) : question.prefilledValue || _ctx.checkConditions(question) ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $20f3774800fa1c01$var$_hoisted_9, [
                        question.type !== "paragraph" ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("label", {
                            key: 0,
                            class: (0, $6ZvW5.normalizeClass)(question.prefilledValue ? "label-info" : "")
                        }, (0, $6ZvW5.toDisplayString)(question.title[_ctx.lang]), 3)) : (0, $8zRru.createCommentVNode)("", true),
                        question.prefilledValue ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("p", {
                            key: 1,
                            value: question.prefilledValue,
                            id: question.id,
                            class: "form-data",
                            "for-form-submit": ""
                        }, (0, $6ZvW5.toDisplayString)(question.prefilledValue), 9, $20f3774800fa1c01$var$_hoisted_10)) : question.type === "select" ? (0, $8zRru.withDirectives)(((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("select", {
                            key: 2,
                            class: "select",
                            "onUpdate:modelValue": ($event)=>question.value = $event,
                            "for-form-submit": "",
                            required: question.required === false ? question.required : true,
                            id: question.id,
                            onChange: ($event)=>_ctx.handleChange($event, question)
                        }, [
                            ((0, $8zRru.openBlock)(true), (0, $8zRru.createElementBlock)((0, $8zRru.Fragment), null, (0, $8zRru.renderList)(question.options, (option)=>{
                                return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("option", {
                                    key: option.label[_ctx.lang],
                                    value: option.value
                                }, (0, $6ZvW5.toDisplayString)(option.label[_ctx.lang]), 9, $20f3774800fa1c01$var$_hoisted_12);
                            }), 128))
                        ], 40, $20f3774800fa1c01$var$_hoisted_11)), [
                            [
                                (0, $5lPju.vModelSelect),
                                question.value
                            ]
                        ]) : question.type === "radio" ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $20f3774800fa1c01$var$_hoisted_13, [
                            ((0, $8zRru.openBlock)(true), (0, $8zRru.createElementBlock)((0, $8zRru.Fragment), null, (0, $8zRru.renderList)(question.options, (option, index)=>{
                                return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("label", {
                                    class: "radio-btn",
                                    key: index
                                }, [
                                    (0, $8zRru.createElementVNode)("input", {
                                        type: "radio",
                                        value: option.value,
                                        name: question.id,
                                        onChange: ($event)=>_ctx.handleChange($event, question),
                                        checked: question.value === option.value,
                                        required: question.required === false ? question.required : true
                                    }, null, 40, $20f3774800fa1c01$var$_hoisted_14),
                                    (0, $8zRru.createElementVNode)("p", null, (0, $6ZvW5.toDisplayString)(option.label[_ctx.lang]), 1)
                                ]);
                            }), 128))
                        ])) : question.type === "date" ? (0, $8zRru.withDirectives)(((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("input", {
                            key: 4,
                            "onUpdate:modelValue": ($event)=>question.value = $event,
                            type: "date",
                            onChange: ($event)=>_ctx.handleChange($event, question),
                            required: question.required === false ? question.required : true,
                            id: question.id,
                            "for-form-submit": "",
                            onfocus: "this.showPicker()"
                        }, null, 40, $20f3774800fa1c01$var$_hoisted_15)), [
                            [
                                (0, $5lPju.vModelText),
                                question.value
                            ]
                        ]) : question.type === `textarea` && typeof question.value === `string` ? (0, $8zRru.withDirectives)(((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("textarea", {
                            key: 5,
                            "onUpdate:modelValue": ($event)=>question.value = $event,
                            onChange: ($event)=>_ctx.handleChange($event, question),
                            rows: "3",
                            cols: "25",
                            required: question.required === false ? question.required : true,
                            id: question.id,
                            "for-form-submit": ""
                        }, null, 40, $20f3774800fa1c01$var$_hoisted_16)), [
                            [
                                (0, $5lPju.vModelText),
                                question.value
                            ]
                        ]) : question.type === "paragraph" ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("label", $20f3774800fa1c01$var$_hoisted_17, (0, $6ZvW5.toDisplayString)(question.title[_ctx.lang]), 1)) : question.type === "file" ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $20f3774800fa1c01$var$_hoisted_18, [
                            question.description ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("label", $20f3774800fa1c01$var$_hoisted_19, "**" + (0, $6ZvW5.toDisplayString)(question.description[_ctx.lang]) + "**", 1)) : (0, $8zRru.createCommentVNode)("", true),
                            (0, $8zRru.createElementVNode)("input", {
                                type: "file",
                                id: question.id,
                                "for-form-submit": "",
                                accept: "image/*,application/pdf",
                                onChange: ($event)=>_ctx.handleChange($event, question),
                                required: question.required === false ? question.required : true,
                                style: {
                                    "position": "absolute",
                                    "width": "1px",
                                    "height": "1px",
                                    "opacity": "0",
                                    "overflow": "hidden"
                                }
                            }, null, 40, $20f3774800fa1c01$var$_hoisted_20),
                            question.value ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("div", $20f3774800fa1c01$var$_hoisted_21, [
                                (0, $8zRru.createElementVNode)("span", $20f3774800fa1c01$var$_hoisted_22, (0, $6ZvW5.toDisplayString)(question.value), 1),
                                (0, $8zRru.createElementVNode)("label", {
                                    class: "file-delete-icon",
                                    onClick: ($event)=>{
                                        _ctx.handleChange($event, question);
                                        question.value = null;
                                        _ctx.resetFileInput(question.id);
                                    }
                                }, "x", 8, $20f3774800fa1c01$var$_hoisted_23)
                            ])) : (0, $8zRru.createCommentVNode)("", true),
                            !question.value ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("label", {
                                key: 2,
                                for: question.id,
                                class: "add-file-btn"
                            }, [
                                _cache[4] || (_cache[4] = (0, $8zRru.createElementVNode)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1Frv0))),
                                    alt: "add icon"
                                }, null, -1)),
                                (0, $8zRru.createTextVNode)(" " + (0, $6ZvW5.toDisplayString)(_ctx.$t("formPage.addFile")), 1)
                            ], 8, $20f3774800fa1c01$var$_hoisted_24)) : (0, $8zRru.createCommentVNode)("", true)
                        ])) : (0, $8zRru.withDirectives)(((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("input", {
                            key: 8,
                            type: question.type,
                            "onUpdate:modelValue": ($event)=>question.value = $event,
                            required: question.required === false ? question.required : true,
                            id: question.id,
                            "for-form-submit": "",
                            onChange: ($event)=>_ctx.handleChange($event, question),
                            value: question.value
                        }, null, 40, $20f3774800fa1c01$var$_hoisted_25)), [
                            [
                                (0, $5lPju.vModelDynamic),
                                question.value,
                                void 0,
                                {
                                    lazy: true
                                }
                            ]
                        ])
                    ])) : (0, $8zRru.createCommentVNode)("", true)
                ]);
            }), 128)),
            _ctx.isLastSection ? ((0, $8zRru.openBlock)(), (0, $8zRru.createBlock)(_component_Button, {
                key: 2,
                type: "submit",
                buttonText: _ctx.$t("formPage.submit"),
                onButtonClick: _ctx.handleSubmit
            }, null, 8, [
                "buttonText",
                "onButtonClick"
            ])) : (0, $8zRru.createCommentVNode)("", true)
        ], 544),
        _ctx.currentSectionIndex === 1 ? ((0, $8zRru.openBlock)(), (0, $8zRru.createBlock)(_component_Button, {
            key: 0,
            buttonText: _ctx.$t("formPage.addRelation"),
            isPrimary: false,
            onButtonClick: _ctx.handleAddNewRelation,
            showIcon: ""
        }, null, 8, [
            "buttonText",
            "onButtonClick"
        ])) : (0, $8zRru.createCommentVNode)("", true),
        !_ctx.isLastSection ? ((0, $8zRru.openBlock)(), (0, $8zRru.createBlock)(_component_Button, {
            key: 1,
            buttonText: _ctx.$t("formPage.continue"),
            onButtonClick: _cache[3] || (_cache[3] = ($event)=>_ctx.handleNavigation("forward"))
        }, null, 8, [
            "buttonText"
        ])) : (0, $8zRru.createCommentVNode)("", true)
    ]));
}

});
parcelRegister("bA7RK", function(module, exports) {
module.exports = new URL("back-arrow.d1092585.svg", import.meta.url).toString();

});

parcelRegister("4SNgb", function(module, exports) {
module.exports = new URL("remove-icon.153442ac.svg", import.meta.url).toString();

});


parcelRegister("iQDNl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db8bf3bfeeba0e98$export$2e2bcd8739ae039; });
let $db8bf3bfeeba0e98$var$NOOP = ()=>{};
var $db8bf3bfeeba0e98$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("hqvgn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e610c330d904f7de$export$2e2bcd8739ae039; });
parcelRequire("i2PrI");
var $cxzoJ = parcelRequire("cxzoJ");

var $2Wseo = parcelRequire("2Wseo");

var $gF9qy = parcelRequire("gF9qy");
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");

var $kBVDt = parcelRequire("kBVDt");

var $58E6z = parcelRequire("58E6z");

var $2aNQ5 = parcelRequire("2aNQ5");

var $36h9V = parcelRequire("36h9V");
var $e610c330d904f7de$export$2e2bcd8739ae039 = (0, $8zRru.defineComponent)({
    data () {
        return {
            email: this.$route.query.email || "",
            emailSent: false,
            noEmailMessage: false
        };
    },
    async created () {
        const firebaseInstance = (0, $58E6z.firebaseApp).instance;
        const auth = (0, $cxzoJ.o)(firebaseInstance);
        auth.onAuthStateChanged(async (user)=>{
            if (user) {
                this.$router.push("form");
                return;
            }
            const emailInUrl = this.$route.query.email;
            const langInUrl = this.$route.query.lang;
            const doesLangMatch = (0, $2aNQ5.languages).includes(langInUrl);
            const langToUse = doesLangMatch ? langInUrl : "en";
            await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_LANG_KEY), langToUse);
            this.$i18n.locale = langToUse;
            const doesEmailInUrlExist = !!emailInUrl;
            const shouldRedirectUser = !doesEmailInUrlExist;
            this.email = emailInUrl;
            if (shouldRedirectUser) {
                this.noEmailMessage = true;
                return;
            }
            this.handleSubmit();
        });
    },
    methods: {
        async handleSubmit () {
            const firebaseInstance = (0, $58E6z.firebaseApp).instance;
            const actionCodeSettings = {
                url: window.location.href,
                handleCodeInApp: true
            };
            try {
                this.emailSent = true;
                const auth = (0, $cxzoJ.o)(firebaseInstance);
                await (0, $cxzoJ.ac)(auth, this.email, actionCodeSettings);
                await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).setItem((0, $kBVDt.STORED_EMAIL_KEY), this.email);
            } catch (error) {
                console.log(error);
                const lang = await (0, $36h9V.getSavedLang)();
                const errorTitle = (0, $2aNQ5.ERROR_MESSAGES).SIGN_IN_FAILED[lang];
                const errorMessage = (0, $2aNQ5.ERROR_MESSAGES).SIGN_IN_FAILED_REFRESH[lang];
                (0, (/*@__PURE__*/$parcel$interopDefault($gF9qy))).Report.failure(errorTitle, errorMessage, "Ok", ()=>{
                    window.location.reload();
                });
            }
        }
    }
});

});

parcelRegister("5d68S", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $3cb2ee5b6751f44c$export$b3890eb0ae9dca99; });
parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $6ZvW5 = parcelRequire("6ZvW5");
const $3cb2ee5b6751f44c$var$_hoisted_1 = {
    key: 0,
    class: "login-message"
};
const $3cb2ee5b6751f44c$var$_hoisted_2 = {
    key: 1,
    class: "login-message"
};
function $3cb2ee5b6751f44c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)((0, $8zRru.Fragment), null, [
        _ctx.noEmailMessage ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("p", $3cb2ee5b6751f44c$var$_hoisted_1, (0, $6ZvW5.toDisplayString)(_ctx.$t("loginPage.noEmailMessage")), 1)) : (0, $8zRru.createCommentVNode)("", true),
        _ctx.emailSent ? ((0, $8zRru.openBlock)(), (0, $8zRru.createElementBlock)("p", $3cb2ee5b6751f44c$var$_hoisted_2, (0, $6ZvW5.toDisplayString)(_ctx.$t("loginPage.loginMessage")), 1)) : (0, $8zRru.createCommentVNode)("", true)
    ], 64);
}

});

parcelRegister("lnKuo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f90fcebfdced5dde$export$2e2bcd8739ae039; });
let $f90fcebfdced5dde$var$NOOP = ()=>{};
var $f90fcebfdced5dde$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("a38K9");
var $5lPju = parcelRequire("5lPju");
let $c9291cbe07952190$var$script;




let $c9291cbe07952190$var$initialize = ()=>{
    $c9291cbe07952190$var$script = (parcelRequire("i68qq"));
    if ($c9291cbe07952190$var$script.__esModule) $c9291cbe07952190$var$script = $c9291cbe07952190$var$script.default;
    $c9291cbe07952190$var$script.render = (parcelRequire("h69le")).render;
    $c9291cbe07952190$var$script.__cssModules = {};
    (parcelRequire("a7MAA")).default($c9291cbe07952190$var$script);
    $c9291cbe07952190$var$script.__scopeId = "data-v-b403cd";
    $c9291cbe07952190$var$script.__file = "App.vue";
};
$c9291cbe07952190$var$initialize();
var $c9291cbe07952190$export$2e2bcd8739ae039 = $c9291cbe07952190$var$script;



var $2Wseo = parcelRequire("2Wseo");
/*!
  * vue-i18n v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ /*!
  * shared v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ function $73e90664ed51b607$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== "undefined") {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
const $73e90664ed51b607$var$hasWarned = {};
function $73e90664ed51b607$export$5b28268982f175ba(msg) {
    if (!$73e90664ed51b607$var$hasWarned[msg]) {
        $73e90664ed51b607$var$hasWarned[msg] = true;
        $73e90664ed51b607$export$c106dd0671a0fc2d(msg);
    }
}
/**
 * Original Utilities
 * written by kazuya kawaguchi
 */ const $73e90664ed51b607$export$620a268685f0ac45 = typeof window !== "undefined";
let $73e90664ed51b607$export$bf7f2fce5c1cf636;
let $73e90664ed51b607$export$83602b44513dc228;
var $73e90664ed51b607$var$tag, $73e90664ed51b607$var$name, $73e90664ed51b607$var$startTag, $73e90664ed51b607$var$endTag;
const $73e90664ed51b607$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $73e90664ed51b607$export$d9468344d3651243(message, ...args) {
    if (args.length === 1 && $73e90664ed51b607$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($73e90664ed51b607$var$RE_ARGS, (match, identifier)=>{
        return args.hasOwnProperty(identifier) ? args[identifier] : "";
    });
}
const $73e90664ed51b607$export$cd133c5e04906ece = (name, shareable = false)=>!shareable ? Symbol(name) : Symbol.for(name);
const $73e90664ed51b607$export$5024ef1f92c9a364 = (locale, key, source)=>$73e90664ed51b607$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
const $73e90664ed51b607$export$d704025436eaed65 = (json)=>JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
const $73e90664ed51b607$export$7e4aa119212bc614 = (val)=>typeof val === "number" && isFinite(val);
const $73e90664ed51b607$export$871608497c498473 = (val)=>$73e90664ed51b607$export$1dccc787cc36538b(val) === "[object Date]";
const $73e90664ed51b607$export$49841c62b9eff15 = (val)=>$73e90664ed51b607$export$1dccc787cc36538b(val) === "[object RegExp]";
const $73e90664ed51b607$export$83b788b1a3698c03 = (val)=>$73e90664ed51b607$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
const $73e90664ed51b607$export$e6e34fd1f2686227 = Object.assign;
const $73e90664ed51b607$var$_create = Object.create;
const $73e90664ed51b607$export$185802fd694ee1f5 = (obj = null)=>$73e90664ed51b607$var$_create(obj);
let $73e90664ed51b607$var$_globalThis;
const $73e90664ed51b607$export$ff5f2eeb11fc7e14 = ()=>{
    // prettier-ignore
    return $73e90664ed51b607$var$_globalThis || ($73e90664ed51b607$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : $73e90664ed51b607$export$185802fd694ee1f5());
};
function $73e90664ed51b607$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/&/g, "&amp;") // escape `&` first to avoid double escaping
    .replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;") // escape `/` to prevent closing tags or JavaScript URLs
    .replace(/=/g, "&#x3D;"); // escape `=` to prevent attribute injection
}
function $73e90664ed51b607$var$escapeAttributeValue(value) {
    return value.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;") // escape unescaped `&`
    .replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $73e90664ed51b607$export$d27e3ef8781285da(html) {
    // Escape dangerous characters in attribute values
    // Process attributes with double quotes
    html = html.replace(/(\w+)\s*=\s*"([^"]*)"/g, (_, attrName, attrValue)=>`${attrName}="${$73e90664ed51b607$var$escapeAttributeValue(attrValue)}"`);
    // Process attributes with single quotes
    html = html.replace(/(\w+)\s*=\s*'([^']*)'/g, (_, attrName, attrValue)=>`${attrName}='${$73e90664ed51b607$var$escapeAttributeValue(attrValue)}'`);
    // Detect and neutralize event handler attributes
    const eventHandlerPattern = /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi;
    if (eventHandlerPattern.test(html)) // Neutralize event handler attributes by escaping 'on'
    html = html.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3");
    // Disable javascript: URLs in various contexts
    const javascriptUrlPattern = [
        // In href, src, action, formaction attributes
        /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
        // In style attributes within url()
        /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
    ];
    javascriptUrlPattern.forEach((pattern)=>{
        html = html.replace(pattern, "$1javascript&#58;");
    });
    return html;
}
const $73e90664ed51b607$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $73e90664ed51b607$export$b5a638e9b3fff9f3(obj, key) {
    return $73e90664ed51b607$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ const $73e90664ed51b607$export$43bee75e5e14138e = Array.isArray;
const $73e90664ed51b607$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $73e90664ed51b607$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $73e90664ed51b607$export$f9ce7b637dfbe238 = (val)=>typeof val === "boolean";
const $73e90664ed51b607$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e90664ed51b607$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e90664ed51b607$export$4369c812aac99591 = (val)=>{
    return $73e90664ed51b607$export$a6cdc56e425d0d0a(val) && $73e90664ed51b607$export$f6e2535fb5126e54(val.then) && $73e90664ed51b607$export$f6e2535fb5126e54(val.catch);
};
const $73e90664ed51b607$export$830c053460e5ddf6 = Object.prototype.toString;
const $73e90664ed51b607$export$1dccc787cc36538b = (value)=>$73e90664ed51b607$export$830c053460e5ddf6.call(value);
const $73e90664ed51b607$export$53b83ca8eaab0383 = (val)=>{
    if (!$73e90664ed51b607$export$a6cdc56e425d0d0a(val)) return false;
    const proto = Object.getPrototypeOf(val);
    return proto === null || proto.constructor === Object;
};
// for converting list and named values to displayed strings.
const $73e90664ed51b607$export$b5b1545233b45293 = (val)=>{
    return val == null ? "" : $73e90664ed51b607$export$43bee75e5e14138e(val) || $73e90664ed51b607$export$53b83ca8eaab0383(val) && val.toString === $73e90664ed51b607$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
function $73e90664ed51b607$export$f7e2c8231c57a8bd(items, separator = "") {
    return items.reduce((str, item, index)=>index === 0 ? str + item : str + separator + item, "");
}
const $73e90664ed51b607$var$RANGE = 2;
function $73e90664ed51b607$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(let j = i - $73e90664ed51b607$var$RANGE; j <= i + $73e90664ed51b607$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $73e90664ed51b607$export$47db5deb603dfca1(code) {
    let current = code;
    return ()=>++current;
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $73e90664ed51b607$export$6f5e8f34570e3ad1() {
    const events = new Map();
    const emitter = {
        events: events,
        on (event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off (event, handler) {
            const handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit (event, payload) {
            (events.get(event) || []).slice().map((handler)=>handler(payload));
            (events.get("*") || []).slice().map((handler)=>handler(event, payload));
        }
    };
    return emitter;
}
const $73e90664ed51b607$var$isNotObjectOrIsArray = (val)=>!$73e90664ed51b607$export$a6cdc56e425d0d0a(val) || $73e90664ed51b607$export$43bee75e5e14138e(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $73e90664ed51b607$export$6c40052bed430212(src, des) {
    // src and des should both be objects, and none of them can be a array
    if ($73e90664ed51b607$var$isNotObjectOrIsArray(src) || $73e90664ed51b607$var$isNotObjectOrIsArray(des)) throw new Error("Invalid value");
    const stack = [
        {
            src: src,
            des: des
        }
    ];
    while(stack.length){
        const { src: src, des: des } = stack.pop();
        // using `Object.keys` which skips prototype properties
        Object.keys(src).forEach((key)=>{
            if (key === "__proto__") return;
            // if src[key] is an object/array, set des[key]
            // to empty object/array to prevent setting by reference
            if ($73e90664ed51b607$export$a6cdc56e425d0d0a(src[key]) && !$73e90664ed51b607$export$a6cdc56e425d0d0a(des[key])) des[key] = Array.isArray(src[key]) ? [] : $73e90664ed51b607$export$185802fd694ee1f5();
            if ($73e90664ed51b607$var$isNotObjectOrIsArray(des[key]) || $73e90664ed51b607$var$isNotObjectOrIsArray(src[key])) // replace with src[key] when:
            // src[key] or des[key] is not an object, or
            // src[key] or des[key] is an array
            des[key] = src[key];
            else // src[key] and des[key] are both objects, merge them
            stack.push({
                src: src[key],
                des: des[key]
            });
        });
    }
}


/*!
  * core-base v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ 
/*!
  * message-compiler v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ 
const $9e75e8a260101339$export$7119efed969a17d8 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $9e75e8a260101339$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $9e75e8a260101339$export$90c043f1c57770b8(start, end, source) {
    const loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
const $9e75e8a260101339$export$21499b937901db8a = {
    USE_MODULO_SYNTAX: 1,
    __EXTEND_POINT__: 2
};
/** @internal */ const $9e75e8a260101339$export$a9ce0120dbc716f9 = {
    [$9e75e8a260101339$export$21499b937901db8a.USE_MODULO_SYNTAX]: `Use modulo before '{{0}}'.`
};
function $9e75e8a260101339$export$b5ca1ea40a366b08(code, loc, ...args) {
    const msg = code;
    const message = {
        message: String(msg),
        code: code
    };
    if (loc) message.location = loc;
    return message;
}
const $9e75e8a260101339$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // generator error codes
    UNHANDLED_CODEGEN_NODE_TYPE: 15,
    // minifier error codes
    UNHANDLED_MINIFIER_NODE_TYPE: 16,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 17
};
/** @internal */ const $9e75e8a260101339$export$d8bd0967cb58683 = {
    // tokenizer error messages
    [$9e75e8a260101339$export$77436aae039469c4.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [$9e75e8a260101339$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [$9e75e8a260101339$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [$9e75e8a260101339$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [$9e75e8a260101339$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [$9e75e8a260101339$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [$9e75e8a260101339$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [$9e75e8a260101339$export$77436aae039469c4.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [$9e75e8a260101339$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [$9e75e8a260101339$export$77436aae039469c4.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [$9e75e8a260101339$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [$9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [$9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [$9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
    // generator error messages
    [$9e75e8a260101339$export$77436aae039469c4.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
    // minimizer error messages
    [$9e75e8a260101339$export$77436aae039469c4.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function $9e75e8a260101339$export$21efa8bb37d5fecb(code, loc, options = {}) {
    const { domain: domain, messages: messages, args: args } = options;
    const msg = code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $9e75e8a260101339$export$ad0eb2c702f03471(error) {
    throw error;
}
// eslint-disable-next-line no-useless-escape
const $9e75e8a260101339$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const $9e75e8a260101339$export$6de85467cbd6ae39 = (source)=>$9e75e8a260101339$var$RE_HTML_TAG.test(source);
const $9e75e8a260101339$var$CHAR_SP = " ";
const $9e75e8a260101339$var$CHAR_CR = "\r";
const $9e75e8a260101339$var$CHAR_LF = "\n";
const $9e75e8a260101339$var$CHAR_LS = String.fromCharCode(0x2028);
const $9e75e8a260101339$var$CHAR_PS = String.fromCharCode(0x2029);
function $9e75e8a260101339$var$createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index)=>_buf[index] === $9e75e8a260101339$var$CHAR_CR && _buf[index + 1] === $9e75e8a260101339$var$CHAR_LF;
    const isLF = (index)=>_buf[index] === $9e75e8a260101339$var$CHAR_LF;
    const isPS = (index)=>_buf[index] === $9e75e8a260101339$var$CHAR_PS;
    const isLS = (index)=>_buf[index] === $9e75e8a260101339$var$CHAR_LS;
    const isLineEnd = (index)=>isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = ()=>_index;
    const line = ()=>_line;
    const column = ()=>_column;
    const peekOffset = ()=>_peekOffset;
    const charAt = (offset)=>isCRLF(offset) || isPS(offset) || isLS(offset) ? $9e75e8a260101339$var$CHAR_LF : _buf[offset];
    const currentChar = ()=>charAt(_index);
    const currentPeek = ()=>charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while(target !== _index)next();
        _peekOffset = 0;
    }
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
const $9e75e8a260101339$var$EOF = undefined;
const $9e75e8a260101339$var$DOT = ".";
const $9e75e8a260101339$var$LITERAL_DELIMITER = "'";
const $9e75e8a260101339$var$ERROR_DOMAIN$3 = "tokenizer";
function $9e75e8a260101339$var$createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = $9e75e8a260101339$var$createScanner(source);
    const currentOffset = ()=>_scnr.index();
    const currentPosition = ()=>$9e75e8a260101339$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 14 /* TokenTypes.EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* TokenTypes.EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ""
    };
    const context = ()=>_context;
    const { onError: onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = location ? $9e75e8a260101339$export$90c043f1c57770b8(ctx.startLoc, pos) : null;
            const err = $9e75e8a260101339$export$21efa8bb37d5fecb(code, loc, {
                domain: $9e75e8a260101339$var$ERROR_DOMAIN$3,
                args: args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = {
            type: type
        };
        if (location) token.loc = $9e75e8a260101339$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    }
    const getEndToken = (context)=>getToken(context, 14 /* TokenTypes.EOF */ );
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($9e75e8a260101339$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return "";
        }
    }
    function peekSpaces(scnr) {
        let buf = "";
        while(scnr.currentPeek() === $9e75e8a260101339$var$CHAR_SP || scnr.currentPeek() === $9e75e8a260101339$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === $9e75e8a260101339$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    }
    function isNumberStart(ch) {
        if (ch === $9e75e8a260101339$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === $9e75e8a260101339$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 8 /* TokenTypes.LinkedAlias */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* TokenChars.LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 9 /* TokenTypes.LinkedDot */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType: currentType } = context;
        if (!(currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 12 /* TokenTypes.LinkedModifier */ )) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* TokenChars.LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 10 /* TokenTypes.LinkedDelimiter */ ) return false;
        const fn = ()=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* TokenChars.LinkedAlias */  || ch === "%" /* TokenChars.Modulo */  || ch === "|" /* TokenChars.Pipe */  || ch === ":" /* TokenChars.LinkedDelimiter */  || ch === "." /* TokenChars.LinkedDot */  || ch === $9e75e8a260101339$var$CHAR_SP || !ch) return false;
            else if (ch === $9e75e8a260101339$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isTextStart(scnr, false);
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* TokenChars.Pipe */ ;
        scnr.resetPeek();
        return ret;
    }
    function detectModuloStart(scnr) {
        const spaces = peekSpaces(scnr);
        const ret = scnr.currentPeek() === "%" /* TokenChars.Modulo */  && scnr.peek() === "{" /* TokenChars.BraceLeft */ ;
        scnr.resetPeek();
        return {
            isModulo: ret,
            hasSpace: spaces.length > 0
        };
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = "", detectModulo = false)=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return prev === "%" /* TokenChars.Modulo */  ? false : hasSpace;
            else if (ch === "@" /* TokenChars.LinkedAlias */  || !ch) return prev === "%" /* TokenChars.Modulo */  ? true : hasSpace;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                scnr.peek();
                return fn(hasSpace, "%" /* TokenChars.Modulo */ , true);
            } else if (ch === "|" /* TokenChars.Pipe */ ) return prev === "%" /* TokenChars.Modulo */  || detectModulo ? true : !(prev === $9e75e8a260101339$var$CHAR_SP || prev === $9e75e8a260101339$var$CHAR_LF);
            else if (ch === $9e75e8a260101339$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $9e75e8a260101339$var$CHAR_SP, detectModulo);
            } else if (ch === $9e75e8a260101339$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $9e75e8a260101339$var$CHAR_LF, detectModulo);
            } else return true;
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === $9e75e8a260101339$var$EOF) return $9e75e8a260101339$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function isIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 // $
        ;
    }
    function takeIdentifierChar(scnr) {
        return takeChar(scnr, isIdentifier);
    }
    function isNamedIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 || // $
        cc === 45 // -
        ;
    }
    function takeNamedIdentifierChar(scnr) {
        return takeChar(scnr, isNamedIdentifier);
    }
    function isDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function takeDigit(scnr) {
        return takeChar(scnr, isDigit);
    }
    function isHexDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57 || // 0-9
        cc >= 65 && cc <= 70 || // A-F
        cc >= 97 && cc <= 102; // a-f
    }
    function takeHexDigit(scnr) {
        return takeChar(scnr, isHexDigit);
    }
    function getDigits(scnr) {
        let ch = "";
        let num = "";
        while(ch = takeDigit(scnr))num += ch;
        return num;
    }
    function readModulo(scnr) {
        skipSpaces(scnr);
        const ch = scnr.currentChar();
        if (ch !== "%" /* TokenChars.Modulo */ ) emitError($9e75e8a260101339$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
        scnr.next();
        return "%" /* TokenChars.Modulo */ ;
    }
    function readText(scnr) {
        let buf = "";
        // eslint-disable-next-line no-constant-condition
        while(true){
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "}" /* TokenChars.BraceRight */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || !ch) break;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else break;
            } else if (ch === $9e75e8a260101339$var$CHAR_SP || ch === $9e75e8a260101339$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let name = "";
        while(ch = takeNamedIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $9e75e8a260101339$var$EOF) emitError($9e75e8a260101339$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = "";
        if (scnr.currentChar() === "-") {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $9e75e8a260101339$var$EOF) emitError($9e75e8a260101339$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    }
    function isLiteral(ch) {
        return ch !== $9e75e8a260101339$var$LITERAL_DELIMITER && ch !== $9e75e8a260101339$var$CHAR_LF;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        let ch = "";
        let literal = "";
        while(ch = takeChar(scnr, isLiteral))if (ch === "\\") literal += readEscapeSequence(scnr);
        else literal += ch;
        const current = scnr.currentChar();
        if (current === $9e75e8a260101339$var$CHAR_LF || current === $9e75e8a260101339$var$EOF) {
            emitError($9e75e8a260101339$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $9e75e8a260101339$var$CHAR_LF) {
                scnr.next();
                // eslint-disable-next-line no-useless-escape
                eat(scnr, `\'`);
            }
            return literal;
        }
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch(ch){
            case "\\":
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case "u":
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case "U":
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($9e75e8a260101339$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return "";
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = "";
        for(let i = 0; i < digits; i++){
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($9e75e8a260101339$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function isInvalidIdentifier(ch) {
        return ch !== "{" /* TokenChars.BraceLeft */  && ch !== "}" /* TokenChars.BraceRight */  && ch !== $9e75e8a260101339$var$CHAR_SP && ch !== $9e75e8a260101339$var$CHAR_LF;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let identifiers = "";
        while(ch = takeChar(scnr, isInvalidIdentifier))identifiers += ch;
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = "";
        let name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (buf)=>{
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "%" /* TokenChars.Modulo */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || ch === "(" /* TokenChars.ParenLeft */  || ch === ")" /* TokenChars.ParenRight */  || !ch) return buf;
            else if (ch === $9e75e8a260101339$var$CHAR_SP) return buf;
            else if (ch === $9e75e8a260101339$var$CHAR_LF || ch === $9e75e8a260101339$var$DOT) {
                buf += ch;
                scnr.next();
                return fn(buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
        };
        return fn("");
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* TokenChars.Pipe */ );
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                if (context.braceNest >= 1) emitError($9e75e8a260101339$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* TokenTypes.BraceLeft */ , "{" /* TokenChars.BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* TokenChars.BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* TokenTypes.BraceLeft */ ) emitError($9e75e8a260101339$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* TokenChars.LinkedAlias */ :
                if (context.braceNest > 0) emitError($9e75e8a260101339$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                {
                    let validNamedIdentifier = true;
                    let validListIdentifier = true;
                    let validLiteral = true;
                    if (isPluralStart(scnr)) {
                        if (context.braceNest > 0) emitError($9e75e8a260101339$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    if (context.braceNest > 0 && (context.currentType === 5 /* TokenTypes.Named */  || context.currentType === 6 /* TokenTypes.List */  || context.currentType === 7 /* TokenTypes.Literal */ )) {
                        emitError($9e75e8a260101339$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        context.braceNest = 0;
                        return readToken(scnr, context);
                    }
                    if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                        token = getToken(context, 5 /* TokenTypes.Named */ , readNamedIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                        token = getToken(context, 6 /* TokenTypes.List */ , readListIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validLiteral = isLiteralStart(scnr, context)) {
                        token = getToken(context, 7 /* TokenTypes.Literal */ , readLiteral(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                        // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                        token = getToken(context, 13 /* TokenTypes.InvalidPlace */ , readInvalidIdentifier(scnr));
                        emitError($9e75e8a260101339$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                        skipSpaces(scnr);
                        return token;
                    }
                    break;
                }
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType: currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 9 /* TokenTypes.LinkedDot */  || currentType === 12 /* TokenTypes.LinkedModifier */  || currentType === 10 /* TokenTypes.LinkedDelimiter */ ) && (ch === $9e75e8a260101339$var$CHAR_LF || ch === $9e75e8a260101339$var$CHAR_SP)) emitError($9e75e8a260101339$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* TokenChars.LinkedAlias */ :
                scnr.next();
                token = getToken(context, 8 /* TokenTypes.LinkedAlias */ , "@" /* TokenChars.LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* TokenChars.LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* TokenTypes.LinkedDot */ , "." /* TokenChars.LinkedDot */ );
            case ":" /* TokenChars.LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* TokenTypes.LinkedDelimiter */ , ":" /* TokenChars.LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* TokenTypes.LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* TokenChars.BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 11 /* TokenTypes.LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 8 /* TokenTypes.LinkedAlias */ ) emitError($9e75e8a260101339$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = {
            type: 14 /* TokenTypes.EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* TokenChars.BraceRight */ :
                emitError($9e75e8a260101339$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
            case "@" /* TokenChars.LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                {
                    if (isPluralStart(scnr)) {
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    const { isModulo: isModulo, hasSpace: hasSpace } = detectModuloStart(scnr);
                    if (isModulo) return hasSpace ? getToken(context, 0 /* TokenTypes.Text */ , readText(scnr)) : getToken(context, 4 /* TokenTypes.Modulo */ , readModulo(scnr));
                    if (isTextStart(scnr)) return getToken(context, 0 /* TokenTypes.Text */ , readText(scnr));
                    break;
                }
        }
        return token;
    }
    function nextToken() {
        const { currentType: currentType, offset: offset, startLoc: startLoc, endLoc: endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $9e75e8a260101339$var$EOF) return getToken(_context, 14 /* TokenTypes.EOF */ );
        return readToken(_scnr, _context);
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
const $9e75e8a260101339$export$9838302824baa7fa = "parser";
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const $9e75e8a260101339$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $9e75e8a260101339$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case `\\\\`:
            return `\\`;
        // eslint-disable-next-line no-useless-escape
        case `\\\'`:
            // eslint-disable-next-line no-useless-escape
            return `\'`;
        default:
            {
                const codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "\uFFFD";
            }
    }
}
function $9e75e8a260101339$export$88a1156fad04455f(options = {}) {
    const location = options.location !== false;
    const { onError: onError, onWarn: onWarn } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = location ? $9e75e8a260101339$export$90c043f1c57770b8(start, end) : null;
            const err = $9e75e8a260101339$export$21efa8bb37d5fecb(code, loc, {
                domain: $9e75e8a260101339$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    }
    function emitWarn(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onWarn) {
            const loc = location ? $9e75e8a260101339$export$90c043f1c57770b8(start, end) : null;
            onWarn($9e75e8a260101339$export$b5ca1ea40a366b08(code, loc, args));
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type: type
        };
        if (location) {
            node.start = offset;
            node.end = offset;
            node.loc = {
                start: loc,
                end: loc
            };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        if (type) node.type = type;
        if (location) {
            node.end = offset;
            if (node.loc) node.loc.end = pos;
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* NodeTypes.Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* NodeTypes.List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key, modulo) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* NodeTypes.Named */ , offset, loc);
        node.key = key;
        if (modulo === true) node.modulo = true;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* NodeTypes.Literal */ , offset, loc);
        node.value = value.replace($9e75e8a260101339$var$KNOWN_ESCAPES, $9e75e8a260101339$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* NodeTypes.LinkedModifier */ , offset, loc);
        if (token.type !== 12 /* TokenTypes.LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = "";
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
        node.value = token.value || "";
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* NodeTypes.LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* NodeTypes.Linked */ , context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 9 /* TokenTypes.LinkedDot */ ) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* TokenTypes.LinkedDelimiter */ ) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* TokenTypes.BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 11 /* TokenTypes.LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
                break;
            case 5 /* TokenTypes.Named */ :
                if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || "");
                break;
            case 6 /* TokenTypes.List */ :
                if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || "");
                break;
            case 7 /* TokenTypes.Literal */ :
                if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || "");
                break;
            default:
                {
                    // empty key
                    emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                    const nextContext = tokenizer.context();
                    const emptyLinkedKeyNode = startNode(7 /* NodeTypes.LinkedKey */ , nextContext.offset, nextContext.startLoc);
                    emptyLinkedKeyNode.value = "";
                    endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                    linkedNode.key = emptyLinkedKeyNode;
                    endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                    return {
                        nextConsumeToken: token,
                        node: linkedNode
                    };
                }
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? tokenizer.currentOffset() : context.offset;
        const startLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.endLoc : context.startLoc;
        const node = startNode(2 /* NodeTypes.Message */ , startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        let modulo = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* TokenTypes.Text */ :
                    if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ""));
                    break;
                case 6 /* TokenTypes.List */ :
                    if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ""));
                    break;
                case 4 /* TokenTypes.Modulo */ :
                    modulo = true;
                    break;
                case 5 /* TokenTypes.Named */ :
                    if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || "", !!modulo));
                    if (modulo) {
                        emitWarn(tokenizer, $9e75e8a260101339$export$21499b937901db8a.USE_MODULO_SYNTAX, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                        modulo = null;
                    }
                    break;
                case 7 /* TokenTypes.Literal */ :
                    if (token.value == null) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $9e75e8a260101339$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ""));
                    break;
                case 8 /* TokenTypes.LinkedAlias */ :
                    {
                        const parsed = parseLinked(tokenizer);
                        node.items.push(parsed.node);
                        nextToken = parsed.nextConsumeToken || null;
                        break;
                    }
            }
        }while (context.currentType !== 14 /* TokenTypes.EOF */  && context.currentType !== 1 /* TokenTypes.Pipe */ );
        // adjust message node loc
        const endOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* NodeTypes.Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 14 /* TokenTypes.EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset: offset, startLoc: startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* TokenTypes.EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
    function parse(source) {
        const tokenizer = $9e75e8a260101339$var$createTokenizer(source, (0, $73e90664ed51b607$export$e6e34fd1f2686227)({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* NodeTypes.Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        if (options.onCacheKey) node.cacheKey = options.onCacheKey(source);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* TokenTypes.EOF */ ) emitError(tokenizer, $9e75e8a260101339$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || "");
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return {
        parse: parse
    };
}
function $9e75e8a260101339$var$getTokenCaption(token) {
    if (token.type === 14 /* TokenTypes.EOF */ ) return "EOF";
    const name = (token.value || "").replace(/\r?\n/gu, "\\n");
    return name.length > 10 ? name.slice(0, 9) + "\u2026" : name;
}
function $9e75e8a260101339$var$createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast: ast,
        helpers: new Set()
    };
    const context = ()=>_context;
    const helper = (name)=>{
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $9e75e8a260101339$var$traverseNodes(nodes, transformer) {
    for(let i = 0; i < nodes.length; i++)$9e75e8a260101339$var$traverseNode(nodes[i], transformer);
}
function $9e75e8a260101339$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* NodeTypes.Plural */ :
            $9e75e8a260101339$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* HelperNameMap.PLURAL */ );
            break;
        case 2 /* NodeTypes.Message */ :
            $9e75e8a260101339$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $9e75e8a260101339$var$traverseNode(linked.key, transformer);
                transformer.helper("linked" /* HelperNameMap.LINKED */ );
                transformer.helper("type" /* HelperNameMap.TYPE */ );
                break;
            }
        case 5 /* NodeTypes.List */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("list" /* HelperNameMap.LIST */ );
            break;
        case 4 /* NodeTypes.Named */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("named" /* HelperNameMap.NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $9e75e8a260101339$var$transform(ast, options = {} // eslint-disable-line
) {
    const transformer = $9e75e8a260101339$var$createTransformer(ast);
    transformer.helper("normalize" /* HelperNameMap.NORMALIZE */ );
    // traverse
    ast.body && $9e75e8a260101339$var$traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $9e75e8a260101339$var$optimize(ast) {
    const body = ast.body;
    if (body.type === 2 /* NodeTypes.Message */ ) $9e75e8a260101339$var$optimizeMessageNode(body);
    else body.cases.forEach((c)=>$9e75e8a260101339$var$optimizeMessageNode(c));
    return ast;
}
function $9e75e8a260101339$var$optimizeMessageNode(message) {
    if (message.items.length === 1) {
        const item = message.items[0];
        if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) {
            message.static = item.value;
            delete item.value; // optimization for size
        }
    } else {
        const values = [];
        for(let i = 0; i < message.items.length; i++){
            const item = message.items[i];
            if (!(item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ )) break;
            if (item.value == null) break;
            values.push(item.value);
        }
        if (values.length === message.items.length) {
            message.static = (0, $73e90664ed51b607$export$f7e2c8231c57a8bd)(values);
            for(let i = 0; i < message.items.length; i++){
                const item = message.items[i];
                if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) delete item.value; // optimization for size
            }
        }
    }
}
const $9e75e8a260101339$var$ERROR_DOMAIN$1 = "minifier";
/* eslint-disable @typescript-eslint/no-explicit-any */ function $9e75e8a260101339$var$minify(node) {
    node.t = node.type;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            {
                const resource = node;
                $9e75e8a260101339$var$minify(resource.body);
                resource.b = resource.body;
                delete resource.body;
                break;
            }
        case 1 /* NodeTypes.Plural */ :
            {
                const plural = node;
                const cases = plural.cases;
                for(let i = 0; i < cases.length; i++)$9e75e8a260101339$var$minify(cases[i]);
                plural.c = cases;
                delete plural.cases;
                break;
            }
        case 2 /* NodeTypes.Message */ :
            {
                const message = node;
                const items = message.items;
                for(let i = 0; i < items.length; i++)$9e75e8a260101339$var$minify(items[i]);
                message.i = items;
                delete message.items;
                if (message.static) {
                    message.s = message.static;
                    delete message.static;
                }
                break;
            }
        case 3 /* NodeTypes.Text */ :
        case 9 /* NodeTypes.Literal */ :
        case 8 /* NodeTypes.LinkedModifier */ :
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const valueNode = node;
                if (valueNode.value) {
                    valueNode.v = valueNode.value;
                    delete valueNode.value;
                }
                break;
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $9e75e8a260101339$var$minify(linked.key);
                linked.k = linked.key;
                delete linked.key;
                if (linked.modifier) {
                    $9e75e8a260101339$var$minify(linked.modifier);
                    linked.m = linked.modifier;
                    delete linked.modifier;
                }
                break;
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                list.i = list.index;
                delete list.index;
                break;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                named.k = named.key;
                delete named.key;
                break;
            }
        default:
    }
    delete node.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ // eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
const $9e75e8a260101339$var$ERROR_DOMAIN = "parser";
function $9e75e8a260101339$var$createCodeGenerator(ast, options) {
    const { sourceMap: sourceMap, filename: filename, breakLineCode: breakLineCode, needIndent: _needIndent } = options;
    const location = options.location !== false;
    const _context = {
        filename: filename,
        code: "",
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    if (location && ast.loc) _context.source = ast.loc.source;
    const context = ()=>_context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : "";
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key)=>`_${key}`;
    const needIndent = ()=>_context.needIndent;
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $9e75e8a260101339$var$generateLinkedNode(generator, node) {
    const { helper: helper } = generator;
    generator.push(`${helper("linked" /* HelperNameMap.LINKED */ )}(`);
    $9e75e8a260101339$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        $9e75e8a260101339$var$generateNode(generator, node.modifier);
        generator.push(`, _type`);
    } else generator.push(`, undefined, _type`);
    generator.push(`)`);
}
function $9e75e8a260101339$var$generateMessageNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    generator.push(`${helper("normalize" /* HelperNameMap.NORMALIZE */ )}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for(let i = 0; i < length; i++){
        $9e75e8a260101339$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push("])");
}
function $9e75e8a260101339$var$generatePluralNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* HelperNameMap.PLURAL */ )}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for(let i = 0; i < length; i++){
            $9e75e8a260101339$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(", ");
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function $9e75e8a260101339$var$generateResource(generator, node) {
    if (node.body) $9e75e8a260101339$var$generateNode(generator, node.body);
    else generator.push("null");
}
function $9e75e8a260101339$var$generateNode(generator, node) {
    const { helper: helper } = generator;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            $9e75e8a260101339$var$generateResource(generator, node);
            break;
        case 1 /* NodeTypes.Plural */ :
            $9e75e8a260101339$var$generatePluralNode(generator, node);
            break;
        case 2 /* NodeTypes.Message */ :
            $9e75e8a260101339$var$generateMessageNode(generator, node);
            break;
        case 6 /* NodeTypes.Linked */ :
            $9e75e8a260101339$var$generateLinkedNode(generator, node);
            break;
        case 8 /* NodeTypes.LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* NodeTypes.LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* NodeTypes.List */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("list" /* HelperNameMap.LIST */ )}(${node.index}))`, node);
            break;
        case 4 /* NodeTypes.Named */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("named" /* HelperNameMap.NAMED */ )}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* NodeTypes.Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* NodeTypes.Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
    }
}
// generate code from AST
const $9e75e8a260101339$var$generate = (ast, options = {} // eslint-disable-line
)=>{
    const mode = (0, $73e90664ed51b607$export$844ec244b1367d54)(options.mode) ? options.mode : "normal";
    const filename = (0, $73e90664ed51b607$export$844ec244b1367d54)(options.filename) ? options.filename : "message.intl";
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
    const needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
    const helpers = ast.helpers || [];
    const generator = $9e75e8a260101339$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === "normal" ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${(0, $73e90664ed51b607$export$f7e2c8231c57a8bd)(helpers.map((s)=>`${s}: _${s}`), ", ")} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    $9e75e8a260101339$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    delete ast.helpers;
    const { code: code, map: map } = generator.context();
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $9e75e8a260101339$export$3243579822c486a0(source, options = {}) {
    const assignedOptions = (0, $73e90664ed51b607$export$e6e34fd1f2686227)({}, options);
    const jit = !!assignedOptions.jit;
    const enalbeMinify = !!assignedOptions.minify;
    const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
    // parse source codes
    const parser = $9e75e8a260101339$export$88a1156fad04455f(assignedOptions);
    const ast = parser.parse(source);
    if (!jit) {
        // transform ASTs
        $9e75e8a260101339$var$transform(ast, assignedOptions);
        // generate javascript codes
        return $9e75e8a260101339$var$generate(ast, assignedOptions);
    } else {
        // optimize ASTs
        enambeOptimize && $9e75e8a260101339$var$optimize(ast);
        // minimize ASTs
        enalbeMinify && $9e75e8a260101339$var$minify(ast);
        // In JIT mode, no ast transform, no code generation.
        return {
            ast: ast,
            code: ""
        };
    }
}


/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $f46e6a02d365fb97$var$initFeatureFlags() {
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
}
function $f46e6a02d365fb97$export$9ba95744594b90e0(val) {
    return (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(val) && $f46e6a02d365fb97$var$resolveType(val) === 0 && ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(val, "b") || (0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(val, "body"));
}
const $f46e6a02d365fb97$var$PROPS_BODY = [
    "b",
    "body"
];
function $f46e6a02d365fb97$var$resolveBody(node) {
    return $f46e6a02d365fb97$var$resolveProps(node, $f46e6a02d365fb97$var$PROPS_BODY);
}
const $f46e6a02d365fb97$var$PROPS_CASES = [
    "c",
    "cases"
];
function $f46e6a02d365fb97$var$resolveCases(node) {
    return $f46e6a02d365fb97$var$resolveProps(node, $f46e6a02d365fb97$var$PROPS_CASES, []);
}
const $f46e6a02d365fb97$var$PROPS_STATIC = [
    "s",
    "static"
];
function $f46e6a02d365fb97$var$resolveStatic(node) {
    return $f46e6a02d365fb97$var$resolveProps(node, $f46e6a02d365fb97$var$PROPS_STATIC);
}
const $f46e6a02d365fb97$var$PROPS_ITEMS = [
    "i",
    "items"
];
function $f46e6a02d365fb97$var$resolveItems(node) {
    return $f46e6a02d365fb97$var$resolveProps(node, $f46e6a02d365fb97$var$PROPS_ITEMS, []);
}
const $f46e6a02d365fb97$var$PROPS_TYPE = [
    "t",
    "type"
];
function $f46e6a02d365fb97$var$resolveType(node) {
    return $f46e6a02d365fb97$var$resolveProps(node, $f46e6a02d365fb97$var$PROPS_TYPE);
}
const $f46e6a02d365fb97$var$PROPS_VALUE = [
    "v",
    "value"
];
function $f46e6a02d365fb97$var$resolveValue$1(node, type) {
    const resolved = $f46e6a02d365fb97$var$resolveProps(node, $f46e6a02d365fb97$var$PROPS_VALUE);
    if (resolved != null) return resolved;
    else throw $f46e6a02d365fb97$var$createUnhandleNodeError(type);
}
const $f46e6a02d365fb97$var$PROPS_MODIFIER = [
    "m",
    "modifier"
];
function $f46e6a02d365fb97$var$resolveLinkedModifier(node) {
    return $f46e6a02d365fb97$var$resolveProps(node, $f46e6a02d365fb97$var$PROPS_MODIFIER);
}
const $f46e6a02d365fb97$var$PROPS_KEY = [
    "k",
    "key"
];
function $f46e6a02d365fb97$var$resolveLinkedKey(node) {
    const resolved = $f46e6a02d365fb97$var$resolveProps(node, $f46e6a02d365fb97$var$PROPS_KEY);
    if (resolved) return resolved;
    else throw $f46e6a02d365fb97$var$createUnhandleNodeError(6 /* NodeTypes.Linked */ );
}
function $f46e6a02d365fb97$var$resolveProps(node, props, defaultValue) {
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(node, prop) && node[prop] != null) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return node[prop];
    }
    return defaultValue;
}
const $f46e6a02d365fb97$export$cc9169d6f60edf74 = [
    ...$f46e6a02d365fb97$var$PROPS_BODY,
    ...$f46e6a02d365fb97$var$PROPS_CASES,
    ...$f46e6a02d365fb97$var$PROPS_STATIC,
    ...$f46e6a02d365fb97$var$PROPS_ITEMS,
    ...$f46e6a02d365fb97$var$PROPS_KEY,
    ...$f46e6a02d365fb97$var$PROPS_MODIFIER,
    ...$f46e6a02d365fb97$var$PROPS_VALUE,
    ...$f46e6a02d365fb97$var$PROPS_TYPE
];
function $f46e6a02d365fb97$var$createUnhandleNodeError(type) {
    return new Error(`unhandled node type: ${type}`);
}
const $f46e6a02d365fb97$var$pathStateMachine = [];
$f46e6a02d365fb97$var$pathStateMachine[0 /* States.BEFORE_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        0 /* States.BEFORE_PATH */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$f46e6a02d365fb97$var$pathStateMachine[1 /* States.IN_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$f46e6a02d365fb97$var$pathStateMachine[2 /* States.BEFORE_IDENT */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ]
};
$f46e6a02d365fb97$var$pathStateMachine[3 /* States.IN_IDENT */ ] = {
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ ,
        1 /* Actions.PUSH */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ ,
        1 /* Actions.PUSH */ 
    ]
};
$f46e6a02d365fb97$var$pathStateMachine[4 /* States.IN_SUB_PATH */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ['"' /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        2 /* Actions.INC_SUB_PATH_DEPTH */ 
    ],
    ["]" /* PathCharTypes.RIGHT_BRACKET */ ]: [
        1 /* States.IN_PATH */ ,
        3 /* Actions.PUSH_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ]
};
$f46e6a02d365fb97$var$pathStateMachine[5 /* States.IN_SINGLE_QUOTE */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
$f46e6a02d365fb97$var$pathStateMachine[6 /* States.IN_DOUBLE_QUOTE */ ] = {
    ['"' /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
/**
 * Check if an expression is a literal value.
 */ const $f46e6a02d365fb97$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $f46e6a02d365fb97$var$isLiteral(exp) {
    return $f46e6a02d365fb97$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $f46e6a02d365fb97$var$stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $f46e6a02d365fb97$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* PathCharTypes.END_OF_FAIL */ ;
    const code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* PathCharTypes.IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* PathCharTypes.WORKSPACE */ ;
    }
    return "i" /* PathCharTypes.IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $f46e6a02d365fb97$var$formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === "0" && isNaN(parseInt(path))) return false;
    return $f46e6a02d365fb97$var$isLiteral(trimmed) ? $f46e6a02d365fb97$var$stripQuotes(trimmed) : "*" /* PathCharTypes.ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $f46e6a02d365fb97$export$98e6a39c04603d36(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* States.BEFORE_PATH */ ;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* Actions.APPEND */ ] = ()=>{
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* Actions.PUSH */ ] = ()=>{
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* Actions.INC_SUB_PATH_DEPTH */ ] = ()=>{
        actions[0 /* Actions.APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* Actions.PUSH_SUB_PATH */ ] = ()=>{
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* States.IN_SUB_PATH */ ;
            actions[0 /* Actions.APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $f46e6a02d365fb97$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* Actions.PUSH */ ]();
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if (mode === 5 /* States.IN_SINGLE_QUOTE */  && nextChar === "'" /* PathCharTypes.SINGLE_QUOTE */  || mode === 6 /* States.IN_DOUBLE_QUOTE */  && nextChar === '"' /* PathCharTypes.DOUBLE_QUOTE */ ) {
            index++;
            newChar = "\\" + nextChar;
            actions[0 /* Actions.APPEND */ ]();
            return true;
        }
    }
    while(mode !== null){
        index++;
        c = path[index];
        if (c === "\\" && maybeUnescapeQuote()) continue;
        type = $f46e6a02d365fb97$var$getPathCharType(c);
        typeMap = $f46e6a02d365fb97$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* PathCharTypes.ELSE */ ] || 8 /* States.ERROR */ ;
        // check parse error
        if (transition === 8 /* States.ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* States.AFTER_PATH */ ) return keys;
    }
}
// path token cache
const $f46e6a02d365fb97$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $f46e6a02d365fb97$export$b365de4c3506886c(obj, path) {
    return (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $f46e6a02d365fb97$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(obj)) return null;
    // parse path
    let hit = $f46e6a02d365fb97$var$cache.get(path);
    if (!hit) {
        hit = $f46e6a02d365fb97$export$98e6a39c04603d36(path);
        if (hit) $f46e6a02d365fb97$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while(i < len){
        const key = hit[i];
        /**
         * NOTE:
         * if `key` is intlify message format AST node key and `last` is intlify message format AST, skip it.
         * because the AST node is not a key-value structure.
         */ if ($f46e6a02d365fb97$export$cc9169d6f60edf74.includes(key) && $f46e6a02d365fb97$export$9ba95744594b90e0(last)) return null;
        const val = last[key];
        if (val === undefined) return null;
        if ((0, $73e90664ed51b607$export$f6e2535fb5126e54)(last)) return null;
        last = val;
        i++;
    }
    return last;
}
const $f46e6a02d365fb97$var$DEFAULT_MODIFIER = (str)=>str;
const $f46e6a02d365fb97$var$DEFAULT_MESSAGE = (ctx)=>""; // eslint-disable-line
const $f46e6a02d365fb97$export$12b53af6b8529bfc = "text";
const $f46e6a02d365fb97$var$DEFAULT_NORMALIZE = (values)=>values.length === 0 ? "" : (0, $73e90664ed51b607$export$f7e2c8231c57a8bd)(values);
const $f46e6a02d365fb97$var$DEFAULT_INTERPOLATE = (0, $73e90664ed51b607$export$b5b1545233b45293);
function $f46e6a02d365fb97$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $f46e6a02d365fb97$var$getPluralIndex(options) {
    // prettier-ignore
    const index = (0, $73e90664ed51b607$export$7e4aa119212bc614)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $73e90664ed51b607$export$7e4aa119212bc614)(options.named.count) || (0, $73e90664ed51b607$export$7e4aa119212bc614)(options.named.n)) ? (0, $73e90664ed51b607$export$7e4aa119212bc614)(options.named.count) ? options.named.count : (0, $73e90664ed51b607$export$7e4aa119212bc614)(options.named.n) ? options.named.n : index : index;
}
function $f46e6a02d365fb97$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $f46e6a02d365fb97$export$70de3b14beda2f5e(options = {}) {
    const locale = options.locale;
    const pluralIndex = $f46e6a02d365fb97$var$getPluralIndex(options);
    const pluralRule = (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $73e90664ed51b607$export$844ec244b1367d54)(locale) && (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? options.pluralRules[locale] : $f46e6a02d365fb97$var$pluralDefault;
    const orgPluralRule = (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $73e90664ed51b607$export$844ec244b1367d54)(locale) && (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? $f46e6a02d365fb97$var$pluralDefault : undefined;
    const plural = (messages)=>{
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index)=>_list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    (0, $73e90664ed51b607$export$7e4aa119212bc614)(options.pluralIndex) && $f46e6a02d365fb97$var$normalizeNamed(pluralIndex, _named);
    const named = (key)=>_named[key];
    function message(key) {
        // prettier-ignore
        const msg = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.messages) ? options.messages(key) : (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $f46e6a02d365fb97$var$DEFAULT_MESSAGE : msg;
    }
    const _modifier = (name)=>options.modifiers ? options.modifiers[name] : $f46e6a02d365fb97$var$DEFAULT_MODIFIER;
    const normalize = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.processor) && (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.processor.normalize) ? options.processor.normalize : $f46e6a02d365fb97$var$DEFAULT_NORMALIZE;
    const interpolate = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.processor) && (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.processor.interpolate) ? options.processor.interpolate : $f46e6a02d365fb97$var$DEFAULT_INTERPOLATE;
    const type = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.processor) && (0, $73e90664ed51b607$export$844ec244b1367d54)(options.processor.type) ? options.processor.type : $f46e6a02d365fb97$export$12b53af6b8529bfc;
    const linked = (key, ...args)=>{
        const [arg1, arg2] = args;
        let type = "text";
        let modifier = "";
        if (args.length === 1) {
            if ((0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            } else if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
        } else if (args.length === 2) {
            if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
            if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg2)) type = arg2 || type;
        }
        const ret = message(key)(ctx);
        const msg = // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type === "vnode" && (0, $73e90664ed51b607$export$43bee75e5e14138e)(ret) && modifier ? ret[0] : ret;
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* HelperNameMap.LIST */ ]: list,
        ["named" /* HelperNameMap.NAMED */ ]: named,
        ["plural" /* HelperNameMap.PLURAL */ ]: plural,
        ["linked" /* HelperNameMap.LINKED */ ]: linked,
        ["message" /* HelperNameMap.MESSAGE */ ]: message,
        ["type" /* HelperNameMap.TYPE */ ]: type,
        ["interpolate" /* HelperNameMap.INTERPOLATE */ ]: interpolate,
        ["normalize" /* HelperNameMap.NORMALIZE */ ]: normalize,
        ["values" /* HelperNameMap.VALUES */ ]: (0, $73e90664ed51b607$export$e6e34fd1f2686227)((0, $73e90664ed51b607$export$185802fd694ee1f5)(), _list, _named)
    };
    return ctx;
}
let $f46e6a02d365fb97$var$devtools = null;
function $f46e6a02d365fb97$export$c893d6c8966908b9(hook) {
    $f46e6a02d365fb97$var$devtools = hook;
}
function $f46e6a02d365fb97$export$8bd08e70642dc6f4() {
    return $f46e6a02d365fb97$var$devtools;
}
function $f46e6a02d365fb97$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $f46e6a02d365fb97$var$devtools && $f46e6a02d365fb97$var$devtools.emit("i18n:init" /* IntlifyDevToolsHooks.I18nInit */ , {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
const $f46e6a02d365fb97$export$190d71a47ff3f767 = /* #__PURE__*/ $f46e6a02d365fb97$var$createDevToolsHook("function:translate" /* IntlifyDevToolsHooks.FunctionTranslate */ );
function $f46e6a02d365fb97$var$createDevToolsHook(hook) {
    return (payloads)=>$f46e6a02d365fb97$var$devtools && $f46e6a02d365fb97$var$devtools.emit(hook, payloads);
}
const $f46e6a02d365fb97$var$code$1 = (0, $9e75e8a260101339$export$21499b937901db8a).__EXTEND_POINT__;
const $f46e6a02d365fb97$var$inc$1 = (0, $73e90664ed51b607$export$47db5deb603dfca1)($f46e6a02d365fb97$var$code$1);
const $f46e6a02d365fb97$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: $f46e6a02d365fb97$var$code$1,
    FALLBACK_TO_TRANSLATE: $f46e6a02d365fb97$var$inc$1(),
    CANNOT_FORMAT_NUMBER: $f46e6a02d365fb97$var$inc$1(),
    FALLBACK_TO_NUMBER_FORMAT: $f46e6a02d365fb97$var$inc$1(),
    CANNOT_FORMAT_DATE: $f46e6a02d365fb97$var$inc$1(),
    FALLBACK_TO_DATE_FORMAT: $f46e6a02d365fb97$var$inc$1(),
    EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: $f46e6a02d365fb97$var$inc$1(),
    __EXTEND_POINT__: $f46e6a02d365fb97$var$inc$1() // 9
};
/** @internal */ const $f46e6a02d365fb97$var$warnMessages = {
    [$f46e6a02d365fb97$export$b6a676a18b27d4c8.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [$f46e6a02d365fb97$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [$f46e6a02d365fb97$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [$f46e6a02d365fb97$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [$f46e6a02d365fb97$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [$f46e6a02d365fb97$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`,
    [$f46e6a02d365fb97$export$b6a676a18b27d4c8.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: `This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.`
};
function $f46e6a02d365fb97$export$ae7a7631f2b2bb7(code, ...args) {
    return (0, $73e90664ed51b607$export$d9468344d3651243)($f46e6a02d365fb97$var$warnMessages[code], ...args);
}
const $f46e6a02d365fb97$var$code = (0, $9e75e8a260101339$export$77436aae039469c4).__EXTEND_POINT__;
const $f46e6a02d365fb97$var$inc = (0, $73e90664ed51b607$export$47db5deb603dfca1)($f46e6a02d365fb97$var$code);
const $f46e6a02d365fb97$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: $f46e6a02d365fb97$var$code,
    INVALID_DATE_ARGUMENT: $f46e6a02d365fb97$var$inc(),
    INVALID_ISO_DATE_ARGUMENT: $f46e6a02d365fb97$var$inc(),
    NOT_SUPPORT_NON_STRING_MESSAGE: $f46e6a02d365fb97$var$inc(),
    NOT_SUPPORT_LOCALE_PROMISE_VALUE: $f46e6a02d365fb97$var$inc(),
    NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: $f46e6a02d365fb97$var$inc(),
    NOT_SUPPORT_LOCALE_TYPE: $f46e6a02d365fb97$var$inc(),
    __EXTEND_POINT__: $f46e6a02d365fb97$var$inc() // 24
};
function $f46e6a02d365fb97$export$3d702f7ac45b0a6b(code) {
    return (0, $9e75e8a260101339$export$21efa8bb37d5fecb)(code, null, undefined);
}
/** @internal */ const $f46e6a02d365fb97$var$errorMessages = {
    [$f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_ARGUMENT]: "Invalid arguments",
    [$f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
    [$f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
    [$f46e6a02d365fb97$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
    [$f46e6a02d365fb97$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
    [$f46e6a02d365fb97$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
    [$f46e6a02d365fb97$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
/** @internal */ function $f46e6a02d365fb97$export$180605366c04f0cd(context, options) {
    return options.locale != null ? $f46e6a02d365fb97$export$df9bcabe7f932e01(options.locale) : $f46e6a02d365fb97$export$df9bcabe7f932e01(context.locale);
}
let $f46e6a02d365fb97$var$_resolveLocale;
/** @internal */ function $f46e6a02d365fb97$export$df9bcabe7f932e01(locale) {
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(locale)) return locale;
    else {
        if ((0, $73e90664ed51b607$export$f6e2535fb5126e54)(locale)) {
            if (locale.resolvedOnce && $f46e6a02d365fb97$var$_resolveLocale != null) return $f46e6a02d365fb97$var$_resolveLocale;
            else if (locale.constructor.name === "Function") {
                const resolve = locale();
                if ((0, $73e90664ed51b607$export$4369c812aac99591)(resolve)) throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
                return $f46e6a02d365fb97$var$_resolveLocale = resolve;
            } else throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
        } else throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE);
    }
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $f46e6a02d365fb97$export$e3330076537ef9d1(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return [
        ...new Set([
            start,
            ...(0, $73e90664ed51b607$export$43bee75e5e14138e)(fallback) ? fallback : (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(fallback) ? Object.keys(fallback) : (0, $73e90664ed51b607$export$844ec244b1367d54)(fallback) ? [
                fallback
            ] : [
                start
            ]
        ])
    ];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $f46e6a02d365fb97$export$71df9db82dc445(ctx, fallback, start) {
    const startLocale = (0, $73e90664ed51b607$export$844ec244b1367d54)(start) ? start : $f46e6a02d365fb97$export$1af4c7e47ad72f44;
    const context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [
            start
        ];
        // while any intervening block found
        while((0, $73e90664ed51b607$export$43bee75e5e14138e)(block))block = $f46e6a02d365fb97$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        const defaults = (0, $73e90664ed51b607$export$43bee75e5e14138e)(fallback) || !(0, $73e90664ed51b607$export$53b83ca8eaab0383)(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
        // convert defaults to array
        block = (0, $73e90664ed51b607$export$844ec244b1367d54)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(block)) $f46e6a02d365fb97$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $f46e6a02d365fb97$var$appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for(let i = 0; i < block.length && (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(follow); i++){
        const locale = block[i];
        if ((0, $73e90664ed51b607$export$844ec244b1367d54)(locale)) follow = $f46e6a02d365fb97$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $f46e6a02d365fb97$var$appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split("-");
    do {
        const target = tokens.join("-");
        follow = $f46e6a02d365fb97$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $f46e6a02d365fb97$var$appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== "!";
            const locale = target.replace(/!/g, "");
            chain.push(locale);
            if (((0, $73e90664ed51b607$export$43bee75e5e14138e)(blocks) || (0, $73e90664ed51b607$export$53b83ca8eaab0383)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ const $f46e6a02d365fb97$export$a4ad2735b021c132 = "9.14.5";
const $f46e6a02d365fb97$export$b7f13a18d1d0f835 = -1;
const $f46e6a02d365fb97$export$1af4c7e47ad72f44 = "en-US";
const $f46e6a02d365fb97$export$a04371e9dbb3870b = "";
const $f46e6a02d365fb97$var$capitalize = (str)=>`${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function $f46e6a02d365fb97$var$getDefaultLinkedModifiers() {
    return {
        upper: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $73e90664ed51b607$export$844ec244b1367d54)(val) ? val.toUpperCase() : type === "vnode" && (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val;
        },
        lower: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $73e90664ed51b607$export$844ec244b1367d54)(val) ? val.toLowerCase() : type === "vnode" && (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val;
        },
        capitalize: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $73e90664ed51b607$export$844ec244b1367d54)(val) ? $f46e6a02d365fb97$var$capitalize(val) : type === "vnode" && (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? $f46e6a02d365fb97$var$capitalize(val.children) : val;
        }
    };
}
let $f46e6a02d365fb97$var$_compiler;
function $f46e6a02d365fb97$export$6ee2fbe83628b40b(compiler) {
    $f46e6a02d365fb97$var$_compiler = compiler;
}
let $f46e6a02d365fb97$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $f46e6a02d365fb97$export$45dacdc710815463(resolver) {
    $f46e6a02d365fb97$var$_resolver = resolver;
}
let $f46e6a02d365fb97$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $f46e6a02d365fb97$export$fd8ec9dd8067edec(fallbacker) {
    $f46e6a02d365fb97$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let $f46e6a02d365fb97$var$_additionalMeta = null;
/* #__NO_SIDE_EFFECTS__ */ const $f46e6a02d365fb97$export$605703447dca72aa = (meta)=>{
    $f46e6a02d365fb97$var$_additionalMeta = meta;
};
/* #__NO_SIDE_EFFECTS__ */ const $f46e6a02d365fb97$export$817795a14e5c6622 = ()=>$f46e6a02d365fb97$var$_additionalMeta;
let $f46e6a02d365fb97$var$_fallbackContext = null;
const $f46e6a02d365fb97$export$e16aca6786e72a5e = (context)=>{
    $f46e6a02d365fb97$var$_fallbackContext = context;
};
const $f46e6a02d365fb97$export$3adddc434faa9e35 = ()=>$f46e6a02d365fb97$var$_fallbackContext;
// ID for CoreContext
let $f46e6a02d365fb97$var$_cid = 0;
function $f46e6a02d365fb97$export$3599d465b05a74a5(options = {}) {
    // setup options
    const onWarn = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.onWarn) ? options.onWarn : (0, $73e90664ed51b607$export$c106dd0671a0fc2d);
    const version = (0, $73e90664ed51b607$export$844ec244b1367d54)(options.version) ? options.version : $f46e6a02d365fb97$export$a4ad2735b021c132;
    const locale = (0, $73e90664ed51b607$export$844ec244b1367d54)(options.locale) || (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.locale) ? options.locale : $f46e6a02d365fb97$export$1af4c7e47ad72f44;
    const _locale = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(locale) ? $f46e6a02d365fb97$export$1af4c7e47ad72f44 : locale;
    const fallbackLocale = (0, $73e90664ed51b607$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.fallbackLocale) || (0, $73e90664ed51b607$export$844ec244b1367d54)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale;
    const messages = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.messages) ? options.messages : $f46e6a02d365fb97$var$createResources(_locale);
    const datetimeFormats = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : $f46e6a02d365fb97$var$createResources(_locale);
    const numberFormats = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : $f46e6a02d365fb97$var$createResources(_locale);
    const modifiers = (0, $73e90664ed51b607$export$e6e34fd1f2686227)((0, $73e90664ed51b607$export$185802fd694ee1f5)(), options.modifiers, $f46e6a02d365fb97$var$getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    const missing = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    const missingWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $73e90664ed51b607$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    const fallbackWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $73e90664ed51b607$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    const processor = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.processor) ? options.processor : null;
    const warnHtmlMessage = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.messageCompiler) ? options.messageCompiler : $f46e6a02d365fb97$var$_compiler;
    const messageResolver = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.messageResolver) ? options.messageResolver : $f46e6a02d365fb97$var$_resolver || $f46e6a02d365fb97$export$b365de4c3506886c;
    const localeFallbacker = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.localeFallbacker) ? options.localeFallbacker : $f46e6a02d365fb97$var$_fallbacker || $f46e6a02d365fb97$export$e3330076537ef9d1;
    const fallbackContext = (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(options.fallbackContext) ? options.fallbackContext : undefined;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    const __numberFormatters = (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    const __meta = (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(internalOptions.__meta) ? internalOptions.__meta : {};
    $f46e6a02d365fb97$var$_cid++;
    const context = {
        version: version,
        cid: $f46e6a02d365fb97$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        fallbackContext: fallbackContext,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) $f46e6a02d365fb97$export$725afc6a300324a0(context, version, __meta);
    return context;
}
const $f46e6a02d365fb97$var$createResources = (locale)=>({
        [locale]: (0, $73e90664ed51b607$export$185802fd694ee1f5)()
    });
/** @internal */ function $f46e6a02d365fb97$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $f46e6a02d365fb97$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $f46e6a02d365fb97$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    const { missing: missing, onWarn: onWarn } = context;
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return (0, $73e90664ed51b607$export$844ec244b1367d54)(ret) ? ret : key;
    } else return key;
}
/** @internal */ function $f46e6a02d365fb97$export$c743ad8a3cc01530(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/** @internal */ function $f46e6a02d365fb97$export$59f8e8904fd79a18(locale, compareLocale) {
    if (locale === compareLocale) return false;
    return locale.split("-")[0] === compareLocale.split("-")[0];
}
/** @internal */ function $f46e6a02d365fb97$export$d783301aca6271c3(targetLocale, locales) {
    const index = locales.indexOf(targetLocale);
    if (index === -1) return false;
    for(let i = index + 1; i < locales.length; i++){
        if ($f46e6a02d365fb97$export$59f8e8904fd79a18(targetLocale, locales[i])) return true;
    }
    return false;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ function $f46e6a02d365fb97$var$format(ast) {
    const msg = (ctx)=>$f46e6a02d365fb97$var$formatParts(ctx, ast);
    return msg;
}
function $f46e6a02d365fb97$var$formatParts(ctx, ast) {
    const body = $f46e6a02d365fb97$var$resolveBody(ast);
    if (body == null) throw $f46e6a02d365fb97$var$createUnhandleNodeError(0 /* NodeTypes.Resource */ );
    const type = $f46e6a02d365fb97$var$resolveType(body);
    if (type === 1 /* NodeTypes.Plural */ ) {
        const plural = body;
        const cases = $f46e6a02d365fb97$var$resolveCases(plural);
        return ctx.plural(cases.reduce((messages, c)=>[
                ...messages,
                $f46e6a02d365fb97$var$formatMessageParts(ctx, c)
            ], []));
    } else return $f46e6a02d365fb97$var$formatMessageParts(ctx, body);
}
function $f46e6a02d365fb97$var$formatMessageParts(ctx, node) {
    const static_ = $f46e6a02d365fb97$var$resolveStatic(node);
    if (static_ != null) return ctx.type === "text" ? static_ : ctx.normalize([
        static_
    ]);
    else {
        const messages = $f46e6a02d365fb97$var$resolveItems(node).reduce((acm, c)=>[
                ...acm,
                $f46e6a02d365fb97$var$formatMessagePart(ctx, c)
            ], []);
        return ctx.normalize(messages);
    }
}
function $f46e6a02d365fb97$var$formatMessagePart(ctx, node) {
    const type = $f46e6a02d365fb97$var$resolveType(node);
    switch(type){
        case 3 /* NodeTypes.Text */ :
            return $f46e6a02d365fb97$var$resolveValue$1(node, type);
        case 9 /* NodeTypes.Literal */ :
            return $f46e6a02d365fb97$var$resolveValue$1(node, type);
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                if ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(named, "k") && named.k) return ctx.interpolate(ctx.named(named.k));
                if ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(named, "key") && named.key) return ctx.interpolate(ctx.named(named.key));
                throw $f46e6a02d365fb97$var$createUnhandleNodeError(type);
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                if ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(list, "i") && (0, $73e90664ed51b607$export$7e4aa119212bc614)(list.i)) return ctx.interpolate(ctx.list(list.i));
                if ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(list, "index") && (0, $73e90664ed51b607$export$7e4aa119212bc614)(list.index)) return ctx.interpolate(ctx.list(list.index));
                throw $f46e6a02d365fb97$var$createUnhandleNodeError(type);
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                const modifier = $f46e6a02d365fb97$var$resolveLinkedModifier(linked);
                const key = $f46e6a02d365fb97$var$resolveLinkedKey(linked);
                return ctx.linked($f46e6a02d365fb97$var$formatMessagePart(ctx, key), modifier ? $f46e6a02d365fb97$var$formatMessagePart(ctx, modifier) : undefined, ctx.type);
            }
        case 7 /* NodeTypes.LinkedKey */ :
            return $f46e6a02d365fb97$var$resolveValue$1(node, type);
        case 8 /* NodeTypes.LinkedModifier */ :
            return $f46e6a02d365fb97$var$resolveValue$1(node, type);
        default:
            throw new Error(`unhandled node on format message part: ${type}`);
    }
}
const $f46e6a02d365fb97$var$WARN_MESSAGE = `Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`;
function $f46e6a02d365fb97$var$checkHtmlMessage(source, warnHtmlMessage) {
    if (warnHtmlMessage && (0, $9e75e8a260101339$export$6de85467cbd6ae39)(source)) (0, $73e90664ed51b607$export$c106dd0671a0fc2d)((0, $73e90664ed51b607$export$d9468344d3651243)($f46e6a02d365fb97$var$WARN_MESSAGE, {
        source: source
    }));
}
const $f46e6a02d365fb97$var$defaultOnCacheKey = (message)=>message;
let $f46e6a02d365fb97$var$compileCache = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
function $f46e6a02d365fb97$var$onCompileWarn(_warn) {
    if (_warn.code === (0, $9e75e8a260101339$export$21499b937901db8a).USE_MODULO_SYNTAX) (0, $73e90664ed51b607$export$c106dd0671a0fc2d)(`The use of named interpolation with modulo syntax is deprecated. ` + `It will be removed in v10.\n` + `reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format \n` + `(message compiler warning message: ${_warn.message})`);
}
function $f46e6a02d365fb97$export$2683c80ae3fe544() {
    $f46e6a02d365fb97$var$compileCache = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
}
function $f46e6a02d365fb97$var$baseCompile(message, options = {}) {
    // error detecting on compile
    let detectError = false;
    const onError = options.onError || (0, $9e75e8a260101339$export$ad0eb2c702f03471);
    options.onError = (err)=>{
        detectError = true;
        onError(err);
    };
    // compile with mesasge-compiler
    return {
        ...(0, $9e75e8a260101339$export$3243579822c486a0)(message, options),
        detectError: detectError
    };
}
/* #__NO_SIDE_EFFECTS__ */ const $f46e6a02d365fb97$export$1ea8807c727891fc = (message, context)=>{
    if (!(0, $73e90664ed51b607$export$844ec244b1367d54)(message)) throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE);
    {
        // check HTML message
        const warnHtmlMessage = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $f46e6a02d365fb97$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $f46e6a02d365fb97$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile
        const { code: code, detectError: detectError } = $f46e6a02d365fb97$var$baseCompile(message, context);
        // evaluate function
        const msg = new Function(`return ${code}`)();
        // if occurred compile error, don't cache
        return !detectError ? $f46e6a02d365fb97$var$compileCache[cacheKey] = msg : msg;
    }
};
function $f46e6a02d365fb97$export$ef7acd7185315e22(message, context) {
    if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && (0, $73e90664ed51b607$export$844ec244b1367d54)(message)) {
        // check HTML message
        const warnHtmlMessage = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $f46e6a02d365fb97$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $f46e6a02d365fb97$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile with JIT mode
        const { ast: ast, detectError: detectError } = $f46e6a02d365fb97$var$baseCompile(message, {
            ...context,
            location: false,
            jit: true
        });
        // compose message function from AST
        const msg = $f46e6a02d365fb97$var$format(ast);
        // if occurred compile error, don't cache
        return !detectError ? $f46e6a02d365fb97$var$compileCache[cacheKey] = msg : msg;
    } else {
        // AST case (passed from bundler)
        const cacheKey = message.cacheKey;
        if (cacheKey) {
            const cached = $f46e6a02d365fb97$var$compileCache[cacheKey];
            if (cached) return cached;
            // compose message function from message (AST)
            return $f46e6a02d365fb97$var$compileCache[cacheKey] = $f46e6a02d365fb97$var$format(message);
        } else return $f46e6a02d365fb97$var$format(message);
    }
}
const $f46e6a02d365fb97$var$NOOP_MESSAGE_FUNCTION = ()=>"";
const $f46e6a02d365fb97$export$92c0a039cf358271 = (val)=>(0, $73e90664ed51b607$export$f6e2535fb5126e54)(val);
// implementation of `translate` function
function $f46e6a02d365fb97$export$d73ee8ef04f5226a(context, ...args) {
    const { fallbackFormat: fallbackFormat, postTranslation: postTranslation, unresolving: unresolving, messageCompiler: messageCompiler, fallbackLocale: fallbackLocale, messages: messages } = context;
    const [key, options] = $f46e6a02d365fb97$export$8d9616744e22681a(...args);
    const missingWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const escapeParameter = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = (0, $73e90664ed51b607$export$844ec244b1367d54)(options.default) || (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.default) // default by function option
     ? !(0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.default) ? options.default : !messageCompiler ? ()=>key : key : fallbackFormat // default by `fallbackFormat` option
     ? !messageCompiler ? ()=>key : key : "";
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
    const locale = $f46e6a02d365fb97$export$180605366c04f0cd(context, options);
    // escape params
    escapeParameter && $f46e6a02d365fb97$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage ? $f46e6a02d365fb97$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || (0, $73e90664ed51b607$export$185802fd694ee1f5)()
    ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage && !((0, $73e90664ed51b607$export$844ec244b1367d54)(format) || $f46e6a02d365fb97$export$9ba95744594b90e0(format) || $f46e6a02d365fb97$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $73e90664ed51b607$export$844ec244b1367d54)(format) || $f46e6a02d365fb97$export$9ba95744594b90e0(format) || $f46e6a02d365fb97$export$92c0a039cf358271(format)) || !(0, $73e90664ed51b607$export$844ec244b1367d54)(targetLocale))) return unresolving ? $f46e6a02d365fb97$export$b7f13a18d1d0f835 : key;
    // setup compile error detecting
    let occurred = false;
    const onError = ()=>{
        occurred = true;
    };
    // compile message format
    const msg = !$f46e6a02d365fb97$export$92c0a039cf358271(format) ? $f46e6a02d365fb97$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    const ctxOptions = $f46e6a02d365fb97$var$getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = $f46e6a02d365fb97$export$70de3b14beda2f5e(ctxOptions);
    const messaged = $f46e6a02d365fb97$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    let ret = postTranslation ? postTranslation(messaged, key) : messaged;
    // apply HTML sanitization for security
    if (escapeParameter && (0, $73e90664ed51b607$export$844ec244b1367d54)(ret)) ret = (0, $73e90664ed51b607$export$d27e3ef8781285da)(ret);
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: (0, $73e90664ed51b607$export$844ec244b1367d54)(key) ? key : $f46e6a02d365fb97$export$92c0a039cf358271(format) ? format.key : "",
            locale: targetLocale || ($f46e6a02d365fb97$export$92c0a039cf358271(format) ? format.locale : ""),
            format: (0, $73e90664ed51b607$export$844ec244b1367d54)(format) ? format : $f46e6a02d365fb97$export$92c0a039cf358271(format) ? format.source : "",
            message: ret
        };
        payloads.meta = (0, $73e90664ed51b607$export$e6e34fd1f2686227)({}, context.__meta, $f46e6a02d365fb97$export$817795a14e5c6622() || {});
        $f46e6a02d365fb97$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $f46e6a02d365fb97$var$escapeParams(options) {
    if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(options.list)) options.list = options.list.map((item)=>(0, $73e90664ed51b607$export$844ec244b1367d54)(item) ? (0, $73e90664ed51b607$export$4cf11838cdc2a8a8)(item) : item);
    else if ((0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(options.named)) Object.keys(options.named).forEach((key)=>{
        if ((0, $73e90664ed51b607$export$844ec244b1367d54)(options.named[key])) options.named[key] = (0, $73e90664ed51b607$export$4cf11838cdc2a8a8)(options.named[key]);
    });
}
function $f46e6a02d365fb97$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages: messages, onWarn: onWarn, messageResolver: resolveValue, localeFallbacker: localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "translate";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        message = messages[targetLocale] || (0, $73e90664ed51b607$export$185802fd694ee1f5)();
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        if ((0, $73e90664ed51b607$export$844ec244b1367d54)(format) || $f46e6a02d365fb97$export$9ba95744594b90e0(format) || $f46e6a02d365fb97$export$92c0a039cf358271(format)) break;
        if (!$f46e6a02d365fb97$export$d783301aca6271c3(targetLocale, locales)) {
            const missingRet = $f46e6a02d365fb97$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
            if (missingRet !== key) format = missingRet;
        }
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $f46e6a02d365fb97$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) {
    const { messageCompiler: messageCompiler, warnHtmlMessage: warnHtmlMessage } = context;
    if ($f46e6a02d365fb97$export$92c0a039cf358271(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = ()=>format;
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const msg = messageCompiler(format, $f46e6a02d365fb97$var$getCompileContext(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, onError));
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function $f46e6a02d365fb97$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const messaged = msg(msgCtx);
    return messaged;
}
/** @internal */ function $f46e6a02d365fb97$export$8d9616744e22681a(...args) {
    const [arg1, arg2, arg3] = args;
    const options = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    if (!(0, $73e90664ed51b607$export$844ec244b1367d54)(arg1) && !(0, $73e90664ed51b607$export$7e4aa119212bc614)(arg1) && !$f46e6a02d365fb97$export$92c0a039cf358271(arg1) && !$f46e6a02d365fb97$export$9ba95744594b90e0(arg1)) throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    const key = (0, $73e90664ed51b607$export$7e4aa119212bc614)(arg1) ? String(arg1) : $f46e6a02d365fb97$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $73e90664ed51b607$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
    else if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg2)) options.default = arg2;
    else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg2) && !(0, $73e90664ed51b607$export$83b788b1a3698c03)(arg2)) options.named = arg2;
    else if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(arg2)) options.list = arg2;
    if ((0, $73e90664ed51b607$export$7e4aa119212bc614)(arg3)) options.plural = arg3;
    else if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg3)) options.default = arg3;
    else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg3)) (0, $73e90664ed51b607$export$e6e34fd1f2686227)(options, arg3);
    return [
        key,
        options
    ];
}
function $f46e6a02d365fb97$var$getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
    return {
        locale: locale,
        key: key,
        warnHtmlMessage: warnHtmlMessage,
        onError: (err)=>{
            onError && onError(err);
            throw err;
        },
        onCacheKey: (source)=>(0, $73e90664ed51b607$export$5024ef1f92c9a364)(locale, key, source)
    };
}
function $f46e6a02d365fb97$var$getSourceForCodeFrame(source) {
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(source)) return source;
    else {
        if (source.loc && source.loc.source) return source.loc.source;
    }
}
function $f46e6a02d365fb97$var$getMessageContextOptions(context, locale, message, options) {
    const { modifiers: modifiers, pluralRules: pluralRules, messageResolver: resolveValue, fallbackLocale: fallbackLocale, fallbackWarn: fallbackWarn, missingWarn: missingWarn, fallbackContext: fallbackContext } = context;
    const resolveMessage = (key)=>{
        let val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            const [, , message] = $f46e6a02d365fb97$var$resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if ((0, $73e90664ed51b607$export$844ec244b1367d54)(val) || $f46e6a02d365fb97$export$9ba95744594b90e0(val)) {
            let occurred = false;
            const onError = ()=>{
                occurred = true;
            };
            const msg = $f46e6a02d365fb97$var$compileMessageFormat(context, key, locale, val, key, onError);
            return !occurred ? msg : $f46e6a02d365fb97$var$NOOP_MESSAGE_FUNCTION;
        } else if ($f46e6a02d365fb97$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $f46e6a02d365fb97$var$NOOP_MESSAGE_FUNCTION;
    };
    const ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $73e90664ed51b607$export$7e4aa119212bc614)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
const $f46e6a02d365fb97$var$intlDefined = typeof Intl !== "undefined";
const $f46e6a02d365fb97$var$Availabilities = {
    dateTimeFormat: $f46e6a02d365fb97$var$intlDefined && typeof Intl.DateTimeFormat !== "undefined",
    numberFormat: $f46e6a02d365fb97$var$intlDefined && typeof Intl.NumberFormat !== "undefined"
};
// implementation of `datetime` function
function $f46e6a02d365fb97$export$7ba4466dbd0f07e1(context, ...args) {
    const { datetimeFormats: datetimeFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __datetimeFormatters: __datetimeFormatters } = context;
    const [key, value, options, overrides] = $f46e6a02d365fb97$export$165524b21a0d6b5e(...args);
    const missingWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $f46e6a02d365fb97$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $73e90664ed51b607$export$844ec244b1367d54)(key) || key === "") return new Intl.DateTimeFormat(locale, overrides).format(value);
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "datetime format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(format)) break;
        $f46e6a02d365fb97$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $73e90664ed51b607$export$53b83ca8eaab0383)(format) || !(0, $73e90664ed51b607$export$844ec244b1367d54)(targetLocale)) return unresolving ? $f46e6a02d365fb97$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $73e90664ed51b607$export$83b788b1a3698c03)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $73e90664ed51b607$export$e6e34fd1f2686227)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $f46e6a02d365fb97$export$c77049eaf05b1508 = [
    "localeMatcher",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "formatMatcher",
    "hour12",
    "timeZone",
    "dateStyle",
    "timeStyle",
    "calendar",
    "dayPeriod",
    "numberingSystem",
    "hourCycle",
    "fractionalSecondDigits"
];
/** @internal */ function $f46e6a02d365fb97$export$165524b21a0d6b5e(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    let overrides = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    let value;
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3] ? matches[3].trim().startsWith("T") ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch (e) {
            throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $73e90664ed51b607$export$871608497c498473)(arg1)) {
        if (isNaN(arg1.getTime())) throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $73e90664ed51b607$export$7e4aa119212bc614)(arg1)) value = arg1;
    else throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($f46e6a02d365fb97$export$c77049eaf05b1508.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $f46e6a02d365fb97$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $f46e6a02d365fb97$export$98e628dec113755e(context, ...args) {
    const { numberFormats: numberFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __numberFormatters: __numberFormatters } = context;
    const [key, value, options, overrides] = $f46e6a02d365fb97$export$d0e2eec8b686cf72(...args);
    const missingWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $f46e6a02d365fb97$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $73e90664ed51b607$export$844ec244b1367d54)(key) || key === "") return new Intl.NumberFormat(locale, overrides).format(value);
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "number format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(format)) break;
        $f46e6a02d365fb97$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $73e90664ed51b607$export$53b83ca8eaab0383)(format) || !(0, $73e90664ed51b607$export$844ec244b1367d54)(targetLocale)) return unresolving ? $f46e6a02d365fb97$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $73e90664ed51b607$export$83b788b1a3698c03)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $73e90664ed51b607$export$e6e34fd1f2686227)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $f46e6a02d365fb97$export$c39a7c3789c46ed6 = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "currencySign",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "roundingMode",
    "roundingPriority",
    "roundingIncrement",
    "trailingZeroDisplay"
];
/** @internal */ function $f46e6a02d365fb97$export$d0e2eec8b686cf72(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    let overrides = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    if (!(0, $73e90664ed51b607$export$7e4aa119212bc614)(arg1)) throw $f46e6a02d365fb97$export$3d702f7ac45b0a6b($f46e6a02d365fb97$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    const value = arg1;
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($f46e6a02d365fb97$export$c39a7c3789c46ed6.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $f46e6a02d365fb97$export$6a8717b3043a4f23(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
$f46e6a02d365fb97$var$initFeatureFlags();


parcelRequire("a38K9");
var $g90JB = parcelRequire("g90JB");
var $8zRru = parcelRequire("8zRru");
function $9861819e8e9c0154$export$5a2d366b2d9f38f6() {
    return $9861819e8e9c0154$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $9861819e8e9c0154$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const $9861819e8e9c0154$export$bc32a04c49ed7464 = typeof Proxy === "function";


const $460d7366241c791c$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $460d7366241c791c$export$a0897f44accbe922 = "plugin:settings:set";



let $718b5c7ceee689b2$var$supported;
let $718b5c7ceee689b2$var$perf;
function $718b5c7ceee689b2$export$70d26280bc1ca547() {
    var _a;
    if ($718b5c7ceee689b2$var$supported !== undefined) return $718b5c7ceee689b2$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $718b5c7ceee689b2$var$supported = true;
        $718b5c7ceee689b2$var$perf = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $718b5c7ceee689b2$var$supported = true;
        $718b5c7ceee689b2$var$perf = globalThis.perf_hooks.performance;
    } else $718b5c7ceee689b2$var$supported = false;
    return $718b5c7ceee689b2$var$supported;
}
function $718b5c7ceee689b2$export$461939dd4422153() {
    return $718b5c7ceee689b2$export$70d26280bc1ca547() ? $718b5c7ceee689b2$var$perf.now() : Date.now();
}


class $2b830a23ed434189$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $718b5c7ceee689b2$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $460d7366241c791c$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}





function $b25fb7fa660e1e93$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $9861819e8e9c0154$export$c22522a4dfa48e9c)();
    const hook = (0, $9861819e8e9c0154$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $9861819e8e9c0154$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $460d7366241c791c$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $2b830a23ed434189$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ const $4d6f230e440a3770$export$a4ad2735b021c132 = "9.14.5";
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $4d6f230e440a3770$var$initFeatureFlags() {
    if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)().__VUE_I18N_FULL_INSTALL__ = true;
    if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)().__VUE_I18N_LEGACY_API__ = true;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
}
const $4d6f230e440a3770$var$code$1 = (0, $f46e6a02d365fb97$export$b6a676a18b27d4c8).__EXTEND_POINT__;
const $4d6f230e440a3770$var$inc$1 = (0, $73e90664ed51b607$export$47db5deb603dfca1)($4d6f230e440a3770$var$code$1);
const $4d6f230e440a3770$var$I18nWarnCodes = {
    FALLBACK_TO_ROOT: $4d6f230e440a3770$var$code$1,
    NOT_SUPPORTED_PRESERVE: $4d6f230e440a3770$var$inc$1(),
    NOT_SUPPORTED_FORMATTER: $4d6f230e440a3770$var$inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: $4d6f230e440a3770$var$inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: $4d6f230e440a3770$var$inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: $4d6f230e440a3770$var$inc$1(),
    NOT_FOUND_PARENT_SCOPE: $4d6f230e440a3770$var$inc$1(),
    IGNORE_OBJ_FLATTEN: $4d6f230e440a3770$var$inc$1(),
    NOTICE_DROP_ALLOW_COMPOSITION: $4d6f230e440a3770$var$inc$1(),
    NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: $4d6f230e440a3770$var$inc$1() // 18
};
const $4d6f230e440a3770$var$warnMessages = {
    [$4d6f230e440a3770$var$I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [$4d6f230e440a3770$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE]: `Not supported 'preserve'.`,
    [$4d6f230e440a3770$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER]: `Not supported 'formatter'.`,
    [$4d6f230e440a3770$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: `Not supported 'preserveDirectiveContent'.`,
    [$4d6f230e440a3770$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX]: `Not supported 'getChoiceIndex'.`,
    [$4d6f230e440a3770$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE]: `Component name legacy compatible: '{name}' -> 'i18n'`,
    [$4d6f230e440a3770$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`,
    [$4d6f230e440a3770$var$I18nWarnCodes.IGNORE_OBJ_FLATTEN]: `Ignore object flatten: '{key}' key has an string value`,
    [$4d6f230e440a3770$var$I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION]: `'allowComposition' option will be dropped in the next major version. For more information, please see \u{1F449} https://tinyurl.com/2p97mcze`,
    [$4d6f230e440a3770$var$I18nWarnCodes.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: `'translateExistCompatible' option will be dropped in the next major version.`
};
function $4d6f230e440a3770$var$getWarnMessage(code, ...args) {
    return (0, $73e90664ed51b607$export$d9468344d3651243)($4d6f230e440a3770$var$warnMessages[code], ...args);
}
const $4d6f230e440a3770$var$code = (0, $f46e6a02d365fb97$export$1d4dfd6045c40277).__EXTEND_POINT__;
const $4d6f230e440a3770$var$inc = (0, $73e90664ed51b607$export$47db5deb603dfca1)($4d6f230e440a3770$var$code);
const $4d6f230e440a3770$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $4d6f230e440a3770$var$code,
    // legacy module errors
    INVALID_ARGUMENT: $4d6f230e440a3770$var$inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: $4d6f230e440a3770$var$inc(),
    NOT_INSTALLED: $4d6f230e440a3770$var$inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: $4d6f230e440a3770$var$inc(),
    // directive module errors
    REQUIRED_VALUE: $4d6f230e440a3770$var$inc(),
    INVALID_VALUE: $4d6f230e440a3770$var$inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: $4d6f230e440a3770$var$inc(),
    NOT_INSTALLED_WITH_PROVIDE: $4d6f230e440a3770$var$inc(),
    // unexpected error
    UNEXPECTED_ERROR: $4d6f230e440a3770$var$inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: $4d6f230e440a3770$var$inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: $4d6f230e440a3770$var$inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: $4d6f230e440a3770$var$inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: $4d6f230e440a3770$var$inc(),
    // for enhancement
    __EXTEND_POINT__: $4d6f230e440a3770$var$inc() // 38
};
function $4d6f230e440a3770$var$createI18nError(code, ...args) {
    return (0, $9e75e8a260101339$export$21efa8bb37d5fecb)(code, null, undefined);
}
const $4d6f230e440a3770$var$errorMessages = {
    [$4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
    [$4d6f230e440a3770$var$I18nErrorCodes.INVALID_ARGUMENT]: "Invalid argument",
    [$4d6f230e440a3770$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
    [$4d6f230e440a3770$var$I18nErrorCodes.NOT_INSTALLED]: "Need to install with `app.use` function",
    [$4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_ERROR]: "Unexpected error",
    [$4d6f230e440a3770$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
    [$4d6f230e440a3770$var$I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [$4d6f230e440a3770$var$I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [$4d6f230e440a3770$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [$4d6f230e440a3770$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
    [$4d6f230e440a3770$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
    [$4d6f230e440a3770$var$I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
    [$4d6f230e440a3770$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define \u2018i18n\u2019 option or custom block in Composition API with using local scope in Legacy API mode",
    [$4d6f230e440a3770$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
};
const $4d6f230e440a3770$var$TranslateVNodeSymbol = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("__translateVNode");
const $4d6f230e440a3770$var$DatetimePartsSymbol = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("__datetimeParts");
const $4d6f230e440a3770$var$NumberPartsSymbol = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("__numberParts");
const $4d6f230e440a3770$var$EnableEmitter = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("__enableEmitter");
const $4d6f230e440a3770$var$DisableEmitter = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("__disableEmitter");
const $4d6f230e440a3770$var$SetPluralRulesSymbol = (0, $73e90664ed51b607$export$cd133c5e04906ece)("__setPluralRules");
(0, $73e90664ed51b607$export$cd133c5e04906ece)("__intlifyMeta");
const $4d6f230e440a3770$var$InejctWithOptionSymbol = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("__injectWithOption");
const $4d6f230e440a3770$var$DisposeSymbol = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("__dispose");
const $4d6f230e440a3770$var$__VUE_I18N_BRIDGE__ = "__VUE_I18N_BRIDGE__";
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $4d6f230e440a3770$var$handleFlatJson(obj) {
    // check obj
    if (!(0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(obj)) return obj;
    if ((0, $f46e6a02d365fb97$export$9ba95744594b90e0)(obj)) return obj;
    for(const key in obj){
        // check key
        if (!(0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(obj, key)) continue;
        // handle for normal json
        if (!key.includes(".")) // recursive process value if value is also a object
        {
            if ((0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(obj[key])) $4d6f230e440a3770$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            const subKeys = key.split(".");
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            let hasStringValue = false;
            for(let i = 0; i < lastIndex; i++){
                if (subKeys[i] === "__proto__") throw new Error(`unsafe key: ${subKeys[i]}`);
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
                if (!(0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(currentObj[subKeys[i]])) {
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                if (!(0, $f46e6a02d365fb97$export$9ba95744594b90e0)(currentObj)) {
                    currentObj[subKeys[lastIndex]] = obj[key];
                    delete obj[key];
                } else /**
                     * NOTE:
                     * if the last object is a message AST and subKeys[lastIndex] has message AST prop key, ignore to copy and key deletion
                     */ if (!(0, $f46e6a02d365fb97$export$cc9169d6f60edf74).includes(subKeys[lastIndex])) delete obj[key];
            }
            // recursive process value if value is also a object
            if (!(0, $f46e6a02d365fb97$export$9ba95744594b90e0)(currentObj)) {
                const target = currentObj[subKeys[lastIndex]];
                if ((0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(target)) $4d6f230e440a3770$var$handleFlatJson(target);
            }
        }
    }
    return obj;
}
function $4d6f230e440a3770$var$getLocaleMessages(locale, options) {
    const { messages: messages, __i18n: __i18n, messageResolver: messageResolver, flatJson: flatJson } = options;
    // prettier-ignore
    const ret = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(messages) ? messages : (0, $73e90664ed51b607$export$43bee75e5e14138e)(__i18n) ? (0, $73e90664ed51b607$export$185802fd694ee1f5)() : {
        [locale]: (0, $73e90664ed51b607$export$185802fd694ee1f5)()
    };
    // merge locale messages of i18n custom block
    if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(__i18n)) __i18n.forEach((custom)=>{
        if ("locale" in custom && "resource" in custom) {
            const { locale: locale, resource: resource } = custom;
            if (locale) {
                ret[locale] = ret[locale] || (0, $73e90664ed51b607$export$185802fd694ee1f5)();
                (0, $73e90664ed51b607$export$6c40052bed430212)(resource, ret[locale]);
            } else (0, $73e90664ed51b607$export$6c40052bed430212)(resource, ret);
        } else (0, $73e90664ed51b607$export$844ec244b1367d54)(custom) && (0, $73e90664ed51b607$export$6c40052bed430212)(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(const key in ret)if ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(ret, key)) $4d6f230e440a3770$var$handleFlatJson(ret[key]);
    }
    return ret;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4d6f230e440a3770$var$getComponentOptions(instance) {
    return instance.type;
}
function $4d6f230e440a3770$var$adjustI18nResources(gl, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    let messages = (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(options.messages) ? options.messages : (0, $73e90664ed51b607$export$185802fd694ee1f5)();
    if ("__i18nGlobal" in componentOptions) messages = $4d6f230e440a3770$var$getLocaleMessages(gl.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) locales.forEach((locale)=>{
        gl.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ((0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(options.datetimeFormats)) {
        const locales = Object.keys(options.datetimeFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ((0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(options.numberFormats)) {
        const locales = Object.keys(options.numberFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $4d6f230e440a3770$var$createTextNode(key) {
    return (0, $8zRru.createVNode)((0, $8zRru.Text), null, key, 0);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ // extend VNode interface
const $4d6f230e440a3770$var$DEVTOOLS_META = "__INTLIFY_META__";
const $4d6f230e440a3770$var$NOOP_RETURN_ARRAY = ()=>[];
const $4d6f230e440a3770$var$NOOP_RETURN_FALSE = ()=>false;
let $4d6f230e440a3770$var$composerID = 0;
function $4d6f230e440a3770$var$defineCoreMissingHandler(missing) {
    return (ctx, locale, key, type)=>{
        return missing(locale, key, (0, $8zRru.getCurrentInstance)() || undefined, type);
    };
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */ const $4d6f230e440a3770$var$getMetaInfo = ()=>{
    const instance = (0, $8zRru.getCurrentInstance)();
    let meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = $4d6f230e440a3770$var$getComponentOptions(instance)[$4d6f230e440a3770$var$DEVTOOLS_META]) ? {
        [$4d6f230e440a3770$var$DEVTOOLS_META]: meta
    } // eslint-disable-line @typescript-eslint/no-explicit-any
     : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $4d6f230e440a3770$var$createComposer(options = {}, VueI18nLegacy) {
    const { __root: __root, __injectWithOption: __injectWithOption } = options;
    const _isGlobal = __root === undefined;
    const flatJson = options.flatJson;
    const _ref = (0, $73e90664ed51b607$export$620a268685f0ac45) ? (0, $g90JB.ref) : (0, $g90JB.shallowRef);
    const translateExistCompatible = !!options.translateExistCompatible;
    let _inheritLocale = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : true;
    const _locale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : (0, $73e90664ed51b607$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $f46e6a02d365fb97$export$1af4c7e47ad72f44));
    const _fallbackLocale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : (0, $73e90664ed51b607$export$844ec244b1367d54)(options.fallbackLocale) || (0, $73e90664ed51b607$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = _ref($4d6f230e440a3770$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = _ref((0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = _ref((0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root ? __root.missingWarn : (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $73e90664ed51b607$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    let _fallbackWarn = __root ? __root.fallbackWarn : (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $73e90664ed51b607$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    let _fallbackRoot = __root ? __root.fallbackRoot : (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    let _runtimeMissing = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.missing) ? $4d6f230e440a3770$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    let _postTranslation = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    let _warnHtmlMessage = __root ? __root.warnHtmlMessage : (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root ? __root.modifiers : (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    let _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = ()=>{
        _isGlobal && (0, $f46e6a02d365fb97$export$e16aca6786e72a5e)(null);
        const ctxOptions = {
            version: $4d6f230e440a3770$export$a4ad2735b021c132,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: {
                framework: "vue"
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(_context) ? _context.__numberFormatters : undefined;
        const ctx = (0, $f46e6a02d365fb97$export$3599d465b05a74a5)(ctxOptions);
        _isGlobal && (0, $f46e6a02d365fb97$export$e16aca6786e72a5e)(ctx);
        return ctx;
    };
    _context = getCoreContext();
    (0, $f46e6a02d365fb97$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $g90JB.computed)({
        get: ()=>_locale.value,
        set: (val1)=>{
            _locale.value = val1;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $g90JB.computed)({
        get: ()=>_fallbackLocale.value,
        set: (val1)=>{
            _fallbackLocale.value = val1;
            _context.fallbackLocale = _fallbackLocale.value;
            (0, $f46e6a02d365fb97$export$c743ad8a3cc01530)(_context, _locale.value, val1);
        }
    });
    // messages
    const messages = (0, $g90JB.computed)(()=>_messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ (0, $g90JB.computed)(()=>_datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ (0, $g90JB.computed)(()=>_numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return (0, $73e90664ed51b607$export$f6e2535fb5126e54)(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $4d6f230e440a3770$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== "translate" || !arg.resolvedMessage;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition)=>{
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        try {
            if (__INTLIFY_PROD_DEVTOOLS__) (0, $f46e6a02d365fb97$export$605703447dca72aa)($4d6f230e440a3770$var$getMetaInfo());
            if (!_isGlobal) _context.fallbackContext = __root ? (0, $f46e6a02d365fb97$export$3adddc434faa9e35)() : undefined;
            ret = fn(_context);
        } finally{
            if (__INTLIFY_PROD_DEVTOOLS__) (0, $f46e6a02d365fb97$export$605703447dca72aa)(null);
            if (!_isGlobal) _context.fallbackContext = undefined;
        }
        if (warnType !== "translate exists" && // for not `te` (e.g `t`)
        (0, $73e90664ed51b607$export$7e4aa119212bc614)(ret) && ret === (0, $f46e6a02d365fb97$export$b7f13a18d1d0f835) || warnType === "translate exists" && !ret // for `te`
        ) {
            const [key, arg2] = argumentParser();
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    };
    // t
    function t(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f46e6a02d365fb97$export$d73ee8ef04f5226a), null, [
                context,
                ...args
            ]), ()=>(0, $f46e6a02d365fb97$export$8d9616744e22681a)(...args), "translate", (root)=>Reflect.apply(root.t, root, [
                ...args
            ]), (key)=>key, (val1)=>(0, $73e90664ed51b607$export$844ec244b1367d54)(val1));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !(0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(arg3)) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t(...[
            arg1,
            arg2,
            (0, $73e90664ed51b607$export$e6e34fd1f2686227)({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    }
    // d
    function d(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f46e6a02d365fb97$export$7ba4466dbd0f07e1), null, [
                context,
                ...args
            ]), ()=>(0, $f46e6a02d365fb97$export$165524b21a0d6b5e)(...args), "datetime format", (root)=>Reflect.apply(root.d, root, [
                ...args
            ]), ()=>(0, $f46e6a02d365fb97$export$a04371e9dbb3870b), (val1)=>(0, $73e90664ed51b607$export$844ec244b1367d54)(val1));
    }
    // n
    function n(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f46e6a02d365fb97$export$98e628dec113755e), null, [
                context,
                ...args
            ]), ()=>(0, $f46e6a02d365fb97$export$d0e2eec8b686cf72)(...args), "number format", (root)=>Reflect.apply(root.n, root, [
                ...args
            ]), ()=>(0, $f46e6a02d365fb97$export$a04371e9dbb3870b), (val1)=>(0, $73e90664ed51b607$export$844ec244b1367d54)(val1));
    }
    // for custom processor
    function normalize(values) {
        return values.map((val1)=>(0, $73e90664ed51b607$export$844ec244b1367d54)(val1) || (0, $73e90664ed51b607$export$7e4aa119212bc614)(val1) || (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(val1) ? $4d6f230e440a3770$var$createTextNode(String(val1)) : val1);
    }
    const interpolate = (val1)=>val1;
    const processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: "vnode"
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode(...args) {
        return wrapWithDeps((context)=>{
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply((0, $f46e6a02d365fb97$export$d73ee8ef04f5226a), null, [
                    _context,
                    ...args
                ]);
            } finally{
                _context.processor = null;
            }
            return ret;
        }, ()=>(0, $f46e6a02d365fb97$export$8d9616744e22681a)(...args), "translate", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$4d6f230e440a3770$var$TranslateVNodeSymbol](...args), (key)=>[
                $4d6f230e440a3770$var$createTextNode(key)
            ], (val1)=>(0, $73e90664ed51b607$export$43bee75e5e14138e)(val1));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f46e6a02d365fb97$export$98e628dec113755e), null, [
                context,
                ...args
            ]), ()=>(0, $f46e6a02d365fb97$export$d0e2eec8b686cf72)(...args), "number format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$4d6f230e440a3770$var$NumberPartsSymbol](...args), $4d6f230e440a3770$var$NOOP_RETURN_ARRAY, (val1)=>(0, $73e90664ed51b607$export$844ec244b1367d54)(val1) || (0, $73e90664ed51b607$export$43bee75e5e14138e)(val1));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f46e6a02d365fb97$export$7ba4466dbd0f07e1), null, [
                context,
                ...args
            ]), ()=>(0, $f46e6a02d365fb97$export$165524b21a0d6b5e)(...args), "datetime format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$4d6f230e440a3770$var$DatetimePartsSymbol](...args), $4d6f230e440a3770$var$NOOP_RETURN_ARRAY, (val1)=>(0, $73e90664ed51b607$export$844ec244b1367d54)(val1) || (0, $73e90664ed51b607$export$43bee75e5e14138e)(val1));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(()=>{
            if (!key) return false;
            const targetLocale = (0, $73e90664ed51b607$export$844ec244b1367d54)(locale) ? locale : _locale.value;
            const message = getLocaleMessage(targetLocale);
            const resolved = _context.messageResolver(message, key);
            return !translateExistCompatible ? (0, $f46e6a02d365fb97$export$9ba95744594b90e0)(resolved) || (0, $f46e6a02d365fb97$export$92c0a039cf358271)(resolved) || (0, $73e90664ed51b607$export$844ec244b1367d54)(resolved) : resolved != null;
        }, ()=>[
                key
            ], "translate exists", (root)=>{
            return Reflect.apply(root.te, root, [
                key,
                locale
            ]);
        }, $4d6f230e440a3770$var$NOOP_RETURN_FALSE, (val1)=>(0, $73e90664ed51b607$export$f9ce7b637dfbe238)(val1));
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = (0, $f46e6a02d365fb97$export$71df9db82dc445)(_context, _fallbackLocale.value, _locale.value);
        for(let i = 0; i < locales.length; i++){
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        if (flatJson) {
            const _message = {
                [locale]: message
            };
            for(const key in _message)if ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(_message, key)) $4d6f230e440a3770$var$handleFlatJson(_message[key]);
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        const _message = {
            [locale]: message
        };
        if (flatJson) {
            for(const key in _message)if ((0, $73e90664ed51b607$export$b5a638e9b3fff9f3)(_message, key)) $4d6f230e440a3770$var$handleFlatJson(_message[key]);
        }
        message = _message[locale];
        (0, $73e90664ed51b607$export$6c40052bed430212)(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $f46e6a02d365fb97$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = (0, $73e90664ed51b607$export$e6e34fd1f2686227)(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $f46e6a02d365fb97$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        (0, $f46e6a02d365fb97$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = (0, $73e90664ed51b607$export$e6e34fd1f2686227)(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        (0, $f46e6a02d365fb97$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // for debug
    $4d6f230e440a3770$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root && (0, $73e90664ed51b607$export$620a268685f0ac45)) {
        (0, $g90JB.watch)(__root.locale, (val1)=>{
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                (0, $f46e6a02d365fb97$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0, $g90JB.watch)(__root.fallbackLocale, (val1)=>{
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                (0, $f46e6a02d365fb97$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: $4d6f230e440a3770$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                (0, $f46e6a02d365fb97$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        [$4d6f230e440a3770$var$SetPluralRulesSymbol]: setPluralRules
    };
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$4d6f230e440a3770$var$InejctWithOptionSymbol] = __injectWithOption;
    composer[$4d6f230e440a3770$var$TranslateVNodeSymbol] = translateVNode;
    composer[$4d6f230e440a3770$var$DatetimePartsSymbol] = datetimeParts;
    composer[$4d6f230e440a3770$var$NumberPartsSymbol] = numberParts;
    var emitter;
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $4d6f230e440a3770$var$convertComposerOptions(options) {
    const locale = (0, $73e90664ed51b607$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $f46e6a02d365fb97$export$1af4c7e47ad72f44);
    const fallbackLocale = (0, $73e90664ed51b607$export$844ec244b1367d54)(options.fallbackLocale) || (0, $73e90664ed51b607$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    const missing = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.missing) ? options.missing : undefined;
    const missingWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.silentTranslationWarn) || (0, $73e90664ed51b607$export$49841c62b9eff15)(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    const fallbackWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.silentFallbackWarn) || (0, $73e90664ed51b607$export$49841c62b9eff15)(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    const fallbackRoot = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : undefined;
    const warnHtmlMessage = (0, $73e90664ed51b607$export$844ec244b1367d54)(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.sync) ? options.sync : true;
    let messages = options.messages;
    if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale)=>{
            const message = messages[locale] || (messages[locale] = {});
            (0, $73e90664ed51b607$export$e6e34fd1f2686227)(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    const { __i18n: __i18n, __root: __root, __injectWithOption: __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    const translateExistCompatible = options.translateExistCompatible;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        translateExistCompatible: translateExistCompatible,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $4d6f230e440a3770$var$createVueI18n(options = {}, VueI18nLegacy) {
    {
        const composer = $4d6f230e440a3770$var$createComposer($4d6f230e440a3770$var$convertComposerOptions(options));
        const { __extender: __extender } = options;
        // defines VueI18n
        const vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale () {
                return composer.locale.value;
            },
            set locale (val){
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale () {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale (val){
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages () {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats () {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats () {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales () {
                return composer.availableLocales;
            },
            // formatter
            get formatter () {
                // dummy
                return {
                    interpolate () {
                        return [];
                    }
                };
            },
            set formatter (val){},
            // missing
            get missing () {
                return composer.getMissingHandler();
            },
            set missing (handler){
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn () {
                return (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
            },
            set silentTranslationWarn (val){
                composer.missingWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn () {
                return (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
            },
            set silentFallbackWarn (val){
                composer.fallbackWarn = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // modifiers
            get modifiers () {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages () {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages (val){
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation () {
                return composer.getPostTranslationHandler();
            },
            set postTranslation (handler){
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync () {
                return composer.inheritLocale;
            },
            set sync (val){
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage () {
                return composer.warnHtmlMessage ? "warn" : "off";
            },
            set warnHtmlInMessage (val){
                composer.warnHtmlMessage = val !== "off";
            },
            // escapeParameterHtml
            get escapeParameterHtml () {
                return composer.escapeParameter;
            },
            set escapeParameterHtml (val){
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent () {
                return true;
            },
            set preserveDirectiveContent (val){},
            // pluralizationRules
            get pluralizationRules () {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {};
                let list = null;
                let named = null;
                if (!(0, $73e90664ed51b607$export$844ec244b1367d54)(arg1)) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            rt (...args) {
                return Reflect.apply(composer.rt, composer, [
                    ...args
                ]);
            },
            // tc
            tc (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {
                    plural: 1
                };
                let list = null;
                let named = null;
                if (!(0, $73e90664ed51b607$export$844ec244b1367d54)(arg1)) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $73e90664ed51b607$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
                else if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $73e90664ed51b607$export$844ec244b1367d54)(arg3)) options.locale = arg3;
                else if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            // te
            te (key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm (key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage (locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage (locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage (locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d (...args) {
                return Reflect.apply(composer.d, composer, [
                    ...args
                ]);
            },
            // getDateTimeFormat
            getDateTimeFormat (locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat (locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat (locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n (...args) {
                return Reflect.apply(composer.n, composer, [
                    ...args
                ]);
            },
            // getNumberFormat
            getNumberFormat (locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat (locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat (locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex (choice, choicesLength) {
                return -1;
            }
        };
        vueI18n.__extender = __extender;
        var emitter;
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */ const $4d6f230e440a3770$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val1 /* ComponentI18nScope */ )=>val1 === "parent" || val1 === "global",
        default: "parent" /* ComponentI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
function $4d6f230e440a3770$var$getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots: slots }, keys) {
    if (keys.length === 1 && keys[0] === "default") {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current)=>{
            return [
                ...slot,
                // prettier-ignore
                ...current.type === (0, $8zRru.Fragment) ? current.children : [
                    current
                ]
            ];
        }, []);
    } else // named slots
    return keys.reduce((arg, key)=>{
        const slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, (0, $73e90664ed51b607$export$185802fd694ee1f5)());
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4d6f230e440a3770$var$getFragmentableTag(tag) {
    return 0, $8zRru.Fragment;
}
const $4d6f230e440a3770$var$TranslationImpl = /*#__PURE__*/ (0, $8zRru.defineComponent)({
    /* eslint-disable */ name: "i18n-t",
    props: (0, $73e90664ed51b607$export$e6e34fd1f2686227)({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: (val1)=>(0, $73e90664ed51b607$export$7e4aa119212bc614)(val1) || !isNaN(val1)
        }
    }, $4d6f230e440a3770$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const { slots: slots, attrs: attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n || $4d6f230e440a3770$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return ()=>{
            const keys = Object.keys(slots).filter((key)=>key !== "_");
            const options = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = (0, $73e90664ed51b607$export$844ec244b1367d54)(props.plural) ? +props.plural : props.plural;
            const arg = $4d6f230e440a3770$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[$4d6f230e440a3770$var$TranslateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = (0, $73e90664ed51b607$export$e6e34fd1f2686227)((0, $73e90664ed51b607$export$185802fd694ee1f5)(), attrs);
            const tag = (0, $73e90664ed51b607$export$844ec244b1367d54)(props.tag) || (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $4d6f230e440a3770$var$getFragmentableTag();
            return (0, $8zRru.h)(tag, assignedAttrs, children);
        };
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ const $4d6f230e440a3770$export$b63289fbda65eed1 = $4d6f230e440a3770$var$TranslationImpl;
const $4d6f230e440a3770$export$1d08de71ac06ffd6 = $4d6f230e440a3770$export$b63289fbda65eed1;
function $4d6f230e440a3770$var$isVNode(target) {
    return (0, $73e90664ed51b607$export$43bee75e5e14138e)(target) && !(0, $73e90664ed51b607$export$844ec244b1367d54)(target[0]);
}
function $4d6f230e440a3770$var$renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots: slots, attrs: attrs } = context;
    return ()=>{
        const options = {
            part: true
        };
        let overrides = (0, $73e90664ed51b607$export$185802fd694ee1f5)();
        if (props.locale) options.locale = props.locale;
        if ((0, $73e90664ed51b607$export$844ec244b1367d54)(props.format)) options.key = props.format;
        else if ((0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((0, $73e90664ed51b607$export$844ec244b1367d54)(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop)=>{
                return slotKeys.includes(prop) ? (0, $73e90664ed51b607$export$e6e34fd1f2686227)((0, $73e90664ed51b607$export$185802fd694ee1f5)(), options, {
                    [prop]: props.format[prop]
                }) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, (0, $73e90664ed51b607$export$185802fd694ee1f5)());
        }
        const parts = partFormatter(...[
            props.value,
            options,
            overrides
        ]);
        let children = [
            options.key
        ];
        if ((0, $73e90664ed51b607$export$43bee75e5e14138e)(parts)) children = parts.map((part, index)=>{
            const slot = slots[part.type];
            const node = slot ? slot({
                [part.type]: part.value,
                index: index,
                parts: parts
            }) : [
                part.value
            ];
            if ($4d6f230e440a3770$var$isVNode(node)) node[0].key = `${part.type}-${index}`;
            return node;
        });
        else if ((0, $73e90664ed51b607$export$844ec244b1367d54)(parts)) children = [
            parts
        ];
        const assignedAttrs = (0, $73e90664ed51b607$export$e6e34fd1f2686227)((0, $73e90664ed51b607$export$185802fd694ee1f5)(), attrs);
        const tag = (0, $73e90664ed51b607$export$844ec244b1367d54)(props.tag) || (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $4d6f230e440a3770$var$getFragmentableTag();
        return (0, $8zRru.h)(tag, assignedAttrs, children);
    };
}
const $4d6f230e440a3770$var$NumberFormatImpl = /*#__PURE__*/ (0, $8zRru.defineComponent)({
    /* eslint-disable */ name: "i18n-n",
    props: (0, $73e90664ed51b607$export$e6e34fd1f2686227)({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $4d6f230e440a3770$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $4d6f230e440a3770$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $4d6f230e440a3770$var$renderFormatter(props, context, (0, $f46e6a02d365fb97$export$c39a7c3789c46ed6), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$4d6f230e440a3770$var$NumberPartsSymbol](...args));
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ const $4d6f230e440a3770$export$27bce688931fdfcc = $4d6f230e440a3770$var$NumberFormatImpl;
const $4d6f230e440a3770$export$4665d24327644133 = $4d6f230e440a3770$export$27bce688931fdfcc;
const $4d6f230e440a3770$var$DatetimeFormatImpl = /* #__PURE__*/ (0, $8zRru.defineComponent)({
    /* eslint-disable */ name: "i18n-d",
    props: (0, $73e90664ed51b607$export$e6e34fd1f2686227)({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $4d6f230e440a3770$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $4d6f230e440a3770$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $4d6f230e440a3770$var$renderFormatter(props, context, (0, $f46e6a02d365fb97$export$c77049eaf05b1508), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$4d6f230e440a3770$var$DatetimePartsSymbol](...args));
    }
});
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ const $4d6f230e440a3770$export$64ca50867510e64e = $4d6f230e440a3770$var$DatetimeFormatImpl;
const $4d6f230e440a3770$export$c741260b89dcb234 = $4d6f230e440a3770$export$64ca50867510e64e;
function $4d6f230e440a3770$var$getComposer$2(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === "composition") return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
function $4d6f230e440a3770$export$8a5a05546006d0b5(i18n) {
    const _process = (binding)=>{
        const { instance: instance, modifiers: modifiers, value: value } = binding;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const composer = $4d6f230e440a3770$var$getComposer$2(i18n, instance.$);
        const parsedValue = $4d6f230e440a3770$var$parseValue(value);
        return [
            Reflect.apply(composer.t, composer, [
                ...$4d6f230e440a3770$var$makeParams(parsedValue)
            ]),
            composer
        ];
    };
    const register = (el, binding)=>{
        const [textContent, composer] = _process(binding);
        if ((0, $73e90664ed51b607$export$620a268685f0ac45) && i18n.global === composer) // global scope only
        el.__i18nWatcher = (0, $g90JB.watch)(composer.locale, ()=>{
            binding.instance && binding.instance.$forceUpdate();
        });
        el.__composer = composer;
        el.textContent = textContent;
    };
    const unregister = (el)=>{
        if ((0, $73e90664ed51b607$export$620a268685f0ac45) && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    const update = (el, { value: value })=>{
        if (el.__composer) {
            const composer = el.__composer;
            const parsedValue = $4d6f230e440a3770$var$parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, [
                ...$4d6f230e440a3770$var$makeParams(parsedValue)
            ]);
        }
    };
    const getSSRProps = (binding)=>{
        const [textContent] = _process(binding);
        return {
            textContent: textContent
        };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function $4d6f230e440a3770$var$parseValue(value) {
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(value)) return {
        path: value
    };
    else if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(value)) {
        if (!("path" in value)) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.REQUIRED_VALUE, "path");
        return value;
    } else throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.INVALID_VALUE);
}
function $4d6f230e440a3770$var$makeParams(value) {
    const { path: path, locale: locale, args: args, choice: choice, plural: plural } = value;
    const options = {};
    const named = args || {};
    if ((0, $73e90664ed51b607$export$844ec244b1367d54)(locale)) options.locale = locale;
    if ((0, $73e90664ed51b607$export$7e4aa119212bc614)(choice)) options.plural = choice;
    if ((0, $73e90664ed51b607$export$7e4aa119212bc614)(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $4d6f230e440a3770$var$apply(app, i18n, ...options) {
    const pluginOptions = (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options[0]) ? options[0] : {};
    const useI18nComponentName = !!pluginOptions.useI18nComponentName;
    const globalInstall = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall) {
        [
            !useI18nComponentName ? $4d6f230e440a3770$export$b63289fbda65eed1.name : "i18n",
            "I18nT"
        ].forEach((name)=>app.component(name, $4d6f230e440a3770$export$b63289fbda65eed1));
        [
            $4d6f230e440a3770$export$27bce688931fdfcc.name,
            "I18nN"
        ].forEach((name)=>app.component(name, $4d6f230e440a3770$export$27bce688931fdfcc));
        [
            $4d6f230e440a3770$export$64ca50867510e64e.name,
            "I18nD"
        ].forEach((name)=>app.component(name, $4d6f230e440a3770$export$64ca50867510e64e));
    }
    app.directive("t", $4d6f230e440a3770$export$8a5a05546006d0b5(i18n));
}
const $4d6f230e440a3770$var$VueDevToolsLabels = {
    ["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ]: "Vue I18n devtools",
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: "I18n Resources",
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: "Vue I18n"
};
const $4d6f230e440a3770$var$VueDevToolsPlaceholders = {
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: "Search for scopes ..."
};
const $4d6f230e440a3770$var$VueDevToolsTimelineColors = {
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: 0xffcd19
};
const $4d6f230e440a3770$var$VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties";
let $4d6f230e440a3770$var$devtoolsApi;
async function $4d6f230e440a3770$var$enableDevTools(app, i18n) {
    return new Promise((resolve, reject)=>{
        try {
            (0, $b25fb7fa660e1e93$export$63b9a9bba9f20f3e)({
                id: "vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ,
                label: $4d6f230e440a3770$var$VueDevToolsLabels["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ],
                packageName: "vue-i18n",
                homepage: "https://vue-i18n.intlify.dev",
                logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
                componentStateTypes: [
                    $4d6f230e440a3770$var$VUE_I18N_COMPONENT_TYPES
                ],
                app: app // eslint-disable-line @typescript-eslint/no-explicit-any
            }, (api)=>{
                $4d6f230e440a3770$var$devtoolsApi = api;
                api.on.visitComponentTree(({ componentInstance: componentInstance, treeNode: treeNode })=>{
                    $4d6f230e440a3770$var$updateComponentTreeTags(componentInstance, treeNode, i18n);
                });
                api.on.inspectComponent(({ componentInstance: componentInstance, instanceData: instanceData })=>{
                    if (componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData) {
                        if (i18n.mode === "legacy") // ignore global scope on legacy mode
                        {
                            if (componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer) $4d6f230e440a3770$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                        } else $4d6f230e440a3770$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                    }
                });
                api.addInspector({
                    id: "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ,
                    label: $4d6f230e440a3770$var$VueDevToolsLabels["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ],
                    icon: "language",
                    treeFilterPlaceholder: $4d6f230e440a3770$var$VueDevToolsPlaceholders["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]
                });
                api.on.getInspectorTree((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $4d6f230e440a3770$var$registerScope(payload, i18n);
                });
                const roots = new Map();
                api.on.getInspectorState(async (payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) {
                        api.unhighlightElement();
                        $4d6f230e440a3770$var$inspectScope(payload, i18n);
                        if (payload.nodeId === "global") {
                            if (!roots.has(payload.app)) {
                                const [root] = await api.getComponentInstances(payload.app);
                                roots.set(payload.app, root);
                            }
                            api.highlightElement(roots.get(payload.app));
                        } else {
                            const instance = $4d6f230e440a3770$var$getComponentInstance(payload.nodeId, i18n);
                            instance && api.highlightElement(instance);
                        }
                    }
                });
                api.on.editInspectorState((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $4d6f230e440a3770$var$editScope(payload, i18n);
                });
                api.addTimelineLayer({
                    id: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
                    label: $4d6f230e440a3770$var$VueDevToolsLabels["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ],
                    color: $4d6f230e440a3770$var$VueDevToolsTimelineColors["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]
                });
                resolve(true);
            });
        } catch (e) {
            console.error(e);
            reject(false);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4d6f230e440a3770$var$getI18nScopeLable(instance) {
    return instance.type.name || instance.type.displayName || instance.type.__file || "Anonymous";
}
function $4d6f230e440a3770$var$updateComponentTreeTags(instance, treeNode, i18n) {
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) // add custom tags local scope only
    {
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            const tag = {
                label: `i18n (${$4d6f230e440a3770$var$getI18nScopeLable(instance)} Scope)`,
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function $4d6f230e440a3770$var$inspectComposer(instanceData, composer) {
    const type = $4d6f230e440a3770$var$VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: "locale",
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: "availableLocales",
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: "fallbackLocale",
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: "inheritLocale",
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: "messages",
        editable: false,
        value: $4d6f230e440a3770$var$getLocaleMessageValue(composer.messages.value)
    });
    instanceData.state.push({
        type: type,
        key: "datetimeFormats",
        editable: false,
        value: composer.datetimeFormats.value
    });
    instanceData.state.push({
        type: type,
        key: "numberFormats",
        editable: false,
        value: composer.numberFormats.value
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4d6f230e440a3770$var$getLocaleMessageValue(messages) {
    const value = {};
    Object.keys(messages).forEach((key)=>{
        const v = messages[key];
        if ((0, $73e90664ed51b607$export$f6e2535fb5126e54)(v) && "source" in v) value[key] = $4d6f230e440a3770$var$getMessageFunctionDetails(v);
        else if ((0, $f46e6a02d365fb97$export$9ba95744594b90e0)(v) && v.loc && v.loc.source) value[key] = v.loc.source;
        else if ((0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(v)) value[key] = $4d6f230e440a3770$var$getLocaleMessageValue(v);
        else value[key] = v;
    });
    return value;
}
const $4d6f230e440a3770$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
function $4d6f230e440a3770$var$escape(s) {
    return s.replace(/[<>"&]/g, $4d6f230e440a3770$var$escapeChar);
}
function $4d6f230e440a3770$var$escapeChar(a) {
    return $4d6f230e440a3770$var$ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4d6f230e440a3770$var$getMessageFunctionDetails(func) {
    const argString = func.source ? `("${$4d6f230e440a3770$var$escape(func.source)}")` : `(?)`;
    return {
        _custom: {
            type: "function",
            display: `<span>\u{192}</span> ${argString}`
        }
    };
}
function $4d6f230e440a3770$var$registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: "global",
        label: "Global Scope"
    });
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    for (const [keyInstance, instance] of i18n.__instances){
        // prettier-ignore
        const composer = i18n.mode === "composition" ? instance : instance.__composer;
        if (global === composer) continue;
        payload.rootNodes.push({
            id: composer.id.toString(),
            label: `${$4d6f230e440a3770$var$getI18nScopeLable(keyInstance)} Scope`
        });
    }
}
function $4d6f230e440a3770$var$getComponentInstance(nodeId, i18n) {
    let instance = null;
    if (nodeId !== "global") {
        for (const [component, composer] of i18n.__instances.entries())if (composer.id.toString() === nodeId) {
            instance = component;
            break;
        }
    }
    return instance;
}
function $4d6f230e440a3770$var$getComposer$1(nodeId, i18n) {
    if (nodeId === "global") return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    else {
        const instance = Array.from(i18n.__instances.values()).find((item)=>item.id.toString() === nodeId);
        if (instance) return i18n.mode === "composition" ? instance : instance.__composer;
        else return null;
    }
}
function $4d6f230e440a3770$var$inspectScope(payload, i18n) {
    const composer = $4d6f230e440a3770$var$getComposer$1(payload.nodeId, i18n);
    if (composer) // TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload.state = $4d6f230e440a3770$var$makeScopeInspectState(composer);
    return null;
}
function $4d6f230e440a3770$var$makeScopeInspectState(composer) {
    const state = {};
    const localeType = "Locale related info";
    const localeStates = [
        {
            type: localeType,
            key: "locale",
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: "fallbackLocale",
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: "availableLocales",
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: "inheritLocale",
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    const localeMessagesType = "Locale messages info";
    const localeMessagesStates = [
        {
            type: localeMessagesType,
            key: "messages",
            editable: false,
            value: $4d6f230e440a3770$var$getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        const datetimeFormatsType = "Datetime formats info";
        const datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: "datetimeFormats",
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        const numberFormatsType = "Datetime formats info";
        const numberFormatsStates = [
            {
                type: numberFormatsType,
                key: "numberFormats",
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function $4d6f230e440a3770$var$addTimelineEvent(event, payload) {
    if ($4d6f230e440a3770$var$devtoolsApi) {
        let groupId;
        if (payload && "groupId" in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        $4d6f230e440a3770$var$devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* VueDevToolsTimelineEvents.COMPILE_ERROR */  ? "error" : event === "fallback" /* VueDevToolsTimelineEvents.FALBACK */  || event === "missing" /* VueDevToolsTimelineEvents.MISSING */  ? "warning" : "default"
            }
        });
    }
}
function $4d6f230e440a3770$var$editScope(payload, i18n) {
    const composer = $4d6f230e440a3770$var$getComposer$1(payload.nodeId, i18n);
    if (composer) {
        const [field] = payload.path;
        if (field === "locale" && (0, $73e90664ed51b607$export$844ec244b1367d54)(payload.state.value)) composer.locale.value = payload.state.value;
        else if (field === "fallbackLocale" && ((0, $73e90664ed51b607$export$844ec244b1367d54)(payload.state.value) || (0, $73e90664ed51b607$export$43bee75e5e14138e)(payload.state.value) || (0, $73e90664ed51b607$export$a6cdc56e425d0d0a)(payload.state.value))) composer.fallbackLocale.value = payload.state.value;
        else if (field === "inheritLocale" && (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(payload.state.value)) composer.inheritLocale = payload.state.value;
    }
}
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $4d6f230e440a3770$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate () {
            const instance = (0, $8zRru.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $4d6f230e440a3770$var$mergeToGlobal(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    optionsI18n.__extender = i18n.__vueI18nExtend;
                    // atttach local VueI18n instance
                    this.$i18n = $4d6f230e440a3770$var$createVueI18n(optionsI18n);
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $4d6f230e440a3770$var$mergeToGlobal(vuei18n, options);
                else {
                    // atttach local VueI18n instance
                    this.$i18n = $4d6f230e440a3770$var$createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __extender: i18n.__vueI18nExtend,
                        __root: composer
                    });
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else // attach global VueI18n instance
            this.$i18n = vuei18n;
            if (options.__i18nGlobal) $4d6f230e440a3770$var$adjustI18nResources(composer, options, options);
            // defines vue-i18n legacy APIs
            this.$t = (...args)=>this.$i18n.t(...args);
            this.$rt = (...args)=>this.$i18n.rt(...args);
            this.$tc = (...args)=>this.$i18n.tc(...args);
            this.$te = (key, locale)=>this.$i18n.te(key, locale);
            this.$d = (...args)=>this.$i18n.d(...args);
            this.$n = (...args)=>this.$i18n.n(...args);
            this.$tm = (key)=>this.$i18n.tm(key);
            i18n.__setInstance(instance, this.$i18n);
        },
        mounted () {
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$i18n) {
                const _vueI18n = this.$i18n;
                this.$el.__VUE_I18N__ = _vueI18n.__composer;
                const emitter = this.__v_emitter = (0, $73e90664ed51b607$export$6f5e8f34570e3ad1)();
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on("*", $4d6f230e440a3770$var$addTimelineEvent);
            }
        },
        unmounted () {
            const instance = (0, $8zRru.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const _vueI18n = this.$i18n;
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$el.__VUE_I18N__) {
                if (this.__v_emitter) {
                    this.__v_emitter.off("*", $4d6f230e440a3770$var$addTimelineEvent);
                    delete this.__v_emitter;
                }
                if (this.$i18n) {
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete this.$el.__VUE_I18N__;
                }
            }
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            if (_vueI18n.__disposer) {
                _vueI18n.__disposer();
                delete _vueI18n.__disposer;
                delete _vueI18n.__extender;
            }
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function $4d6f230e440a3770$var$mergeToGlobal(g, options) {
    g.locale = options.locale || g.locale;
    g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
    g.missing = options.missing || g.missing;
    g.silentTranslationWarn = options.silentTranslationWarn || g.silentFallbackWarn;
    g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
    g.formatFallbackMessages = options.formatFallbackMessages || g.formatFallbackMessages;
    g.postTranslation = options.postTranslation || g.postTranslation;
    g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
    g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
    g.sync = options.sync || g.sync;
    g.__composer[$4d6f230e440a3770$var$SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
    const messages = $4d6f230e440a3770$var$getLocaleMessages(g.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach((locale)=>g.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach((locale)=>g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    if (options.numberFormats) Object.keys(options.numberFormats).forEach((locale)=>g.mergeNumberFormat(locale, options.numberFormats[locale]));
    return g;
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ const $4d6f230e440a3770$export$b19990ca6e622dd2 = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("global-vue-i18n");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $4d6f230e440a3770$export$920091e3d72d80ee(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __legacyMode = __VUE_I18N_LEGACY_API__ && (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    const __globalInjection = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.globalInjection) ? options.globalInjection : true;
    // prettier-ignore
    const __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
    const __instances = new Map();
    const [globalScope, __global] = $4d6f230e440a3770$var$createGlobal(options, __legacyMode);
    const symbol = /* #__PURE__*/ (0, $73e90664ed51b607$export$cd133c5e04906ece)("");
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        const i18n = {
            // mode
            get mode () {
                return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
            },
            // allowComposition
            get allowComposition () {
                return __allowComposition;
            },
            // install plugin
            async install (app, ...options) {
                if (__VUE_PROD_DEVTOOLS__ && true) app.__VUE_I18N__ = i18n;
                // setup global provider
                app.__VUE_I18N_SYMBOL__ = symbol;
                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                // set composer & vuei18n extend hook options from plugin options
                if ((0, $73e90664ed51b607$export$53b83ca8eaab0383)(options[0])) {
                    const opts = options[0];
                    i18n.__composerExtend = opts.__composerExtend;
                    i18n.__vueI18nExtend = opts.__vueI18nExtend;
                }
                // global method and properties injection for Composition API
                let globalReleaseHandler = null;
                if (!__legacyMode && __globalInjection) globalReleaseHandler = $4d6f230e440a3770$var$injectGlobalFields(app, i18n.global);
                // install built-in components and directive
                if (__VUE_I18N_FULL_INSTALL__) $4d6f230e440a3770$var$apply(app, i18n, ...options);
                // setup mixin for Legacy API
                if (__VUE_I18N_LEGACY_API__ && __legacyMode) app.mixin($4d6f230e440a3770$var$defineMixin(__global, __global.__composer, i18n));
                // release global scope
                const unmountApp = app.unmount;
                app.unmount = ()=>{
                    globalReleaseHandler && globalReleaseHandler();
                    i18n.dispose();
                    unmountApp();
                };
                // setup vue-devtools plugin
                if (__VUE_PROD_DEVTOOLS__ && true) {
                    const ret = await $4d6f230e440a3770$var$enableDevTools(app, i18n);
                    if (!ret) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                    const emitter = (0, $73e90664ed51b607$export$6f5e8f34570e3ad1)();
                    if (__legacyMode) {
                        const _vueI18n = __global;
                        _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                    } else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const _composer = __global;
                        _composer[$4d6f230e440a3770$var$EnableEmitter] && _composer[$4d6f230e440a3770$var$EnableEmitter](emitter);
                    }
                    emitter.on("*", $4d6f230e440a3770$var$addTimelineEvent);
                }
            },
            // global accessor
            get global () {
                return __global;
            },
            dispose () {
                globalScope.stop();
            },
            __instances: // @internal
            __instances,
            __getInstance: // @internal
            __getInstance,
            __setInstance: // @internal
            __setInstance,
            __deleteInstance: // @internal
            __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $4d6f230e440a3770$export$3f3caade1c12f8c9(options = {}) {
    const instance = (0, $8zRru.getCurrentInstance)();
    if (instance == null) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.NOT_INSTALLED);
    const i18n = $4d6f230e440a3770$var$getI18nInstance(instance);
    const gl = $4d6f230e440a3770$var$getGlobalComposer(i18n);
    const componentOptions = $4d6f230e440a3770$var$getComponentOptions(instance);
    const scope = $4d6f230e440a3770$var$getScope(options, componentOptions);
    if (__VUE_I18N_LEGACY_API__) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {
        if (i18n.mode === "legacy" && !options.__useComponent) {
            if (!i18n.allowComposition) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
            return $4d6f230e440a3770$var$useI18nForLegacy(instance, scope, gl, options);
        }
    }
    if (scope === "global") {
        $4d6f230e440a3770$var$adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === "parent") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = $4d6f230e440a3770$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) composer = gl;
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = (0, $73e90664ed51b607$export$e6e34fd1f2686227)({}, options);
        if ("__i18n" in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (gl) composerOptions.__root = gl;
        composer = $4d6f230e440a3770$var$createComposer(composerOptions);
        if (i18nInternal.__composerExtend) composer[$4d6f230e440a3770$var$DisposeSymbol] = i18nInternal.__composerExtend(composer);
        $4d6f230e440a3770$var$setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 */ /* #__NO_SIDE_EFFECTS__ */ const $4d6f230e440a3770$export$ec8a89fa64fbfb0 = (i18n)=>{
    if (!($4d6f230e440a3770$var$__VUE_I18N_BRIDGE__ in i18n)) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);
    return i18n;
};
function $4d6f230e440a3770$var$createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = (0, $g90JB.effectScope)();
    {
        const obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(()=>$4d6f230e440a3770$var$createVueI18n(options)) : scope.run(()=>$4d6f230e440a3770$var$createComposer(options));
        if (obj == null) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_ERROR);
        return [
            scope,
            obj
        ];
    }
}
function $4d6f230e440a3770$var$getI18nInstance(instance) {
    {
        const i18n = (0, $8zRru.inject)(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $4d6f230e440a3770$export$b19990ca6e622dd2);
        /* istanbul ignore if */ if (!i18n) throw $4d6f230e440a3770$var$createI18nError(!instance.isCE ? $4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_ERROR : $4d6f230e440a3770$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4d6f230e440a3770$var$getScope(options, componentOptions) {
    // prettier-ignore
    return (0, $73e90664ed51b607$export$83b788b1a3698c03)(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function $4d6f230e440a3770$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
function $4d6f230e440a3770$var$getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = $4d6f230e440a3770$var$getParentComponentInstance(target, useComponent);
    while(current != null){
        const i18nInternal = i18n;
        if (i18n.mode === "composition") composer = i18nInternal.__getInstance(current);
        else if (__VUE_I18N_LEGACY_API__) {
            const vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$4d6f230e440a3770$var$InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $4d6f230e440a3770$var$getParentComponentInstance(target, useComponent = false) {
    if (target == null) return null;
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent ? target.parent : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function $4d6f230e440a3770$var$setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    (0, $8zRru.onMounted)(()=>{
        // inject composer instance to DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = (0, $73e90664ed51b607$export$6f5e8f34570e3ad1)();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _composer = composer;
            _composer[$4d6f230e440a3770$var$EnableEmitter] && _composer[$4d6f230e440a3770$var$EnableEmitter](emitter);
            emitter.on("*", $4d6f230e440a3770$var$addTimelineEvent);
        }
    }, target);
    (0, $8zRru.onUnmounted)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _composer = composer;
        // remove composer instance from DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el && target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off("*", $4d6f230e440a3770$var$addTimelineEvent);
            _composer[$4d6f230e440a3770$var$DisableEmitter] && _composer[$4d6f230e440a3770$var$DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
        // dispose extended resources
        const dispose = _composer[$4d6f230e440a3770$var$DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[$4d6f230e440a3770$var$DisposeSymbol];
        }
    }, target);
}
function $4d6f230e440a3770$var$useI18nForLegacy(instance, scope, root, options = {} // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const isLocalScope = scope === "local";
    const _composer = (0, $g90JB.shallowRef)(null);
    if (isLocalScope && instance.proxy && !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
    const _inheritLocale = (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : !(0, $73e90664ed51b607$export$844ec244b1367d54)(options.locale);
    const _locale = (0, $g90JB.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.locale.value : (0, $73e90664ed51b607$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $f46e6a02d365fb97$export$1af4c7e47ad72f44));
    const _fallbackLocale = (0, $g90JB.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.fallbackLocale.value : (0, $73e90664ed51b607$export$844ec244b1367d54)(options.fallbackLocale) || (0, $73e90664ed51b607$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = (0, $g90JB.ref)($4d6f230e440a3770$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0, $g90JB.ref)((0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = (0, $g90JB.ref)((0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _missingWarn = isLocalScope ? root.missingWarn : (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $73e90664ed51b607$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    const _fallbackWarn = isLocalScope ? root.fallbackWarn : (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $73e90664ed51b607$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    const _fallbackRoot = isLocalScope ? root.fallbackRoot : (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    const _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    const _missing = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    // postTranslation handler
    const _postTranslation = (0, $73e90664ed51b607$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    const _warnHtmlMessage = isLocalScope ? root.warnHtmlMessage : (0, $73e90664ed51b607$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const _escapeParameter = !!options.escapeParameter;
    // prettier-ignore
    const _modifiers = isLocalScope ? root.modifiers : (0, $73e90664ed51b607$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    const _pluralRules = options.pluralRules || isLocalScope && root.pluralRules;
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $g90JB.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.locale.value : _locale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.locale.value = val1;
            _locale.value = val1;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $g90JB.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.fallbackLocale.value = val1;
            _fallbackLocale.value = val1;
        }
    });
    // messages
    const messages = (0, $g90JB.computed)(()=>{
        if (_composer.value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _composer.value.messages.value;
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _messages.value;
    });
    const datetimeFormats = (0, $g90JB.computed)(()=>_datetimeFormats.value);
    const numberFormats = (0, $g90JB.computed)(()=>_numberFormats.value);
    function getPostTranslationHandler() {
        return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
    }
    function setPostTranslationHandler(handler1) {
        if (_composer.value) _composer.value.setPostTranslationHandler(handler1);
    }
    function getMissingHandler() {
        return _composer.value ? _composer.value.getMissingHandler() : _missing;
    }
    function setMissingHandler(handler1) {
        if (_composer.value) _composer.value.setMissingHandler(handler1);
    }
    function warpWithDeps(fn) {
        trackReactivityValues();
        return fn();
    }
    function t(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.t, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function rt(...args) {
        return _composer.value ? Reflect.apply(_composer.value.rt, null, [
            ...args
        ]) : "";
    }
    function d(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.d, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function n(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.n, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function tm(key) {
        return _composer.value ? _composer.value.tm(key) : {};
    }
    function te(key, locale) {
        return _composer.value ? _composer.value.te(key, locale) : false;
    }
    function getLocaleMessage(locale) {
        return _composer.value ? _composer.value.getLocaleMessage(locale) : {};
    }
    function setLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.setLocaleMessage(locale, message);
            _messages.value[locale] = message;
        }
    }
    function mergeLocaleMessage(locale, message) {
        if (_composer.value) _composer.value.mergeLocaleMessage(locale, message);
    }
    function getDateTimeFormat(locale) {
        return _composer.value ? _composer.value.getDateTimeFormat(locale) : {};
    }
    function setDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setDateTimeFormat(locale, format);
            _datetimeFormats.value[locale] = format;
        }
    }
    function mergeDateTimeFormat(locale, format) {
        if (_composer.value) _composer.value.mergeDateTimeFormat(locale, format);
    }
    function getNumberFormat(locale) {
        return _composer.value ? _composer.value.getNumberFormat(locale) : {};
    }
    function setNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setNumberFormat(locale, format);
            _numberFormats.value[locale] = format;
        }
    }
    function mergeNumberFormat(locale, format) {
        if (_composer.value) _composer.value.mergeNumberFormat(locale, format);
    }
    const wrapper = {
        get id () {
            return _composer.value ? _composer.value.id : -1;
        },
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        get inheritLocale () {
            return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
        },
        set inheritLocale (val){
            if (_composer.value) _composer.value.inheritLocale = val;
        },
        get availableLocales () {
            return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
        },
        get modifiers () {
            return _composer.value ? _composer.value.modifiers : _modifiers;
        },
        get pluralRules () {
            return _composer.value ? _composer.value.pluralRules : _pluralRules;
        },
        get isGlobal () {
            return _composer.value ? _composer.value.isGlobal : false;
        },
        get missingWarn () {
            return _composer.value ? _composer.value.missingWarn : _missingWarn;
        },
        set missingWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackWarn () {
            return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
        },
        set fallbackWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackRoot () {
            return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
        },
        set fallbackRoot (val){
            if (_composer.value) _composer.value.fallbackRoot = val;
        },
        get fallbackFormat () {
            return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
        },
        set fallbackFormat (val){
            if (_composer.value) _composer.value.fallbackFormat = val;
        },
        get warnHtmlMessage () {
            return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            if (_composer.value) _composer.value.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
        },
        set escapeParameter (val){
            if (_composer.value) _composer.value.escapeParameter = val;
        },
        t: t,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        rt: rt,
        d: d,
        n: n,
        tm: tm,
        te: te,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getDateTimeFormat: getDateTimeFormat,
        setDateTimeFormat: setDateTimeFormat,
        mergeDateTimeFormat: mergeDateTimeFormat,
        getNumberFormat: getNumberFormat,
        setNumberFormat: setNumberFormat,
        mergeNumberFormat: mergeNumberFormat
    };
    function sync(composer) {
        composer.locale.value = _locale.value;
        composer.fallbackLocale.value = _fallbackLocale.value;
        Object.keys(_messages.value).forEach((locale)=>{
            composer.mergeLocaleMessage(locale, _messages.value[locale]);
        });
        Object.keys(_datetimeFormats.value).forEach((locale)=>{
            composer.mergeDateTimeFormat(locale, _datetimeFormats.value[locale]);
        });
        Object.keys(_numberFormats.value).forEach((locale)=>{
            composer.mergeNumberFormat(locale, _numberFormats.value[locale]);
        });
        composer.escapeParameter = _escapeParameter;
        composer.fallbackFormat = _fallbackFormat;
        composer.fallbackRoot = _fallbackRoot;
        composer.fallbackWarn = _fallbackWarn;
        composer.missingWarn = _missingWarn;
        composer.warnHtmlMessage = _warnHtmlMessage;
    }
    (0, $8zRru.onBeforeMount)(()=>{
        if (instance.proxy == null || instance.proxy.$i18n == null) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const composer = _composer.value = instance.proxy.$i18n.__composer;
        if (scope === "global") {
            _locale.value = composer.locale.value;
            _fallbackLocale.value = composer.fallbackLocale.value;
            _messages.value = composer.messages.value;
            _datetimeFormats.value = composer.datetimeFormats.value;
            _numberFormats.value = composer.numberFormats.value;
        } else if (isLocalScope) sync(composer);
    });
    return wrapper;
}
const $4d6f230e440a3770$var$globalExportProps = [
    "locale",
    "fallbackLocale",
    "availableLocales"
];
const $4d6f230e440a3770$var$globalExportMethods = [
    "t",
    "rt",
    "d",
    "n",
    "tm",
    "te"
];
function $4d6f230e440a3770$var$injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    $4d6f230e440a3770$var$globalExportProps.forEach((prop)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const wrap = (0, $g90JB.isRef)(desc.value) // check computed props
         ? {
            get () {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (val1) {
                desc.value.value = val1;
            }
        } : {
            get () {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $4d6f230e440a3770$var$globalExportMethods.forEach((method)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $4d6f230e440a3770$var$createI18nError($4d6f230e440a3770$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
    const dispose = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete app.config.globalProperties.$i18n;
        $4d6f230e440a3770$var$globalExportMethods.forEach((method)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete app.config.globalProperties[`$${method}`];
        });
    };
    return dispose;
}
$4d6f230e440a3770$var$initFeatureFlags();
// register message compiler at vue-i18n
if (__INTLIFY_JIT_COMPILATION__) (0, $f46e6a02d365fb97$export$6ee2fbe83628b40b)((0, $f46e6a02d365fb97$export$ef7acd7185315e22));
else (0, $f46e6a02d365fb97$export$6ee2fbe83628b40b)((0, $f46e6a02d365fb97$export$1ea8807c727891fc));
// register message resolver at vue-i18n
(0, $f46e6a02d365fb97$export$45dacdc710815463)((0, $f46e6a02d365fb97$export$d812c8e1906863d0));
// register fallback locale at vue-i18n
(0, $f46e6a02d365fb97$export$fd8ec9dd8067edec)((0, $f46e6a02d365fb97$export$71df9db82dc445));
// NOTE: experimental !!
if (__INTLIFY_PROD_DEVTOOLS__) {
    const target = (0, $73e90664ed51b607$export$ff5f2eeb11fc7e14)();
    target.__INTLIFY__ = true;
    (0, $f46e6a02d365fb97$export$c893d6c8966908b9)(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}


const $1007c1e098c525e5$export$84584c2a98eb6753 = {
    languages: {
        english: "English",
        spanish: "Spanish",
        dutch: "Dutch",
        french: "French",
        portuguese: "Portuguese",
        italian: "Italian",
        german: "German",
        polish: "Polish",
        romanian: "Romanian",
        greek: "Greek"
    },
    loginPage: {
        title: "Sign in",
        email: "Email",
        placeholder: "Enter your email",
        buttonText: "Login",
        loginMessage: "An email has been sent to the provided email address. Please click the link in the email to authenticate.",
        noEmailMessage: "Please use the link in the email that was sent to you to trigger this process"
    },
    formPage: {
        title: "Periodic Review",
        submittedMessage: "The form has been submitted!",
        alreadySubmittedMessage: "The form has already been submitted! If you would like to change information previously submitted please contact your relationship manager.",
        waitMessage: "Loading data, please wait...",
        asteriskMessage1: "Please fill all fields with",
        asteriskMessage2: "as they are required.",
        savedLocallyMessage: "All changes will be saved locally on your device.",
        accessFormAgain: "You can access the form again using the link",
        openPRs: "Open Periodic Reviews",
        addRelation: "Add Relation",
        submit: "Submit",
        continue: "Continue",
        addFile: "Add File"
    }
};


const $304f7833b4e50145$export$ca5e4045a55e76d2 = {
    languages: {
        english: "Ingl\xe9s",
        spanish: "Espa\xf1ol",
        dutch: "Holand\xe9s",
        french: "Franc\xe9s",
        portuguese: "Portugu\xe9s",
        italian: "Italiano",
        german: "Alem\xe1n",
        polish: "Polaco",
        romanian: "Rumano",
        greek: "Griego"
    },
    loginPage: {
        title: "Acceder",
        email: "Correo Electronico",
        placeholder: "Introduce tu correo electr\xf3nico",
        buttonText: "Acceso",
        loginMessage: "Se ha enviado un correo electr\xf3nico a la direcci\xf3n de correo electr\xf3nico proporcionada. Haga clic en el enlace del correo electr\xf3nico para autenticarse.",
        noEmailMessage: "Utilice el enlace del correo electr\xf3nico que se le envi\xf3 para iniciar este proceso"
    },
    formPage: {
        title: "Actualizaci\xf3n de informaci\xf3n",
        submittedMessage: "\xa1El formulario ya ha sido enviado! Si desea cambiar la informaci\xf3n presentada anteriormente, comun\xedquese con su gerente de relaciones",
        alreadySubmittedMessage: "\xa1El formulario ya ha sido enviado!",
        waitMessage: "Cargando datos, por favor espera...",
        asteriskMessage1: "Por favor, rellene todos los campos con",
        asteriskMessage2: "ya que son obligatorios.",
        savedLocallyMessage: "Todos los cambios se guardar\xe1n localmente en su dispositivo.",
        accessFormAgain: "Puede acceder al formulario nuevamente usando el enlace",
        openPRs: "Revisiones peri\xf3dicas abiertas",
        addRelation: "A\xf1adir otra relaci\xf3n",
        submit: "Enviar",
        continue: "Continuar",
        addFile: "A\xf1adir archivo"
    }
};


const $4a4177470e07620e$export$9c64ee4d84d79ce1 = {
    languages: {
        english: "Engels",
        spanish: "Spaans",
        dutch: "Nederlands",
        french: "Frans",
        portuguese: "Portugees",
        italian: "Italiaans",
        german: "Duits",
        polish: "Pools",
        romanian: "Roemeens",
        greek: "Grieks"
    },
    loginPage: {
        loginMessage: "Er is een e-mail verzonden naar het opgegeven e-mailadres. Klik op de link in de e-mail om te verifi\xebren.",
        noEmailMessage: "Please use the link in the email that was sent to you to trigger this process"
    },
    formPage: {
        title: "Periodieke Evaluatie",
        submittedMessage: "Het formulier is verzonden!",
        alreadySubmittedMessage: "Het formulier is al verzonden! Als u eerder verstrekte gegevens wilt wijzigen, kunt u contact opnemen met uw relatiebeheerder",
        waitMessage: "Gegevens worden geladen, even geduld a.u.b....",
        asteriskMessage1: "Vul alle velden met",
        asteriskMessage2: "in, deze zijn verplicht.",
        savedLocallyMessage: "Alle wijzigingen worden lokaal op uw apparaat opgeslagen",
        accessFormAgain: "U kunt het formulier opnieuw openen via de link",
        openPRs: "Geopende periodieke evaluaties",
        addRelation: "Een relatie toevoegen",
        submit: "Stuur in",
        continue: "Doorgaan",
        addFile: "Bestand toevoegen"
    }
};


const $3abfbcc15486c101$export$acb2a88f7d552ebf = {
    languages: {
        english: "Anglais",
        spanish: "Espagnol",
        dutch: "N\xe9erlandais",
        french: "Fran\xe7ais",
        portuguese: "Portugais",
        italian: "Italien",
        german: "Allemand",
        polish: "Polonais",
        romanian: "Roumain",
        greek: "Grec"
    },
    loginPage: {
        loginMessage: "Un e-mail a \xe9t\xe9 envoy\xe9 au courrier \xe9lectronique fournie. Veuillez cliquer sur le lien dans l'e-mail pour vous authentifier.",
        noEmailMessage: "Please use the link in the email that was sent to you to trigger this process"
    },
    formPage: {
        title: "R\xe9vision p\xe9riodique",
        submittedMessage: "Le formulaire a \xe9t\xe9 soumis !",
        alreadySubmittedMessage: "Le formulaire a d\xe9j\xe0 \xe9t\xe9 soumis ! Si vous souhaitez modifier les informations pr\xe9c\xe9demment soumises, veuillez contacter votre responsable relationnel.",
        waitMessage: "Chargement des donn\xe9es, veuillez patienter...",
        asteriskMessage1: "Veuillez remplir tous les champs avec",
        asteriskMessage2: "car ils sont obligatoires.",
        savedLocallyMessage: "Toutes les modifications seront enregistr\xe9es localement sur votre appareil",
        accessFormAgain: "Vous pouvez \xe0 nouveau acc\xe9der au formulaire en utilisant le lien",
        openPRs: "R\xe9vision p\xe9riodique ouverte",
        addRelation: "Ajouter une relation",
        submit: "Envoyer",
        continue: "Continuer",
        addFile: "Ajouter un fichier"
    }
};


const $a0df25e396515fff$export$84175d5f1cb4e39d = {
    languages: {
        english: "Ingl\xeas",
        spanish: "Espanhol",
        dutch: "Holand\xeas",
        french: "Franc\xeas",
        portuguese: "Portugu\xeas",
        italian: "Italiano",
        german: "Alem\xe3o",
        polish: "Polon\xeas",
        romanian: "Romeno",
        greek: "Grego"
    },
    loginPage: {
        title: "Entrar",
        email: "E-mail",
        placeholder: "Digite seu e-mail",
        buttonText: "Entrar",
        loginMessage: "Foi enviado um email para o endere\xe7o de email proporcionado. Clique no link do email para autenticar.",
        noEmailMessage: "Por favor, use o link no e-mail que foi enviado para voc\xea para iniciar este processo"
    },
    formPage: {
        title: "Revis\xe3o Peri\xf3dica",
        submittedMessage: "O formul\xe1rio foi enviado!",
        alreadySubmittedMessage: "O formul\xe1rio j\xe1 foi enviado! Se voc\xea deseja alterar as informa\xe7\xf5es enviadas anteriormente, entre em contato com seu gerente de relacionamento.",
        waitMessage: "Carregando dados, por favor, aguarde...",
        asteriskMessage1: "Por favor, preencha todos os campos com",
        asteriskMessage2: "pois eles s\xe3o obrigat\xf3rios.",
        savedLocallyMessage: "Todas as altera\xe7\xf5es ser\xe3o salvas localmente no seu dispositivo.",
        accessFormAgain: "Voc\xea pode acessar o formul\xe1rio novamente usando o link",
        openPRs: "Revis\xf5es Peri\xf3dicas Abertas",
        addRelation: "Adicionar Rela\xe7\xe3o",
        submit: "Enviar",
        continue: "Continuar",
        addFile: "Adicionar Arquivo"
    }
};


const $8d555e430f9e27e7$export$3486a10f30cf1ee4 = {
    languages: {
        english: "Inglese",
        spanish: "Spagnolo",
        dutch: "Olandese",
        french: "Francese",
        portuguese: "Portoghese",
        italian: "Italiano",
        german: "Tedesco",
        polish: "Polacco",
        romanian: "Rumeno",
        greek: "Greco"
    },
    loginPage: {
        title: "Accedi",
        email: "Email",
        placeholder: "Inserisci la tua email",
        buttonText: "Accedi",
        loginMessage: "\xc8 stata inviata un'email all'indirizzo fornito. Clicca sul link nell'email per autenticarti.",
        noEmailMessage: "Per favore, usa il link nell'email che ti \xe8 stata inviata per avviare questo processo"
    },
    formPage: {
        title: "Revisione Periodica",
        submittedMessage: "Il modulo \xe8 stato inviato!",
        alreadySubmittedMessage: "Il modulo \xe8 gi\xe0 stato inviato! Se desideri modificare le informazioni precedentemente inviate, contatta il tuo relationship manager.",
        waitMessage: "Caricamento dati, attendere prego...",
        asteriskMessage1: "Si prega di compilare tutti i campi con",
        asteriskMessage2: "poich\xe9 sono obbligatori.",
        savedLocallyMessage: "Tutte le modifiche verranno salvate localmente sul tuo dispositivo.",
        accessFormAgain: "Puoi accedere nuovamente al modulo usando il link",
        openPRs: "Revisioni Periodiche Aperte",
        addRelation: "Aggiungi Relazione",
        submit: "Invia",
        continue: "Continua",
        addFile: "Aggiungi File"
    }
};


const $24759d73627e6be8$export$2fa162a495d26869 = {
    languages: {
        english: "Englisch",
        spanish: "Spanisch",
        dutch: "Niederl\xe4ndisch",
        french: "Franz\xf6sisch",
        portuguese: "Portugiesisch",
        italian: "Italienisch",
        german: "Deutsch",
        polish: "Polnisch",
        romanian: "Rum\xe4nisch",
        greek: "Griechisch"
    },
    loginPage: {
        title: "Anmelden",
        email: "E-Mail",
        placeholder: "Geben Sie Ihre E-Mail-Adresse ein",
        buttonText: "Anmelden",
        loginMessage: "Eine E-Mail wurde an die angegebene E-Mail-Adresse gesendet. Bitte klicken Sie auf den Link in der E-Mail, um sich zu authentifizieren.",
        noEmailMessage: "Bitte verwenden Sie den Link in der E-Mail, die Ihnen zugesandt wurde, um diesen Vorgang zu starten."
    },
    formPage: {
        title: "Periodische \xdcberpr\xfcfung",
        submittedMessage: "Das Formular wurde \xfcbermittelt!",
        alreadySubmittedMessage: "Das Formular wurde bereits \xfcbermittelt! Wenn Sie zuvor \xfcbermittelte Informationen \xe4ndern m\xf6chten, wenden Sie sich bitte an Ihren Kundenbetreuer.",
        waitMessage: "Daten werden geladen, bitte warten...",
        asteriskMessage1: "Bitte f\xfcllen Sie alle Felder mit",
        asteriskMessage2: "aus, da diese erforderlich sind.",
        savedLocallyMessage: "Alle \xc4nderungen werden lokal auf Ihrem Ger\xe4t gespeichert.",
        accessFormAgain: "Sie k\xf6nnen das Formular \xfcber den Link erneut aufrufen",
        openPRs: "Offene periodische \xdcberpr\xfcfungen",
        addRelation: "Beziehung hinzuf\xfcgen",
        submit: "Senden",
        continue: "Weiter",
        addFile: "Datei hinzuf\xfcgen"
    }
};


const $ce8ab61c8bf957aa$export$6ea5311eda92944f = {
    languages: {
        english: "Angielski",
        spanish: "Hiszpa\u0144ski",
        dutch: "Holenderski",
        french: "Francuski",
        portuguese: "Portugalski",
        italian: "W\u0142oski",
        german: "Niemiecki",
        polish: "Polski",
        romanian: "Rumu\u0144ski",
        greek: "Grecki"
    },
    loginPage: {
        title: "Zaloguj si\u0119",
        email: "Email",
        placeholder: "Wprowad\u017A sw\xf3j adres e-mail",
        buttonText: "Zaloguj",
        loginMessage: "Na podany adres e-mail zosta\u0142a wys\u0142ana wiadomo\u015B\u0107. Kliknij link w wiadomo\u015Bci e-mail, aby si\u0119 uwierzytelni\u0107.",
        noEmailMessage: "U\u017Cyj linku z wiadomo\u015Bci e-mail, kt\xf3ra zosta\u0142a do Ciebie wys\u0142ana, aby uruchomi\u0107 ten proces."
    },
    formPage: {
        title: "Przegl\u0105d okresowy",
        submittedMessage: "Formularz zosta\u0142 przes\u0142any!",
        alreadySubmittedMessage: "Formularz zosta\u0142 ju\u017C przes\u0142any! Je\u015Bli chcesz zmieni\u0107 wcze\u015Bniej przes\u0142ane informacje, skontaktuj si\u0119 ze swoim mened\u017Cerem ds. relacji.",
        waitMessage: "\u0141adowanie danych, prosz\u0119 czeka\u0107...",
        asteriskMessage1: "Prosz\u0119 wype\u0142ni\u0107 wszystkie pola oznaczone",
        asteriskMessage2: ", poniewa\u017C s\u0105 one wymagane.",
        savedLocallyMessage: "Wszystkie zmiany zostan\u0105 zapisane lokalnie na Twoim urz\u0105dzeniu.",
        accessFormAgain: "Mo\u017Cesz ponownie uzyska\u0107 dost\u0119p do formularza, korzystaj\u0105c z linku",
        openPRs: "Otwarte przegl\u0105dy okresowe",
        addRelation: "Dodaj relacj\u0119",
        submit: "Prze\u015Blij",
        continue: "Kontynuuj",
        addFile: "Dodaj plik"
    }
};


const $58ed881c49e6105a$export$ea30ec7f37fb148d = {
    languages: {
        english: "Englez\u0103",
        spanish: "Spaniol\u0103",
        dutch: "Olandez\u0103",
        french: "Francez\u0103",
        portuguese: "Portughez\u0103",
        italian: "Italian\u0103",
        german: "German\u0103",
        polish: "Polonez\u0103",
        romanian: "Rom\xe2n\u0103",
        greek: "Greac\u0103"
    },
    loginPage: {
        title: "Autentificare",
        email: "Email",
        placeholder: "Introduce\u021Bi adresa de email",
        buttonText: "Autentificare",
        loginMessage: "Un email a fost trimis la adresa de email furnizat\u0103. V\u0103 rug\u0103m s\u0103 face\u021Bi clic pe linkul din email pentru a v\u0103 autentifica.",
        noEmailMessage: "V\u0103 rug\u0103m s\u0103 utiliza\u021Bi linkul din emailul care v-a fost trimis pentru a declan\u0219a acest proces."
    },
    formPage: {
        title: "Revizuire periodic\u0103",
        submittedMessage: "Formularul a fost trimis!",
        alreadySubmittedMessage: "Formularul a fost deja trimis! Dac\u0103 dori\u021Bi s\u0103 modifica\u021Bi informa\u021Biile trimise anterior, v\u0103 rug\u0103m s\u0103 contacta\u021Bi managerul de rela\u021Bii.",
        waitMessage: "Se \xeencarc\u0103 datele, v\u0103 rug\u0103m a\u0219tepta\u021Bi...",
        asteriskMessage1: "V\u0103 rug\u0103m s\u0103 completa\u021Bi toate c\xe2mpurile cu",
        asteriskMessage2: "deoarece sunt obligatorii.",
        savedLocallyMessage: "Toate modific\u0103rile vor fi salvate local pe dispozitivul dumneavoastr\u0103.",
        accessFormAgain: "Pute\u021Bi accesa din nou formularul folosind linkul",
        openPRs: "Revizuiri periodice deschise",
        addRelation: "Ad\u0103ugare rela\u021Bie",
        submit: "Trimite",
        continue: "Continu\u0103",
        addFile: "Adaug\u0103 fi\u0219ier"
    }
};


const $e5867dd5a9e773f5$export$d911550c75100362 = {
    languages: {
        english: "\u0391\u03B3\u03B3\u03BB\u03B9\u03BA\u03AC",
        spanish: "\u0399\u03C3\u03C0\u03B1\u03BD\u03B9\u03BA\u03AC",
        dutch: "\u039F\u03BB\u03BB\u03B1\u03BD\u03B4\u03B9\u03BA\u03AC",
        french: "\u0393\u03B1\u03BB\u03BB\u03B9\u03BA\u03AC",
        portuguese: "\u03A0\u03BF\u03C1\u03C4\u03BF\u03B3\u03B1\u03BB\u03B9\u03BA\u03AC",
        italian: "\u0399\u03C4\u03B1\u03BB\u03B9\u03BA\u03AC",
        german: "\u0393\u03B5\u03C1\u03BC\u03B1\u03BD\u03B9\u03BA\u03AC",
        polish: "\u03A0\u03BF\u03BB\u03C9\u03BD\u03B9\u03BA\u03AC",
        romanian: "\u03A1\u03BF\u03C5\u03BC\u03B1\u03BD\u03B9\u03BA\u03AC",
        greek: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"
    },
    loginPage: {
        title: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7",
        email: "Email",
        placeholder: "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2",
        buttonText: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7",
        loginMessage: "\u0388\u03BD\u03B1 email \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03C3\u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C0\u03BF\u03C5 \u03B4\u03CE\u03C3\u03B1\u03C4\u03B5. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03C3\u03C4\u03BF email \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B3\u03AF\u03BD\u03B5\u03B9 \u03B7 \u03C4\u03B1\u03C5\u03C4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7.",
        noEmailMessage: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03C3\u03C4\u03BF email \u03C0\u03BF\u03C5 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B1."
    },
    formPage: {
        title: "\u03A0\u03B5\u03C1\u03B9\u03BF\u03B4\u03B9\u03BA\u03AE \u0391\u03BD\u03B1\u03B8\u03B5\u03CE\u03C1\u03B7\u03C3\u03B7",
        submittedMessage: "\u0397 \u03C6\u03CC\u03C1\u03BC\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF!",
        alreadySubmittedMessage: "\u0397 \u03C6\u03CC\u03C1ma \u03AD\u03C7\u03B5\u03B9 \u03AE\u03B4\u03B7 \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF! \u0391\u03BD \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03C4\u03B5 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03BF\u03B2\u03BB\u03AE\u03B8\u03B7\u03BA\u03B1\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03C5\u03BC\u03AD\u03BD\u03C9\u03C2, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03B4\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE \u03C4\u03B7\u03C2 \u03C3\u03C7\u03AD\u03C3\u03B7\u03C2 \u03C3\u03B1\u03C2.",
        waitMessage: "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5...",
        asteriskMessage1: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03B5\u03B4\u03AF\u03B1 \u03BC\u03B5",
        asteriskMessage2: "\u03BA\u03B1\u03B8\u03CE\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03AC.",
        savedLocallyMessage: "\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03B8\u03B1 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03C4\u03BF\u03CD\u03BD \u03C4\u03BF\u03C0\u03B9\u03BA\u03AC \u03C3\u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03C3\u03B1\u03C2.",
        accessFormAgain: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03BA\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF",
        openPRs: "\u0391\u03BD\u03BF\u03B9\u03BA\u03C4\u03AD\u03C2 \u03A0\u03B5\u03C1\u03B9\u03BF\u03B4\u03B9\u03BA\u03AD\u03C2 \u0391\u03BD\u03B1\u03B8\u03B5\u03C9\u03C1\u03AE\u03C3\u03B5\u03B9\u03C2",
        addRelation: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03A3\u03C7\u03AD\u03C3\u03B7\u03C2",
        submit: "\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE",
        continue: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
        addFile: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u0391\u03C1\u03C7\u03B5\u03AF\u03BF\u03C5"
    }
};



var $kBVDt = parcelRequire("kBVDt");
const $e43b4fb969d1050e$var$initializeI18n = async ()=>{
    const translations = {
        en: $1007c1e098c525e5$export$84584c2a98eb6753,
        es: $304f7833b4e50145$export$ca5e4045a55e76d2,
        nl: $4a4177470e07620e$export$9c64ee4d84d79ce1,
        fr: $3abfbcc15486c101$export$acb2a88f7d552ebf,
        pt: $a0df25e396515fff$export$84175d5f1cb4e39d,
        it: $8d555e430f9e27e7$export$3486a10f30cf1ee4,
        de: $24759d73627e6be8$export$2fa162a495d26869,
        pl: $ce8ab61c8bf957aa$export$6ea5311eda92944f,
        ro: $58ed881c49e6105a$export$ea30ec7f37fb148d,
        gr: $e5867dd5a9e773f5$export$d911550c75100362
    };
    const userLang = navigator.language.split("-")[0];
    const savedLang = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem((0, $kBVDt.STORED_LANG_KEY));
    const i18n = (0, $4d6f230e440a3770$export$920091e3d72d80ee)({
        locale: savedLang || userLang || "en",
        messages: translations
    });
    return i18n;
};
var $e43b4fb969d1050e$export$2e2bcd8739ae039 = $e43b4fb969d1050e$var$initializeI18n();


/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ /*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("a38K9");
var $8zRru = parcelRequire("8zRru");
var $g90JB = parcelRequire("g90JB");

//#region src/utils/env.ts
const $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9 = typeof document !== "undefined";
//#endregion
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ const $9cf3e6406bb1dafb$export$8743009a87fcb00f = (v)=>v;
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $9cf3e6406bb1dafb$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $9cf3e6406bb1dafb$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $9cf3e6406bb1dafb$var$isRouteComponent(obj.default);
}
const $9cf3e6406bb1dafb$export$b4171a6734a65d42 = Object.assign;
function $9cf3e6406bb1dafb$export$9e5f44173e64f162(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $9cf3e6406bb1dafb$export$78acf4525d8a74c4(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $9cf3e6406bb1dafb$export$3722cfe417b6ed86 = ()=>{};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ const $9cf3e6406bb1dafb$export$78acf4525d8a74c4 = Array.isArray;
function $9cf3e6406bb1dafb$export$dc98b0b04f4c7758(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/warning.ts
function $9cf3e6406bb1dafb$export$3466f893ebf79586(msg) {
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ const $9cf3e6406bb1dafb$var$HASH_RE = /#/g;
const $9cf3e6406bb1dafb$var$AMPERSAND_RE = /&/g;
const $9cf3e6406bb1dafb$var$SLASH_RE = /\//g;
const $9cf3e6406bb1dafb$var$EQUAL_RE = /=/g;
const $9cf3e6406bb1dafb$var$IM_RE = /\?/g;
const $9cf3e6406bb1dafb$var$PLUS_RE = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ const $9cf3e6406bb1dafb$var$ENC_BRACKET_OPEN_RE = /%5B/g;
const $9cf3e6406bb1dafb$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
const $9cf3e6406bb1dafb$var$ENC_CARET_RE = /%5E/g;
const $9cf3e6406bb1dafb$var$ENC_BACKTICK_RE = /%60/g;
const $9cf3e6406bb1dafb$var$ENC_CURLY_OPEN_RE = /%7B/g;
const $9cf3e6406bb1dafb$var$ENC_PIPE_RE = /%7C/g;
const $9cf3e6406bb1dafb$var$ENC_CURLY_CLOSE_RE = /%7D/g;
const $9cf3e6406bb1dafb$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $9cf3e6406bb1dafb$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($9cf3e6406bb1dafb$var$ENC_PIPE_RE, "|").replace($9cf3e6406bb1dafb$var$ENC_BRACKET_OPEN_RE, "[").replace($9cf3e6406bb1dafb$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $9cf3e6406bb1dafb$export$3a6d5c9ae78a2c08(text) {
    return $9cf3e6406bb1dafb$var$commonEncode(text).replace($9cf3e6406bb1dafb$var$ENC_CURLY_OPEN_RE, "{").replace($9cf3e6406bb1dafb$var$ENC_CURLY_CLOSE_RE, "}").replace($9cf3e6406bb1dafb$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $9cf3e6406bb1dafb$var$encodeQueryValue(text) {
    return $9cf3e6406bb1dafb$var$commonEncode(text).replace($9cf3e6406bb1dafb$var$PLUS_RE, "%2B").replace($9cf3e6406bb1dafb$var$ENC_SPACE_RE, "+").replace($9cf3e6406bb1dafb$var$HASH_RE, "%23").replace($9cf3e6406bb1dafb$var$AMPERSAND_RE, "%26").replace($9cf3e6406bb1dafb$var$ENC_BACKTICK_RE, "`").replace($9cf3e6406bb1dafb$var$ENC_CURLY_OPEN_RE, "{").replace($9cf3e6406bb1dafb$var$ENC_CURLY_CLOSE_RE, "}").replace($9cf3e6406bb1dafb$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $9cf3e6406bb1dafb$var$encodeQueryKey(text) {
    return $9cf3e6406bb1dafb$var$encodeQueryValue(text).replace($9cf3e6406bb1dafb$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $9cf3e6406bb1dafb$export$2329c99376c9d0a4(text) {
    return $9cf3e6406bb1dafb$var$commonEncode(text).replace($9cf3e6406bb1dafb$var$HASH_RE, "%23").replace($9cf3e6406bb1dafb$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $9cf3e6406bb1dafb$export$71cec2538cb2c617(text) {
    return $9cf3e6406bb1dafb$export$2329c99376c9d0a4(text).replace($9cf3e6406bb1dafb$var$SLASH_RE, "%2F");
}
function $9cf3e6406bb1dafb$export$7f8ddf7c7c20b3cd(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
//#endregion
//#region src/location.ts
const $9cf3e6406bb1dafb$var$TRAILING_SLASH_RE = /\/$/;
const $9cf3e6406bb1dafb$var$removeTrailingSlash = (path)=>path.replace($9cf3e6406bb1dafb$var$TRAILING_SLASH_RE, "");
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $9cf3e6406bb1dafb$export$db202ddc8be9136(parseQuery$1, location, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    const hashPos = location.indexOf("#");
    let searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery$1(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $9cf3e6406bb1dafb$export$df995fae86a55f06(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $9cf3e6406bb1dafb$export$7f8ddf7c7c20b3cd(hash)
    };
}
function $9cf3e6406bb1dafb$export$a07804094c3ecf2d(stringifyQuery$1, path, query, hash = "") {
    const searchText = stringifyQuery$1(query);
    return path + (searchText && "?") + searchText + $9cf3e6406bb1dafb$export$3a6d5c9ae78a2c08(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $9cf3e6406bb1dafb$export$ef35774e6d314e91(stringifyQuery$1, location) {
    const query = location.query ? stringifyQuery$1(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $9cf3e6406bb1dafb$export$e7c866399fa523f5(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $9cf3e6406bb1dafb$export$d66501df72047452(stringifyQuery$1, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $9cf3e6406bb1dafb$export$61196ced6d74a310(a.matched[aLastIndex], b.matched[bLastIndex]) && $9cf3e6406bb1dafb$export$9bb611d729802a56(a.params, b.params) && stringifyQuery$1(a.query) === stringifyQuery$1(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $9cf3e6406bb1dafb$export$61196ced6d74a310(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $9cf3e6406bb1dafb$export$9bb611d729802a56(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$9cf3e6406bb1dafb$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $9cf3e6406bb1dafb$var$isSameRouteLocationParamsValue(a, b) {
    return $9cf3e6406bb1dafb$export$78acf4525d8a74c4(a) ? $9cf3e6406bb1dafb$var$isEquivalentArray(a, b) : $9cf3e6406bb1dafb$export$78acf4525d8a74c4(b) ? $9cf3e6406bb1dafb$var$isEquivalentArray(b, a) : a?.valueOf() === b?.valueOf();
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $9cf3e6406bb1dafb$var$isEquivalentArray(a, b) {
    return $9cf3e6406bb1dafb$export$78acf4525d8a74c4(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $9cf3e6406bb1dafb$export$df995fae86a55f06(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ const $9cf3e6406bb1dafb$export$56c0d5a1e737357d = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
let $9cf3e6406bb1dafb$export$342063e11d6c3cad = /* @__PURE__ */ function(NavigationType$1) {
    NavigationType$1["pop"] = "pop";
    NavigationType$1["push"] = "push";
    return NavigationType$1;
}({});
let $9cf3e6406bb1dafb$export$c4ce752e73470fba = /* @__PURE__ */ function(NavigationDirection$1) {
    NavigationDirection$1["back"] = "back";
    NavigationDirection$1["forward"] = "forward";
    NavigationDirection$1["unknown"] = "";
    return NavigationDirection$1;
}({});
/**
* Starting location for Histories
*/ const $9cf3e6406bb1dafb$export$ebd11618f299a286 = "";
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $9cf3e6406bb1dafb$export$3a1a48c8f6ef640e(base) {
    if (!base) {
        if ($9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9) {
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $9cf3e6406bb1dafb$var$removeTrailingSlash(base);
}
const $9cf3e6406bb1dafb$var$BEFORE_HASH_RE = /^[^#]+#/;
function $9cf3e6406bb1dafb$export$35e795649ee09318(base, location) {
    return base.replace($9cf3e6406bb1dafb$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $9cf3e6406bb1dafb$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $9cf3e6406bb1dafb$export$e7094788287c5e9b = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $9cf3e6406bb1dafb$export$96f57966bedc81b4(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $9cf3e6406bb1dafb$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $9cf3e6406bb1dafb$export$971d5caa766a69d7(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
const $9cf3e6406bb1dafb$var$scrollPositions = /* @__PURE__ */ new Map();
function $9cf3e6406bb1dafb$export$a9c23c6ac3fc3eca(key, scrollPosition) {
    $9cf3e6406bb1dafb$var$scrollPositions.set(key, scrollPosition);
}
function $9cf3e6406bb1dafb$export$efccba1c4a2ef57b(key) {
    const scroll = $9cf3e6406bb1dafb$var$scrollPositions.get(key);
    $9cf3e6406bb1dafb$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $9cf3e6406bb1dafb$export$d141bba7fdc215a3(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $9cf3e6406bb1dafb$export$25ce5a424b770e84(name) {
    return typeof name === "string" || typeof name === "symbol";
}
//#endregion
//#region src/errors.ts
/**
* Flags so we can combine them when checking for multiple errors. This is the internal version of
* {@link NavigationFailureType}.
*
* @internal
*/ let $9cf3e6406bb1dafb$export$71511d61b312f219 = /* @__PURE__ */ function(ErrorTypes$1) {
    ErrorTypes$1[ErrorTypes$1["MATCHER_NOT_FOUND"] = 1] = "MATCHER_NOT_FOUND";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_GUARD_REDIRECT"] = 2] = "NAVIGATION_GUARD_REDIRECT";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_ABORTED"] = 4] = "NAVIGATION_ABORTED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_CANCELLED"] = 8] = "NAVIGATION_CANCELLED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_DUPLICATED"] = 16] = "NAVIGATION_DUPLICATED";
    return ErrorTypes$1;
}({});
const $9cf3e6406bb1dafb$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ let $9cf3e6406bb1dafb$export$90a7f3efeed30595 = /* @__PURE__ */ function(NavigationFailureType$1) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType$1[NavigationFailureType$1["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType$1[NavigationFailureType$1["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType$1[NavigationFailureType$1["duplicated"] = 16] = "duplicated";
    return NavigationFailureType$1;
}({});
const $9cf3e6406bb1dafb$var$ErrorTypeMessages = {
    [$9cf3e6406bb1dafb$export$71511d61b312f219.MATCHER_NOT_FOUND] ({ location: location, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [$9cf3e6406bb1dafb$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$9cf3e6406bb1dafb$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [$9cf3e6406bb1dafb$export$71511d61b312f219.NAVIGATION_ABORTED] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [$9cf3e6406bb1dafb$export$71511d61b312f219.NAVIGATION_CANCELLED] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [$9cf3e6406bb1dafb$export$71511d61b312f219.NAVIGATION_DUPLICATED] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $9cf3e6406bb1dafb$export$4a5767248b18ef41(type, params) {
    return $9cf3e6406bb1dafb$export$b4171a6734a65d42(/* @__PURE__ */ new Error(), {
        type: type,
        [$9cf3e6406bb1dafb$var$NavigationFailureSymbol]: true
    }, params);
}
function $9cf3e6406bb1dafb$export$8b22cf2602fb60ce(error, type) {
    return error instanceof Error && $9cf3e6406bb1dafb$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $9cf3e6406bb1dafb$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $9cf3e6406bb1dafb$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location = {};
    for (const key of $9cf3e6406bb1dafb$var$propertiesToLog)if (key in to) location[key] = to[key];
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $9cf3e6406bb1dafb$export$dda1d9f60106f0e9(search) {
    const query = {};
    if (search === "" || search === "?") return query;
    const searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        const searchParam = searchParams[i].replace($9cf3e6406bb1dafb$var$PLUS_RE, " ");
        const eqPos = searchParam.indexOf("=");
        const key = $9cf3e6406bb1dafb$export$7f8ddf7c7c20b3cd(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $9cf3e6406bb1dafb$export$7f8ddf7c7c20b3cd(searchParam.slice(eqPos + 1));
        if (key in query) {
            let currentValue = query[key];
            if (!$9cf3e6406bb1dafb$export$78acf4525d8a74c4(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $9cf3e6406bb1dafb$export$39b482c5e57630a8(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $9cf3e6406bb1dafb$var$encodeQueryKey(key);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key;
            continue;
        }
        ($9cf3e6406bb1dafb$export$78acf4525d8a74c4(value) ? value.map((v)=>v && $9cf3e6406bb1dafb$var$encodeQueryValue(v)) : [
            value && $9cf3e6406bb1dafb$var$encodeQueryValue(value)
        ]).forEach((value$1)=>{
            if (value$1 !== void 0) {
                search += (search.length ? "&" : "") + key;
                if (value$1 != null) search += "=" + value$1;
            }
        });
    }
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $9cf3e6406bb1dafb$export$953cecd6e717a553(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== void 0) normalizedQuery[key] = $9cf3e6406bb1dafb$export$78acf4525d8a74c4(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ const $9cf3e6406bb1dafb$export$882b5998b3b9117c = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ const $9cf3e6406bb1dafb$export$ffb5f4729a158638 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ const $9cf3e6406bb1dafb$export$4368d992c4eafac0 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ const $9cf3e6406bb1dafb$export$3b14a55fb2447963 = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ const $9cf3e6406bb1dafb$export$2d1720544b23b823 = Symbol("");
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $9cf3e6406bb1dafb$export$db3b6bfb95261072() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $9cf3e6406bb1dafb$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $8zRru.onUnmounted)(removeFromList);
    (0, $8zRru.onDeactivated)(removeFromList);
    (0, $8zRru.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $9cf3e6406bb1dafb$export$ae1af26003f05816(leaveGuard) {
    const activeRecord = (0, $8zRru.inject)($9cf3e6406bb1dafb$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $9cf3e6406bb1dafb$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $9cf3e6406bb1dafb$export$2408f22a0fab9ae5(updateGuard) {
    const activeRecord = (0, $8zRru.inject)($9cf3e6406bb1dafb$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $9cf3e6406bb1dafb$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $9cf3e6406bb1dafb$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    const enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($9cf3e6406bb1dafb$export$4a5767248b18ef41($9cf3e6406bb1dafb$export$71511d61b312f219.NAVIGATION_ABORTED, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($9cf3e6406bb1dafb$export$d141bba7fdc215a3(valid)) reject($9cf3e6406bb1dafb$export$4a5767248b18ef41($9cf3e6406bb1dafb$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $9cf3e6406bb1dafb$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $9cf3e6406bb1dafb$export$3466f893ebf79586(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $9cf3e6406bb1dafb$export$43caf9889c228507(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($9cf3e6406bb1dafb$var$isRouteComponent(rawComponent)) {
            const guard = (rawComponent.__vccOpts || rawComponent)[guardType];
            guard && guards.push($9cf3e6406bb1dafb$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
        } else {
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $9cf3e6406bb1dafb$var$isESModule(resolved) ? resolved.default : resolved;
                    record.mods[name] = resolved;
                    record.components[name] = resolvedComponent;
                    const guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                    return guard && $9cf3e6406bb1dafb$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $9cf3e6406bb1dafb$export$407448d2b89b1813(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $9cf3e6406bb1dafb$var$isESModule(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, [])))).then(()=>route);
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $9cf3e6406bb1dafb$export$7ccc53e8f1e7dfc5(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$9cf3e6406bb1dafb$export$61196ced6d74a310(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find((record)=>$9cf3e6406bb1dafb$export$61196ced6d74a310(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $9cf3e6406bb1dafb$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $9cf3e6406bb1dafb$export$b4171a6734a65d42({}, routeLocation, {
        matched: routeLocation.matched.map((matched)=>$9cf3e6406bb1dafb$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $9cf3e6406bb1dafb$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
let $9cf3e6406bb1dafb$var$routerId = 0;
function $9cf3e6406bb1dafb$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    const id = $9cf3e6406bb1dafb$var$routerId++;
    (0, $b25fb7fa660e1e93$export$63b9a9bba9f20f3e)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $9cf3e6406bb1dafb$export$3466f893ebf79586("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $9cf3e6406bb1dafb$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $9cf3e6406bb1dafb$var$PINK_500
                });
            }
            if ($9cf3e6406bb1dafb$export$78acf4525d8a74c4(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $9cf3e6406bb1dafb$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $9cf3e6406bb1dafb$var$RED_100;
                        textColor = $9cf3e6406bb1dafb$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $9cf3e6406bb1dafb$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $9cf3e6406bb1dafb$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $g90JB.watch)(router.currentRoute, ()=>{
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 4237508
        });
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $9cf3e6406bb1dafb$var$formatDisplay("beforeEach"),
                from: $9cf3e6406bb1dafb$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $9cf3e6406bb1dafb$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $9cf3e6406bb1dafb$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $9cf3e6406bb1dafb$var$formatDisplay("\u274C");
            } else data.status = $9cf3e6406bb1dafb$var$formatDisplay("\u2705");
            data.from = $9cf3e6406bb1dafb$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $9cf3e6406bb1dafb$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            let routes = matcher.getRoutes().filter((route)=>!route.parent || !route.parent.record.components);
            routes.forEach($9cf3e6406bb1dafb$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter((route)=>$9cf3e6406bb1dafb$var$isRouteMatching(route, payload.filter.toLowerCase()));
            routes.forEach((route)=>$9cf3e6406bb1dafb$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($9cf3e6406bb1dafb$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const route = matcher.getRoutes().find((route$1)=>route$1.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $9cf3e6406bb1dafb$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $9cf3e6406bb1dafb$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $9cf3e6406bb1dafb$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$9cf3e6406bb1dafb$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ const $9cf3e6406bb1dafb$var$PINK_500 = 15485081;
const $9cf3e6406bb1dafb$var$BLUE_600 = 2450411;
const $9cf3e6406bb1dafb$var$LIME_500 = 8702998;
const $9cf3e6406bb1dafb$var$CYAN_400 = 2282478;
const $9cf3e6406bb1dafb$var$ORANGE_400 = 16486972;
const $9cf3e6406bb1dafb$var$DARK = 6710886;
const $9cf3e6406bb1dafb$var$RED_100 = 16704226;
const $9cf3e6406bb1dafb$var$RED_700 = 12131356;
function $9cf3e6406bb1dafb$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $9cf3e6406bb1dafb$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $9cf3e6406bb1dafb$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $9cf3e6406bb1dafb$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $9cf3e6406bb1dafb$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $9cf3e6406bb1dafb$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 16777215,
        backgroundColor: $9cf3e6406bb1dafb$var$DARK
    });
    let id = record.__vd_id;
    if (id == null) {
        id = String($9cf3e6406bb1dafb$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($9cf3e6406bb1dafb$var$formatRouteRecordForInspector)
    };
}
let $9cf3e6406bb1dafb$var$routeRecordId = 0;
const $9cf3e6406bb1dafb$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $9cf3e6406bb1dafb$var$markRouteRecordActive(route, currentRoute) {
    const isExactActive = currentRoute.matched.length && $9cf3e6406bb1dafb$export$61196ced6d74a310(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$9cf3e6406bb1dafb$export$61196ced6d74a310(match, route.record));
    route.children.forEach((childRoute)=>$9cf3e6406bb1dafb$var$markRouteRecordActive(childRoute, currentRoute));
}
function $9cf3e6406bb1dafb$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($9cf3e6406bb1dafb$var$resetMatchStateOnRouteRecord);
}
function $9cf3e6406bb1dafb$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($9cf3e6406bb1dafb$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach((child)=>$9cf3e6406bb1dafb$var$isRouteMatching(child, filter));
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $9cf3e6406bb1dafb$export$7f8ddf7c7c20b3cd(path);
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$9cf3e6406bb1dafb$var$isRouteMatching(child, filter));
}
function $9cf3e6406bb1dafb$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}


parcelRequire("a38K9");
var $g90JB = parcelRequire("g90JB");
var $8zRru = parcelRequire("8zRru");
//#region src/history/html5.ts
let $3d1dd3bf1a44e5c2$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
* Creates a normalized history location from a window.location object
* @param base - The base path
* @param location - The window.location object
*/ function $3d1dd3bf1a44e5c2$var$createCurrentLocation(base, location$1) {
    const { pathname: pathname, search: search, hash: hash } = location$1;
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return (0, $9cf3e6406bb1dafb$export$e7c866399fa523f5)(pathFromHash, "");
    }
    return (0, $9cf3e6406bb1dafb$export$e7c866399fa523f5)(pathname, base) + search + hash;
}
function $3d1dd3bf1a44e5c2$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $3d1dd3bf1a44e5c2$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: (0, $9cf3e6406bb1dafb$export$342063e11d6c3cad).pop,
                direction: delta ? delta > 0 ? (0, $9cf3e6406bb1dafb$export$c4ce752e73470fba).forward : (0, $9cf3e6406bb1dafb$export$c4ce752e73470fba).back : (0, $9cf3e6406bb1dafb$export$c4ce752e73470fba).unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        if (document.visibilityState === "hidden") {
            const { history: history$1 } = window;
            if (!history$1.state) return;
            history$1.replaceState((0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, history$1.state, {
                scroll: (0, $9cf3e6406bb1dafb$export$e7094788287c5e9b)()
            }), "");
        }
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("pagehide", beforeUnloadListener);
        document.removeEventListener("visibilitychange", beforeUnloadListener);
    }
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("pagehide", beforeUnloadListener);
    document.addEventListener("visibilitychange", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
* Creates a state object
*/ function $3d1dd3bf1a44e5c2$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? (0, $9cf3e6406bb1dafb$export$e7094788287c5e9b)() : null
    };
}
function $3d1dd3bf1a44e5c2$var$useHistoryStateNavigation(base) {
    const { history: history$1, location: location$1 } = window;
    const currentLocation = {
        value: $3d1dd3bf1a44e5c2$var$createCurrentLocation(base, location$1)
    };
    const historyState = {
        value: history$1.state
    };
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        position: history$1.length - 1,
        replaced: true,
        scroll: null
    }, true);
    function changeLocation(to, state, replace$1) {
        /**
		* if a base tag is provided, and we are on a normal domain, we have to
		* respect the provided `base` attribute because pushState() will use it and
		* potentially erase anything before the `#` like at
		* https://github.com/vuejs/router/issues/685 where a base of
		* `/folder/#` but a base of `/` would erase the `/folder/` section. If
		* there is no host, the `<base>` tag makes no sense and if there isn't a
		* base tag we can just use everything after the `#`.
		*/ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location$1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $3d1dd3bf1a44e5c2$var$createBaseLocation() + base + to;
        try {
            history$1[replace$1 ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            location$1[replace$1 ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        changeLocation(to, (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, history$1.state, $3d1dd3bf1a44e5c2$var$buildState(historyState.value.back, to, historyState.value.forward, true), data, {
            position: historyState.value.position
        }), true);
        currentLocation.value = to;
    }
    function push(to, data) {
        const currentState = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, historyState.value, history$1.state, {
            forward: to,
            scroll: (0, $9cf3e6406bb1dafb$export$e7094788287c5e9b)()
        });
        changeLocation(currentState.current, currentState, true);
        changeLocation(to, (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, $3d1dd3bf1a44e5c2$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data), false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
* Creates an HTML5 history. Most common history for single page applications.
*
* @param base -
*/ function $3d1dd3bf1a44e5c2$export$7b4942f78e7b8a49(base) {
    base = (0, $9cf3e6406bb1dafb$export$3a1a48c8f6ef640e)(base);
    const historyNavigation = $3d1dd3bf1a44e5c2$var$useHistoryStateNavigation(base);
    const historyListeners = $3d1dd3bf1a44e5c2$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({
        location: "",
        base: base,
        go: go,
        createHref: (0, $9cf3e6406bb1dafb$export$35e795649ee09318).bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
//#endregion
//#region src/history/memory.ts
/**
* Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
* It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
*
* @param base - Base applied to all urls, defaults to '/'
* @returns a history object that can be passed to the router constructor
*/ function $3d1dd3bf1a44e5c2$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        [
            (0, $9cf3e6406bb1dafb$export$ebd11618f299a286),
            {}
        ]
    ];
    let position = 0;
    base = (0, $9cf3e6406bb1dafb$export$3a1a48c8f6ef640e)(base);
    function setLocation(location$1, state = {}) {
        position++;
        if (position !== queue.length) queue.splice(position);
        queue.push([
            location$1,
            state
        ]);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: (0, $9cf3e6406bb1dafb$export$342063e11d6c3cad).pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        location: (0, $9cf3e6406bb1dafb$export$ebd11618f299a286),
        state: {},
        base: base,
        createHref: (0, $9cf3e6406bb1dafb$export$35e795649ee09318).bind(null, base),
        replace (to, state) {
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push (to, state) {
            setLocation(to, state);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                [
                    (0, $9cf3e6406bb1dafb$export$ebd11618f299a286),
                    {}
                ]
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = delta < 0 ? (0, $9cf3e6406bb1dafb$export$c4ce752e73470fba).back : (0, $9cf3e6406bb1dafb$export$c4ce752e73470fba).forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position][0]
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>queue[position][1]
    });
    return routerHistory;
}
//#endregion
//#region src/history/hash.ts
/**
* Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
* handle any URL is not possible.
*
* @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
* in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
* calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
* after the `#`).
*
* @example
* ```js
* // at https://example.com/folder
* createWebHashHistory() // gives a url of `https://example.com/folder#`
* createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
* // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
* createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
* // you should avoid doing this because it changes the original url and breaks copying urls
* createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
*
* // at file:///usr/etc/folder/index.html
* // for locations with no `host`, the base is ignored
* createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
* ```
*/ function $3d1dd3bf1a44e5c2$export$542bc3a76486c94d(base) {
    base = location.host ? base || location.pathname + location.search : "";
    if (!base.includes("#")) base += "#";
    return $3d1dd3bf1a44e5c2$export$7b4942f78e7b8a49(base);
}
//#endregion
//#region src/matcher/pathTokenizer.ts
let $3d1dd3bf1a44e5c2$var$TokenType = /* @__PURE__ */ function(TokenType$1) {
    TokenType$1[TokenType$1["Static"] = 0] = "Static";
    TokenType$1[TokenType$1["Param"] = 1] = "Param";
    TokenType$1[TokenType$1["Group"] = 2] = "Group";
    return TokenType$1;
}({});
var $3d1dd3bf1a44e5c2$var$TokenizerState = /* @__PURE__ */ function(TokenizerState$1) {
    TokenizerState$1[TokenizerState$1["Static"] = 0] = "Static";
    TokenizerState$1[TokenizerState$1["Param"] = 1] = "Param";
    TokenizerState$1[TokenizerState$1["ParamRegExp"] = 2] = "ParamRegExp";
    TokenizerState$1[TokenizerState$1["ParamRegExpEnd"] = 3] = "ParamRegExpEnd";
    TokenizerState$1[TokenizerState$1["EscapeNext"] = 4] = "EscapeNext";
    return TokenizerState$1;
}($3d1dd3bf1a44e5c2$var$TokenizerState || {});
const $3d1dd3bf1a44e5c2$var$ROOT_TOKEN = {
    type: $3d1dd3bf1a44e5c2$var$TokenType.Static,
    value: ""
};
const $3d1dd3bf1a44e5c2$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
function $3d1dd3bf1a44e5c2$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $3d1dd3bf1a44e5c2$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = $3d1dd3bf1a44e5c2$var$TokenizerState.Static;
    let previousState = state;
    const tokens = [];
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    let i = 0;
    let char;
    let buffer = "";
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === $3d1dd3bf1a44e5c2$var$TokenizerState.Static) segment.push({
            type: $3d1dd3bf1a44e5c2$var$TokenType.Static,
            value: buffer
        });
        else if (state === $3d1dd3bf1a44e5c2$var$TokenizerState.Param || state === $3d1dd3bf1a44e5c2$var$TokenizerState.ParamRegExp || state === $3d1dd3bf1a44e5c2$var$TokenizerState.ParamRegExpEnd) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: $3d1dd3bf1a44e5c2$var$TokenType.Param,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== $3d1dd3bf1a44e5c2$var$TokenizerState.ParamRegExp) {
            previousState = state;
            state = $3d1dd3bf1a44e5c2$var$TokenizerState.EscapeNext;
            continue;
        }
        switch(state){
            case $3d1dd3bf1a44e5c2$var$TokenizerState.Static:
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = $3d1dd3bf1a44e5c2$var$TokenizerState.Param;
                } else addCharToBuffer();
                break;
            case $3d1dd3bf1a44e5c2$var$TokenizerState.EscapeNext:
                addCharToBuffer();
                state = previousState;
                break;
            case $3d1dd3bf1a44e5c2$var$TokenizerState.Param:
                if (char === "(") state = $3d1dd3bf1a44e5c2$var$TokenizerState.ParamRegExp;
                else if ($3d1dd3bf1a44e5c2$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = $3d1dd3bf1a44e5c2$var$TokenizerState.Static;
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case $3d1dd3bf1a44e5c2$var$TokenizerState.ParamRegExp:
                if (char === ")") {
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = $3d1dd3bf1a44e5c2$var$TokenizerState.ParamRegExpEnd;
                } else customRe += char;
                break;
            case $3d1dd3bf1a44e5c2$var$TokenizerState.ParamRegExpEnd:
                consumeBuffer();
                state = $3d1dd3bf1a44e5c2$var$TokenizerState.Static;
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === $3d1dd3bf1a44e5c2$var$TokenizerState.ParamRegExp) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    return tokens;
}
//#endregion
//#region src/matcher/pathParserRanker.ts
const $3d1dd3bf1a44e5c2$var$BASE_PARAM_PATTERN = "[^/]+?";
const $3d1dd3bf1a44e5c2$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
var $3d1dd3bf1a44e5c2$var$PathScore = /* @__PURE__ */ function(PathScore$1) {
    PathScore$1[PathScore$1["_multiplier"] = 10] = "_multiplier";
    PathScore$1[PathScore$1["Root"] = 90] = "Root";
    PathScore$1[PathScore$1["Segment"] = 40] = "Segment";
    PathScore$1[PathScore$1["SubSegment"] = 30] = "SubSegment";
    PathScore$1[PathScore$1["Static"] = 40] = "Static";
    PathScore$1[PathScore$1["Dynamic"] = 20] = "Dynamic";
    PathScore$1[PathScore$1["BonusCustomRegExp"] = 10] = "BonusCustomRegExp";
    PathScore$1[PathScore$1["BonusWildcard"] = -50] = "BonusWildcard";
    PathScore$1[PathScore$1["BonusRepeatable"] = -20] = "BonusRepeatable";
    PathScore$1[PathScore$1["BonusOptional"] = -8] = "BonusOptional";
    PathScore$1[PathScore$1["BonusStrict"] = .7000000000000001] = "BonusStrict";
    PathScore$1[PathScore$1["BonusCaseSensitive"] = .25] = "BonusCaseSensitive";
    return PathScore$1;
}($3d1dd3bf1a44e5c2$var$PathScore || {});
const $3d1dd3bf1a44e5c2$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
* Creates a path parser from an array of Segments (a segment is an array of Tokens)
*
* @param segments - array of segments returned by tokenizePath
* @param extraOptions - optional options for the regexp
* @returns a PathParser
*/ function $3d1dd3bf1a44e5c2$var$tokensToParser(segments, extraOptions) {
    const options = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, $3d1dd3bf1a44e5c2$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    const score = [];
    let pattern = options.start ? "^" : "";
    const keys = [];
    for (const segment of segments){
        const segmentScores = segment.length ? [] : [
            $3d1dd3bf1a44e5c2$var$PathScore.Root
        ];
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            let subSegmentScore = $3d1dd3bf1a44e5c2$var$PathScore.Segment + (options.sensitive ? $3d1dd3bf1a44e5c2$var$PathScore.BonusCaseSensitive : 0);
            if (token.type === $3d1dd3bf1a44e5c2$var$TokenType.Static) {
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($3d1dd3bf1a44e5c2$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += $3d1dd3bf1a44e5c2$var$PathScore.Static;
            } else if (token.type === $3d1dd3bf1a44e5c2$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re$1 = regexp ? regexp : $3d1dd3bf1a44e5c2$var$BASE_PARAM_PATTERN;
                if (re$1 !== $3d1dd3bf1a44e5c2$var$BASE_PARAM_PATTERN) subSegmentScore += $3d1dd3bf1a44e5c2$var$PathScore.BonusCustomRegExp;
                let subPattern = repeatable ? `((?:${re$1})(?:/(?:${re$1}))*)` : `(${re$1})`;
                if (!tokenIndex) subPattern = optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += $3d1dd3bf1a44e5c2$var$PathScore.Dynamic;
                if (optional) subSegmentScore += $3d1dd3bf1a44e5c2$var$PathScore.BonusOptional;
                if (repeatable) subSegmentScore += $3d1dd3bf1a44e5c2$var$PathScore.BonusRepeatable;
                if (re$1 === ".*") subSegmentScore += $3d1dd3bf1a44e5c2$var$PathScore.BonusWildcard;
            }
            segmentScores.push(subSegmentScore);
        }
        score.push(segmentScores);
    }
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += $3d1dd3bf1a44e5c2$var$PathScore.BonusStrict;
    }
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict && !pattern.endsWith("/")) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment)if (token.type === $3d1dd3bf1a44e5c2$var$TokenType.Static) path += token.value;
            else if (token.type === $3d1dd3bf1a44e5c2$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional } = token;
                const param = value in params ? params[value] : "";
                if ((0, $9cf3e6406bb1dafb$export$78acf4525d8a74c4)(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                const text = (0, $9cf3e6406bb1dafb$export$78acf4525d8a74c4)(param) ? param.join("/") : param;
                if (!text) {
                    if (optional) {
                        if (segment.length < 2) {
                            if (path.endsWith("/")) path = path.slice(0, -1);
                            else avoidDuplicatedSlash = true;
                        }
                    } else throw new Error(`Missing required param "${value}"`);
                }
                path += text;
            }
        }
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
* Compares an array of numbers as used in PathParser.score and returns a
* number. This function can be used to `sort` an array
*
* @param a - first array of numbers
* @param b - second array of numbers
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
* should be sorted first
*/ function $3d1dd3bf1a44e5c2$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        if (diff) return diff;
        i++;
    }
    if (a.length < b.length) return a.length === 1 && a[0] === $3d1dd3bf1a44e5c2$var$PathScore.Static + $3d1dd3bf1a44e5c2$var$PathScore.Segment ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === $3d1dd3bf1a44e5c2$var$PathScore.Static + $3d1dd3bf1a44e5c2$var$PathScore.Segment ? 1 : -1;
    return 0;
}
/**
* Compare function that can be used with `sort` to sort an array of PathParser
*
* @param a - first PathParser
* @param b - second PathParser
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
*/ function $3d1dd3bf1a44e5c2$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $3d1dd3bf1a44e5c2$var$compareScoreArray(aScore[i], bScore[i]);
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($3d1dd3bf1a44e5c2$var$isLastScoreNegative(aScore)) return 1;
        if ($3d1dd3bf1a44e5c2$var$isLastScoreNegative(bScore)) return -1;
    }
    return bScore.length - aScore.length;
}
/**
* This allows detecting splats at the end of a path: /home/:id(.*)*
*
* @param score - score to check
* @returns true if the last entry is negative
*/ function $3d1dd3bf1a44e5c2$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $3d1dd3bf1a44e5c2$var$PATH_PARSER_OPTIONS_DEFAULTS = {
    strict: false,
    end: true,
    sensitive: false
};
//#endregion
//#region src/matcher/pathMatcher.ts
function $3d1dd3bf1a44e5c2$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $3d1dd3bf1a44e5c2$var$tokensToParser($3d1dd3bf1a44e5c2$var$tokenizePath(record.path), options);
    const matcher = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)(parser, {
        record: record,
        parent: parent,
        children: [],
        alias: []
    });
    if (parent) {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
//#endregion
//#region src/matcher/index.ts
/**
* Creates a Router Matcher.
*
* @internal
* @param routes - array of initial routes
* @param globalOptions - global route options
*/ function $3d1dd3bf1a44e5c2$export$36302c85fdcc95a8(routes, globalOptions) {
    const matchers = [];
    const matcherMap = /* @__PURE__ */ new Map();
    globalOptions = (0, $9cf3e6406bb1dafb$export$dc98b0b04f4c7758)($3d1dd3bf1a44e5c2$var$PATH_PARSER_OPTIONS_DEFAULTS, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $3d1dd3bf1a44e5c2$var$normalizeRouteRecord(record);
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = (0, $9cf3e6406bb1dafb$export$dc98b0b04f4c7758)(globalOptions, record);
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($3d1dd3bf1a44e5c2$var$normalizeRouteRecord((0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, mainNormalizedRecord, {
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            matcher = $3d1dd3bf1a44e5c2$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                if (isRootAdd && record.name && !$3d1dd3bf1a44e5c2$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if ($3d1dd3bf1a44e5c2$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            originalRecord = originalRecord || matcher;
        }
        return originalMatcher ? ()=>{
            removeRoute(originalMatcher);
        } : (0, $9cf3e6406bb1dafb$export$3722cfe417b6ed86);
    }
    function removeRoute(matcherRef) {
        if ((0, $9cf3e6406bb1dafb$export$25ce5a424b770e84)(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $3d1dd3bf1a44e5c2$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        if (matcher.record.name && !$3d1dd3bf1a44e5c2$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location$1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location$1 && location$1.name) {
            matcher = matcherMap.get(location$1.name);
            if (!matcher) throw (0, $9cf3e6406bb1dafb$export$4a5767248b18ef41)((0, $9cf3e6406bb1dafb$export$71511d61b312f219).MATCHER_NOT_FOUND, {
                location: location$1
            });
            name = matcher.record.name;
            params = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)($3d1dd3bf1a44e5c2$var$pickParams(currentLocation.params, matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), location$1.params && $3d1dd3bf1a44e5c2$var$pickParams(location$1.params, matcher.keys.map((k)=>k.name)));
            path = matcher.stringify(params);
        } else if (location$1.path != null) {
            path = location$1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            if (matcher) {
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        } else {
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw (0, $9cf3e6406bb1dafb$export$4a5767248b18ef41)((0, $9cf3e6406bb1dafb$export$71511d61b312f219).MATCHER_NOT_FOUND, {
                location: location$1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            params = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, currentLocation.params, location$1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $3d1dd3bf1a44e5c2$var$mergeMetaFields(matched)
        };
    }
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
/**
* Picks an object param to contain only specified keys.
*
* @param params - params object to pick from
* @param keys - keys to pick
*/ function $3d1dd3bf1a44e5c2$var$pickParams(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
* Normalizes a RouteRecordRaw. Creates a copy
*
* @param record
* @returns the normalized version
*/ function $3d1dd3bf1a44e5c2$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $3d1dd3bf1a44e5c2$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: /* @__PURE__ */ new Set(),
        updateGuards: /* @__PURE__ */ new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
* Normalize the optional `props` in a record to always be an object similar to
* components. Also accept a boolean for components.
* @param record
*/ function $3d1dd3bf1a44e5c2$var$normalizeRecordProps(record) {
    const propsObject = {};
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
* Checks if a record or any of its parent is an alias
* @param record
*/ function $3d1dd3bf1a44e5c2$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
* Merge meta fields of an array of records
*
* @param matched - array of matched records
*/ function $3d1dd3bf1a44e5c2$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>(0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)(meta, record.meta), {});
}
function $3d1dd3bf1a44e5c2$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
* Check if a path and its alias have the same required params
*
* @param a - original record
* @param b - alias record
*/ function $3d1dd3bf1a44e5c2$var$checkSameParams(a, b) {
    for (const key of a.keys)if (!key.optional && !b.keys.find($3d1dd3bf1a44e5c2$var$isSameParam.bind(null, key))) return (0, $9cf3e6406bb1dafb$export$3466f893ebf79586)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    for (const key of b.keys)if (!key.optional && !a.keys.find($3d1dd3bf1a44e5c2$var$isSameParam.bind(null, key))) return (0, $9cf3e6406bb1dafb$export$3466f893ebf79586)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
}
/**
* A route with a name and a child with an empty path without a name should warn when adding the route
*
* @param mainNormalizedRecord - RouteRecordNormalized
* @param parent - RouteRecordMatcher
*/ function $3d1dd3bf1a44e5c2$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) (0, $9cf3e6406bb1dafb$export$3466f893ebf79586)(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $3d1dd3bf1a44e5c2$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent)if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? "child" : "descendant"} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
}
function $3d1dd3bf1a44e5c2$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys)if (!record.keys.find($3d1dd3bf1a44e5c2$var$isSameParam.bind(null, key))) return (0, $9cf3e6406bb1dafb$export$3466f893ebf79586)(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
}
/**
* Performs a binary search to find the correct insertion index for a new matcher.
*
* Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
* with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
*
* @param matcher - new matcher to be inserted
* @param matchers - existing matchers
*/ function $3d1dd3bf1a44e5c2$var$findInsertionIndex(matcher, matchers) {
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        if ($3d1dd3bf1a44e5c2$var$comparePathParserScore(matcher, matchers[mid]) < 0) upper = mid;
        else lower = mid + 1;
    }
    const insertionAncestor = $3d1dd3bf1a44e5c2$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $3d1dd3bf1a44e5c2$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent)if ($3d1dd3bf1a44e5c2$var$isMatchable(ancestor) && $3d1dd3bf1a44e5c2$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
}
/**
* Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
* a component, or name, or redirect, are just used to group other routes.
* @param matcher
* @param matcher.record record of the matcher
* @returns
*/ function $3d1dd3bf1a44e5c2$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
//#endregion
//#region src/RouterLink.ts
/**
* Returns the internal behavior of a {@link RouterLink} without the rendering part.
*
* @param props - a `to` location and an optional `replace` flag
*/ function $3d1dd3bf1a44e5c2$export$dcf14c9974fe2767(props) {
    const router = (0, $8zRru.inject)((0, $9cf3e6406bb1dafb$export$4368d992c4eafac0));
    const currentRoute = (0, $8zRru.inject)((0, $9cf3e6406bb1dafb$export$3b14a55fb2447963));
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $g90JB.computed)(()=>{
        const to = (0, $g90JB.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $g90JB.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex((0, $9cf3e6406bb1dafb$export$61196ced6d74a310).bind(null, routeMatched));
        if (index > -1) return index;
        const parentRecordPath = $3d1dd3bf1a44e5c2$var$getOriginalPath(matched[length - 2]);
        return length > 1 && $3d1dd3bf1a44e5c2$var$getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex((0, $9cf3e6406bb1dafb$export$61196ced6d74a310).bind(null, matched[length - 2])) : index;
    });
    const isActive = (0, $g90JB.computed)(()=>activeRecordIndex.value > -1 && $3d1dd3bf1a44e5c2$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $g90JB.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && (0, $9cf3e6406bb1dafb$export$9bb611d729802a56)(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($3d1dd3bf1a44e5c2$var$guardEvent(e)) {
            const p = router[(0, $g90JB.unref)(props.replace) ? "replace" : "push"]((0, $g90JB.unref)(props.to)).catch((0, $9cf3e6406bb1dafb$export$3722cfe417b6ed86));
            if (props.viewTransition && typeof document !== "undefined" && "startViewTransition" in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    if (__VUE_PROD_DEVTOOLS__ && (0, $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9)) {
        const instance = (0, $8zRru.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $8zRru.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = (0, $9cf3e6406bb1dafb$export$d141bba7fdc215a3)((0, $g90JB.unref)(props.to)) ? null : 'Invalid "to" value';
            }, {
                flush: "post"
            });
        }
    }
    /**
	* NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
	*/ return {
        route: route,
        href: (0, $g90JB.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $3d1dd3bf1a44e5c2$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
const $3d1dd3bf1a44e5c2$var$RouterLinkImpl = /* @__PURE__ */ (0, $8zRru.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        },
        viewTransition: Boolean
    },
    useLink: $3d1dd3bf1a44e5c2$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $g90JB.reactive)($3d1dd3bf1a44e5c2$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $8zRru.inject)((0, $9cf3e6406bb1dafb$export$4368d992c4eafac0));
        const elClass = (0, $g90JB.computed)(()=>({
                [$3d1dd3bf1a44e5c2$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                [$3d1dd3bf1a44e5c2$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $3d1dd3bf1a44e5c2$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $8zRru.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
/**
* Component to render a link that triggers a navigation on click.
*/ const $3d1dd3bf1a44e5c2$export$fce709ebdac448ed = $3d1dd3bf1a44e5c2$var$RouterLinkImpl;
function $3d1dd3bf1a44e5c2$var$guardEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;
    if (e.button !== void 0 && e.button !== 0) return;
    if (e.currentTarget && e.currentTarget.getAttribute) {
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $3d1dd3bf1a44e5c2$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else if (!(0, $9cf3e6406bb1dafb$export$78acf4525d8a74c4)(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value.valueOf() !== outerValue[i].valueOf())) return false;
    }
    return true;
}
/**
* Get the original path value of a record by following its aliasOf
* @param record
*/ function $3d1dd3bf1a44e5c2$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
* Utility class to get the active class based on defaults.
* @param propClass
* @param globalClass
* @param defaultClass
*/ const $3d1dd3bf1a44e5c2$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
//#endregion
//#region src/RouterView.ts
const $3d1dd3bf1a44e5c2$var$RouterViewImpl = /* @__PURE__ */ (0, $8zRru.defineComponent)({
    name: "RouterView",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $8zRru.inject)((0, $9cf3e6406bb1dafb$export$2d1720544b23b823));
        const routeToDisplay = (0, $g90JB.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $8zRru.inject)((0, $9cf3e6406bb1dafb$export$ffb5f4729a158638), 0);
        const depth = (0, $g90JB.computed)(()=>{
            let initialDepth = (0, $g90JB.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $g90JB.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $8zRru.provide)((0, $9cf3e6406bb1dafb$export$ffb5f4729a158638), (0, $g90JB.computed)(()=>depth.value + 1));
        (0, $8zRru.provide)((0, $9cf3e6406bb1dafb$export$882b5998b3b9117c), matchedRouteRef);
        (0, $8zRru.provide)((0, $9cf3e6406bb1dafb$export$2d1720544b23b823), routeToDisplay);
        const viewRef = (0, $g90JB.ref)();
        (0, $g90JB.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            if (to) {
                to.instances[name] = instance;
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            if (instance && to && (!from || !(0, $9cf3e6406bb1dafb$export$61196ced6d74a310)(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $3d1dd3bf1a44e5c2$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $8zRru.h)(ViewComponent, (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && (0, $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9) && component.ref) {
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                ((0, $9cf3e6406bb1dafb$export$78acf4525d8a74c4)(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ]).forEach((instance)=>{
                    instance.__vrv_devtools = info;
                });
            }
            return $3d1dd3bf1a44e5c2$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component;
        };
    }
});
function $3d1dd3bf1a44e5c2$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
/**
* Component to display the current route the user is at.
*/ const $3d1dd3bf1a44e5c2$export$d941f00e9b9a537 = $3d1dd3bf1a44e5c2$var$RouterViewImpl;
function $3d1dd3bf1a44e5c2$var$warnDeprecatedUsage() {
    const instance = (0, $8zRru.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        (0, $9cf3e6406bb1dafb$export$3466f893ebf79586)(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.
Use slot props instead:

<router-view v-slot="{ Component }">
  <${comp}>\n    <component :is="Component" />\n  </${comp}>\n</router-view>`);
    }
}
//#endregion
//#region src/router.ts
/**
* Creates a Router instance that can be used by a Vue app.
*
* @param options - {@link RouterOptions}
*/ function $3d1dd3bf1a44e5c2$export$baddd0131ee8c05b(options) {
    const matcher = $3d1dd3bf1a44e5c2$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || (0, $9cf3e6406bb1dafb$export$dda1d9f60106f0e9);
    const stringifyQuery$1 = options.stringifyQuery || (0, $9cf3e6406bb1dafb$export$39b482c5e57630a8);
    const routerHistory = options.history;
    const beforeGuards = (0, $9cf3e6406bb1dafb$export$db3b6bfb95261072)();
    const beforeResolveGuards = (0, $9cf3e6406bb1dafb$export$db3b6bfb95261072)();
    const afterGuards = (0, $9cf3e6406bb1dafb$export$db3b6bfb95261072)();
    const currentRoute = (0, $g90JB.shallowRef)((0, $9cf3e6406bb1dafb$export$56c0d5a1e737357d));
    let pendingLocation = (0, $9cf3e6406bb1dafb$export$56c0d5a1e737357d);
    if ((0, $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9) && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = (0, $9cf3e6406bb1dafb$export$9e5f44173e64f162).bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = (0, $9cf3e6406bb1dafb$export$9e5f44173e64f162).bind(null, (0, $9cf3e6406bb1dafb$export$71cec2538cb2c617));
    const decodeParams = (0, $9cf3e6406bb1dafb$export$9e5f44173e64f162).bind(null, (0, $9cf3e6406bb1dafb$export$7f8ddf7c7c20b3cd));
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ((0, $9cf3e6406bb1dafb$export$25ce5a424b770e84)(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        currentLocation = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = (0, $9cf3e6406bb1dafb$export$db202ddc8be9136)(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute$1 = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href$1 = routerHistory.createHref(locationNormalized.fullPath);
            return (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)(locationNormalized, matchedRoute$1, {
                params: decodeParams(matchedRoute$1.params),
                hash: (0, $9cf3e6406bb1dafb$export$7f8ddf7c7c20b3cd)(locationNormalized.hash),
                redirectedFrom: void 0,
                href: href$1
            });
        }
        let matcherLocation;
        if (rawLocation.path != null) matcherLocation = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, rawLocation, {
            path: (0, $9cf3e6406bb1dafb$export$db202ddc8be9136)(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            const targetParams = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            matcherLocation = (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = (0, $9cf3e6406bb1dafb$export$ef35774e6d314e91)(stringifyQuery$1, (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, rawLocation, {
            hash: (0, $9cf3e6406bb1dafb$export$3a6d5c9ae78a2c08)(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({
            fullPath: fullPath,
            hash: hash,
            query: stringifyQuery$1 === (0, $9cf3e6406bb1dafb$export$39b482c5e57630a8) ? (0, $9cf3e6406bb1dafb$export$953cecd6e717a553)(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: void 0,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? (0, $9cf3e6406bb1dafb$export$db202ddc8be9136)(parseQuery$1, to, currentRoute.value.path) : (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return (0, $9cf3e6406bb1dafb$export$4a5767248b18ef41)((0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_CANCELLED, {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push((0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to, from) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to, from) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                newTargetLocation.params = {};
            }
            return (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({
                query: to.query,
                hash: to.hash,
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        const replace$1 = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation, from);
        if (shouldRedirect) return pushWithRedirect((0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace$1
        }), redirectedFrom || targetLocation);
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && (0, $9cf3e6406bb1dafb$export$d66501df72047452)(stringifyQuery$1, from, targetLocation)) {
            failure = (0, $9cf3e6406bb1dafb$export$4a5767248b18ef41)((0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_DUPLICATED, {
                to: toLocation,
                from: from
            });
            handleScroll(from, from, true, false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>(0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(error) ? (0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(error, (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT) ? error : markAsReady(error) : triggerError(error, toLocation, from)).then((failure$1)=>{
            if (failure$1) {
                if ((0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(failure$1, (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT)) return pushWithRedirect((0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({
                    replace: replace$1
                }, locationAsObject(failure$1.to), {
                    state: typeof failure$1.to === "object" ? (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({}, data, failure$1.to.state) : data,
                    force: force
                }), redirectedFrom || toLocation);
            } else failure$1 = finalizeNavigation(toLocation, from, true, replace$1, data);
            triggerAfterEach(toLocation, from, failure$1);
            return failure$1;
        });
    }
    /**
	* Helper to reject and skip all navigation guards if a new navigation happened
	* @param to
	* @param from
	*/ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = (0, $9cf3e6406bb1dafb$export$7ccc53e8f1e7dfc5)(to, from);
        guards = (0, $9cf3e6406bb1dafb$export$43caf9889c228507)(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push((0, $9cf3e6406bb1dafb$export$23f2a1d2818174ef)(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        return runGuardQueue(guards).then(()=>{
            guards = [];
            for (const guard of beforeGuards.list())guards.push((0, $9cf3e6406bb1dafb$export$23f2a1d2818174ef)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = (0, $9cf3e6406bb1dafb$export$43caf9889c228507)(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push((0, $9cf3e6406bb1dafb$export$23f2a1d2818174ef)(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const record of enteringRecords)if (record.beforeEnter) {
                if ((0, $9cf3e6406bb1dafb$export$78acf4525d8a74c4)(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push((0, $9cf3e6406bb1dafb$export$23f2a1d2818174ef)(beforeEnter, to, from));
                else guards.push((0, $9cf3e6406bb1dafb$export$23f2a1d2818174ef)(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            to.matched.forEach((record)=>record.enterCallbacks = {});
            guards = (0, $9cf3e6406bb1dafb$export$43caf9889c228507)(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push((0, $9cf3e6406bb1dafb$export$23f2a1d2818174ef)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).catch((err)=>(0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(err, (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_CANCELLED) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
	* - Cleans up any navigation guards
	* - Changes the url if necessary
	* - Calls the scrollBehavior
	*/ function finalizeNavigation(toLocation, from, isPush, replace$1, data) {
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        const isFirstNavigation = from === (0, $9cf3e6406bb1dafb$export$56c0d5a1e737357d);
        const state = !(0, $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9) ? {} : history.state;
        if (isPush) {
            if (replace$1 || isFirstNavigation) routerHistory.replace(toLocation.fullPath, (0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    function setupListeners() {
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            const toLocation = resolve(to);
            const shouldRedirect = handleRedirectRecord(toLocation, router.currentRoute.value);
            if (shouldRedirect) {
                pushWithRedirect((0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch((0, $9cf3e6406bb1dafb$export$3722cfe417b6ed86));
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            if (0, $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9) (0, $9cf3e6406bb1dafb$export$a9c23c6ac3fc3eca)((0, $9cf3e6406bb1dafb$export$971d5caa766a69d7)(from.fullPath, info.delta), (0, $9cf3e6406bb1dafb$export$e7094788287c5e9b)());
            navigate(toLocation, from).catch((error)=>{
                if ((0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(error, (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_CANCELLED)) return error;
                if ((0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(error, (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT)) {
                    pushWithRedirect((0, $9cf3e6406bb1dafb$export$b4171a6734a65d42)(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        if ((0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(failure, (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_DUPLICATED) && !info.delta && info.type === (0, $9cf3e6406bb1dafb$export$342063e11d6c3cad).pop) routerHistory.go(-1, false);
                    }).catch((0, $9cf3e6406bb1dafb$export$3722cfe417b6ed86));
                    return Promise.reject();
                }
                if (info.delta) routerHistory.go(-info.delta, false);
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(toLocation, from, false);
                if (failure) {
                    if (info.delta && !(0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(failure, (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_CANCELLED)) routerHistory.go(-info.delta, false);
                    else if (info.type === (0, $9cf3e6406bb1dafb$export$342063e11d6c3cad).pop && (0, $9cf3e6406bb1dafb$export$8b22cf2602fb60ce)(failure, (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $9cf3e6406bb1dafb$export$71511d61b312f219).NAVIGATION_DUPLICATED)) routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch((0, $9cf3e6406bb1dafb$export$3722cfe417b6ed86));
        });
    }
    let readyHandlers = (0, $9cf3e6406bb1dafb$export$db3b6bfb95261072)();
    let errorListeners = (0, $9cf3e6406bb1dafb$export$db3b6bfb95261072)();
    let ready;
    /**
	* Trigger errorListeners added via onError and throws the error as well
	*
	* @param error - error to throw
	* @param to - location we were navigating to when the error happened
	* @param from - location we were navigating from when the error happened
	* @returns the error as a rejected promise
	*/ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== (0, $9cf3e6406bb1dafb$export$56c0d5a1e737357d)) return Promise.resolve();
        return new Promise((resolve$1, reject)=>{
            readyHandlers.add([
                resolve$1,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve$1, reject])=>err ? reject(err) : resolve$1());
            readyHandlers.reset();
        }
        return err;
    }
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!(0, $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9) || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && (0, $9cf3e6406bb1dafb$export$efccba1c4a2ef57b)((0, $9cf3e6406bb1dafb$export$971d5caa766a69d7)(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $8zRru.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && (0, $9cf3e6406bb1dafb$export$96f57966bedc81b4)(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = /* @__PURE__ */ new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            app.component("RouterLink", $3d1dd3bf1a44e5c2$export$fce709ebdac448ed);
            app.component("RouterView", $3d1dd3bf1a44e5c2$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $g90JB.unref)(currentRoute)
            });
            if ((0, $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9) && !started && currentRoute.value === (0, $9cf3e6406bb1dafb$export$56c0d5a1e737357d)) {
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in 0, $9cf3e6406bb1dafb$export$56c0d5a1e737357d)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide((0, $9cf3e6406bb1dafb$export$4368d992c4eafac0), router);
            app.provide((0, $9cf3e6406bb1dafb$export$3b14a55fb2447963), (0, $g90JB.shallowReactive)(reactiveRoute));
            app.provide((0, $9cf3e6406bb1dafb$export$2d1720544b23b823), currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                if (installedApps.size < 1) {
                    pendingLocation = (0, $9cf3e6406bb1dafb$export$56c0d5a1e737357d);
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = (0, $9cf3e6406bb1dafb$export$56c0d5a1e737357d);
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && (0, $9cf3e6406bb1dafb$export$3d8c2f653ac9d0b9)) (0, $9cf3e6406bb1dafb$export$625550452a3fa3ec)(app, router, matcher);
        }
    };
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
//#endregion
//#region src/useApi.ts
/**
* Returns the router instance. Equivalent to using `$router` inside
* templates.
*/ function $3d1dd3bf1a44e5c2$export$9a302a45f65d0572() {
    return (0, $8zRru.inject)((0, $9cf3e6406bb1dafb$export$4368d992c4eafac0));
}
/**
* Returns the current route location. Equivalent to using `$route` inside
* templates.
*/ function $3d1dd3bf1a44e5c2$export$3f79f0b98112cf57(_name) {
    return (0, $8zRru.inject)((0, $9cf3e6406bb1dafb$export$3b14a55fb2447963));
}


let $9d80996a426a3537$var$script;




let $9d80996a426a3537$var$initialize = ()=>{
    $9d80996a426a3537$var$script = (parcelRequire("gLwTq"));
    if ($9d80996a426a3537$var$script.__esModule) $9d80996a426a3537$var$script = $9d80996a426a3537$var$script.default;
    $9d80996a426a3537$var$script.render = (parcelRequire("2PoEo")).render;
    $9d80996a426a3537$var$script.__cssModules = {};
    (parcelRequire("iQDNl")).default($9d80996a426a3537$var$script);
    $9d80996a426a3537$var$script.__scopeId = "data-v-eb4f10";
    $9d80996a426a3537$var$script.__file = "FormView.vue";
};
$9d80996a426a3537$var$initialize();
var $9d80996a426a3537$export$2e2bcd8739ae039 = $9d80996a426a3537$var$script;


let $e64a2dd75817144a$var$script;




let $e64a2dd75817144a$var$initialize = ()=>{
    $e64a2dd75817144a$var$script = (parcelRequire("hqvgn"));
    if ($e64a2dd75817144a$var$script.__esModule) $e64a2dd75817144a$var$script = $e64a2dd75817144a$var$script.default;
    $e64a2dd75817144a$var$script.render = (parcelRequire("5d68S")).render;
    $e64a2dd75817144a$var$script.__cssModules = {};
    (parcelRequire("lnKuo")).default($e64a2dd75817144a$var$script);
    $e64a2dd75817144a$var$script.__scopeId = "data-v-8f7f33";
    $e64a2dd75817144a$var$script.__file = "LoginView.vue";
};
$e64a2dd75817144a$var$initialize();
var $e64a2dd75817144a$export$2e2bcd8739ae039 = $e64a2dd75817144a$var$script;


const $57260f0eeb556384$var$routes = [
    {
        path: "/",
        name: "home",
        component: (0, $e64a2dd75817144a$export$2e2bcd8739ae039)
    },
    {
        path: "/form",
        name: "form",
        component: (0, $9d80996a426a3537$export$2e2bcd8739ae039)
    }
];
const $57260f0eeb556384$var$router = (0, $3d1dd3bf1a44e5c2$export$baddd0131ee8c05b)({
    history: (0, $3d1dd3bf1a44e5c2$export$7b4942f78e7b8a49)(undefined),
    routes: $57260f0eeb556384$var$routes
});
var $57260f0eeb556384$export$2e2bcd8739ae039 = $57260f0eeb556384$var$router;



var $2Wseo = parcelRequire("2Wseo");

var $2aNQ5 = parcelRequire("2aNQ5");

var $2EJsO = parcelRequire("2EJsO");
const $74d912be0e17452b$var$TIME_TO_WAIT_BEFORE_RETRYING = 1000;
const $74d912be0e17452b$var$alreadyUploading = new Set();
const $74d912be0e17452b$export$c53a67234791195 = ()=>{
    setInterval(async ()=>{
        const savedKeys = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).keys();
        const savedKeysWithPrefix = savedKeys.filter((key)=>key.startsWith((0, $2aNQ5.FILE_UPLOAD_PREFIX)));
        for (const key of savedKeysWithPrefix){
            const storedFile = await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).getItem(key);
            const questionName = key.replace((0, $2aNQ5.FILE_UPLOAD_PREFIX), "");
            const isAlreadyUploading = $74d912be0e17452b$var$alreadyUploading.has(questionName);
            if (isAlreadyUploading) continue;
            $74d912be0e17452b$var$alreadyUploading.add(questionName);
            const result = await (0, $2EJsO.callApi)({
                action: "store_file",
                data: storedFile
            });
            console.log({
                result: result
            });
            const isSuccessful = result?.data.success;
            if (isSuccessful) {
                await (0, (/*@__PURE__*/$parcel$interopDefault($2Wseo))).removeItem(key);
                $74d912be0e17452b$var$alreadyUploading.delete(questionName);
            }
        }
    }, $74d912be0e17452b$var$TIME_TO_WAIT_BEFORE_RETRYING);
};



var $2SEys = parcelRequire("2SEys");

var $2aNQ5 = parcelRequire("2aNQ5");
const $8d4f6bf918833ffd$var$componentNames = Object.keys((0, $2aNQ5.VERSIONS));
const $8d4f6bf918833ffd$export$36b85d2936c62732 = ()=>{
    $8d4f6bf918833ffd$var$componentNames.forEach((component)=>{
        const currentVersion = (0, $2aNQ5.VERSIONS)[component];
        const storedVersion = Number(localStorage.getItem(`${component}-VERSION`));
        if (currentVersion !== storedVersion) {
            console.log(`Version mismatch for ${component}`, {
                currentVersion: currentVersion,
                storedVersion: storedVersion
            });
            localStorage.setItem(`${component}-VERSION`, String(currentVersion));
        }
    });
};



var $hLDPq = parcelRequire("hLDPq");

var $kBVDt = parcelRequire("kBVDt");
(0, $8d4f6bf918833ffd$export$36b85d2936c62732)();
(0, $e43b4fb969d1050e$export$2e2bcd8739ae039).then(async (i18n)=>{
    (0, $5lPju.createApp)((0, $c9291cbe07952190$export$2e2bcd8739ae039)).use((0, $57260f0eeb556384$export$2e2bcd8739ae039)).use(i18n).mount("#app");
    const accountNumber = await (0, $2SEys.getCurrentAccountNumber)();
    const email = await (0, $hLDPq.getCurrentEmail)();
    // add the account number to the URL if it's not there
    if (accountNumber) $495f23922e6d3e6f$var$addParameterToUrl((0, $kBVDt.ACCOUNT_NUMBER_PARAMETER_KEY), accountNumber);
    if (email) $495f23922e6d3e6f$var$addParameterToUrl((0, $kBVDt.EMAIL_PARAMETER_KEY), email);
    (0, $74d912be0e17452b$export$c53a67234791195)();
});
const $495f23922e6d3e6f$var$addParameterToUrl = (paramKey, value)=>{
    const currentUrl = new URL(window.location.href);
    const parameters = currentUrl.searchParams;
    parameters.set(paramKey, value);
    window.history.replaceState({}, "", currentUrl.toString());
};


//# sourceMappingURL=index.9d13f5fb.js.map
